(self.webpackChunkdashkit = self.webpackChunkdashkit || []).push([
    [736], {
        320: e => {
            var t;
            window, t = function () {
                return function (e) {
                    var t = {};

                    function n(i) {
                        if (t[i]) return t[i].exports;
                        var r = t[i] = {
                            i,
                            l: !1,
                            exports: {}
                        };
                        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
                    }
                    return n.m = e, n.c = t, n.d = function (e, t, i) {
                        n.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: i
                        })
                    }, n.r = function (e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        })
                    }, n.t = function (e, t) {
                        if (1 & t && (e = n(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var i = Object.create(null);
                        if (n.r(i), Object.defineProperty(i, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e)
                            for (var r in e) n.d(i, r, function (t) {
                                return e[t]
                            }.bind(null, r));
                        return i
                    }, n.n = function (e) {
                        var t = e && e.__esModule ? function () {
                            return e.default
                        } : function () {
                            return e
                        };
                        return n.d(t, "a", t), t
                    }, n.o = function (e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }, n.p = "", n(n.s = 66)
                }([function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(64),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(60),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(51);
                    Object.defineProperty(t, "closest", {
                        enumerable: !0,
                        get: function () {
                            return o(i).default
                        }
                    });
                    var r = n(49);

                    function o(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    Object.defineProperty(t, "requestNextAnimationFrame", {
                        enumerable: !0,
                        get: function () {
                            return o(r).default
                        }
                    })
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(44);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(47),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(14);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r = n(13);
                    Object.keys(r).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return r[e]
                            }
                        })
                    }));
                    var o = n(12);
                    Object.keys(o).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return o[e]
                            }
                        })
                    }));
                    var a = n(6);
                    Object.keys(a).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return a[e]
                            }
                        })
                    }));
                    var s, l = n(37),
                        c = (s = l) && s.__esModule ? s : {
                            default: s
                        };
                    t.default = c.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(4);
                    Object.defineProperty(t, "Sensor", {
                        enumerable: !0,
                        get: function () {
                            return c(i).default
                        }
                    });
                    var r = n(46);
                    Object.defineProperty(t, "MouseSensor", {
                        enumerable: !0,
                        get: function () {
                            return c(r).default
                        }
                    });
                    var o = n(43);
                    Object.defineProperty(t, "TouchSensor", {
                        enumerable: !0,
                        get: function () {
                            return c(o).default
                        }
                    });
                    var a = n(41);
                    Object.defineProperty(t, "DragSensor", {
                        enumerable: !0,
                        get: function () {
                            return c(a).default
                        }
                    });
                    var s = n(39);
                    Object.defineProperty(t, "ForceTouchSensor", {
                        enumerable: !0,
                        get: function () {
                            return c(s).default
                        }
                    });
                    var l = n(3);

                    function c(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    Object.keys(l).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return l[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(18);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(23);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(27);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(30);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(33);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(62);
                    Object.defineProperty(t, "Announcement", {
                        enumerable: !0,
                        get: function () {
                            return s(i).default
                        }
                    }), Object.defineProperty(t, "defaultAnnouncementOptions", {
                        enumerable: !0,
                        get: function () {
                            return i.defaultOptions
                        }
                    });
                    var r = n(59);
                    Object.defineProperty(t, "Focusable", {
                        enumerable: !0,
                        get: function () {
                            return s(r).default
                        }
                    });
                    var o = n(57);
                    Object.defineProperty(t, "Mirror", {
                        enumerable: !0,
                        get: function () {
                            return s(o).default
                        }
                    }), Object.defineProperty(t, "defaultMirrorOptions", {
                        enumerable: !0,
                        get: function () {
                            return o.defaultOptions
                        }
                    });
                    var a = n(53);

                    function s(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    Object.defineProperty(t, "Scrollable", {
                        enumerable: !0,
                        get: function () {
                            return s(a).default
                        }
                    }), Object.defineProperty(t, "defaultScrollableOptions", {
                        enumerable: !0,
                        get: function () {
                            return a.defaultOptions
                        }
                    })
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(63);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(65);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        };
                    const s = Symbol("onSortableSorted"),
                        l = t.defaultOptions = {
                            duration: 150,
                            easingFunction: "ease-in-out",
                            horizontal: !1
                        };
                    class c extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, l, this.getOptions()), this.lastAnimationFrame = null, this[s] = this[s].bind(this)
                        }
                        attach() {
                            this.draggable.on("sortable:sorted", this[s])
                        }
                        detach() {
                            this.draggable.off("sortable:sorted", this[s])
                        }
                        getOptions() {
                            return this.draggable.options.swapAnimation || {}
                        } [s]({
                            oldIndex: e,
                            newIndex: t,
                            dragEvent: n
                        }) {
                            const {
                                source: i,
                                over: r
                            } = n;
                            cancelAnimationFrame(this.lastAnimationFrame), this.lastAnimationFrame = requestAnimationFrame((() => {
                                e >= t ? u(i, r, this.options) : u(r, i, this.options)
                            }))
                        }
                    }

                    function u(e, t, {
                        duration: n,
                        easingFunction: i,
                        horizontal: r
                    }) {
                        for (const n of [e, t]) n.style.pointerEvents = "none";
                        if (r) {
                            const n = e.offsetWidth;
                            e.style.transform = `translate3d(${n}px, 0, 0)`, t.style.transform = `translate3d(-${n}px, 0, 0)`
                        } else {
                            const n = e.offsetHeight;
                            e.style.transform = `translate3d(0, ${n}px, 0)`, t.style.transform = `translate3d(0, -${n}px, 0)`
                        }
                        requestAnimationFrame((() => {
                            for (const r of [e, t]) r.addEventListener("transitionend", d), r.style.transition = `transform ${n}ms ${i}`, r.style.transform = ""
                        }))
                    }

                    function d(e) {
                        e.target.style.transition = "", e.target.style.pointerEvents = "", e.target.removeEventListener("transitionend", d)
                    }
                    t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = n(15),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default, t.defaultOptions = r.defaultOptions
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(1),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = n(7);
                    const s = Symbol("onDragStart"),
                        l = Symbol("onDragStop"),
                        c = Symbol("onDragOver"),
                        u = Symbol("onDragOut"),
                        d = Symbol("onMirrorCreated"),
                        h = Symbol("onMirrorDestroy");
                    class f extends o.default {
                        constructor(e) {
                            super(e), this.firstSource = null, this.mirror = null, this[s] = this[s].bind(this), this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this[h] = this[h].bind(this)
                        }
                        attach() {
                            this.draggable.on("drag:start", this[s]).on("drag:stop", this[l]).on("drag:over", this[c]).on("drag:out", this[u]).on("droppable:over", this[c]).on("droppable:out", this[u]).on("mirror:created", this[d]).on("mirror:destroy", this[h])
                        }
                        detach() {
                            this.draggable.off("drag:start", this[s]).off("drag:stop", this[l]).off("drag:over", this[c]).off("drag:out", this[u]).off("droppable:over", this[c]).off("droppable:out", this[u]).off("mirror:created", this[d]).off("mirror:destroy", this[h])
                        } [s](e) {
                            e.canceled() || (this.firstSource = e.source)
                        } [l]() {
                            this.firstSource = null
                        } [c](e) {
                            if (e.canceled()) return;
                            const t = e.source || e.dragEvent.source;
                            if (t === this.firstSource) return void(this.firstSource = null);
                            const n = new a.SnapInEvent({
                                dragEvent: e,
                                snappable: e.over || e.droppable
                            });
                            this.draggable.trigger(n), n.canceled() || (this.mirror && (this.mirror.style.display = "none"), t.classList.remove(this.draggable.getClassNameFor("source:dragging")), t.classList.add(this.draggable.getClassNameFor("source:placed")), setTimeout((() => {
                                t.classList.remove(this.draggable.getClassNameFor("source:placed"))
                            }), this.draggable.options.placedTimeout))
                        } [u](e) {
                            if (e.canceled()) return;
                            const t = e.source || e.dragEvent.source,
                                n = new a.SnapOutEvent({
                                    dragEvent: e,
                                    snappable: e.over || e.droppable
                                });
                            this.draggable.trigger(n), n.canceled() || (this.mirror && (this.mirror.style.display = ""), t.classList.add(this.draggable.getClassNameFor("source:dragging")))
                        } [d]({
                            mirror: e
                        }) {
                            this.mirror = e
                        } [h]() {
                            this.mirror = null
                        }
                    }
                    t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.SnapOutEvent = t.SnapInEvent = t.SnapEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                        get snappable() {
                            return this.data.snappable
                        }
                    }
                    t.SnapEvent = a, a.type = "snap";
                    class s extends a {}
                    t.SnapInEvent = s, s.type = "snap:in", s.cancelable = !0;
                    class l extends a {}
                    t.SnapOutEvent = l, l.type = "snap:out", l.cancelable = !0
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(7);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r, o = n(17),
                        a = (r = o) && r.__esModule ? r : {
                            default: r
                        };
                    t.default = a.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(2);
                    const l = Symbol("onMirrorCreated"),
                        c = Symbol("onMirrorDestroy"),
                        u = Symbol("onDragOver"),
                        d = Symbol("resize"),
                        h = t.defaultOptions = {};
                    class f extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, h, this.getOptions()), this.lastWidth = 0, this.lastHeight = 0, this.mirror = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this)
                        }
                        attach() {
                            this.draggable.on("mirror:created", this[l]).on("drag:over", this[u]).on("drag:over:container", this[u])
                        }
                        detach() {
                            this.draggable.off("mirror:created", this[l]).off("mirror:destroy", this[c]).off("drag:over", this[u]).off("drag:over:container", this[u])
                        }
                        getOptions() {
                            return this.draggable.options.resizeMirror || {}
                        } [l]({
                            mirror: e
                        }) {
                            this.mirror = e
                        } [c]() {
                            this.mirror = null
                        } [u](e) {
                            this[d](e)
                        } [d]({
                            overContainer: e,
                            over: t
                        }) {
                            requestAnimationFrame((() => {
                                this.mirror.parentNode !== e && e.appendChild(this.mirror);
                                const n = t || this.draggable.getDraggableElementsForContainer(e)[0];
                                n && (0, s.requestNextAnimationFrame)((() => {
                                    const e = n.getBoundingClientRect();
                                    this.lastHeight === e.height && this.lastWidth === e.width || (this.mirror.style.width = `${e.width}px`, this.mirror.style.height = `${e.height}px`, this.lastWidth = e.width, this.lastHeight = e.height)
                                }))
                            }))
                        }
                    }
                    t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = n(20),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default, t.defaultOptions = r.defaultOptions
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(1),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = n(2),
                        s = n(8);
                    const l = Symbol("onDragMove"),
                        c = Symbol("onDragStop"),
                        u = Symbol("onRequestAnimationFrame");
                    class d extends o.default {
                        constructor(e) {
                            super(e), this.currentlyCollidingElement = null, this.lastCollidingElement = null, this.currentAnimationFrame = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this)
                        }
                        attach() {
                            this.draggable.on("drag:move", this[l]).on("drag:stop", this[c])
                        }
                        detach() {
                            this.draggable.off("drag:move", this[l]).off("drag:stop", this[c])
                        }
                        getCollidables() {
                            const e = this.draggable.options.collidables;
                            return "string" == typeof e ? Array.prototype.slice.call(document.querySelectorAll(e)) : e instanceof NodeList || e instanceof Array ? Array.prototype.slice.call(e) : e instanceof HTMLElement ? [e] : "function" == typeof e ? e() : []
                        } [l](e) {
                            const t = e.sensorEvent.target;
                            this.currentAnimationFrame = requestAnimationFrame(this[u](t)), this.currentlyCollidingElement && e.cancel();
                            const n = new s.CollidableInEvent({
                                    dragEvent: e,
                                    collidingElement: this.currentlyCollidingElement
                                }),
                                i = new s.CollidableOutEvent({
                                    dragEvent: e,
                                    collidingElement: this.lastCollidingElement
                                }),
                                r = Boolean(this.currentlyCollidingElement && this.lastCollidingElement !== this.currentlyCollidingElement),
                                o = Boolean(!this.currentlyCollidingElement && this.lastCollidingElement);
                            r ? (this.lastCollidingElement && this.draggable.trigger(i), this.draggable.trigger(n)) : o && this.draggable.trigger(i), this.lastCollidingElement = this.currentlyCollidingElement
                        } [c](e) {
                            const t = this.currentlyCollidingElement || this.lastCollidingElement,
                                n = new s.CollidableOutEvent({
                                    dragEvent: e,
                                    collidingElement: t
                                });
                            t && this.draggable.trigger(n), this.lastCollidingElement = null, this.currentlyCollidingElement = null
                        } [u](e) {
                            return () => {
                                const t = this.getCollidables();
                                this.currentlyCollidingElement = (0, a.closest)(e, (e => t.includes(e)))
                            }
                        }
                    }
                    t.default = d
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.CollidableOutEvent = t.CollidableInEvent = t.CollidableEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                    }
                    t.CollidableEvent = a, a.type = "collidable";
                    class s extends a {
                        get collidingElement() {
                            return this.data.collidingElement
                        }
                    }
                    t.CollidableInEvent = s, s.type = "collidable:in";
                    class l extends a {
                        get collidingElement() {
                            return this.data.collidingElement
                        }
                    }
                    t.CollidableOutEvent = l, l.type = "collidable:out"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(8);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r, o = n(22),
                        a = (r = o) && r.__esModule ? r : {
                            default: r
                        };
                    t.default = a.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(24);
                    Object.defineProperty(t, "Collidable", {
                        enumerable: !0,
                        get: function () {
                            return s(i).default
                        }
                    });
                    var r = n(21);
                    Object.defineProperty(t, "ResizeMirror", {
                        enumerable: !0,
                        get: function () {
                            return s(r).default
                        }
                    }), Object.defineProperty(t, "defaultResizeMirrorOptions", {
                        enumerable: !0,
                        get: function () {
                            return r.defaultOptions
                        }
                    });
                    var o = n(19);
                    Object.defineProperty(t, "Snappable", {
                        enumerable: !0,
                        get: function () {
                            return s(o).default
                        }
                    });
                    var a = n(16);

                    function s(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    Object.defineProperty(t, "SwapAnimation", {
                        enumerable: !0,
                        get: function () {
                            return s(a).default
                        }
                    }), Object.defineProperty(t, "defaultSwapAnimationOptions", {
                        enumerable: !0,
                        get: function () {
                            return a.defaultOptions
                        }
                    })
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(5),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(9);
                    const l = Symbol("onDragStart"),
                        c = Symbol("onDragOverContainer"),
                        u = Symbol("onDragOver"),
                        d = Symbol("onDragStop"),
                        h = {
                            "sortable:sorted": function ({
                                dragEvent: e
                            }) {
                                const t = e.source.textContent.trim() || e.source.id || "sortable element";
                                if (e.over) {
                                    const n = e.over.textContent.trim() || e.over.id || "sortable element";
                                    return e.source.compareDocumentPosition(e.over) & Node.DOCUMENT_POSITION_FOLLOWING ? `Placed ${t} after ${n}` : `Placed ${t} before ${n}`
                                }
                                return `Placed ${t} into a different container`
                            }
                        };
                    class f extends a.default {
                        constructor(e = [], t = {}) {
                            super(e, r({}, t, {
                                announcements: r({}, h, t.announcements || {})
                            })), this.startIndex = null, this.startContainer = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this.on("drag:start", this[l]).on("drag:over:container", this[c]).on("drag:over", this[u]).on("drag:stop", this[d])
                        }
                        destroy() {
                            super.destroy(), this.off("drag:start", this[l]).off("drag:over:container", this[c]).off("drag:over", this[u]).off("drag:stop", this[d])
                        }
                        index(e) {
                            return this.getDraggableElementsForContainer(e.parentNode).indexOf(e)
                        } [l](e) {
                            this.startContainer = e.source.parentNode, this.startIndex = this.index(e.source);
                            const t = new s.SortableStartEvent({
                                dragEvent: e,
                                startIndex: this.startIndex,
                                startContainer: this.startContainer
                            });
                            this.trigger(t), t.canceled() && e.cancel()
                        } [c](e) {
                            if (e.canceled()) return;
                            const {
                                source: t,
                                over: n,
                                overContainer: i
                            } = e, r = this.index(t), o = new s.SortableSortEvent({
                                dragEvent: e,
                                currentIndex: r,
                                source: t,
                                over: n
                            });
                            if (this.trigger(o), o.canceled()) return;
                            const a = g({
                                source: t,
                                over: n,
                                overContainer: i,
                                children: this.getDraggableElementsForContainer(i)
                            });
                            if (!a) return;
                            const {
                                oldContainer: l,
                                newContainer: c
                            } = a, u = this.index(e.source), d = new s.SortableSortedEvent({
                                dragEvent: e,
                                oldIndex: r,
                                newIndex: u,
                                oldContainer: l,
                                newContainer: c
                            });
                            this.trigger(d)
                        } [u](e) {
                            if (e.over === e.originalSource || e.over === e.source) return;
                            const {
                                source: t,
                                over: n,
                                overContainer: i
                            } = e, r = this.index(t), o = new s.SortableSortEvent({
                                dragEvent: e,
                                currentIndex: r,
                                source: t,
                                over: n
                            });
                            if (this.trigger(o), o.canceled()) return;
                            const a = g({
                                source: t,
                                over: n,
                                overContainer: i,
                                children: this.getDraggableElementsForContainer(i)
                            });
                            if (!a) return;
                            const {
                                oldContainer: l,
                                newContainer: c
                            } = a, u = this.index(t), d = new s.SortableSortedEvent({
                                dragEvent: e,
                                oldIndex: r,
                                newIndex: u,
                                oldContainer: l,
                                newContainer: c
                            });
                            this.trigger(d)
                        } [d](e) {
                            const t = new s.SortableStopEvent({
                                dragEvent: e,
                                oldIndex: this.startIndex,
                                newIndex: this.index(e.source),
                                oldContainer: this.startContainer,
                                newContainer: e.source.parentNode
                            });
                            this.trigger(t), this.startIndex = null, this.startContainer = null
                        }
                    }

                    function p(e) {
                        return Array.prototype.indexOf.call(e.parentNode.children, e)
                    }

                    function g({
                        source: e,
                        over: t,
                        overContainer: n,
                        children: i
                    }) {
                        const r = !i.length,
                            o = e.parentNode !== n,
                            a = t && !o;
                        return r ? function (e, t) {
                            const n = e.parentNode;
                            return t.appendChild(e), {
                                oldContainer: n,
                                newContainer: t
                            }
                        }(e, n) : a ? function (e, t) {
                            const n = p(e),
                                i = p(t);
                            return n < i ? e.parentNode.insertBefore(e, t.nextElementSibling) : e.parentNode.insertBefore(e, t), {
                                oldContainer: e.parentNode,
                                newContainer: e.parentNode
                            }
                        }(e, t) : o ? function (e, t, n) {
                            const i = e.parentNode;
                            return t ? t.parentNode.insertBefore(e, t) : n.appendChild(e), {
                                oldContainer: i,
                                newContainer: e.parentNode
                            }
                        }(e, t, n) : null
                    }
                    t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.SortableStopEvent = t.SortableSortedEvent = t.SortableSortEvent = t.SortableStartEvent = t.SortableEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                    }
                    t.SortableEvent = a, a.type = "sortable";
                    class s extends a {
                        get startIndex() {
                            return this.data.startIndex
                        }
                        get startContainer() {
                            return this.data.startContainer
                        }
                    }
                    t.SortableStartEvent = s, s.type = "sortable:start", s.cancelable = !0;
                    class l extends a {
                        get currentIndex() {
                            return this.data.currentIndex
                        }
                        get over() {
                            return this.data.oldIndex
                        }
                        get overContainer() {
                            return this.data.newIndex
                        }
                    }
                    t.SortableSortEvent = l, l.type = "sortable:sort", l.cancelable = !0;
                    class c extends a {
                        get oldIndex() {
                            return this.data.oldIndex
                        }
                        get newIndex() {
                            return this.data.newIndex
                        }
                        get oldContainer() {
                            return this.data.oldContainer
                        }
                        get newContainer() {
                            return this.data.newContainer
                        }
                    }
                    t.SortableSortedEvent = c, c.type = "sortable:sorted";
                    class u extends a {
                        get oldIndex() {
                            return this.data.oldIndex
                        }
                        get newIndex() {
                            return this.data.newIndex
                        }
                        get oldContainer() {
                            return this.data.oldContainer
                        }
                        get newContainer() {
                            return this.data.newContainer
                        }
                    }
                    t.SortableStopEvent = u, u.type = "sortable:stop"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(9);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r, o = n(26),
                        a = (r = o) && r.__esModule ? r : {
                            default: r
                        };
                    t.default = a.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(5),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(10);
                    const l = Symbol("onDragStart"),
                        c = Symbol("onDragOver"),
                        u = Symbol("onDragStop"),
                        d = {
                            "swappabled:swapped": function ({
                                dragEvent: e,
                                swappedElement: t
                            }) {
                                return `Swapped ${e.source.textContent.trim()||e.source.id||"swappable element"} with ${t.textContent.trim()||t.id||"swappable element"}`
                            }
                        };
                    class h extends a.default {
                        constructor(e = [], t = {}) {
                            super(e, r({}, t, {
                                announcements: r({}, d, t.announcements || {})
                            })), this.lastOver = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this.on("drag:start", this[l]).on("drag:over", this[c]).on("drag:stop", this[u])
                        }
                        destroy() {
                            super.destroy(), this.off("drag:start", this._onDragStart).off("drag:over", this._onDragOver).off("drag:stop", this._onDragStop)
                        } [l](e) {
                            const t = new s.SwappableStartEvent({
                                dragEvent: e
                            });
                            this.trigger(t), t.canceled() && e.cancel()
                        } [c](e) {
                            if (e.over === e.originalSource || e.over === e.source || e.canceled()) return;
                            const t = new s.SwappableSwapEvent({
                                dragEvent: e,
                                over: e.over,
                                overContainer: e.overContainer
                            });
                            if (this.trigger(t), t.canceled()) return;
                            this.lastOver && this.lastOver !== e.over && f(this.lastOver, e.source), this.lastOver === e.over ? this.lastOver = null : this.lastOver = e.over, f(e.source, e.over);
                            const n = new s.SwappableSwappedEvent({
                                dragEvent: e,
                                swappedElement: e.over
                            });
                            this.trigger(n)
                        } [u](e) {
                            const t = new s.SwappableStopEvent({
                                dragEvent: e
                            });
                            this.trigger(t), this.lastOver = null
                        }
                    }

                    function f(e, t) {
                        const n = t.parentNode,
                            i = e.parentNode;
                        ! function (e) {
                            const t = document.createElement("div");
                            e(t), t.parentNode.removeChild(t)
                        }((r => {
                            i.insertBefore(r, e), n.insertBefore(e, t), i.insertBefore(t, r)
                        }))
                    }
                    t.default = h
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.SwappableStopEvent = t.SwappableSwappedEvent = t.SwappableSwapEvent = t.SwappableStartEvent = t.SwappableEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                    }
                    t.SwappableEvent = a, a.type = "swappable";
                    class s extends a {}
                    t.SwappableStartEvent = s, s.type = "swappable:start", s.cancelable = !0;
                    class l extends a {
                        get over() {
                            return this.data.over
                        }
                        get overContainer() {
                            return this.data.overContainer
                        }
                    }
                    t.SwappableSwapEvent = l, l.type = "swappable:swap", l.cancelable = !0;
                    class c extends a {
                        get swappedElement() {
                            return this.data.swappedElement
                        }
                    }
                    t.SwappableSwappedEvent = c, c.type = "swappable:swapped";
                    class u extends a {}
                    t.SwappableStopEvent = u, u.type = "swappable:stop"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(10);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r, o = n(29),
                        a = (r = o) && r.__esModule ? r : {
                            default: r
                        };
                    t.default = a.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(2),
                        a = n(5),
                        s = (i = a) && i.__esModule ? i : {
                            default: i
                        },
                        l = n(11);
                    const c = Symbol("onDragStart"),
                        u = Symbol("onDragMove"),
                        d = Symbol("onDragStop"),
                        h = Symbol("dropInDropZone"),
                        f = Symbol("returnToOriginalDropzone"),
                        p = Symbol("closestDropzone"),
                        g = Symbol("getDropzones"),
                        m = {
                            "droppable:dropped": function ({
                                dragEvent: e,
                                dropzone: t
                            }) {
                                return `Dropped ${e.source.textContent.trim()||e.source.id||"draggable element"} into ${t.textContent.trim()||t.id||"droppable element"}`
                            },
                            "droppable:returned": function ({
                                dragEvent: e,
                                dropzone: t
                            }) {
                                return `Returned ${e.source.textContent.trim()||e.source.id||"draggable element"} from ${t.textContent.trim()||t.id||"droppable element"}`
                            }
                        },
                        v = {
                            "droppable:active": "draggable-dropzone--active",
                            "droppable:occupied": "draggable-dropzone--occupied"
                        },
                        b = {
                            dropzone: ".draggable-droppable"
                        };
                    class y extends s.default {
                        constructor(e = [], t = {}) {
                            super(e, r({}, b, t, {
                                classes: r({}, v, t.classes || {}),
                                announcements: r({}, m, t.announcements || {})
                            })), this.dropzones = null, this.lastDropzone = null, this.initialDropzone = null, this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this.on("drag:start", this[c]).on("drag:move", this[u]).on("drag:stop", this[d])
                        }
                        destroy() {
                            super.destroy(), this.off("drag:start", this[c]).off("drag:move", this[u]).off("drag:stop", this[d])
                        } [c](e) {
                            if (e.canceled()) return;
                            this.dropzones = [...this[g]()];
                            const t = (0, o.closest)(e.sensorEvent.target, this.options.dropzone);
                            if (!t) return void e.cancel();
                            const n = new l.DroppableStartEvent({
                                dragEvent: e,
                                dropzone: t
                            });
                            if (this.trigger(n), n.canceled()) e.cancel();
                            else {
                                this.initialDropzone = t;
                                for (const e of this.dropzones) e.classList.contains(this.getClassNameFor("droppable:occupied")) || e.classList.add(this.getClassNameFor("droppable:active"))
                            }
                        } [u](e) {
                            if (e.canceled()) return;
                            const t = this[p](e.sensorEvent.target);
                            t && !t.classList.contains(this.getClassNameFor("droppable:occupied")) && this[h](e, t) ? this.lastDropzone = t : t && t !== this.initialDropzone || !this.lastDropzone || (this[f](e), this.lastDropzone = null)
                        } [d](e) {
                            const t = new l.DroppableStopEvent({
                                dragEvent: e,
                                dropzone: this.lastDropzone || this.initialDropzone
                            });
                            this.trigger(t);
                            const n = this.getClassNameFor("droppable:occupied");
                            for (const e of this.dropzones) e.classList.remove(this.getClassNameFor("droppable:active"));
                            this.lastDropzone && this.lastDropzone !== this.initialDropzone && this.initialDropzone.classList.remove(n), this.dropzones = null, this.lastDropzone = null, this.initialDropzone = null
                        } [h](e, t) {
                            const n = new l.DroppableDroppedEvent({
                                dragEvent: e,
                                dropzone: t
                            });
                            if (this.trigger(n), n.canceled()) return !1;
                            const i = this.getClassNameFor("droppable:occupied");
                            return this.lastDropzone && this.lastDropzone.classList.remove(i), t.appendChild(e.source), t.classList.add(i), !0
                        } [f](e) {
                            const t = new l.DroppableReturnedEvent({
                                dragEvent: e,
                                dropzone: this.lastDropzone
                            });
                            this.trigger(t), t.canceled() || (this.initialDropzone.appendChild(e.source), this.lastDropzone.classList.remove(this.getClassNameFor("droppable:occupied")))
                        } [p](e) {
                            return this.dropzones ? (0, o.closest)(e, this.dropzones) : null
                        } [g]() {
                            const e = this.options.dropzone;
                            return "string" == typeof e ? document.querySelectorAll(e) : e instanceof NodeList || e instanceof Array ? e : "function" == typeof e ? e() : []
                        }
                    }
                    t.default = y
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.DroppableStopEvent = t.DroppableReturnedEvent = t.DroppableDroppedEvent = t.DroppableStartEvent = t.DroppableEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                    }
                    t.DroppableEvent = a, a.type = "droppable";
                    class s extends a {
                        get dropzone() {
                            return this.data.dropzone
                        }
                    }
                    t.DroppableStartEvent = s, s.type = "droppable:start", s.cancelable = !0;
                    class l extends a {
                        get dropzone() {
                            return this.data.dropzone
                        }
                    }
                    t.DroppableDroppedEvent = l, l.type = "droppable:dropped", l.cancelable = !0;
                    class c extends a {
                        get dropzone() {
                            return this.data.dropzone
                        }
                    }
                    t.DroppableReturnedEvent = c, c.type = "droppable:returned", c.cancelable = !0;
                    class u extends a {
                        get dropzone() {
                            return this.data.dropzone
                        }
                    }
                    t.DroppableStopEvent = u, u.type = "droppable:stop", u.cancelable = !0
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(11);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }));
                    var r, o = n(32),
                        a = (r = o) && r.__esModule ? r : {
                            default: r
                        };
                    t.default = a.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = class {
                        constructor() {
                            this.callbacks = {}
                        }
                        on(e, ...t) {
                            return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(...t), this
                        }
                        off(e, t) {
                            if (!this.callbacks[e]) return null;
                            const n = this.callbacks[e].slice(0);
                            for (let i = 0; i < n.length; i++) t === n[i] && this.callbacks[e].splice(i, 1);
                            return this
                        }
                        trigger(e) {
                            if (!this.callbacks[e.type]) return null;
                            const t = [...this.callbacks[e.type]],
                                n = [];
                            for (let i = t.length - 1; i >= 0; i--) {
                                const r = t[i];
                                try {
                                    r(e)
                                } catch (e) {
                                    n.push(e)
                                }
                            }
                            return n.length && console.error(`Draggable caught errors while triggering '${e.type}'`, n), this
                        }
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(35),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(2),
                        a = n(12),
                        s = n(36),
                        l = (i = s) && i.__esModule ? i : {
                            default: i
                        },
                        c = n(6),
                        u = n(13),
                        d = n(14);
                    const h = Symbol("onDragStart"),
                        f = Symbol("onDragMove"),
                        p = Symbol("onDragStop"),
                        g = Symbol("onDragPressure"),
                        m = {
                            "drag:start": e => `Picked up ${e.source.textContent.trim()||e.source.id||"draggable element"}`,
                            "drag:stop": e => `Released ${e.source.textContent.trim()||e.source.id||"draggable element"}`
                        },
                        v = {
                            "container:dragging": "draggable-container--is-dragging",
                            "source:dragging": "draggable-source--is-dragging",
                            "source:placed": "draggable-source--placed",
                            "container:placed": "draggable-container--placed",
                            "body:dragging": "draggable--is-dragging",
                            "draggable:over": "draggable--over",
                            "container:over": "draggable-container--over",
                            "source:original": "draggable--original",
                            mirror: "draggable-mirror"
                        },
                        b = t.defaultOptions = {
                            draggable: ".draggable-source",
                            handle: null,
                            delay: 100,
                            placedTimeout: 800,
                            plugins: [],
                            sensors: []
                        };
                    class y {
                        constructor(e = [document.body], t = {}) {
                            if (e instanceof NodeList || e instanceof Array) this.containers = [...e];
                            else {
                                if (!(e instanceof HTMLElement)) throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
                                this.containers = [e]
                            }
                            this.options = r({}, b, t, {
                                classes: r({}, v, t.classes || {}),
                                announcements: r({}, m, t.announcements || {})
                            }), this.emitter = new l.default, this.dragging = !1, this.plugins = [], this.sensors = [], this[h] = this[h].bind(this), this[f] = this[f].bind(this), this[p] = this[p].bind(this), this[g] = this[g].bind(this), document.addEventListener("drag:start", this[h], !0), document.addEventListener("drag:move", this[f], !0), document.addEventListener("drag:stop", this[p], !0), document.addEventListener("drag:pressure", this[g], !0);
                            const n = Object.values(y.Plugins).map((e => e)),
                                i = [c.MouseSensor, c.TouchSensor];
                            this.addPlugin(...n, ...this.options.plugins), this.addSensor(...i, ...this.options.sensors);
                            const o = new u.DraggableInitializedEvent({
                                draggable: this
                            });
                            this.on("mirror:created", (({
                                mirror: e
                            }) => this.mirror = e)), this.on("mirror:destroy", (() => this.mirror = null)), this.trigger(o)
                        }
                        destroy() {
                            document.removeEventListener("drag:start", this[h], !0), document.removeEventListener("drag:move", this[f], !0), document.removeEventListener("drag:stop", this[p], !0), document.removeEventListener("drag:pressure", this[g], !0);
                            const e = new u.DraggableDestroyEvent({
                                draggable: this
                            });
                            this.trigger(e), this.removePlugin(...this.plugins.map((e => e.constructor))), this.removeSensor(...this.sensors.map((e => e.constructor)))
                        }
                        addPlugin(...e) {
                            const t = e.map((e => new e(this)));
                            return t.forEach((e => e.attach())), this.plugins = [...this.plugins, ...t], this
                        }
                        removePlugin(...e) {
                            return this.plugins.filter((t => e.includes(t.constructor))).forEach((e => e.detach())), this.plugins = this.plugins.filter((t => !e.includes(t.constructor))), this
                        }
                        addSensor(...e) {
                            const t = e.map((e => new e(this.containers, this.options)));
                            return t.forEach((e => e.attach())), this.sensors = [...this.sensors, ...t], this
                        }
                        removeSensor(...e) {
                            return this.sensors.filter((t => e.includes(t.constructor))).forEach((e => e.detach())), this.sensors = this.sensors.filter((t => !e.includes(t.constructor))), this
                        }
                        addContainer(...e) {
                            return this.containers = [...this.containers, ...e], this.sensors.forEach((t => t.addContainer(...e))), this
                        }
                        removeContainer(...e) {
                            return this.containers = this.containers.filter((t => !e.includes(t))), this.sensors.forEach((t => t.removeContainer(...e))), this
                        }
                        on(e, ...t) {
                            return this.emitter.on(e, ...t), this
                        }
                        off(e, t) {
                            return this.emitter.off(e, t), this
                        }
                        trigger(e) {
                            return this.emitter.trigger(e), this
                        }
                        getClassNameFor(e) {
                            return this.options.classes[e]
                        }
                        isDragging() {
                            return Boolean(this.dragging)
                        }
                        getDraggableElements() {
                            return this.containers.reduce(((e, t) => [...e, ...this.getDraggableElementsForContainer(t)]), [])
                        }
                        getDraggableElementsForContainer(e) {
                            return [...e.querySelectorAll(this.options.draggable)].filter((e => e !== this.originalSource && e !== this.mirror))
                        } [h](e) {
                            const t = _(e),
                                {
                                    target: n,
                                    container: i
                                } = t;
                            if (!this.containers.includes(i)) return;
                            if (this.options.handle && n && !(0, o.closest)(n, this.options.handle)) return void t.cancel();
                            if (this.originalSource = (0, o.closest)(n, this.options.draggable), this.sourceContainer = i, !this.originalSource) return void t.cancel();
                            this.lastPlacedSource && this.lastPlacedContainer && (clearTimeout(this.placedTimeoutID), this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed")), this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed"))), this.source = this.originalSource.cloneNode(!0), this.originalSource.parentNode.insertBefore(this.source, this.originalSource), this.originalSource.style.display = "none";
                            const a = new d.DragStartEvent({
                                source: this.source,
                                originalSource: this.originalSource,
                                sourceContainer: i,
                                sensorEvent: t
                            });
                            if (this.trigger(a), this.dragging = !a.canceled(), a.canceled()) return this.source.parentNode.removeChild(this.source), void(this.originalSource.style.display = null);
                            this.originalSource.classList.add(this.getClassNameFor("source:original")), this.source.classList.add(this.getClassNameFor("source:dragging")), this.sourceContainer.classList.add(this.getClassNameFor("container:dragging")), document.body.classList.add(this.getClassNameFor("body:dragging")), x(document.body, "none"), requestAnimationFrame((() => {
                                const t = _(e).clone({
                                    target: this.source
                                });
                                this[f](r({}, e, {
                                    detail: t
                                }))
                            }))
                        } [f](e) {
                            if (!this.dragging) return;
                            const t = _(e),
                                {
                                    container: n
                                } = t;
                            let i = t.target;
                            const r = new d.DragMoveEvent({
                                source: this.source,
                                originalSource: this.originalSource,
                                sourceContainer: n,
                                sensorEvent: t
                            });
                            this.trigger(r), r.canceled() && t.cancel(), i = (0, o.closest)(i, this.options.draggable);
                            const a = (0, o.closest)(t.target, this.containers),
                                s = t.overContainer || a,
                                l = this.currentOverContainer && s !== this.currentOverContainer,
                                c = this.currentOver && i !== this.currentOver,
                                u = s && this.currentOverContainer !== s,
                                h = a && i && this.currentOver !== i;
                            if (c) {
                                const e = new d.DragOutEvent({
                                    source: this.source,
                                    originalSource: this.originalSource,
                                    sourceContainer: n,
                                    sensorEvent: t,
                                    over: this.currentOver
                                });
                                this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOver = null, this.trigger(e)
                            }
                            if (l) {
                                const e = new d.DragOutContainerEvent({
                                    source: this.source,
                                    originalSource: this.originalSource,
                                    sourceContainer: n,
                                    sensorEvent: t,
                                    overContainer: this.currentOverContainer
                                });
                                this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.currentOverContainer = null, this.trigger(e)
                            }
                            if (u) {
                                s.classList.add(this.getClassNameFor("container:over"));
                                const e = new d.DragOverContainerEvent({
                                    source: this.source,
                                    originalSource: this.originalSource,
                                    sourceContainer: n,
                                    sensorEvent: t,
                                    overContainer: s
                                });
                                this.currentOverContainer = s, this.trigger(e)
                            }
                            if (h) {
                                i.classList.add(this.getClassNameFor("draggable:over"));
                                const e = new d.DragOverEvent({
                                    source: this.source,
                                    originalSource: this.originalSource,
                                    sourceContainer: n,
                                    sensorEvent: t,
                                    overContainer: s,
                                    over: i
                                });
                                this.currentOver = i, this.trigger(e)
                            }
                        } [p](e) {
                            if (!this.dragging) return;
                            this.dragging = !1;
                            const t = new d.DragStopEvent({
                                source: this.source,
                                originalSource: this.originalSource,
                                sensorEvent: e.sensorEvent,
                                sourceContainer: this.sourceContainer
                            });
                            this.trigger(t), this.source.parentNode.insertBefore(this.originalSource, this.source), this.source.parentNode.removeChild(this.source), this.originalSource.style.display = "", this.source.classList.remove(this.getClassNameFor("source:dragging")), this.originalSource.classList.remove(this.getClassNameFor("source:original")), this.originalSource.classList.add(this.getClassNameFor("source:placed")), this.sourceContainer.classList.add(this.getClassNameFor("container:placed")), this.sourceContainer.classList.remove(this.getClassNameFor("container:dragging")), document.body.classList.remove(this.getClassNameFor("body:dragging")), x(document.body, ""), this.currentOver && this.currentOver.classList.remove(this.getClassNameFor("draggable:over")), this.currentOverContainer && this.currentOverContainer.classList.remove(this.getClassNameFor("container:over")), this.lastPlacedSource = this.originalSource, this.lastPlacedContainer = this.sourceContainer, this.placedTimeoutID = setTimeout((() => {
                                this.lastPlacedSource && this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed")), this.lastPlacedContainer && this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed")), this.lastPlacedSource = null, this.lastPlacedContainer = null
                            }), this.options.placedTimeout), this.source = null, this.originalSource = null, this.currentOverContainer = null, this.currentOver = null, this.sourceContainer = null
                        } [g](e) {
                            if (!this.dragging) return;
                            const t = _(e),
                                n = this.source || (0, o.closest)(t.originalEvent.target, this.options.draggable),
                                i = new d.DragPressureEvent({
                                    sensorEvent: t,
                                    source: n,
                                    pressure: t.pressure
                                });
                            this.trigger(i)
                        }
                    }

                    function _(e) {
                        return e.detail
                    }

                    function x(e, t) {
                        e.style.webkitUserSelect = t, e.style.mozUserSelect = t, e.style.msUserSelect = t, e.style.oUserSelect = t, e.style.userSelect = t
                    }
                    t.default = y, y.Plugins = {
                        Announcement: a.Announcement,
                        Focusable: a.Focusable,
                        Mirror: a.Mirror,
                        Scrollable: a.Scrollable
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(4),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = n(3);
                    const s = Symbol("onMouseForceWillBegin"),
                        l = Symbol("onMouseForceDown"),
                        c = Symbol("onMouseDown"),
                        u = Symbol("onMouseForceChange"),
                        d = Symbol("onMouseMove"),
                        h = Symbol("onMouseUp"),
                        f = Symbol("onMouseForceGlobalChange");
                    class p extends o.default {
                        constructor(e = [], t = {}) {
                            super(e, t), this.mightDrag = !1, this[s] = this[s].bind(this), this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this[h] = this[h].bind(this)
                        }
                        attach() {
                            for (const e of this.containers) e.addEventListener("webkitmouseforcewillbegin", this[s], !1), e.addEventListener("webkitmouseforcedown", this[l], !1), e.addEventListener("mousedown", this[c], !0), e.addEventListener("webkitmouseforcechanged", this[u], !1);
                            document.addEventListener("mousemove", this[d]), document.addEventListener("mouseup", this[h])
                        }
                        detach() {
                            for (const e of this.containers) e.removeEventListener("webkitmouseforcewillbegin", this[s], !1), e.removeEventListener("webkitmouseforcedown", this[l], !1), e.removeEventListener("mousedown", this[c], !0), e.removeEventListener("webkitmouseforcechanged", this[u], !1);
                            document.removeEventListener("mousemove", this[d]), document.removeEventListener("mouseup", this[h])
                        } [s](e) {
                            e.preventDefault(), this.mightDrag = !0
                        } [l](e) {
                            if (this.dragging) return;
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = e.currentTarget,
                                i = new a.DragStartSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: n,
                                    originalEvent: e
                                });
                            this.trigger(n, i), this.currentContainer = n, this.dragging = !i.canceled(), this.mightDrag = !1
                        } [h](e) {
                            if (!this.dragging) return;
                            const t = new a.DragStopSensorEvent({
                                clientX: e.clientX,
                                clientY: e.clientY,
                                target: null,
                                container: this.currentContainer,
                                originalEvent: e
                            });
                            this.trigger(this.currentContainer, t), this.currentContainer = null, this.dragging = !1, this.mightDrag = !1
                        } [c](e) {
                            this.mightDrag && (e.stopPropagation(), e.stopImmediatePropagation(), e.preventDefault())
                        } [d](e) {
                            if (!this.dragging) return;
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = new a.DragMoveSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: this.currentContainer,
                                    originalEvent: e
                                });
                            this.trigger(this.currentContainer, n)
                        } [u](e) {
                            if (this.dragging) return;
                            const t = e.target,
                                n = e.currentTarget,
                                i = new a.DragPressureSensorEvent({
                                    pressure: e.webkitForce,
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: n,
                                    originalEvent: e
                                });
                            this.trigger(n, i)
                        } [f](e) {
                            if (!this.dragging) return;
                            const t = e.target,
                                n = new a.DragPressureSensorEvent({
                                    pressure: e.webkitForce,
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: this.currentContainer,
                                    originalEvent: e
                                });
                            this.trigger(this.currentContainer, n)
                        }
                    }
                    t.default = p
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(38),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(2),
                        o = n(4),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(3);
                    const l = Symbol("onMouseDown"),
                        c = Symbol("onMouseUp"),
                        u = Symbol("onDragStart"),
                        d = Symbol("onDragOver"),
                        h = Symbol("onDragEnd"),
                        f = Symbol("onDrop"),
                        p = Symbol("reset");
                    class g extends a.default {
                        constructor(e = [], t = {}) {
                            super(e, t), this.mouseDownTimeout = null, this.draggableElement = null, this.nativeDraggableElement = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this[h] = this[h].bind(this), this[f] = this[f].bind(this)
                        }
                        attach() {
                            document.addEventListener("mousedown", this[l], !0)
                        }
                        detach() {
                            document.removeEventListener("mousedown", this[l], !0)
                        } [u](e) {
                            e.dataTransfer.setData("text", ""), e.dataTransfer.effectAllowed = this.options.type;
                            const t = document.elementFromPoint(e.clientX, e.clientY);
                            if (this.currentContainer = (0, r.closest)(e.target, this.containers), !this.currentContainer) return;
                            const n = new s.DragStartSensorEvent({
                                clientX: e.clientX,
                                clientY: e.clientY,
                                target: t,
                                container: this.currentContainer,
                                originalEvent: e
                            });
                            setTimeout((() => {
                                this.trigger(this.currentContainer, n), n.canceled() ? this.dragging = !1 : this.dragging = !0
                            }), 0)
                        } [d](e) {
                            if (!this.dragging) return;
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = this.currentContainer,
                                i = new s.DragMoveSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: n,
                                    originalEvent: e
                                });
                            this.trigger(n, i), i.canceled() || (e.preventDefault(), e.dataTransfer.dropEffect = this.options.type)
                        } [h](e) {
                            if (!this.dragging) return;
                            document.removeEventListener("mouseup", this[c], !0);
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = this.currentContainer,
                                i = new s.DragStopSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: n,
                                    originalEvent: e
                                });
                            this.trigger(n, i), this.dragging = !1, this[p]()
                        } [f](e) {
                            e.preventDefault()
                        } [l](e) {
                            if (e.target && (e.target.form || e.target.contenteditable)) return;
                            const t = (0, r.closest)(e.target, (e => e.draggable));
                            t && (t.draggable = !1, this.nativeDraggableElement = t), document.addEventListener("mouseup", this[c], !0), document.addEventListener("dragstart", this[u], !1), document.addEventListener("dragover", this[d], !1), document.addEventListener("dragend", this[h], !1), document.addEventListener("drop", this[f], !1);
                            const n = (0, r.closest)(e.target, this.options.draggable);
                            n && (this.mouseDownTimeout = setTimeout((() => {
                                n.draggable = !0, this.draggableElement = n
                            }), this.options.delay))
                        } [c]() {
                            this[p]()
                        } [p]() {
                            clearTimeout(this.mouseDownTimeout), document.removeEventListener("mouseup", this[c], !0), document.removeEventListener("dragstart", this[u], !1), document.removeEventListener("dragover", this[d], !1), document.removeEventListener("dragend", this[h], !1), document.removeEventListener("drop", this[f], !1), this.nativeDraggableElement && (this.nativeDraggableElement.draggable = !0, this.nativeDraggableElement = null), this.draggableElement && (this.draggableElement.draggable = !1, this.draggableElement = null)
                        }
                    }
                    t.default = g
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(40),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(2),
                        o = n(4),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(3);
                    const l = Symbol("onTouchStart"),
                        c = Symbol("onTouchHold"),
                        u = Symbol("onTouchEnd"),
                        d = Symbol("onTouchMove");
                    let h = !1;
                    window.addEventListener("touchmove", (e => {
                        h && e.preventDefault()
                    }), {
                        passive: !1
                    });
                    class f extends a.default {
                        constructor(e = [], t = {}) {
                            super(e, t), this.currentScrollableParent = null, this.tapTimeout = null, this.touchMoved = !1, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this)
                        }
                        attach() {
                            document.addEventListener("touchstart", this[l])
                        }
                        detach() {
                            document.removeEventListener("touchstart", this[l])
                        } [l](e) {
                            const t = (0, r.closest)(e.target, this.containers);
                            t && (document.addEventListener("touchmove", this[d]), document.addEventListener("touchend", this[u]), document.addEventListener("touchcancel", this[u]), t.addEventListener("contextmenu", p), this.currentContainer = t, this.tapTimeout = setTimeout(this[c](e, t), this.options.delay))
                        } [c](e, t) {
                            return () => {
                                if (this.touchMoved) return;
                                const n = e.touches[0] || e.changedTouches[0],
                                    i = e.target,
                                    r = new s.DragStartSensorEvent({
                                        clientX: n.pageX,
                                        clientY: n.pageY,
                                        target: i,
                                        container: t,
                                        originalEvent: e
                                    });
                                this.trigger(t, r), this.dragging = !r.canceled(), h = this.dragging
                            }
                        } [d](e) {
                            if (this.touchMoved = !0, !this.dragging) return;
                            const t = e.touches[0] || e.changedTouches[0],
                                n = document.elementFromPoint(t.pageX - window.scrollX, t.pageY - window.scrollY),
                                i = new s.DragMoveSensorEvent({
                                    clientX: t.pageX,
                                    clientY: t.pageY,
                                    target: n,
                                    container: this.currentContainer,
                                    originalEvent: e
                                });
                            this.trigger(this.currentContainer, i)
                        } [u](e) {
                            if (this.touchMoved = !1, h = !1, document.removeEventListener("touchend", this[u]), document.removeEventListener("touchcancel", this[u]), document.removeEventListener("touchmove", this[d]), this.currentContainer && this.currentContainer.removeEventListener("contextmenu", p), clearTimeout(this.tapTimeout), !this.dragging) return;
                            const t = e.touches[0] || e.changedTouches[0],
                                n = document.elementFromPoint(t.pageX - window.scrollX, t.pageY - window.scrollY);
                            e.preventDefault();
                            const i = new s.DragStopSensorEvent({
                                clientX: t.pageX,
                                clientY: t.pageY,
                                target: n,
                                container: this.currentContainer,
                                originalEvent: e
                            });
                            this.trigger(this.currentContainer, i), this.currentContainer = null, this.dragging = !1
                        }
                    }

                    function p(e) {
                        e.preventDefault(), e.stopPropagation()
                    }
                    t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(42),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.DragPressureSensorEvent = t.DragStopSensorEvent = t.DragMoveSensorEvent = t.DragStartSensorEvent = t.SensorEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get originalEvent() {
                            return this.data.originalEvent
                        }
                        get clientX() {
                            return this.data.clientX
                        }
                        get clientY() {
                            return this.data.clientY
                        }
                        get target() {
                            return this.data.target
                        }
                        get container() {
                            return this.data.container
                        }
                        get pressure() {
                            return this.data.pressure
                        }
                    }
                    t.SensorEvent = a;
                    class s extends a {}
                    t.DragStartSensorEvent = s, s.type = "drag:start";
                    class l extends a {}
                    t.DragMoveSensorEvent = l, l.type = "drag:move";
                    class c extends a {}
                    t.DragStopSensorEvent = c, c.type = "drag:stop";
                    class u extends a {}
                    t.DragPressureSensorEvent = u, u.type = "drag:pressure"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(2),
                        o = n(4),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(3);
                    const l = Symbol("onContextMenuWhileDragging"),
                        c = Symbol("onMouseDown"),
                        u = Symbol("onMouseMove"),
                        d = Symbol("onMouseUp");
                    class h extends a.default {
                        constructor(e = [], t = {}) {
                            super(e, t), this.mouseDown = !1, this.mouseDownTimeout = null, this.openedContextMenu = !1, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this)
                        }
                        attach() {
                            document.addEventListener("mousedown", this[c], !0)
                        }
                        detach() {
                            document.removeEventListener("mousedown", this[c], !0)
                        } [c](e) {
                            if (0 !== e.button || e.ctrlKey || e.metaKey) return;
                            document.addEventListener("mouseup", this[d]);
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = (0, r.closest)(t, this.containers);
                            n && (document.addEventListener("dragstart", f), this.mouseDown = !0, clearTimeout(this.mouseDownTimeout), this.mouseDownTimeout = setTimeout((() => {
                                if (!this.mouseDown) return;
                                const i = new s.DragStartSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: n,
                                    originalEvent: e
                                });
                                this.trigger(n, i), this.currentContainer = n, this.dragging = !i.canceled(), this.dragging && (document.addEventListener("contextmenu", this[l]), document.addEventListener("mousemove", this[u]))
                            }), this.options.delay))
                        } [u](e) {
                            if (!this.dragging) return;
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = new s.DragMoveSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: this.currentContainer,
                                    originalEvent: e
                                });
                            this.trigger(this.currentContainer, n)
                        } [d](e) {
                            if (this.mouseDown = Boolean(this.openedContextMenu), this.openedContextMenu) return void(this.openedContextMenu = !1);
                            if (document.removeEventListener("mouseup", this[d]), document.removeEventListener("dragstart", f), !this.dragging) return;
                            const t = document.elementFromPoint(e.clientX, e.clientY),
                                n = new s.DragStopSensorEvent({
                                    clientX: e.clientX,
                                    clientY: e.clientY,
                                    target: t,
                                    container: this.currentContainer,
                                    originalEvent: e
                                });
                            this.trigger(this.currentContainer, n), document.removeEventListener("contextmenu", this[l]), document.removeEventListener("mousemove", this[u]), this.currentContainer = null, this.dragging = !1
                        } [l](e) {
                            e.preventDefault(), this.openedContextMenu = !0
                        }
                    }

                    function f(e) {
                        e.preventDefault()
                    }
                    t.default = h
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(45),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = Object.assign || function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                            var n = arguments[t];
                            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                        }
                        return e
                    };
                    t.default = class {
                        constructor(e = [], t = {}) {
                            this.containers = [...e], this.options = i({}, t), this.dragging = !1, this.currentContainer = null
                        }
                        attach() {
                            return this
                        }
                        detach() {
                            return this
                        }
                        addContainer(...e) {
                            this.containers = [...this.containers, ...e]
                        }
                        removeContainer(...e) {
                            this.containers = this.containers.filter((t => !e.includes(t)))
                        }
                        trigger(e, t) {
                            const n = document.createEvent("Event");
                            return n.detail = t, n.initEvent(t.type, !0, !0), e.dispatchEvent(n), this.lastEvent = t, t
                        }
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = function (e) {
                        return requestAnimationFrame((() => {
                            requestAnimationFrame(e)
                        }))
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(48),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = function (e, t) {
                        if (!e) return null;
                        const n = t,
                            r = t,
                            o = t,
                            a = t,
                            s = Boolean("string" == typeof t),
                            l = Boolean("function" == typeof t),
                            c = Boolean(t instanceof NodeList || t instanceof Array),
                            u = Boolean(t instanceof HTMLElement);
                        let d = e;
                        do {
                            if (d = d.correspondingUseElement || d.correspondingElement || d, (h = d) ? s ? i.call(h, n) : c ? [...o].includes(h) : u ? a === h : l && r(h) : h) return d;
                            d = d.parentNode
                        } while (d && d !== document.body && d !== document);
                        var h;
                        return null
                    };
                    const i = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(50),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = t.scroll = t.onDragStop = t.onDragMove = t.onDragStart = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(2);
                    const l = t.onDragStart = Symbol("onDragStart"),
                        c = t.onDragMove = Symbol("onDragMove"),
                        u = t.onDragStop = Symbol("onDragStop"),
                        d = t.scroll = Symbol("scroll"),
                        h = t.defaultOptions = {
                            speed: 6,
                            sensitivity: 50,
                            scrollableElements: []
                        };
                    class f extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, h, this.getOptions()), this.currentMousePosition = null, this.scrollAnimationFrame = null, this.scrollableElement = null, this.findScrollableElementFrame = null, this[l] = this[l].bind(this), this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this)
                        }
                        attach() {
                            this.draggable.on("drag:start", this[l]).on("drag:move", this[c]).on("drag:stop", this[u])
                        }
                        detach() {
                            this.draggable.off("drag:start", this[l]).off("drag:move", this[c]).off("drag:stop", this[u])
                        }
                        getOptions() {
                            return this.draggable.options.scrollable || {}
                        }
                        getScrollableElement(e) {
                            return this.hasDefinedScrollableElements() ? (0, s.closest)(e, this.options.scrollableElements) || document.documentElement : function (e) {
                                if (!e) return p();
                                const t = getComputedStyle(e).getPropertyValue("position"),
                                    n = "absolute" === t,
                                    i = (0, s.closest)(e, (e => (!n || ! function (e) {
                                        return "static" === getComputedStyle(e).getPropertyValue("position")
                                    }(e)) && function (e) {
                                        const t = /(auto|scroll)/,
                                            n = getComputedStyle(e, null),
                                            i = n.getPropertyValue("overflow") + n.getPropertyValue("overflow-y") + n.getPropertyValue("overflow-x");
                                        return t.test(i)
                                    }(e)));
                                return "fixed" !== t && i ? i : p()
                            }(e)
                        }
                        hasDefinedScrollableElements() {
                            return Boolean(0 !== this.options.scrollableElements.length)
                        } [l](e) {
                            this.findScrollableElementFrame = requestAnimationFrame((() => {
                                this.scrollableElement = this.getScrollableElement(e.source)
                            }))
                        } [c](e) {
                            if (this.findScrollableElementFrame = requestAnimationFrame((() => {
                                    this.scrollableElement = this.getScrollableElement(e.sensorEvent.target)
                                })), !this.scrollableElement) return;
                            const t = e.sensorEvent,
                                n = {
                                    x: 0,
                                    y: 0
                                };
                            "ontouchstart" in window && (n.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0, n.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0), this.currentMousePosition = {
                                clientX: t.clientX - n.x,
                                clientY: t.clientY - n.y
                            }, this.scrollAnimationFrame = requestAnimationFrame(this[d])
                        } [u]() {
                            cancelAnimationFrame(this.scrollAnimationFrame), cancelAnimationFrame(this.findScrollableElementFrame), this.scrollableElement = null, this.scrollAnimationFrame = null, this.findScrollableElementFrame = null, this.currentMousePosition = null
                        } [d]() {
                            if (!this.scrollableElement || !this.currentMousePosition) return;
                            cancelAnimationFrame(this.scrollAnimationFrame);
                            const {
                                speed: e,
                                sensitivity: t
                            } = this.options, n = this.scrollableElement.getBoundingClientRect(), i = n.bottom > window.innerHeight, r = n.top < 0 || i, o = p(), a = this.scrollableElement, s = this.currentMousePosition.clientX, l = this.currentMousePosition.clientY;
                            if (a === document.body || a === document.documentElement || r) {
                                const {
                                    innerHeight: n,
                                    innerWidth: i
                                } = window;
                                l < t ? o.scrollTop -= e : n - l < t && (o.scrollTop += e), s < t ? o.scrollLeft -= e : i - s < t && (o.scrollLeft += e)
                            } else {
                                const {
                                    offsetHeight: i,
                                    offsetWidth: r
                                } = a;
                                n.top + i - l < t ? a.scrollTop += e : l - n.top < t && (a.scrollTop -= e), n.left + r - s < t ? a.scrollLeft += e : s - n.left < t && (a.scrollLeft -= e)
                            }
                            this.scrollAnimationFrame = requestAnimationFrame(this[d])
                        }
                    }

                    function p() {
                        return document.scrollingElement || document.documentElement
                    }
                    t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = n(52),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default, t.defaultOptions = r.defaultOptions
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.MirrorDestroyEvent = t.MirrorMoveEvent = t.MirrorAttachedEvent = t.MirrorCreatedEvent = t.MirrorCreateEvent = t.MirrorEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get source() {
                            return this.data.source
                        }
                        get originalSource() {
                            return this.data.originalSource
                        }
                        get sourceContainer() {
                            return this.data.sourceContainer
                        }
                        get sensorEvent() {
                            return this.data.sensorEvent
                        }
                        get dragEvent() {
                            return this.data.dragEvent
                        }
                        get originalEvent() {
                            return this.sensorEvent ? this.sensorEvent.originalEvent : null
                        }
                    }
                    t.MirrorEvent = a;
                    class s extends a {}
                    t.MirrorCreateEvent = s, s.type = "mirror:create";
                    class l extends a {
                        get mirror() {
                            return this.data.mirror
                        }
                    }
                    t.MirrorCreatedEvent = l, l.type = "mirror:created";
                    class c extends a {
                        get mirror() {
                            return this.data.mirror
                        }
                    }
                    t.MirrorAttachedEvent = c, c.type = "mirror:attached";
                    class u extends a {
                        get mirror() {
                            return this.data.mirror
                        }
                    }
                    t.MirrorMoveEvent = u, u.type = "mirror:move", u.cancelable = !0;
                    class d extends a {
                        get mirror() {
                            return this.data.mirror
                        }
                    }
                    t.MirrorDestroyEvent = d, d.type = "mirror:destroy", d.cancelable = !0
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(54);
                    Object.keys(i).forEach((function (e) {
                        "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
                            enumerable: !0,
                            get: function () {
                                return i[e]
                            }
                        })
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = t.getAppendableContainer = t.onScroll = t.onMirrorMove = t.onMirrorCreated = t.onDragStop = t.onDragMove = t.onDragStart = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        },
                        s = n(55);

                    function l(e, t) {
                        var n = {};
                        for (var i in e) t.indexOf(i) >= 0 || Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
                        return n
                    }
                    const c = t.onDragStart = Symbol("onDragStart"),
                        u = t.onDragMove = Symbol("onDragMove"),
                        d = t.onDragStop = Symbol("onDragStop"),
                        h = t.onMirrorCreated = Symbol("onMirrorCreated"),
                        f = t.onMirrorMove = Symbol("onMirrorMove"),
                        p = t.onScroll = Symbol("onScroll"),
                        g = t.getAppendableContainer = Symbol("getAppendableContainer"),
                        m = t.defaultOptions = {
                            constrainDimensions: !1,
                            xAxis: !0,
                            yAxis: !0,
                            cursorOffsetX: null,
                            cursorOffsetY: null
                        };
                    class v extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, m, this.getOptions()), this.scrollOffset = {
                                x: 0,
                                y: 0
                            }, this.initialScrollOffset = {
                                x: window.scrollX,
                                y: window.scrollY
                            }, this[c] = this[c].bind(this), this[u] = this[u].bind(this), this[d] = this[d].bind(this), this[h] = this[h].bind(this), this[f] = this[f].bind(this), this[p] = this[p].bind(this)
                        }
                        attach() {
                            this.draggable.on("drag:start", this[c]).on("drag:move", this[u]).on("drag:stop", this[d]).on("mirror:created", this[h]).on("mirror:move", this[f])
                        }
                        detach() {
                            this.draggable.off("drag:start", this[c]).off("drag:move", this[u]).off("drag:stop", this[d]).off("mirror:created", this[h]).off("mirror:move", this[f])
                        }
                        getOptions() {
                            return this.draggable.options.mirror || {}
                        } [c](e) {
                            if (e.canceled()) return;
                            "ontouchstart" in window && document.addEventListener("scroll", this[p], !0), this.initialScrollOffset = {
                                x: window.scrollX,
                                y: window.scrollY
                            };
                            const {
                                source: t,
                                originalSource: n,
                                sourceContainer: i,
                                sensorEvent: r
                            } = e, o = new s.MirrorCreateEvent({
                                source: t,
                                originalSource: n,
                                sourceContainer: i,
                                sensorEvent: r,
                                dragEvent: e
                            });
                            if (this.draggable.trigger(o), function (e) {
                                    return /^drag/.test(e.originalEvent.type)
                                }(r) || o.canceled()) return;
                            const a = this[g](t) || i;
                            this.mirror = t.cloneNode(!0);
                            const l = new s.MirrorCreatedEvent({
                                    source: t,
                                    originalSource: n,
                                    sourceContainer: i,
                                    sensorEvent: r,
                                    dragEvent: e,
                                    mirror: this.mirror
                                }),
                                c = new s.MirrorAttachedEvent({
                                    source: t,
                                    originalSource: n,
                                    sourceContainer: i,
                                    sensorEvent: r,
                                    dragEvent: e,
                                    mirror: this.mirror
                                });
                            this.draggable.trigger(l), a.appendChild(this.mirror), this.draggable.trigger(c)
                        } [u](e) {
                            if (!this.mirror || e.canceled()) return;
                            const {
                                source: t,
                                originalSource: n,
                                sourceContainer: i,
                                sensorEvent: r
                            } = e, o = new s.MirrorMoveEvent({
                                source: t,
                                originalSource: n,
                                sourceContainer: i,
                                sensorEvent: r,
                                dragEvent: e,
                                mirror: this.mirror
                            });
                            this.draggable.trigger(o)
                        } [d](e) {
                            if ("ontouchstart" in window && document.removeEventListener("scroll", this[p], !0), this.initialScrollOffset = {
                                    x: 0,
                                    y: 0
                                }, this.scrollOffset = {
                                    x: 0,
                                    y: 0
                                }, !this.mirror) return;
                            const {
                                source: t,
                                sourceContainer: n,
                                sensorEvent: i
                            } = e, r = new s.MirrorDestroyEvent({
                                source: t,
                                mirror: this.mirror,
                                sourceContainer: n,
                                sensorEvent: i,
                                dragEvent: e
                            });
                            this.draggable.trigger(r), r.canceled() || this.mirror.parentNode.removeChild(this.mirror)
                        } [p]() {
                            this.scrollOffset = {
                                x: window.scrollX - this.initialScrollOffset.x,
                                y: window.scrollY - this.initialScrollOffset.y
                            }
                        } [h]({
                            mirror: e,
                            source: t,
                            sensorEvent: n
                        }) {
                            const i = {
                                mirror: e,
                                source: t,
                                sensorEvent: n,
                                mirrorClass: this.draggable.getClassNameFor("mirror"),
                                scrollOffset: this.scrollOffset,
                                options: this.options
                            };
                            return Promise.resolve(i).then(b).then(y).then(_).then(x).then(E({
                                initial: !0
                            })).then(w).then((e => {
                                let {
                                    mirrorOffset: t,
                                    initialX: n,
                                    initialY: i
                                } = e, o = l(e, ["mirrorOffset", "initialX", "initialY"]);
                                return this.mirrorOffset = t, this.initialX = n, this.initialY = i, r({
                                    mirrorOffset: t,
                                    initialX: n,
                                    initialY: i
                                }, o)
                            }))
                        } [f](e) {
                            if (e.canceled()) return null;
                            const t = {
                                mirror: e.mirror,
                                sensorEvent: e.sensorEvent,
                                mirrorOffset: this.mirrorOffset,
                                options: this.options,
                                initialX: this.initialX,
                                initialY: this.initialY,
                                scrollOffset: this.scrollOffset
                            };
                            return Promise.resolve(t).then(E({
                                raf: !0
                            }))
                        } [g](e) {
                            const t = this.options.appendTo;
                            return "string" == typeof t ? document.querySelector(t) : t instanceof HTMLElement ? t : "function" == typeof t ? t(e) : e.parentNode
                        }
                    }

                    function b(e) {
                        let {
                            source: t
                        } = e, n = l(e, ["source"]);
                        return k((e => {
                            const i = t.getBoundingClientRect();
                            e(r({
                                source: t,
                                sourceRect: i
                            }, n))
                        }))
                    }

                    function y(e) {
                        let {
                            sensorEvent: t,
                            sourceRect: n,
                            options: i
                        } = e, o = l(e, ["sensorEvent", "sourceRect", "options"]);
                        return k((e => {
                            const a = null === i.cursorOffsetY ? t.clientY - n.top : i.cursorOffsetY,
                                s = null === i.cursorOffsetX ? t.clientX - n.left : i.cursorOffsetX;
                            e(r({
                                sensorEvent: t,
                                sourceRect: n,
                                mirrorOffset: {
                                    top: a,
                                    left: s
                                },
                                options: i
                            }, o))
                        }))
                    }

                    function _(e) {
                        let {
                            mirror: t,
                            source: n,
                            options: i
                        } = e, o = l(e, ["mirror", "source", "options"]);
                        return k((e => {
                            let a, s;
                            if (i.constrainDimensions) {
                                const e = getComputedStyle(n);
                                a = e.getPropertyValue("height"), s = e.getPropertyValue("width")
                            }
                            t.style.position = "fixed", t.style.pointerEvents = "none", t.style.top = 0, t.style.left = 0, t.style.margin = 0, i.constrainDimensions && (t.style.height = a, t.style.width = s), e(r({
                                mirror: t,
                                source: n,
                                options: i
                            }, o))
                        }))
                    }

                    function x(e) {
                        let {
                            mirror: t,
                            mirrorClass: n
                        } = e, i = l(e, ["mirror", "mirrorClass"]);
                        return k((e => {
                            t.classList.add(n), e(r({
                                mirror: t,
                                mirrorClass: n
                            }, i))
                        }))
                    }

                    function w(e) {
                        let {
                            mirror: t
                        } = e, n = l(e, ["mirror"]);
                        return k((e => {
                            t.removeAttribute("id"), delete t.id, e(r({
                                mirror: t
                            }, n))
                        }))
                    }

                    function E({
                        withFrame: e = !1,
                        initial: t = !1
                    } = {}) {
                        return n => {
                            let {
                                mirror: i,
                                sensorEvent: o,
                                mirrorOffset: a,
                                initialY: s,
                                initialX: c,
                                scrollOffset: u,
                                options: d
                            } = n, h = l(n, ["mirror", "sensorEvent", "mirrorOffset", "initialY", "initialX", "scrollOffset", "options"]);
                            return k((e => {
                                const n = r({
                                    mirror: i,
                                    sensorEvent: o,
                                    mirrorOffset: a,
                                    options: d
                                }, h);
                                if (a) {
                                    const e = o.clientX - a.left - u.x,
                                        r = o.clientY - a.top - u.y;
                                    d.xAxis && d.yAxis || t ? i.style.transform = `translate3d(${e}px, ${r}px, 0)` : d.xAxis && !d.yAxis ? i.style.transform = `translate3d(${e}px, ${s}px, 0)` : d.yAxis && !d.xAxis && (i.style.transform = `translate3d(${c}px, ${r}px, 0)`), t && (n.initialX = e, n.initialY = r)
                                }
                                e(n)
                            }), {
                                frame: e
                            })
                        }
                    }

                    function k(e, {
                        raf: t = !1
                    } = {}) {
                        return new Promise(((n, i) => {
                            t ? requestAnimationFrame((() => {
                                e(n, i)
                            })) : e(n, i)
                        }))
                    }
                    t.default = v
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = n(56),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default, t.defaultOptions = r.defaultOptions
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        };
                    const s = Symbol("onInitialize"),
                        l = Symbol("onDestroy"),
                        c = {};
                    class u extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, c, this.getOptions()), this[s] = this[s].bind(this), this[l] = this[l].bind(this)
                        }
                        attach() {
                            this.draggable.on("draggable:initialize", this[s]).on("draggable:destroy", this[l])
                        }
                        detach() {
                            this.draggable.off("draggable:initialize", this[s]).off("draggable:destroy", this[l])
                        }
                        getOptions() {
                            return this.draggable.options.focusable || {}
                        }
                        getElements() {
                            return [...this.draggable.containers, ...this.draggable.getDraggableElements()]
                        } [s]() {
                            requestAnimationFrame((() => {
                                this.getElements().forEach((e => function (e) {
                                    Boolean(!e.getAttribute("tabindex") && -1 === e.tabIndex) && (d.push(e), e.tabIndex = 0)
                                }(e)))
                            }))
                        } [l]() {
                            requestAnimationFrame((() => {
                                this.getElements().forEach((e => function (e) {
                                    const t = d.indexOf(e); - 1 !== t && (e.tabIndex = -1, d.splice(t, 1))
                                }(e)))
                            }))
                        }
                    }
                    t.default = u;
                    const d = []
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(58),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = class {
                        constructor(e) {
                            this.draggable = e
                        }
                        attach() {
                            throw new Error("Not Implemented")
                        }
                        detach() {
                            throw new Error("Not Implemented")
                        }
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = Object.assign || function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                            }
                            return e
                        },
                        o = n(1),
                        a = (i = o) && i.__esModule ? i : {
                            default: i
                        };
                    const s = Symbol("onInitialize"),
                        l = Symbol("onDestroy"),
                        c = Symbol("announceEvent"),
                        u = Symbol("announceMessage"),
                        d = t.defaultOptions = {
                            expire: 7e3
                        };
                    class h extends a.default {
                        constructor(e) {
                            super(e), this.options = r({}, d, this.getOptions()), this.originalTriggerMethod = this.draggable.trigger, this[s] = this[s].bind(this), this[l] = this[l].bind(this)
                        }
                        attach() {
                            this.draggable.on("draggable:initialize", this[s])
                        }
                        detach() {
                            this.draggable.off("draggable:destroy", this[l])
                        }
                        getOptions() {
                            return this.draggable.options.announcements || {}
                        } [c](e) {
                            const t = this.options[e.type];
                            t && "string" == typeof t && this[u](t), t && "function" == typeof t && this[u](t(e))
                        } [u](e) {
                            ! function (e, {
                                expire: t
                            }) {
                                const n = document.createElement("div");
                                n.textContent = e, f.appendChild(n), setTimeout((() => {
                                    f.removeChild(n)
                                }), t)
                            }(e, {
                                expire: this.options.expire
                            })
                        } [s]() {
                            this.draggable.trigger = e => {
                                try {
                                    this[c](e)
                                } finally {
                                    this.originalTriggerMethod.call(this.draggable, e)
                                }
                            }
                        } [l]() {
                            this.draggable.trigger = this.originalTriggerMethod
                        }
                    }
                    t.default = h;
                    const f = function () {
                        const e = document.createElement("div");
                        return e.setAttribute("id", "draggable-live-region"), e.setAttribute("aria-relevant", "additions"), e.setAttribute("aria-atomic", "true"), e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "log"), e.style.position = "fixed", e.style.width = "1px", e.style.height = "1px", e.style.top = "-1px", e.style.overflow = "hidden", e
                    }();
                    document.addEventListener("DOMContentLoaded", (() => {
                        document.body.appendChild(f)
                    }))
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.defaultOptions = void 0;
                    var i, r = n(61),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    t.default = o.default, t.defaultOptions = r.defaultOptions
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.DraggableDestroyEvent = t.DraggableInitializedEvent = t.DraggableEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get draggable() {
                            return this.data.draggable
                        }
                    }
                    t.DraggableEvent = a, a.type = "draggable";
                    class s extends a {}
                    t.DraggableInitializedEvent = s, s.type = "draggable:initialize";
                    class l extends a {}
                    t.DraggableDestroyEvent = l, l.type = "draggable:destroy"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = Object.assign || function (e) {
                        for (var t = 1; t < arguments.length; t++) {
                            var n = arguments[t];
                            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
                        }
                        return e
                    };
                    const r = Symbol("canceled");
                    class o {
                        constructor(e) {
                            this[r] = !1, this.data = e
                        }
                        get type() {
                            return this.constructor.type
                        }
                        get cancelable() {
                            return this.constructor.cancelable
                        }
                        cancel() {
                            this[r] = !0
                        }
                        canceled() {
                            return Boolean(this[r])
                        }
                        clone(e) {
                            return new this.constructor(i({}, this.data, e))
                        }
                    }
                    t.default = o, o.type = "event", o.cancelable = !1
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.DragStopEvent = t.DragPressureEvent = t.DragOutContainerEvent = t.DragOverContainerEvent = t.DragOutEvent = t.DragOverEvent = t.DragMoveEvent = t.DragStartEvent = t.DragEvent = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        };
                    class a extends o.default {
                        get source() {
                            return this.data.source
                        }
                        get originalSource() {
                            return this.data.originalSource
                        }
                        get mirror() {
                            return this.data.mirror
                        }
                        get sourceContainer() {
                            return this.data.sourceContainer
                        }
                        get sensorEvent() {
                            return this.data.sensorEvent
                        }
                        get originalEvent() {
                            return this.sensorEvent ? this.sensorEvent.originalEvent : null
                        }
                    }
                    t.DragEvent = a, a.type = "drag";
                    class s extends a {}
                    t.DragStartEvent = s, s.type = "drag:start", s.cancelable = !0;
                    class l extends a {}
                    t.DragMoveEvent = l, l.type = "drag:move";
                    class c extends a {
                        get overContainer() {
                            return this.data.overContainer
                        }
                        get over() {
                            return this.data.over
                        }
                    }
                    t.DragOverEvent = c, c.type = "drag:over", c.cancelable = !0;
                    class u extends a {
                        get overContainer() {
                            return this.data.overContainer
                        }
                        get over() {
                            return this.data.over
                        }
                    }
                    t.DragOutEvent = u, u.type = "drag:out";
                    class d extends a {
                        get overContainer() {
                            return this.data.overContainer
                        }
                    }
                    t.DragOverContainerEvent = d, d.type = "drag:over:container";
                    class h extends a {
                        get overContainer() {
                            return this.data.overContainer
                        }
                    }
                    t.DragOutContainerEvent = h, h.type = "drag:out:container";
                    class f extends a {
                        get pressure() {
                            return this.data.pressure
                        }
                    }
                    t.DragPressureEvent = f, f.type = "drag:pressure";
                    class p extends a {}
                    t.DragStopEvent = p, p.type = "drag:stop"
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.Plugins = t.Sensors = t.Sortable = t.Swappable = t.Droppable = t.Draggable = t.BasePlugin = t.BaseEvent = void 0;
                    var i = n(5);
                    Object.defineProperty(t, "Draggable", {
                        enumerable: !0,
                        get: function () {
                            return h(i).default
                        }
                    });
                    var r = n(34);
                    Object.defineProperty(t, "Droppable", {
                        enumerable: !0,
                        get: function () {
                            return h(r).default
                        }
                    });
                    var o = n(31);
                    Object.defineProperty(t, "Swappable", {
                        enumerable: !0,
                        get: function () {
                            return h(o).default
                        }
                    });
                    var a = n(28);
                    Object.defineProperty(t, "Sortable", {
                        enumerable: !0,
                        get: function () {
                            return h(a).default
                        }
                    });
                    var s = h(n(0)),
                        l = h(n(1)),
                        c = d(n(6)),
                        u = d(n(25));

                    function d(e) {
                        if (e && e.__esModule) return e;
                        var t = {};
                        if (null != e)
                            for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                        return t.default = e, t
                    }

                    function h(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    t.BaseEvent = s.default, t.BasePlugin = l.default, t.Sensors = c, t.Plugins = u
                }])
            }, e.exports = t()
        },
        682: (e, t, n) => {
            "use strict";
            n.d(t, {
                Z: () => u
            });
            var i, r, o = "function" == typeof Map ? new Map : (i = [], r = [], {
                    has: function (e) {
                        return i.indexOf(e) > -1
                    },
                    get: function (e) {
                        return r[i.indexOf(e)]
                    },
                    set: function (e, t) {
                        -1 === i.indexOf(e) && (i.push(e), r.push(t))
                    },
                    delete: function (e) {
                        var t = i.indexOf(e);
                        t > -1 && (i.splice(t, 1), r.splice(t, 1))
                    }
                }),
                a = function (e) {
                    return new Event(e, {
                        bubbles: !0
                    })
                };
            try {
                new Event("test")
            } catch (i) {
                a = function (e) {
                    var t = document.createEvent("Event");
                    return t.initEvent(e, !0, !1), t
                }
            }

            function s(e) {
                var t = o.get(e);
                t && t.destroy()
            }

            function l(e) {
                var t = o.get(e);
                t && t.update()
            }
            var c = null;
            "undefined" == typeof window || "function" != typeof window.getComputedStyle ? ((c = function (e) {
                return e
            }).destroy = function (e) {
                return e
            }, c.update = function (e) {
                return e
            }) : ((c = function (e, t) {
                return e && Array.prototype.forEach.call(e.length ? e : [e], (function (e) {
                    return function (e) {
                        if (e && e.nodeName && "TEXTAREA" === e.nodeName && !o.has(e)) {
                            var t, n = null,
                                i = null,
                                r = null,
                                s = function () {
                                    e.clientWidth !== i && d()
                                },
                                l = function (t) {
                                    window.removeEventListener("resize", s, !1), e.removeEventListener("input", d, !1), e.removeEventListener("keyup", d, !1), e.removeEventListener("autosize:destroy", l, !1), e.removeEventListener("autosize:update", d, !1), Object.keys(t).forEach((function (n) {
                                        e.style[n] = t[n]
                                    })), o.delete(e)
                                }.bind(e, {
                                    height: e.style.height,
                                    resize: e.style.resize,
                                    overflowY: e.style.overflowY,
                                    overflowX: e.style.overflowX,
                                    wordWrap: e.style.wordWrap
                                });
                            e.addEventListener("autosize:destroy", l, !1), "onpropertychange" in e && "oninput" in e && e.addEventListener("keyup", d, !1), window.addEventListener("resize", s, !1), e.addEventListener("input", d, !1), e.addEventListener("autosize:update", d, !1), e.style.overflowX = "hidden", e.style.wordWrap = "break-word", o.set(e, {
                                destroy: l,
                                update: d
                            }), "vertical" === (t = window.getComputedStyle(e, null)).resize ? e.style.resize = "none" : "both" === t.resize && (e.style.resize = "horizontal"), n = "content-box" === t.boxSizing ? -(parseFloat(t.paddingTop) + parseFloat(t.paddingBottom)) : parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), isNaN(n) && (n = 0), d()
                        }

                        function c(t) {
                            var n = e.style.width;
                            e.style.width = "0px", e.style.width = n, e.style.overflowY = t
                        }

                        function u() {
                            if (0 !== e.scrollHeight) {
                                var t = function (e) {
                                        for (var t = []; e && e.parentNode && e.parentNode instanceof Element;) e.parentNode.scrollTop && t.push({
                                            node: e.parentNode,
                                            scrollTop: e.parentNode.scrollTop
                                        }), e = e.parentNode;
                                        return t
                                    }(e),
                                    r = document.documentElement && document.documentElement.scrollTop;
                                e.style.height = "", e.style.height = e.scrollHeight + n + "px", i = e.clientWidth, t.forEach((function (e) {
                                    e.node.scrollTop = e.scrollTop
                                })), r && (document.documentElement.scrollTop = r)
                            }
                        }

                        function d() {
                            u();
                            var t = Math.round(parseFloat(e.style.height)),
                                n = window.getComputedStyle(e, null),
                                i = "content-box" === n.boxSizing ? Math.round(parseFloat(n.height)) : e.offsetHeight;
                            if (i < t ? "hidden" === n.overflowY && (c("scroll"), u(), i = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight) : "hidden" !== n.overflowY && (c("hidden"), u(), i = "content-box" === n.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight), r !== i) {
                                r = i;
                                var o = a("autosize:resized");
                                try {
                                    e.dispatchEvent(o)
                                } catch (e) {}
                            }
                        }
                    }(e)
                })), e
            }).destroy = function (e) {
                return e && Array.prototype.forEach.call(e.length ? e : [e], s), e
            }, c.update = function (e) {
                return e && Array.prototype.forEach.call(e.length ? e : [e], l), e
            });
            const u = c
        },
        169: (e, t, n) => {
            "use strict";
            n.d(t, {
                bZ: () => yt,
                zx: () => xt,
                lr: () => Rt,
                UO: () => Kt,
                Lt: () => gn,
                u_: () => Vn,
                TB: () => Zn,
                J2: () => Ei,
                DA: () => Li,
                OK: () => Bi,
                FN: () => Yi,
                u: () => yi
            });
            var i = {};
            n.r(i), n.d(i, {
                afterMain: () => E,
                afterRead: () => _,
                afterWrite: () => S,
                applyStyles: () => L,
                arrow: () => Z,
                auto: () => l,
                basePlacements: () => c,
                beforeMain: () => x,
                beforeRead: () => b,
                beforeWrite: () => k,
                bottom: () => o,
                clippingParents: () => h,
                computeStyles: () => te,
                createPopper: () => Pe,
                createPopperBase: () => Te,
                createPopperLite: () => De,
                detectOverflow: () => ve,
                end: () => d,
                eventListeners: () => ie,
                flip: () => be,
                hide: () => xe,
                left: () => s,
                main: () => w,
                modifierPhases: () => C,
                offset: () => we,
                placements: () => v,
                popper: () => p,
                popperGenerator: () => Me,
                popperOffsets: () => Ee,
                preventOverflow: () => ke,
                read: () => y,
                reference: () => g,
                right: () => a,
                start: () => u,
                top: () => r,
                variationPlacements: () => m,
                viewport: () => f,
                write: () => O
            });
            var r = "top",
                o = "bottom",
                a = "right",
                s = "left",
                l = "auto",
                c = [r, o, a, s],
                u = "start",
                d = "end",
                h = "clippingParents",
                f = "viewport",
                p = "popper",
                g = "reference",
                m = c.reduce((function (e, t) {
                    return e.concat([t + "-" + u, t + "-" + d])
                }), []),
                v = [].concat(c, [l]).reduce((function (e, t) {
                    return e.concat([t, t + "-" + u, t + "-" + d])
                }), []),
                b = "beforeRead",
                y = "read",
                _ = "afterRead",
                x = "beforeMain",
                w = "main",
                E = "afterMain",
                k = "beforeWrite",
                O = "write",
                S = "afterWrite",
                C = [b, y, _, x, w, E, k, O, S];

            function A(e) {
                return e ? (e.nodeName || "").toLowerCase() : null
            }

            function M(e) {
                if (null == e) return window;
                if ("[object Window]" !== e.toString()) {
                    var t = e.ownerDocument;
                    return t && t.defaultView || window
                }
                return e
            }

            function T(e) {
                return e instanceof M(e).Element || e instanceof Element
            }

            function P(e) {
                return e instanceof M(e).HTMLElement || e instanceof HTMLElement
            }

            function D(e) {
                return "undefined" != typeof ShadowRoot && (e instanceof M(e).ShadowRoot || e instanceof ShadowRoot)
            }
            const L = {
                name: "applyStyles",
                enabled: !0,
                phase: "write",
                fn: function (e) {
                    var t = e.state;
                    Object.keys(t.elements).forEach((function (e) {
                        var n = t.styles[e] || {},
                            i = t.attributes[e] || {},
                            r = t.elements[e];
                        P(r) && A(r) && (Object.assign(r.style, n), Object.keys(i).forEach((function (e) {
                            var t = i[e];
                            !1 === t ? r.removeAttribute(e) : r.setAttribute(e, !0 === t ? "" : t)
                        })))
                    }))
                },
                effect: function (e) {
                    var t = e.state,
                        n = {
                            popper: {
                                position: t.options.strategy,
                                left: "0",
                                top: "0",
                                margin: "0"
                            },
                            arrow: {
                                position: "absolute"
                            },
                            reference: {}
                        };
                    return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow),
                        function () {
                            Object.keys(t.elements).forEach((function (e) {
                                var i = t.elements[e],
                                    r = t.attributes[e] || {},
                                    o = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce((function (e, t) {
                                        return e[t] = "", e
                                    }), {});
                                P(i) && A(i) && (Object.assign(i.style, o), Object.keys(r).forEach((function (e) {
                                    i.removeAttribute(e)
                                })))
                            }))
                        }
                },
                requires: ["computeStyles"]
            };

            function N(e) {
                return e.split("-")[0]
            }

            function j(e, t) {
                void 0 === t && (t = !1);
                var n = e.getBoundingClientRect();
                return {
                    width: n.width / 1,
                    height: n.height / 1,
                    top: n.top / 1,
                    right: n.right / 1,
                    bottom: n.bottom / 1,
                    left: n.left / 1,
                    x: n.left / 1,
                    y: n.top / 1
                }
            }

            function I(e) {
                var t = j(e),
                    n = e.offsetWidth,
                    i = e.offsetHeight;
                return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - i) <= 1 && (i = t.height), {
                    x: e.offsetLeft,
                    y: e.offsetTop,
                    width: n,
                    height: i
                }
            }

            function R(e, t) {
                var n = t.getRootNode && t.getRootNode();
                if (e.contains(t)) return !0;
                if (n && D(n)) {
                    var i = t;
                    do {
                        if (i && e.isSameNode(i)) return !0;
                        i = i.parentNode || i.host
                    } while (i)
                }
                return !1
            }

            function F(e) {
                return M(e).getComputedStyle(e)
            }

            function B(e) {
                return ["table", "td", "th"].indexOf(A(e)) >= 0
            }

            function q(e) {
                return ((T(e) ? e.ownerDocument : e.document) || window.document).documentElement
            }

            function z(e) {
                return "html" === A(e) ? e : e.assignedSlot || e.parentNode || (D(e) ? e.host : null) || q(e)
            }

            function H(e) {
                return P(e) && "fixed" !== F(e).position ? e.offsetParent : null
            }

            function U(e) {
                for (var t = M(e), n = H(e); n && B(n) && "static" === F(n).position;) n = H(n);
                return n && ("html" === A(n) || "body" === A(n) && "static" === F(n).position) ? t : n || function (e) {
                    var t = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
                    if (-1 !== navigator.userAgent.indexOf("Trident") && P(e) && "fixed" === F(e).position) return null;
                    for (var n = z(e); P(n) && ["html", "body"].indexOf(A(n)) < 0;) {
                        var i = F(n);
                        if ("none" !== i.transform || "none" !== i.perspective || "paint" === i.contain || -1 !== ["transform", "perspective"].indexOf(i.willChange) || t && "filter" === i.willChange || t && i.filter && "none" !== i.filter) return n;
                        n = n.parentNode
                    }
                    return null
                }(e) || t
            }

            function V(e) {
                return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y"
            }
            var W = Math.max,
                Y = Math.min,
                $ = Math.round;

            function K(e, t, n) {
                return W(e, Y(t, n))
            }

            function G(e) {
                return Object.assign({}, {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }, e)
            }

            function X(e, t) {
                return t.reduce((function (t, n) {
                    return t[n] = e, t
                }), {})
            }
            const Z = {
                name: "arrow",
                enabled: !0,
                phase: "main",
                fn: function (e) {
                    var t, n = e.state,
                        i = e.name,
                        l = e.options,
                        u = n.elements.arrow,
                        d = n.modifiersData.popperOffsets,
                        h = N(n.placement),
                        f = V(h),
                        p = [s, a].indexOf(h) >= 0 ? "height" : "width";
                    if (u && d) {
                        var g = function (e, t) {
                                return G("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
                                    placement: t.placement
                                })) : e) ? e : X(e, c))
                            }(l.padding, n),
                            m = I(u),
                            v = "y" === f ? r : s,
                            b = "y" === f ? o : a,
                            y = n.rects.reference[p] + n.rects.reference[f] - d[f] - n.rects.popper[p],
                            _ = d[f] - n.rects.reference[f],
                            x = U(u),
                            w = x ? "y" === f ? x.clientHeight || 0 : x.clientWidth || 0 : 0,
                            E = y / 2 - _ / 2,
                            k = g[v],
                            O = w - m[p] - g[b],
                            S = w / 2 - m[p] / 2 + E,
                            C = K(k, S, O),
                            A = f;
                        n.modifiersData[i] = ((t = {})[A] = C, t.centerOffset = C - S, t)
                    }
                },
                effect: function (e) {
                    var t = e.state,
                        n = e.options.element,
                        i = void 0 === n ? "[data-popper-arrow]" : n;
                    null != i && ("string" != typeof i || (i = t.elements.popper.querySelector(i))) && R(t.elements.popper, i) && (t.elements.arrow = i)
                },
                requires: ["popperOffsets"],
                requiresIfExists: ["preventOverflow"]
            };

            function Q(e) {
                return e.split("-")[1]
            }
            var J = {
                top: "auto",
                right: "auto",
                bottom: "auto",
                left: "auto"
            };

            function ee(e) {
                var t, n = e.popper,
                    i = e.popperRect,
                    l = e.placement,
                    c = e.variation,
                    u = e.offsets,
                    h = e.position,
                    f = e.gpuAcceleration,
                    p = e.adaptive,
                    g = e.roundOffsets,
                    m = !0 === g ? function (e) {
                        var t = e.x,
                            n = e.y,
                            i = window.devicePixelRatio || 1;
                        return {
                            x: $($(t * i) / i) || 0,
                            y: $($(n * i) / i) || 0
                        }
                    }(u) : "function" == typeof g ? g(u) : u,
                    v = m.x,
                    b = void 0 === v ? 0 : v,
                    y = m.y,
                    _ = void 0 === y ? 0 : y,
                    x = u.hasOwnProperty("x"),
                    w = u.hasOwnProperty("y"),
                    E = s,
                    k = r,
                    O = window;
                if (p) {
                    var S = U(n),
                        C = "clientHeight",
                        A = "clientWidth";
                    S === M(n) && "static" !== F(S = q(n)).position && "absolute" === h && (C = "scrollHeight", A = "scrollWidth"), S = S, l !== r && (l !== s && l !== a || c !== d) || (k = o, _ -= S[C] - i.height, _ *= f ? 1 : -1), l !== s && (l !== r && l !== o || c !== d) || (E = a, b -= S[A] - i.width, b *= f ? 1 : -1)
                }
                var T, P = Object.assign({
                    position: h
                }, p && J);
                return f ? Object.assign({}, P, ((T = {})[k] = w ? "0" : "", T[E] = x ? "0" : "", T.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + b + "px, " + _ + "px)" : "translate3d(" + b + "px, " + _ + "px, 0)", T)) : Object.assign({}, P, ((t = {})[k] = w ? _ + "px" : "", t[E] = x ? b + "px" : "", t.transform = "", t))
            }
            const te = {
                name: "computeStyles",
                enabled: !0,
                phase: "beforeWrite",
                fn: function (e) {
                    var t = e.state,
                        n = e.options,
                        i = n.gpuAcceleration,
                        r = void 0 === i || i,
                        o = n.adaptive,
                        a = void 0 === o || o,
                        s = n.roundOffsets,
                        l = void 0 === s || s,
                        c = {
                            placement: N(t.placement),
                            variation: Q(t.placement),
                            popper: t.elements.popper,
                            popperRect: t.rects.popper,
                            gpuAcceleration: r
                        };
                    null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, ee(Object.assign({}, c, {
                        offsets: t.modifiersData.popperOffsets,
                        position: t.options.strategy,
                        adaptive: a,
                        roundOffsets: l
                    })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, ee(Object.assign({}, c, {
                        offsets: t.modifiersData.arrow,
                        position: "absolute",
                        adaptive: !1,
                        roundOffsets: l
                    })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
                        "data-popper-placement": t.placement
                    })
                },
                data: {}
            };
            var ne = {
                passive: !0
            };
            const ie = {
                name: "eventListeners",
                enabled: !0,
                phase: "write",
                fn: function () {},
                effect: function (e) {
                    var t = e.state,
                        n = e.instance,
                        i = e.options,
                        r = i.scroll,
                        o = void 0 === r || r,
                        a = i.resize,
                        s = void 0 === a || a,
                        l = M(t.elements.popper),
                        c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
                    return o && c.forEach((function (e) {
                            e.addEventListener("scroll", n.update, ne)
                        })), s && l.addEventListener("resize", n.update, ne),
                        function () {
                            o && c.forEach((function (e) {
                                e.removeEventListener("scroll", n.update, ne)
                            })), s && l.removeEventListener("resize", n.update, ne)
                        }
                },
                data: {}
            };
            var re = {
                left: "right",
                right: "left",
                bottom: "top",
                top: "bottom"
            };

            function oe(e) {
                return e.replace(/left|right|bottom|top/g, (function (e) {
                    return re[e]
                }))
            }
            var ae = {
                start: "end",
                end: "start"
            };

            function se(e) {
                return e.replace(/start|end/g, (function (e) {
                    return ae[e]
                }))
            }

            function le(e) {
                var t = M(e);
                return {
                    scrollLeft: t.pageXOffset,
                    scrollTop: t.pageYOffset
                }
            }

            function ce(e) {
                return j(q(e)).left + le(e).scrollLeft
            }

            function ue(e) {
                var t = F(e),
                    n = t.overflow,
                    i = t.overflowX,
                    r = t.overflowY;
                return /auto|scroll|overlay|hidden/.test(n + r + i)
            }

            function de(e) {
                return ["html", "body", "#document"].indexOf(A(e)) >= 0 ? e.ownerDocument.body : P(e) && ue(e) ? e : de(z(e))
            }

            function he(e, t) {
                var n;
                void 0 === t && (t = []);
                var i = de(e),
                    r = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
                    o = M(i),
                    a = r ? [o].concat(o.visualViewport || [], ue(i) ? i : []) : i,
                    s = t.concat(a);
                return r ? s : s.concat(he(z(a)))
            }

            function fe(e) {
                return Object.assign({}, e, {
                    left: e.x,
                    top: e.y,
                    right: e.x + e.width,
                    bottom: e.y + e.height
                })
            }

            function pe(e, t) {
                return t === f ? fe(function (e) {
                    var t = M(e),
                        n = q(e),
                        i = t.visualViewport,
                        r = n.clientWidth,
                        o = n.clientHeight,
                        a = 0,
                        s = 0;
                    return i && (r = i.width, o = i.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = i.offsetLeft, s = i.offsetTop)), {
                        width: r,
                        height: o,
                        x: a + ce(e),
                        y: s
                    }
                }(e)) : P(t) ? function (e) {
                    var t = j(e);
                    return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t
                }(t) : fe(function (e) {
                    var t, n = q(e),
                        i = le(e),
                        r = null == (t = e.ownerDocument) ? void 0 : t.body,
                        o = W(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0),
                        a = W(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0),
                        s = -i.scrollLeft + ce(e),
                        l = -i.scrollTop;
                    return "rtl" === F(r || n).direction && (s += W(n.clientWidth, r ? r.clientWidth : 0) - o), {
                        width: o,
                        height: a,
                        x: s,
                        y: l
                    }
                }(q(e)))
            }

            function ge(e, t, n) {
                var i = "clippingParents" === t ? function (e) {
                        var t = he(z(e)),
                            n = ["absolute", "fixed"].indexOf(F(e).position) >= 0 && P(e) ? U(e) : e;
                        return T(n) ? t.filter((function (e) {
                            return T(e) && R(e, n) && "body" !== A(e)
                        })) : []
                    }(e) : [].concat(t),
                    r = [].concat(i, [n]),
                    o = r[0],
                    a = r.reduce((function (t, n) {
                        var i = pe(e, n);
                        return t.top = W(i.top, t.top), t.right = Y(i.right, t.right), t.bottom = Y(i.bottom, t.bottom), t.left = W(i.left, t.left), t
                    }), pe(e, o));
                return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a
            }

            function me(e) {
                var t, n = e.reference,
                    i = e.element,
                    l = e.placement,
                    c = l ? N(l) : null,
                    h = l ? Q(l) : null,
                    f = n.x + n.width / 2 - i.width / 2,
                    p = n.y + n.height / 2 - i.height / 2;
                switch (c) {
                    case r:
                        t = {
                            x: f,
                            y: n.y - i.height
                        };
                        break;
                    case o:
                        t = {
                            x: f,
                            y: n.y + n.height
                        };
                        break;
                    case a:
                        t = {
                            x: n.x + n.width,
                            y: p
                        };
                        break;
                    case s:
                        t = {
                            x: n.x - i.width,
                            y: p
                        };
                        break;
                    default:
                        t = {
                            x: n.x,
                            y: n.y
                        }
                }
                var g = c ? V(c) : null;
                if (null != g) {
                    var m = "y" === g ? "height" : "width";
                    switch (h) {
                        case u:
                            t[g] = t[g] - (n[m] / 2 - i[m] / 2);
                            break;
                        case d:
                            t[g] = t[g] + (n[m] / 2 - i[m] / 2)
                    }
                }
                return t
            }

            function ve(e, t) {
                void 0 === t && (t = {});
                var n = t,
                    i = n.placement,
                    s = void 0 === i ? e.placement : i,
                    l = n.boundary,
                    u = void 0 === l ? h : l,
                    d = n.rootBoundary,
                    m = void 0 === d ? f : d,
                    v = n.elementContext,
                    b = void 0 === v ? p : v,
                    y = n.altBoundary,
                    _ = void 0 !== y && y,
                    x = n.padding,
                    w = void 0 === x ? 0 : x,
                    E = G("number" != typeof w ? w : X(w, c)),
                    k = b === p ? g : p,
                    O = e.rects.popper,
                    S = e.elements[_ ? k : b],
                    C = ge(T(S) ? S : S.contextElement || q(e.elements.popper), u, m),
                    A = j(e.elements.reference),
                    M = me({
                        reference: A,
                        element: O,
                        strategy: "absolute",
                        placement: s
                    }),
                    P = fe(Object.assign({}, O, M)),
                    D = b === p ? P : A,
                    L = {
                        top: C.top - D.top + E.top,
                        bottom: D.bottom - C.bottom + E.bottom,
                        left: C.left - D.left + E.left,
                        right: D.right - C.right + E.right
                    },
                    N = e.modifiersData.offset;
                if (b === p && N) {
                    var I = N[s];
                    Object.keys(L).forEach((function (e) {
                        var t = [a, o].indexOf(e) >= 0 ? 1 : -1,
                            n = [r, o].indexOf(e) >= 0 ? "y" : "x";
                        L[e] += I[n] * t
                    }))
                }
                return L
            }
            const be = {
                name: "flip",
                enabled: !0,
                phase: "main",
                fn: function (e) {
                    var t = e.state,
                        n = e.options,
                        i = e.name;
                    if (!t.modifiersData[i]._skip) {
                        for (var d = n.mainAxis, h = void 0 === d || d, f = n.altAxis, p = void 0 === f || f, g = n.fallbackPlacements, b = n.padding, y = n.boundary, _ = n.rootBoundary, x = n.altBoundary, w = n.flipVariations, E = void 0 === w || w, k = n.allowedAutoPlacements, O = t.options.placement, S = N(O), C = g || (S === O || !E ? [oe(O)] : function (e) {
                                if (N(e) === l) return [];
                                var t = oe(e);
                                return [se(e), t, se(t)]
                            }(O)), A = [O].concat(C).reduce((function (e, n) {
                                return e.concat(N(n) === l ? function (e, t) {
                                    void 0 === t && (t = {});
                                    var n = t,
                                        i = n.placement,
                                        r = n.boundary,
                                        o = n.rootBoundary,
                                        a = n.padding,
                                        s = n.flipVariations,
                                        l = n.allowedAutoPlacements,
                                        u = void 0 === l ? v : l,
                                        d = Q(i),
                                        h = d ? s ? m : m.filter((function (e) {
                                            return Q(e) === d
                                        })) : c,
                                        f = h.filter((function (e) {
                                            return u.indexOf(e) >= 0
                                        }));
                                    0 === f.length && (f = h);
                                    var p = f.reduce((function (t, n) {
                                        return t[n] = ve(e, {
                                            placement: n,
                                            boundary: r,
                                            rootBoundary: o,
                                            padding: a
                                        })[N(n)], t
                                    }), {});
                                    return Object.keys(p).sort((function (e, t) {
                                        return p[e] - p[t]
                                    }))
                                }(t, {
                                    placement: n,
                                    boundary: y,
                                    rootBoundary: _,
                                    padding: b,
                                    flipVariations: E,
                                    allowedAutoPlacements: k
                                }) : n)
                            }), []), M = t.rects.reference, T = t.rects.popper, P = new Map, D = !0, L = A[0], j = 0; j < A.length; j++) {
                            var I = A[j],
                                R = N(I),
                                F = Q(I) === u,
                                B = [r, o].indexOf(R) >= 0,
                                q = B ? "width" : "height",
                                z = ve(t, {
                                    placement: I,
                                    boundary: y,
                                    rootBoundary: _,
                                    altBoundary: x,
                                    padding: b
                                }),
                                H = B ? F ? a : s : F ? o : r;
                            M[q] > T[q] && (H = oe(H));
                            var U = oe(H),
                                V = [];
                            if (h && V.push(z[R] <= 0), p && V.push(z[H] <= 0, z[U] <= 0), V.every((function (e) {
                                    return e
                                }))) {
                                L = I, D = !1;
                                break
                            }
                            P.set(I, V)
                        }
                        if (D)
                            for (var W = function (e) {
                                    var t = A.find((function (t) {
                                        var n = P.get(t);
                                        if (n) return n.slice(0, e).every((function (e) {
                                            return e
                                        }))
                                    }));
                                    if (t) return L = t, "break"
                                }, Y = E ? 3 : 1; Y > 0; Y--) {
                                if ("break" === W(Y)) break
                            }
                        t.placement !== L && (t.modifiersData[i]._skip = !0, t.placement = L, t.reset = !0)
                    }
                },
                requiresIfExists: ["offset"],
                data: {
                    _skip: !1
                }
            };

            function ye(e, t, n) {
                return void 0 === n && (n = {
                    x: 0,
                    y: 0
                }), {
                    top: e.top - t.height - n.y,
                    right: e.right - t.width + n.x,
                    bottom: e.bottom - t.height + n.y,
                    left: e.left - t.width - n.x
                }
            }

            function _e(e) {
                return [r, a, o, s].some((function (t) {
                    return e[t] >= 0
                }))
            }
            const xe = {
                name: "hide",
                enabled: !0,
                phase: "main",
                requiresIfExists: ["preventOverflow"],
                fn: function (e) {
                    var t = e.state,
                        n = e.name,
                        i = t.rects.reference,
                        r = t.rects.popper,
                        o = t.modifiersData.preventOverflow,
                        a = ve(t, {
                            elementContext: "reference"
                        }),
                        s = ve(t, {
                            altBoundary: !0
                        }),
                        l = ye(a, i),
                        c = ye(s, r, o),
                        u = _e(l),
                        d = _e(c);
                    t.modifiersData[n] = {
                        referenceClippingOffsets: l,
                        popperEscapeOffsets: c,
                        isReferenceHidden: u,
                        hasPopperEscaped: d
                    }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
                        "data-popper-reference-hidden": u,
                        "data-popper-escaped": d
                    })
                }
            };
            const we = {
                name: "offset",
                enabled: !0,
                phase: "main",
                requires: ["popperOffsets"],
                fn: function (e) {
                    var t = e.state,
                        n = e.options,
                        i = e.name,
                        o = n.offset,
                        l = void 0 === o ? [0, 0] : o,
                        c = v.reduce((function (e, n) {
                            return e[n] = function (e, t, n) {
                                var i = N(e),
                                    o = [s, r].indexOf(i) >= 0 ? -1 : 1,
                                    l = "function" == typeof n ? n(Object.assign({}, t, {
                                        placement: e
                                    })) : n,
                                    c = l[0],
                                    u = l[1];
                                return c = c || 0, u = (u || 0) * o, [s, a].indexOf(i) >= 0 ? {
                                    x: u,
                                    y: c
                                } : {
                                    x: c,
                                    y: u
                                }
                            }(n, t.rects, l), e
                        }), {}),
                        u = c[t.placement],
                        d = u.x,
                        h = u.y;
                    null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += h), t.modifiersData[i] = c
                }
            };
            const Ee = {
                name: "popperOffsets",
                enabled: !0,
                phase: "read",
                fn: function (e) {
                    var t = e.state,
                        n = e.name;
                    t.modifiersData[n] = me({
                        reference: t.rects.reference,
                        element: t.rects.popper,
                        strategy: "absolute",
                        placement: t.placement
                    })
                },
                data: {}
            };
            const ke = {
                name: "preventOverflow",
                enabled: !0,
                phase: "main",
                fn: function (e) {
                    var t = e.state,
                        n = e.options,
                        i = e.name,
                        l = n.mainAxis,
                        c = void 0 === l || l,
                        d = n.altAxis,
                        h = void 0 !== d && d,
                        f = n.boundary,
                        p = n.rootBoundary,
                        g = n.altBoundary,
                        m = n.padding,
                        v = n.tether,
                        b = void 0 === v || v,
                        y = n.tetherOffset,
                        _ = void 0 === y ? 0 : y,
                        x = ve(t, {
                            boundary: f,
                            rootBoundary: p,
                            padding: m,
                            altBoundary: g
                        }),
                        w = N(t.placement),
                        E = Q(t.placement),
                        k = !E,
                        O = V(w),
                        S = "x" === O ? "y" : "x",
                        C = t.modifiersData.popperOffsets,
                        A = t.rects.reference,
                        M = t.rects.popper,
                        T = "function" == typeof _ ? _(Object.assign({}, t.rects, {
                            placement: t.placement
                        })) : _,
                        P = {
                            x: 0,
                            y: 0
                        };
                    if (C) {
                        if (c || h) {
                            var D = "y" === O ? r : s,
                                L = "y" === O ? o : a,
                                j = "y" === O ? "height" : "width",
                                R = C[O],
                                F = C[O] + x[D],
                                B = C[O] - x[L],
                                q = b ? -M[j] / 2 : 0,
                                z = E === u ? A[j] : M[j],
                                H = E === u ? -M[j] : -A[j],
                                $ = t.elements.arrow,
                                G = b && $ ? I($) : {
                                    width: 0,
                                    height: 0
                                },
                                X = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                Z = X[D],
                                J = X[L],
                                ee = K(0, A[j], G[j]),
                                te = k ? A[j] / 2 - q - ee - Z - T : z - ee - Z - T,
                                ne = k ? -A[j] / 2 + q + ee + J + T : H + ee + J + T,
                                ie = t.elements.arrow && U(t.elements.arrow),
                                re = ie ? "y" === O ? ie.clientTop || 0 : ie.clientLeft || 0 : 0,
                                oe = t.modifiersData.offset ? t.modifiersData.offset[t.placement][O] : 0,
                                ae = C[O] + te - oe - re,
                                se = C[O] + ne - oe;
                            if (c) {
                                var le = K(b ? Y(F, ae) : F, R, b ? W(B, se) : B);
                                C[O] = le, P[O] = le - R
                            }
                            if (h) {
                                var ce = "x" === O ? r : s,
                                    ue = "x" === O ? o : a,
                                    de = C[S],
                                    he = de + x[ce],
                                    fe = de - x[ue],
                                    pe = K(b ? Y(he, ae) : he, de, b ? W(fe, se) : fe);
                                C[S] = pe, P[S] = pe - de
                            }
                        }
                        t.modifiersData[i] = P
                    }
                },
                requiresIfExists: ["offset"]
            };

            function Oe(e, t, n) {
                void 0 === n && (n = !1);
                var i, r, o = P(t),
                    a = P(t) && function (e) {
                        var t = e.getBoundingClientRect(),
                            n = t.width / e.offsetWidth || 1,
                            i = t.height / e.offsetHeight || 1;
                        return 1 !== n || 1 !== i
                    }(t),
                    s = q(t),
                    l = j(e, a),
                    c = {
                        scrollLeft: 0,
                        scrollTop: 0
                    },
                    u = {
                        x: 0,
                        y: 0
                    };
                return (o || !o && !n) && (("body" !== A(t) || ue(s)) && (c = (i = t) !== M(i) && P(i) ? {
                    scrollLeft: (r = i).scrollLeft,
                    scrollTop: r.scrollTop
                } : le(i)), P(t) ? ((u = j(t, !0)).x += t.clientLeft, u.y += t.clientTop) : s && (u.x = ce(s))), {
                    x: l.left + c.scrollLeft - u.x,
                    y: l.top + c.scrollTop - u.y,
                    width: l.width,
                    height: l.height
                }
            }

            function Se(e) {
                var t = new Map,
                    n = new Set,
                    i = [];

                function r(e) {
                    n.add(e.name), [].concat(e.requires || [], e.requiresIfExists || []).forEach((function (e) {
                        if (!n.has(e)) {
                            var i = t.get(e);
                            i && r(i)
                        }
                    })), i.push(e)
                }
                return e.forEach((function (e) {
                    t.set(e.name, e)
                })), e.forEach((function (e) {
                    n.has(e.name) || r(e)
                })), i
            }
            var Ce = {
                placement: "bottom",
                modifiers: [],
                strategy: "absolute"
            };

            function Ae() {
                for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                return !t.some((function (e) {
                    return !(e && "function" == typeof e.getBoundingClientRect)
                }))
            }

            function Me(e) {
                void 0 === e && (e = {});
                var t = e,
                    n = t.defaultModifiers,
                    i = void 0 === n ? [] : n,
                    r = t.defaultOptions,
                    o = void 0 === r ? Ce : r;
                return function (e, t, n) {
                    void 0 === n && (n = o);
                    var r, a, s = {
                            placement: "bottom",
                            orderedModifiers: [],
                            options: Object.assign({}, Ce, o),
                            modifiersData: {},
                            elements: {
                                reference: e,
                                popper: t
                            },
                            attributes: {},
                            styles: {}
                        },
                        l = [],
                        c = !1,
                        u = {
                            state: s,
                            setOptions: function (n) {
                                var r = "function" == typeof n ? n(s.options) : n;
                                d(), s.options = Object.assign({}, o, s.options, r), s.scrollParents = {
                                    reference: T(e) ? he(e) : e.contextElement ? he(e.contextElement) : [],
                                    popper: he(t)
                                };
                                var a = function (e) {
                                    var t = Se(e);
                                    return C.reduce((function (e, n) {
                                        return e.concat(t.filter((function (e) {
                                            return e.phase === n
                                        })))
                                    }), [])
                                }(function (e) {
                                    var t = e.reduce((function (e, t) {
                                        var n = e[t.name];
                                        return e[t.name] = n ? Object.assign({}, n, t, {
                                            options: Object.assign({}, n.options, t.options),
                                            data: Object.assign({}, n.data, t.data)
                                        }) : t, e
                                    }), {});
                                    return Object.keys(t).map((function (e) {
                                        return t[e]
                                    }))
                                }([].concat(i, s.options.modifiers)));
                                return s.orderedModifiers = a.filter((function (e) {
                                    return e.enabled
                                })), s.orderedModifiers.forEach((function (e) {
                                    var t = e.name,
                                        n = e.options,
                                        i = void 0 === n ? {} : n,
                                        r = e.effect;
                                    if ("function" == typeof r) {
                                        var o = r({
                                                state: s,
                                                name: t,
                                                instance: u,
                                                options: i
                                            }),
                                            a = function () {};
                                        l.push(o || a)
                                    }
                                })), u.update()
                            },
                            forceUpdate: function () {
                                if (!c) {
                                    var e = s.elements,
                                        t = e.reference,
                                        n = e.popper;
                                    if (Ae(t, n)) {
                                        s.rects = {
                                            reference: Oe(t, U(n), "fixed" === s.options.strategy),
                                            popper: I(n)
                                        }, s.reset = !1, s.placement = s.options.placement, s.orderedModifiers.forEach((function (e) {
                                            return s.modifiersData[e.name] = Object.assign({}, e.data)
                                        }));
                                        for (var i = 0; i < s.orderedModifiers.length; i++)
                                            if (!0 !== s.reset) {
                                                var r = s.orderedModifiers[i],
                                                    o = r.fn,
                                                    a = r.options,
                                                    l = void 0 === a ? {} : a,
                                                    d = r.name;
                                                "function" == typeof o && (s = o({
                                                    state: s,
                                                    options: l,
                                                    name: d,
                                                    instance: u
                                                }) || s)
                                            } else s.reset = !1, i = -1
                                    }
                                }
                            },
                            update: (r = function () {
                                return new Promise((function (e) {
                                    u.forceUpdate(), e(s)
                                }))
                            }, function () {
                                return a || (a = new Promise((function (e) {
                                    Promise.resolve().then((function () {
                                        a = void 0, e(r())
                                    }))
                                }))), a
                            }),
                            destroy: function () {
                                d(), c = !0
                            }
                        };
                    if (!Ae(e, t)) return u;

                    function d() {
                        l.forEach((function (e) {
                            return e()
                        })), l = []
                    }
                    return u.setOptions(n).then((function (e) {
                        !c && n.onFirstUpdate && n.onFirstUpdate(e)
                    })), u
                }
            }
            var Te = Me(),
                Pe = Me({
                    defaultModifiers: [ie, Ee, te, L, we, be, ke, Z, xe]
                }),
                De = Me({
                    defaultModifiers: [ie, Ee, te, L]
                });
            const Le = "transitionend",
                Ne = e => {
                    let t = e.getAttribute("data-bs-target");
                    if (!t || "#" === t) {
                        let n = e.getAttribute("href");
                        if (!n || !n.includes("#") && !n.startsWith(".")) return null;
                        n.includes("#") && !n.startsWith("#") && (n = `#${n.split("#")[1]}`), t = n && "#" !== n ? n.trim() : null
                    }
                    return t
                },
                je = e => {
                    const t = Ne(e);
                    return t && document.querySelector(t) ? t : null
                },
                Ie = e => {
                    const t = Ne(e);
                    return t ? document.querySelector(t) : null
                },
                Re = e => {
                    e.dispatchEvent(new Event(Le))
                },
                Fe = e => !(!e || "object" != typeof e) && (void 0 !== e.jquery && (e = e[0]), void 0 !== e.nodeType),
                Be = e => Fe(e) ? e.jquery ? e[0] : e : "string" == typeof e && e.length > 0 ? document.querySelector(e) : null,
                qe = (e, t, n) => {
                    Object.keys(n).forEach((i => {
                        const r = n[i],
                            o = t[i],
                            a = o && Fe(o) ? "element" : null == (s = o) ? `${s}` : {}.toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase();
                        var s;
                        if (!new RegExp(r).test(a)) throw new TypeError(`${e.toUpperCase()}: Option "${i}" provided type "${a}" but expected type "${r}".`)
                    }))
                },
                ze = e => !(!Fe(e) || 0 === e.getClientRects().length) && "visible" === getComputedStyle(e).getPropertyValue("visibility"),
                He = e => !e || e.nodeType !== Node.ELEMENT_NODE || (!!e.classList.contains("disabled") || (void 0 !== e.disabled ? e.disabled : e.hasAttribute("disabled") && "false" !== e.getAttribute("disabled"))),
                Ue = e => {
                    if (!document.documentElement.attachShadow) return null;
                    if ("function" == typeof e.getRootNode) {
                        const t = e.getRootNode();
                        return t instanceof ShadowRoot ? t : null
                    }
                    return e instanceof ShadowRoot ? e : e.parentNode ? Ue(e.parentNode) : null
                },
                Ve = () => {},
                We = e => {
                    e.offsetHeight
                },
                Ye = () => {
                    const {
                        jQuery: e
                    } = window;
                    return e && !document.body.hasAttribute("data-bs-no-jquery") ? e : null
                },
                $e = [],
                Ke = () => "rtl" === document.documentElement.dir,
                Ge = e => {
                    var t;
                    t = () => {
                        const t = Ye();
                        if (t) {
                            const n = e.NAME,
                                i = t.fn[n];
                            t.fn[n] = e.jQueryInterface, t.fn[n].Constructor = e, t.fn[n].noConflict = () => (t.fn[n] = i, e.jQueryInterface)
                        }
                    }, "loading" === document.readyState ? ($e.length || document.addEventListener("DOMContentLoaded", (() => {
                        $e.forEach((e => e()))
                    })), $e.push(t)) : t()
                },
                Xe = e => {
                    "function" == typeof e && e()
                },
                Ze = (e, t, n = !0) => {
                    if (!n) return void Xe(e);
                    const i = (e => {
                        if (!e) return 0;
                        let {
                            transitionDuration: t,
                            transitionDelay: n
                        } = window.getComputedStyle(e);
                        const i = Number.parseFloat(t),
                            r = Number.parseFloat(n);
                        return i || r ? (t = t.split(",")[0], n = n.split(",")[0], 1e3 * (Number.parseFloat(t) + Number.parseFloat(n))) : 0
                    })(t) + 5;
                    let r = !1;
                    const o = ({
                        target: n
                    }) => {
                        n === t && (r = !0, t.removeEventListener(Le, o), Xe(e))
                    };
                    t.addEventListener(Le, o), setTimeout((() => {
                        r || Re(t)
                    }), i)
                },
                Qe = (e, t, n, i) => {
                    let r = e.indexOf(t);
                    if (-1 === r) return e[!n && i ? e.length - 1 : 0];
                    const o = e.length;
                    return r += n ? 1 : -1, i && (r = (r + o) % o), e[Math.max(0, Math.min(r, o - 1))]
                },
                Je = /[^.]*(?=\..*)\.|.*/,
                et = /\..*/,
                tt = /::\d+$/,
                nt = {};
            let it = 1;
            const rt = {
                    mouseenter: "mouseover",
                    mouseleave: "mouseout"
                },
                ot = /^(mouseenter|mouseleave)/i,
                at = new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);

            function st(e, t) {
                return t && `${t}::${it++}` || e.uidEvent || it++
            }

            function lt(e) {
                const t = st(e);
                return e.uidEvent = t, nt[t] = nt[t] || {}, nt[t]
            }

            function ct(e, t, n = null) {
                const i = Object.keys(e);
                for (let r = 0, o = i.length; r < o; r++) {
                    const o = e[i[r]];
                    if (o.originalHandler === t && o.delegationSelector === n) return o
                }
                return null
            }

            function ut(e, t, n) {
                const i = "string" == typeof t,
                    r = i ? n : t;
                let o = ft(e);
                return at.has(o) || (o = e), [i, r, o]
            }

            function dt(e, t, n, i, r) {
                if ("string" != typeof t || !e) return;
                if (n || (n = i, i = null), ot.test(t)) {
                    const e = e => function (t) {
                        if (!t.relatedTarget || t.relatedTarget !== t.delegateTarget && !t.delegateTarget.contains(t.relatedTarget)) return e.call(this, t)
                    };
                    i ? i = e(i) : n = e(n)
                }
                const [o, a, s] = ut(t, n, i), l = lt(e), c = l[s] || (l[s] = {}), u = ct(c, a, o ? n : null);
                if (u) return void(u.oneOff = u.oneOff && r);
                const d = st(a, t.replace(Je, "")),
                    h = o ? function (e, t, n) {
                        return function i(r) {
                            const o = e.querySelectorAll(t);
                            for (let {
                                    target: a
                                } = r; a && a !== this; a = a.parentNode)
                                for (let s = o.length; s--;)
                                    if (o[s] === a) return r.delegateTarget = a, i.oneOff && pt.off(e, r.type, t, n), n.apply(a, [r]);
                            return null
                        }
                    }(e, n, i) : function (e, t) {
                        return function n(i) {
                            return i.delegateTarget = e, n.oneOff && pt.off(e, i.type, t), t.apply(e, [i])
                        }
                    }(e, n);
                h.delegationSelector = o ? n : null, h.originalHandler = a, h.oneOff = r, h.uidEvent = d, c[d] = h, e.addEventListener(s, h, o)
            }

            function ht(e, t, n, i, r) {
                const o = ct(t[n], i, r);
                o && (e.removeEventListener(n, o, Boolean(r)), delete t[n][o.uidEvent])
            }

            function ft(e) {
                return e = e.replace(et, ""), rt[e] || e
            }
            const pt = {
                    on(e, t, n, i) {
                        dt(e, t, n, i, !1)
                    },
                    one(e, t, n, i) {
                        dt(e, t, n, i, !0)
                    },
                    off(e, t, n, i) {
                        if ("string" != typeof t || !e) return;
                        const [r, o, a] = ut(t, n, i), s = a !== t, l = lt(e), c = t.startsWith(".");
                        if (void 0 !== o) {
                            if (!l || !l[a]) return;
                            return void ht(e, l, a, o, r ? n : null)
                        }
                        c && Object.keys(l).forEach((n => {
                            ! function (e, t, n, i) {
                                const r = t[n] || {};
                                Object.keys(r).forEach((o => {
                                    if (o.includes(i)) {
                                        const i = r[o];
                                        ht(e, t, n, i.originalHandler, i.delegationSelector)
                                    }
                                }))
                            }(e, l, n, t.slice(1))
                        }));
                        const u = l[a] || {};
                        Object.keys(u).forEach((n => {
                            const i = n.replace(tt, "");
                            if (!s || t.includes(i)) {
                                const t = u[n];
                                ht(e, l, a, t.originalHandler, t.delegationSelector)
                            }
                        }))
                    },
                    trigger(e, t, n) {
                        if ("string" != typeof t || !e) return null;
                        const i = Ye(),
                            r = ft(t),
                            o = t !== r,
                            a = at.has(r);
                        let s, l = !0,
                            c = !0,
                            u = !1,
                            d = null;
                        return o && i && (s = i.Event(t, n), i(e).trigger(s), l = !s.isPropagationStopped(), c = !s.isImmediatePropagationStopped(), u = s.isDefaultPrevented()), a ? (d = document.createEvent("HTMLEvents"), d.initEvent(r, l, !0)) : d = new CustomEvent(t, {
                            bubbles: l,
                            cancelable: !0
                        }), void 0 !== n && Object.keys(n).forEach((e => {
                            Object.defineProperty(d, e, {
                                get: () => n[e]
                            })
                        })), u && d.preventDefault(), c && e.dispatchEvent(d), d.defaultPrevented && void 0 !== s && s.preventDefault(), d
                    }
                },
                gt = new Map,
                mt = {
                    set(e, t, n) {
                        gt.has(e) || gt.set(e, new Map);
                        const i = gt.get(e);
                        i.has(t) || 0 === i.size ? i.set(t, n) : console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(i.keys())[0]}.`)
                    },
                    get: (e, t) => gt.has(e) && gt.get(e).get(t) || null,
                    remove(e, t) {
                        if (!gt.has(e)) return;
                        const n = gt.get(e);
                        n.delete(t), 0 === n.size && gt.delete(e)
                    }
                };
            class vt {
                constructor(e) {
                    (e = Be(e)) && (this._element = e, mt.set(this._element, this.constructor.DATA_KEY, this))
                }
                dispose() {
                    mt.remove(this._element, this.constructor.DATA_KEY), pt.off(this._element, this.constructor.EVENT_KEY), Object.getOwnPropertyNames(this).forEach((e => {
                        this[e] = null
                    }))
                }
                _queueCallback(e, t, n = !0) {
                    Ze(e, t, n)
                }
                static getInstance(e) {
                    return mt.get(Be(e), this.DATA_KEY)
                }
                static getOrCreateInstance(e, t = {}) {
                    return this.getInstance(e) || new this(e, "object" == typeof t ? t : null)
                }
                static get VERSION() {
                    return "5.1.3"
                }
                static get NAME() {
                    throw new Error('You have to implement the static method "NAME", for each component!')
                }
                static get DATA_KEY() {
                    return `bs.${this.NAME}`
                }
                static get EVENT_KEY() {
                    return `.${this.DATA_KEY}`
                }
            }
            const bt = (e, t = "hide") => {
                const n = `click.dismiss${e.EVENT_KEY}`,
                    i = e.NAME;
                pt.on(document, n, `[data-bs-dismiss="${i}"]`, (function (n) {
                    if (["A", "AREA"].includes(this.tagName) && n.preventDefault(), He(this)) return;
                    const r = Ie(this) || this.closest(`.${i}`);
                    e.getOrCreateInstance(r)[t]()
                }))
            };
            class yt extends vt {
                static get NAME() {
                    return "alert"
                }
                close() {
                    if (pt.trigger(this._element, "close.bs.alert").defaultPrevented) return;
                    this._element.classList.remove("show");
                    const e = this._element.classList.contains("fade");
                    this._queueCallback((() => this._destroyElement()), this._element, e)
                }
                _destroyElement() {
                    this._element.remove(), pt.trigger(this._element, "closed.bs.alert"), this.dispose()
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = yt.getOrCreateInstance(this);
                        if ("string" == typeof e) {
                            if (void 0 === t[e] || e.startsWith("_") || "constructor" === e) throw new TypeError(`No method named "${e}"`);
                            t[e](this)
                        }
                    }))
                }
            }
            bt(yt, "close"), Ge(yt);
            const _t = '[data-bs-toggle="button"]';
            class xt extends vt {
                static get NAME() {
                    return "button"
                }
                toggle() {
                    this._element.setAttribute("aria-pressed", this._element.classList.toggle("active"))
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = xt.getOrCreateInstance(this);
                        "toggle" === e && t[e]()
                    }))
                }
            }

            function wt(e) {
                return "true" === e || "false" !== e && (e === Number(e).toString() ? Number(e) : "" === e || "null" === e ? null : e)
            }

            function Et(e) {
                return e.replace(/[A-Z]/g, (e => `-${e.toLowerCase()}`))
            }
            pt.on(document, "click.bs.button.data-api", _t, (e => {
                e.preventDefault();
                const t = e.target.closest(_t);
                xt.getOrCreateInstance(t).toggle()
            })), Ge(xt);
            const kt = {
                    setDataAttribute(e, t, n) {
                        e.setAttribute(`data-bs-${Et(t)}`, n)
                    },
                    removeDataAttribute(e, t) {
                        e.removeAttribute(`data-bs-${Et(t)}`)
                    },
                    getDataAttributes(e) {
                        if (!e) return {};
                        const t = {};
                        return Object.keys(e.dataset).filter((e => e.startsWith("bs"))).forEach((n => {
                            let i = n.replace(/^bs/, "");
                            i = i.charAt(0).toLowerCase() + i.slice(1, i.length), t[i] = wt(e.dataset[n])
                        })), t
                    },
                    getDataAttribute: (e, t) => wt(e.getAttribute(`data-bs-${Et(t)}`)),
                    offset(e) {
                        const t = e.getBoundingClientRect();
                        return {
                            top: t.top + window.pageYOffset,
                            left: t.left + window.pageXOffset
                        }
                    },
                    position: e => ({
                        top: e.offsetTop,
                        left: e.offsetLeft
                    })
                },
                Ot = {
                    find: (e, t = document.documentElement) => [].concat(...Element.prototype.querySelectorAll.call(t, e)),
                    findOne: (e, t = document.documentElement) => Element.prototype.querySelector.call(t, e),
                    children: (e, t) => [].concat(...e.children).filter((e => e.matches(t))),
                    parents(e, t) {
                        const n = [];
                        let i = e.parentNode;
                        for (; i && i.nodeType === Node.ELEMENT_NODE && 3 !== i.nodeType;) i.matches(t) && n.push(i), i = i.parentNode;
                        return n
                    },
                    prev(e, t) {
                        let n = e.previousElementSibling;
                        for (; n;) {
                            if (n.matches(t)) return [n];
                            n = n.previousElementSibling
                        }
                        return []
                    },
                    next(e, t) {
                        let n = e.nextElementSibling;
                        for (; n;) {
                            if (n.matches(t)) return [n];
                            n = n.nextElementSibling
                        }
                        return []
                    },
                    focusableChildren(e) {
                        const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((e => `${e}:not([tabindex^="-"])`)).join(", ");
                        return this.find(t, e).filter((e => !He(e) && ze(e)))
                    }
                },
                St = "carousel",
                Ct = {
                    interval: 5e3,
                    keyboard: !0,
                    slide: !1,
                    pause: "hover",
                    wrap: !0,
                    touch: !0
                },
                At = {
                    interval: "(number|boolean)",
                    keyboard: "boolean",
                    slide: "(boolean|string)",
                    pause: "(string|boolean)",
                    wrap: "boolean",
                    touch: "boolean"
                },
                Mt = "next",
                Tt = "prev",
                Pt = "left",
                Dt = "right",
                Lt = {
                    ArrowLeft: Dt,
                    ArrowRight: Pt
                },
                Nt = "slid.bs.carousel",
                jt = "active",
                It = ".active.carousel-item";
            class Rt extends vt {
                constructor(e, t) {
                    super(e), this._items = null, this._interval = null, this._activeElement = null, this._isPaused = !1, this._isSliding = !1, this.touchTimeout = null, this.touchStartX = 0, this.touchDeltaX = 0, this._config = this._getConfig(t), this._indicatorsElement = Ot.findOne(".carousel-indicators", this._element), this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0, this._pointerEvent = Boolean(window.PointerEvent), this._addEventListeners()
                }
                static get Default() {
                    return Ct
                }
                static get NAME() {
                    return St
                }
                next() {
                    this._slide(Mt)
                }
                nextWhenVisible() {
                    !document.hidden && ze(this._element) && this.next()
                }
                prev() {
                    this._slide(Tt)
                }
                pause(e) {
                    e || (this._isPaused = !0), Ot.findOne(".carousel-item-next, .carousel-item-prev", this._element) && (Re(this._element), this.cycle(!0)), clearInterval(this._interval), this._interval = null
                }
                cycle(e) {
                    e || (this._isPaused = !1), this._interval && (clearInterval(this._interval), this._interval = null), this._config && this._config.interval && !this._isPaused && (this._updateInterval(), this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval))
                }
                to(e) {
                    this._activeElement = Ot.findOne(It, this._element);
                    const t = this._getItemIndex(this._activeElement);
                    if (e > this._items.length - 1 || e < 0) return;
                    if (this._isSliding) return void pt.one(this._element, Nt, (() => this.to(e)));
                    if (t === e) return this.pause(), void this.cycle();
                    const n = e > t ? Mt : Tt;
                    this._slide(n, this._items[e])
                }
                _getConfig(e) {
                    return e = {
                        ...Ct,
                        ...kt.getDataAttributes(this._element),
                        ..."object" == typeof e ? e : {}
                    }, qe(St, e, At), e
                }
                _handleSwipe() {
                    const e = Math.abs(this.touchDeltaX);
                    if (e <= 40) return;
                    const t = e / this.touchDeltaX;
                    this.touchDeltaX = 0, t && this._slide(t > 0 ? Dt : Pt)
                }
                _addEventListeners() {
                    this._config.keyboard && pt.on(this._element, "keydown.bs.carousel", (e => this._keydown(e))), "hover" === this._config.pause && (pt.on(this._element, "mouseenter.bs.carousel", (e => this.pause(e))), pt.on(this._element, "mouseleave.bs.carousel", (e => this.cycle(e)))), this._config.touch && this._touchSupported && this._addTouchEventListeners()
                }
                _addTouchEventListeners() {
                    const e = e => this._pointerEvent && ("pen" === e.pointerType || "touch" === e.pointerType),
                        t = t => {
                            e(t) ? this.touchStartX = t.clientX : this._pointerEvent || (this.touchStartX = t.touches[0].clientX)
                        },
                        n = e => {
                            this.touchDeltaX = e.touches && e.touches.length > 1 ? 0 : e.touches[0].clientX - this.touchStartX
                        },
                        i = t => {
                            e(t) && (this.touchDeltaX = t.clientX - this.touchStartX), this._handleSwipe(), "hover" === this._config.pause && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout((e => this.cycle(e)), 500 + this._config.interval))
                        };
                    Ot.find(".carousel-item img", this._element).forEach((e => {
                        pt.on(e, "dragstart.bs.carousel", (e => e.preventDefault()))
                    })), this._pointerEvent ? (pt.on(this._element, "pointerdown.bs.carousel", (e => t(e))), pt.on(this._element, "pointerup.bs.carousel", (e => i(e))), this._element.classList.add("pointer-event")) : (pt.on(this._element, "touchstart.bs.carousel", (e => t(e))), pt.on(this._element, "touchmove.bs.carousel", (e => n(e))), pt.on(this._element, "touchend.bs.carousel", (e => i(e))))
                }
                _keydown(e) {
                    if (/input|textarea/i.test(e.target.tagName)) return;
                    const t = Lt[e.key];
                    t && (e.preventDefault(), this._slide(t))
                }
                _getItemIndex(e) {
                    return this._items = e && e.parentNode ? Ot.find(".carousel-item", e.parentNode) : [], this._items.indexOf(e)
                }
                _getItemByOrder(e, t) {
                    const n = e === Mt;
                    return Qe(this._items, t, n, this._config.wrap)
                }
                _triggerSlideEvent(e, t) {
                    const n = this._getItemIndex(e),
                        i = this._getItemIndex(Ot.findOne(It, this._element));
                    return pt.trigger(this._element, "slide.bs.carousel", {
                        relatedTarget: e,
                        direction: t,
                        from: i,
                        to: n
                    })
                }
                _setActiveIndicatorElement(e) {
                    if (this._indicatorsElement) {
                        const t = Ot.findOne(".active", this._indicatorsElement);
                        t.classList.remove(jt), t.removeAttribute("aria-current");
                        const n = Ot.find("[data-bs-target]", this._indicatorsElement);
                        for (let t = 0; t < n.length; t++)
                            if (Number.parseInt(n[t].getAttribute("data-bs-slide-to"), 10) === this._getItemIndex(e)) {
                                n[t].classList.add(jt), n[t].setAttribute("aria-current", "true");
                                break
                            }
                    }
                }
                _updateInterval() {
                    const e = this._activeElement || Ot.findOne(It, this._element);
                    if (!e) return;
                    const t = Number.parseInt(e.getAttribute("data-bs-interval"), 10);
                    t ? (this._config.defaultInterval = this._config.defaultInterval || this._config.interval, this._config.interval = t) : this._config.interval = this._config.defaultInterval || this._config.interval
                }
                _slide(e, t) {
                    const n = this._directionToOrder(e),
                        i = Ot.findOne(It, this._element),
                        r = this._getItemIndex(i),
                        o = t || this._getItemByOrder(n, i),
                        a = this._getItemIndex(o),
                        s = Boolean(this._interval),
                        l = n === Mt,
                        c = l ? "carousel-item-start" : "carousel-item-end",
                        u = l ? "carousel-item-next" : "carousel-item-prev",
                        d = this._orderToDirection(n);
                    if (o && o.classList.contains(jt)) return void(this._isSliding = !1);
                    if (this._isSliding) return;
                    if (this._triggerSlideEvent(o, d).defaultPrevented) return;
                    if (!i || !o) return;
                    this._isSliding = !0, s && this.pause(), this._setActiveIndicatorElement(o), this._activeElement = o;
                    const h = () => {
                        pt.trigger(this._element, Nt, {
                            relatedTarget: o,
                            direction: d,
                            from: r,
                            to: a
                        })
                    };
                    if (this._element.classList.contains("slide")) {
                        o.classList.add(u), We(o), i.classList.add(c), o.classList.add(c);
                        const e = () => {
                            o.classList.remove(c, u), o.classList.add(jt), i.classList.remove(jt, u, c), this._isSliding = !1, setTimeout(h, 0)
                        };
                        this._queueCallback(e, i, !0)
                    } else i.classList.remove(jt), o.classList.add(jt), this._isSliding = !1, h();
                    s && this.cycle()
                }
                _directionToOrder(e) {
                    return [Dt, Pt].includes(e) ? Ke() ? e === Pt ? Tt : Mt : e === Pt ? Mt : Tt : e
                }
                _orderToDirection(e) {
                    return [Mt, Tt].includes(e) ? Ke() ? e === Tt ? Pt : Dt : e === Tt ? Dt : Pt : e
                }
                static carouselInterface(e, t) {
                    const n = Rt.getOrCreateInstance(e, t);
                    let {
                        _config: i
                    } = n;
                    "object" == typeof t && (i = {
                        ...i,
                        ...t
                    });
                    const r = "string" == typeof t ? t : i.slide;
                    if ("number" == typeof t) n.to(t);
                    else if ("string" == typeof r) {
                        if (void 0 === n[r]) throw new TypeError(`No method named "${r}"`);
                        n[r]()
                    } else i.interval && i.ride && (n.pause(), n.cycle())
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        Rt.carouselInterface(this, e)
                    }))
                }
                static dataApiClickHandler(e) {
                    const t = Ie(this);
                    if (!t || !t.classList.contains("carousel")) return;
                    const n = {
                            ...kt.getDataAttributes(t),
                            ...kt.getDataAttributes(this)
                        },
                        i = this.getAttribute("data-bs-slide-to");
                    i && (n.interval = !1), Rt.carouselInterface(t, n), i && Rt.getInstance(t).to(i), e.preventDefault()
                }
            }
            pt.on(document, "click.bs.carousel.data-api", "[data-bs-slide], [data-bs-slide-to]", Rt.dataApiClickHandler), pt.on(window, "load.bs.carousel.data-api", (() => {
                const e = Ot.find('[data-bs-ride="carousel"]');
                for (let t = 0, n = e.length; t < n; t++) Rt.carouselInterface(e[t], Rt.getInstance(e[t]))
            })), Ge(Rt);
            const Ft = "collapse",
                Bt = "bs.collapse",
                qt = {
                    toggle: !0,
                    parent: null
                },
                zt = {
                    toggle: "boolean",
                    parent: "(null|element)"
                },
                Ht = "show",
                Ut = "collapse",
                Vt = "collapsing",
                Wt = "collapsed",
                Yt = ":scope .collapse .collapse",
                $t = '[data-bs-toggle="collapse"]';
            class Kt extends vt {
                constructor(e, t) {
                    super(e), this._isTransitioning = !1, this._config = this._getConfig(t), this._triggerArray = [];
                    const n = Ot.find($t);
                    for (let e = 0, t = n.length; e < t; e++) {
                        const t = n[e],
                            i = je(t),
                            r = Ot.find(i).filter((e => e === this._element));
                        null !== i && r.length && (this._selector = i, this._triggerArray.push(t))
                    }
                    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle()
                }
                static get Default() {
                    return qt
                }
                static get NAME() {
                    return Ft
                }
                toggle() {
                    this._isShown() ? this.hide() : this.show()
                }
                show() {
                    if (this._isTransitioning || this._isShown()) return;
                    let e, t = [];
                    if (this._config.parent) {
                        const e = Ot.find(Yt, this._config.parent);
                        t = Ot.find(".collapse.show, .collapse.collapsing", this._config.parent).filter((t => !e.includes(t)))
                    }
                    const n = Ot.findOne(this._selector);
                    if (t.length) {
                        const i = t.find((e => n !== e));
                        if (e = i ? Kt.getInstance(i) : null, e && e._isTransitioning) return
                    }
                    if (pt.trigger(this._element, "show.bs.collapse").defaultPrevented) return;
                    t.forEach((t => {
                        n !== t && Kt.getOrCreateInstance(t, {
                            toggle: !1
                        }).hide(), e || mt.set(t, Bt, null)
                    }));
                    const i = this._getDimension();
                    this._element.classList.remove(Ut), this._element.classList.add(Vt), this._element.style[i] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
                    const r = `scroll${i[0].toUpperCase()+i.slice(1)}`;
                    this._queueCallback((() => {
                        this._isTransitioning = !1, this._element.classList.remove(Vt), this._element.classList.add(Ut, Ht), this._element.style[i] = "", pt.trigger(this._element, "shown.bs.collapse")
                    }), this._element, !0), this._element.style[i] = `${this._element[r]}px`
                }
                hide() {
                    if (this._isTransitioning || !this._isShown()) return;
                    if (pt.trigger(this._element, "hide.bs.collapse").defaultPrevented) return;
                    const e = this._getDimension();
                    this._element.style[e] = `${this._element.getBoundingClientRect()[e]}px`, We(this._element), this._element.classList.add(Vt), this._element.classList.remove(Ut, Ht);
                    const t = this._triggerArray.length;
                    for (let e = 0; e < t; e++) {
                        const t = this._triggerArray[e],
                            n = Ie(t);
                        n && !this._isShown(n) && this._addAriaAndCollapsedClass([t], !1)
                    }
                    this._isTransitioning = !0;
                    this._element.style[e] = "", this._queueCallback((() => {
                        this._isTransitioning = !1, this._element.classList.remove(Vt), this._element.classList.add(Ut), pt.trigger(this._element, "hidden.bs.collapse")
                    }), this._element, !0)
                }
                _isShown(e = this._element) {
                    return e.classList.contains(Ht)
                }
                _getConfig(e) {
                    return (e = {
                        ...qt,
                        ...kt.getDataAttributes(this._element),
                        ...e
                    }).toggle = Boolean(e.toggle), e.parent = Be(e.parent), qe(Ft, e, zt), e
                }
                _getDimension() {
                    return this._element.classList.contains("collapse-horizontal") ? "width" : "height"
                }
                _initializeChildren() {
                    if (!this._config.parent) return;
                    const e = Ot.find(Yt, this._config.parent);
                    Ot.find($t, this._config.parent).filter((t => !e.includes(t))).forEach((e => {
                        const t = Ie(e);
                        t && this._addAriaAndCollapsedClass([e], this._isShown(t))
                    }))
                }
                _addAriaAndCollapsedClass(e, t) {
                    e.length && e.forEach((e => {
                        t ? e.classList.remove(Wt) : e.classList.add(Wt), e.setAttribute("aria-expanded", t)
                    }))
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = {};
                        "string" == typeof e && /show|hide/.test(e) && (t.toggle = !1);
                        const n = Kt.getOrCreateInstance(this, t);
                        if ("string" == typeof e) {
                            if (void 0 === n[e]) throw new TypeError(`No method named "${e}"`);
                            n[e]()
                        }
                    }))
                }
            }
            pt.on(document, "click.bs.collapse.data-api", $t, (function (e) {
                ("A" === e.target.tagName || e.delegateTarget && "A" === e.delegateTarget.tagName) && e.preventDefault();
                const t = je(this);
                Ot.find(t).forEach((e => {
                    Kt.getOrCreateInstance(e, {
                        toggle: !1
                    }).toggle()
                }))
            })), Ge(Kt);
            const Gt = "dropdown",
                Xt = "Escape",
                Zt = "Space",
                Qt = "ArrowUp",
                Jt = "ArrowDown",
                en = new RegExp("ArrowUp|ArrowDown|Escape"),
                tn = "click.bs.dropdown.data-api",
                nn = "keydown.bs.dropdown.data-api",
                rn = "show",
                on = '[data-bs-toggle="dropdown"]',
                an = ".dropdown-menu",
                sn = Ke() ? "top-end" : "top-start",
                ln = Ke() ? "top-start" : "top-end",
                cn = Ke() ? "bottom-end" : "bottom-start",
                un = Ke() ? "bottom-start" : "bottom-end",
                dn = Ke() ? "left-start" : "right-start",
                hn = Ke() ? "right-start" : "left-start",
                fn = {
                    offset: [0, 2],
                    boundary: "clippingParents",
                    reference: "toggle",
                    display: "dynamic",
                    popperConfig: null,
                    autoClose: !0
                },
                pn = {
                    offset: "(array|string|function)",
                    boundary: "(string|element)",
                    reference: "(string|element|object)",
                    display: "string",
                    popperConfig: "(null|object|function)",
                    autoClose: "(boolean|string)"
                };
            class gn extends vt {
                constructor(e, t) {
                    super(e), this._popper = null, this._config = this._getConfig(t), this._menu = this._getMenuElement(), this._inNavbar = this._detectNavbar()
                }
                static get Default() {
                    return fn
                }
                static get DefaultType() {
                    return pn
                }
                static get NAME() {
                    return Gt
                }
                toggle() {
                    return this._isShown() ? this.hide() : this.show()
                }
                show() {
                    if (He(this._element) || this._isShown(this._menu)) return;
                    const e = {
                        relatedTarget: this._element
                    };
                    if (pt.trigger(this._element, "show.bs.dropdown", e).defaultPrevented) return;
                    const t = gn.getParentFromElement(this._element);
                    this._inNavbar ? kt.setDataAttribute(this._menu, "popper", "none") : this._createPopper(t), "ontouchstart" in document.documentElement && !t.closest(".navbar-nav") && [].concat(...document.body.children).forEach((e => pt.on(e, "mouseover", Ve))), this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(rn), this._element.classList.add(rn), pt.trigger(this._element, "shown.bs.dropdown", e)
                }
                hide() {
                    if (He(this._element) || !this._isShown(this._menu)) return;
                    const e = {
                        relatedTarget: this._element
                    };
                    this._completeHide(e)
                }
                dispose() {
                    this._popper && this._popper.destroy(), super.dispose()
                }
                update() {
                    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update()
                }
                _completeHide(e) {
                    pt.trigger(this._element, "hide.bs.dropdown", e).defaultPrevented || ("ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((e => pt.off(e, "mouseover", Ve))), this._popper && this._popper.destroy(), this._menu.classList.remove(rn), this._element.classList.remove(rn), this._element.setAttribute("aria-expanded", "false"), kt.removeDataAttribute(this._menu, "popper"), pt.trigger(this._element, "hidden.bs.dropdown", e))
                }
                _getConfig(e) {
                    if (e = {
                            ...this.constructor.Default,
                            ...kt.getDataAttributes(this._element),
                            ...e
                        }, qe(Gt, e, this.constructor.DefaultType), "object" == typeof e.reference && !Fe(e.reference) && "function" != typeof e.reference.getBoundingClientRect) throw new TypeError(`${Gt.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
                    return e
                }
                _createPopper(e) {
                    if (void 0 === i) throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                    let t = this._element;
                    "parent" === this._config.reference ? t = e : Fe(this._config.reference) ? t = Be(this._config.reference) : "object" == typeof this._config.reference && (t = this._config.reference);
                    const n = this._getPopperConfig(),
                        r = n.modifiers.find((e => "applyStyles" === e.name && !1 === e.enabled));
                    this._popper = Pe(t, this._menu, n), r && kt.setDataAttribute(this._menu, "popper", "static")
                }
                _isShown(e = this._element) {
                    return e.classList.contains(rn)
                }
                _getMenuElement() {
                    return Ot.next(this._element, an)[0]
                }
                _getPlacement() {
                    const e = this._element.parentNode;
                    if (e.classList.contains("dropend")) return dn;
                    if (e.classList.contains("dropstart")) return hn;
                    const t = "end" === getComputedStyle(this._menu).getPropertyValue("--bs-position").trim();
                    return e.classList.contains("dropup") ? t ? ln : sn : t ? un : cn
                }
                _detectNavbar() {
                    return null !== this._element.closest(".navbar")
                }
                _getOffset() {
                    const {
                        offset: e
                    } = this._config;
                    return "string" == typeof e ? e.split(",").map((e => Number.parseInt(e, 10))) : "function" == typeof e ? t => e(t, this._element) : e
                }
                _getPopperConfig() {
                    const e = {
                        placement: this._getPlacement(),
                        modifiers: [{
                            name: "preventOverflow",
                            options: {
                                boundary: this._config.boundary
                            }
                        }, {
                            name: "offset",
                            options: {
                                offset: this._getOffset()
                            }
                        }]
                    };
                    return "static" === this._config.display && (e.modifiers = [{
                        name: "applyStyles",
                        enabled: !1
                    }]), {
                        ...e,
                        ..."function" == typeof this._config.popperConfig ? this._config.popperConfig(e) : this._config.popperConfig
                    }
                }
                _selectMenuItem({
                    key: e,
                    target: t
                }) {
                    const n = Ot.find(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", this._menu).filter(ze);
                    n.length && Qe(n, t, e === Jt, !n.includes(t)).focus()
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = gn.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e]()
                        }
                    }))
                }
                static clearMenus(e) {
                    if (e && (2 === e.button || "keyup" === e.type && "Tab" !== e.key)) return;
                    const t = Ot.find(on);
                    for (let n = 0, i = t.length; n < i; n++) {
                        const i = gn.getInstance(t[n]);
                        if (!i || !1 === i._config.autoClose) continue;
                        if (!i._isShown()) continue;
                        const r = {
                            relatedTarget: i._element
                        };
                        if (e) {
                            const t = e.composedPath(),
                                n = t.includes(i._menu);
                            if (t.includes(i._element) || "inside" === i._config.autoClose && !n || "outside" === i._config.autoClose && n) continue;
                            if (i._menu.contains(e.target) && ("keyup" === e.type && "Tab" === e.key || /input|select|option|textarea|form/i.test(e.target.tagName))) continue;
                            "click" === e.type && (r.clickEvent = e)
                        }
                        i._completeHide(r)
                    }
                }
                static getParentFromElement(e) {
                    return Ie(e) || e.parentNode
                }
                static dataApiKeydownHandler(e) {
                    if (/input|textarea/i.test(e.target.tagName) ? e.key === Zt || e.key !== Xt && (e.key !== Jt && e.key !== Qt || e.target.closest(an)) : !en.test(e.key)) return;
                    const t = this.classList.contains(rn);
                    if (!t && e.key === Xt) return;
                    if (e.preventDefault(), e.stopPropagation(), He(this)) return;
                    const n = this.matches(on) ? this : Ot.prev(this, on)[0],
                        i = gn.getOrCreateInstance(n);
                    if (e.key !== Xt) return e.key === Qt || e.key === Jt ? (t || i.show(), void i._selectMenuItem(e)) : void(t && e.key !== Zt || gn.clearMenus());
                    i.hide()
                }
            }
            pt.on(document, nn, on, gn.dataApiKeydownHandler), pt.on(document, nn, an, gn.dataApiKeydownHandler), pt.on(document, tn, gn.clearMenus), pt.on(document, "keyup.bs.dropdown.data-api", gn.clearMenus), pt.on(document, tn, on, (function (e) {
                e.preventDefault(), gn.getOrCreateInstance(this).toggle()
            })), Ge(gn);
            const mn = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
                vn = ".sticky-top";
            class bn {
                constructor() {
                    this._element = document.body
                }
                getWidth() {
                    const e = document.documentElement.clientWidth;
                    return Math.abs(window.innerWidth - e)
                }
                hide() {
                    const e = this.getWidth();
                    this._disableOverFlow(), this._setElementAttributes(this._element, "paddingRight", (t => t + e)), this._setElementAttributes(mn, "paddingRight", (t => t + e)), this._setElementAttributes(vn, "marginRight", (t => t - e))
                }
                _disableOverFlow() {
                    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden"
                }
                _setElementAttributes(e, t, n) {
                    const i = this.getWidth();
                    this._applyManipulationCallback(e, (e => {
                        if (e !== this._element && window.innerWidth > e.clientWidth + i) return;
                        this._saveInitialAttribute(e, t);
                        const r = window.getComputedStyle(e)[t];
                        e.style[t] = `${n(Number.parseFloat(r))}px`
                    }))
                }
                reset() {
                    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, "paddingRight"), this._resetElementAttributes(mn, "paddingRight"), this._resetElementAttributes(vn, "marginRight")
                }
                _saveInitialAttribute(e, t) {
                    const n = e.style[t];
                    n && kt.setDataAttribute(e, t, n)
                }
                _resetElementAttributes(e, t) {
                    this._applyManipulationCallback(e, (e => {
                        const n = kt.getDataAttribute(e, t);
                        void 0 === n ? e.style.removeProperty(t) : (kt.removeDataAttribute(e, t), e.style[t] = n)
                    }))
                }
                _applyManipulationCallback(e, t) {
                    Fe(e) ? t(e) : Ot.find(e, this._element).forEach(t)
                }
                isOverflowing() {
                    return this.getWidth() > 0
                }
            }
            const yn = {
                    className: "modal-backdrop",
                    isVisible: !0,
                    isAnimated: !1,
                    rootElement: "body",
                    clickCallback: null
                },
                _n = {
                    className: "string",
                    isVisible: "boolean",
                    isAnimated: "boolean",
                    rootElement: "(element|string)",
                    clickCallback: "(function|null)"
                },
                xn = "backdrop",
                wn = "show",
                En = "mousedown.bs.backdrop";
            class kn {
                constructor(e) {
                    this._config = this._getConfig(e), this._isAppended = !1, this._element = null
                }
                show(e) {
                    this._config.isVisible ? (this._append(), this._config.isAnimated && We(this._getElement()), this._getElement().classList.add(wn), this._emulateAnimation((() => {
                        Xe(e)
                    }))) : Xe(e)
                }
                hide(e) {
                    this._config.isVisible ? (this._getElement().classList.remove(wn), this._emulateAnimation((() => {
                        this.dispose(), Xe(e)
                    }))) : Xe(e)
                }
                _getElement() {
                    if (!this._element) {
                        const e = document.createElement("div");
                        e.className = this._config.className, this._config.isAnimated && e.classList.add("fade"), this._element = e
                    }
                    return this._element
                }
                _getConfig(e) {
                    return (e = {
                        ...yn,
                        ..."object" == typeof e ? e : {}
                    }).rootElement = Be(e.rootElement), qe(xn, e, _n), e
                }
                _append() {
                    this._isAppended || (this._config.rootElement.append(this._getElement()), pt.on(this._getElement(), En, (() => {
                        Xe(this._config.clickCallback)
                    })), this._isAppended = !0)
                }
                dispose() {
                    this._isAppended && (pt.off(this._element, En), this._element.remove(), this._isAppended = !1)
                }
                _emulateAnimation(e) {
                    Ze(e, this._getElement(), this._config.isAnimated)
                }
            }
            const On = {
                    trapElement: null,
                    autofocus: !0
                },
                Sn = {
                    trapElement: "element",
                    autofocus: "boolean"
                },
                Cn = ".bs.focustrap",
                An = "backward";
            class Mn {
                constructor(e) {
                    this._config = this._getConfig(e), this._isActive = !1, this._lastTabNavDirection = null
                }
                activate() {
                    const {
                        trapElement: e,
                        autofocus: t
                    } = this._config;
                    this._isActive || (t && e.focus(), pt.off(document, Cn), pt.on(document, "focusin.bs.focustrap", (e => this._handleFocusin(e))), pt.on(document, "keydown.tab.bs.focustrap", (e => this._handleKeydown(e))), this._isActive = !0)
                }
                deactivate() {
                    this._isActive && (this._isActive = !1, pt.off(document, Cn))
                }
                _handleFocusin(e) {
                    const {
                        target: t
                    } = e, {
                        trapElement: n
                    } = this._config;
                    if (t === document || t === n || n.contains(t)) return;
                    const i = Ot.focusableChildren(n);
                    0 === i.length ? n.focus() : this._lastTabNavDirection === An ? i[i.length - 1].focus() : i[0].focus()
                }
                _handleKeydown(e) {
                    "Tab" === e.key && (this._lastTabNavDirection = e.shiftKey ? An : "forward")
                }
                _getConfig(e) {
                    return e = {
                        ...On,
                        ..."object" == typeof e ? e : {}
                    }, qe("focustrap", e, Sn), e
                }
            }
            const Tn = "modal",
                Pn = ".bs.modal",
                Dn = "Escape",
                Ln = {
                    backdrop: !0,
                    keyboard: !0,
                    focus: !0
                },
                Nn = {
                    backdrop: "(boolean|string)",
                    keyboard: "boolean",
                    focus: "boolean"
                },
                jn = "hidden.bs.modal",
                In = "show.bs.modal",
                Rn = "resize.bs.modal",
                Fn = "click.dismiss.bs.modal",
                Bn = "keydown.dismiss.bs.modal",
                qn = "mousedown.dismiss.bs.modal",
                zn = "modal-open",
                Hn = "show",
                Un = "modal-static";
            class Vn extends vt {
                constructor(e, t) {
                    super(e), this._config = this._getConfig(t), this._dialog = Ot.findOne(".modal-dialog", this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1, this._scrollBar = new bn
                }
                static get Default() {
                    return Ln
                }
                static get NAME() {
                    return Tn
                }
                toggle(e) {
                    return this._isShown ? this.hide() : this.show(e)
                }
                show(e) {
                    if (this._isShown || this._isTransitioning) return;
                    pt.trigger(this._element, In, {
                        relatedTarget: e
                    }).defaultPrevented || (this._isShown = !0, this._isAnimated() && (this._isTransitioning = !0), this._scrollBar.hide(), document.body.classList.add(zn), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), pt.on(this._dialog, qn, (() => {
                        pt.one(this._element, "mouseup.dismiss.bs.modal", (e => {
                            e.target === this._element && (this._ignoreBackdropClick = !0)
                        }))
                    })), this._showBackdrop((() => this._showElement(e))))
                }
                hide() {
                    if (!this._isShown || this._isTransitioning) return;
                    if (pt.trigger(this._element, "hide.bs.modal").defaultPrevented) return;
                    this._isShown = !1;
                    const e = this._isAnimated();
                    e && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), this._focustrap.deactivate(), this._element.classList.remove(Hn), pt.off(this._element, Fn), pt.off(this._dialog, qn), this._queueCallback((() => this._hideModal()), this._element, e)
                }
                dispose() {
                    [window, this._dialog].forEach((e => pt.off(e, Pn))), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose()
                }
                handleUpdate() {
                    this._adjustDialog()
                }
                _initializeBackDrop() {
                    return new kn({
                        isVisible: Boolean(this._config.backdrop),
                        isAnimated: this._isAnimated()
                    })
                }
                _initializeFocusTrap() {
                    return new Mn({
                        trapElement: this._element
                    })
                }
                _getConfig(e) {
                    return e = {
                        ...Ln,
                        ...kt.getDataAttributes(this._element),
                        ..."object" == typeof e ? e : {}
                    }, qe(Tn, e, Nn), e
                }
                _showElement(e) {
                    const t = this._isAnimated(),
                        n = Ot.findOne(".modal-body", this._dialog);
                    this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0, n && (n.scrollTop = 0), t && We(this._element), this._element.classList.add(Hn);
                    this._queueCallback((() => {
                        this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, pt.trigger(this._element, "shown.bs.modal", {
                            relatedTarget: e
                        })
                    }), this._dialog, t)
                }
                _setEscapeEvent() {
                    this._isShown ? pt.on(this._element, Bn, (e => {
                        this._config.keyboard && e.key === Dn ? (e.preventDefault(), this.hide()) : this._config.keyboard || e.key !== Dn || this._triggerBackdropTransition()
                    })) : pt.off(this._element, Bn)
                }
                _setResizeEvent() {
                    this._isShown ? pt.on(window, Rn, (() => this._adjustDialog())) : pt.off(window, Rn)
                }
                _hideModal() {
                    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide((() => {
                        document.body.classList.remove(zn), this._resetAdjustments(), this._scrollBar.reset(), pt.trigger(this._element, jn)
                    }))
                }
                _showBackdrop(e) {
                    pt.on(this._element, Fn, (e => {
                        this._ignoreBackdropClick ? this._ignoreBackdropClick = !1 : e.target === e.currentTarget && (!0 === this._config.backdrop ? this.hide() : "static" === this._config.backdrop && this._triggerBackdropTransition())
                    })), this._backdrop.show(e)
                }
                _isAnimated() {
                    return this._element.classList.contains("fade")
                }
                _triggerBackdropTransition() {
                    if (pt.trigger(this._element, "hidePrevented.bs.modal").defaultPrevented) return;
                    const {
                        classList: e,
                        scrollHeight: t,
                        style: n
                    } = this._element, i = t > document.documentElement.clientHeight;
                    !i && "hidden" === n.overflowY || e.contains(Un) || (i || (n.overflowY = "hidden"), e.add(Un), this._queueCallback((() => {
                        e.remove(Un), i || this._queueCallback((() => {
                            n.overflowY = ""
                        }), this._dialog)
                    }), this._dialog), this._element.focus())
                }
                _adjustDialog() {
                    const e = this._element.scrollHeight > document.documentElement.clientHeight,
                        t = this._scrollBar.getWidth(),
                        n = t > 0;
                    (!n && e && !Ke() || n && !e && Ke()) && (this._element.style.paddingLeft = `${t}px`), (n && !e && !Ke() || !n && e && Ke()) && (this._element.style.paddingRight = `${t}px`)
                }
                _resetAdjustments() {
                    this._element.style.paddingLeft = "", this._element.style.paddingRight = ""
                }
                static jQueryInterface(e, t) {
                    return this.each((function () {
                        const n = Vn.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === n[e]) throw new TypeError(`No method named "${e}"`);
                            n[e](t)
                        }
                    }))
                }
            }
            pt.on(document, "click.bs.modal.data-api", '[data-bs-toggle="modal"]', (function (e) {
                const t = Ie(this);
                ["A", "AREA"].includes(this.tagName) && e.preventDefault(), pt.one(t, In, (e => {
                    e.defaultPrevented || pt.one(t, jn, (() => {
                        ze(this) && this.focus()
                    }))
                }));
                const n = Ot.findOne(".modal.show");
                n && Vn.getInstance(n).hide();
                Vn.getOrCreateInstance(t).toggle(this)
            })), bt(Vn), Ge(Vn);
            const Wn = "offcanvas",
                Yn = {
                    backdrop: !0,
                    keyboard: !0,
                    scroll: !1
                },
                $n = {
                    backdrop: "boolean",
                    keyboard: "boolean",
                    scroll: "boolean"
                },
                Kn = "show",
                Gn = ".offcanvas.show",
                Xn = "hidden.bs.offcanvas";
            class Zn extends vt {
                constructor(e, t) {
                    super(e), this._config = this._getConfig(t), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners()
                }
                static get NAME() {
                    return Wn
                }
                static get Default() {
                    return Yn
                }
                toggle(e) {
                    return this._isShown ? this.hide() : this.show(e)
                }
                show(e) {
                    if (this._isShown) return;
                    if (pt.trigger(this._element, "show.bs.offcanvas", {
                            relatedTarget: e
                        }).defaultPrevented) return;
                    this._isShown = !0, this._element.style.visibility = "visible", this._backdrop.show(), this._config.scroll || (new bn).hide(), this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(Kn);
                    this._queueCallback((() => {
                        this._config.scroll || this._focustrap.activate(), pt.trigger(this._element, "shown.bs.offcanvas", {
                            relatedTarget: e
                        })
                    }), this._element, !0)
                }
                hide() {
                    if (!this._isShown) return;
                    if (pt.trigger(this._element, "hide.bs.offcanvas").defaultPrevented) return;
                    this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.remove(Kn), this._backdrop.hide();
                    this._queueCallback((() => {
                        this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._element.style.visibility = "hidden", this._config.scroll || (new bn).reset(), pt.trigger(this._element, Xn)
                    }), this._element, !0)
                }
                dispose() {
                    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose()
                }
                _getConfig(e) {
                    return e = {
                        ...Yn,
                        ...kt.getDataAttributes(this._element),
                        ..."object" == typeof e ? e : {}
                    }, qe(Wn, e, $n), e
                }
                _initializeBackDrop() {
                    return new kn({
                        className: "offcanvas-backdrop",
                        isVisible: this._config.backdrop,
                        isAnimated: !0,
                        rootElement: this._element.parentNode,
                        clickCallback: () => this.hide()
                    })
                }
                _initializeFocusTrap() {
                    return new Mn({
                        trapElement: this._element
                    })
                }
                _addEventListeners() {
                    pt.on(this._element, "keydown.dismiss.bs.offcanvas", (e => {
                        this._config.keyboard && "Escape" === e.key && this.hide()
                    }))
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = Zn.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e] || e.startsWith("_") || "constructor" === e) throw new TypeError(`No method named "${e}"`);
                            t[e](this)
                        }
                    }))
                }
            }
            pt.on(document, "click.bs.offcanvas.data-api", '[data-bs-toggle="offcanvas"]', (function (e) {
                const t = Ie(this);
                if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), He(this)) return;
                pt.one(t, Xn, (() => {
                    ze(this) && this.focus()
                }));
                const n = Ot.findOne(Gn);
                n && n !== t && Zn.getInstance(n).hide();
                Zn.getOrCreateInstance(t).toggle(this)
            })), pt.on(window, "load.bs.offcanvas.data-api", (() => Ot.find(Gn).forEach((e => Zn.getOrCreateInstance(e).show())))), bt(Zn), Ge(Zn);
            const Qn = new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]),
                Jn = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,
                ei = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,
                ti = (e, t) => {
                    const n = e.nodeName.toLowerCase();
                    if (t.includes(n)) return !Qn.has(n) || Boolean(Jn.test(e.nodeValue) || ei.test(e.nodeValue));
                    const i = t.filter((e => e instanceof RegExp));
                    for (let e = 0, t = i.length; e < t; e++)
                        if (i[e].test(n)) return !0;
                    return !1
                },
                ni = {
                    "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
                    a: ["target", "href", "title", "rel"],
                    area: [],
                    b: [],
                    br: [],
                    col: [],
                    code: [],
                    div: [],
                    em: [],
                    hr: [],
                    h1: [],
                    h2: [],
                    h3: [],
                    h4: [],
                    h5: [],
                    h6: [],
                    i: [],
                    img: ["src", "srcset", "alt", "title", "width", "height"],
                    li: [],
                    ol: [],
                    p: [],
                    pre: [],
                    s: [],
                    small: [],
                    span: [],
                    sub: [],
                    sup: [],
                    strong: [],
                    u: [],
                    ul: []
                };

            function ii(e, t, n) {
                if (!e.length) return e;
                if (n && "function" == typeof n) return n(e);
                const i = (new window.DOMParser).parseFromString(e, "text/html"),
                    r = [].concat(...i.body.querySelectorAll("*"));
                for (let e = 0, n = r.length; e < n; e++) {
                    const n = r[e],
                        i = n.nodeName.toLowerCase();
                    if (!Object.keys(t).includes(i)) {
                        n.remove();
                        continue
                    }
                    const o = [].concat(...n.attributes),
                        a = [].concat(t["*"] || [], t[i] || []);
                    o.forEach((e => {
                        ti(e, a) || n.removeAttribute(e.nodeName)
                    }))
                }
                return i.body.innerHTML
            }
            const ri = "tooltip",
                oi = new Set(["sanitize", "allowList", "sanitizeFn"]),
                ai = {
                    animation: "boolean",
                    template: "string",
                    title: "(string|element|function)",
                    trigger: "string",
                    delay: "(number|object)",
                    html: "boolean",
                    selector: "(string|boolean)",
                    placement: "(string|function)",
                    offset: "(array|string|function)",
                    container: "(string|element|boolean)",
                    fallbackPlacements: "array",
                    boundary: "(string|element)",
                    customClass: "(string|function)",
                    sanitize: "boolean",
                    sanitizeFn: "(null|function)",
                    allowList: "object",
                    popperConfig: "(null|object|function)"
                },
                si = {
                    AUTO: "auto",
                    TOP: "top",
                    RIGHT: Ke() ? "left" : "right",
                    BOTTOM: "bottom",
                    LEFT: Ke() ? "right" : "left"
                },
                li = {
                    animation: !0,
                    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
                    trigger: "hover focus",
                    title: "",
                    delay: 0,
                    html: !1,
                    selector: !1,
                    placement: "top",
                    offset: [0, 0],
                    container: !1,
                    fallbackPlacements: ["top", "right", "bottom", "left"],
                    boundary: "clippingParents",
                    customClass: "",
                    sanitize: !0,
                    sanitizeFn: null,
                    allowList: ni,
                    popperConfig: null
                },
                ci = {
                    HIDE: "hide.bs.tooltip",
                    HIDDEN: "hidden.bs.tooltip",
                    SHOW: "show.bs.tooltip",
                    SHOWN: "shown.bs.tooltip",
                    INSERTED: "inserted.bs.tooltip",
                    CLICK: "click.bs.tooltip",
                    FOCUSIN: "focusin.bs.tooltip",
                    FOCUSOUT: "focusout.bs.tooltip",
                    MOUSEENTER: "mouseenter.bs.tooltip",
                    MOUSELEAVE: "mouseleave.bs.tooltip"
                },
                ui = "fade",
                di = "show",
                hi = "show",
                fi = "out",
                pi = ".tooltip-inner",
                gi = ".modal",
                mi = "hide.bs.modal",
                vi = "hover",
                bi = "focus";
            class yi extends vt {
                constructor(e, t) {
                    if (void 0 === i) throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
                    super(e), this._isEnabled = !0, this._timeout = 0, this._hoverState = "", this._activeTrigger = {}, this._popper = null, this._config = this._getConfig(t), this.tip = null, this._setListeners()
                }
                static get Default() {
                    return li
                }
                static get NAME() {
                    return ri
                }
                static get Event() {
                    return ci
                }
                static get DefaultType() {
                    return ai
                }
                enable() {
                    this._isEnabled = !0
                }
                disable() {
                    this._isEnabled = !1
                }
                toggleEnabled() {
                    this._isEnabled = !this._isEnabled
                }
                toggle(e) {
                    if (this._isEnabled)
                        if (e) {
                            const t = this._initializeOnDelegatedTarget(e);
                            t._activeTrigger.click = !t._activeTrigger.click, t._isWithActiveTrigger() ? t._enter(null, t) : t._leave(null, t)
                        } else {
                            if (this.getTipElement().classList.contains(di)) return void this._leave(null, this);
                            this._enter(null, this)
                        }
                }
                dispose() {
                    clearTimeout(this._timeout), pt.off(this._element.closest(gi), mi, this._hideModalHandler), this.tip && this.tip.remove(), this._disposePopper(), super.dispose()
                }
                show() {
                    if ("none" === this._element.style.display) throw new Error("Please use show on visible elements");
                    if (!this.isWithContent() || !this._isEnabled) return;
                    const e = pt.trigger(this._element, this.constructor.Event.SHOW),
                        t = Ue(this._element),
                        n = null === t ? this._element.ownerDocument.documentElement.contains(this._element) : t.contains(this._element);
                    if (e.defaultPrevented || !n) return;
                    "tooltip" === this.constructor.NAME && this.tip && this.getTitle() !== this.tip.querySelector(pi).innerHTML && (this._disposePopper(), this.tip.remove(), this.tip = null);
                    const i = this.getTipElement(),
                        r = (e => {
                            do {
                                e += Math.floor(1e6 * Math.random())
                            } while (document.getElementById(e));
                            return e
                        })(this.constructor.NAME);
                    i.setAttribute("id", r), this._element.setAttribute("aria-describedby", r), this._config.animation && i.classList.add(ui);
                    const o = "function" == typeof this._config.placement ? this._config.placement.call(this, i, this._element) : this._config.placement,
                        a = this._getAttachment(o);
                    this._addAttachmentClass(a);
                    const {
                        container: s
                    } = this._config;
                    mt.set(i, this.constructor.DATA_KEY, this), this._element.ownerDocument.documentElement.contains(this.tip) || (s.append(i), pt.trigger(this._element, this.constructor.Event.INSERTED)), this._popper ? this._popper.update() : this._popper = Pe(this._element, i, this._getPopperConfig(a)), i.classList.add(di);
                    const l = this._resolvePossibleFunction(this._config.customClass);
                    l && i.classList.add(...l.split(" ")), "ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((e => {
                        pt.on(e, "mouseover", Ve)
                    }));
                    const c = this.tip.classList.contains(ui);
                    this._queueCallback((() => {
                        const e = this._hoverState;
                        this._hoverState = null, pt.trigger(this._element, this.constructor.Event.SHOWN), e === fi && this._leave(null, this)
                    }), this.tip, c)
                }
                hide() {
                    if (!this._popper) return;
                    const e = this.getTipElement();
                    if (pt.trigger(this._element, this.constructor.Event.HIDE).defaultPrevented) return;
                    e.classList.remove(di), "ontouchstart" in document.documentElement && [].concat(...document.body.children).forEach((e => pt.off(e, "mouseover", Ve))), this._activeTrigger.click = !1, this._activeTrigger.focus = !1, this._activeTrigger.hover = !1;
                    const t = this.tip.classList.contains(ui);
                    this._queueCallback((() => {
                        this._isWithActiveTrigger() || (this._hoverState !== hi && e.remove(), this._cleanTipClass(), this._element.removeAttribute("aria-describedby"), pt.trigger(this._element, this.constructor.Event.HIDDEN), this._disposePopper())
                    }), this.tip, t), this._hoverState = ""
                }
                update() {
                    null !== this._popper && this._popper.update()
                }
                isWithContent() {
                    return Boolean(this.getTitle())
                }
                getTipElement() {
                    if (this.tip) return this.tip;
                    const e = document.createElement("div");
                    e.innerHTML = this._config.template;
                    const t = e.children[0];
                    return this.setContent(t), t.classList.remove(ui, di), this.tip = t, this.tip
                }
                setContent(e) {
                    this._sanitizeAndSetContent(e, this.getTitle(), pi)
                }
                _sanitizeAndSetContent(e, t, n) {
                    const i = Ot.findOne(n, e);
                    t || !i ? this.setElementContent(i, t) : i.remove()
                }
                setElementContent(e, t) {
                    if (null !== e) return Fe(t) ? (t = Be(t), void(this._config.html ? t.parentNode !== e && (e.innerHTML = "", e.append(t)) : e.textContent = t.textContent)) : void(this._config.html ? (this._config.sanitize && (t = ii(t, this._config.allowList, this._config.sanitizeFn)), e.innerHTML = t) : e.textContent = t)
                }
                getTitle() {
                    const e = this._element.getAttribute("data-bs-original-title") || this._config.title;
                    return this._resolvePossibleFunction(e)
                }
                updateAttachment(e) {
                    return "right" === e ? "end" : "left" === e ? "start" : e
                }
                _initializeOnDelegatedTarget(e, t) {
                    return t || this.constructor.getOrCreateInstance(e.delegateTarget, this._getDelegateConfig())
                }
                _getOffset() {
                    const {
                        offset: e
                    } = this._config;
                    return "string" == typeof e ? e.split(",").map((e => Number.parseInt(e, 10))) : "function" == typeof e ? t => e(t, this._element) : e
                }
                _resolvePossibleFunction(e) {
                    return "function" == typeof e ? e.call(this._element) : e
                }
                _getPopperConfig(e) {
                    const t = {
                        placement: e,
                        modifiers: [{
                            name: "flip",
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        }, {
                            name: "offset",
                            options: {
                                offset: this._getOffset()
                            }
                        }, {
                            name: "preventOverflow",
                            options: {
                                boundary: this._config.boundary
                            }
                        }, {
                            name: "arrow",
                            options: {
                                element: `.${this.constructor.NAME}-arrow`
                            }
                        }, {
                            name: "onChange",
                            enabled: !0,
                            phase: "afterWrite",
                            fn: e => this._handlePopperPlacementChange(e)
                        }],
                        onFirstUpdate: e => {
                            e.options.placement !== e.placement && this._handlePopperPlacementChange(e)
                        }
                    };
                    return {
                        ...t,
                        ..."function" == typeof this._config.popperConfig ? this._config.popperConfig(t) : this._config.popperConfig
                    }
                }
                _addAttachmentClass(e) {
                    this.getTipElement().classList.add(`${this._getBasicClassPrefix()}-${this.updateAttachment(e)}`)
                }
                _getAttachment(e) {
                    return si[e.toUpperCase()]
                }
                _setListeners() {
                    this._config.trigger.split(" ").forEach((e => {
                        if ("click" === e) pt.on(this._element, this.constructor.Event.CLICK, this._config.selector, (e => this.toggle(e)));
                        else if ("manual" !== e) {
                            const t = e === vi ? this.constructor.Event.MOUSEENTER : this.constructor.Event.FOCUSIN,
                                n = e === vi ? this.constructor.Event.MOUSELEAVE : this.constructor.Event.FOCUSOUT;
                            pt.on(this._element, t, this._config.selector, (e => this._enter(e))), pt.on(this._element, n, this._config.selector, (e => this._leave(e)))
                        }
                    })), this._hideModalHandler = () => {
                        this._element && this.hide()
                    }, pt.on(this._element.closest(gi), mi, this._hideModalHandler), this._config.selector ? this._config = {
                        ...this._config,
                        trigger: "manual",
                        selector: ""
                    } : this._fixTitle()
                }
                _fixTitle() {
                    const e = this._element.getAttribute("title"),
                        t = typeof this._element.getAttribute("data-bs-original-title");
                    (e || "string" !== t) && (this._element.setAttribute("data-bs-original-title", e || ""), !e || this._element.getAttribute("aria-label") || this._element.textContent || this._element.setAttribute("aria-label", e), this._element.setAttribute("title", ""))
                }
                _enter(e, t) {
                    t = this._initializeOnDelegatedTarget(e, t), e && (t._activeTrigger["focusin" === e.type ? bi : vi] = !0), t.getTipElement().classList.contains(di) || t._hoverState === hi ? t._hoverState = hi : (clearTimeout(t._timeout), t._hoverState = hi, t._config.delay && t._config.delay.show ? t._timeout = setTimeout((() => {
                        t._hoverState === hi && t.show()
                    }), t._config.delay.show) : t.show())
                }
                _leave(e, t) {
                    t = this._initializeOnDelegatedTarget(e, t), e && (t._activeTrigger["focusout" === e.type ? bi : vi] = t._element.contains(e.relatedTarget)), t._isWithActiveTrigger() || (clearTimeout(t._timeout), t._hoverState = fi, t._config.delay && t._config.delay.hide ? t._timeout = setTimeout((() => {
                        t._hoverState === fi && t.hide()
                    }), t._config.delay.hide) : t.hide())
                }
                _isWithActiveTrigger() {
                    for (const e in this._activeTrigger)
                        if (this._activeTrigger[e]) return !0;
                    return !1
                }
                _getConfig(e) {
                    const t = kt.getDataAttributes(this._element);
                    return Object.keys(t).forEach((e => {
                        oi.has(e) && delete t[e]
                    })), (e = {
                        ...this.constructor.Default,
                        ...t,
                        ..."object" == typeof e && e ? e : {}
                    }).container = !1 === e.container ? document.body : Be(e.container), "number" == typeof e.delay && (e.delay = {
                        show: e.delay,
                        hide: e.delay
                    }), "number" == typeof e.title && (e.title = e.title.toString()), "number" == typeof e.content && (e.content = e.content.toString()), qe(ri, e, this.constructor.DefaultType), e.sanitize && (e.template = ii(e.template, e.allowList, e.sanitizeFn)), e
                }
                _getDelegateConfig() {
                    const e = {};
                    for (const t in this._config) this.constructor.Default[t] !== this._config[t] && (e[t] = this._config[t]);
                    return e
                }
                _cleanTipClass() {
                    const e = this.getTipElement(),
                        t = new RegExp(`(^|\\s)${this._getBasicClassPrefix()}\\S+`, "g"),
                        n = e.getAttribute("class").match(t);
                    null !== n && n.length > 0 && n.map((e => e.trim())).forEach((t => e.classList.remove(t)))
                }
                _getBasicClassPrefix() {
                    return "bs-tooltip"
                }
                _handlePopperPlacementChange(e) {
                    const {
                        state: t
                    } = e;
                    t && (this.tip = t.elements.popper, this._cleanTipClass(), this._addAttachmentClass(this._getAttachment(t.placement)))
                }
                _disposePopper() {
                    this._popper && (this._popper.destroy(), this._popper = null)
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = yi.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e]()
                        }
                    }))
                }
            }
            Ge(yi);
            const _i = {
                    ...yi.Default,
                    placement: "right",
                    offset: [0, 8],
                    trigger: "click",
                    content: "",
                    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
                },
                xi = {
                    ...yi.DefaultType,
                    content: "(string|element|function)"
                },
                wi = {
                    HIDE: "hide.bs.popover",
                    HIDDEN: "hidden.bs.popover",
                    SHOW: "show.bs.popover",
                    SHOWN: "shown.bs.popover",
                    INSERTED: "inserted.bs.popover",
                    CLICK: "click.bs.popover",
                    FOCUSIN: "focusin.bs.popover",
                    FOCUSOUT: "focusout.bs.popover",
                    MOUSEENTER: "mouseenter.bs.popover",
                    MOUSELEAVE: "mouseleave.bs.popover"
                };
            class Ei extends yi {
                static get Default() {
                    return _i
                }
                static get NAME() {
                    return "popover"
                }
                static get Event() {
                    return wi
                }
                static get DefaultType() {
                    return xi
                }
                isWithContent() {
                    return this.getTitle() || this._getContent()
                }
                setContent(e) {
                    this._sanitizeAndSetContent(e, this.getTitle(), ".popover-header"), this._sanitizeAndSetContent(e, this._getContent(), ".popover-body")
                }
                _getContent() {
                    return this._resolvePossibleFunction(this._config.content)
                }
                _getBasicClassPrefix() {
                    return "bs-popover"
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = Ei.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e]()
                        }
                    }))
                }
            }
            Ge(Ei);
            const ki = "scrollspy",
                Oi = ".bs.scrollspy",
                Si = {
                    offset: 10,
                    method: "auto",
                    target: ""
                },
                Ci = {
                    offset: "number",
                    method: "string",
                    target: "(string|element)"
                },
                Ai = "dropdown-item",
                Mi = "active",
                Ti = ".nav-link",
                Pi = ".nav-link, .list-group-item, .dropdown-item",
                Di = "position";
            class Li extends vt {
                constructor(e, t) {
                    super(e), this._scrollElement = "BODY" === this._element.tagName ? window : this._element, this._config = this._getConfig(t), this._offsets = [], this._targets = [], this._activeTarget = null, this._scrollHeight = 0, pt.on(this._scrollElement, "scroll.bs.scrollspy", (() => this._process())), this.refresh(), this._process()
                }
                static get Default() {
                    return Si
                }
                static get NAME() {
                    return ki
                }
                refresh() {
                    const e = this._scrollElement === this._scrollElement.window ? "offset" : Di,
                        t = "auto" === this._config.method ? e : this._config.method,
                        n = t === Di ? this._getScrollTop() : 0;
                    this._offsets = [], this._targets = [], this._scrollHeight = this._getScrollHeight();
                    Ot.find(Pi, this._config.target).map((e => {
                        const i = je(e),
                            r = i ? Ot.findOne(i) : null;
                        if (r) {
                            const e = r.getBoundingClientRect();
                            if (e.width || e.height) return [kt[t](r).top + n, i]
                        }
                        return null
                    })).filter((e => e)).sort(((e, t) => e[0] - t[0])).forEach((e => {
                        this._offsets.push(e[0]), this._targets.push(e[1])
                    }))
                }
                dispose() {
                    pt.off(this._scrollElement, Oi), super.dispose()
                }
                _getConfig(e) {
                    return (e = {
                        ...Si,
                        ...kt.getDataAttributes(this._element),
                        ..."object" == typeof e && e ? e : {}
                    }).target = Be(e.target) || document.documentElement, qe(ki, e, Ci), e
                }
                _getScrollTop() {
                    return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop
                }
                _getScrollHeight() {
                    return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
                }
                _getOffsetHeight() {
                    return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height
                }
                _process() {
                    const e = this._getScrollTop() + this._config.offset,
                        t = this._getScrollHeight(),
                        n = this._config.offset + t - this._getOffsetHeight();
                    if (this._scrollHeight !== t && this.refresh(), e >= n) {
                        const e = this._targets[this._targets.length - 1];
                        this._activeTarget !== e && this._activate(e)
                    } else {
                        if (this._activeTarget && e < this._offsets[0] && this._offsets[0] > 0) return this._activeTarget = null, void this._clear();
                        for (let t = this._offsets.length; t--;) {
                            this._activeTarget !== this._targets[t] && e >= this._offsets[t] && (void 0 === this._offsets[t + 1] || e < this._offsets[t + 1]) && this._activate(this._targets[t])
                        }
                    }
                }
                _activate(e) {
                    this._activeTarget = e, this._clear();
                    const t = Pi.split(",").map((t => `${t}[data-bs-target="${e}"],${t}[href="${e}"]`)),
                        n = Ot.findOne(t.join(","), this._config.target);
                    n.classList.add(Mi), n.classList.contains(Ai) ? Ot.findOne(".dropdown-toggle", n.closest(".dropdown")).classList.add(Mi) : Ot.parents(n, ".nav, .list-group").forEach((e => {
                        Ot.prev(e, ".nav-link, .list-group-item").forEach((e => e.classList.add(Mi))), Ot.prev(e, ".nav-item").forEach((e => {
                            Ot.children(e, Ti).forEach((e => e.classList.add(Mi)))
                        }))
                    })), pt.trigger(this._scrollElement, "activate.bs.scrollspy", {
                        relatedTarget: e
                    })
                }
                _clear() {
                    Ot.find(Pi, this._config.target).filter((e => e.classList.contains(Mi))).forEach((e => e.classList.remove(Mi)))
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = Li.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e]()
                        }
                    }))
                }
            }
            pt.on(window, "load.bs.scrollspy.data-api", (() => {
                Ot.find('[data-bs-spy="scroll"]').forEach((e => new Li(e)))
            })), Ge(Li);
            const Ni = "active",
                ji = "fade",
                Ii = "show",
                Ri = ".active",
                Fi = ":scope > li > .active";
            class Bi extends vt {
                static get NAME() {
                    return "tab"
                }
                show() {
                    if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(Ni)) return;
                    let e;
                    const t = Ie(this._element),
                        n = this._element.closest(".nav, .list-group");
                    if (n) {
                        const t = "UL" === n.nodeName || "OL" === n.nodeName ? Fi : Ri;
                        e = Ot.find(t, n), e = e[e.length - 1]
                    }
                    const i = e ? pt.trigger(e, "hide.bs.tab", {
                        relatedTarget: this._element
                    }) : null;
                    if (pt.trigger(this._element, "show.bs.tab", {
                            relatedTarget: e
                        }).defaultPrevented || null !== i && i.defaultPrevented) return;
                    this._activate(this._element, n);
                    const r = () => {
                        pt.trigger(e, "hidden.bs.tab", {
                            relatedTarget: this._element
                        }), pt.trigger(this._element, "shown.bs.tab", {
                            relatedTarget: e
                        })
                    };
                    t ? this._activate(t, t.parentNode, r) : r()
                }
                _activate(e, t, n) {
                    const i = (!t || "UL" !== t.nodeName && "OL" !== t.nodeName ? Ot.children(t, Ri) : Ot.find(Fi, t))[0],
                        r = n && i && i.classList.contains(ji),
                        o = () => this._transitionComplete(e, i, n);
                    i && r ? (i.classList.remove(Ii), this._queueCallback(o, e, !0)) : o()
                }
                _transitionComplete(e, t, n) {
                    if (t) {
                        t.classList.remove(Ni);
                        const e = Ot.findOne(":scope > .dropdown-menu .active", t.parentNode);
                        e && e.classList.remove(Ni), "tab" === t.getAttribute("role") && t.setAttribute("aria-selected", !1)
                    }
                    e.classList.add(Ni), "tab" === e.getAttribute("role") && e.setAttribute("aria-selected", !0), We(e), e.classList.contains(ji) && e.classList.add(Ii);
                    let i = e.parentNode;
                    if (i && "LI" === i.nodeName && (i = i.parentNode), i && i.classList.contains("dropdown-menu")) {
                        const t = e.closest(".dropdown");
                        t && Ot.find(".dropdown-toggle", t).forEach((e => e.classList.add(Ni))), e.setAttribute("aria-expanded", !0)
                    }
                    n && n()
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = Bi.getOrCreateInstance(this);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e]()
                        }
                    }))
                }
            }
            pt.on(document, "click.bs.tab.data-api", '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', (function (e) {
                if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), He(this)) return;
                Bi.getOrCreateInstance(this).show()
            })), Ge(Bi);
            const qi = "toast",
                zi = "hide",
                Hi = "show",
                Ui = "showing",
                Vi = {
                    animation: "boolean",
                    autohide: "boolean",
                    delay: "number"
                },
                Wi = {
                    animation: !0,
                    autohide: !0,
                    delay: 5e3
                };
            class Yi extends vt {
                constructor(e, t) {
                    super(e), this._config = this._getConfig(t), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners()
                }
                static get DefaultType() {
                    return Vi
                }
                static get Default() {
                    return Wi
                }
                static get NAME() {
                    return qi
                }
                show() {
                    if (pt.trigger(this._element, "show.bs.toast").defaultPrevented) return;
                    this._clearTimeout(), this._config.animation && this._element.classList.add("fade");
                    this._element.classList.remove(zi), We(this._element), this._element.classList.add(Hi), this._element.classList.add(Ui), this._queueCallback((() => {
                        this._element.classList.remove(Ui), pt.trigger(this._element, "shown.bs.toast"), this._maybeScheduleHide()
                    }), this._element, this._config.animation)
                }
                hide() {
                    if (!this._element.classList.contains(Hi)) return;
                    if (pt.trigger(this._element, "hide.bs.toast").defaultPrevented) return;
                    this._element.classList.add(Ui), this._queueCallback((() => {
                        this._element.classList.add(zi), this._element.classList.remove(Ui), this._element.classList.remove(Hi), pt.trigger(this._element, "hidden.bs.toast")
                    }), this._element, this._config.animation)
                }
                dispose() {
                    this._clearTimeout(), this._element.classList.contains(Hi) && this._element.classList.remove(Hi), super.dispose()
                }
                _getConfig(e) {
                    return e = {
                        ...Wi,
                        ...kt.getDataAttributes(this._element),
                        ..."object" == typeof e && e ? e : {}
                    }, qe(qi, e, this.constructor.DefaultType), e
                }
                _maybeScheduleHide() {
                    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout((() => {
                        this.hide()
                    }), this._config.delay)))
                }
                _onInteraction(e, t) {
                    switch (e.type) {
                        case "mouseover":
                        case "mouseout":
                            this._hasMouseInteraction = t;
                            break;
                        case "focusin":
                        case "focusout":
                            this._hasKeyboardInteraction = t
                    }
                    if (t) return void this._clearTimeout();
                    const n = e.relatedTarget;
                    this._element === n || this._element.contains(n) || this._maybeScheduleHide()
                }
                _setListeners() {
                    pt.on(this._element, "mouseover.bs.toast", (e => this._onInteraction(e, !0))), pt.on(this._element, "mouseout.bs.toast", (e => this._onInteraction(e, !1))), pt.on(this._element, "focusin.bs.toast", (e => this._onInteraction(e, !0))), pt.on(this._element, "focusout.bs.toast", (e => this._onInteraction(e, !1)))
                }
                _clearTimeout() {
                    clearTimeout(this._timeout), this._timeout = null
                }
                static jQueryInterface(e) {
                    return this.each((function () {
                        const t = Yi.getOrCreateInstance(this, e);
                        if ("string" == typeof e) {
                            if (void 0 === t[e]) throw new TypeError(`No method named "${e}"`);
                            t[e](this)
                        }
                    }))
                }
            }
            bt(Yi), Ge(Yi)
        },
        181: (e, t, n) => {
            "use strict";
            n.d(t, {
                qi: () => mr,
                vn: () => jn,
                ZL: () => Nr,
                N0: () => In,
                uw: () => wo,
                kL: () => lr,
                WY: () => Rr,
                jI: () => Rn,
                Gu: () => to,
                De: () => ro,
                ST: () => Fn,
                jn: () => Or,
                f$: () => So,
                WV: () => Ao,
                tt: () => qn,
                od: () => Cr,
                CV: () => Bn,
                Xi: () => zn,
                l7: () => Ro,
                ho: () => Hn,
                FB: () => Wo,
                RM: () => $o,
                Dx: () => ao,
                u: () => _o
            });
            const i = "undefined" == typeof window ? function (e) {
                return e()
            } : window.requestAnimationFrame;

            function r(e, t, n) {
                const r = n || (e => Array.prototype.slice.call(e));
                let o = !1,
                    a = [];
                return function (...n) {
                    a = r(n), o || (o = !0, i.call(window, (() => {
                        o = !1, e.apply(t, a)
                    })))
                }
            }
            const o = e => "start" === e ? "left" : "end" === e ? "right" : "center",
                a = (e, t, n) => "start" === e ? t : "end" === e ? n : (t + n) / 2;

            function s() {}
            const l = function () {
                let e = 0;
                return function () {
                    return e++
                }
            }();

            function c(e) {
                return null == e
            }

            function u(e) {
                if (Array.isArray && Array.isArray(e)) return !0;
                const t = Object.prototype.toString.call(e);
                return "[object" === t.substr(0, 7) && "Array]" === t.substr(-6)
            }

            function d(e) {
                return null !== e && "[object Object]" === Object.prototype.toString.call(e)
            }
            const h = e => ("number" == typeof e || e instanceof Number) && isFinite(+e);

            function f(e, t) {
                return h(e) ? e : t
            }

            function p(e, t) {
                return void 0 === e ? t : e
            }
            const g = (e, t) => "string" == typeof e && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;

            function m(e, t, n) {
                if (e && "function" == typeof e.call) return e.apply(n, t)
            }

            function v(e, t, n, i) {
                let r, o, a;
                if (u(e))
                    if (o = e.length, i)
                        for (r = o - 1; r >= 0; r--) t.call(n, e[r], r);
                    else
                        for (r = 0; r < o; r++) t.call(n, e[r], r);
                else if (d(e))
                    for (a = Object.keys(e), o = a.length, r = 0; r < o; r++) t.call(n, e[a[r]], a[r])
            }

            function b(e, t) {
                let n, i, r, o;
                if (!e || !t || e.length !== t.length) return !1;
                for (n = 0, i = e.length; n < i; ++n)
                    if (r = e[n], o = t[n], r.datasetIndex !== o.datasetIndex || r.index !== o.index) return !1;
                return !0
            }

            function y(e) {
                if (u(e)) return e.map(y);
                if (d(e)) {
                    const t = Object.create(null),
                        n = Object.keys(e),
                        i = n.length;
                    let r = 0;
                    for (; r < i; ++r) t[n[r]] = y(e[n[r]]);
                    return t
                }
                return e
            }

            function _(e) {
                return -1 === ["__proto__", "prototype", "constructor"].indexOf(e)
            }

            function x(e, t, n, i) {
                if (!_(e)) return;
                const r = t[e],
                    o = n[e];
                d(r) && d(o) ? w(r, o, i) : t[e] = y(o)
            }

            function w(e, t, n) {
                const i = u(t) ? t : [t],
                    r = i.length;
                if (!d(e)) return e;
                const o = (n = n || {}).merger || x;
                for (let a = 0; a < r; ++a) {
                    if (!d(t = i[a])) continue;
                    const r = Object.keys(t);
                    for (let i = 0, a = r.length; i < a; ++i) o(r[i], e, t, n)
                }
                return e
            }

            function E(e, t) {
                return w(e, t, {
                    merger: k
                })
            }

            function k(e, t, n) {
                if (!_(e)) return;
                const i = t[e],
                    r = n[e];
                d(i) && d(r) ? E(i, r) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = y(r))
            }

            function O(e, t) {
                const n = e.indexOf(".", t);
                return -1 === n ? e.length : n
            }

            function S(e, t) {
                if ("" === t) return e;
                let n = 0,
                    i = O(t, n);
                for (; e && i > n;) e = e[t.substr(n, i - n)], n = i + 1, i = O(t, n);
                return e
            }

            function C(e) {
                return e.charAt(0).toUpperCase() + e.slice(1)
            }
            const A = e => void 0 !== e,
                M = e => "function" == typeof e,
                T = Math.PI,
                P = 2 * T,
                D = P + T,
                L = Number.POSITIVE_INFINITY,
                N = T / 180,
                j = T / 2,
                I = T / 4,
                R = 2 * T / 3,
                F = Math.log10,
                B = Math.sign;

            function q(e) {
                const t = Math.round(e);
                e = H(e, t, e / 1e3) ? t : e;
                const n = Math.pow(10, Math.floor(F(e))),
                    i = e / n;
                return (i <= 1 ? 1 : i <= 2 ? 2 : i <= 5 ? 5 : 10) * n
            }

            function z(e) {
                return !isNaN(parseFloat(e)) && isFinite(e)
            }

            function H(e, t, n) {
                return Math.abs(e - t) < n
            }

            function U(e, t, n) {
                let i, r, o;
                for (i = 0, r = e.length; i < r; i++) o = e[i][n], isNaN(o) || (t.min = Math.min(t.min, o), t.max = Math.max(t.max, o))
            }

            function V(e) {
                return e * (T / 180)
            }

            function W(e) {
                return e * (180 / T)
            }

            function Y(e) {
                if (!h(e)) return;
                let t = 1,
                    n = 0;
                for (; Math.round(e * t) / t !== e;) t *= 10, n++;
                return n
            }

            function $(e, t) {
                return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
            }

            function K(e, t) {
                return (e - t + D) % P - T
            }

            function G(e) {
                return (e % P + P) % P
            }

            function X(e, t, n, i) {
                const r = G(e),
                    o = G(t),
                    a = G(n),
                    s = G(o - r),
                    l = G(a - r),
                    c = G(r - o),
                    u = G(r - a);
                return r === o || r === a || i && o === a || s > l && c < u
            }

            function Z(e, t, n) {
                return Math.max(t, Math.min(n, e))
            }
            const Q = e => 0 === e || 1 === e,
                J = (e, t, n) => -Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * P / n),
                ee = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * P / n) + 1,
                te = {
                    linear: e => e,
                    easeInQuad: e => e * e,
                    easeOutQuad: e => -e * (e - 2),
                    easeInOutQuad: e => (e /= .5) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1),
                    easeInCubic: e => e * e * e,
                    easeOutCubic: e => (e -= 1) * e * e + 1,
                    easeInOutCubic: e => (e /= .5) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2),
                    easeInQuart: e => e * e * e * e,
                    easeOutQuart: e => -((e -= 1) * e * e * e - 1),
                    easeInOutQuart: e => (e /= .5) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2),
                    easeInQuint: e => e * e * e * e * e,
                    easeOutQuint: e => (e -= 1) * e * e * e * e + 1,
                    easeInOutQuint: e => (e /= .5) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2),
                    easeInSine: e => 1 - Math.cos(e * j),
                    easeOutSine: e => Math.sin(e * j),
                    easeInOutSine: e => -.5 * (Math.cos(T * e) - 1),
                    easeInExpo: e => 0 === e ? 0 : Math.pow(2, 10 * (e - 1)),
                    easeOutExpo: e => 1 === e ? 1 : 1 - Math.pow(2, -10 * e),
                    easeInOutExpo: e => Q(e) ? e : e < .5 ? .5 * Math.pow(2, 10 * (2 * e - 1)) : .5 * (2 - Math.pow(2, -10 * (2 * e - 1))),
                    easeInCirc: e => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
                    easeOutCirc: e => Math.sqrt(1 - (e -= 1) * e),
                    easeInOutCirc: e => (e /= .5) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
                    easeInElastic: e => Q(e) ? e : J(e, .075, .3),
                    easeOutElastic: e => Q(e) ? e : ee(e, .075, .3),
                    easeInOutElastic(e) {
                        const t = .1125;
                        return Q(e) ? e : e < .5 ? .5 * J(2 * e, t, .45) : .5 + .5 * ee(2 * e - 1, t, .45)
                    },
                    easeInBack(e) {
                        const t = 1.70158;
                        return e * e * ((t + 1) * e - t)
                    },
                    easeOutBack(e) {
                        const t = 1.70158;
                        return (e -= 1) * e * ((t + 1) * e + t) + 1
                    },
                    easeInOutBack(e) {
                        let t = 1.70158;
                        return (e /= .5) < 1 ? e * e * ((1 + (t *= 1.525)) * e - t) * .5 : .5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2)
                    },
                    easeInBounce: e => 1 - te.easeOutBounce(1 - e),
                    easeOutBounce(e) {
                        const t = 7.5625,
                            n = 2.75;
                        return e < 1 / n ? t * e * e : e < 2 / n ? t * (e -= 1.5 / n) * e + .75 : e < 2.5 / n ? t * (e -= 2.25 / n) * e + .9375 : t * (e -= 2.625 / n) * e + .984375
                    },
                    easeInOutBounce: e => e < .5 ? .5 * te.easeInBounce(2 * e) : .5 * te.easeOutBounce(2 * e - 1) + .5
                },
                ne = {
                    0: 0,
                    1: 1,
                    2: 2,
                    3: 3,
                    4: 4,
                    5: 5,
                    6: 6,
                    7: 7,
                    8: 8,
                    9: 9,
                    A: 10,
                    B: 11,
                    C: 12,
                    D: 13,
                    E: 14,
                    F: 15,
                    a: 10,
                    b: 11,
                    c: 12,
                    d: 13,
                    e: 14,
                    f: 15
                },
                ie = "0123456789ABCDEF",
                re = e => ie[15 & e],
                oe = e => ie[(240 & e) >> 4] + ie[15 & e],
                ae = e => (240 & e) >> 4 == (15 & e);

            function se(e) {
                var t = function (e) {
                    return ae(e.r) && ae(e.g) && ae(e.b) && ae(e.a)
                }(e) ? re : oe;
                return e ? "#" + t(e.r) + t(e.g) + t(e.b) + (e.a < 255 ? t(e.a) : "") : e
            }

            function le(e) {
                return e + .5 | 0
            }
            const ce = (e, t, n) => Math.max(Math.min(e, n), t);

            function ue(e) {
                return ce(le(2.55 * e), 0, 255)
            }

            function de(e) {
                return ce(le(255 * e), 0, 255)
            }

            function he(e) {
                return ce(le(e / 2.55) / 100, 0, 1)
            }

            function fe(e) {
                return ce(le(100 * e), 0, 100)
            }
            const pe = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
            const ge = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;

            function me(e, t, n) {
                const i = t * Math.min(n, 1 - n),
                    r = (t, r = (t + e / 30) % 12) => n - i * Math.max(Math.min(r - 3, 9 - r, 1), -1);
                return [r(0), r(8), r(4)]
            }

            function ve(e, t, n) {
                const i = (i, r = (i + e / 60) % 6) => n - n * t * Math.max(Math.min(r, 4 - r, 1), 0);
                return [i(5), i(3), i(1)]
            }

            function be(e, t, n) {
                const i = me(e, 1, .5);
                let r;
                for (t + n > 1 && (r = 1 / (t + n), t *= r, n *= r), r = 0; r < 3; r++) i[r] *= 1 - t - n, i[r] += t;
                return i
            }

            function ye(e) {
                const t = e.r / 255,
                    n = e.g / 255,
                    i = e.b / 255,
                    r = Math.max(t, n, i),
                    o = Math.min(t, n, i),
                    a = (r + o) / 2;
                let s, l, c;
                return r !== o && (c = r - o, l = a > .5 ? c / (2 - r - o) : c / (r + o), s = r === t ? (n - i) / c + (n < i ? 6 : 0) : r === n ? (i - t) / c + 2 : (t - n) / c + 4, s = 60 * s + .5), [0 | s, l || 0, a]
            }

            function _e(e, t, n, i) {
                return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, i)).map(de)
            }

            function xe(e, t, n) {
                return _e(me, e, t, n)
            }

            function we(e) {
                return (e % 360 + 360) % 360
            }

            function Ee(e) {
                const t = ge.exec(e);
                let n, i = 255;
                if (!t) return;
                t[5] !== n && (i = t[6] ? ue(+t[5]) : de(+t[5]));
                const r = we(+t[2]),
                    o = +t[3] / 100,
                    a = +t[4] / 100;
                return n = "hwb" === t[1] ? function (e, t, n) {
                    return _e(be, e, t, n)
                }(r, o, a) : "hsv" === t[1] ? function (e, t, n) {
                    return _e(ve, e, t, n)
                }(r, o, a) : xe(r, o, a), {
                    r: n[0],
                    g: n[1],
                    b: n[2],
                    a: i
                }
            }
            const ke = {
                    x: "dark",
                    Z: "light",
                    Y: "re",
                    X: "blu",
                    W: "gr",
                    V: "medium",
                    U: "slate",
                    A: "ee",
                    T: "ol",
                    S: "or",
                    B: "ra",
                    C: "lateg",
                    D: "ights",
                    R: "in",
                    Q: "turquois",
                    E: "hi",
                    P: "ro",
                    O: "al",
                    N: "le",
                    M: "de",
                    L: "yello",
                    F: "en",
                    K: "ch",
                    G: "arks",
                    H: "ea",
                    I: "ightg",
                    J: "wh"
                },
                Oe = {
                    OiceXe: "f0f8ff",
                    antiquewEte: "faebd7",
                    aqua: "ffff",
                    aquamarRe: "7fffd4",
                    azuY: "f0ffff",
                    beige: "f5f5dc",
                    bisque: "ffe4c4",
                    black: "0",
                    blanKedOmond: "ffebcd",
                    Xe: "ff",
                    XeviTet: "8a2be2",
                    bPwn: "a52a2a",
                    burlywood: "deb887",
                    caMtXe: "5f9ea0",
                    KartYuse: "7fff00",
                    KocTate: "d2691e",
                    cSO: "ff7f50",
                    cSnflowerXe: "6495ed",
                    cSnsilk: "fff8dc",
                    crimson: "dc143c",
                    cyan: "ffff",
                    xXe: "8b",
                    xcyan: "8b8b",
                    xgTMnPd: "b8860b",
                    xWay: "a9a9a9",
                    xgYF: "6400",
                    xgYy: "a9a9a9",
                    xkhaki: "bdb76b",
                    xmagFta: "8b008b",
                    xTivegYF: "556b2f",
                    xSange: "ff8c00",
                    xScEd: "9932cc",
                    xYd: "8b0000",
                    xsOmon: "e9967a",
                    xsHgYF: "8fbc8f",
                    xUXe: "483d8b",
                    xUWay: "2f4f4f",
                    xUgYy: "2f4f4f",
                    xQe: "ced1",
                    xviTet: "9400d3",
                    dAppRk: "ff1493",
                    dApskyXe: "bfff",
                    dimWay: "696969",
                    dimgYy: "696969",
                    dodgerXe: "1e90ff",
                    fiYbrick: "b22222",
                    flSOwEte: "fffaf0",
                    foYstWAn: "228b22",
                    fuKsia: "ff00ff",
                    gaRsbSo: "dcdcdc",
                    ghostwEte: "f8f8ff",
                    gTd: "ffd700",
                    gTMnPd: "daa520",
                    Way: "808080",
                    gYF: "8000",
                    gYFLw: "adff2f",
                    gYy: "808080",
                    honeyMw: "f0fff0",
                    hotpRk: "ff69b4",
                    RdianYd: "cd5c5c",
                    Rdigo: "4b0082",
                    ivSy: "fffff0",
                    khaki: "f0e68c",
                    lavFMr: "e6e6fa",
                    lavFMrXsh: "fff0f5",
                    lawngYF: "7cfc00",
                    NmoncEffon: "fffacd",
                    ZXe: "add8e6",
                    ZcSO: "f08080",
                    Zcyan: "e0ffff",
                    ZgTMnPdLw: "fafad2",
                    ZWay: "d3d3d3",
                    ZgYF: "90ee90",
                    ZgYy: "d3d3d3",
                    ZpRk: "ffb6c1",
                    ZsOmon: "ffa07a",
                    ZsHgYF: "20b2aa",
                    ZskyXe: "87cefa",
                    ZUWay: "778899",
                    ZUgYy: "778899",
                    ZstAlXe: "b0c4de",
                    ZLw: "ffffe0",
                    lime: "ff00",
                    limegYF: "32cd32",
                    lRF: "faf0e6",
                    magFta: "ff00ff",
                    maPon: "800000",
                    VaquamarRe: "66cdaa",
                    VXe: "cd",
                    VScEd: "ba55d3",
                    VpurpN: "9370db",
                    VsHgYF: "3cb371",
                    VUXe: "7b68ee",
                    VsprRggYF: "fa9a",
                    VQe: "48d1cc",
                    VviTetYd: "c71585",
                    midnightXe: "191970",
                    mRtcYam: "f5fffa",
                    mistyPse: "ffe4e1",
                    moccasR: "ffe4b5",
                    navajowEte: "ffdead",
                    navy: "80",
                    Tdlace: "fdf5e6",
                    Tive: "808000",
                    TivedBb: "6b8e23",
                    Sange: "ffa500",
                    SangeYd: "ff4500",
                    ScEd: "da70d6",
                    pOegTMnPd: "eee8aa",
                    pOegYF: "98fb98",
                    pOeQe: "afeeee",
                    pOeviTetYd: "db7093",
                    papayawEp: "ffefd5",
                    pHKpuff: "ffdab9",
                    peru: "cd853f",
                    pRk: "ffc0cb",
                    plum: "dda0dd",
                    powMrXe: "b0e0e6",
                    purpN: "800080",
                    YbeccapurpN: "663399",
                    Yd: "ff0000",
                    Psybrown: "bc8f8f",
                    PyOXe: "4169e1",
                    saddNbPwn: "8b4513",
                    sOmon: "fa8072",
                    sandybPwn: "f4a460",
                    sHgYF: "2e8b57",
                    sHshell: "fff5ee",
                    siFna: "a0522d",
                    silver: "c0c0c0",
                    skyXe: "87ceeb",
                    UXe: "6a5acd",
                    UWay: "708090",
                    UgYy: "708090",
                    snow: "fffafa",
                    sprRggYF: "ff7f",
                    stAlXe: "4682b4",
                    tan: "d2b48c",
                    teO: "8080",
                    tEstN: "d8bfd8",
                    tomato: "ff6347",
                    Qe: "40e0d0",
                    viTet: "ee82ee",
                    JHt: "f5deb3",
                    wEte: "ffffff",
                    wEtesmoke: "f5f5f5",
                    Lw: "ffff00",
                    LwgYF: "9acd32"
                };
            let Se;

            function Ce(e) {
                Se || (Se = function () {
                    const e = {},
                        t = Object.keys(Oe),
                        n = Object.keys(ke);
                    let i, r, o, a, s;
                    for (i = 0; i < t.length; i++) {
                        for (a = s = t[i], r = 0; r < n.length; r++) o = n[r], s = s.replace(o, ke[o]);
                        o = parseInt(Oe[a], 16), e[s] = [o >> 16 & 255, o >> 8 & 255, 255 & o]
                    }
                    return e
                }(), Se.transparent = [0, 0, 0, 0]);
                const t = Se[e.toLowerCase()];
                return t && {
                    r: t[0],
                    g: t[1],
                    b: t[2],
                    a: 4 === t.length ? t[3] : 255
                }
            }

            function Ae(e, t, n) {
                if (e) {
                    let i = ye(e);
                    i[t] = Math.max(0, Math.min(i[t] + i[t] * n, 0 === t ? 360 : 1)), i = xe(i), e.r = i[0], e.g = i[1], e.b = i[2]
                }
            }

            function Me(e, t) {
                return e ? Object.assign(t || {}, e) : e
            }

            function Te(e) {
                var t = {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 255
                };
                return Array.isArray(e) ? e.length >= 3 && (t = {
                    r: e[0],
                    g: e[1],
                    b: e[2],
                    a: 255
                }, e.length > 3 && (t.a = de(e[3]))) : (t = Me(e, {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                })).a = de(t.a), t
            }

            function Pe(e) {
                return "r" === e.charAt(0) ? function (e) {
                    const t = pe.exec(e);
                    let n, i, r, o = 255;
                    if (t) {
                        if (t[7] !== n) {
                            const e = +t[7];
                            o = 255 & (t[8] ? ue(e) : 255 * e)
                        }
                        return n = +t[1], i = +t[3], r = +t[5], n = 255 & (t[2] ? ue(n) : n), i = 255 & (t[4] ? ue(i) : i), r = 255 & (t[6] ? ue(r) : r), {
                            r: n,
                            g: i,
                            b: r,
                            a: o
                        }
                    }
                }(e) : Ee(e)
            }
            class De {
                constructor(e) {
                    if (e instanceof De) return e;
                    const t = typeof e;
                    let n;
                    var i, r, o;
                    "object" === t ? n = Te(e) : "string" === t && (o = (i = e).length, "#" === i[0] && (4 === o || 5 === o ? r = {
                        r: 255 & 17 * ne[i[1]],
                        g: 255 & 17 * ne[i[2]],
                        b: 255 & 17 * ne[i[3]],
                        a: 5 === o ? 17 * ne[i[4]] : 255
                    } : 7 !== o && 9 !== o || (r = {
                        r: ne[i[1]] << 4 | ne[i[2]],
                        g: ne[i[3]] << 4 | ne[i[4]],
                        b: ne[i[5]] << 4 | ne[i[6]],
                        a: 9 === o ? ne[i[7]] << 4 | ne[i[8]] : 255
                    })), n = r || Ce(e) || Pe(e)), this._rgb = n, this._valid = !!n
                }
                get valid() {
                    return this._valid
                }
                get rgb() {
                    var e = Me(this._rgb);
                    return e && (e.a = he(e.a)), e
                }
                set rgb(e) {
                    this._rgb = Te(e)
                }
                rgbString() {
                    return this._valid ? (e = this._rgb) && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${he(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`) : this._rgb;
                    var e
                }
                hexString() {
                    return this._valid ? se(this._rgb) : this._rgb
                }
                hslString() {
                    return this._valid ? function (e) {
                        if (!e) return;
                        const t = ye(e),
                            n = t[0],
                            i = fe(t[1]),
                            r = fe(t[2]);
                        return e.a < 255 ? `hsla(${n}, ${i}%, ${r}%, ${he(e.a)})` : `hsl(${n}, ${i}%, ${r}%)`
                    }(this._rgb) : this._rgb
                }
                mix(e, t) {
                    const n = this;
                    if (e) {
                        const i = n.rgb,
                            r = e.rgb;
                        let o;
                        const a = t === o ? .5 : t,
                            s = 2 * a - 1,
                            l = i.a - r.a,
                            c = ((s * l == -1 ? s : (s + l) / (1 + s * l)) + 1) / 2;
                        o = 1 - c, i.r = 255 & c * i.r + o * r.r + .5, i.g = 255 & c * i.g + o * r.g + .5, i.b = 255 & c * i.b + o * r.b + .5, i.a = a * i.a + (1 - a) * r.a, n.rgb = i
                    }
                    return n
                }
                clone() {
                    return new De(this.rgb)
                }
                alpha(e) {
                    return this._rgb.a = de(e), this
                }
                clearer(e) {
                    return this._rgb.a *= 1 - e, this
                }
                greyscale() {
                    const e = this._rgb,
                        t = le(.3 * e.r + .59 * e.g + .11 * e.b);
                    return e.r = e.g = e.b = t, this
                }
                opaquer(e) {
                    return this._rgb.a *= 1 + e, this
                }
                negate() {
                    const e = this._rgb;
                    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this
                }
                lighten(e) {
                    return Ae(this._rgb, 2, e), this
                }
                darken(e) {
                    return Ae(this._rgb, 2, -e), this
                }
                saturate(e) {
                    return Ae(this._rgb, 1, e), this
                }
                desaturate(e) {
                    return Ae(this._rgb, 1, -e), this
                }
                rotate(e) {
                    return function (e, t) {
                        var n = ye(e);
                        n[0] = we(n[0] + t), n = xe(n), e.r = n[0], e.g = n[1], e.b = n[2]
                    }(this._rgb, e), this
                }
            }

            function Le(e) {
                return new De(e)
            }
            const Ne = e => e instanceof CanvasGradient || e instanceof CanvasPattern;

            function je(e) {
                return Ne(e) ? e : Le(e)
            }

            function Ie(e) {
                return Ne(e) ? e : Le(e).saturate(.5).darken(.1).hexString()
            }
            const Re = Object.create(null),
                Fe = Object.create(null);

            function Be(e, t) {
                if (!t) return e;
                const n = t.split(".");
                for (let t = 0, i = n.length; t < i; ++t) {
                    const i = n[t];
                    e = e[i] || (e[i] = Object.create(null))
                }
                return e
            }

            function qe(e, t, n) {
                return "string" == typeof t ? w(Be(e, t), n) : w(Be(e, ""), t)
            }
            var ze = new class {
                constructor(e) {
                    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = e => e.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = ["mousemove", "mouseout", "click", "touchstart", "touchmove"], this.font = {
                        family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                        size: 12,
                        style: "normal",
                        lineHeight: 1.2,
                        weight: null
                    }, this.hover = {}, this.hoverBackgroundColor = (e, t) => Ie(t.backgroundColor), this.hoverBorderColor = (e, t) => Ie(t.borderColor), this.hoverColor = (e, t) => Ie(t.color), this.indexAxis = "x", this.interaction = {
                        mode: "nearest",
                        intersect: !0
                    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.describe(e)
                }
                set(e, t) {
                    return qe(this, e, t)
                }
                get(e) {
                    return Be(this, e)
                }
                describe(e, t) {
                    return qe(Fe, e, t)
                }
                override(e, t) {
                    return qe(Re, e, t)
                }
                route(e, t, n, i) {
                    const r = Be(this, e),
                        o = Be(this, n),
                        a = "_" + t;
                    Object.defineProperties(r, {
                        [a]: {
                            value: r[t],
                            writable: !0
                        },
                        [t]: {
                            enumerable: !0,
                            get() {
                                const e = this[a],
                                    t = o[i];
                                return d(e) ? Object.assign({}, t, e) : p(e, t)
                            },
                            set(e) {
                                this[a] = e
                            }
                        }
                    })
                }
            }({
                _scriptable: e => !e.startsWith("on"),
                _indexable: e => "events" !== e,
                hover: {
                    _fallback: "interaction"
                },
                interaction: {
                    _scriptable: !1,
                    _indexable: !1
                }
            });

            function He(e, t, n, i, r) {
                let o = t[r];
                return o || (o = t[r] = e.measureText(r).width, n.push(r)), o > i && (i = o), i
            }

            function Ue(e, t, n, i) {
                let r = (i = i || {}).data = i.data || {},
                    o = i.garbageCollect = i.garbageCollect || [];
                i.font !== t && (r = i.data = {}, o = i.garbageCollect = [], i.font = t), e.save(), e.font = t;
                let a = 0;
                const s = n.length;
                let l, c, d, h, f;
                for (l = 0; l < s; l++)
                    if (h = n[l], null != h && !0 !== u(h)) a = He(e, r, o, a, h);
                    else if (u(h))
                    for (c = 0, d = h.length; c < d; c++) f = h[c], null == f || u(f) || (a = He(e, r, o, a, f));
                e.restore();
                const p = o.length / 2;
                if (p > n.length) {
                    for (l = 0; l < p; l++) delete r[o[l]];
                    o.splice(0, p)
                }
                return a
            }

            function Ve(e, t, n) {
                const i = e.currentDevicePixelRatio,
                    r = 0 !== n ? Math.max(n / 2, .5) : 0;
                return Math.round((t - r) * i) / i + r
            }

            function We(e, t) {
                (t = t || e.getContext("2d")).save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore()
            }

            function Ye(e, t, n, i) {
                let r, o, a, s, l;
                const c = t.pointStyle,
                    u = t.rotation,
                    d = t.radius;
                let h = (u || 0) * N;
                if (c && "object" == typeof c && (r = c.toString(), "[object HTMLImageElement]" === r || "[object HTMLCanvasElement]" === r)) return e.save(), e.translate(n, i), e.rotate(h), e.drawImage(c, -c.width / 2, -c.height / 2, c.width, c.height), void e.restore();
                if (!(isNaN(d) || d <= 0)) {
                    switch (e.beginPath(), c) {
                        default:
                            e.arc(n, i, d, 0, P), e.closePath();
                            break;
                        case "triangle":
                            e.moveTo(n + Math.sin(h) * d, i - Math.cos(h) * d), h += R, e.lineTo(n + Math.sin(h) * d, i - Math.cos(h) * d), h += R, e.lineTo(n + Math.sin(h) * d, i - Math.cos(h) * d), e.closePath();
                            break;
                        case "rectRounded":
                            l = .516 * d, s = d - l, o = Math.cos(h + I) * s, a = Math.sin(h + I) * s, e.arc(n - o, i - a, l, h - T, h - j), e.arc(n + a, i - o, l, h - j, h), e.arc(n + o, i + a, l, h, h + j), e.arc(n - a, i + o, l, h + j, h + T), e.closePath();
                            break;
                        case "rect":
                            if (!u) {
                                s = Math.SQRT1_2 * d, e.rect(n - s, i - s, 2 * s, 2 * s);
                                break
                            }
                            h += I;
                        case "rectRot":
                            o = Math.cos(h) * d, a = Math.sin(h) * d, e.moveTo(n - o, i - a), e.lineTo(n + a, i - o), e.lineTo(n + o, i + a), e.lineTo(n - a, i + o), e.closePath();
                            break;
                        case "crossRot":
                            h += I;
                        case "cross":
                            o = Math.cos(h) * d, a = Math.sin(h) * d, e.moveTo(n - o, i - a), e.lineTo(n + o, i + a), e.moveTo(n + a, i - o), e.lineTo(n - a, i + o);
                            break;
                        case "star":
                            o = Math.cos(h) * d, a = Math.sin(h) * d, e.moveTo(n - o, i - a), e.lineTo(n + o, i + a), e.moveTo(n + a, i - o), e.lineTo(n - a, i + o), h += I, o = Math.cos(h) * d, a = Math.sin(h) * d, e.moveTo(n - o, i - a), e.lineTo(n + o, i + a), e.moveTo(n + a, i - o), e.lineTo(n - a, i + o);
                            break;
                        case "line":
                            o = Math.cos(h) * d, a = Math.sin(h) * d, e.moveTo(n - o, i - a), e.lineTo(n + o, i + a);
                            break;
                        case "dash":
                            e.moveTo(n, i), e.lineTo(n + Math.cos(h) * d, i + Math.sin(h) * d)
                    }
                    e.fill(), t.borderWidth > 0 && e.stroke()
                }
            }

            function $e(e, t, n) {
                return n = n || .5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n
            }

            function Ke(e, t) {
                e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip()
            }

            function Ge(e) {
                e.restore()
            }

            function Xe(e, t, n, i, r) {
                if (!t) return e.lineTo(n.x, n.y);
                if ("middle" === r) {
                    const i = (t.x + n.x) / 2;
                    e.lineTo(i, t.y), e.lineTo(i, n.y)
                } else "after" === r != !!i ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
                e.lineTo(n.x, n.y)
            }

            function Ze(e, t, n, i) {
                if (!t) return e.lineTo(n.x, n.y);
                e.bezierCurveTo(i ? t.cp1x : t.cp2x, i ? t.cp1y : t.cp2y, i ? n.cp2x : n.cp1x, i ? n.cp2y : n.cp1y, n.x, n.y)
            }

            function Qe(e, t, n, i, r, o = {}) {
                const a = u(t) ? t : [t],
                    s = o.strokeWidth > 0 && "" !== o.strokeColor;
                let l, d;
                for (e.save(), e.font = r.string, function (e, t) {
                        t.translation && e.translate(t.translation[0], t.translation[1]);
                        c(t.rotation) || e.rotate(t.rotation);
                        t.color && (e.fillStyle = t.color);
                        t.textAlign && (e.textAlign = t.textAlign);
                        t.textBaseline && (e.textBaseline = t.textBaseline)
                    }(e, o), l = 0; l < a.length; ++l) d = a[l], s && (o.strokeColor && (e.strokeStyle = o.strokeColor), c(o.strokeWidth) || (e.lineWidth = o.strokeWidth), e.strokeText(d, n, i, o.maxWidth)), e.fillText(d, n, i, o.maxWidth), Je(e, n, i, d, o), i += r.lineHeight;
                e.restore()
            }

            function Je(e, t, n, i, r) {
                if (r.strikethrough || r.underline) {
                    const o = e.measureText(i),
                        a = t - o.actualBoundingBoxLeft,
                        s = t + o.actualBoundingBoxRight,
                        l = n - o.actualBoundingBoxAscent,
                        c = n + o.actualBoundingBoxDescent,
                        u = r.strikethrough ? (l + c) / 2 : c;
                    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = r.decorationWidth || 2, e.moveTo(a, u), e.lineTo(s, u), e.stroke()
                }
            }

            function et(e, t) {
                const {
                    x: n,
                    y: i,
                    w: r,
                    h: o,
                    radius: a
                } = t;
                e.arc(n + a.topLeft, i + a.topLeft, a.topLeft, -j, T, !0), e.lineTo(n, i + o - a.bottomLeft), e.arc(n + a.bottomLeft, i + o - a.bottomLeft, a.bottomLeft, T, j, !0), e.lineTo(n + r - a.bottomRight, i + o), e.arc(n + r - a.bottomRight, i + o - a.bottomRight, a.bottomRight, j, 0, !0), e.lineTo(n + r, i + a.topRight), e.arc(n + r - a.topRight, i + a.topRight, a.topRight, 0, -j, !0), e.lineTo(n + a.topLeft, i)
            }
            const tt = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/),
                nt = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);

            function it(e, t) {
                const n = ("" + e).match(tt);
                if (!n || "normal" === n[1]) return 1.2 * t;
                switch (e = +n[2], n[3]) {
                    case "px":
                        return e;
                    case "%":
                        e /= 100
                }
                return t * e
            }

            function rt(e, t) {
                const n = {},
                    i = d(t),
                    r = i ? Object.keys(t) : t,
                    o = d(e) ? i ? n => p(e[n], e[t[n]]) : t => e[t] : () => e;
                for (const e of r) n[e] = +o(e) || 0;
                return n
            }

            function ot(e) {
                return rt(e, {
                    top: "y",
                    right: "x",
                    bottom: "y",
                    left: "x"
                })
            }

            function at(e) {
                return rt(e, ["topLeft", "topRight", "bottomLeft", "bottomRight"])
            }

            function st(e) {
                const t = ot(e);
                return t.width = t.left + t.right, t.height = t.top + t.bottom, t
            }

            function lt(e, t) {
                e = e || {}, t = t || ze.font;
                let n = p(e.size, t.size);
                "string" == typeof n && (n = parseInt(n, 10));
                let i = p(e.style, t.style);
                i && !("" + i).match(nt) && (console.warn('Invalid font style specified: "' + i + '"'), i = "");
                const r = {
                    family: p(e.family, t.family),
                    lineHeight: it(p(e.lineHeight, t.lineHeight), n),
                    size: n,
                    style: i,
                    weight: p(e.weight, t.weight),
                    string: ""
                };
                return r.string = function (e) {
                    return !e || c(e.size) || c(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family
                }(r), r
            }

            function ct(e, t, n, i) {
                let r, o, a, s = !0;
                for (r = 0, o = e.length; r < o; ++r)
                    if (a = e[r], void 0 !== a && (void 0 !== t && "function" == typeof a && (a = a(t), s = !1), void 0 !== n && u(a) && (a = a[n % a.length], s = !1), void 0 !== a)) return i && !s && (i.cacheable = !1), a
            }

            function ut(e, t, n) {
                n = n || (n => e[n] < t);
                let i, r = e.length - 1,
                    o = 0;
                for (; r - o > 1;) i = o + r >> 1, n(i) ? o = i : r = i;
                return {
                    lo: o,
                    hi: r
                }
            }
            const dt = (e, t, n) => ut(e, n, (i => e[i][t] < n)),
                ht = (e, t, n) => ut(e, n, (i => e[i][t] >= n));
            const ft = ["push", "pop", "shift", "splice", "unshift"];

            function pt(e, t) {
                const n = e._chartjs;
                if (!n) return;
                const i = n.listeners,
                    r = i.indexOf(t); - 1 !== r && i.splice(r, 1), i.length > 0 || (ft.forEach((t => {
                    delete e[t]
                })), delete e._chartjs)
            }

            function gt(e) {
                const t = new Set;
                let n, i;
                for (n = 0, i = e.length; n < i; ++n) t.add(e[n]);
                return t.size === i ? e : Array.from(t)
            }

            function mt(e, t = [""], n = e, i, r = (() => e[0])) {
                A(i) || (i = Ct("_fallback", e));
                const o = {
                    [Symbol.toStringTag]: "Object",
                    _cacheable: !0,
                    _scopes: e,
                    _rootScopes: n,
                    _fallback: i,
                    _getTarget: r,
                    override: r => mt([r, ...e], t, n, i)
                };
                return new Proxy(o, {
                    deleteProperty: (t, n) => (delete t[n], delete t._keys, delete e[0][n], !0),
                    get: (n, i) => xt(n, i, (() => function (e, t, n, i) {
                        let r;
                        for (const o of t)
                            if (r = Ct(yt(o, e), n), A(r)) return _t(e, r) ? Ot(n, i, e, r) : r
                    }(i, t, e, n))),
                    getOwnPropertyDescriptor: (e, t) => Reflect.getOwnPropertyDescriptor(e._scopes[0], t),
                    getPrototypeOf: () => Reflect.getPrototypeOf(e[0]),
                    has: (e, t) => At(e).includes(t),
                    ownKeys: e => At(e),
                    set: (e, t, n) => ((e._storage || (e._storage = r()))[t] = n, delete e[t], delete e._keys, !0)
                })
            }

            function vt(e, t, n, i) {
                const r = {
                    _cacheable: !1,
                    _proxy: e,
                    _context: t,
                    _subProxy: n,
                    _stack: new Set,
                    _descriptors: bt(e, i),
                    setContext: t => vt(e, t, n, i),
                    override: r => vt(e.override(r), t, n, i)
                };
                return new Proxy(r, {
                    deleteProperty: (t, n) => (delete t[n], delete e[n], !0),
                    get: (e, t, n) => xt(e, t, (() => function (e, t, n) {
                        const {
                            _proxy: i,
                            _context: r,
                            _subProxy: o,
                            _descriptors: a
                        } = e;
                        let s = i[t];
                        M(s) && a.isScriptable(t) && (s = function (e, t, n, i) {
                            const {
                                _proxy: r,
                                _context: o,
                                _subProxy: a,
                                _stack: s
                            } = n;
                            if (s.has(e)) throw new Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
                            s.add(e), t = t(o, a || i), s.delete(e), d(t) && (t = Ot(r._scopes, r, e, t));
                            return t
                        }(t, s, e, n));
                        u(s) && s.length && (s = function (e, t, n, i) {
                            const {
                                _proxy: r,
                                _context: o,
                                _subProxy: a,
                                _descriptors: s
                            } = n;
                            if (A(o.index) && i(e)) t = t[o.index % t.length];
                            else if (d(t[0])) {
                                const n = t,
                                    i = r._scopes.filter((e => e !== n));
                                t = [];
                                for (const l of n) {
                                    const n = Ot(i, r, e, l);
                                    t.push(vt(n, o, a && a[e], s))
                                }
                            }
                            return t
                        }(t, s, e, a.isIndexable));
                        _t(t, s) && (s = vt(s, r, o && o[t], a));
                        return s
                    }(e, t, n))),
                    getOwnPropertyDescriptor: (t, n) => t._descriptors.allKeys ? Reflect.has(e, n) ? {
                        enumerable: !0,
                        configurable: !0
                    } : void 0 : Reflect.getOwnPropertyDescriptor(e, n),
                    getPrototypeOf: () => Reflect.getPrototypeOf(e),
                    has: (t, n) => Reflect.has(e, n),
                    ownKeys: () => Reflect.ownKeys(e),
                    set: (t, n, i) => (e[n] = i, delete t[n], !0)
                })
            }

            function bt(e, t = {
                scriptable: !0,
                indexable: !0
            }) {
                const {
                    _scriptable: n = t.scriptable,
                    _indexable: i = t.indexable,
                    _allKeys: r = t.allKeys
                } = e;
                return {
                    allKeys: r,
                    scriptable: n,
                    indexable: i,
                    isScriptable: M(n) ? n : () => n,
                    isIndexable: M(i) ? i : () => i
                }
            }
            const yt = (e, t) => e ? e + C(t) : t,
                _t = (e, t) => d(t) && "adapters" !== e;

            function xt(e, t, n) {
                let i = e[t];
                return A(i) || (i = n(), A(i) && (e[t] = i)), i
            }

            function wt(e, t, n) {
                return M(e) ? e(t, n) : e
            }
            const Et = (e, t) => !0 === e ? t : "string" == typeof e ? S(t, e) : void 0;

            function kt(e, t, n, i) {
                for (const r of t) {
                    const t = Et(n, r);
                    if (t) {
                        e.add(t);
                        const r = wt(t._fallback, n, t);
                        if (A(r) && r !== n && r !== i) return r
                    } else if (!1 === t && A(i) && n !== i) return null
                }
                return !1
            }

            function Ot(e, t, n, i) {
                const r = t._rootScopes,
                    o = wt(t._fallback, n, i),
                    a = [...e, ...r],
                    s = new Set;
                s.add(i);
                let l = St(s, a, n, o || n);
                return null !== l && ((!A(o) || o === n || (l = St(s, a, o, l), null !== l)) && mt(Array.from(s), [""], r, o, (() => function (e, t, n) {
                    const i = e._getTarget();
                    t in i || (i[t] = {});
                    const r = i[t];
                    if (u(r) && d(n)) return n;
                    return r
                }(t, n, i))))
            }

            function St(e, t, n, i) {
                for (; n;) n = kt(e, t, n, i);
                return n
            }

            function Ct(e, t) {
                for (const n of t) {
                    if (!n) continue;
                    const t = n[e];
                    if (A(t)) return t
                }
            }

            function At(e) {
                let t = e._keys;
                return t || (t = e._keys = function (e) {
                    const t = new Set;
                    for (const n of e)
                        for (const e of Object.keys(n).filter((e => !e.startsWith("_")))) t.add(e);
                    return Array.from(t)
                }(e._scopes)), t
            }
            const Mt = Number.EPSILON || 1e-14,
                Tt = (e, t) => t < e.length && !e[t].skip && e[t],
                Pt = e => "x" === e ? "y" : "x";

            function Dt(e, t, n, i) {
                const r = e.skip ? t : e,
                    o = t,
                    a = n.skip ? t : n,
                    s = $(o, r),
                    l = $(a, o);
                let c = s / (s + l),
                    u = l / (s + l);
                c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
                const d = i * c,
                    h = i * u;
                return {
                    previous: {
                        x: o.x - d * (a.x - r.x),
                        y: o.y - d * (a.y - r.y)
                    },
                    next: {
                        x: o.x + h * (a.x - r.x),
                        y: o.y + h * (a.y - r.y)
                    }
                }
            }

            function Lt(e, t = "x") {
                const n = Pt(t),
                    i = e.length,
                    r = Array(i).fill(0),
                    o = Array(i);
                let a, s, l, c = Tt(e, 0);
                for (a = 0; a < i; ++a)
                    if (s = l, l = c, c = Tt(e, a + 1), l) {
                        if (c) {
                            const e = c[t] - l[t];
                            r[a] = 0 !== e ? (c[n] - l[n]) / e : 0
                        }
                        o[a] = s ? c ? B(r[a - 1]) !== B(r[a]) ? 0 : (r[a - 1] + r[a]) / 2 : r[a - 1] : r[a]
                    }!
                function (e, t, n) {
                    const i = e.length;
                    let r, o, a, s, l, c = Tt(e, 0);
                    for (let u = 0; u < i - 1; ++u) l = c, c = Tt(e, u + 1), l && c && (H(t[u], 0, Mt) ? n[u] = n[u + 1] = 0 : (r = n[u] / t[u], o = n[u + 1] / t[u], s = Math.pow(r, 2) + Math.pow(o, 2), s <= 9 || (a = 3 / Math.sqrt(s), n[u] = r * a * t[u], n[u + 1] = o * a * t[u])))
                }(e, r, o),
                function (e, t, n = "x") {
                    const i = Pt(n),
                        r = e.length;
                    let o, a, s, l = Tt(e, 0);
                    for (let c = 0; c < r; ++c) {
                        if (a = s, s = l, l = Tt(e, c + 1), !s) continue;
                        const r = s[n],
                            u = s[i];
                        a && (o = (r - a[n]) / 3, s[`cp1${n}`] = r - o, s[`cp1${i}`] = u - o * t[c]), l && (o = (l[n] - r) / 3, s[`cp2${n}`] = r + o, s[`cp2${i}`] = u + o * t[c])
                    }
                }(e, o, t)
            }

            function Nt(e, t, n) {
                return Math.max(Math.min(e, n), t)
            }

            function jt(e, t, n, i, r) {
                let o, a, s, l;
                if (t.spanGaps && (e = e.filter((e => !e.skip))), "monotone" === t.cubicInterpolationMode) Lt(e, r);
                else {
                    let n = i ? e[e.length - 1] : e[0];
                    for (o = 0, a = e.length; o < a; ++o) s = e[o], l = Dt(n, s, e[Math.min(o + 1, a - (i ? 0 : 1)) % a], t.tension), s.cp1x = l.previous.x, s.cp1y = l.previous.y, s.cp2x = l.next.x, s.cp2y = l.next.y, n = s
                }
                t.capBezierPoints && function (e, t) {
                    let n, i, r, o, a, s = $e(e[0], t);
                    for (n = 0, i = e.length; n < i; ++n) a = o, o = s, s = n < i - 1 && $e(e[n + 1], t), o && (r = e[n], a && (r.cp1x = Nt(r.cp1x, t.left, t.right), r.cp1y = Nt(r.cp1y, t.top, t.bottom)), s && (r.cp2x = Nt(r.cp2x, t.left, t.right), r.cp2y = Nt(r.cp2y, t.top, t.bottom)))
                }(e, n)
            }

            function It() {
                return "undefined" != typeof window && "undefined" != typeof document
            }

            function Rt(e) {
                let t = e.parentNode;
                return t && "[object ShadowRoot]" === t.toString() && (t = t.host), t
            }

            function Ft(e, t, n) {
                let i;
                return "string" == typeof e ? (i = parseInt(e, 10), -1 !== e.indexOf("%") && (i = i / 100 * t.parentNode[n])) : i = e, i
            }
            const Bt = e => window.getComputedStyle(e, null);
            const qt = ["top", "right", "bottom", "left"];

            function zt(e, t, n) {
                const i = {};
                n = n ? "-" + n : "";
                for (let r = 0; r < 4; r++) {
                    const o = qt[r];
                    i[o] = parseFloat(e[t + "-" + o + n]) || 0
                }
                return i.width = i.left + i.right, i.height = i.top + i.bottom, i
            }

            function Ht(e, t) {
                const {
                    canvas: n,
                    currentDevicePixelRatio: i
                } = t, r = Bt(n), o = "border-box" === r.boxSizing, a = zt(r, "padding"), s = zt(r, "border", "width"), {
                    x: l,
                    y: c,
                    box: u
                } = function (e, t) {
                    const n = e.native || e,
                        i = n.touches,
                        r = i && i.length ? i[0] : n,
                        {
                            offsetX: o,
                            offsetY: a
                        } = r;
                    let s, l, c = !1;
                    if (((e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot))(o, a, n.target)) s = o, l = a;
                    else {
                        const e = t.getBoundingClientRect();
                        s = r.clientX - e.left, l = r.clientY - e.top, c = !0
                    }
                    return {
                        x: s,
                        y: l,
                        box: c
                    }
                }(e, n), d = a.left + (u && s.left), h = a.top + (u && s.top);
                let {
                    width: f,
                    height: p
                } = t;
                return o && (f -= a.width + s.width, p -= a.height + s.height), {
                    x: Math.round((l - d) / f * n.width / i),
                    y: Math.round((c - h) / p * n.height / i)
                }
            }
            const Ut = e => Math.round(10 * e) / 10;

            function Vt(e, t, n, i) {
                const r = Bt(e),
                    o = zt(r, "margin"),
                    a = Ft(r.maxWidth, e, "clientWidth") || L,
                    s = Ft(r.maxHeight, e, "clientHeight") || L,
                    l = function (e, t, n) {
                        let i, r;
                        if (void 0 === t || void 0 === n) {
                            const o = Rt(e);
                            if (o) {
                                const e = o.getBoundingClientRect(),
                                    a = Bt(o),
                                    s = zt(a, "border", "width"),
                                    l = zt(a, "padding");
                                t = e.width - l.width - s.width, n = e.height - l.height - s.height, i = Ft(a.maxWidth, o, "clientWidth"), r = Ft(a.maxHeight, o, "clientHeight")
                            } else t = e.clientWidth, n = e.clientHeight
                        }
                        return {
                            width: t,
                            height: n,
                            maxWidth: i || L,
                            maxHeight: r || L
                        }
                    }(e, t, n);
                let {
                    width: c,
                    height: u
                } = l;
                if ("content-box" === r.boxSizing) {
                    const e = zt(r, "border", "width"),
                        t = zt(r, "padding");
                    c -= t.width + e.width, u -= t.height + e.height
                }
                return c = Math.max(0, c - o.width), u = Math.max(0, i ? Math.floor(c / i) : u - o.height), c = Ut(Math.min(c, a, l.maxWidth)), u = Ut(Math.min(u, s, l.maxHeight)), c && !u && (u = Ut(c / 2)), {
                    width: c,
                    height: u
                }
            }

            function Wt(e, t, n) {
                const i = t || 1,
                    r = Math.floor(e.height * i),
                    o = Math.floor(e.width * i);
                e.height = r / i, e.width = o / i;
                const a = e.canvas;
                return a.style && (n || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), (e.currentDevicePixelRatio !== i || a.height !== r || a.width !== o) && (e.currentDevicePixelRatio = i, a.height = r, a.width = o, e.ctx.setTransform(i, 0, 0, i, 0, 0), !0)
            }
            const Yt = function () {
                let e = !1;
                try {
                    const t = {
                        get passive() {
                            return e = !0, !1
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t)
                } catch (e) {}
                return e
            }();

            function $t(e, t) {
                const n = function (e, t) {
                        return Bt(e).getPropertyValue(t)
                    }(e, t),
                    i = n && n.match(/^(\d+)(\.\d+)?px$/);
                return i ? +i[1] : void 0
            }

            function Kt(e, t, n, i) {
                return {
                    x: e.x + n * (t.x - e.x),
                    y: e.y + n * (t.y - e.y)
                }
            }

            function Gt(e, t, n, i) {
                return {
                    x: e.x + n * (t.x - e.x),
                    y: "middle" === i ? n < .5 ? e.y : t.y : "after" === i ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
                }
            }

            function Xt(e, t, n, i) {
                const r = {
                        x: e.cp2x,
                        y: e.cp2y
                    },
                    o = {
                        x: t.cp1x,
                        y: t.cp1y
                    },
                    a = Kt(e, r, n),
                    s = Kt(r, o, n),
                    l = Kt(o, t, n),
                    c = Kt(a, s, n),
                    u = Kt(s, l, n);
                return Kt(c, u, n)
            }
            const Zt = new Map;

            function Qt(e, t, n) {
                return function (e, t) {
                    t = t || {};
                    const n = e + JSON.stringify(t);
                    let i = Zt.get(n);
                    return i || (i = new Intl.NumberFormat(e, t), Zt.set(n, i)), i
                }(t, n).format(e)
            }

            function Jt(e, t, n) {
                return e ? function (e, t) {
                    return {
                        x: n => e + e + t - n,
                        setWidth(e) {
                            t = e
                        },
                        textAlign: e => "center" === e ? e : "right" === e ? "left" : "right",
                        xPlus: (e, t) => e - t,
                        leftForLtr: (e, t) => e - t
                    }
                }(t, n) : {
                    x: e => e,
                    setWidth(e) {},
                    textAlign: e => e,
                    xPlus: (e, t) => e + t,
                    leftForLtr: (e, t) => e
                }
            }

            function en(e, t) {
                let n, i;
                "ltr" !== t && "rtl" !== t || (n = e.canvas.style, i = [n.getPropertyValue("direction"), n.getPropertyPriority("direction")], n.setProperty("direction", t, "important"), e.prevTextDirection = i)
            }

            function tn(e, t) {
                void 0 !== t && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]))
            }

            function nn(e) {
                return "angle" === e ? {
                    between: X,
                    compare: K,
                    normalize: G
                } : {
                    between: (e, t, n) => e >= Math.min(t, n) && e <= Math.max(n, t),
                    compare: (e, t) => e - t,
                    normalize: e => e
                }
            }

            function rn({
                start: e,
                end: t,
                count: n,
                loop: i,
                style: r
            }) {
                return {
                    start: e % n,
                    end: t % n,
                    loop: i && (t - e + 1) % n == 0,
                    style: r
                }
            }

            function on(e, t, n) {
                if (!n) return [e];
                const {
                    property: i,
                    start: r,
                    end: o
                } = n, a = t.length, {
                    compare: s,
                    between: l,
                    normalize: c
                } = nn(i), {
                    start: u,
                    end: d,
                    loop: h,
                    style: f
                } = function (e, t, n) {
                    const {
                        property: i,
                        start: r,
                        end: o
                    } = n, {
                        between: a,
                        normalize: s
                    } = nn(i), l = t.length;
                    let c, u, {
                        start: d,
                        end: h,
                        loop: f
                    } = e;
                    if (f) {
                        for (d += l, h += l, c = 0, u = l; c < u && a(s(t[d % l][i]), r, o); ++c) d--, h--;
                        d %= l, h %= l
                    }
                    return h < d && (h += l), {
                        start: d,
                        end: h,
                        loop: f,
                        style: e.style
                    }
                }(e, t, n), p = [];
                let g, m, v, b = !1,
                    y = null;
                const _ = () => b || l(r, v, g) && 0 !== s(r, v),
                    x = () => !b || 0 === s(o, g) || l(o, v, g);
                for (let e = u, n = u; e <= d; ++e) m = t[e % a], m.skip || (g = c(m[i]), g !== v && (b = l(g, r, o), null === y && _() && (y = 0 === s(g, r) ? e : n), null !== y && x() && (p.push(rn({
                    start: y,
                    end: e,
                    loop: h,
                    count: a,
                    style: f
                })), y = null), n = e, v = g));
                return null !== y && p.push(rn({
                    start: y,
                    end: d,
                    loop: h,
                    count: a,
                    style: f
                })), p
            }

            function an(e, t) {
                const n = [],
                    i = e.segments;
                for (let r = 0; r < i.length; r++) {
                    const o = on(i[r], e.points, t);
                    o.length && n.push(...o)
                }
                return n
            }

            function sn(e, t, n, i) {
                return i && i.setContext && n ? function (e, t, n, i) {
                    const r = ln(e.options),
                        o = n.length,
                        a = [];
                    let s = t[0].start,
                        l = s;
                    for (const c of t) {
                        let t, u = r,
                            d = n[s % o];
                        for (l = s + 1; l <= c.end; l++) {
                            const r = n[l % o];
                            t = ln(i.setContext({
                                type: "segment",
                                p0: d,
                                p1: r,
                                p0DataIndex: (l - 1) % o,
                                p1DataIndex: l % o,
                                datasetIndex: e._datasetIndex
                            })), cn(t, u) && (a.push({
                                start: s,
                                end: l - 1,
                                loop: c.loop,
                                style: u
                            }), u = t, s = l - 1), d = r, u = t
                        }
                        s < l - 1 && (a.push({
                            start: s,
                            end: l - 1,
                            loop: c.loop,
                            style: t
                        }), s = l - 1)
                    }
                    return a
                }(e, t, n, i) : t
            }

            function ln(e) {
                return {
                    backgroundColor: e.backgroundColor,
                    borderCapStyle: e.borderCapStyle,
                    borderDash: e.borderDash,
                    borderDashOffset: e.borderDashOffset,
                    borderJoinStyle: e.borderJoinStyle,
                    borderWidth: e.borderWidth,
                    borderColor: e.borderColor
                }
            }

            function cn(e, t) {
                return t && JSON.stringify(e) !== JSON.stringify(t)
            }
            var un = new class {
                constructor() {
                    this._request = null, this._charts = new Map, this._running = !1, this._lastDate = void 0
                }
                _notify(e, t, n, i) {
                    const r = t.listeners[i],
                        o = t.duration;
                    r.forEach((i => i({
                        chart: e,
                        initial: t.initial,
                        numSteps: o,
                        currentStep: Math.min(n - t.start, o)
                    })))
                }
                _refresh() {
                    const e = this;
                    e._request || (e._running = !0, e._request = i.call(window, (() => {
                        e._update(), e._request = null, e._running && e._refresh()
                    })))
                }
                _update(e = Date.now()) {
                    const t = this;
                    let n = 0;
                    t._charts.forEach(((i, r) => {
                        if (!i.running || !i.items.length) return;
                        const o = i.items;
                        let a, s = o.length - 1,
                            l = !1;
                        for (; s >= 0; --s) a = o[s], a._active ? (a._total > i.duration && (i.duration = a._total), a.tick(e), l = !0) : (o[s] = o[o.length - 1], o.pop());
                        l && (r.draw(), t._notify(r, i, e, "progress")), o.length || (i.running = !1, t._notify(r, i, e, "complete"), i.initial = !1), n += o.length
                    })), t._lastDate = e, 0 === n && (t._running = !1)
                }
                _getAnims(e) {
                    const t = this._charts;
                    let n = t.get(e);
                    return n || (n = {
                        running: !1,
                        initial: !0,
                        items: [],
                        listeners: {
                            complete: [],
                            progress: []
                        }
                    }, t.set(e, n)), n
                }
                listen(e, t, n) {
                    this._getAnims(e).listeners[t].push(n)
                }
                add(e, t) {
                    t && t.length && this._getAnims(e).items.push(...t)
                }
                has(e) {
                    return this._getAnims(e).items.length > 0
                }
                start(e) {
                    const t = this._charts.get(e);
                    t && (t.running = !0, t.start = Date.now(), t.duration = t.items.reduce(((e, t) => Math.max(e, t._duration)), 0), this._refresh())
                }
                running(e) {
                    if (!this._running) return !1;
                    const t = this._charts.get(e);
                    return !!(t && t.running && t.items.length)
                }
                stop(e) {
                    const t = this._charts.get(e);
                    if (!t || !t.items.length) return;
                    const n = t.items;
                    let i = n.length - 1;
                    for (; i >= 0; --i) n[i].cancel();
                    t.items = [], this._notify(e, t, Date.now(), "complete")
                }
                remove(e) {
                    return this._charts.delete(e)
                }
            };
            const dn = "transparent",
                hn = {
                    boolean: (e, t, n) => n > .5 ? t : e,
                    color(e, t, n) {
                        const i = je(e || dn),
                            r = i.valid && je(t || dn);
                        return r && r.valid ? r.mix(i, n).hexString() : t
                    },
                    number: (e, t, n) => e + (t - e) * n
                };
            class fn {
                constructor(e, t, n, i) {
                    const r = t[n];
                    i = ct([e.to, i, r, e.from]);
                    const o = ct([e.from, r, i]);
                    this._active = !0, this._fn = e.fn || hn[e.type || typeof o], this._easing = te[e.easing] || te.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = t, this._prop = n, this._from = o, this._to = i, this._promises = void 0
                }
                active() {
                    return this._active
                }
                update(e, t, n) {
                    const i = this;
                    if (i._active) {
                        i._notify(!1);
                        const r = i._target[i._prop],
                            o = n - i._start,
                            a = i._duration - o;
                        i._start = n, i._duration = Math.floor(Math.max(a, e.duration)), i._total += o, i._loop = !!e.loop, i._to = ct([e.to, t, r, e.from]), i._from = ct([e.from, r, t])
                    }
                }
                cancel() {
                    const e = this;
                    e._active && (e.tick(Date.now()), e._active = !1, e._notify(!1))
                }
                tick(e) {
                    const t = this,
                        n = e - t._start,
                        i = t._duration,
                        r = t._prop,
                        o = t._from,
                        a = t._loop,
                        s = t._to;
                    let l;
                    if (t._active = o !== s && (a || n < i), !t._active) return t._target[r] = s, void t._notify(!0);
                    n < 0 ? t._target[r] = o : (l = n / i % 2, l = a && l > 1 ? 2 - l : l, l = t._easing(Math.min(1, Math.max(0, l))), t._target[r] = t._fn(o, s, l))
                }
                wait() {
                    const e = this._promises || (this._promises = []);
                    return new Promise(((t, n) => {
                        e.push({
                            res: t,
                            rej: n
                        })
                    }))
                }
                _notify(e) {
                    const t = e ? "res" : "rej",
                        n = this._promises || [];
                    for (let e = 0; e < n.length; e++) n[e][t]()
                }
            }
            ze.set("animation", {
                delay: void 0,
                duration: 1e3,
                easing: "easeOutQuart",
                fn: void 0,
                from: void 0,
                loop: void 0,
                to: void 0,
                type: void 0
            });
            const pn = Object.keys(ze.animation);
            ze.describe("animation", {
                _fallback: !1,
                _indexable: !1,
                _scriptable: e => "onProgress" !== e && "onComplete" !== e && "fn" !== e
            }), ze.set("animations", {
                colors: {
                    type: "color",
                    properties: ["color", "borderColor", "backgroundColor"]
                },
                numbers: {
                    type: "number",
                    properties: ["x", "y", "borderWidth", "radius", "tension"]
                }
            }), ze.describe("animations", {
                _fallback: "animation"
            }), ze.set("transitions", {
                active: {
                    animation: {
                        duration: 400
                    }
                },
                resize: {
                    animation: {
                        duration: 0
                    }
                },
                show: {
                    animations: {
                        colors: {
                            from: "transparent"
                        },
                        visible: {
                            type: "boolean",
                            duration: 0
                        }
                    }
                },
                hide: {
                    animations: {
                        colors: {
                            to: "transparent"
                        },
                        visible: {
                            type: "boolean",
                            easing: "linear",
                            fn: e => 0 | e
                        }
                    }
                }
            });
            class gn {
                constructor(e, t) {
                    this._chart = e, this._properties = new Map, this.configure(t)
                }
                configure(e) {
                    if (!d(e)) return;
                    const t = this._properties;
                    Object.getOwnPropertyNames(e).forEach((n => {
                        const i = e[n];
                        if (!d(i)) return;
                        const r = {};
                        for (const e of pn) r[e] = i[e];
                        (u(i.properties) && i.properties || [n]).forEach((e => {
                            e !== n && t.has(e) || t.set(e, r)
                        }))
                    }))
                }
                _animateOptions(e, t) {
                    const n = t.options,
                        i = function (e, t) {
                            if (!t) return;
                            let n = e.options;
                            if (!n) return void(e.options = t);
                            n.$shared && (e.options = n = Object.assign({}, n, {
                                $shared: !1,
                                $animations: {}
                            }));
                            return n
                        }(e, n);
                    if (!i) return [];
                    const r = this._createAnimations(i, n);
                    return n.$shared && function (e, t) {
                        const n = [],
                            i = Object.keys(t);
                        for (let t = 0; t < i.length; t++) {
                            const r = e[i[t]];
                            r && r.active() && n.push(r.wait())
                        }
                        return Promise.all(n)
                    }(e.options.$animations, n).then((() => {
                        e.options = n
                    }), (() => {})), r
                }
                _createAnimations(e, t) {
                    const n = this._properties,
                        i = [],
                        r = e.$animations || (e.$animations = {}),
                        o = Object.keys(t),
                        a = Date.now();
                    let s;
                    for (s = o.length - 1; s >= 0; --s) {
                        const l = o[s];
                        if ("$" === l.charAt(0)) continue;
                        if ("options" === l) {
                            i.push(...this._animateOptions(e, t));
                            continue
                        }
                        const c = t[l];
                        let u = r[l];
                        const d = n.get(l);
                        if (u) {
                            if (d && u.active()) {
                                u.update(d, c, a);
                                continue
                            }
                            u.cancel()
                        }
                        d && d.duration ? (r[l] = u = new fn(d, e, l, c), i.push(u)) : e[l] = c
                    }
                    return i
                }
                update(e, t) {
                    if (0 === this._properties.size) return void Object.assign(e, t);
                    const n = this._createAnimations(e, t);
                    return n.length ? (un.add(this._chart, n), !0) : void 0
                }
            }

            function mn(e, t) {
                const n = e && e.options || {},
                    i = n.reverse,
                    r = void 0 === n.min ? t : 0,
                    o = void 0 === n.max ? t : 0;
                return {
                    start: i ? o : r,
                    end: i ? r : o
                }
            }

            function vn(e, t) {
                const n = [],
                    i = e._getSortedDatasetMetas(t);
                let r, o;
                for (r = 0, o = i.length; r < o; ++r) n.push(i[r].index);
                return n
            }

            function bn(e, t, n, i) {
                const r = e.keys,
                    o = "single" === i.mode;
                let a, s, l, c;
                if (null !== t) {
                    for (a = 0, s = r.length; a < s; ++a) {
                        if (l = +r[a], l === n) {
                            if (i.all) continue;
                            break
                        }
                        c = e.values[l], h(c) && (o || 0 === t || B(t) === B(c)) && (t += c)
                    }
                    return t
                }
            }

            function yn(e, t) {
                const n = e && e.options.stacked;
                return n || void 0 === n && void 0 !== t.stack
            }

            function _n(e, t, n) {
                const i = e[t] || (e[t] = {});
                return i[n] || (i[n] = {})
            }

            function xn(e, t, n) {
                for (const i of t.getMatchingVisibleMetas("bar").reverse()) {
                    const t = e[i.index];
                    if (n && t > 0 || !n && t < 0) return i.index
                }
                return null
            }

            function wn(e, t) {
                const {
                    chart: n,
                    _cachedMeta: i
                } = e, r = n._stacks || (n._stacks = {}), {
                    iScale: o,
                    vScale: a,
                    index: s
                } = i, l = o.axis, c = a.axis, u = function (e, t, n) {
                    return `${e.id}.${t.id}.${n.stack||n.type}`
                }(o, a, i), d = t.length;
                let h;
                for (let e = 0; e < d; ++e) {
                    const n = t[e],
                        {
                            [l]: i,
                            [c]: o
                        } = n;
                    h = (n._stacks || (n._stacks = {}))[c] = _n(r, u, i), h[s] = o, h._top = xn(h, a, !0), h._bottom = xn(h, a, !1)
                }
            }

            function En(e, t) {
                const n = e.scales;
                return Object.keys(n).filter((e => n[e].axis === t)).shift()
            }

            function kn(e, t) {
                const n = e.controller.index,
                    i = e.vScale && e.vScale.axis;
                if (i) {
                    t = t || e._parsed;
                    for (const e of t) {
                        const t = e._stacks;
                        if (!t || void 0 === t[i] || void 0 === t[i][n]) return;
                        delete t[i][n]
                    }
                }
            }
            const On = e => "reset" === e || "none" === e,
                Sn = (e, t) => t ? e : Object.assign({}, e);
            class Cn {
                constructor(e, t) {
                    this.chart = e, this._ctx = e.ctx, this.index = t, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.$context = void 0, this._syncList = [], this.initialize()
                }
                initialize() {
                    const e = this,
                        t = e._cachedMeta;
                    e.configure(), e.linkScales(), t._stacked = yn(t.vScale, t), e.addElements()
                }
                updateIndex(e) {
                    this.index !== e && kn(this._cachedMeta), this.index = e
                }
                linkScales() {
                    const e = this,
                        t = e.chart,
                        n = e._cachedMeta,
                        i = e.getDataset(),
                        r = (e, t, n, i) => "x" === e ? t : "r" === e ? i : n,
                        o = n.xAxisID = p(i.xAxisID, En(t, "x")),
                        a = n.yAxisID = p(i.yAxisID, En(t, "y")),
                        s = n.rAxisID = p(i.rAxisID, En(t, "r")),
                        l = n.indexAxis,
                        c = n.iAxisID = r(l, o, a, s),
                        u = n.vAxisID = r(l, a, o, s);
                    n.xScale = e.getScaleForId(o), n.yScale = e.getScaleForId(a), n.rScale = e.getScaleForId(s), n.iScale = e.getScaleForId(c), n.vScale = e.getScaleForId(u)
                }
                getDataset() {
                    return this.chart.data.datasets[this.index]
                }
                getMeta() {
                    return this.chart.getDatasetMeta(this.index)
                }
                getScaleForId(e) {
                    return this.chart.scales[e]
                }
                _getOtherScale(e) {
                    const t = this._cachedMeta;
                    return e === t.iScale ? t.vScale : t.iScale
                }
                reset() {
                    this._update("reset")
                }
                _destroy() {
                    const e = this._cachedMeta;
                    this._data && pt(this._data, this), e._stacked && kn(e)
                }
                _dataCheck() {
                    const e = this,
                        t = e.getDataset(),
                        n = t.data || (t.data = []),
                        i = e._data;
                    if (d(n)) e._data = function (e) {
                        const t = Object.keys(e),
                            n = new Array(t.length);
                        let i, r, o;
                        for (i = 0, r = t.length; i < r; ++i) o = t[i], n[i] = {
                            x: o,
                            y: e[o]
                        };
                        return n
                    }(n);
                    else if (i !== n) {
                        if (i) {
                            pt(i, e);
                            const t = e._cachedMeta;
                            kn(t), t._parsed = []
                        }
                        n && Object.isExtensible(n) && (o = e, (r = n)._chartjs ? r._chartjs.listeners.push(o) : (Object.defineProperty(r, "_chartjs", {
                            configurable: !0,
                            enumerable: !1,
                            value: {
                                listeners: [o]
                            }
                        }), ft.forEach((e => {
                            const t = "_onData" + C(e),
                                n = r[e];
                            Object.defineProperty(r, e, {
                                configurable: !0,
                                enumerable: !1,
                                value(...e) {
                                    const i = n.apply(this, e);
                                    return r._chartjs.listeners.forEach((n => {
                                        "function" == typeof n[t] && n[t](...e)
                                    })), i
                                }
                            })
                        })))), e._syncList = [], e._data = n
                    }
                    var r, o
                }
                addElements() {
                    const e = this,
                        t = e._cachedMeta;
                    e._dataCheck(), e.datasetElementType && (t.dataset = new e.datasetElementType)
                }
                buildOrUpdateElements(e) {
                    const t = this,
                        n = t._cachedMeta,
                        i = t.getDataset();
                    let r = !1;
                    t._dataCheck();
                    const o = n._stacked;
                    n._stacked = yn(n.vScale, n), n.stack !== i.stack && (r = !0, kn(n), n.stack = i.stack), t._resyncElements(e), (r || o !== n._stacked) && wn(t, n._parsed)
                }
                configure() {
                    const e = this,
                        t = e.chart.config,
                        n = t.datasetScopeKeys(e._type),
                        i = t.getOptionScopes(e.getDataset(), n, !0);
                    e.options = t.createResolver(i, e.getContext()), e._parsing = e.options.parsing
                }
                parse(e, t) {
                    const n = this,
                        {
                            _cachedMeta: i,
                            _data: r
                        } = n,
                        {
                            iScale: o,
                            _stacked: a
                        } = i,
                        s = o.axis;
                    let l, c, h, f = 0 === e && t === r.length || i._sorted,
                        p = e > 0 && i._parsed[e - 1];
                    if (!1 === n._parsing) i._parsed = r, i._sorted = !0, h = r;
                    else {
                        h = u(r[e]) ? n.parseArrayData(i, r, e, t) : d(r[e]) ? n.parseObjectData(i, r, e, t) : n.parsePrimitiveData(i, r, e, t);
                        const o = () => null === c[s] || p && c[s] < p[s];
                        for (l = 0; l < t; ++l) i._parsed[l + e] = c = h[l], f && (o() && (f = !1), p = c);
                        i._sorted = f
                    }
                    a && wn(n, h)
                }
                parsePrimitiveData(e, t, n, i) {
                    const {
                        iScale: r,
                        vScale: o
                    } = e, a = r.axis, s = o.axis, l = r.getLabels(), c = r === o, u = new Array(i);
                    let d, h, f;
                    for (d = 0, h = i; d < h; ++d) f = d + n, u[d] = {
                        [a]: c || r.parse(l[f], f),
                        [s]: o.parse(t[f], f)
                    };
                    return u
                }
                parseArrayData(e, t, n, i) {
                    const {
                        xScale: r,
                        yScale: o
                    } = e, a = new Array(i);
                    let s, l, c, u;
                    for (s = 0, l = i; s < l; ++s) c = s + n, u = t[c], a[s] = {
                        x: r.parse(u[0], c),
                        y: o.parse(u[1], c)
                    };
                    return a
                }
                parseObjectData(e, t, n, i) {
                    const {
                        xScale: r,
                        yScale: o
                    } = e, {
                        xAxisKey: a = "x",
                        yAxisKey: s = "y"
                    } = this._parsing, l = new Array(i);
                    let c, u, d, h;
                    for (c = 0, u = i; c < u; ++c) d = c + n, h = t[d], l[c] = {
                        x: r.parse(S(h, a), d),
                        y: o.parse(S(h, s), d)
                    };
                    return l
                }
                getParsed(e) {
                    return this._cachedMeta._parsed[e]
                }
                getDataElement(e) {
                    return this._cachedMeta.data[e]
                }
                applyStack(e, t, n) {
                    const i = this.chart,
                        r = this._cachedMeta,
                        o = t[e.axis];
                    return bn({
                        keys: vn(i, !0),
                        values: t._stacks[e.axis]
                    }, o, r.index, {
                        mode: n
                    })
                }
                updateRangeFromParsed(e, t, n, i) {
                    const r = n[t.axis];
                    let o = null === r ? NaN : r;
                    const a = i && n._stacks[t.axis];
                    i && a && (i.values = a, e.min = Math.min(e.min, o), e.max = Math.max(e.max, o), o = bn(i, r, this._cachedMeta.index, {
                        all: !0
                    })), e.min = Math.min(e.min, o), e.max = Math.max(e.max, o)
                }
                getMinMax(e, t) {
                    const n = this,
                        i = n._cachedMeta,
                        r = i._parsed,
                        o = i._sorted && e === i.iScale,
                        a = r.length,
                        s = n._getOtherScale(e),
                        l = t && i._stacked && {
                            keys: vn(n.chart, !0),
                            values: null
                        },
                        c = {
                            min: Number.POSITIVE_INFINITY,
                            max: Number.NEGATIVE_INFINITY
                        },
                        {
                            min: u,
                            max: d
                        } = function (e) {
                            const {
                                min: t,
                                max: n,
                                minDefined: i,
                                maxDefined: r
                            } = e.getUserBounds();
                            return {
                                min: i ? t : Number.NEGATIVE_INFINITY,
                                max: r ? n : Number.POSITIVE_INFINITY
                            }
                        }(s);
                    let f, p, g, m;

                    function v() {
                        return g = r[f], p = g[e.axis], m = g[s.axis], !h(p) || u > m || d < m
                    }
                    for (f = 0; f < a && (v() || (n.updateRangeFromParsed(c, e, g, l), !o)); ++f);
                    if (o)
                        for (f = a - 1; f >= 0; --f)
                            if (!v()) {
                                n.updateRangeFromParsed(c, e, g, l);
                                break
                            } return c
                }
                getAllParsedValues(e) {
                    const t = this._cachedMeta._parsed,
                        n = [];
                    let i, r, o;
                    for (i = 0, r = t.length; i < r; ++i) o = t[i][e.axis], h(o) && n.push(o);
                    return n
                }
                getMaxOverflow() {
                    return !1
                }
                getLabelAndValue(e) {
                    const t = this._cachedMeta,
                        n = t.iScale,
                        i = t.vScale,
                        r = this.getParsed(e);
                    return {
                        label: n ? "" + n.getLabelForValue(r[n.axis]) : "",
                        value: i ? "" + i.getLabelForValue(r[i.axis]) : ""
                    }
                }
                _update(e) {
                    const t = this,
                        n = t._cachedMeta;
                    t.configure(), t._cachedDataOpts = {}, t.update(e || "default"), n._clip = function (e) {
                        let t, n, i, r;
                        return d(e) ? (t = e.top, n = e.right, i = e.bottom, r = e.left) : t = n = i = r = e, {
                            top: t,
                            right: n,
                            bottom: i,
                            left: r,
                            disabled: !1 === e
                        }
                    }(p(t.options.clip, function (e, t, n) {
                        if (!1 === n) return !1;
                        const i = mn(e, n),
                            r = mn(t, n);
                        return {
                            top: r.end,
                            right: i.end,
                            bottom: r.start,
                            left: i.start
                        }
                    }(n.xScale, n.yScale, t.getMaxOverflow())))
                }
                update(e) {}
                draw() {
                    const e = this,
                        t = e._ctx,
                        n = e.chart,
                        i = e._cachedMeta,
                        r = i.data || [],
                        o = n.chartArea,
                        a = [],
                        s = e._drawStart || 0,
                        l = e._drawCount || r.length - s;
                    let c;
                    for (i.dataset && i.dataset.draw(t, o, s, l), c = s; c < s + l; ++c) {
                        const e = r[c];
                        e.hidden || (e.active ? a.push(e) : e.draw(t, o))
                    }
                    for (c = 0; c < a.length; ++c) a[c].draw(t, o)
                }
                getStyle(e, t) {
                    const n = t ? "active" : "default";
                    return void 0 === e && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(e || 0, n)
                }
                getContext(e, t, n) {
                    const i = this,
                        r = i.getDataset();
                    let o;
                    if (e >= 0 && e < i._cachedMeta.data.length) {
                        const t = i._cachedMeta.data[e];
                        o = t.$context || (t.$context = function (e, t, n) {
                            return Object.assign(Object.create(e), {
                                active: !1,
                                dataIndex: t,
                                parsed: void 0,
                                raw: void 0,
                                element: n,
                                index: t,
                                mode: "default",
                                type: "data"
                            })
                        }(i.getContext(), e, t)), o.parsed = i.getParsed(e), o.raw = r.data[e], o.index = o.dataIndex = e
                    } else o = i.$context || (i.$context = function (e, t) {
                        return Object.assign(Object.create(e), {
                            active: !1,
                            dataset: void 0,
                            datasetIndex: t,
                            index: t,
                            mode: "default",
                            type: "dataset"
                        })
                    }(i.chart.getContext(), i.index)), o.dataset = r, o.index = o.datasetIndex = i.index;
                    return o.active = !!t, o.mode = n, o
                }
                resolveDatasetElementOptions(e) {
                    return this._resolveElementOptions(this.datasetElementType.id, e)
                }
                resolveDataElementOptions(e, t) {
                    return this._resolveElementOptions(this.dataElementType.id, t, e)
                }
                _resolveElementOptions(e, t = "default", n) {
                    const i = this,
                        r = "active" === t,
                        o = i._cachedDataOpts,
                        a = e + "-" + t,
                        s = o[a],
                        l = i.enableOptionSharing && A(n);
                    if (s) return Sn(s, l);
                    const c = i.chart.config,
                        u = c.datasetElementScopeKeys(i._type, e),
                        d = r ? [`${e}Hover`, "hover", e, ""] : [e, ""],
                        h = c.getOptionScopes(i.getDataset(), u),
                        f = Object.keys(ze.elements[e]),
                        p = c.resolveNamedOptions(h, f, (() => i.getContext(n, r)), d);
                    return p.$shared && (p.$shared = l, o[a] = Object.freeze(Sn(p, l))), p
                }
                _resolveAnimations(e, t, n) {
                    const i = this,
                        r = i.chart,
                        o = i._cachedDataOpts,
                        a = `animation-${t}`,
                        s = o[a];
                    if (s) return s;
                    let l;
                    if (!1 !== r.options.animation) {
                        const r = i.chart.config,
                            o = r.datasetAnimationScopeKeys(i._type, t),
                            a = r.getOptionScopes(i.getDataset(), o);
                        l = r.createResolver(a, i.getContext(e, n, t))
                    }
                    const c = new gn(r, l && l.animations);
                    return l && l._cacheable && (o[a] = Object.freeze(c)), c
                }
                getSharedOptions(e) {
                    if (e.$shared) return this._sharedOptions || (this._sharedOptions = Object.assign({}, e))
                }
                includeOptions(e, t) {
                    return !t || On(e) || this.chart._animationsDisabled
                }
                updateElement(e, t, n, i) {
                    On(i) ? Object.assign(e, n) : this._resolveAnimations(t, i).update(e, n)
                }
                updateSharedOptions(e, t, n) {
                    e && !On(t) && this._resolveAnimations(void 0, t).update(e, n)
                }
                _setStyle(e, t, n, i) {
                    e.active = i;
                    const r = this.getStyle(t, i);
                    this._resolveAnimations(t, n, i).update(e, {
                        options: !i && this.getSharedOptions(r) || r
                    })
                }
                removeHoverStyle(e, t, n) {
                    this._setStyle(e, n, "active", !1)
                }
                setHoverStyle(e, t, n) {
                    this._setStyle(e, n, "active", !0)
                }
                _removeDatasetHoverStyle() {
                    const e = this._cachedMeta.dataset;
                    e && this._setStyle(e, void 0, "active", !1)
                }
                _setDatasetHoverStyle() {
                    const e = this._cachedMeta.dataset;
                    e && this._setStyle(e, void 0, "active", !0)
                }
                _resyncElements(e) {
                    const t = this,
                        n = t._data,
                        i = t._cachedMeta.data;
                    for (const [e, n, i] of t._syncList) t[e](n, i);
                    t._syncList = [];
                    const r = i.length,
                        o = n.length,
                        a = Math.min(o, r);
                    a && t.parse(0, a), o > r ? t._insertElements(r, o - r, e) : o < r && t._removeElements(o, r - o)
                }
                _insertElements(e, t, n = !0) {
                    const i = this,
                        r = i._cachedMeta,
                        o = r.data,
                        a = e + t;
                    let s;
                    const l = e => {
                        for (e.length += t, s = e.length - 1; s >= a; s--) e[s] = e[s - t]
                    };
                    for (l(o), s = e; s < a; ++s) o[s] = new i.dataElementType;
                    i._parsing && l(r._parsed), i.parse(e, t), n && i.updateElements(o, e, t, "reset")
                }
                updateElements(e, t, n, i) {}
                _removeElements(e, t) {
                    const n = this._cachedMeta;
                    if (this._parsing) {
                        const i = n._parsed.splice(e, t);
                        n._stacked && kn(n, i)
                    }
                    n.data.splice(e, t)
                }
                _sync(e) {
                    if (this._parsing) this._syncList.push(e);
                    else {
                        const [t, n, i] = e;
                        this[t](n, i)
                    }
                }
                _onDataPush() {
                    const e = arguments.length;
                    this._sync(["_insertElements", this.getDataset().data.length - e, e])
                }
                _onDataPop() {
                    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1])
                }
                _onDataShift() {
                    this._sync(["_removeElements", 0, 1])
                }
                _onDataSplice(e, t) {
                    this._sync(["_removeElements", e, t]), this._sync(["_insertElements", e, arguments.length - 2])
                }
                _onDataUnshift() {
                    this._sync(["_insertElements", 0, arguments.length])
                }
            }

            function An(e) {
                const t = function (e) {
                    if (!e._cache.$bar) {
                        const t = e.getMatchingVisibleMetas("bar");
                        let n = [];
                        for (let i = 0, r = t.length; i < r; i++) n = n.concat(t[i].controller.getAllParsedValues(e));
                        e._cache.$bar = gt(n.sort(((e, t) => e - t)))
                    }
                    return e._cache.$bar
                }(e);
                let n, i, r, o, a = e._length;
                const s = () => {
                    32767 !== r && -32768 !== r && (A(o) && (a = Math.min(a, Math.abs(r - o) || a)), o = r)
                };
                for (n = 0, i = t.length; n < i; ++n) r = e.getPixelForValue(t[n]), s();
                for (o = void 0, n = 0, i = e.ticks.length; n < i; ++n) r = e.getPixelForTick(n), s();
                return a
            }

            function Mn(e, t, n, i) {
                return u(e) ? function (e, t, n, i) {
                    const r = n.parse(e[0], i),
                        o = n.parse(e[1], i),
                        a = Math.min(r, o),
                        s = Math.max(r, o);
                    let l = a,
                        c = s;
                    Math.abs(a) > Math.abs(s) && (l = s, c = a), t[n.axis] = c, t._custom = {
                        barStart: l,
                        barEnd: c,
                        start: r,
                        end: o,
                        min: a,
                        max: s
                    }
                }(e, t, n, i) : t[n.axis] = n.parse(e, i), t
            }

            function Tn(e, t, n, i) {
                const r = e.iScale,
                    o = e.vScale,
                    a = r.getLabels(),
                    s = r === o,
                    l = [];
                let c, u, d, h;
                for (c = n, u = n + i; c < u; ++c) h = t[c], d = {}, d[r.axis] = s || r.parse(a[c], c), l.push(Mn(h, d, o, c));
                return l
            }

            function Pn(e) {
                return e && void 0 !== e.barStart && void 0 !== e.barEnd
            }

            function Dn(e, t, n, i) {
                let r = t.borderSkipped;
                const o = {};
                if (!r) return void(e.borderSkipped = o);
                const {
                    start: a,
                    end: s,
                    reverse: l,
                    top: c,
                    bottom: u
                } = function (e) {
                    let t, n, i, r, o;
                    return e.horizontal ? (t = e.base > e.x, n = "left", i = "right") : (t = e.base < e.y, n = "bottom", i = "top"), t ? (r = "end", o = "start") : (r = "start", o = "end"), {
                        start: n,
                        end: i,
                        reverse: t,
                        top: r,
                        bottom: o
                    }
                }(e);
                "middle" === r && n && (e.enableBorderRadius = !0, (n._top || 0) === i ? r = c : (n._bottom || 0) === i ? r = u : (o[Ln(u, a, s, l)] = !0, r = c)), o[Ln(r, a, s, l)] = !0, e.borderSkipped = o
            }

            function Ln(e, t, n, i) {
                var r, o, a;
                return i ? (a = n, e = Nn(e = (r = e) === (o = t) ? a : r === a ? o : r, n, t)) : e = Nn(e, t, n), e
            }

            function Nn(e, t, n) {
                return "start" === e ? t : "end" === e ? n : e
            }
            Cn.defaults = {}, Cn.prototype.datasetElementType = null, Cn.prototype.dataElementType = null;
            class jn extends Cn {
                parsePrimitiveData(e, t, n, i) {
                    return Tn(e, t, n, i)
                }
                parseArrayData(e, t, n, i) {
                    return Tn(e, t, n, i)
                }
                parseObjectData(e, t, n, i) {
                    const {
                        iScale: r,
                        vScale: o
                    } = e, {
                        xAxisKey: a = "x",
                        yAxisKey: s = "y"
                    } = this._parsing, l = "x" === r.axis ? a : s, c = "x" === o.axis ? a : s, u = [];
                    let d, h, f, p;
                    for (d = n, h = n + i; d < h; ++d) p = t[d], f = {}, f[r.axis] = r.parse(S(p, l), d), u.push(Mn(S(p, c), f, o, d));
                    return u
                }
                updateRangeFromParsed(e, t, n, i) {
                    super.updateRangeFromParsed(e, t, n, i);
                    const r = n._custom;
                    r && t === this._cachedMeta.vScale && (e.min = Math.min(e.min, r.min), e.max = Math.max(e.max, r.max))
                }
                getMaxOverflow() {
                    return 0
                }
                getLabelAndValue(e) {
                    const t = this._cachedMeta,
                        {
                            iScale: n,
                            vScale: i
                        } = t,
                        r = this.getParsed(e),
                        o = r._custom,
                        a = Pn(o) ? "[" + o.start + ", " + o.end + "]" : "" + i.getLabelForValue(r[i.axis]);
                    return {
                        label: "" + n.getLabelForValue(r[n.axis]),
                        value: a
                    }
                }
                initialize() {
                    const e = this;
                    e.enableOptionSharing = !0, super.initialize();
                    e._cachedMeta.stack = e.getDataset().stack
                }
                update(e) {
                    const t = this._cachedMeta;
                    this.updateElements(t.data, 0, t.data.length, e)
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = "reset" === i,
                        {
                            index: a,
                            _cachedMeta: {
                                vScale: s
                            }
                        } = r,
                        l = s.getBasePixel(),
                        u = s.isHorizontal(),
                        d = r._getRuler(),
                        h = r.resolveDataElementOptions(t, i),
                        f = r.getSharedOptions(h),
                        p = r.includeOptions(i, f);
                    r.updateSharedOptions(f, i, h);
                    for (let h = t; h < t + n; h++) {
                        const t = r.getParsed(h),
                            n = o || c(t[s.axis]) ? {
                                base: l,
                                head: l
                            } : r._calculateBarValuePixels(h),
                            g = r._calculateBarIndexPixels(h, d),
                            m = (t._stacks || {})[s.axis],
                            v = {
                                horizontal: u,
                                base: n.base,
                                enableBorderRadius: !m || Pn(t._custom) || a === m._top || a === m._bottom,
                                x: u ? n.head : g.center,
                                y: u ? g.center : n.head,
                                height: u ? g.size : Math.abs(n.size),
                                width: u ? Math.abs(n.size) : g.size
                            };
                        p && (v.options = f || r.resolveDataElementOptions(h, e[h].active ? "active" : i)), Dn(v, v.options || e[h].options, m, a), r.updateElement(e[h], h, v, i)
                    }
                }
                _getStacks(e, t) {
                    const n = this._cachedMeta.iScale,
                        i = n.getMatchingVisibleMetas(this._type),
                        r = n.options.stacked,
                        o = i.length,
                        a = [];
                    let s, l;
                    for (s = 0; s < o; ++s)
                        if (l = i[s], l.controller.options.grouped) {
                            if (void 0 !== t) {
                                const e = l.controller.getParsed(t)[l.controller._cachedMeta.vScale.axis];
                                if (c(e) || isNaN(e)) continue
                            }
                            if ((!1 === r || -1 === a.indexOf(l.stack) || void 0 === r && void 0 === l.stack) && a.push(l.stack), l.index === e) break
                        } return a.length || a.push(void 0), a
                }
                _getStackCount(e) {
                    return this._getStacks(void 0, e).length
                }
                _getStackIndex(e, t, n) {
                    const i = this._getStacks(e, n),
                        r = void 0 !== t ? i.indexOf(t) : -1;
                    return -1 === r ? i.length - 1 : r
                }
                _getRuler() {
                    const e = this,
                        t = e.options,
                        n = e._cachedMeta,
                        i = n.iScale,
                        r = [];
                    let o, a;
                    for (o = 0, a = n.data.length; o < a; ++o) r.push(i.getPixelForValue(e.getParsed(o)[i.axis], o));
                    const s = t.barThickness;
                    return {
                        min: s || An(i),
                        pixels: r,
                        start: i._startPixel,
                        end: i._endPixel,
                        stackCount: e._getStackCount(),
                        scale: i,
                        grouped: t.grouped,
                        ratio: s ? 1 : t.categoryPercentage * t.barPercentage
                    }
                }
                _calculateBarValuePixels(e) {
                    const t = this,
                        {
                            _cachedMeta: {
                                vScale: n,
                                _stacked: i
                            },
                            options: {
                                base: r,
                                minBarLength: o
                            }
                        } = t,
                        a = r || 0,
                        s = t.getParsed(e),
                        l = s._custom,
                        u = Pn(l);
                    let d, h, f = s[n.axis],
                        p = 0,
                        g = i ? t.applyStack(n, s, i) : f;
                    g !== f && (p = g - f, g = f), u && (f = l.barStart, g = l.barEnd - l.barStart, 0 !== f && B(f) !== B(l.barEnd) && (p = 0), p += f);
                    const m = c(r) || u ? p : r;
                    let v = n.getPixelForValue(m);
                    if (d = t.chart.getDataVisibility(e) ? n.getPixelForValue(p + g) : v, h = d - v, Math.abs(h) < o && (h = function (e, t, n) {
                            return 0 !== e ? B(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1)
                        }(h, n, a) * o, f === a && (v -= h / 2), d = v + h), v === n.getPixelForValue(a)) {
                        const e = B(h) * n.getLineWidthForValue(a) / 2;
                        v += e, h -= e
                    }
                    return {
                        size: h,
                        base: v,
                        head: d,
                        center: d + h / 2
                    }
                }
                _calculateBarIndexPixels(e, t) {
                    const n = this,
                        i = t.scale,
                        r = n.options,
                        o = r.skipNull,
                        a = p(r.maxBarThickness, 1 / 0);
                    let s, l;
                    if (t.grouped) {
                        const i = o ? n._getStackCount(e) : t.stackCount,
                            u = "flex" === r.barThickness ? function (e, t, n, i) {
                                const r = t.pixels,
                                    o = r[e];
                                let a = e > 0 ? r[e - 1] : null,
                                    s = e < r.length - 1 ? r[e + 1] : null;
                                const l = n.categoryPercentage;
                                null === a && (a = o - (null === s ? t.end - t.start : s - o)), null === s && (s = o + o - a);
                                const c = o - (o - Math.min(a, s)) / 2 * l;
                                return {
                                    chunk: Math.abs(s - a) / 2 * l / i,
                                    ratio: n.barPercentage,
                                    start: c
                                }
                            }(e, t, r, i) : function (e, t, n, i) {
                                const r = n.barThickness;
                                let o, a;
                                return c(r) ? (o = t.min * n.categoryPercentage, a = n.barPercentage) : (o = r * i, a = 1), {
                                    chunk: o / i,
                                    ratio: a,
                                    start: t.pixels[e] - o / 2
                                }
                            }(e, t, r, i),
                            d = n._getStackIndex(n.index, n._cachedMeta.stack, o ? e : void 0);
                        s = u.start + u.chunk * d + u.chunk / 2, l = Math.min(a, u.chunk * u.ratio)
                    } else s = i.getPixelForValue(n.getParsed(e)[i.axis], e), l = Math.min(a, t.min * t.ratio);
                    return {
                        base: s - l / 2,
                        head: s + l / 2,
                        center: s,
                        size: l
                    }
                }
                draw() {
                    const e = this,
                        t = e._cachedMeta,
                        n = t.vScale,
                        i = t.data,
                        r = i.length;
                    let o = 0;
                    for (; o < r; ++o) null !== e.getParsed(o)[n.axis] && i[o].draw(e._ctx)
                }
            }
            jn.id = "bar", jn.defaults = {
                datasetElementType: !1,
                dataElementType: "bar",
                categoryPercentage: .8,
                barPercentage: .9,
                grouped: !0,
                animations: {
                    numbers: {
                        type: "number",
                        properties: ["x", "y", "base", "width", "height"]
                    }
                }
            }, jn.overrides = {
                scales: {
                    _index_: {
                        type: "category",
                        offset: !0,
                        grid: {
                            offset: !0
                        }
                    },
                    _value_: {
                        type: "linear",
                        beginAtZero: !0
                    }
                }
            };
            class In extends Cn {
                initialize() {
                    this.enableOptionSharing = !0, super.initialize()
                }
                parseObjectData(e, t, n, i) {
                    const {
                        xScale: r,
                        yScale: o
                    } = e, {
                        xAxisKey: a = "x",
                        yAxisKey: s = "y"
                    } = this._parsing, l = [];
                    let c, u, d;
                    for (c = n, u = n + i; c < u; ++c) d = t[c], l.push({
                        x: r.parse(S(d, a), c),
                        y: o.parse(S(d, s), c),
                        _custom: d && d.r && +d.r
                    });
                    return l
                }
                getMaxOverflow() {
                    const {
                        data: e,
                        _parsed: t
                    } = this._cachedMeta;
                    let n = 0;
                    for (let i = e.length - 1; i >= 0; --i) n = Math.max(n, e[i].size() / 2, t[i]._custom);
                    return n > 0 && n
                }
                getLabelAndValue(e) {
                    const t = this._cachedMeta,
                        {
                            xScale: n,
                            yScale: i
                        } = t,
                        r = this.getParsed(e),
                        o = n.getLabelForValue(r.x),
                        a = i.getLabelForValue(r.y),
                        s = r._custom;
                    return {
                        label: t.label,
                        value: "(" + o + ", " + a + (s ? ", " + s : "") + ")"
                    }
                }
                update(e) {
                    const t = this._cachedMeta.data;
                    this.updateElements(t, 0, t.length, e)
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = "reset" === i,
                        {
                            iScale: a,
                            vScale: s
                        } = r._cachedMeta,
                        l = r.resolveDataElementOptions(t, i),
                        c = r.getSharedOptions(l),
                        u = r.includeOptions(i, c),
                        d = a.axis,
                        h = s.axis;
                    for (let l = t; l < t + n; l++) {
                        const t = e[l],
                            n = !o && r.getParsed(l),
                            c = {},
                            f = c[d] = o ? a.getPixelForDecimal(.5) : a.getPixelForValue(n[d]),
                            p = c[h] = o ? s.getBasePixel() : s.getPixelForValue(n[h]);
                        c.skip = isNaN(f) || isNaN(p), u && (c.options = r.resolveDataElementOptions(l, t.active ? "active" : i), o && (c.options.radius = 0)), r.updateElement(t, l, c, i)
                    }
                    r.updateSharedOptions(c, i, l)
                }
                resolveDataElementOptions(e, t) {
                    const n = this.getParsed(e);
                    let i = super.resolveDataElementOptions(e, t);
                    i.$shared && (i = Object.assign({}, i, {
                        $shared: !1
                    }));
                    const r = i.radius;
                    return "active" !== t && (i.radius = 0), i.radius += p(n && n._custom, r), i
                }
            }
            In.id = "bubble", In.defaults = {
                datasetElementType: !1,
                dataElementType: "point",
                animations: {
                    numbers: {
                        type: "number",
                        properties: ["x", "y", "borderWidth", "radius"]
                    }
                }
            }, In.overrides = {
                scales: {
                    x: {
                        type: "linear"
                    },
                    y: {
                        type: "linear"
                    }
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            title: () => ""
                        }
                    }
                }
            };
            class Rn extends Cn {
                constructor(e, t) {
                    super(e, t), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0
                }
                linkScales() {}
                parse(e, t) {
                    const n = this.getDataset().data,
                        i = this._cachedMeta;
                    let r, o;
                    for (r = e, o = e + t; r < o; ++r) i._parsed[r] = +n[r]
                }
                _getRotation() {
                    return V(this.options.rotation - 90)
                }
                _getCircumference() {
                    return V(this.options.circumference)
                }
                _getRotationExtents() {
                    let e = P,
                        t = -P;
                    const n = this;
                    for (let i = 0; i < n.chart.data.datasets.length; ++i)
                        if (n.chart.isDatasetVisible(i)) {
                            const r = n.chart.getDatasetMeta(i).controller,
                                o = r._getRotation(),
                                a = r._getCircumference();
                            e = Math.min(e, o), t = Math.max(t, o + a)
                        } return {
                        rotation: e,
                        circumference: t - e
                    }
                }
                update(e) {
                    const t = this,
                        n = t.chart,
                        {
                            chartArea: i
                        } = n,
                        r = t._cachedMeta,
                        o = r.data,
                        a = t.getMaxBorderWidth() + t.getMaxOffset(o) + t.options.spacing,
                        s = Math.max((Math.min(i.width, i.height) - a) / 2, 0),
                        l = Math.min((c = t.options.cutout, u = s, "string" == typeof c && c.endsWith("%") ? parseFloat(c) / 100 : c / u), 1);
                    var c, u;
                    const d = t._getRingWeight(t.index),
                        {
                            circumference: h,
                            rotation: f
                        } = t._getRotationExtents(),
                        {
                            ratioX: p,
                            ratioY: m,
                            offsetX: v,
                            offsetY: b
                        } = function (e, t, n) {
                            let i = 1,
                                r = 1,
                                o = 0,
                                a = 0;
                            if (t < P) {
                                const s = e,
                                    l = s + t,
                                    c = Math.cos(s),
                                    u = Math.sin(s),
                                    d = Math.cos(l),
                                    h = Math.sin(l),
                                    f = (e, t, i) => X(e, s, l, !0) ? 1 : Math.max(t, t * n, i, i * n),
                                    p = (e, t, i) => X(e, s, l, !0) ? -1 : Math.min(t, t * n, i, i * n),
                                    g = f(0, c, d),
                                    m = f(j, u, h),
                                    v = p(T, c, d),
                                    b = p(T + j, u, h);
                                i = (g - v) / 2, r = (m - b) / 2, o = -(g + v) / 2, a = -(m + b) / 2
                            }
                            return {
                                ratioX: i,
                                ratioY: r,
                                offsetX: o,
                                offsetY: a
                            }
                        }(f, h, l),
                        y = (i.width - a) / p,
                        _ = (i.height - a) / m,
                        x = Math.max(Math.min(y, _) / 2, 0),
                        w = g(t.options.radius, x),
                        E = (w - Math.max(w * l, 0)) / t._getVisibleDatasetWeightTotal();
                    t.offsetX = v * w, t.offsetY = b * w, r.total = t.calculateTotal(), t.outerRadius = w - E * t._getRingWeightOffset(t.index), t.innerRadius = Math.max(t.outerRadius - E * d, 0), t.updateElements(o, 0, o.length, e)
                }
                _circumference(e, t) {
                    const n = this,
                        i = n.options,
                        r = n._cachedMeta,
                        o = n._getCircumference();
                    return t && i.animation.animateRotate || !this.chart.getDataVisibility(e) || null === r._parsed[e] || r.data[e].hidden ? 0 : n.calculateCircumference(r._parsed[e] * o / P)
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = "reset" === i,
                        a = r.chart,
                        s = a.chartArea,
                        l = a.options.animation,
                        c = (s.left + s.right) / 2,
                        u = (s.top + s.bottom) / 2,
                        d = o && l.animateScale,
                        h = d ? 0 : r.innerRadius,
                        f = d ? 0 : r.outerRadius,
                        p = r.resolveDataElementOptions(t, i),
                        g = r.getSharedOptions(p),
                        m = r.includeOptions(i, g);
                    let v, b = r._getRotation();
                    for (v = 0; v < t; ++v) b += r._circumference(v, o);
                    for (v = t; v < t + n; ++v) {
                        const t = r._circumference(v, o),
                            n = e[v],
                            a = {
                                x: c + r.offsetX,
                                y: u + r.offsetY,
                                startAngle: b,
                                endAngle: b + t,
                                circumference: t,
                                outerRadius: f,
                                innerRadius: h
                            };
                        m && (a.options = g || r.resolveDataElementOptions(v, n.active ? "active" : i)), b += t, r.updateElement(n, v, a, i)
                    }
                    r.updateSharedOptions(g, i, p)
                }
                calculateTotal() {
                    const e = this._cachedMeta,
                        t = e.data;
                    let n, i = 0;
                    for (n = 0; n < t.length; n++) {
                        const r = e._parsed[n];
                        null === r || isNaN(r) || !this.chart.getDataVisibility(n) || t[n].hidden || (i += Math.abs(r))
                    }
                    return i
                }
                calculateCircumference(e) {
                    const t = this._cachedMeta.total;
                    return t > 0 && !isNaN(e) ? P * (Math.abs(e) / t) : 0
                }
                getLabelAndValue(e) {
                    const t = this._cachedMeta,
                        n = this.chart,
                        i = n.data.labels || [],
                        r = Qt(t._parsed[e], n.options.locale);
                    return {
                        label: i[e] || "",
                        value: r
                    }
                }
                getMaxBorderWidth(e) {
                    const t = this;
                    let n = 0;
                    const i = t.chart;
                    let r, o, a, s, l;
                    if (!e)
                        for (r = 0, o = i.data.datasets.length; r < o; ++r)
                            if (i.isDatasetVisible(r)) {
                                a = i.getDatasetMeta(r), e = a.data, s = a.controller, s !== t && s.configure();
                                break
                            } if (!e) return 0;
                    for (r = 0, o = e.length; r < o; ++r) l = s.resolveDataElementOptions(r), "inner" !== l.borderAlign && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
                    return n
                }
                getMaxOffset(e) {
                    let t = 0;
                    for (let n = 0, i = e.length; n < i; ++n) {
                        const e = this.resolveDataElementOptions(n);
                        t = Math.max(t, e.offset || 0, e.hoverOffset || 0)
                    }
                    return t
                }
                _getRingWeightOffset(e) {
                    let t = 0;
                    for (let n = 0; n < e; ++n) this.chart.isDatasetVisible(n) && (t += this._getRingWeight(n));
                    return t
                }
                _getRingWeight(e) {
                    return Math.max(p(this.chart.data.datasets[e].weight, 1), 0)
                }
                _getVisibleDatasetWeightTotal() {
                    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1
                }
            }
            Rn.id = "doughnut", Rn.defaults = {
                datasetElementType: !1,
                dataElementType: "arc",
                animation: {
                    animateRotate: !0,
                    animateScale: !1
                },
                animations: {
                    numbers: {
                        type: "number",
                        properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
                    }
                },
                cutout: "50%",
                rotation: 0,
                circumference: 360,
                radius: "100%",
                spacing: 0,
                indexAxis: "r"
            }, Rn.descriptors = {
                _scriptable: e => "spacing" !== e,
                _indexable: e => "spacing" !== e
            }, Rn.overrides = {
                aspectRatio: 1,
                plugins: {
                    legend: {
                        labels: {
                            generateLabels(e) {
                                const t = e.data;
                                if (t.labels.length && t.datasets.length) {
                                    const {
                                        labels: {
                                            pointStyle: n
                                        }
                                    } = e.legend.options;
                                    return t.labels.map(((t, i) => {
                                        const r = e.getDatasetMeta(0).controller.getStyle(i);
                                        return {
                                            text: t,
                                            fillStyle: r.backgroundColor,
                                            strokeStyle: r.borderColor,
                                            lineWidth: r.borderWidth,
                                            pointStyle: n,
                                            hidden: !e.getDataVisibility(i),
                                            index: i
                                        }
                                    }))
                                }
                                return []
                            }
                        },
                        onClick(e, t, n) {
                            n.chart.toggleDataVisibility(t.index), n.chart.update()
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: () => "",
                            label(e) {
                                let t = e.label;
                                const n = ": " + e.formattedValue;
                                return u(t) ? (t = t.slice(), t[0] += n) : t += n, t
                            }
                        }
                    }
                }
            };
            class Fn extends Cn {
                initialize() {
                    this.enableOptionSharing = !0, super.initialize()
                }
                update(e) {
                    const t = this,
                        n = t._cachedMeta,
                        {
                            dataset: i,
                            data: r = [],
                            _dataset: o
                        } = n,
                        a = t.chart._animationsDisabled;
                    let {
                        start: s,
                        count: l
                    } = function (e, t, n) {
                        const i = t.length;
                        let r = 0,
                            o = i;
                        if (e._sorted) {
                            const {
                                iScale: a,
                                _parsed: s
                            } = e, l = a.axis, {
                                min: c,
                                max: u,
                                minDefined: d,
                                maxDefined: h
                            } = a.getUserBounds();
                            d && (r = Z(Math.min(dt(s, a.axis, c).lo, n ? i : dt(t, l, a.getPixelForValue(c)).lo), 0, i - 1)), o = h ? Z(Math.max(dt(s, a.axis, u).hi + 1, n ? 0 : dt(t, l, a.getPixelForValue(u)).hi + 1), r, i) - r : i - r
                        }
                        return {
                            start: r,
                            count: o
                        }
                    }(n, r, a);
                    t._drawStart = s, t._drawCount = l,
                        function (e) {
                            const {
                                xScale: t,
                                yScale: n,
                                _scaleRanges: i
                            } = e, r = {
                                xmin: t.min,
                                xmax: t.max,
                                ymin: n.min,
                                ymax: n.max
                            };
                            if (!i) return e._scaleRanges = r, !0;
                            const o = i.xmin !== t.min || i.xmax !== t.max || i.ymin !== n.min || i.ymax !== n.max;
                            return Object.assign(i, r), o
                        }(n) && (s = 0, l = r.length), i._datasetIndex = t.index, i._decimated = !!o._decimated, i.points = r;
                    const c = t.resolveDatasetElementOptions(e);
                    t.options.showLine || (c.borderWidth = 0), c.segment = t.options.segment, t.updateElement(i, void 0, {
                        animated: !a,
                        options: c
                    }, e), t.updateElements(r, s, l, e)
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = "reset" === i,
                        {
                            iScale: a,
                            vScale: s,
                            _stacked: l
                        } = r._cachedMeta,
                        u = r.resolveDataElementOptions(t, i),
                        d = r.getSharedOptions(u),
                        h = r.includeOptions(i, d),
                        f = a.axis,
                        p = s.axis,
                        g = r.options.spanGaps,
                        m = z(g) ? g : Number.POSITIVE_INFINITY,
                        v = r.chart._animationsDisabled || o || "none" === i;
                    let b = t > 0 && r.getParsed(t - 1);
                    for (let u = t; u < t + n; ++u) {
                        const t = e[u],
                            n = r.getParsed(u),
                            g = v ? t : {},
                            y = c(n[p]),
                            _ = g[f] = a.getPixelForValue(n[f], u),
                            x = g[p] = o || y ? s.getBasePixel() : s.getPixelForValue(l ? r.applyStack(s, n, l) : n[p], u);
                        g.skip = isNaN(_) || isNaN(x) || y, g.stop = u > 0 && n[f] - b[f] > m, g.parsed = n, h && (g.options = d || r.resolveDataElementOptions(u, t.active ? "active" : i)), v || r.updateElement(t, u, g, i), b = n
                    }
                    r.updateSharedOptions(d, i, u)
                }
                getMaxOverflow() {
                    const e = this,
                        t = e._cachedMeta,
                        n = t.dataset,
                        i = n.options && n.options.borderWidth || 0,
                        r = t.data || [];
                    if (!r.length) return i;
                    const o = r[0].size(e.resolveDataElementOptions(0)),
                        a = r[r.length - 1].size(e.resolveDataElementOptions(r.length - 1));
                    return Math.max(i, o, a) / 2
                }
                draw() {
                    const e = this._cachedMeta;
                    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw()
                }
            }
            Fn.id = "line", Fn.defaults = {
                datasetElementType: "line",
                dataElementType: "point",
                showLine: !0,
                spanGaps: !1
            }, Fn.overrides = {
                scales: {
                    _index_: {
                        type: "category"
                    },
                    _value_: {
                        type: "linear"
                    }
                }
            };
            class Bn extends Cn {
                constructor(e, t) {
                    super(e, t), this.innerRadius = void 0, this.outerRadius = void 0
                }
                getLabelAndValue(e) {
                    const t = this._cachedMeta,
                        n = this.chart,
                        i = n.data.labels || [],
                        r = Qt(t._parsed[e].r, n.options.locale);
                    return {
                        label: i[e] || "",
                        value: r
                    }
                }
                update(e) {
                    const t = this._cachedMeta.data;
                    this._updateRadius(), this.updateElements(t, 0, t.length, e)
                }
                _updateRadius() {
                    const e = this,
                        t = e.chart,
                        n = t.chartArea,
                        i = t.options,
                        r = Math.min(n.right - n.left, n.bottom - n.top),
                        o = Math.max(r / 2, 0),
                        a = (o - Math.max(i.cutoutPercentage ? o / 100 * i.cutoutPercentage : 1, 0)) / t.getVisibleDatasetCount();
                    e.outerRadius = o - a * e.index, e.innerRadius = e.outerRadius - a
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = "reset" === i,
                        a = r.chart,
                        s = r.getDataset(),
                        l = a.options.animation,
                        c = r._cachedMeta.rScale,
                        u = c.xCenter,
                        d = c.yCenter,
                        h = c.getIndexAngle(0) - .5 * T;
                    let f, p = h;
                    const g = 360 / r.countVisibleElements();
                    for (f = 0; f < t; ++f) p += r._computeAngle(f, i, g);
                    for (f = t; f < t + n; f++) {
                        const t = e[f];
                        let n = p,
                            m = p + r._computeAngle(f, i, g),
                            v = a.getDataVisibility(f) ? c.getDistanceFromCenterForValue(s.data[f]) : 0;
                        p = m, o && (l.animateScale && (v = 0), l.animateRotate && (n = m = h));
                        const b = {
                            x: u,
                            y: d,
                            innerRadius: 0,
                            outerRadius: v,
                            startAngle: n,
                            endAngle: m,
                            options: r.resolveDataElementOptions(f, t.active ? "active" : i)
                        };
                        r.updateElement(t, f, b, i)
                    }
                }
                countVisibleElements() {
                    const e = this.getDataset(),
                        t = this._cachedMeta;
                    let n = 0;
                    return t.data.forEach(((t, i) => {
                        !isNaN(e.data[i]) && this.chart.getDataVisibility(i) && n++
                    })), n
                }
                _computeAngle(e, t, n) {
                    return this.chart.getDataVisibility(e) ? V(this.resolveDataElementOptions(e, t).angle || n) : 0
                }
            }
            Bn.id = "polarArea", Bn.defaults = {
                dataElementType: "arc",
                animation: {
                    animateRotate: !0,
                    animateScale: !0
                },
                animations: {
                    numbers: {
                        type: "number",
                        properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
                    }
                },
                indexAxis: "r",
                startAngle: 0
            }, Bn.overrides = {
                aspectRatio: 1,
                plugins: {
                    legend: {
                        labels: {
                            generateLabels(e) {
                                const t = e.data;
                                if (t.labels.length && t.datasets.length) {
                                    const {
                                        labels: {
                                            pointStyle: n
                                        }
                                    } = e.legend.options;
                                    return t.labels.map(((t, i) => {
                                        const r = e.getDatasetMeta(0).controller.getStyle(i);
                                        return {
                                            text: t,
                                            fillStyle: r.backgroundColor,
                                            strokeStyle: r.borderColor,
                                            lineWidth: r.borderWidth,
                                            pointStyle: n,
                                            hidden: !e.getDataVisibility(i),
                                            index: i
                                        }
                                    }))
                                }
                                return []
                            }
                        },
                        onClick(e, t, n) {
                            n.chart.toggleDataVisibility(t.index), n.chart.update()
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: () => "",
                            label: e => e.chart.data.labels[e.dataIndex] + ": " + e.formattedValue
                        }
                    }
                },
                scales: {
                    r: {
                        type: "radialLinear",
                        angleLines: {
                            display: !1
                        },
                        beginAtZero: !0,
                        grid: {
                            circular: !0
                        },
                        pointLabels: {
                            display: !1
                        },
                        startAngle: 0
                    }
                }
            };
            class qn extends Rn {}
            qn.id = "pie", qn.defaults = {
                cutout: 0,
                rotation: 0,
                circumference: 360,
                radius: "100%"
            };
            class zn extends Cn {
                getLabelAndValue(e) {
                    const t = this._cachedMeta.vScale,
                        n = this.getParsed(e);
                    return {
                        label: t.getLabels()[e],
                        value: "" + t.getLabelForValue(n[t.axis])
                    }
                }
                update(e) {
                    const t = this,
                        n = t._cachedMeta,
                        i = n.dataset,
                        r = n.data || [],
                        o = n.iScale.getLabels();
                    if (i.points = r, "resize" !== e) {
                        const n = t.resolveDatasetElementOptions(e);
                        t.options.showLine || (n.borderWidth = 0);
                        const a = {
                            _loop: !0,
                            _fullLoop: o.length === r.length,
                            options: n
                        };
                        t.updateElement(i, void 0, a, e)
                    }
                    t.updateElements(r, 0, r.length, e)
                }
                updateElements(e, t, n, i) {
                    const r = this,
                        o = r.getDataset(),
                        a = r._cachedMeta.rScale,
                        s = "reset" === i;
                    for (let l = t; l < t + n; l++) {
                        const t = e[l],
                            n = r.resolveDataElementOptions(l, t.active ? "active" : i),
                            c = a.getPointPositionForValue(l, o.data[l]),
                            u = s ? a.xCenter : c.x,
                            d = s ? a.yCenter : c.y,
                            h = {
                                x: u,
                                y: d,
                                angle: c.angle,
                                skip: isNaN(u) || isNaN(d),
                                options: n
                            };
                        r.updateElement(t, l, h, i)
                    }
                }
            }
            zn.id = "radar", zn.defaults = {
                datasetElementType: "line",
                dataElementType: "point",
                indexAxis: "r",
                showLine: !0,
                elements: {
                    line: {
                        fill: "start"
                    }
                }
            }, zn.overrides = {
                aspectRatio: 1,
                scales: {
                    r: {
                        type: "radialLinear"
                    }
                }
            };
            class Hn extends Fn {}
            Hn.id = "scatter", Hn.defaults = {
                showLine: !1,
                fill: !1
            }, Hn.overrides = {
                interaction: {
                    mode: "point"
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            title: () => "",
                            label: e => "(" + e.label + ", " + e.formattedValue + ")"
                        }
                    }
                },
                scales: {
                    x: {
                        type: "linear"
                    },
                    y: {
                        type: "linear"
                    }
                }
            };

            function Un() {
                throw new Error("This method is not implemented: Check that a complete date adapter is provided.")
            }
            class Vn {
                constructor(e) {
                    this.options = e || {}
                }
                formats() {
                    return Un()
                }
                parse(e, t) {
                    return Un()
                }
                format(e, t) {
                    return Un()
                }
                add(e, t, n) {
                    return Un()
                }
                diff(e, t, n) {
                    return Un()
                }
                startOf(e, t, n) {
                    return Un()
                }
                endOf(e, t) {
                    return Un()
                }
            }
            Vn.override = function (e) {
                Object.assign(Vn.prototype, e)
            };
            var Wn = {
                _date: Vn
            };

            function Yn(e, t) {
                return "native" in e ? {
                    x: e.x,
                    y: e.y
                } : Ht(e, t)
            }

            function $n(e, t, n, i) {
                const {
                    controller: r,
                    data: o,
                    _sorted: a
                } = e, s = r._cachedMeta.iScale;
                if (s && t === s.axis && a && o.length) {
                    const e = s._reversePixels ? ht : dt;
                    if (!i) return e(o, t, n);
                    if (r._sharedOptions) {
                        const i = o[0],
                            r = "function" == typeof i.getRange && i.getRange(t);
                        if (r) {
                            const i = e(o, t, n - r),
                                a = e(o, t, n + r);
                            return {
                                lo: i.lo,
                                hi: a.hi
                            }
                        }
                    }
                }
                return {
                    lo: 0,
                    hi: o.length - 1
                }
            }

            function Kn(e, t, n, i, r) {
                const o = e.getSortedVisibleDatasetMetas(),
                    a = n[t];
                for (let e = 0, n = o.length; e < n; ++e) {
                    const {
                        index: n,
                        data: s
                    } = o[e], {
                        lo: l,
                        hi: c
                    } = $n(o[e], t, a, r);
                    for (let e = l; e <= c; ++e) {
                        const t = s[e];
                        t.skip || i(t, n, e)
                    }
                }
            }

            function Gn(e, t, n, i) {
                const r = [];
                if (!$e(t, e.chartArea, e._minPadding)) return r;
                return Kn(e, n, t, (function (e, n, o) {
                    e.inRange(t.x, t.y, i) && r.push({
                        element: e,
                        datasetIndex: n,
                        index: o
                    })
                }), !0), r
            }

            function Xn(e, t, n, i, r) {
                const o = function (e) {
                    const t = -1 !== e.indexOf("x"),
                        n = -1 !== e.indexOf("y");
                    return function (e, i) {
                        const r = t ? Math.abs(e.x - i.x) : 0,
                            o = n ? Math.abs(e.y - i.y) : 0;
                        return Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2))
                    }
                }(n);
                let a = Number.POSITIVE_INFINITY,
                    s = [];
                if (!$e(t, e.chartArea, e._minPadding)) return s;
                return Kn(e, n, t, (function (n, l, c) {
                    if (i && !n.inRange(t.x, t.y, r)) return;
                    const u = n.getCenterPoint(r);
                    if (!$e(u, e.chartArea, e._minPadding) && !n.inRange(t.x, t.y, r)) return;
                    const d = o(t, u);
                    d < a ? (s = [{
                        element: n,
                        datasetIndex: l,
                        index: c
                    }], a = d) : d === a && s.push({
                        element: n,
                        datasetIndex: l,
                        index: c
                    })
                })), s
            }

            function Zn(e, t, n, i) {
                const r = Yn(t, e),
                    o = [],
                    a = n.axis,
                    s = "x" === a ? "inXRange" : "inYRange";
                let l = !1;
                return function (e, t) {
                    const n = e.getSortedVisibleDatasetMetas();
                    let i, r, o;
                    for (let e = 0, a = n.length; e < a; ++e) {
                        ({
                            index: i,
                            data: r
                        } = n[e]);
                        for (let e = 0, n = r.length; e < n; ++e) o = r[e], o.skip || t(o, i, e)
                    }
                }(e, ((e, t, n) => {
                    e[s](r[a], i) && o.push({
                        element: e,
                        datasetIndex: t,
                        index: n
                    }), e.inRange(r.x, r.y, i) && (l = !0)
                })), n.intersect && !l ? [] : o
            }
            var Qn = {
                modes: {
                    index(e, t, n, i) {
                        const r = Yn(t, e),
                            o = n.axis || "x",
                            a = n.intersect ? Gn(e, r, o, i) : Xn(e, r, o, !1, i),
                            s = [];
                        return a.length ? (e.getSortedVisibleDatasetMetas().forEach((e => {
                            const t = a[0].index,
                                n = e.data[t];
                            n && !n.skip && s.push({
                                element: n,
                                datasetIndex: e.index,
                                index: t
                            })
                        })), s) : []
                    },
                    dataset(e, t, n, i) {
                        const r = Yn(t, e),
                            o = n.axis || "xy";
                        let a = n.intersect ? Gn(e, r, o, i) : Xn(e, r, o, !1, i);
                        if (a.length > 0) {
                            const t = a[0].datasetIndex,
                                n = e.getDatasetMeta(t).data;
                            a = [];
                            for (let e = 0; e < n.length; ++e) a.push({
                                element: n[e],
                                datasetIndex: t,
                                index: e
                            })
                        }
                        return a
                    },
                    point: (e, t, n, i) => Gn(e, Yn(t, e), n.axis || "xy", i),
                    nearest: (e, t, n, i) => Xn(e, Yn(t, e), n.axis || "xy", n.intersect, i),
                    x: (e, t, n, i) => (n.axis = "x", Zn(e, t, n, i)),
                    y: (e, t, n, i) => (n.axis = "y", Zn(e, t, n, i))
                }
            };
            const Jn = ["left", "top", "right", "bottom"];

            function ei(e, t) {
                return e.filter((e => e.pos === t))
            }

            function ti(e, t) {
                return e.filter((e => -1 === Jn.indexOf(e.pos) && e.box.axis === t))
            }

            function ni(e, t) {
                return e.sort(((e, n) => {
                    const i = t ? n : e,
                        r = t ? e : n;
                    return i.weight === r.weight ? i.index - r.index : i.weight - r.weight
                }))
            }

            function ii(e, t) {
                const n = function (e) {
                        const t = {};
                        for (const n of e) {
                            const {
                                stack: e,
                                pos: i,
                                stackWeight: r
                            } = n;
                            if (!e || !Jn.includes(i)) continue;
                            const o = t[e] || (t[e] = {
                                count: 0,
                                placed: 0,
                                weight: 0,
                                size: 0
                            });
                            o.count++, o.weight += r
                        }
                        return t
                    }(e),
                    {
                        vBoxMaxWidth: i,
                        hBoxMaxHeight: r
                    } = t;
                let o, a, s;
                for (o = 0, a = e.length; o < a; ++o) {
                    s = e[o];
                    const {
                        fullSize: a
                    } = s.box, l = n[s.stack], c = l && s.stackWeight / l.weight;
                    s.horizontal ? (s.width = c ? c * i : a && t.availableWidth, s.height = r) : (s.width = i, s.height = c ? c * r : a && t.availableHeight)
                }
                return n
            }

            function ri(e, t, n, i) {
                return Math.max(e[n], t[n]) + Math.max(e[i], t[i])
            }

            function oi(e, t) {
                e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right)
            }

            function ai(e, t, n, i) {
                const {
                    pos: r,
                    box: o
                } = n, a = e.maxPadding;
                if (!d(r)) {
                    n.size && (e[r] -= n.size);
                    const t = i[n.stack] || {
                        size: 0,
                        count: 1
                    };
                    t.size = Math.max(t.size, n.horizontal ? o.height : o.width), n.size = t.size / t.count, e[r] += n.size
                }
                o.getPadding && oi(a, o.getPadding());
                const s = Math.max(0, t.outerWidth - ri(a, e, "left", "right")),
                    l = Math.max(0, t.outerHeight - ri(a, e, "top", "bottom")),
                    c = s !== e.w,
                    u = l !== e.h;
                return e.w = s, e.h = l, n.horizontal ? {
                    same: c,
                    other: u
                } : {
                    same: u,
                    other: c
                }
            }

            function si(e, t) {
                const n = t.maxPadding;

                function i(e) {
                    const i = {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0
                    };
                    return e.forEach((e => {
                        i[e] = Math.max(t[e], n[e])
                    })), i
                }
                return i(e ? ["left", "right"] : ["top", "bottom"])
            }

            function li(e, t, n, i) {
                const r = [];
                let o, a, s, l, c, u;
                for (o = 0, a = e.length, c = 0; o < a; ++o) {
                    s = e[o], l = s.box, l.update(s.width || t.w, s.height || t.h, si(s.horizontal, t));
                    const {
                        same: a,
                        other: d
                    } = ai(t, n, s, i);
                    c |= a && r.length, u = u || d, l.fullSize || r.push(s)
                }
                return c && li(r, t, n, i) || u
            }

            function ci(e, t, n, i, r) {
                e.top = n, e.left = t, e.right = t + i, e.bottom = n + r, e.width = i, e.height = r
            }

            function ui(e, t, n, i) {
                const r = n.padding;
                let {
                    x: o,
                    y: a
                } = t;
                for (const s of e) {
                    const e = s.box,
                        l = i[s.stack] || {
                            count: 1,
                            placed: 0,
                            weight: 1
                        },
                        c = s.stackWeight / l.weight || 1;
                    if (s.horizontal) {
                        const i = t.w * c,
                            o = l.size || e.height;
                        A(l.start) && (a = l.start), e.fullSize ? ci(e, r.left, a, n.outerWidth - r.right - r.left, o) : ci(e, t.left + l.placed, a, i, o), l.start = a, l.placed += i, a = e.bottom
                    } else {
                        const i = t.h * c,
                            a = l.size || e.width;
                        A(l.start) && (o = l.start), e.fullSize ? ci(e, o, r.top, a, n.outerHeight - r.bottom - r.top) : ci(e, o, t.top + l.placed, a, i), l.start = o, l.placed += i, o = e.right
                    }
                }
                t.x = o, t.y = a
            }
            ze.set("layout", {
                padding: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                }
            });
            var di = {
                addBox(e, t) {
                    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function () {
                        return [{
                            z: 0,
                            draw(e) {
                                t.draw(e)
                            }
                        }]
                    }, e.boxes.push(t)
                },
                removeBox(e, t) {
                    const n = e.boxes ? e.boxes.indexOf(t) : -1; - 1 !== n && e.boxes.splice(n, 1)
                },
                configure(e, t, n) {
                    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight
                },
                update(e, t, n, i) {
                    if (!e) return;
                    const r = st(e.options.layout.padding),
                        o = Math.max(t - r.width, 0),
                        a = Math.max(n - r.height, 0),
                        s = function (e) {
                            const t = function (e) {
                                    const t = [];
                                    let n, i, r, o, a, s;
                                    for (n = 0, i = (e || []).length; n < i; ++n) r = e[n], ({
                                        position: o,
                                        options: {
                                            stack: a,
                                            stackWeight: s = 1
                                        }
                                    } = r), t.push({
                                        index: n,
                                        box: r,
                                        pos: o,
                                        horizontal: r.isHorizontal(),
                                        weight: r.weight,
                                        stack: a && o + a,
                                        stackWeight: s
                                    });
                                    return t
                                }(e),
                                n = ni(t.filter((e => e.box.fullSize)), !0),
                                i = ni(ei(t, "left"), !0),
                                r = ni(ei(t, "right")),
                                o = ni(ei(t, "top"), !0),
                                a = ni(ei(t, "bottom")),
                                s = ti(t, "x"),
                                l = ti(t, "y");
                            return {
                                fullSize: n,
                                leftAndTop: i.concat(o),
                                rightAndBottom: r.concat(l).concat(a).concat(s),
                                chartArea: ei(t, "chartArea"),
                                vertical: i.concat(r).concat(l),
                                horizontal: o.concat(a).concat(s)
                            }
                        }(e.boxes),
                        l = s.vertical,
                        c = s.horizontal;
                    v(e.boxes, (e => {
                        "function" == typeof e.beforeLayout && e.beforeLayout()
                    }));
                    const u = l.reduce(((e, t) => t.box.options && !1 === t.box.options.display ? e : e + 1), 0) || 1,
                        d = Object.freeze({
                            outerWidth: t,
                            outerHeight: n,
                            padding: r,
                            availableWidth: o,
                            availableHeight: a,
                            vBoxMaxWidth: o / 2 / u,
                            hBoxMaxHeight: a / 2
                        }),
                        h = Object.assign({}, r);
                    oi(h, st(i));
                    const f = Object.assign({
                            maxPadding: h,
                            w: o,
                            h: a,
                            x: r.left,
                            y: r.top
                        }, r),
                        p = ii(l.concat(c), d);
                    li(s.fullSize, f, d, p), li(l, f, d, p), li(c, f, d, p) && li(l, f, d, p),
                        function (e) {
                            const t = e.maxPadding;

                            function n(n) {
                                const i = Math.max(t[n] - e[n], 0);
                                return e[n] += i, i
                            }
                            e.y += n("top"), e.x += n("left"), n("right"), n("bottom")
                        }(f), ui(s.leftAndTop, f, d, p), f.x += f.w, f.y += f.h, ui(s.rightAndBottom, f, d, p), e.chartArea = {
                            left: f.left,
                            top: f.top,
                            right: f.left + f.w,
                            bottom: f.top + f.h,
                            height: f.h,
                            width: f.w
                        }, v(s.chartArea, (t => {
                            const n = t.box;
                            Object.assign(n, e.chartArea), n.update(f.w, f.h)
                        }))
                }
            };
            class hi {
                acquireContext(e, t) {}
                releaseContext(e) {
                    return !1
                }
                addEventListener(e, t, n) {}
                removeEventListener(e, t, n) {}
                getDevicePixelRatio() {
                    return 1
                }
                getMaximumSize(e, t, n, i) {
                    return t = Math.max(0, t || e.width), n = n || e.height, {
                        width: t,
                        height: Math.max(0, i ? Math.floor(t / i) : n)
                    }
                }
                isAttached(e) {
                    return !0
                }
            }
            class fi extends hi {
                acquireContext(e) {
                    return e && e.getContext && e.getContext("2d") || null
                }
            }
            const pi = {
                    touchstart: "mousedown",
                    touchmove: "mousemove",
                    touchend: "mouseup",
                    pointerenter: "mouseenter",
                    pointerdown: "mousedown",
                    pointermove: "mousemove",
                    pointerup: "mouseup",
                    pointerleave: "mouseout",
                    pointerout: "mouseout"
                },
                gi = e => null === e || "" === e;
            const mi = !!Yt && {
                passive: !0
            };

            function vi(e, t, n) {
                e.canvas.removeEventListener(t, n, mi)
            }

            function bi(e, t, n) {
                const i = e.canvas,
                    r = i && Rt(i) || i,
                    o = new MutationObserver((e => {
                        const t = Rt(r);
                        e.forEach((e => {
                            for (let i = 0; i < e.addedNodes.length; i++) {
                                const o = e.addedNodes[i];
                                o !== r && o !== t || n(e.target)
                            }
                        }))
                    }));
                return o.observe(document, {
                    childList: !0,
                    subtree: !0
                }), o
            }

            function yi(e, t, n) {
                const i = e.canvas,
                    r = i && Rt(i);
                if (!r) return;
                const o = new MutationObserver((e => {
                    e.forEach((e => {
                        for (let t = 0; t < e.removedNodes.length; t++)
                            if (e.removedNodes[t] === i) {
                                n();
                                break
                            }
                    }))
                }));
                return o.observe(r, {
                    childList: !0
                }), o
            }
            const _i = new Map;
            let xi = 0;

            function wi() {
                const e = window.devicePixelRatio;
                e !== xi && (xi = e, _i.forEach(((t, n) => {
                    n.currentDevicePixelRatio !== e && t()
                })))
            }

            function Ei(e, t, n) {
                const i = e.canvas,
                    o = i && Rt(i);
                if (!o) return;
                const a = r(((e, t) => {
                        const i = o.clientWidth;
                        n(e, t), i < o.clientWidth && n()
                    }), window),
                    s = new ResizeObserver((e => {
                        const t = e[0],
                            n = t.contentRect.width,
                            i = t.contentRect.height;
                        0 === n && 0 === i || a(n, i)
                    }));
                return s.observe(o),
                    function (e, t) {
                        _i.size || window.addEventListener("resize", wi), _i.set(e, t)
                    }(e, a), s
            }

            function ki(e, t, n) {
                n && n.disconnect(), "resize" === t && function (e) {
                    _i.delete(e), _i.size || window.removeEventListener("resize", wi)
                }(e)
            }

            function Oi(e, t, n) {
                const i = e.canvas,
                    o = r((t => {
                        null !== e.ctx && n(function (e, t) {
                            const n = pi[e.type] || e.type,
                                {
                                    x: i,
                                    y: r
                                } = Ht(e, t);
                            return {
                                type: n,
                                chart: t,
                                native: e,
                                x: void 0 !== i ? i : null,
                                y: void 0 !== r ? r : null
                            }
                        }(t, e))
                    }), e, (e => {
                        const t = e[0];
                        return [t, t.offsetX, t.offsetY]
                    }));
                return function (e, t, n) {
                    e.addEventListener(t, n, mi)
                }(i, t, o), o
            }
            class Si extends hi {
                acquireContext(e, t) {
                    const n = e && e.getContext && e.getContext("2d");
                    return n && n.canvas === e ? (function (e, t) {
                        const n = e.style,
                            i = e.getAttribute("height"),
                            r = e.getAttribute("width");
                        if (e.$chartjs = {
                                initial: {
                                    height: i,
                                    width: r,
                                    style: {
                                        display: n.display,
                                        height: n.height,
                                        width: n.width
                                    }
                                }
                            }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", gi(r)) {
                            const t = $t(e, "width");
                            void 0 !== t && (e.width = t)
                        }
                        if (gi(i))
                            if ("" === e.style.height) e.height = e.width / (t || 2);
                            else {
                                const t = $t(e, "height");
                                void 0 !== t && (e.height = t)
                            }
                    }(e, t), n) : null
                }
                releaseContext(e) {
                    const t = e.canvas;
                    if (!t.$chartjs) return !1;
                    const n = t.$chartjs.initial;
                    ["height", "width"].forEach((e => {
                        const i = n[e];
                        c(i) ? t.removeAttribute(e) : t.setAttribute(e, i)
                    }));
                    const i = n.style || {};
                    return Object.keys(i).forEach((e => {
                        t.style[e] = i[e]
                    })), t.width = t.width, delete t.$chartjs, !0
                }
                addEventListener(e, t, n) {
                    this.removeEventListener(e, t);
                    const i = e.$proxies || (e.$proxies = {}),
                        r = {
                            attach: bi,
                            detach: yi,
                            resize: Ei
                        } [t] || Oi;
                    i[t] = r(e, t, n)
                }
                removeEventListener(e, t) {
                    const n = e.$proxies || (e.$proxies = {}),
                        i = n[t];
                    if (!i) return;
                    ({
                        attach: ki,
                        detach: ki,
                        resize: ki
                    } [t] || vi)(e, t, i), n[t] = void 0
                }
                getDevicePixelRatio() {
                    return window.devicePixelRatio
                }
                getMaximumSize(e, t, n, i) {
                    return Vt(e, t, n, i)
                }
                isAttached(e) {
                    const t = Rt(e);
                    return !(!t || !t.isConnected)
                }
            }
            class Ci {
                constructor() {
                    this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0
                }
                tooltipPosition(e) {
                    const {
                        x: t,
                        y: n
                    } = this.getProps(["x", "y"], e);
                    return {
                        x: t,
                        y: n
                    }
                }
                hasValue() {
                    return z(this.x) && z(this.y)
                }
                getProps(e, t) {
                    const n = this,
                        i = this.$animations;
                    if (!t || !i) return n;
                    const r = {};
                    return e.forEach((e => {
                        r[e] = i[e] && i[e].active() ? i[e]._to : n[e]
                    })), r
                }
            }
            Ci.defaults = {}, Ci.defaultRoutes = void 0;
            const Ai = {
                values: e => u(e) ? e : "" + e,
                numeric(e, t, n) {
                    if (0 === e) return "0";
                    const i = this.chart.options.locale;
                    let r, o = e;
                    if (n.length > 1) {
                        const t = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
                        (t < 1e-4 || t > 1e15) && (r = "scientific"), o = function (e, t) {
                            let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
                            Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e));
                            return n
                        }(e, n)
                    }
                    const a = F(Math.abs(o)),
                        s = Math.max(Math.min(-1 * Math.floor(a), 20), 0),
                        l = {
                            notation: r,
                            minimumFractionDigits: s,
                            maximumFractionDigits: s
                        };
                    return Object.assign(l, this.options.ticks.format), Qt(e, i, l)
                },
                logarithmic(e, t, n) {
                    if (0 === e) return "0";
                    const i = e / Math.pow(10, Math.floor(F(e)));
                    return 1 === i || 2 === i || 5 === i ? Ai.numeric.call(this, e, t, n) : ""
                }
            };
            var Mi = {
                formatters: Ai
            };

            function Ti(e, t) {
                const n = e.options.ticks,
                    i = n.maxTicksLimit || function (e) {
                        const t = e.options.offset,
                            n = e._tickSize(),
                            i = e._length / n + (t ? 0 : 1),
                            r = e._maxLength / n;
                        return Math.floor(Math.min(i, r))
                    }(e),
                    r = n.major.enabled ? function (e) {
                        const t = [];
                        let n, i;
                        for (n = 0, i = e.length; n < i; n++) e[n].major && t.push(n);
                        return t
                    }(t) : [],
                    o = r.length,
                    a = r[0],
                    s = r[o - 1],
                    l = [];
                if (o > i) return function (e, t, n, i) {
                    let r, o = 0,
                        a = n[0];
                    for (i = Math.ceil(i), r = 0; r < e.length; r++) r === a && (t.push(e[r]), o++, a = n[o * i])
                }(t, l, r, o / i), l;
                const u = function (e, t, n) {
                    const i = function (e) {
                            const t = e.length;
                            let n, i;
                            if (t < 2) return !1;
                            for (i = e[0], n = 1; n < t; ++n)
                                if (e[n] - e[n - 1] !== i) return !1;
                            return i
                        }(e),
                        r = t.length / n;
                    if (!i) return Math.max(r, 1);
                    const o = function (e) {
                        const t = [],
                            n = Math.sqrt(e);
                        let i;
                        for (i = 1; i < n; i++) e % i == 0 && (t.push(i), t.push(e / i));
                        return n === (0 | n) && t.push(n), t.sort(((e, t) => e - t)).pop(), t
                    }(i);
                    for (let e = 0, t = o.length - 1; e < t; e++) {
                        const t = o[e];
                        if (t > r) return t
                    }
                    return Math.max(r, 1)
                }(r, t, i);
                if (o > 0) {
                    let e, n;
                    const i = o > 1 ? Math.round((s - a) / (o - 1)) : null;
                    for (Pi(t, l, u, c(i) ? 0 : a - i, a), e = 0, n = o - 1; e < n; e++) Pi(t, l, u, r[e], r[e + 1]);
                    return Pi(t, l, u, s, c(i) ? t.length : s + i), l
                }
                return Pi(t, l, u), l
            }

            function Pi(e, t, n, i, r) {
                const o = p(i, 0),
                    a = Math.min(p(r, e.length), e.length);
                let s, l, c, u = 0;
                for (n = Math.ceil(n), r && (s = r - i, n = s / Math.floor(s / n)), c = o; c < 0;) u++, c = Math.round(o + u * n);
                for (l = Math.max(o, 0); l < a; l++) l === c && (t.push(e[l]), u++, c = Math.round(o + u * n))
            }
            ze.set("scale", {
                display: !0,
                offset: !1,
                reverse: !1,
                beginAtZero: !1,
                bounds: "ticks",
                grace: 0,
                grid: {
                    display: !0,
                    lineWidth: 1,
                    drawBorder: !0,
                    drawOnChartArea: !0,
                    drawTicks: !0,
                    tickLength: 8,
                    tickWidth: (e, t) => t.lineWidth,
                    tickColor: (e, t) => t.color,
                    offset: !1,
                    borderDash: [],
                    borderDashOffset: 0,
                    borderWidth: 1
                },
                title: {
                    display: !1,
                    text: "",
                    padding: {
                        top: 4,
                        bottom: 4
                    }
                },
                ticks: {
                    minRotation: 0,
                    maxRotation: 50,
                    mirror: !1,
                    textStrokeWidth: 0,
                    textStrokeColor: "",
                    padding: 3,
                    display: !0,
                    autoSkip: !0,
                    autoSkipPadding: 3,
                    labelOffset: 0,
                    callback: Mi.formatters.values,
                    minor: {},
                    major: {},
                    align: "center",
                    crossAlign: "near",
                    showLabelBackdrop: !1,
                    backdropColor: "rgba(255, 255, 255, 0.75)",
                    backdropPadding: 2
                }
            }), ze.route("scale.ticks", "color", "", "color"), ze.route("scale.grid", "color", "", "borderColor"), ze.route("scale.grid", "borderColor", "", "borderColor"), ze.route("scale.title", "color", "", "color"), ze.describe("scale", {
                _fallback: !1,
                _scriptable: e => !e.startsWith("before") && !e.startsWith("after") && "callback" !== e && "parser" !== e,
                _indexable: e => "borderDash" !== e && "tickBorderDash" !== e
            }), ze.describe("scales", {
                _fallback: "scale"
            }), ze.describe("scale.ticks", {
                _scriptable: e => "backdropPadding" !== e && "callback" !== e,
                _indexable: e => "backdropPadding" !== e
            });
            const Di = (e, t, n) => "top" === t || "left" === t ? e[t] + n : e[t] - n;

            function Li(e, t) {
                const n = [],
                    i = e.length / t,
                    r = e.length;
                let o = 0;
                for (; o < r; o += i) n.push(e[Math.floor(o)]);
                return n
            }

            function Ni(e, t, n) {
                const i = e.ticks.length,
                    r = Math.min(t, i - 1),
                    o = e._startPixel,
                    a = e._endPixel,
                    s = 1e-6;
                let l, c = e.getPixelForTick(r);
                if (!(n && (l = 1 === i ? Math.max(c - o, a - c) : 0 === t ? (e.getPixelForTick(1) - c) / 2 : (c - e.getPixelForTick(r - 1)) / 2, c += r < t ? l : -l, c < o - s || c > a + s))) return c
            }

            function ji(e) {
                return e.drawTicks ? e.tickLength : 0
            }

            function Ii(e, t) {
                if (!e.display) return 0;
                const n = lt(e.font, t),
                    i = st(e.padding);
                return (u(e.text) ? e.text.length : 1) * n.lineHeight + i.height
            }

            function Ri(e, t, n) {
                let i = o(e);
                return (n && "right" !== t || !n && "right" === t) && (i = (e => "left" === e ? "right" : "right" === e ? "left" : e)(i)), i
            }
            class Fi extends Ci {
                constructor(e) {
                    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0
                }
                init(e) {
                    const t = this;
                    t.options = e.setContext(t.getContext()), t.axis = e.axis, t._userMin = t.parse(e.min), t._userMax = t.parse(e.max), t._suggestedMin = t.parse(e.suggestedMin), t._suggestedMax = t.parse(e.suggestedMax)
                }
                parse(e, t) {
                    return e
                }
                getUserBounds() {
                    let {
                        _userMin: e,
                        _userMax: t,
                        _suggestedMin: n,
                        _suggestedMax: i
                    } = this;
                    return e = f(e, Number.POSITIVE_INFINITY), t = f(t, Number.NEGATIVE_INFINITY), n = f(n, Number.POSITIVE_INFINITY), i = f(i, Number.NEGATIVE_INFINITY), {
                        min: f(e, n),
                        max: f(t, i),
                        minDefined: h(e),
                        maxDefined: h(t)
                    }
                }
                getMinMax(e) {
                    const t = this;
                    let n, {
                        min: i,
                        max: r,
                        minDefined: o,
                        maxDefined: a
                    } = t.getUserBounds();
                    if (o && a) return {
                        min: i,
                        max: r
                    };
                    const s = t.getMatchingVisibleMetas();
                    for (let l = 0, c = s.length; l < c; ++l) n = s[l].controller.getMinMax(t, e), o || (i = Math.min(i, n.min)), a || (r = Math.max(r, n.max));
                    return {
                        min: f(i, f(r, i)),
                        max: f(r, f(i, r))
                    }
                }
                getPadding() {
                    const e = this;
                    return {
                        left: e.paddingLeft || 0,
                        top: e.paddingTop || 0,
                        right: e.paddingRight || 0,
                        bottom: e.paddingBottom || 0
                    }
                }
                getTicks() {
                    return this.ticks
                }
                getLabels() {
                    const e = this.chart.data;
                    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || []
                }
                beforeLayout() {
                    this._cache = {}, this._dataLimitsCached = !1
                }
                beforeUpdate() {
                    m(this.options.beforeUpdate, [this])
                }
                update(e, t, n) {
                    const i = this,
                        r = i.options.ticks,
                        o = r.sampleSize;
                    i.beforeUpdate(), i.maxWidth = e, i.maxHeight = t, i._margins = n = Object.assign({
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }, n), i.ticks = null, i._labelSizes = null, i._gridLineItems = null, i._labelItems = null, i.beforeSetDimensions(), i.setDimensions(), i.afterSetDimensions(), i._maxLength = i.isHorizontal() ? i.width + n.left + n.right : i.height + n.top + n.bottom, i._dataLimitsCached || (i.beforeDataLimits(), i.determineDataLimits(), i.afterDataLimits(), i._range = function (e, t) {
                        const {
                            min: n,
                            max: i
                        } = e;
                        return {
                            min: n - Math.abs(g(t, n)),
                            max: i + g(t, i)
                        }
                    }(i, i.options.grace), i._dataLimitsCached = !0), i.beforeBuildTicks(), i.ticks = i.buildTicks() || [], i.afterBuildTicks();
                    const a = o < i.ticks.length;
                    i._convertTicksToLabels(a ? Li(i.ticks, o) : i.ticks), i.configure(), i.beforeCalculateLabelRotation(), i.calculateLabelRotation(), i.afterCalculateLabelRotation(), r.display && (r.autoSkip || "auto" === r.source) && (i.ticks = Ti(i, i.ticks), i._labelSizes = null), a && i._convertTicksToLabels(i.ticks), i.beforeFit(), i.fit(), i.afterFit(), i.afterUpdate()
                }
                configure() {
                    const e = this;
                    let t, n, i = e.options.reverse;
                    e.isHorizontal() ? (t = e.left, n = e.right) : (t = e.top, n = e.bottom, i = !i), e._startPixel = t, e._endPixel = n, e._reversePixels = i, e._length = n - t, e._alignToPixels = e.options.alignToPixels
                }
                afterUpdate() {
                    m(this.options.afterUpdate, [this])
                }
                beforeSetDimensions() {
                    m(this.options.beforeSetDimensions, [this])
                }
                setDimensions() {
                    const e = this;
                    e.isHorizontal() ? (e.width = e.maxWidth, e.left = 0, e.right = e.width) : (e.height = e.maxHeight, e.top = 0, e.bottom = e.height), e.paddingLeft = 0, e.paddingTop = 0, e.paddingRight = 0, e.paddingBottom = 0
                }
                afterSetDimensions() {
                    m(this.options.afterSetDimensions, [this])
                }
                _callHooks(e) {
                    const t = this;
                    t.chart.notifyPlugins(e, t.getContext()), m(t.options[e], [t])
                }
                beforeDataLimits() {
                    this._callHooks("beforeDataLimits")
                }
                determineDataLimits() {}
                afterDataLimits() {
                    this._callHooks("afterDataLimits")
                }
                beforeBuildTicks() {
                    this._callHooks("beforeBuildTicks")
                }
                buildTicks() {
                    return []
                }
                afterBuildTicks() {
                    this._callHooks("afterBuildTicks")
                }
                beforeTickToLabelConversion() {
                    m(this.options.beforeTickToLabelConversion, [this])
                }
                generateTickLabels(e) {
                    const t = this,
                        n = t.options.ticks;
                    let i, r, o;
                    for (i = 0, r = e.length; i < r; i++) o = e[i], o.label = m(n.callback, [o.value, i, e], t)
                }
                afterTickToLabelConversion() {
                    m(this.options.afterTickToLabelConversion, [this])
                }
                beforeCalculateLabelRotation() {
                    m(this.options.beforeCalculateLabelRotation, [this])
                }
                calculateLabelRotation() {
                    const e = this,
                        t = e.options,
                        n = t.ticks,
                        i = e.ticks.length,
                        r = n.minRotation || 0,
                        o = n.maxRotation;
                    let a, s, l, c = r;
                    if (!e._isVisible() || !n.display || r >= o || i <= 1 || !e.isHorizontal()) return void(e.labelRotation = r);
                    const u = e._getLabelSizes(),
                        d = u.widest.width,
                        h = u.highest.height,
                        f = Z(e.chart.width - d, 0, e.maxWidth);
                    a = t.offset ? e.maxWidth / i : f / (i - 1), d + 6 > a && (a = f / (i - (t.offset ? .5 : 1)), s = e.maxHeight - ji(t.grid) - n.padding - Ii(t.title, e.chart.options.font), l = Math.sqrt(d * d + h * h), c = W(Math.min(Math.asin(Z((u.highest.height + 6) / a, -1, 1)), Math.asin(Z(s / l, -1, 1)) - Math.asin(Z(h / l, -1, 1)))), c = Math.max(r, Math.min(o, c))), e.labelRotation = c
                }
                afterCalculateLabelRotation() {
                    m(this.options.afterCalculateLabelRotation, [this])
                }
                beforeFit() {
                    m(this.options.beforeFit, [this])
                }
                fit() {
                    const e = this,
                        t = {
                            width: 0,
                            height: 0
                        },
                        {
                            chart: n,
                            options: {
                                ticks: i,
                                title: r,
                                grid: o
                            }
                        } = e,
                        a = e._isVisible(),
                        s = e.isHorizontal();
                    if (a) {
                        const a = Ii(r, n.options.font);
                        if (s ? (t.width = e.maxWidth, t.height = ji(o) + a) : (t.height = e.maxHeight, t.width = ji(o) + a), i.display && e.ticks.length) {
                            const {
                                first: n,
                                last: r,
                                widest: o,
                                highest: a
                            } = e._getLabelSizes(), l = 2 * i.padding, c = V(e.labelRotation), u = Math.cos(c), d = Math.sin(c);
                            if (s) {
                                const n = i.mirror ? 0 : d * o.width + u * a.height;
                                t.height = Math.min(e.maxHeight, t.height + n + l)
                            } else {
                                const n = i.mirror ? 0 : u * o.width + d * a.height;
                                t.width = Math.min(e.maxWidth, t.width + n + l)
                            }
                            e._calculatePadding(n, r, d, u)
                        }
                    }
                    e._handleMargins(), s ? (e.width = e._length = n.width - e._margins.left - e._margins.right, e.height = t.height) : (e.width = t.width, e.height = e._length = n.height - e._margins.top - e._margins.bottom)
                }
                _calculatePadding(e, t, n, i) {
                    const r = this,
                        {
                            ticks: {
                                align: o,
                                padding: a
                            },
                            position: s
                        } = r.options,
                        l = 0 !== r.labelRotation,
                        c = "top" !== s && "x" === r.axis;
                    if (r.isHorizontal()) {
                        const s = r.getPixelForTick(0) - r.left,
                            u = r.right - r.getPixelForTick(r.ticks.length - 1);
                        let d = 0,
                            h = 0;
                        l ? c ? (d = i * e.width, h = n * t.height) : (d = n * e.height, h = i * t.width) : "start" === o ? h = t.width : "end" === o ? d = e.width : (d = e.width / 2, h = t.width / 2), r.paddingLeft = Math.max((d - s + a) * r.width / (r.width - s), 0), r.paddingRight = Math.max((h - u + a) * r.width / (r.width - u), 0)
                    } else {
                        let n = t.height / 2,
                            i = e.height / 2;
                        "start" === o ? (n = 0, i = e.height) : "end" === o && (n = t.height, i = 0), r.paddingTop = n + a, r.paddingBottom = i + a
                    }
                }
                _handleMargins() {
                    const e = this;
                    e._margins && (e._margins.left = Math.max(e.paddingLeft, e._margins.left), e._margins.top = Math.max(e.paddingTop, e._margins.top), e._margins.right = Math.max(e.paddingRight, e._margins.right), e._margins.bottom = Math.max(e.paddingBottom, e._margins.bottom))
                }
                afterFit() {
                    m(this.options.afterFit, [this])
                }
                isHorizontal() {
                    const {
                        axis: e,
                        position: t
                    } = this.options;
                    return "top" === t || "bottom" === t || "x" === e
                }
                isFullSize() {
                    return this.options.fullSize
                }
                _convertTicksToLabels(e) {
                    const t = this;
                    let n, i;
                    for (t.beforeTickToLabelConversion(), t.generateTickLabels(e), n = 0, i = e.length; n < i; n++) c(e[n].label) && (e.splice(n, 1), i--, n--);
                    t.afterTickToLabelConversion()
                }
                _getLabelSizes() {
                    const e = this;
                    let t = e._labelSizes;
                    if (!t) {
                        const n = e.options.ticks.sampleSize;
                        let i = e.ticks;
                        n < i.length && (i = Li(i, n)), e._labelSizes = t = e._computeLabelSizes(i, i.length)
                    }
                    return t
                }
                _computeLabelSizes(e, t) {
                    const {
                        ctx: n,
                        _longestTextCache: i
                    } = this, r = [], o = [];
                    let a, s, l, d, h, f, p, g, m, b, y, _ = 0,
                        x = 0;
                    for (a = 0; a < t; ++a) {
                        if (d = e[a].label, h = this._resolveTickFontOptions(a), n.font = f = h.string, p = i[f] = i[f] || {
                                data: {},
                                gc: []
                            }, g = h.lineHeight, m = b = 0, c(d) || u(d)) {
                            if (u(d))
                                for (s = 0, l = d.length; s < l; ++s) y = d[s], c(y) || u(y) || (m = He(n, p.data, p.gc, m, y), b += g)
                        } else m = He(n, p.data, p.gc, m, d), b = g;
                        r.push(m), o.push(b), _ = Math.max(m, _), x = Math.max(b, x)
                    }! function (e, t) {
                        v(e, (e => {
                            const n = e.gc,
                                i = n.length / 2;
                            let r;
                            if (i > t) {
                                for (r = 0; r < i; ++r) delete e.data[n[r]];
                                n.splice(0, i)
                            }
                        }))
                    }(i, t);
                    const w = r.indexOf(_),
                        E = o.indexOf(x),
                        k = e => ({
                            width: r[e] || 0,
                            height: o[e] || 0
                        });
                    return {
                        first: k(0),
                        last: k(t - 1),
                        widest: k(w),
                        highest: k(E),
                        widths: r,
                        heights: o
                    }
                }
                getLabelForValue(e) {
                    return e
                }
                getPixelForValue(e, t) {
                    return NaN
                }
                getValueForPixel(e) {}
                getPixelForTick(e) {
                    const t = this.ticks;
                    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value)
                }
                getPixelForDecimal(e) {
                    const t = this;
                    t._reversePixels && (e = 1 - e);
                    const n = t._startPixel + e * t._length;
                    return Z(t._alignToPixels ? Ve(t.chart, n, 0) : n, -32768, 32767)
                }
                getDecimalForPixel(e) {
                    const t = (e - this._startPixel) / this._length;
                    return this._reversePixels ? 1 - t : t
                }
                getBasePixel() {
                    return this.getPixelForValue(this.getBaseValue())
                }
                getBaseValue() {
                    const {
                        min: e,
                        max: t
                    } = this;
                    return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0
                }
                getContext(e) {
                    const t = this,
                        n = t.ticks || [];
                    if (e >= 0 && e < n.length) {
                        const i = n[e];
                        return i.$context || (i.$context = function (e, t, n) {
                            return Object.assign(Object.create(e), {
                                tick: n,
                                index: t,
                                type: "tick"
                            })
                        }(t.getContext(), e, i))
                    }
                    return t.$context || (t.$context = (i = t.chart.getContext(), r = t, Object.assign(Object.create(i), {
                        scale: r,
                        type: "scale"
                    })));
                    var i, r
                }
                _tickSize() {
                    const e = this,
                        t = e.options.ticks,
                        n = V(e.labelRotation),
                        i = Math.abs(Math.cos(n)),
                        r = Math.abs(Math.sin(n)),
                        o = e._getLabelSizes(),
                        a = t.autoSkipPadding || 0,
                        s = o ? o.widest.width + a : 0,
                        l = o ? o.highest.height + a : 0;
                    return e.isHorizontal() ? l * i > s * r ? s / i : l / r : l * r < s * i ? l / i : s / r
                }
                _isVisible() {
                    const e = this.options.display;
                    return "auto" !== e ? !!e : this.getMatchingVisibleMetas().length > 0
                }
                _computeGridLineItems(e) {
                    const t = this,
                        n = t.axis,
                        i = t.chart,
                        r = t.options,
                        {
                            grid: o,
                            position: a
                        } = r,
                        s = o.offset,
                        l = t.isHorizontal(),
                        c = t.ticks.length + (s ? 1 : 0),
                        u = ji(o),
                        h = [],
                        f = o.setContext(t.getContext()),
                        g = f.drawBorder ? f.borderWidth : 0,
                        m = g / 2,
                        v = function (e) {
                            return Ve(i, e, g)
                        };
                    let b, y, _, x, w, E, k, O, S, C, A, M;
                    if ("top" === a) b = v(t.bottom), E = t.bottom - u, O = b - m, C = v(e.top) + m, M = e.bottom;
                    else if ("bottom" === a) b = v(t.top), C = e.top, M = v(e.bottom) - m, E = b + m, O = t.top + u;
                    else if ("left" === a) b = v(t.right), w = t.right - u, k = b - m, S = v(e.left) + m, A = e.right;
                    else if ("right" === a) b = v(t.left), S = e.left, A = v(e.right) - m, w = b + m, k = t.left + u;
                    else if ("x" === n) {
                        if ("center" === a) b = v((e.top + e.bottom) / 2 + .5);
                        else if (d(a)) {
                            const e = Object.keys(a)[0],
                                n = a[e];
                            b = v(t.chart.scales[e].getPixelForValue(n))
                        }
                        C = e.top, M = e.bottom, E = b + m, O = E + u
                    } else if ("y" === n) {
                        if ("center" === a) b = v((e.left + e.right) / 2);
                        else if (d(a)) {
                            const e = Object.keys(a)[0],
                                n = a[e];
                            b = v(t.chart.scales[e].getPixelForValue(n))
                        }
                        w = b - m, k = w - u, S = e.left, A = e.right
                    }
                    const T = p(r.ticks.maxTicksLimit, c),
                        P = Math.max(1, Math.ceil(c / T));
                    for (y = 0; y < c; y += P) {
                        const e = o.setContext(t.getContext(y)),
                            n = e.lineWidth,
                            r = e.color,
                            a = o.borderDash || [],
                            c = e.borderDashOffset,
                            u = e.tickWidth,
                            d = e.tickColor,
                            f = e.tickBorderDash || [],
                            p = e.tickBorderDashOffset;
                        _ = Ni(t, y, s), void 0 !== _ && (x = Ve(i, _, n), l ? w = k = S = A = x : E = O = C = M = x, h.push({
                            tx1: w,
                            ty1: E,
                            tx2: k,
                            ty2: O,
                            x1: S,
                            y1: C,
                            x2: A,
                            y2: M,
                            width: n,
                            color: r,
                            borderDash: a,
                            borderDashOffset: c,
                            tickWidth: u,
                            tickColor: d,
                            tickBorderDash: f,
                            tickBorderDashOffset: p
                        }))
                    }
                    return t._ticksLength = c, t._borderValue = b, h
                }
                _computeLabelItems(e) {
                    const t = this,
                        n = t.axis,
                        i = t.options,
                        {
                            position: r,
                            ticks: o
                        } = i,
                        a = t.isHorizontal(),
                        s = t.ticks,
                        {
                            align: l,
                            crossAlign: c,
                            padding: h,
                            mirror: f
                        } = o,
                        p = ji(i.grid),
                        g = p + h,
                        m = f ? -h : g,
                        v = -V(t.labelRotation),
                        b = [];
                    let y, _, x, w, E, k, O, S, C, A, M, T, P = "middle";
                    if ("top" === r) k = t.bottom - m, O = t._getXAxisLabelAlignment();
                    else if ("bottom" === r) k = t.top + m, O = t._getXAxisLabelAlignment();
                    else if ("left" === r) {
                        const e = t._getYAxisLabelAlignment(p);
                        O = e.textAlign, E = e.x
                    } else if ("right" === r) {
                        const e = t._getYAxisLabelAlignment(p);
                        O = e.textAlign, E = e.x
                    } else if ("x" === n) {
                        if ("center" === r) k = (e.top + e.bottom) / 2 + g;
                        else if (d(r)) {
                            const e = Object.keys(r)[0],
                                n = r[e];
                            k = t.chart.scales[e].getPixelForValue(n) + g
                        }
                        O = t._getXAxisLabelAlignment()
                    } else if ("y" === n) {
                        if ("center" === r) E = (e.left + e.right) / 2 - g;
                        else if (d(r)) {
                            const e = Object.keys(r)[0],
                                n = r[e];
                            E = t.chart.scales[e].getPixelForValue(n)
                        }
                        O = t._getYAxisLabelAlignment(p).textAlign
                    }
                    "y" === n && ("start" === l ? P = "top" : "end" === l && (P = "bottom"));
                    const D = t._getLabelSizes();
                    for (y = 0, _ = s.length; y < _; ++y) {
                        x = s[y], w = x.label;
                        const e = o.setContext(t.getContext(y));
                        S = t.getPixelForTick(y) + o.labelOffset, C = t._resolveTickFontOptions(y), A = C.lineHeight, M = u(w) ? w.length : 1;
                        const n = M / 2,
                            i = e.color,
                            l = e.textStrokeColor,
                            d = e.textStrokeWidth;
                        let h;
                        if (a ? (E = S, T = "top" === r ? "near" === c || 0 !== v ? -M * A + A / 2 : "center" === c ? -D.highest.height / 2 - n * A + A : -D.highest.height + A / 2 : "near" === c || 0 !== v ? A / 2 : "center" === c ? D.highest.height / 2 - n * A : D.highest.height - M * A, f && (T *= -1)) : (k = S, T = (1 - M) * A / 2), e.showLabelBackdrop) {
                            const t = st(e.backdropPadding),
                                n = D.heights[y],
                                i = D.widths[y];
                            let r = k + T - t.top,
                                o = E - t.left;
                            switch (P) {
                                case "middle":
                                    r -= n / 2;
                                    break;
                                case "bottom":
                                    r -= n
                            }
                            switch (O) {
                                case "center":
                                    o -= i / 2;
                                    break;
                                case "right":
                                    o -= i
                            }
                            h = {
                                left: o,
                                top: r,
                                width: i + t.width,
                                height: n + t.height,
                                color: e.backdropColor
                            }
                        }
                        b.push({
                            rotation: v,
                            label: w,
                            font: C,
                            color: i,
                            strokeColor: l,
                            strokeWidth: d,
                            textOffset: T,
                            textAlign: O,
                            textBaseline: P,
                            translation: [E, k],
                            backdrop: h
                        })
                    }
                    return b
                }
                _getXAxisLabelAlignment() {
                    const {
                        position: e,
                        ticks: t
                    } = this.options;
                    if (-V(this.labelRotation)) return "top" === e ? "left" : "right";
                    let n = "center";
                    return "start" === t.align ? n = "left" : "end" === t.align && (n = "right"), n
                }
                _getYAxisLabelAlignment(e) {
                    const t = this,
                        {
                            position: n,
                            ticks: {
                                crossAlign: i,
                                mirror: r,
                                padding: o
                            }
                        } = t.options,
                        a = e + o,
                        s = t._getLabelSizes().widest.width;
                    let l, c;
                    return "left" === n ? r ? (c = t.right + o, "near" === i ? l = "left" : "center" === i ? (l = "center", c += s / 2) : (l = "right", c += s)) : (c = t.right - a, "near" === i ? l = "right" : "center" === i ? (l = "center", c -= s / 2) : (l = "left", c = t.left)) : "right" === n ? r ? (c = t.left + o, "near" === i ? l = "right" : "center" === i ? (l = "center", c -= s / 2) : (l = "left", c -= s)) : (c = t.left + a, "near" === i ? l = "left" : "center" === i ? (l = "center", c += s / 2) : (l = "right", c = t.right)) : l = "right", {
                        textAlign: l,
                        x: c
                    }
                }
                _computeLabelArea() {
                    const e = this;
                    if (e.options.ticks.mirror) return;
                    const t = e.chart,
                        n = e.options.position;
                    return "left" === n || "right" === n ? {
                        top: 0,
                        left: e.left,
                        bottom: t.height,
                        right: e.right
                    } : "top" === n || "bottom" === n ? {
                        top: e.top,
                        left: 0,
                        bottom: e.bottom,
                        right: t.width
                    } : void 0
                }
                drawBackground() {
                    const {
                        ctx: e,
                        options: {
                            backgroundColor: t
                        },
                        left: n,
                        top: i,
                        width: r,
                        height: o
                    } = this;
                    t && (e.save(), e.fillStyle = t, e.fillRect(n, i, r, o), e.restore())
                }
                getLineWidthForValue(e) {
                    const t = this,
                        n = t.options.grid;
                    if (!t._isVisible() || !n.display) return 0;
                    const i = t.ticks.findIndex((t => t.value === e));
                    if (i >= 0) {
                        return n.setContext(t.getContext(i)).lineWidth
                    }
                    return 0
                }
                drawGrid(e) {
                    const t = this,
                        n = t.options.grid,
                        i = t.ctx,
                        r = t._gridLineItems || (t._gridLineItems = t._computeGridLineItems(e));
                    let o, a;
                    const s = (e, t, n) => {
                        n.width && n.color && (i.save(), i.lineWidth = n.width, i.strokeStyle = n.color, i.setLineDash(n.borderDash || []), i.lineDashOffset = n.borderDashOffset, i.beginPath(), i.moveTo(e.x, e.y), i.lineTo(t.x, t.y), i.stroke(), i.restore())
                    };
                    if (n.display)
                        for (o = 0, a = r.length; o < a; ++o) {
                            const e = r[o];
                            n.drawOnChartArea && s({
                                x: e.x1,
                                y: e.y1
                            }, {
                                x: e.x2,
                                y: e.y2
                            }, e), n.drawTicks && s({
                                x: e.tx1,
                                y: e.ty1
                            }, {
                                x: e.tx2,
                                y: e.ty2
                            }, {
                                color: e.tickColor,
                                width: e.tickWidth,
                                borderDash: e.tickBorderDash,
                                borderDashOffset: e.tickBorderDashOffset
                            })
                        }
                }
                drawBorder() {
                    const e = this,
                        {
                            chart: t,
                            ctx: n,
                            options: {
                                grid: i
                            }
                        } = e,
                        r = i.setContext(e.getContext()),
                        o = i.drawBorder ? r.borderWidth : 0;
                    if (!o) return;
                    const a = i.setContext(e.getContext(0)).lineWidth,
                        s = e._borderValue;
                    let l, c, u, d;
                    e.isHorizontal() ? (l = Ve(t, e.left, o) - o / 2, c = Ve(t, e.right, a) + a / 2, u = d = s) : (u = Ve(t, e.top, o) - o / 2, d = Ve(t, e.bottom, a) + a / 2, l = c = s), n.save(), n.lineWidth = r.borderWidth, n.strokeStyle = r.borderColor, n.beginPath(), n.moveTo(l, u), n.lineTo(c, d), n.stroke(), n.restore()
                }
                drawLabels(e) {
                    const t = this;
                    if (!t.options.ticks.display) return;
                    const n = t.ctx,
                        i = t._computeLabelArea();
                    i && Ke(n, i);
                    const r = t._labelItems || (t._labelItems = t._computeLabelItems(e));
                    let o, a;
                    for (o = 0, a = r.length; o < a; ++o) {
                        const e = r[o],
                            t = e.font,
                            i = e.label;
                        e.backdrop && (n.fillStyle = e.backdrop.color, n.fillRect(e.backdrop.left, e.backdrop.top, e.backdrop.width, e.backdrop.height)), Qe(n, i, 0, e.textOffset, t, e)
                    }
                    i && Ge(n)
                }
                drawTitle() {
                    const {
                        ctx: e,
                        options: {
                            position: t,
                            title: n,
                            reverse: i
                        }
                    } = this;
                    if (!n.display) return;
                    const r = lt(n.font),
                        o = st(n.padding),
                        s = n.align;
                    let l = r.lineHeight / 2;
                    "bottom" === t || "center" === t || d(t) ? (l += o.bottom, u(n.text) && (l += r.lineHeight * (n.text.length - 1))) : l += o.top;
                    const {
                        titleX: c,
                        titleY: h,
                        maxWidth: f,
                        rotation: p
                    } = function (e, t, n, i) {
                        const {
                            top: r,
                            left: o,
                            bottom: s,
                            right: l,
                            chart: c
                        } = e, {
                            chartArea: u,
                            scales: h
                        } = c;
                        let f, p, g, m = 0;
                        const v = s - r,
                            b = l - o;
                        if (e.isHorizontal()) {
                            if (p = a(i, o, l), d(n)) {
                                const e = Object.keys(n)[0],
                                    i = n[e];
                                g = h[e].getPixelForValue(i) + v - t
                            } else g = "center" === n ? (u.bottom + u.top) / 2 + v - t : Di(e, n, t);
                            f = l - o
                        } else {
                            if (d(n)) {
                                const e = Object.keys(n)[0],
                                    i = n[e];
                                p = h[e].getPixelForValue(i) - b + t
                            } else p = "center" === n ? (u.left + u.right) / 2 - b + t : Di(e, n, t);
                            g = a(i, s, r), m = "left" === n ? -j : j
                        }
                        return {
                            titleX: p,
                            titleY: g,
                            maxWidth: f,
                            rotation: m
                        }
                    }(this, l, t, s);
                    Qe(e, n.text, 0, 0, r, {
                        color: n.color,
                        maxWidth: f,
                        rotation: p,
                        textAlign: Ri(s, t, i),
                        textBaseline: "middle",
                        translation: [c, h]
                    })
                }
                draw(e) {
                    const t = this;
                    t._isVisible() && (t.drawBackground(), t.drawGrid(e), t.drawBorder(), t.drawTitle(), t.drawLabels(e))
                }
                _layers() {
                    const e = this,
                        t = e.options,
                        n = t.ticks && t.ticks.z || 0,
                        i = p(t.grid && t.grid.z, -1);
                    return e._isVisible() && e.draw === Fi.prototype.draw ? [{
                        z: i,
                        draw(t) {
                            e.drawBackground(), e.drawGrid(t), e.drawTitle()
                        }
                    }, {
                        z: i + 1,
                        draw() {
                            e.drawBorder()
                        }
                    }, {
                        z: n,
                        draw(t) {
                            e.drawLabels(t)
                        }
                    }] : [{
                        z: n,
                        draw(t) {
                            e.draw(t)
                        }
                    }]
                }
                getMatchingVisibleMetas(e) {
                    const t = this,
                        n = t.chart.getSortedVisibleDatasetMetas(),
                        i = t.axis + "AxisID",
                        r = [];
                    let o, a;
                    for (o = 0, a = n.length; o < a; ++o) {
                        const a = n[o];
                        a[i] !== t.id || e && a.type !== e || r.push(a)
                    }
                    return r
                }
                _resolveTickFontOptions(e) {
                    return lt(this.options.ticks.setContext(this.getContext(e)).font)
                }
                _maxDigits() {
                    const e = this,
                        t = e._resolveTickFontOptions(0).lineHeight;
                    return (e.isHorizontal() ? e.width : e.height) / t
                }
            }
            class Bi {
                constructor(e, t, n) {
                    this.type = e, this.scope = t, this.override = n, this.items = Object.create(null)
                }
                isForType(e) {
                    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype)
                }
                register(e) {
                    const t = this,
                        n = Object.getPrototypeOf(e);
                    let i;
                    (function (e) {
                        return "id" in e && "defaults" in e
                    })(n) && (i = t.register(n));
                    const r = t.items,
                        o = e.id,
                        a = t.scope + "." + o;
                    if (!o) throw new Error("class does not have id: " + e);
                    return o in r || (r[o] = e, function (e, t, n) {
                        const i = w(Object.create(null), [n ? ze.get(n) : {}, ze.get(t), e.defaults]);
                        ze.set(t, i), e.defaultRoutes && function (e, t) {
                            Object.keys(t).forEach((n => {
                                const i = n.split("."),
                                    r = i.pop(),
                                    o = [e].concat(i).join("."),
                                    a = t[n].split("."),
                                    s = a.pop(),
                                    l = a.join(".");
                                ze.route(o, r, l, s)
                            }))
                        }(t, e.defaultRoutes);
                        e.descriptors && ze.describe(t, e.descriptors)
                    }(e, a, i), t.override && ze.override(e.id, e.overrides)), a
                }
                get(e) {
                    return this.items[e]
                }
                unregister(e) {
                    const t = this.items,
                        n = e.id,
                        i = this.scope;
                    n in t && delete t[n], i && n in ze[i] && (delete ze[i][n], this.override && delete Re[n])
                }
            }
            var qi = new class {
                constructor() {
                    this.controllers = new Bi(Cn, "datasets", !0), this.elements = new Bi(Ci, "elements"), this.plugins = new Bi(Object, "plugins"), this.scales = new Bi(Fi, "scales"), this._typedRegistries = [this.controllers, this.scales, this.elements]
                }
                add(...e) {
                    this._each("register", e)
                }
                remove(...e) {
                    this._each("unregister", e)
                }
                addControllers(...e) {
                    this._each("register", e, this.controllers)
                }
                addElements(...e) {
                    this._each("register", e, this.elements)
                }
                addPlugins(...e) {
                    this._each("register", e, this.plugins)
                }
                addScales(...e) {
                    this._each("register", e, this.scales)
                }
                getController(e) {
                    return this._get(e, this.controllers, "controller")
                }
                getElement(e) {
                    return this._get(e, this.elements, "element")
                }
                getPlugin(e) {
                    return this._get(e, this.plugins, "plugin")
                }
                getScale(e) {
                    return this._get(e, this.scales, "scale")
                }
                removeControllers(...e) {
                    this._each("unregister", e, this.controllers)
                }
                removeElements(...e) {
                    this._each("unregister", e, this.elements)
                }
                removePlugins(...e) {
                    this._each("unregister", e, this.plugins)
                }
                removeScales(...e) {
                    this._each("unregister", e, this.scales)
                }
                _each(e, t, n) {
                    const i = this;
                    [...t].forEach((t => {
                        const r = n || i._getRegistryForType(t);
                        n || r.isForType(t) || r === i.plugins && t.id ? i._exec(e, r, t) : v(t, (t => {
                            const r = n || i._getRegistryForType(t);
                            i._exec(e, r, t)
                        }))
                    }))
                }
                _exec(e, t, n) {
                    const i = C(e);
                    m(n["before" + i], [], n), t[e](n), m(n["after" + i], [], n)
                }
                _getRegistryForType(e) {
                    for (let t = 0; t < this._typedRegistries.length; t++) {
                        const n = this._typedRegistries[t];
                        if (n.isForType(e)) return n
                    }
                    return this.plugins
                }
                _get(e, t, n) {
                    const i = t.get(e);
                    if (void 0 === i) throw new Error('"' + e + '" is not a registered ' + n + ".");
                    return i
                }
            };
            class zi {
                constructor() {
                    this._init = []
                }
                notify(e, t, n, i) {
                    const r = this;
                    "beforeInit" === t && (r._init = r._createDescriptors(e, !0), r._notify(r._init, e, "install"));
                    const o = i ? r._descriptors(e).filter(i) : r._descriptors(e),
                        a = r._notify(o, e, t, n);
                    return "destroy" === t && (r._notify(o, e, "stop"), r._notify(r._init, e, "uninstall")), a
                }
                _notify(e, t, n, i) {
                    i = i || {};
                    for (const r of e) {
                        const e = r.plugin;
                        if (!1 === m(e[n], [t, i, r.options], e) && i.cancelable) return !1
                    }
                    return !0
                }
                invalidate() {
                    c(this._cache) || (this._oldCache = this._cache, this._cache = void 0)
                }
                _descriptors(e) {
                    if (this._cache) return this._cache;
                    const t = this._cache = this._createDescriptors(e);
                    return this._notifyStateChanges(e), t
                }
                _createDescriptors(e, t) {
                    const n = e && e.config,
                        i = p(n.options && n.options.plugins, {}),
                        r = function (e) {
                            const t = [],
                                n = Object.keys(qi.plugins.items);
                            for (let e = 0; e < n.length; e++) t.push(qi.getPlugin(n[e]));
                            const i = e.plugins || [];
                            for (let e = 0; e < i.length; e++) {
                                const n = i[e]; - 1 === t.indexOf(n) && t.push(n)
                            }
                            return t
                        }(n);
                    return !1 !== i || t ? function (e, t, n, i) {
                        const r = [],
                            o = e.getContext();
                        for (let a = 0; a < t.length; a++) {
                            const s = t[a],
                                l = Hi(n[s.id], i);
                            null !== l && r.push({
                                plugin: s,
                                options: Ui(e.config, s, l, o)
                            })
                        }
                        return r
                    }(e, r, i, t) : []
                }
                _notifyStateChanges(e) {
                    const t = this._oldCache || [],
                        n = this._cache,
                        i = (e, t) => e.filter((e => !t.some((t => e.plugin.id === t.plugin.id))));
                    this._notify(i(t, n), e, "stop"), this._notify(i(n, t), e, "start")
                }
            }

            function Hi(e, t) {
                return t || !1 !== e ? !0 === e ? {} : e : null
            }

            function Ui(e, t, n, i) {
                const r = e.pluginScopeKeys(t),
                    o = e.getOptionScopes(n, r);
                return e.createResolver(o, i, [""], {
                    scriptable: !1,
                    indexable: !1,
                    allKeys: !0
                })
            }

            function Vi(e, t) {
                const n = ze.datasets[e] || {};
                return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x"
            }

            function Wi(e, t) {
                return "x" === e || "y" === e ? e : t.axis || ("top" === (n = t.position) || "bottom" === n ? "x" : "left" === n || "right" === n ? "y" : void 0) || e.charAt(0).toLowerCase();
                var n
            }

            function Yi(e) {
                const t = e.options || (e.options = {});
                t.plugins = p(t.plugins, {}), t.scales = function (e, t) {
                    const n = Re[e.type] || {
                            scales: {}
                        },
                        i = t.scales || {},
                        r = Vi(e.type, t),
                        o = Object.create(null),
                        a = Object.create(null);
                    return Object.keys(i).forEach((e => {
                        const t = i[e],
                            s = Wi(e, t),
                            l = function (e, t) {
                                return e === t ? "_index_" : "_value_"
                            }(s, r),
                            c = n.scales || {};
                        o[s] = o[s] || e, a[e] = E(Object.create(null), [{
                            axis: s
                        }, t, c[s], c[l]])
                    })), e.data.datasets.forEach((n => {
                        const r = n.type || e.type,
                            s = n.indexAxis || Vi(r, t),
                            l = (Re[r] || {}).scales || {};
                        Object.keys(l).forEach((e => {
                            const t = function (e, t) {
                                    let n = e;
                                    return "_index_" === e ? n = t : "_value_" === e && (n = "x" === t ? "y" : "x"), n
                                }(e, s),
                                r = n[t + "AxisID"] || o[t] || t;
                            a[r] = a[r] || Object.create(null), E(a[r], [{
                                axis: t
                            }, i[r], l[e]])
                        }))
                    })), Object.keys(a).forEach((e => {
                        const t = a[e];
                        E(t, [ze.scales[t.type], ze.scale])
                    })), a
                }(e, t)
            }

            function $i(e) {
                return (e = e || {}).datasets = e.datasets || [], e.labels = e.labels || [], e
            }
            const Ki = new Map,
                Gi = new Set;

            function Xi(e, t) {
                let n = Ki.get(e);
                return n || (n = t(), Ki.set(e, n), Gi.add(n)), n
            }
            const Zi = (e, t, n) => {
                const i = S(t, n);
                void 0 !== i && e.add(i)
            };
            class Qi {
                constructor(e) {
                    this._config = function (e) {
                        return (e = e || {}).data = $i(e.data), Yi(e), e
                    }(e), this._scopeCache = new Map, this._resolverCache = new Map
                }
                get platform() {
                    return this._config.platform
                }
                get type() {
                    return this._config.type
                }
                set type(e) {
                    this._config.type = e
                }
                get data() {
                    return this._config.data
                }
                set data(e) {
                    this._config.data = $i(e)
                }
                get options() {
                    return this._config.options
                }
                set options(e) {
                    this._config.options = e
                }
                get plugins() {
                    return this._config.plugins
                }
                update() {
                    const e = this._config;
                    this.clearCache(), Yi(e)
                }
                clearCache() {
                    this._scopeCache.clear(), this._resolverCache.clear()
                }
                datasetScopeKeys(e) {
                    return Xi(e, (() => [
                        [`datasets.${e}`, ""]
                    ]))
                }
                datasetAnimationScopeKeys(e, t) {
                    return Xi(`${e}.transition.${t}`, (() => [
                        [`datasets.${e}.transitions.${t}`, `transitions.${t}`],
                        [`datasets.${e}`, ""]
                    ]))
                }
                datasetElementScopeKeys(e, t) {
                    return Xi(`${e}-${t}`, (() => [
                        [`datasets.${e}.elements.${t}`, `datasets.${e}`, `elements.${t}`, ""]
                    ]))
                }
                pluginScopeKeys(e) {
                    const t = e.id;
                    return Xi(`${this.type}-plugin-${t}`, (() => [
                        [`plugins.${t}`, ...e.additionalOptionScopes || []]
                    ]))
                }
                _cachedScopes(e, t) {
                    const n = this._scopeCache;
                    let i = n.get(e);
                    return i && !t || (i = new Map, n.set(e, i)), i
                }
                getOptionScopes(e, t, n) {
                    const {
                        options: i,
                        type: r
                    } = this, o = this._cachedScopes(e, n), a = o.get(t);
                    if (a) return a;
                    const s = new Set;
                    t.forEach((t => {
                        e && (s.add(e), t.forEach((t => Zi(s, e, t)))), t.forEach((e => Zi(s, i, e))), t.forEach((e => Zi(s, Re[r] || {}, e))), t.forEach((e => Zi(s, ze, e))), t.forEach((e => Zi(s, Fe, e)))
                    }));
                    const l = Array.from(s);
                    return 0 === l.length && l.push(Object.create(null)), Gi.has(t) && o.set(t, l), l
                }
                chartOptionScopes() {
                    const {
                        options: e,
                        type: t
                    } = this;
                    return [e, Re[t] || {}, ze.datasets[t] || {}, {
                        type: t
                    }, ze, Fe]
                }
                resolveNamedOptions(e, t, n, i = [""]) {
                    const r = {
                            $shared: !0
                        },
                        {
                            resolver: o,
                            subPrefixes: a
                        } = Ji(this._resolverCache, e, i);
                    let s = o;
                    if (function (e, t) {
                            const {
                                isScriptable: n,
                                isIndexable: i
                            } = bt(e);
                            for (const r of t)
                                if (n(r) && M(e[r]) || i(r) && u(e[r])) return !0;
                            return !1
                        }(o, t)) {
                        r.$shared = !1;
                        s = vt(o, n = M(n) ? n() : n, this.createResolver(e, n, a))
                    }
                    for (const e of t) r[e] = s[e];
                    return r
                }
                createResolver(e, t, n = [""], i) {
                    const {
                        resolver: r
                    } = Ji(this._resolverCache, e, n);
                    return d(t) ? vt(r, t, void 0, i) : r
                }
            }

            function Ji(e, t, n) {
                let i = e.get(t);
                i || (i = new Map, e.set(t, i));
                const r = n.join();
                let o = i.get(r);
                if (!o) {
                    o = {
                        resolver: mt(t, n),
                        subPrefixes: n.filter((e => !e.toLowerCase().includes("hover")))
                    }, i.set(r, o)
                }
                return o
            }
            const er = ["top", "bottom", "left", "right", "chartArea"];

            function tr(e, t) {
                return "top" === e || "bottom" === e || -1 === er.indexOf(e) && "x" === t
            }

            function nr(e, t) {
                return function (n, i) {
                    return n[e] === i[e] ? n[t] - i[t] : n[e] - i[e]
                }
            }

            function ir(e) {
                const t = e.chart,
                    n = t.options.animation;
                t.notifyPlugins("afterRender"), m(n && n.onComplete, [e], t)
            }

            function rr(e) {
                const t = e.chart,
                    n = t.options.animation;
                m(n && n.onProgress, [e], t)
            }

            function or(e) {
                return It() && "string" == typeof e ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e
            }
            const ar = {},
                sr = e => {
                    const t = or(e);
                    return Object.values(ar).filter((e => e.canvas === t)).pop()
                };
            class lr {
                constructor(e, t) {
                    const n = this,
                        i = this.config = new Qi(t),
                        r = or(e),
                        o = sr(r);
                    if (o) throw new Error("Canvas is already in use. Chart with ID '" + o.id + "' must be destroyed before the canvas can be reused.");
                    const a = i.createResolver(i.chartOptionScopes(), n.getContext());
                    this.platform = new(i.platform || function (e) {
                        return !It() || "undefined" != typeof OffscreenCanvas && e instanceof OffscreenCanvas ? fi : Si
                    }(r));
                    const s = n.platform.acquireContext(r, a.aspectRatio),
                        c = s && s.canvas,
                        u = c && c.height,
                        d = c && c.width;
                    this.id = l(), this.ctx = s, this.canvas = c, this.width = d, this.height = u, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new zi, this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = function (e, t) {
                        let n;
                        return function () {
                            return t ? (clearTimeout(n), n = setTimeout(e, t)) : e(), t
                        }
                    }((() => this.update("resize")), a.resizeDelay || 0), ar[n.id] = n, s && c ? (un.listen(n, "complete", ir), un.listen(n, "progress", rr), n._initialize(), n.attached && n.update()) : console.error("Failed to create chart: can't acquire context from the given item")
                }
                get aspectRatio() {
                    const {
                        options: {
                            aspectRatio: e,
                            maintainAspectRatio: t
                        },
                        width: n,
                        height: i,
                        _aspectRatio: r
                    } = this;
                    return c(e) ? t && r ? r : i ? n / i : null : e
                }
                get data() {
                    return this.config.data
                }
                set data(e) {
                    this.config.data = e
                }
                get options() {
                    return this._options
                }
                set options(e) {
                    this.config.options = e
                }
                _initialize() {
                    const e = this;
                    return e.notifyPlugins("beforeInit"), e.options.responsive ? e.resize() : Wt(e, e.options.devicePixelRatio), e.bindEvents(), e.notifyPlugins("afterInit"), e
                }
                clear() {
                    return We(this.canvas, this.ctx), this
                }
                stop() {
                    return un.stop(this), this
                }
                resize(e, t) {
                    un.running(this) ? this._resizeBeforeDraw = {
                        width: e,
                        height: t
                    } : this._resize(e, t)
                }
                _resize(e, t) {
                    const n = this,
                        i = n.options,
                        r = n.canvas,
                        o = i.maintainAspectRatio && n.aspectRatio,
                        a = n.platform.getMaximumSize(r, e, t, o),
                        s = i.devicePixelRatio || n.platform.getDevicePixelRatio();
                    n.width = a.width, n.height = a.height, n._aspectRatio = n.aspectRatio, Wt(n, s, !0) && (n.notifyPlugins("resize", {
                        size: a
                    }), m(i.onResize, [n, a], n), n.attached && n._doResize() && n.render())
                }
                ensureScalesHaveIDs() {
                    v(this.options.scales || {}, ((e, t) => {
                        e.id = t
                    }))
                }
                buildOrUpdateScales() {
                    const e = this,
                        t = e.options,
                        n = t.scales,
                        i = e.scales,
                        r = Object.keys(i).reduce(((e, t) => (e[t] = !1, e)), {});
                    let o = [];
                    n && (o = o.concat(Object.keys(n).map((e => {
                        const t = n[e],
                            i = Wi(e, t),
                            r = "r" === i,
                            o = "x" === i;
                        return {
                            options: t,
                            dposition: r ? "chartArea" : o ? "bottom" : "left",
                            dtype: r ? "radialLinear" : o ? "category" : "linear"
                        }
                    })))), v(o, (n => {
                        const o = n.options,
                            a = o.id,
                            s = Wi(a, o),
                            l = p(o.type, n.dtype);
                        void 0 !== o.position && tr(o.position, s) === tr(n.dposition) || (o.position = n.dposition), r[a] = !0;
                        let c = null;
                        if (a in i && i[a].type === l) c = i[a];
                        else {
                            c = new(qi.getScale(l))({
                                id: a,
                                type: l,
                                ctx: e.ctx,
                                chart: e
                            }), i[c.id] = c
                        }
                        c.init(o, t)
                    })), v(r, ((e, t) => {
                        e || delete i[t]
                    })), v(i, (t => {
                        di.configure(e, t, t.options), di.addBox(e, t)
                    }))
                }
                _updateMetasets() {
                    const e = this,
                        t = e._metasets,
                        n = e.data.datasets.length,
                        i = t.length;
                    if (t.sort(((e, t) => e.index - t.index)), i > n) {
                        for (let t = n; t < i; ++t) e._destroyDatasetMeta(t);
                        t.splice(n, i - n)
                    }
                    e._sortedMetasets = t.slice(0).sort(nr("order", "index"))
                }
                _removeUnreferencedMetasets() {
                    const e = this,
                        {
                            _metasets: t,
                            data: {
                                datasets: n
                            }
                        } = e;
                    t.length > n.length && delete e._stacks, t.forEach(((t, i) => {
                        0 === n.filter((e => e === t._dataset)).length && e._destroyDatasetMeta(i)
                    }))
                }
                buildOrUpdateControllers() {
                    const e = this,
                        t = [],
                        n = e.data.datasets;
                    let i, r;
                    for (e._removeUnreferencedMetasets(), i = 0, r = n.length; i < r; i++) {
                        const r = n[i];
                        let o = e.getDatasetMeta(i);
                        const a = r.type || e.config.type;
                        if (o.type && o.type !== a && (e._destroyDatasetMeta(i), o = e.getDatasetMeta(i)), o.type = a, o.indexAxis = r.indexAxis || Vi(a, e.options), o.order = r.order || 0, o.index = i, o.label = "" + r.label, o.visible = e.isDatasetVisible(i), o.controller) o.controller.updateIndex(i), o.controller.linkScales();
                        else {
                            const n = qi.getController(a),
                                {
                                    datasetElementType: r,
                                    dataElementType: s
                                } = ze.datasets[a];
                            Object.assign(n.prototype, {
                                dataElementType: qi.getElement(s),
                                datasetElementType: r && qi.getElement(r)
                            }), o.controller = new n(e, i), t.push(o.controller)
                        }
                    }
                    return e._updateMetasets(), t
                }
                _resetElements() {
                    const e = this;
                    v(e.data.datasets, ((t, n) => {
                        e.getDatasetMeta(n).controller.reset()
                    }), e)
                }
                reset() {
                    this._resetElements(), this.notifyPlugins("reset")
                }
                update(e) {
                    const t = this,
                        n = t.config;
                    n.update(), t._options = n.createResolver(n.chartOptionScopes(), t.getContext()), v(t.scales, (e => {
                        di.removeBox(t, e)
                    }));
                    const i = t._animationsDisabled = !t.options.animation;
                    t.ensureScalesHaveIDs(), t.buildOrUpdateScales();
                    if (((e, t) => {
                            if (e.size !== t.size) return !1;
                            for (const n of e)
                                if (!t.has(n)) return !1;
                            return !0
                        })(new Set(Object.keys(t._listeners)), new Set(t.options.events)) && !!this._responsiveListeners === t.options.responsive || (t.unbindEvents(), t.bindEvents()), t._plugins.invalidate(), !1 === t.notifyPlugins("beforeUpdate", {
                            mode: e,
                            cancelable: !0
                        })) return;
                    const r = t.buildOrUpdateControllers();
                    t.notifyPlugins("beforeElementsUpdate");
                    let o = 0;
                    for (let e = 0, n = t.data.datasets.length; e < n; e++) {
                        const {
                            controller: n
                        } = t.getDatasetMeta(e), a = !i && -1 === r.indexOf(n);
                        n.buildOrUpdateElements(a), o = Math.max(+n.getMaxOverflow(), o)
                    }
                    t._minPadding = o, t._updateLayout(o), i || v(r, (e => {
                        e.reset()
                    })), t._updateDatasets(e), t.notifyPlugins("afterUpdate", {
                        mode: e
                    }), t._layers.sort(nr("z", "_idx")), t._lastEvent && t._eventHandler(t._lastEvent, !0), t.render()
                }
                _updateLayout(e) {
                    const t = this;
                    if (!1 === t.notifyPlugins("beforeLayout", {
                            cancelable: !0
                        })) return;
                    di.update(t, t.width, t.height, e);
                    const n = t.chartArea,
                        i = n.width <= 0 || n.height <= 0;
                    t._layers = [], v(t.boxes, (e => {
                        i && "chartArea" === e.position || (e.configure && e.configure(), t._layers.push(...e._layers()))
                    }), t), t._layers.forEach(((e, t) => {
                        e._idx = t
                    })), t.notifyPlugins("afterLayout")
                }
                _updateDatasets(e) {
                    const t = this,
                        n = "function" == typeof e;
                    if (!1 !== t.notifyPlugins("beforeDatasetsUpdate", {
                            mode: e,
                            cancelable: !0
                        })) {
                        for (let i = 0, r = t.data.datasets.length; i < r; ++i) t._updateDataset(i, n ? e({
                            datasetIndex: i
                        }) : e);
                        t.notifyPlugins("afterDatasetsUpdate", {
                            mode: e
                        })
                    }
                }
                _updateDataset(e, t) {
                    const n = this,
                        i = n.getDatasetMeta(e),
                        r = {
                            meta: i,
                            index: e,
                            mode: t,
                            cancelable: !0
                        };
                    !1 !== n.notifyPlugins("beforeDatasetUpdate", r) && (i.controller._update(t), r.cancelable = !1, n.notifyPlugins("afterDatasetUpdate", r))
                }
                render() {
                    const e = this;
                    !1 !== e.notifyPlugins("beforeRender", {
                        cancelable: !0
                    }) && (un.has(e) ? e.attached && !un.running(e) && un.start(e) : (e.draw(), ir({
                        chart: e
                    })))
                }
                draw() {
                    const e = this;
                    let t;
                    if (e._resizeBeforeDraw) {
                        const {
                            width: t,
                            height: n
                        } = e._resizeBeforeDraw;
                        e._resize(t, n), e._resizeBeforeDraw = null
                    }
                    if (e.clear(), e.width <= 0 || e.height <= 0) return;
                    if (!1 === e.notifyPlugins("beforeDraw", {
                            cancelable: !0
                        })) return;
                    const n = e._layers;
                    for (t = 0; t < n.length && n[t].z <= 0; ++t) n[t].draw(e.chartArea);
                    for (e._drawDatasets(); t < n.length; ++t) n[t].draw(e.chartArea);
                    e.notifyPlugins("afterDraw")
                }
                _getSortedDatasetMetas(e) {
                    const t = this._sortedMetasets,
                        n = [];
                    let i, r;
                    for (i = 0, r = t.length; i < r; ++i) {
                        const r = t[i];
                        e && !r.visible || n.push(r)
                    }
                    return n
                }
                getSortedVisibleDatasetMetas() {
                    return this._getSortedDatasetMetas(!0)
                }
                _drawDatasets() {
                    const e = this;
                    if (!1 === e.notifyPlugins("beforeDatasetsDraw", {
                            cancelable: !0
                        })) return;
                    const t = e.getSortedVisibleDatasetMetas();
                    for (let n = t.length - 1; n >= 0; --n) e._drawDataset(t[n]);
                    e.notifyPlugins("afterDatasetsDraw")
                }
                _drawDataset(e) {
                    const t = this,
                        n = t.ctx,
                        i = e._clip,
                        r = !i.disabled,
                        o = t.chartArea,
                        a = {
                            meta: e,
                            index: e.index,
                            cancelable: !0
                        };
                    !1 !== t.notifyPlugins("beforeDatasetDraw", a) && (r && Ke(n, {
                        left: !1 === i.left ? 0 : o.left - i.left,
                        right: !1 === i.right ? t.width : o.right + i.right,
                        top: !1 === i.top ? 0 : o.top - i.top,
                        bottom: !1 === i.bottom ? t.height : o.bottom + i.bottom
                    }), e.controller.draw(), r && Ge(n), a.cancelable = !1, t.notifyPlugins("afterDatasetDraw", a))
                }
                getElementsAtEventForMode(e, t, n, i) {
                    const r = Qn.modes[t];
                    return "function" == typeof r ? r(this, e, n, i) : []
                }
                getDatasetMeta(e) {
                    const t = this.data.datasets[e],
                        n = this._metasets;
                    let i = n.filter((e => e && e._dataset === t)).pop();
                    return i || (i = {
                        type: null,
                        data: [],
                        dataset: null,
                        controller: null,
                        hidden: null,
                        xAxisID: null,
                        yAxisID: null,
                        order: t && t.order || 0,
                        index: e,
                        _dataset: t,
                        _parsed: [],
                        _sorted: !1
                    }, n.push(i)), i
                }
                getContext() {
                    return this.$context || (this.$context = {
                        chart: this,
                        type: "chart"
                    })
                }
                getVisibleDatasetCount() {
                    return this.getSortedVisibleDatasetMetas().length
                }
                isDatasetVisible(e) {
                    const t = this.data.datasets[e];
                    if (!t) return !1;
                    const n = this.getDatasetMeta(e);
                    return "boolean" == typeof n.hidden ? !n.hidden : !t.hidden
                }
                setDatasetVisibility(e, t) {
                    this.getDatasetMeta(e).hidden = !t
                }
                toggleDataVisibility(e) {
                    this._hiddenIndices[e] = !this._hiddenIndices[e]
                }
                getDataVisibility(e) {
                    return !this._hiddenIndices[e]
                }
                _updateVisibility(e, t, n) {
                    const i = this,
                        r = n ? "show" : "hide",
                        o = i.getDatasetMeta(e),
                        a = o.controller._resolveAnimations(void 0, r);
                    A(t) ? (o.data[t].hidden = !n, i.update()) : (i.setDatasetVisibility(e, n), a.update(o, {
                        visible: n
                    }), i.update((t => t.datasetIndex === e ? r : void 0)))
                }
                hide(e, t) {
                    this._updateVisibility(e, t, !1)
                }
                show(e, t) {
                    this._updateVisibility(e, t, !0)
                }
                _destroyDatasetMeta(e) {
                    const t = this,
                        n = t._metasets && t._metasets[e];
                    n && n.controller && (n.controller._destroy(), delete t._metasets[e])
                }
                destroy() {
                    const e = this,
                        {
                            canvas: t,
                            ctx: n
                        } = e;
                    let i, r;
                    for (e.stop(), un.remove(e), i = 0, r = e.data.datasets.length; i < r; ++i) e._destroyDatasetMeta(i);
                    e.config.clearCache(), t && (e.unbindEvents(), We(t, n), e.platform.releaseContext(n), e.canvas = null, e.ctx = null), e.notifyPlugins("destroy"), delete ar[e.id]
                }
                toBase64Image(...e) {
                    return this.canvas.toDataURL(...e)
                }
                bindEvents() {
                    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0
                }
                bindUserEvents() {
                    const e = this,
                        t = e._listeners,
                        n = e.platform,
                        i = function (t, n, i) {
                            t.offsetX = n, t.offsetY = i, e._eventHandler(t)
                        };
                    v(e.options.events, (r => ((i, r) => {
                        n.addEventListener(e, i, r), t[i] = r
                    })(r, i)))
                }
                bindResponsiveEvents() {
                    const e = this;
                    e._responsiveListeners || (e._responsiveListeners = {});
                    const t = e._responsiveListeners,
                        n = e.platform,
                        i = (i, r) => {
                            n.addEventListener(e, i, r), t[i] = r
                        },
                        r = (i, r) => {
                            t[i] && (n.removeEventListener(e, i, r), delete t[i])
                        },
                        o = (t, n) => {
                            e.canvas && e.resize(t, n)
                        };
                    let a;
                    const s = () => {
                        r("attach", s), e.attached = !0, e.resize(), i("resize", o), i("detach", a)
                    };
                    a = () => {
                        e.attached = !1, r("resize", o), i("attach", s)
                    }, n.isAttached(e.canvas) ? s() : a()
                }
                unbindEvents() {
                    const e = this;
                    v(e._listeners, ((t, n) => {
                        e.platform.removeEventListener(e, n, t)
                    })), e._listeners = {}, v(e._responsiveListeners, ((t, n) => {
                        e.platform.removeEventListener(e, n, t)
                    })), e._responsiveListeners = void 0
                }
                updateHoverStyle(e, t, n) {
                    const i = n ? "set" : "remove";
                    let r, o, a, s;
                    for ("dataset" === t && (r = this.getDatasetMeta(e[0].datasetIndex), r.controller["_" + i + "DatasetHoverStyle"]()), a = 0, s = e.length; a < s; ++a) {
                        o = e[a];
                        const t = o && this.getDatasetMeta(o.datasetIndex).controller;
                        t && t[i + "HoverStyle"](o.element, o.datasetIndex, o.index)
                    }
                }
                getActiveElements() {
                    return this._active || []
                }
                setActiveElements(e) {
                    const t = this,
                        n = t._active || [],
                        i = e.map((({
                            datasetIndex: e,
                            index: n
                        }) => {
                            const i = t.getDatasetMeta(e);
                            if (!i) throw new Error("No dataset found at index " + e);
                            return {
                                datasetIndex: e,
                                element: i.data[n],
                                index: n
                            }
                        }));
                    !b(i, n) && (t._active = i, t._updateHoverStyles(i, n))
                }
                notifyPlugins(e, t, n) {
                    return this._plugins.notify(this, e, t, n)
                }
                _updateHoverStyles(e, t, n) {
                    const i = this,
                        r = i.options.hover,
                        o = (e, t) => e.filter((e => !t.some((t => e.datasetIndex === t.datasetIndex && e.index === t.index)))),
                        a = o(t, e),
                        s = n ? e : o(e, t);
                    a.length && i.updateHoverStyle(a, r.mode, !1), s.length && r.mode && i.updateHoverStyle(s, r.mode, !0)
                }
                _eventHandler(e, t) {
                    const n = this,
                        i = {
                            event: e,
                            replay: t,
                            cancelable: !0
                        },
                        r = t => (t.options.events || this.options.events).includes(e.type);
                    if (!1 === n.notifyPlugins("beforeEvent", i, r)) return;
                    const o = n._handleEvent(e, t);
                    return i.cancelable = !1, n.notifyPlugins("afterEvent", i, r), (o || i.changed) && n.render(), n
                }
                _handleEvent(e, t) {
                    const n = this,
                        {
                            _active: i = [],
                            options: r
                        } = n,
                        o = r.hover,
                        a = t;
                    let s = [],
                        l = !1,
                        c = null;
                    return "mouseout" !== e.type && (s = n.getElementsAtEventForMode(e, o.mode, o, a), c = "click" === e.type ? n._lastEvent : e), n._lastEvent = null, $e(e, n.chartArea, n._minPadding) && (m(r.onHover, [e, s, n], n), "mouseup" !== e.type && "click" !== e.type && "contextmenu" !== e.type || m(r.onClick, [e, s, n], n)), l = !b(s, i), (l || t) && (n._active = s, n._updateHoverStyles(s, i, t)), n._lastEvent = c, l
                }
            }
            const cr = () => v(lr.instances, (e => e._plugins.invalidate())),
                ur = !0;

            function dr(e, t, n) {
                const {
                    startAngle: i,
                    pixelMargin: r,
                    x: o,
                    y: a,
                    outerRadius: s,
                    innerRadius: l
                } = t;
                let c = r / s;
                e.beginPath(), e.arc(o, a, s, i - c, n + c), l > r ? (c = r / l, e.arc(o, a, l, n + c, i - c, !0)) : e.arc(o, a, r, n + j, i - j), e.closePath(), e.clip()
            }

            function hr(e, t, n, i) {
                const r = rt(e.options.borderRadius, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
                const o = (n - t) / 2,
                    a = Math.min(o, i * t / 2),
                    s = e => {
                        const t = (n - Math.min(o, e)) * i / 2;
                        return Z(e, 0, Math.min(o, t))
                    };
                return {
                    outerStart: s(r.outerStart),
                    outerEnd: s(r.outerEnd),
                    innerStart: Z(r.innerStart, 0, a),
                    innerEnd: Z(r.innerEnd, 0, a)
                }
            }

            function fr(e, t, n, i) {
                return {
                    x: n + e * Math.cos(t),
                    y: i + e * Math.sin(t)
                }
            }

            function pr(e, t, n, i, r) {
                const {
                    x: o,
                    y: a,
                    startAngle: s,
                    pixelMargin: l,
                    innerRadius: c
                } = t, u = Math.max(t.outerRadius + i + n - l, 0), d = c > 0 ? c + i + n + l : 0;
                let h = 0;
                const f = r - s;
                if (i) {
                    const e = ((c > 0 ? c - i : 0) + (u > 0 ? u - i : 0)) / 2;
                    h = (f - (0 !== e ? f * e / (e + i) : f)) / 2
                }
                const p = (f - Math.max(.001, f * u - n / T) / u) / 2,
                    g = s + p + h,
                    m = r - p - h,
                    {
                        outerStart: v,
                        outerEnd: b,
                        innerStart: y,
                        innerEnd: _
                    } = hr(t, d, u, m - g),
                    x = u - v,
                    w = u - b,
                    E = g + v / x,
                    k = m - b / w,
                    O = d + y,
                    S = d + _,
                    C = g + y / O,
                    A = m - _ / S;
                if (e.beginPath(), e.arc(o, a, u, E, k), b > 0) {
                    const t = fr(w, k, o, a);
                    e.arc(t.x, t.y, b, k, m + j)
                }
                const M = fr(S, m, o, a);
                if (e.lineTo(M.x, M.y), _ > 0) {
                    const t = fr(S, A, o, a);
                    e.arc(t.x, t.y, _, m + j, A + Math.PI)
                }
                if (e.arc(o, a, d, m - _ / d, g + y / d, !0), y > 0) {
                    const t = fr(O, C, o, a);
                    e.arc(t.x, t.y, y, C + Math.PI, g - j)
                }
                const P = fr(x, g, o, a);
                if (e.lineTo(P.x, P.y), v > 0) {
                    const t = fr(x, E, o, a);
                    e.arc(t.x, t.y, v, g - j, E)
                }
                e.closePath()
            }

            function gr(e, t, n, i, r) {
                const {
                    options: o
                } = t, a = "inner" === o.borderAlign;
                o.borderWidth && (a ? (e.lineWidth = 2 * o.borderWidth, e.lineJoin = "round") : (e.lineWidth = o.borderWidth, e.lineJoin = "bevel"), t.fullCircles && function (e, t, n) {
                    const {
                        x: i,
                        y: r,
                        startAngle: o,
                        pixelMargin: a,
                        fullCircles: s
                    } = t, l = Math.max(t.outerRadius - a, 0), c = t.innerRadius + a;
                    let u;
                    for (n && dr(e, t, o + P), e.beginPath(), e.arc(i, r, c, o + P, o, !0), u = 0; u < s; ++u) e.stroke();
                    for (e.beginPath(), e.arc(i, r, l, o, o + P), u = 0; u < s; ++u) e.stroke()
                }(e, t, a), a && dr(e, t, r), pr(e, t, n, i, r), e.stroke())
            }
            Object.defineProperties(lr, {
                defaults: {
                    enumerable: ur,
                    value: ze
                },
                instances: {
                    enumerable: ur,
                    value: ar
                },
                overrides: {
                    enumerable: ur,
                    value: Re
                },
                registry: {
                    enumerable: ur,
                    value: qi
                },
                version: {
                    enumerable: ur,
                    value: "3.5.1"
                },
                getChart: {
                    enumerable: ur,
                    value: sr
                },
                register: {
                    enumerable: ur,
                    value: (...e) => {
                        qi.add(...e), cr()
                    }
                },
                unregister: {
                    enumerable: ur,
                    value: (...e) => {
                        qi.remove(...e), cr()
                    }
                }
            });
            class mr extends Ci {
                constructor(e) {
                    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e)
                }
                inRange(e, t, n) {
                    const i = this.getProps(["x", "y"], n),
                        {
                            angle: r,
                            distance: o
                        } = function (e, t) {
                            const n = t.x - e.x,
                                i = t.y - e.y,
                                r = Math.sqrt(n * n + i * i);
                            let o = Math.atan2(i, n);
                            return o < -.5 * T && (o += P), {
                                angle: o,
                                distance: r
                            }
                        }(i, {
                            x: e,
                            y: t
                        }),
                        {
                            startAngle: a,
                            endAngle: s,
                            innerRadius: l,
                            outerRadius: c,
                            circumference: u
                        } = this.getProps(["startAngle", "endAngle", "innerRadius", "outerRadius", "circumference"], n),
                        d = this.options.spacing / 2;
                    return (u >= P || X(r, a, s)) && (o >= l + d && o <= c + d)
                }
                getCenterPoint(e) {
                    const {
                        x: t,
                        y: n,
                        startAngle: i,
                        endAngle: r,
                        innerRadius: o,
                        outerRadius: a
                    } = this.getProps(["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius", "circumference"], e), {
                        offset: s,
                        spacing: l
                    } = this.options, c = (i + r) / 2, u = (o + a + l + s) / 2;
                    return {
                        x: t + Math.cos(c) * u,
                        y: n + Math.sin(c) * u
                    }
                }
                tooltipPosition(e) {
                    return this.getCenterPoint(e)
                }
                draw(e) {
                    const t = this,
                        {
                            options: n,
                            circumference: i
                        } = t,
                        r = (n.offset || 0) / 2,
                        o = (n.spacing || 0) / 2;
                    if (t.pixelMargin = "inner" === n.borderAlign ? .33 : 0, t.fullCircles = i > P ? Math.floor(i / P) : 0, 0 === i || t.innerRadius < 0 || t.outerRadius < 0) return;
                    e.save();
                    let a = 0;
                    if (r) {
                        a = r / 2;
                        const n = (t.startAngle + t.endAngle) / 2;
                        e.translate(Math.cos(n) * a, Math.sin(n) * a), t.circumference >= T && (a = r)
                    }
                    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor;
                    const s = function (e, t, n, i) {
                        const {
                            fullCircles: r,
                            startAngle: o,
                            circumference: a
                        } = t;
                        let s = t.endAngle;
                        if (r) {
                            pr(e, t, n, i, o + P);
                            for (let t = 0; t < r; ++t) e.fill();
                            isNaN(a) || (s = o + a % P, a % P == 0 && (s += P))
                        }
                        return pr(e, t, n, i, s), e.fill(), s
                    }(e, t, a, o);
                    gr(e, t, a, o, s), e.restore()
                }
            }

            function vr(e, t, n = t) {
                e.lineCap = p(n.borderCapStyle, t.borderCapStyle), e.setLineDash(p(n.borderDash, t.borderDash)), e.lineDashOffset = p(n.borderDashOffset, t.borderDashOffset), e.lineJoin = p(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = p(n.borderWidth, t.borderWidth), e.strokeStyle = p(n.borderColor, t.borderColor)
            }

            function br(e, t, n) {
                e.lineTo(n.x, n.y)
            }

            function yr(e, t, n = {}) {
                const i = e.length,
                    {
                        start: r = 0,
                        end: o = i - 1
                    } = n,
                    {
                        start: a,
                        end: s
                    } = t,
                    l = Math.max(r, a),
                    c = Math.min(o, s),
                    u = r < a && o < a || r > s && o > s;
                return {
                    count: i,
                    start: l,
                    loop: t.loop,
                    ilen: c < l && !u ? i + c - l : c - l
                }
            }

            function _r(e, t, n, i) {
                const {
                    points: r,
                    options: o
                } = t, {
                    count: a,
                    start: s,
                    loop: l,
                    ilen: c
                } = yr(r, n, i), u = function (e) {
                    return e.stepped ? Xe : e.tension || "monotone" === e.cubicInterpolationMode ? Ze : br
                }(o);
                let d, h, f, {
                    move: p = !0,
                    reverse: g
                } = i || {};
                for (d = 0; d <= c; ++d) h = r[(s + (g ? c - d : d)) % a], h.skip || (p ? (e.moveTo(h.x, h.y), p = !1) : u(e, f, h, g, o.stepped), f = h);
                return l && (h = r[(s + (g ? c : 0)) % a], u(e, f, h, g, o.stepped)), !!l
            }

            function xr(e, t, n, i) {
                const r = t.points,
                    {
                        count: o,
                        start: a,
                        ilen: s
                    } = yr(r, n, i),
                    {
                        move: l = !0,
                        reverse: c
                    } = i || {};
                let u, d, h, f, p, g, m = 0,
                    v = 0;
                const b = e => (a + (c ? s - e : e)) % o,
                    y = () => {
                        f !== p && (e.lineTo(m, p), e.lineTo(m, f), e.lineTo(m, g))
                    };
                for (l && (d = r[b(0)], e.moveTo(d.x, d.y)), u = 0; u <= s; ++u) {
                    if (d = r[b(u)], d.skip) continue;
                    const t = d.x,
                        n = d.y,
                        i = 0 | t;
                    i === h ? (n < f ? f = n : n > p && (p = n), m = (v * m + t) / ++v) : (y(), e.lineTo(t, n), h = i, v = 0, f = p = n), g = n
                }
                y()
            }

            function wr(e) {
                const t = e.options,
                    n = t.borderDash && t.borderDash.length;
                return !(e._decimated || e._loop || t.tension || "monotone" === t.cubicInterpolationMode || t.stepped || n) ? xr : _r
            }
            mr.id = "arc", mr.defaults = {
                borderAlign: "center",
                borderColor: "#fff",
                borderRadius: 0,
                borderWidth: 2,
                offset: 0,
                spacing: 0,
                angle: void 0
            }, mr.defaultRoutes = {
                backgroundColor: "backgroundColor"
            };
            const Er = "function" == typeof Path2D;

            function kr(e, t, n, i) {
                Er && 1 === t.segments.length ? function (e, t, n, i) {
                    let r = t._path;
                    r || (r = t._path = new Path2D, t.path(r, n, i) && r.closePath()), vr(e, t.options), e.stroke(r)
                }(e, t, n, i) : function (e, t, n, i) {
                    const {
                        segments: r,
                        options: o
                    } = t, a = wr(t);
                    for (const s of r) vr(e, o, s.style), e.beginPath(), a(e, t, s, {
                        start: n,
                        end: n + i - 1
                    }) && e.closePath(), e.stroke()
                }(e, t, n, i)
            }
            class Or extends Ci {
                constructor(e) {
                    super(), this.animated = !0, this.options = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e)
                }
                updateControlPoints(e, t) {
                    const n = this,
                        i = n.options;
                    if ((i.tension || "monotone" === i.cubicInterpolationMode) && !i.stepped && !n._pointsUpdated) {
                        const r = i.spanGaps ? n._loop : n._fullLoop;
                        jt(n._points, i, e, r, t), n._pointsUpdated = !0
                    }
                }
                set points(e) {
                    const t = this;
                    t._points = e, delete t._segments, delete t._path, t._pointsUpdated = !1
                }
                get points() {
                    return this._points
                }
                get segments() {
                    return this._segments || (this._segments = function (e, t) {
                        const n = e.points,
                            i = e.options.spanGaps,
                            r = n.length;
                        if (!r) return [];
                        const o = !!e._loop,
                            {
                                start: a,
                                end: s
                            } = function (e, t, n, i) {
                                let r = 0,
                                    o = t - 1;
                                if (n && !i)
                                    for (; r < t && !e[r].skip;) r++;
                                for (; r < t && e[r].skip;) r++;
                                for (r %= t, n && (o += r); o > r && e[o % t].skip;) o--;
                                return o %= t, {
                                    start: r,
                                    end: o
                                }
                            }(n, r, o, i);
                        return sn(e, !0 === i ? [{
                            start: a,
                            end: s,
                            loop: o
                        }] : function (e, t, n, i) {
                            const r = e.length,
                                o = [];
                            let a, s = t,
                                l = e[t];
                            for (a = t + 1; a <= n; ++a) {
                                const n = e[a % r];
                                n.skip || n.stop ? l.skip || (i = !1, o.push({
                                    start: t % r,
                                    end: (a - 1) % r,
                                    loop: i
                                }), t = s = n.stop ? a : null) : (s = a, l.skip && (t = a)), l = n
                            }
                            return null !== s && o.push({
                                start: t % r,
                                end: s % r,
                                loop: i
                            }), o
                        }(n, a, s < a ? s + r : s, !!e._fullLoop && 0 === a && s === r - 1), n, t)
                    }(this, this.options.segment))
                }
                first() {
                    const e = this.segments,
                        t = this.points;
                    return e.length && t[e[0].start]
                }
                last() {
                    const e = this.segments,
                        t = this.points,
                        n = e.length;
                    return n && t[e[n - 1].end]
                }
                interpolate(e, t) {
                    const n = this,
                        i = n.options,
                        r = e[t],
                        o = n.points,
                        a = an(n, {
                            property: t,
                            start: r,
                            end: r
                        });
                    if (!a.length) return;
                    const s = [],
                        l = function (e) {
                            return e.stepped ? Gt : e.tension || "monotone" === e.cubicInterpolationMode ? Xt : Kt
                        }(i);
                    let c, u;
                    for (c = 0, u = a.length; c < u; ++c) {
                        const {
                            start: n,
                            end: u
                        } = a[c], d = o[n], h = o[u];
                        if (d === h) {
                            s.push(d);
                            continue
                        }
                        const f = l(d, h, Math.abs((r - d[t]) / (h[t] - d[t])), i.stepped);
                        f[t] = e[t], s.push(f)
                    }
                    return 1 === s.length ? s[0] : s
                }
                pathSegment(e, t, n) {
                    return wr(this)(e, this, t, n)
                }
                path(e, t, n) {
                    const i = this,
                        r = i.segments,
                        o = wr(i);
                    let a = i._loop;
                    t = t || 0, n = n || i.points.length - t;
                    for (const s of r) a &= o(e, i, s, {
                        start: t,
                        end: t + n - 1
                    });
                    return !!a
                }
                draw(e, t, n, i) {
                    const r = this,
                        o = r.options || {};
                    (r.points || []).length && o.borderWidth && (e.save(), kr(e, r, n, i), e.restore(), r.animated && (r._pointsUpdated = !1, r._path = void 0))
                }
            }

            function Sr(e, t, n, i) {
                const r = e.options,
                    {
                        [n]: o
                    } = e.getProps([n], i);
                return Math.abs(t - o) < r.radius + r.hitRadius
            }
            Or.id = "line", Or.defaults = {
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "miter",
                borderWidth: 3,
                capBezierPoints: !0,
                cubicInterpolationMode: "default",
                fill: !1,
                spanGaps: !1,
                stepped: !1,
                tension: 0
            }, Or.defaultRoutes = {
                backgroundColor: "backgroundColor",
                borderColor: "borderColor"
            }, Or.descriptors = {
                _scriptable: !0,
                _indexable: e => "borderDash" !== e && "fill" !== e
            };
            class Cr extends Ci {
                constructor(e) {
                    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e)
                }
                inRange(e, t, n) {
                    const i = this.options,
                        {
                            x: r,
                            y: o
                        } = this.getProps(["x", "y"], n);
                    return Math.pow(e - r, 2) + Math.pow(t - o, 2) < Math.pow(i.hitRadius + i.radius, 2)
                }
                inXRange(e, t) {
                    return Sr(this, e, "x", t)
                }
                inYRange(e, t) {
                    return Sr(this, e, "y", t)
                }
                getCenterPoint(e) {
                    const {
                        x: t,
                        y: n
                    } = this.getProps(["x", "y"], e);
                    return {
                        x: t,
                        y: n
                    }
                }
                size(e) {
                    let t = (e = e || this.options || {}).radius || 0;
                    t = Math.max(t, t && e.hoverRadius || 0);
                    return 2 * (t + (t && e.borderWidth || 0))
                }
                draw(e, t) {
                    const n = this,
                        i = n.options;
                    n.skip || i.radius < .1 || !$e(n, t, n.size(i) / 2) || (e.strokeStyle = i.borderColor, e.lineWidth = i.borderWidth, e.fillStyle = i.backgroundColor, Ye(e, i, n.x, n.y))
                }
                getRange() {
                    const e = this.options || {};
                    return e.radius + e.hitRadius
                }
            }

            function Ar(e, t) {
                const {
                    x: n,
                    y: i,
                    base: r,
                    width: o,
                    height: a
                } = e.getProps(["x", "y", "base", "width", "height"], t);
                let s, l, c, u, d;
                return e.horizontal ? (d = a / 2, s = Math.min(n, r), l = Math.max(n, r), c = i - d, u = i + d) : (d = o / 2, s = n - d, l = n + d, c = Math.min(i, r), u = Math.max(i, r)), {
                    left: s,
                    top: c,
                    right: l,
                    bottom: u
                }
            }

            function Mr(e, t, n, i) {
                return e ? 0 : Z(t, n, i)
            }

            function Tr(e) {
                const t = Ar(e),
                    n = t.right - t.left,
                    i = t.bottom - t.top,
                    r = function (e, t, n) {
                        const i = e.options.borderWidth,
                            r = e.borderSkipped,
                            o = ot(i);
                        return {
                            t: Mr(r.top, o.top, 0, n),
                            r: Mr(r.right, o.right, 0, t),
                            b: Mr(r.bottom, o.bottom, 0, n),
                            l: Mr(r.left, o.left, 0, t)
                        }
                    }(e, n / 2, i / 2),
                    o = function (e, t, n) {
                        const {
                            enableBorderRadius: i
                        } = e.getProps(["enableBorderRadius"]), r = e.options.borderRadius, o = at(r), a = Math.min(t, n), s = e.borderSkipped, l = i || d(r);
                        return {
                            topLeft: Mr(!l || s.top || s.left, o.topLeft, 0, a),
                            topRight: Mr(!l || s.top || s.right, o.topRight, 0, a),
                            bottomLeft: Mr(!l || s.bottom || s.left, o.bottomLeft, 0, a),
                            bottomRight: Mr(!l || s.bottom || s.right, o.bottomRight, 0, a)
                        }
                    }(e, n / 2, i / 2);
                return {
                    outer: {
                        x: t.left,
                        y: t.top,
                        w: n,
                        h: i,
                        radius: o
                    },
                    inner: {
                        x: t.left + r.l,
                        y: t.top + r.t,
                        w: n - r.l - r.r,
                        h: i - r.t - r.b,
                        radius: {
                            topLeft: Math.max(0, o.topLeft - Math.max(r.t, r.l)),
                            topRight: Math.max(0, o.topRight - Math.max(r.t, r.r)),
                            bottomLeft: Math.max(0, o.bottomLeft - Math.max(r.b, r.l)),
                            bottomRight: Math.max(0, o.bottomRight - Math.max(r.b, r.r))
                        }
                    }
                }
            }

            function Pr(e, t, n, i) {
                const r = null === t,
                    o = null === n,
                    a = e && !(r && o) && Ar(e, i);
                return a && (r || t >= a.left && t <= a.right) && (o || n >= a.top && n <= a.bottom)
            }

            function Dr(e, t) {
                e.rect(t.x, t.y, t.w, t.h)
            }

            function Lr(e, t, n = {}) {
                const i = e.x !== n.x ? -t : 0,
                    r = e.y !== n.y ? -t : 0,
                    o = (e.x + e.w !== n.x + n.w ? t : 0) - i,
                    a = (e.y + e.h !== n.y + n.h ? t : 0) - r;
                return {
                    x: e.x + i,
                    y: e.y + r,
                    w: e.w + o,
                    h: e.h + a,
                    radius: e.radius
                }
            }
            Cr.id = "point", Cr.defaults = {
                borderWidth: 1,
                hitRadius: 1,
                hoverBorderWidth: 1,
                hoverRadius: 4,
                pointStyle: "circle",
                radius: 3,
                rotation: 0
            }, Cr.defaultRoutes = {
                backgroundColor: "backgroundColor",
                borderColor: "borderColor"
            };
            class Nr extends Ci {
                constructor(e) {
                    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, e && Object.assign(this, e)
                }
                draw(e) {
                    const t = this.options,
                        {
                            inner: n,
                            outer: i
                        } = Tr(this),
                        r = (o = i.radius).topLeft || o.topRight || o.bottomLeft || o.bottomRight ? et : Dr;
                    var o;
                    const a = .33;
                    e.save(), i.w === n.w && i.h === n.h || (e.beginPath(), r(e, Lr(i, a, n)), e.clip(), r(e, Lr(n, -.33, i)), e.fillStyle = t.borderColor, e.fill("evenodd")), e.beginPath(), r(e, Lr(n, a, i)), e.fillStyle = t.backgroundColor, e.fill(), e.restore()
                }
                inRange(e, t, n) {
                    return Pr(this, e, t, n)
                }
                inXRange(e, t) {
                    return Pr(this, e, null, t)
                }
                inYRange(e, t) {
                    return Pr(this, null, e, t)
                }
                getCenterPoint(e) {
                    const {
                        x: t,
                        y: n,
                        base: i,
                        horizontal: r
                    } = this.getProps(["x", "y", "base", "horizontal"], e);
                    return {
                        x: r ? (t + i) / 2 : t,
                        y: r ? n : (n + i) / 2
                    }
                }
                getRange(e) {
                    return "x" === e ? this.width / 2 : this.height / 2
                }
            }
            Nr.id = "bar", Nr.defaults = {
                borderSkipped: "start",
                borderWidth: 0,
                borderRadius: 0,
                enableBorderRadius: !0,
                pointStyle: void 0
            }, Nr.defaultRoutes = {
                backgroundColor: "backgroundColor",
                borderColor: "borderColor"
            };

            function jr(e) {
                if (e._decimated) {
                    const t = e._data;
                    delete e._decimated, delete e._data, Object.defineProperty(e, "data", {
                        value: t
                    })
                }
            }

            function Ir(e) {
                e.data.datasets.forEach((e => {
                    jr(e)
                }))
            }
            var Rr = {
                id: "decimation",
                defaults: {
                    algorithm: "min-max",
                    enabled: !1
                },
                beforeElementsUpdate: (e, t, n) => {
                    if (!n.enabled) return void Ir(e);
                    const i = e.width;
                    e.data.datasets.forEach(((t, r) => {
                        const {
                            _data: o,
                            indexAxis: a
                        } = t, s = e.getDatasetMeta(r), l = o || t.data;
                        if ("y" === ct([a, e.options.indexAxis])) return;
                        if ("line" !== s.type) return;
                        const u = e.scales[s.xAxisID];
                        if ("linear" !== u.type && "time" !== u.type) return;
                        if (e.options.parsing) return;
                        let {
                            start: d,
                            count: h
                        } = function (e, t) {
                            const n = t.length;
                            let i, r = 0;
                            const {
                                iScale: o
                            } = e, {
                                min: a,
                                max: s,
                                minDefined: l,
                                maxDefined: c
                            } = o.getUserBounds();
                            return l && (r = Z(dt(t, o.axis, a).lo, 0, n - 1)), i = c ? Z(dt(t, o.axis, s).hi + 1, r, n) - r : n - r, {
                                start: r,
                                count: i
                            }
                        }(s, l);
                        if (h <= (n.threshold || 4 * i)) return void jr(t);
                        let f;
                        switch (c(o) && (t._data = l, delete t.data, Object.defineProperty(t, "data", {
                            configurable: !0,
                            enumerable: !0,
                            get: function () {
                                return this._decimated
                            },
                            set: function (e) {
                                this._data = e
                            }
                        })), n.algorithm) {
                            case "lttb":
                                f = function (e, t, n, i, r) {
                                    const o = r.samples || i;
                                    if (o >= n) return e.slice(t, t + n);
                                    const a = [],
                                        s = (n - 2) / (o - 2);
                                    let l = 0;
                                    const c = t + n - 1;
                                    let u, d, h, f, p, g = t;
                                    for (a[l++] = e[g], u = 0; u < o - 2; u++) {
                                        let i, r = 0,
                                            o = 0;
                                        const c = Math.floor((u + 1) * s) + 1 + t,
                                            m = Math.min(Math.floor((u + 2) * s) + 1, n) + t,
                                            v = m - c;
                                        for (i = c; i < m; i++) r += e[i].x, o += e[i].y;
                                        r /= v, o /= v;
                                        const b = Math.floor(u * s) + 1 + t,
                                            y = Math.min(Math.floor((u + 1) * s) + 1, n) + t,
                                            {
                                                x: _,
                                                y: x
                                            } = e[g];
                                        for (h = f = -1, i = b; i < y; i++) f = .5 * Math.abs((_ - r) * (e[i].y - x) - (_ - e[i].x) * (o - x)), f > h && (h = f, d = e[i], p = i);
                                        a[l++] = d, g = p
                                    }
                                    return a[l++] = e[c], a
                                }(l, d, h, i, n);
                                break;
                            case "min-max":
                                f = function (e, t, n, i) {
                                    let r, o, a, s, l, u, d, h, f, p, g = 0,
                                        m = 0;
                                    const v = [],
                                        b = t + n - 1,
                                        y = e[t].x,
                                        _ = e[b].x - y;
                                    for (r = t; r < t + n; ++r) {
                                        o = e[r], a = (o.x - y) / _ * i, s = o.y;
                                        const t = 0 | a;
                                        if (t === l) s < f ? (f = s, u = r) : s > p && (p = s, d = r), g = (m * g + o.x) / ++m;
                                        else {
                                            const n = r - 1;
                                            if (!c(u) && !c(d)) {
                                                const t = Math.min(u, d),
                                                    i = Math.max(u, d);
                                                t !== h && t !== n && v.push({
                                                    ...e[t],
                                                    x: g
                                                }), i !== h && i !== n && v.push({
                                                    ...e[i],
                                                    x: g
                                                })
                                            }
                                            r > 0 && n !== h && v.push(e[n]), v.push(o), l = t, m = 0, f = p = s, u = d = h = r
                                        }
                                    }
                                    return v
                                }(l, d, h, i);
                                break;
                            default:
                                throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`)
                        }
                        t._decimated = f
                    }))
                },
                destroy(e) {
                    Ir(e)
                }
            };

            function Fr(e, t, n) {
                const i = function (e) {
                    const t = e.options,
                        n = t.fill;
                    let i = p(n && n.target, n);
                    return void 0 === i && (i = !!t.backgroundColor), !1 !== i && null !== i && (!0 === i ? "origin" : i)
                }(e);
                if (d(i)) return !isNaN(i.value) && i;
                let r = parseFloat(i);
                return h(r) && Math.floor(r) === r ? ("-" !== i[0] && "+" !== i[0] || (r = t + r), !(r === t || r < 0 || r >= n) && r) : ["origin", "start", "end", "stack", "shape"].indexOf(i) >= 0 && i
            }
            class Br {
                constructor(e) {
                    this.x = e.x, this.y = e.y, this.radius = e.radius
                }
                pathSegment(e, t, n) {
                    const {
                        x: i,
                        y: r,
                        radius: o
                    } = this;
                    return t = t || {
                        start: 0,
                        end: P
                    }, e.arc(i, r, o, t.end, t.start, !0), !n.bounds
                }
                interpolate(e) {
                    const {
                        x: t,
                        y: n,
                        radius: i
                    } = this, r = e.angle;
                    return {
                        x: t + Math.cos(r) * i,
                        y: n + Math.sin(r) * i,
                        angle: r
                    }
                }
            }

            function qr(e) {
                return (e.scale || {}).getPointPositionForValue ? function (e) {
                    const {
                        scale: t,
                        fill: n
                    } = e, i = t.options, r = t.getLabels().length, o = [], a = i.reverse ? t.max : t.min, s = i.reverse ? t.min : t.max;
                    let l, c, u;
                    if (u = "start" === n ? a : "end" === n ? s : d(n) ? n.value : t.getBaseValue(), i.grid.circular) return c = t.getPointPositionForValue(0, a), new Br({
                        x: c.x,
                        y: c.y,
                        radius: t.getDistanceFromCenterForValue(u)
                    });
                    for (l = 0; l < r; ++l) o.push(t.getPointPositionForValue(l, u));
                    return o
                }(e) : function (e) {
                    const {
                        scale: t = {},
                        fill: n
                    } = e;
                    let i, r = null;
                    return "start" === n ? r = t.bottom : "end" === n ? r = t.top : d(n) ? r = t.getPixelForValue(n.value) : t.getBasePixel && (r = t.getBasePixel()), h(r) ? (i = t.isHorizontal(), {
                        x: i ? r : null,
                        y: i ? null : r
                    }) : null
                }(e)
            }

            function zr(e, t, n) {
                for (; t > e; t--) {
                    const e = n[t];
                    if (!isNaN(e.x) && !isNaN(e.y)) break
                }
                return t
            }

            function Hr(e) {
                const {
                    chart: t,
                    scale: n,
                    index: i,
                    line: r
                } = e, o = [], a = r.segments, s = r.points, l = function (e, t) {
                    const n = [],
                        i = e.getSortedVisibleDatasetMetas();
                    for (let e = 0; e < i.length; e++) {
                        const r = i[e];
                        if (r.index === t) break;
                        Ur(r) && n.unshift(r.dataset)
                    }
                    return n
                }(t, i);
                l.push(Yr({
                    x: null,
                    y: n.bottom
                }, r));
                for (let e = 0; e < a.length; e++) {
                    const t = a[e];
                    for (let e = t.start; e <= t.end; e++) Vr(o, s[e], l)
                }
                return new Or({
                    points: o,
                    options: {}
                })
            }
            const Ur = e => "line" === e.type && !e.hidden;

            function Vr(e, t, n) {
                const i = [];
                for (let r = 0; r < n.length; r++) {
                    const o = n[r],
                        {
                            first: a,
                            last: s,
                            point: l
                        } = Wr(o, t, "x");
                    if (!(!l || a && s))
                        if (a) i.unshift(l);
                        else if (e.push(l), !s) break
                }
                e.push(...i)
            }

            function Wr(e, t, n) {
                const i = e.interpolate(t, n);
                if (!i) return {};
                const r = i[n],
                    o = e.segments,
                    a = e.points;
                let s = !1,
                    l = !1;
                for (let e = 0; e < o.length; e++) {
                    const t = o[e],
                        i = a[t.start][n],
                        c = a[t.end][n];
                    if (r >= i && r <= c) {
                        s = r === i, l = r === c;
                        break
                    }
                }
                return {
                    first: s,
                    last: l,
                    point: i
                }
            }

            function Yr(e, t) {
                let n = [],
                    i = !1;
                return u(e) ? (i = !0, n = e) : n = function (e, t) {
                    const {
                        x: n = null,
                        y: i = null
                    } = e || {}, r = t.points, o = [];
                    return t.segments.forEach((({
                        start: e,
                        end: t
                    }) => {
                        t = zr(e, t, r);
                        const a = r[e],
                            s = r[t];
                        null !== i ? (o.push({
                            x: a.x,
                            y: i
                        }), o.push({
                            x: s.x,
                            y: i
                        })) : null !== n && (o.push({
                            x: n,
                            y: a.y
                        }), o.push({
                            x: n,
                            y: s.y
                        }))
                    })), o
                }(e, t), n.length ? new Or({
                    points: n,
                    options: {
                        tension: 0
                    },
                    _loop: i,
                    _fullLoop: i
                }) : null
            }

            function $r(e, t, n) {
                let i = e[t].fill;
                const r = [t];
                let o;
                if (!n) return i;
                for (; !1 !== i && -1 === r.indexOf(i);) {
                    if (!h(i)) return i;
                    if (o = e[i], !o) return !1;
                    if (o.visible) return i;
                    r.push(i), i = o.fill
                }
                return !1
            }

            function Kr(e, t, n) {
                e.beginPath(), t.path(e), e.lineTo(t.last().x, n), e.lineTo(t.first().x, n), e.closePath(), e.clip()
            }

            function Gr(e, t, n, i) {
                if (i) return;
                let r = t[e],
                    o = n[e];
                return "angle" === e && (r = G(r), o = G(o)), {
                    property: e,
                    start: r,
                    end: o
                }
            }

            function Xr(e, t, n, i) {
                return e && t ? i(e[n], t[n]) : e ? e[n] : t ? t[n] : 0
            }

            function Zr(e, t, n) {
                const {
                    top: i,
                    bottom: r
                } = t.chart.chartArea, {
                    property: o,
                    start: a,
                    end: s
                } = n || {};
                "x" === o && (e.beginPath(), e.rect(a, i, s - a, r - i), e.clip())
            }

            function Qr(e, t, n, i) {
                const r = t.interpolate(n, i);
                r && e.lineTo(r.x, r.y)
            }

            function Jr(e, t) {
                const {
                    line: n,
                    target: i,
                    property: r,
                    color: o,
                    scale: a
                } = t, s = function (e, t, n) {
                    const i = e.segments,
                        r = e.points,
                        o = t.points,
                        a = [];
                    for (const e of i) {
                        let {
                            start: i,
                            end: s
                        } = e;
                        s = zr(i, s, r);
                        const l = Gr(n, r[i], r[s], e.loop);
                        if (!t.segments) {
                            a.push({
                                source: e,
                                target: l,
                                start: r[i],
                                end: r[s]
                            });
                            continue
                        }
                        const c = an(t, l);
                        for (const t of c) {
                            const i = Gr(n, o[t.start], o[t.end], t.loop),
                                s = on(e, r, i);
                            for (const e of s) a.push({
                                source: e,
                                target: t,
                                start: {
                                    [n]: Xr(l, i, "start", Math.max)
                                },
                                end: {
                                    [n]: Xr(l, i, "end", Math.min)
                                }
                            })
                        }
                    }
                    return a
                }(n, i, r);
                for (const {
                        source: t,
                        target: l,
                        start: c,
                        end: u
                    } of s) {
                    const {
                        style: {
                            backgroundColor: s = o
                        } = {}
                    } = t, d = !0 !== i;
                    e.save(), e.fillStyle = s, Zr(e, a, d && Gr(r, c, u)), e.beginPath();
                    const h = !!n.pathSegment(e, t);
                    let f;
                    if (d) {
                        h ? e.closePath() : Qr(e, i, u, r);
                        const t = !!i.pathSegment(e, l, {
                            move: h,
                            reverse: !0
                        });
                        f = h && t, f || Qr(e, i, c, r)
                    }
                    e.closePath(), e.fill(f ? "evenodd" : "nonzero"), e.restore()
                }
            }

            function eo(e, t, n) {
                const i = function (e) {
                        const {
                            chart: t,
                            fill: n,
                            line: i
                        } = e;
                        if (h(n)) return function (e, t) {
                            const n = e.getDatasetMeta(t);
                            return n && e.isDatasetVisible(t) ? n.dataset : null
                        }(t, n);
                        if ("stack" === n) return Hr(e);
                        if ("shape" === n) return !0;
                        const r = qr(e);
                        return r instanceof Br ? r : Yr(r, i)
                    }(t),
                    {
                        line: r,
                        scale: o,
                        axis: a
                    } = t,
                    s = r.options,
                    l = s.fill,
                    c = s.backgroundColor,
                    {
                        above: u = c,
                        below: d = c
                    } = l || {};
                i && r.points.length && (Ke(e, n), function (e, t) {
                    const {
                        line: n,
                        target: i,
                        above: r,
                        below: o,
                        area: a,
                        scale: s
                    } = t, l = n._loop ? "angle" : t.axis;
                    e.save(), "x" === l && o !== r && (Kr(e, i, a.top), Jr(e, {
                        line: n,
                        target: i,
                        color: r,
                        scale: s,
                        property: l
                    }), e.restore(), e.save(), Kr(e, i, a.bottom)), Jr(e, {
                        line: n,
                        target: i,
                        color: o,
                        scale: s,
                        property: l
                    }), e.restore()
                }(e, {
                    line: r,
                    target: i,
                    above: u,
                    below: d,
                    area: n,
                    scale: o,
                    axis: a
                }), Ge(e))
            }
            var to = {
                id: "filler",
                afterDatasetsUpdate(e, t, n) {
                    const i = (e.data.datasets || []).length,
                        r = [];
                    let o, a, s, l;
                    for (a = 0; a < i; ++a) o = e.getDatasetMeta(a), s = o.dataset, l = null, s && s.options && s instanceof Or && (l = {
                        visible: e.isDatasetVisible(a),
                        index: a,
                        fill: Fr(s, a, i),
                        chart: e,
                        axis: o.controller.options.indexAxis,
                        scale: o.vScale,
                        line: s
                    }), o.$filler = l, r.push(l);
                    for (a = 0; a < i; ++a) l = r[a], l && !1 !== l.fill && (l.fill = $r(r, a, n.propagate))
                },
                beforeDraw(e, t, n) {
                    const i = "beforeDraw" === n.drawTime,
                        r = e.getSortedVisibleDatasetMetas(),
                        o = e.chartArea;
                    for (let t = r.length - 1; t >= 0; --t) {
                        const n = r[t].$filler;
                        n && (n.line.updateControlPoints(o, n.axis), i && eo(e.ctx, n, o))
                    }
                },
                beforeDatasetsDraw(e, t, n) {
                    if ("beforeDatasetsDraw" !== n.drawTime) return;
                    const i = e.getSortedVisibleDatasetMetas();
                    for (let t = i.length - 1; t >= 0; --t) {
                        const n = i[t].$filler;
                        n && eo(e.ctx, n, e.chartArea)
                    }
                },
                beforeDatasetDraw(e, t, n) {
                    const i = t.meta.$filler;
                    i && !1 !== i.fill && "beforeDatasetDraw" === n.drawTime && eo(e.ctx, i, e.chartArea)
                },
                defaults: {
                    propagate: !0,
                    drawTime: "beforeDatasetDraw"
                }
            };
            const no = (e, t) => {
                let {
                    boxHeight: n = t,
                    boxWidth: i = t
                } = e;
                return e.usePointStyle && (n = Math.min(n, t), i = Math.min(i, t)), {
                    boxWidth: i,
                    boxHeight: n,
                    itemHeight: Math.max(t, n)
                }
            };
            class io extends Ci {
                constructor(e) {
                    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0
                }
                update(e, t, n) {
                    const i = this;
                    i.maxWidth = e, i.maxHeight = t, i._margins = n, i.setDimensions(), i.buildLabels(), i.fit()
                }
                setDimensions() {
                    const e = this;
                    e.isHorizontal() ? (e.width = e.maxWidth, e.left = e._margins.left, e.right = e.width) : (e.height = e.maxHeight, e.top = e._margins.top, e.bottom = e.height)
                }
                buildLabels() {
                    const e = this,
                        t = e.options.labels || {};
                    let n = m(t.generateLabels, [e.chart], e) || [];
                    t.filter && (n = n.filter((n => t.filter(n, e.chart.data)))), t.sort && (n = n.sort(((n, i) => t.sort(n, i, e.chart.data)))), e.options.reverse && n.reverse(), e.legendItems = n
                }
                fit() {
                    const e = this,
                        {
                            options: t,
                            ctx: n
                        } = e;
                    if (!t.display) return void(e.width = e.height = 0);
                    const i = t.labels,
                        r = lt(i.font),
                        o = r.size,
                        a = e._computeTitleHeight(),
                        {
                            boxWidth: s,
                            itemHeight: l
                        } = no(i, o);
                    let c, u;
                    n.font = r.string, e.isHorizontal() ? (c = e.maxWidth, u = e._fitRows(a, o, s, l) + 10) : (u = e.maxHeight, c = e._fitCols(a, o, s, l) + 10), e.width = Math.min(c, t.maxWidth || e.maxWidth), e.height = Math.min(u, t.maxHeight || e.maxHeight)
                }
                _fitRows(e, t, n, i) {
                    const r = this,
                        {
                            ctx: o,
                            maxWidth: a,
                            options: {
                                labels: {
                                    padding: s
                                }
                            }
                        } = r,
                        l = r.legendHitBoxes = [],
                        c = r.lineWidths = [0],
                        u = i + s;
                    let d = e;
                    o.textAlign = "left", o.textBaseline = "middle";
                    let h = -1,
                        f = -u;
                    return r.legendItems.forEach(((e, r) => {
                        const p = n + t / 2 + o.measureText(e.text).width;
                        (0 === r || c[c.length - 1] + p + 2 * s > a) && (d += u, c[c.length - (r > 0 ? 0 : 1)] = 0, f += u, h++), l[r] = {
                            left: 0,
                            top: f,
                            row: h,
                            width: p,
                            height: i
                        }, c[c.length - 1] += p + s
                    })), d
                }
                _fitCols(e, t, n, i) {
                    const r = this,
                        {
                            ctx: o,
                            maxHeight: a,
                            options: {
                                labels: {
                                    padding: s
                                }
                            }
                        } = r,
                        l = r.legendHitBoxes = [],
                        c = r.columnSizes = [],
                        u = a - e;
                    let d = s,
                        h = 0,
                        f = 0,
                        p = 0,
                        g = 0;
                    return r.legendItems.forEach(((e, r) => {
                        const a = n + t / 2 + o.measureText(e.text).width;
                        r > 0 && f + i + 2 * s > u && (d += h + s, c.push({
                            width: h,
                            height: f
                        }), p += h + s, g++, h = f = 0), l[r] = {
                            left: p,
                            top: f,
                            col: g,
                            width: a,
                            height: i
                        }, h = Math.max(h, a), f += i + s
                    })), d += h, c.push({
                        width: h,
                        height: f
                    }), d
                }
                adjustHitBoxes() {
                    const e = this;
                    if (!e.options.display) return;
                    const t = e._computeTitleHeight(),
                        {
                            legendHitBoxes: n,
                            options: {
                                align: i,
                                labels: {
                                    padding: r
                                },
                                rtl: o
                            }
                        } = e,
                        s = Jt(o, e.left, e.width);
                    if (this.isHorizontal()) {
                        let o = 0,
                            l = a(i, e.left + r, e.right - e.lineWidths[o]);
                        for (const c of n) o !== c.row && (o = c.row, l = a(i, e.left + r, e.right - e.lineWidths[o])), c.top += e.top + t + r, c.left = s.leftForLtr(s.x(l), c.width), l += c.width + r
                    } else {
                        let o = 0,
                            l = a(i, e.top + t + r, e.bottom - e.columnSizes[o].height);
                        for (const c of n) c.col !== o && (o = c.col, l = a(i, e.top + t + r, e.bottom - e.columnSizes[o].height)), c.top = l, c.left += e.left + r, c.left = s.leftForLtr(s.x(c.left), c.width), l += c.height + r
                    }
                }
                isHorizontal() {
                    return "top" === this.options.position || "bottom" === this.options.position
                }
                draw() {
                    const e = this;
                    if (e.options.display) {
                        const t = e.ctx;
                        Ke(t, e), e._draw(), Ge(t)
                    }
                }
                _draw() {
                    const e = this,
                        {
                            options: t,
                            columnSizes: n,
                            lineWidths: i,
                            ctx: r
                        } = e,
                        {
                            align: o,
                            labels: s
                        } = t,
                        l = ze.color,
                        c = Jt(t.rtl, e.left, e.width),
                        u = lt(s.font),
                        {
                            color: d,
                            padding: h
                        } = s,
                        f = u.size,
                        g = f / 2;
                    let m;
                    e.drawTitle(), r.textAlign = c.textAlign("left"), r.textBaseline = "middle", r.lineWidth = .5, r.font = u.string;
                    const {
                        boxWidth: v,
                        boxHeight: b,
                        itemHeight: y
                    } = no(s, f), _ = e.isHorizontal(), x = this._computeTitleHeight();
                    m = _ ? {
                        x: a(o, e.left + h, e.right - i[0]),
                        y: e.top + h + x,
                        line: 0
                    } : {
                        x: e.left + h,
                        y: a(o, e.top + x + h, e.bottom - n[0].height),
                        line: 0
                    }, en(e.ctx, t.textDirection);
                    const w = y + h;
                    e.legendItems.forEach(((E, k) => {
                        r.strokeStyle = E.fontColor || d, r.fillStyle = E.fontColor || d;
                        const O = r.measureText(E.text).width,
                            S = c.textAlign(E.textAlign || (E.textAlign = s.textAlign)),
                            C = v + g + O;
                        let A = m.x,
                            M = m.y;
                        c.setWidth(e.width), _ ? k > 0 && A + C + h > e.right && (M = m.y += w, m.line++, A = m.x = a(o, e.left + h, e.right - i[m.line])) : k > 0 && M + w > e.bottom && (A = m.x = A + n[m.line].width + h, m.line++, M = m.y = a(o, e.top + x + h, e.bottom - n[m.line].height));
                        ! function (e, t, n) {
                            if (isNaN(v) || v <= 0 || isNaN(b) || b < 0) return;
                            r.save();
                            const i = p(n.lineWidth, 1);
                            if (r.fillStyle = p(n.fillStyle, l), r.lineCap = p(n.lineCap, "butt"), r.lineDashOffset = p(n.lineDashOffset, 0), r.lineJoin = p(n.lineJoin, "miter"), r.lineWidth = i, r.strokeStyle = p(n.strokeStyle, l), r.setLineDash(p(n.lineDash, [])), s.usePointStyle) {
                                const o = {
                                        radius: v * Math.SQRT2 / 2,
                                        pointStyle: n.pointStyle,
                                        rotation: n.rotation,
                                        borderWidth: i
                                    },
                                    a = c.xPlus(e, v / 2);
                                Ye(r, o, a, t + g)
                            } else {
                                const o = t + Math.max((f - b) / 2, 0),
                                    a = c.leftForLtr(e, v),
                                    s = at(n.borderRadius);
                                r.beginPath(), Object.values(s).some((e => 0 !== e)) ? et(r, {
                                    x: a,
                                    y: o,
                                    w: v,
                                    h: b,
                                    radius: s
                                }) : r.rect(a, o, v, b), r.fill(), 0 !== i && r.stroke()
                            }
                            r.restore()
                        }(c.x(A), M, E), A = ((e, t, n, i) => e === (i ? "left" : "right") ? n : "center" === e ? (t + n) / 2 : t)(S, A + v + g, _ ? A + C : e.right, t.rtl),
                            function (e, t, n) {
                                Qe(r, n.text, e, t + y / 2, u, {
                                    strikethrough: n.hidden,
                                    textAlign: c.textAlign(n.textAlign)
                                })
                            }(c.x(A), M, E), _ ? m.x += C + h : m.y += w
                    })), tn(e.ctx, t.textDirection)
                }
                drawTitle() {
                    const e = this,
                        t = e.options,
                        n = t.title,
                        i = lt(n.font),
                        r = st(n.padding);
                    if (!n.display) return;
                    const s = Jt(t.rtl, e.left, e.width),
                        l = e.ctx,
                        c = n.position,
                        u = i.size / 2,
                        d = r.top + u;
                    let h, f = e.left,
                        p = e.width;
                    if (this.isHorizontal()) p = Math.max(...e.lineWidths), h = e.top + d, f = a(t.align, f, e.right - p);
                    else {
                        const n = e.columnSizes.reduce(((e, t) => Math.max(e, t.height)), 0);
                        h = d + a(t.align, e.top, e.bottom - n - t.labels.padding - e._computeTitleHeight())
                    }
                    const g = a(c, f, f + p);
                    l.textAlign = s.textAlign(o(c)), l.textBaseline = "middle", l.strokeStyle = n.color, l.fillStyle = n.color, l.font = i.string, Qe(l, n.text, g, h, i)
                }
                _computeTitleHeight() {
                    const e = this.options.title,
                        t = lt(e.font),
                        n = st(e.padding);
                    return e.display ? t.lineHeight + n.height : 0
                }
                _getLegendItemAt(e, t) {
                    const n = this;
                    let i, r, o;
                    if (e >= n.left && e <= n.right && t >= n.top && t <= n.bottom)
                        for (o = n.legendHitBoxes, i = 0; i < o.length; ++i)
                            if (r = o[i], e >= r.left && e <= r.left + r.width && t >= r.top && t <= r.top + r.height) return n.legendItems[i];
                    return null
                }
                handleEvent(e) {
                    const t = this,
                        n = t.options;
                    if (! function (e, t) {
                            if ("mousemove" === e && (t.onHover || t.onLeave)) return !0;
                            if (t.onClick && ("click" === e || "mouseup" === e)) return !0;
                            return !1
                        }(e.type, n)) return;
                    const i = t._getLegendItemAt(e.x, e.y);
                    if ("mousemove" === e.type) {
                        const a = t._hoveredItem,
                            s = (o = i, null !== (r = a) && null !== o && r.datasetIndex === o.datasetIndex && r.index === o.index);
                        a && !s && m(n.onLeave, [e, a, t], t), t._hoveredItem = i, i && !s && m(n.onHover, [e, i, t], t)
                    } else i && m(n.onClick, [e, i, t], t);
                    var r, o
                }
            }
            var ro = {
                id: "legend",
                _element: io,
                start(e, t, n) {
                    const i = e.legend = new io({
                        ctx: e.ctx,
                        options: n,
                        chart: e
                    });
                    di.configure(e, i, n), di.addBox(e, i)
                },
                stop(e) {
                    di.removeBox(e, e.legend), delete e.legend
                },
                beforeUpdate(e, t, n) {
                    const i = e.legend;
                    di.configure(e, i, n), i.options = n
                },
                afterUpdate(e) {
                    const t = e.legend;
                    t.buildLabels(), t.adjustHitBoxes()
                },
                afterEvent(e, t) {
                    t.replay || e.legend.handleEvent(t.event)
                },
                defaults: {
                    display: !0,
                    position: "top",
                    align: "center",
                    fullSize: !0,
                    reverse: !1,
                    weight: 1e3,
                    onClick(e, t, n) {
                        const i = t.datasetIndex,
                            r = n.chart;
                        r.isDatasetVisible(i) ? (r.hide(i), t.hidden = !0) : (r.show(i), t.hidden = !1)
                    },
                    onHover: null,
                    onLeave: null,
                    labels: {
                        color: e => e.chart.options.color,
                        boxWidth: 40,
                        padding: 10,
                        generateLabels(e) {
                            const t = e.data.datasets,
                                {
                                    labels: {
                                        usePointStyle: n,
                                        pointStyle: i,
                                        textAlign: r,
                                        color: o
                                    }
                                } = e.legend.options;
                            return e._getSortedDatasetMetas().map((e => {
                                const a = e.controller.getStyle(n ? 0 : void 0),
                                    s = st(a.borderWidth);
                                return {
                                    text: t[e.index].label,
                                    fillStyle: a.backgroundColor,
                                    fontColor: o,
                                    hidden: !e.visible,
                                    lineCap: a.borderCapStyle,
                                    lineDash: a.borderDash,
                                    lineDashOffset: a.borderDashOffset,
                                    lineJoin: a.borderJoinStyle,
                                    lineWidth: (s.width + s.height) / 4,
                                    strokeStyle: a.borderColor,
                                    pointStyle: i || a.pointStyle,
                                    rotation: a.rotation,
                                    textAlign: r || a.textAlign,
                                    borderRadius: 0,
                                    datasetIndex: e.index
                                }
                            }), this)
                        }
                    },
                    title: {
                        color: e => e.chart.options.color,
                        display: !1,
                        position: "center",
                        text: ""
                    }
                },
                descriptors: {
                    _scriptable: e => !e.startsWith("on"),
                    labels: {
                        _scriptable: e => !["generateLabels", "filter", "sort"].includes(e)
                    }
                }
            };
            class oo extends Ci {
                constructor(e) {
                    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0
                }
                update(e, t) {
                    const n = this,
                        i = n.options;
                    if (n.left = 0, n.top = 0, !i.display) return void(n.width = n.height = n.right = n.bottom = 0);
                    n.width = n.right = e, n.height = n.bottom = t;
                    const r = u(i.text) ? i.text.length : 1;
                    n._padding = st(i.padding);
                    const o = r * lt(i.font).lineHeight + n._padding.height;
                    n.isHorizontal() ? n.height = o : n.width = o
                }
                isHorizontal() {
                    const e = this.options.position;
                    return "top" === e || "bottom" === e
                }
                _drawArgs(e) {
                    const {
                        top: t,
                        left: n,
                        bottom: i,
                        right: r,
                        options: o
                    } = this, s = o.align;
                    let l, c, u, d = 0;
                    return this.isHorizontal() ? (c = a(s, n, r), u = t + e, l = r - n) : ("left" === o.position ? (c = n + e, u = a(s, i, t), d = -.5 * T) : (c = r - e, u = a(s, t, i), d = .5 * T), l = i - t), {
                        titleX: c,
                        titleY: u,
                        maxWidth: l,
                        rotation: d
                    }
                }
                draw() {
                    const e = this,
                        t = e.ctx,
                        n = e.options;
                    if (!n.display) return;
                    const i = lt(n.font),
                        r = i.lineHeight / 2 + e._padding.top,
                        {
                            titleX: a,
                            titleY: s,
                            maxWidth: l,
                            rotation: c
                        } = e._drawArgs(r);
                    Qe(t, n.text, 0, 0, i, {
                        color: n.color,
                        maxWidth: l,
                        rotation: c,
                        textAlign: o(n.align),
                        textBaseline: "middle",
                        translation: [a, s]
                    })
                }
            }
            var ao = {
                id: "title",
                _element: oo,
                start(e, t, n) {
                    ! function (e, t) {
                        const n = new oo({
                            ctx: e.ctx,
                            options: t,
                            chart: e
                        });
                        di.configure(e, n, t), di.addBox(e, n), e.titleBlock = n
                    }(e, n)
                },
                stop(e) {
                    const t = e.titleBlock;
                    di.removeBox(e, t), delete e.titleBlock
                },
                beforeUpdate(e, t, n) {
                    const i = e.titleBlock;
                    di.configure(e, i, n), i.options = n
                },
                defaults: {
                    align: "center",
                    display: !1,
                    font: {
                        weight: "bold"
                    },
                    fullSize: !0,
                    padding: 10,
                    position: "top",
                    text: "",
                    weight: 2e3
                },
                defaultRoutes: {
                    color: "color"
                },
                descriptors: {
                    _scriptable: !0,
                    _indexable: !1
                }
            };
            new WeakMap;
            const so = {
                average(e) {
                    if (!e.length) return !1;
                    let t, n, i = 0,
                        r = 0,
                        o = 0;
                    for (t = 0, n = e.length; t < n; ++t) {
                        const n = e[t].element;
                        if (n && n.hasValue()) {
                            const e = n.tooltipPosition();
                            i += e.x, r += e.y, ++o
                        }
                    }
                    return {
                        x: i / o,
                        y: r / o
                    }
                },
                nearest(e, t) {
                    if (!e.length) return !1;
                    let n, i, r, o = t.x,
                        a = t.y,
                        s = Number.POSITIVE_INFINITY;
                    for (n = 0, i = e.length; n < i; ++n) {
                        const i = e[n].element;
                        if (i && i.hasValue()) {
                            const e = $(t, i.getCenterPoint());
                            e < s && (s = e, r = i)
                        }
                    }
                    if (r) {
                        const e = r.tooltipPosition();
                        o = e.x, a = e.y
                    }
                    return {
                        x: o,
                        y: a
                    }
                }
            };

            function lo(e, t) {
                return t && (u(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e
            }

            function co(e) {
                return ("string" == typeof e || e instanceof String) && e.indexOf("\n") > -1 ? e.split("\n") : e
            }

            function uo(e, t) {
                const {
                    element: n,
                    datasetIndex: i,
                    index: r
                } = t, o = e.getDatasetMeta(i).controller, {
                    label: a,
                    value: s
                } = o.getLabelAndValue(r);
                return {
                    chart: e,
                    label: a,
                    parsed: o.getParsed(r),
                    raw: e.data.datasets[i].data[r],
                    formattedValue: s,
                    dataset: o.getDataset(),
                    dataIndex: r,
                    datasetIndex: i,
                    element: n
                }
            }

            function ho(e, t) {
                const n = e._chart.ctx,
                    {
                        body: i,
                        footer: r,
                        title: o
                    } = e,
                    {
                        boxWidth: a,
                        boxHeight: s
                    } = t,
                    l = lt(t.bodyFont),
                    c = lt(t.titleFont),
                    u = lt(t.footerFont),
                    d = o.length,
                    h = r.length,
                    f = i.length,
                    p = st(t.padding);
                let g = p.height,
                    m = 0,
                    b = i.reduce(((e, t) => e + t.before.length + t.lines.length + t.after.length), 0);
                if (b += e.beforeBody.length + e.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), b) {
                    g += f * (t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight) + (b - f) * l.lineHeight + (b - 1) * t.bodySpacing
                }
                h && (g += t.footerMarginTop + h * u.lineHeight + (h - 1) * t.footerSpacing);
                let y = 0;
                const _ = function (e) {
                    m = Math.max(m, n.measureText(e).width + y)
                };
                return n.save(), n.font = c.string, v(e.title, _), n.font = l.string, v(e.beforeBody.concat(e.afterBody), _), y = t.displayColors ? a + 2 : 0, v(i, (e => {
                    v(e.before, _), v(e.lines, _), v(e.after, _)
                })), y = 0, n.font = u.string, v(e.footer, _), n.restore(), m += p.width, {
                    width: m,
                    height: g
                }
            }

            function fo(e, t, n, i) {
                const {
                    x: r,
                    width: o
                } = n, {
                    width: a,
                    chartArea: {
                        left: s,
                        right: l
                    }
                } = e;
                let c = "center";
                return "center" === i ? c = r <= (s + l) / 2 ? "left" : "right" : r <= o / 2 ? c = "left" : r >= a - o / 2 && (c = "right"),
                    function (e, t, n, i) {
                        const {
                            x: r,
                            width: o
                        } = i, a = n.caretSize + n.caretPadding;
                        return "left" === e && r + o + a > t.width || "right" === e && r - o - a < 0 || void 0
                    }(c, e, t, n) && (c = "center"), c
            }

            function po(e, t, n) {
                const i = t.yAlign || function (e, t) {
                    const {
                        y: n,
                        height: i
                    } = t;
                    return n < i / 2 ? "top" : n > e.height - i / 2 ? "bottom" : "center"
                }(e, n);
                return {
                    xAlign: t.xAlign || fo(e, t, n, i),
                    yAlign: i
                }
            }

            function go(e, t, n, i) {
                const {
                    caretSize: r,
                    caretPadding: o,
                    cornerRadius: a
                } = e, {
                    xAlign: s,
                    yAlign: l
                } = n, c = r + o, u = a + o;
                let d = function (e, t) {
                    let {
                        x: n,
                        width: i
                    } = e;
                    return "right" === t ? n -= i : "center" === t && (n -= i / 2), n
                }(t, s);
                const h = function (e, t, n) {
                    let {
                        y: i,
                        height: r
                    } = e;
                    return "top" === t ? i += n : i -= "bottom" === t ? r + n : r / 2, i
                }(t, l, c);
                return "center" === l ? "left" === s ? d += c : "right" === s && (d -= c) : "left" === s ? d -= u : "right" === s && (d += u), {
                    x: Z(d, 0, i.width - t.width),
                    y: Z(h, 0, i.height - t.height)
                }
            }

            function mo(e, t, n) {
                const i = st(n.padding);
                return "center" === t ? e.x + e.width / 2 : "right" === t ? e.x + e.width - i.right : e.x + i.left
            }

            function vo(e) {
                return lo([], co(e))
            }

            function bo(e, t) {
                const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
                return n ? e.override(n) : e
            }
            class yo extends Ci {
                constructor(e) {
                    super(), this.opacity = 0, this._active = [], this._chart = e._chart, this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0
                }
                initialize(e) {
                    this.options = e, this._cachedAnimations = void 0, this.$context = void 0
                }
                _resolveAnimations() {
                    const e = this,
                        t = e._cachedAnimations;
                    if (t) return t;
                    const n = e._chart,
                        i = e.options.setContext(e.getContext()),
                        r = i.enabled && n.options.animation && i.animations,
                        o = new gn(e._chart, r);
                    return r._cacheable && (e._cachedAnimations = Object.freeze(o)), o
                }
                getContext() {
                    const e = this;
                    return e.$context || (e.$context = (t = e._chart.getContext(), n = e, i = e._tooltipItems, Object.assign(Object.create(t), {
                        tooltip: n,
                        tooltipItems: i,
                        type: "tooltip"
                    })));
                    var t, n, i
                }
                getTitle(e, t) {
                    const n = this,
                        {
                            callbacks: i
                        } = t,
                        r = i.beforeTitle.apply(n, [e]),
                        o = i.title.apply(n, [e]),
                        a = i.afterTitle.apply(n, [e]);
                    let s = [];
                    return s = lo(s, co(r)), s = lo(s, co(o)), s = lo(s, co(a)), s
                }
                getBeforeBody(e, t) {
                    return vo(t.callbacks.beforeBody.apply(this, [e]))
                }
                getBody(e, t) {
                    const n = this,
                        {
                            callbacks: i
                        } = t,
                        r = [];
                    return v(e, (e => {
                        const t = {
                                before: [],
                                lines: [],
                                after: []
                            },
                            o = bo(i, e);
                        lo(t.before, co(o.beforeLabel.call(n, e))), lo(t.lines, o.label.call(n, e)), lo(t.after, co(o.afterLabel.call(n, e))), r.push(t)
                    })), r
                }
                getAfterBody(e, t) {
                    return vo(t.callbacks.afterBody.apply(this, [e]))
                }
                getFooter(e, t) {
                    const n = this,
                        {
                            callbacks: i
                        } = t,
                        r = i.beforeFooter.apply(n, [e]),
                        o = i.footer.apply(n, [e]),
                        a = i.afterFooter.apply(n, [e]);
                    let s = [];
                    return s = lo(s, co(r)), s = lo(s, co(o)), s = lo(s, co(a)), s
                }
                _createItems(e) {
                    const t = this,
                        n = t._active,
                        i = t._chart.data,
                        r = [],
                        o = [],
                        a = [];
                    let s, l, c = [];
                    for (s = 0, l = n.length; s < l; ++s) c.push(uo(t._chart, n[s]));
                    return e.filter && (c = c.filter(((t, n, r) => e.filter(t, n, r, i)))), e.itemSort && (c = c.sort(((t, n) => e.itemSort(t, n, i)))), v(c, (n => {
                        const i = bo(e.callbacks, n);
                        r.push(i.labelColor.call(t, n)), o.push(i.labelPointStyle.call(t, n)), a.push(i.labelTextColor.call(t, n))
                    })), t.labelColors = r, t.labelPointStyles = o, t.labelTextColors = a, t.dataPoints = c, c
                }
                update(e, t) {
                    const n = this,
                        i = n.options.setContext(n.getContext()),
                        r = n._active;
                    let o, a = [];
                    if (r.length) {
                        const e = so[i.position].call(n, r, n._eventPosition);
                        a = n._createItems(i), n.title = n.getTitle(a, i), n.beforeBody = n.getBeforeBody(a, i), n.body = n.getBody(a, i), n.afterBody = n.getAfterBody(a, i), n.footer = n.getFooter(a, i);
                        const t = n._size = ho(n, i),
                            s = Object.assign({}, e, t),
                            l = po(n._chart, i, s),
                            c = go(i, s, l, n._chart);
                        n.xAlign = l.xAlign, n.yAlign = l.yAlign, o = {
                            opacity: 1,
                            x: c.x,
                            y: c.y,
                            width: t.width,
                            height: t.height,
                            caretX: e.x,
                            caretY: e.y
                        }
                    } else 0 !== n.opacity && (o = {
                        opacity: 0
                    });
                    n._tooltipItems = a, n.$context = void 0, o && n._resolveAnimations().update(n, o), e && i.external && i.external.call(n, {
                        chart: n._chart,
                        tooltip: n,
                        replay: t
                    })
                }
                drawCaret(e, t, n, i) {
                    const r = this.getCaretPosition(e, n, i);
                    t.lineTo(r.x1, r.y1), t.lineTo(r.x2, r.y2), t.lineTo(r.x3, r.y3)
                }
                getCaretPosition(e, t, n) {
                    const {
                        xAlign: i,
                        yAlign: r
                    } = this, {
                        cornerRadius: o,
                        caretSize: a
                    } = n, {
                        x: s,
                        y: l
                    } = e, {
                        width: c,
                        height: u
                    } = t;
                    let d, h, f, p, g, m;
                    return "center" === r ? (g = l + u / 2, "left" === i ? (d = s, h = d - a, p = g + a, m = g - a) : (d = s + c, h = d + a, p = g - a, m = g + a), f = d) : (h = "left" === i ? s + o + a : "right" === i ? s + c - o - a : this.caretX, "top" === r ? (p = l, g = p - a, d = h - a, f = h + a) : (p = l + u, g = p + a, d = h + a, f = h - a), m = p), {
                        x1: d,
                        x2: h,
                        x3: f,
                        y1: p,
                        y2: g,
                        y3: m
                    }
                }
                drawTitle(e, t, n) {
                    const i = this,
                        r = i.title,
                        o = r.length;
                    let a, s, l;
                    if (o) {
                        const c = Jt(n.rtl, i.x, i.width);
                        for (e.x = mo(i, n.titleAlign, n), t.textAlign = c.textAlign(n.titleAlign), t.textBaseline = "middle", a = lt(n.titleFont), s = n.titleSpacing, t.fillStyle = n.titleColor, t.font = a.string, l = 0; l < o; ++l) t.fillText(r[l], c.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + s, l + 1 === o && (e.y += n.titleMarginBottom - s)
                    }
                }
                _drawColorBox(e, t, n, i, r) {
                    const o = this,
                        a = o.labelColors[n],
                        s = o.labelPointStyles[n],
                        {
                            boxHeight: l,
                            boxWidth: c
                        } = r,
                        u = lt(r.bodyFont),
                        d = mo(o, "left", r),
                        h = i.x(d),
                        f = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0,
                        p = t.y + f;
                    if (r.usePointStyle) {
                        const t = {
                                radius: Math.min(c, l) / 2,
                                pointStyle: s.pointStyle,
                                rotation: s.rotation,
                                borderWidth: 1
                            },
                            n = i.leftForLtr(h, c) + c / 2,
                            o = p + l / 2;
                        e.strokeStyle = r.multiKeyBackground, e.fillStyle = r.multiKeyBackground, Ye(e, t, n, o), e.strokeStyle = a.borderColor, e.fillStyle = a.backgroundColor, Ye(e, t, n, o)
                    } else {
                        e.lineWidth = a.borderWidth || 1, e.strokeStyle = a.borderColor, e.setLineDash(a.borderDash || []), e.lineDashOffset = a.borderDashOffset || 0;
                        const t = i.leftForLtr(h, c),
                            n = i.leftForLtr(i.xPlus(h, 1), c - 2),
                            o = at(a.borderRadius);
                        Object.values(o).some((e => 0 !== e)) ? (e.beginPath(), e.fillStyle = r.multiKeyBackground, et(e, {
                            x: t,
                            y: p,
                            w: c,
                            h: l,
                            radius: o
                        }), e.fill(), e.stroke(), e.fillStyle = a.backgroundColor, e.beginPath(), et(e, {
                            x: n,
                            y: p + 1,
                            w: c - 2,
                            h: l - 2,
                            radius: o
                        }), e.fill()) : (e.fillStyle = r.multiKeyBackground, e.fillRect(t, p, c, l), e.strokeRect(t, p, c, l), e.fillStyle = a.backgroundColor, e.fillRect(n, p + 1, c - 2, l - 2))
                    }
                    e.fillStyle = o.labelTextColors[n]
                }
                drawBody(e, t, n) {
                    const i = this,
                        {
                            body: r
                        } = i,
                        {
                            bodySpacing: o,
                            bodyAlign: a,
                            displayColors: s,
                            boxHeight: l,
                            boxWidth: c
                        } = n,
                        u = lt(n.bodyFont);
                    let d = u.lineHeight,
                        h = 0;
                    const f = Jt(n.rtl, i.x, i.width),
                        p = function (n) {
                            t.fillText(n, f.x(e.x + h), e.y + d / 2), e.y += d + o
                        },
                        g = f.textAlign(a);
                    let m, b, y, _, x, w, E;
                    for (t.textAlign = a, t.textBaseline = "middle", t.font = u.string, e.x = mo(i, g, n), t.fillStyle = n.bodyColor, v(i.beforeBody, p), h = s && "right" !== g ? "center" === a ? c / 2 + 1 : c + 2 : 0, _ = 0, w = r.length; _ < w; ++_) {
                        for (m = r[_], b = i.labelTextColors[_], t.fillStyle = b, v(m.before, p), y = m.lines, s && y.length && (i._drawColorBox(t, e, _, f, n), d = Math.max(u.lineHeight, l)), x = 0, E = y.length; x < E; ++x) p(y[x]), d = u.lineHeight;
                        v(m.after, p)
                    }
                    h = 0, d = u.lineHeight, v(i.afterBody, p), e.y -= o
                }
                drawFooter(e, t, n) {
                    const i = this,
                        r = i.footer,
                        o = r.length;
                    let a, s;
                    if (o) {
                        const l = Jt(n.rtl, i.x, i.width);
                        for (e.x = mo(i, n.footerAlign, n), e.y += n.footerMarginTop, t.textAlign = l.textAlign(n.footerAlign), t.textBaseline = "middle", a = lt(n.footerFont), t.fillStyle = n.footerColor, t.font = a.string, s = 0; s < o; ++s) t.fillText(r[s], l.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + n.footerSpacing
                    }
                }
                drawBackground(e, t, n, i) {
                    const {
                        xAlign: r,
                        yAlign: o
                    } = this, {
                        x: a,
                        y: s
                    } = e, {
                        width: l,
                        height: c
                    } = n, u = i.cornerRadius;
                    t.fillStyle = i.backgroundColor, t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.beginPath(), t.moveTo(a + u, s), "top" === o && this.drawCaret(e, t, n, i), t.lineTo(a + l - u, s), t.quadraticCurveTo(a + l, s, a + l, s + u), "center" === o && "right" === r && this.drawCaret(e, t, n, i), t.lineTo(a + l, s + c - u), t.quadraticCurveTo(a + l, s + c, a + l - u, s + c), "bottom" === o && this.drawCaret(e, t, n, i), t.lineTo(a + u, s + c), t.quadraticCurveTo(a, s + c, a, s + c - u), "center" === o && "left" === r && this.drawCaret(e, t, n, i), t.lineTo(a, s + u), t.quadraticCurveTo(a, s, a + u, s), t.closePath(), t.fill(), i.borderWidth > 0 && t.stroke()
                }
                _updateAnimationTarget(e) {
                    const t = this,
                        n = t._chart,
                        i = t.$animations,
                        r = i && i.x,
                        o = i && i.y;
                    if (r || o) {
                        const i = so[e.position].call(t, t._active, t._eventPosition);
                        if (!i) return;
                        const a = t._size = ho(t, e),
                            s = Object.assign({}, i, t._size),
                            l = po(n, e, s),
                            c = go(e, s, l, n);
                        r._to === c.x && o._to === c.y || (t.xAlign = l.xAlign, t.yAlign = l.yAlign, t.width = a.width, t.height = a.height, t.caretX = i.x, t.caretY = i.y, t._resolveAnimations().update(t, c))
                    }
                }
                draw(e) {
                    const t = this,
                        n = t.options.setContext(t.getContext());
                    let i = t.opacity;
                    if (!i) return;
                    t._updateAnimationTarget(n);
                    const r = {
                            width: t.width,
                            height: t.height
                        },
                        o = {
                            x: t.x,
                            y: t.y
                        };
                    i = Math.abs(i) < .001 ? 0 : i;
                    const a = st(n.padding),
                        s = t.title.length || t.beforeBody.length || t.body.length || t.afterBody.length || t.footer.length;
                    n.enabled && s && (e.save(), e.globalAlpha = i, t.drawBackground(o, e, r, n), en(e, n.textDirection), o.y += a.top, t.drawTitle(o, e, n), t.drawBody(o, e, n), t.drawFooter(o, e, n), tn(e, n.textDirection), e.restore())
                }
                getActiveElements() {
                    return this._active || []
                }
                setActiveElements(e, t) {
                    const n = this,
                        i = n._active,
                        r = e.map((({
                            datasetIndex: e,
                            index: t
                        }) => {
                            const i = n._chart.getDatasetMeta(e);
                            if (!i) throw new Error("Cannot find a dataset at index " + e);
                            return {
                                datasetIndex: e,
                                element: i.data[t],
                                index: t
                            }
                        })),
                        o = !b(i, r),
                        a = n._positionChanged(r, t);
                    (o || a) && (n._active = r, n._eventPosition = t, n.update(!0))
                }
                handleEvent(e, t) {
                    const n = this,
                        i = n.options,
                        r = n._active || [];
                    let o = !1,
                        a = [];
                    "mouseout" !== e.type && (a = n._chart.getElementsAtEventForMode(e, i.mode, i, t), i.reverse && a.reverse());
                    const s = n._positionChanged(a, e);
                    return o = t || !b(a, r) || s, o && (n._active = a, (i.enabled || i.external) && (n._eventPosition = {
                        x: e.x,
                        y: e.y
                    }, n.update(!0, t))), o
                }
                _positionChanged(e, t) {
                    const {
                        caretX: n,
                        caretY: i,
                        options: r
                    } = this, o = so[r.position].call(this, e, t);
                    return !1 !== o && (n !== o.x || i !== o.y)
                }
            }
            yo.positioners = so;
            var _o = {
                id: "tooltip",
                _element: yo,
                positioners: so,
                afterInit(e, t, n) {
                    n && (e.tooltip = new yo({
                        _chart: e,
                        options: n
                    }))
                },
                beforeUpdate(e, t, n) {
                    e.tooltip && e.tooltip.initialize(n)
                },
                reset(e, t, n) {
                    e.tooltip && e.tooltip.initialize(n)
                },
                afterDraw(e) {
                    const t = e.tooltip,
                        n = {
                            tooltip: t
                        };
                    !1 !== e.notifyPlugins("beforeTooltipDraw", n) && (t && t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n))
                },
                afterEvent(e, t) {
                    if (e.tooltip) {
                        const n = t.replay;
                        e.tooltip.handleEvent(t.event, n) && (t.changed = !0)
                    }
                },
                defaults: {
                    enabled: !0,
                    external: null,
                    position: "average",
                    backgroundColor: "rgba(0,0,0,0.8)",
                    titleColor: "#fff",
                    titleFont: {
                        weight: "bold"
                    },
                    titleSpacing: 2,
                    titleMarginBottom: 6,
                    titleAlign: "left",
                    bodyColor: "#fff",
                    bodySpacing: 2,
                    bodyFont: {},
                    bodyAlign: "left",
                    footerColor: "#fff",
                    footerSpacing: 2,
                    footerMarginTop: 6,
                    footerFont: {
                        weight: "bold"
                    },
                    footerAlign: "left",
                    padding: 6,
                    caretPadding: 2,
                    caretSize: 5,
                    cornerRadius: 6,
                    boxHeight: (e, t) => t.bodyFont.size,
                    boxWidth: (e, t) => t.bodyFont.size,
                    multiKeyBackground: "#fff",
                    displayColors: !0,
                    borderColor: "rgba(0,0,0,0)",
                    borderWidth: 0,
                    animation: {
                        duration: 400,
                        easing: "easeOutQuart"
                    },
                    animations: {
                        numbers: {
                            type: "number",
                            properties: ["x", "y", "width", "height", "caretX", "caretY"]
                        },
                        opacity: {
                            easing: "linear",
                            duration: 200
                        }
                    },
                    callbacks: {
                        beforeTitle: s,
                        title(e) {
                            if (e.length > 0) {
                                const t = e[0],
                                    n = t.chart.data.labels,
                                    i = n ? n.length : 0;
                                if (this && this.options && "dataset" === this.options.mode) return t.dataset.label || "";
                                if (t.label) return t.label;
                                if (i > 0 && t.dataIndex < i) return n[t.dataIndex]
                            }
                            return ""
                        },
                        afterTitle: s,
                        beforeBody: s,
                        beforeLabel: s,
                        label(e) {
                            if (this && this.options && "dataset" === this.options.mode) return e.label + ": " + e.formattedValue || e.formattedValue;
                            let t = e.dataset.label || "";
                            t && (t += ": ");
                            const n = e.formattedValue;
                            return c(n) || (t += n), t
                        },
                        labelColor(e) {
                            const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
                            return {
                                borderColor: t.borderColor,
                                backgroundColor: t.backgroundColor,
                                borderWidth: t.borderWidth,
                                borderDash: t.borderDash,
                                borderDashOffset: t.borderDashOffset,
                                borderRadius: 0
                            }
                        },
                        labelTextColor() {
                            return this.options.bodyColor
                        },
                        labelPointStyle(e) {
                            const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
                            return {
                                pointStyle: t.pointStyle,
                                rotation: t.rotation
                            }
                        },
                        afterLabel: s,
                        afterBody: s,
                        beforeFooter: s,
                        footer: s,
                        afterFooter: s
                    }
                },
                defaultRoutes: {
                    bodyFont: "font",
                    footerFont: "font",
                    titleFont: "font"
                },
                descriptors: {
                    _scriptable: e => "filter" !== e && "itemSort" !== e && "external" !== e,
                    _indexable: !1,
                    callbacks: {
                        _scriptable: !1,
                        _indexable: !1
                    },
                    animation: {
                        _fallback: !1
                    },
                    animations: {
                        _fallback: "animation"
                    }
                },
                additionalOptionScopes: ["interaction"]
            };

            function xo(e, t, n) {
                const i = e.indexOf(t);
                if (-1 === i) return ((e, t, n) => "string" == typeof t ? e.push(t) - 1 : isNaN(t) ? null : n)(e, t, n);
                return i !== e.lastIndexOf(t) ? n : i
            }
            class wo extends Fi {
                constructor(e) {
                    super(e), this._startValue = void 0, this._valueRange = 0
                }
                parse(e, t) {
                    if (c(e)) return null;
                    const n = this.getLabels();
                    return ((e, t) => null === e ? null : Z(Math.round(e), 0, t))(t = isFinite(t) && n[t] === e ? t : xo(n, e, p(t, e)), n.length - 1)
                }
                determineDataLimits() {
                    const e = this,
                        {
                            minDefined: t,
                            maxDefined: n
                        } = e.getUserBounds();
                    let {
                        min: i,
                        max: r
                    } = e.getMinMax(!0);
                    "ticks" === e.options.bounds && (t || (i = 0), n || (r = e.getLabels().length - 1)), e.min = i, e.max = r
                }
                buildTicks() {
                    const e = this,
                        t = e.min,
                        n = e.max,
                        i = e.options.offset,
                        r = [];
                    let o = e.getLabels();
                    o = 0 === t && n === o.length - 1 ? o : o.slice(t, n + 1), e._valueRange = Math.max(o.length - (i ? 0 : 1), 1), e._startValue = e.min - (i ? .5 : 0);
                    for (let e = t; e <= n; e++) r.push({
                        value: e
                    });
                    return r
                }
                getLabelForValue(e) {
                    const t = this.getLabels();
                    return e >= 0 && e < t.length ? t[e] : e
                }
                configure() {
                    const e = this;
                    super.configure(), e.isHorizontal() || (e._reversePixels = !e._reversePixels)
                }
                getPixelForValue(e) {
                    const t = this;
                    return "number" != typeof e && (e = t.parse(e)), null === e ? NaN : t.getPixelForDecimal((e - t._startValue) / t._valueRange)
                }
                getPixelForTick(e) {
                    const t = this.ticks;
                    return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value)
                }
                getValueForPixel(e) {
                    const t = this;
                    return Math.round(t._startValue + t.getDecimalForPixel(e) * t._valueRange)
                }
                getBasePixel() {
                    return this.bottom
                }
            }

            function Eo(e, t) {
                const n = [],
                    {
                        bounds: i,
                        step: r,
                        min: o,
                        max: a,
                        precision: s,
                        count: l,
                        maxTicks: u,
                        maxDigits: d,
                        includeBounds: h
                    } = e,
                    f = r || 1,
                    p = u - 1,
                    {
                        min: g,
                        max: m
                    } = t,
                    v = !c(o),
                    b = !c(a),
                    y = !c(l),
                    _ = (m - g) / (d + 1);
                let x, w, E, k, O = q((m - g) / p / f) * f;
                if (O < 1e-14 && !v && !b) return [{
                    value: g
                }, {
                    value: m
                }];
                k = Math.ceil(m / O) - Math.floor(g / O), k > p && (O = q(k * O / p / f) * f), c(s) || (x = Math.pow(10, s), O = Math.ceil(O * x) / x), "ticks" === i ? (w = Math.floor(g / O) * O, E = Math.ceil(m / O) * O) : (w = g, E = m), v && b && r && function (e, t) {
                    const n = Math.round(e);
                    return n - t <= e && n + t >= e
                }((a - o) / r, O / 1e3) ? (k = Math.round(Math.min((a - o) / O, u)), O = (a - o) / k, w = o, E = a) : y ? (w = v ? o : w, E = b ? a : E, k = l - 1, O = (E - w) / k) : (k = (E - w) / O, k = H(k, Math.round(k), O / 1e3) ? Math.round(k) : Math.ceil(k));
                const S = Math.max(Y(O), Y(w));
                x = Math.pow(10, c(s) ? S : s), w = Math.round(w * x) / x, E = Math.round(E * x) / x;
                let C = 0;
                for (v && (h && w !== o ? (n.push({
                        value: o
                    }), w < o && C++, H(Math.round((w + C * O) * x) / x, o, ko(o, _, e)) && C++) : w < o && C++); C < k; ++C) n.push({
                    value: Math.round((w + C * O) * x) / x
                });
                return b && h && E !== a ? H(n[n.length - 1].value, a, ko(a, _, e)) ? n[n.length - 1].value = a : n.push({
                    value: a
                }) : b && E !== a || n.push({
                    value: E
                }), n
            }

            function ko(e, t, {
                horizontal: n,
                minRotation: i
            }) {
                const r = V(i),
                    o = (n ? Math.sin(r) : Math.cos(r)) || .001,
                    a = .75 * t * ("" + e).length;
                return Math.min(t / o, a)
            }
            wo.id = "category", wo.defaults = {
                ticks: {
                    callback: wo.prototype.getLabelForValue
                }
            };
            class Oo extends Fi {
                constructor(e) {
                    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0
                }
                parse(e, t) {
                    return c(e) || ("number" == typeof e || e instanceof Number) && !isFinite(+e) ? null : +e
                }
                handleTickRangeOptions() {
                    const e = this,
                        {
                            beginAtZero: t
                        } = e.options,
                        {
                            minDefined: n,
                            maxDefined: i
                        } = e.getUserBounds();
                    let {
                        min: r,
                        max: o
                    } = e;
                    const a = e => r = n ? r : e,
                        s = e => o = i ? o : e;
                    if (t) {
                        const e = B(r),
                            t = B(o);
                        e < 0 && t < 0 ? s(0) : e > 0 && t > 0 && a(0)
                    }
                    if (r === o) {
                        let e = 1;
                        (o >= Number.MAX_SAFE_INTEGER || r <= Number.MIN_SAFE_INTEGER) && (e = Math.abs(.05 * o)), s(o + e), t || a(r - e)
                    }
                    e.min = r, e.max = o
                }
                getTickLimit() {
                    const e = this,
                        t = e.options.ticks;
                    let n, {
                        maxTicksLimit: i,
                        stepSize: r
                    } = t;
                    return r ? n = Math.ceil(e.max / r) - Math.floor(e.min / r) + 1 : (n = e.computeTickLimit(), i = i || 11), i && (n = Math.min(i, n)), n
                }
                computeTickLimit() {
                    return Number.POSITIVE_INFINITY
                }
                buildTicks() {
                    const e = this,
                        t = e.options,
                        n = t.ticks;
                    let i = e.getTickLimit();
                    i = Math.max(2, i);
                    const r = Eo({
                        maxTicks: i,
                        bounds: t.bounds,
                        min: t.min,
                        max: t.max,
                        precision: n.precision,
                        step: n.stepSize,
                        count: n.count,
                        maxDigits: e._maxDigits(),
                        horizontal: e.isHorizontal(),
                        minRotation: n.minRotation || 0,
                        includeBounds: !1 !== n.includeBounds
                    }, e._range || e);
                    return "ticks" === t.bounds && U(r, e, "value"), t.reverse ? (r.reverse(), e.start = e.max, e.end = e.min) : (e.start = e.min, e.end = e.max), r
                }
                configure() {
                    const e = this,
                        t = e.ticks;
                    let n = e.min,
                        i = e.max;
                    if (super.configure(), e.options.offset && t.length) {
                        const e = (i - n) / Math.max(t.length - 1, 1) / 2;
                        n -= e, i += e
                    }
                    e._startValue = n, e._endValue = i, e._valueRange = i - n
                }
                getLabelForValue(e) {
                    return Qt(e, this.chart.options.locale)
                }
            }
            class So extends Oo {
                determineDataLimits() {
                    const e = this,
                        {
                            min: t,
                            max: n
                        } = e.getMinMax(!0);
                    e.min = h(t) ? t : 0, e.max = h(n) ? n : 1, e.handleTickRangeOptions()
                }
                computeTickLimit() {
                    const e = this,
                        t = e.isHorizontal(),
                        n = t ? e.width : e.height,
                        i = V(e.options.ticks.minRotation),
                        r = (t ? Math.sin(i) : Math.cos(i)) || .001,
                        o = e._resolveTickFontOptions(0);
                    return Math.ceil(n / Math.min(40, o.lineHeight / r))
                }
                getPixelForValue(e) {
                    return null === e ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange)
                }
                getValueForPixel(e) {
                    return this._startValue + this.getDecimalForPixel(e) * this._valueRange
                }
            }

            function Co(e) {
                return 1 === e / Math.pow(10, Math.floor(F(e)))
            }
            So.id = "linear", So.defaults = {
                ticks: {
                    callback: Mi.formatters.numeric
                }
            };
            class Ao extends Fi {
                constructor(e) {
                    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0
                }
                parse(e, t) {
                    const n = Oo.prototype.parse.apply(this, [e, t]);
                    if (0 !== n) return h(n) && n > 0 ? n : null;
                    this._zero = !0
                }
                determineDataLimits() {
                    const e = this,
                        {
                            min: t,
                            max: n
                        } = e.getMinMax(!0);
                    e.min = h(t) ? Math.max(0, t) : null, e.max = h(n) ? Math.max(0, n) : null, e.options.beginAtZero && (e._zero = !0), e.handleTickRangeOptions()
                }
                handleTickRangeOptions() {
                    const e = this,
                        {
                            minDefined: t,
                            maxDefined: n
                        } = e.getUserBounds();
                    let i = e.min,
                        r = e.max;
                    const o = e => i = t ? i : e,
                        a = e => r = n ? r : e,
                        s = (e, t) => Math.pow(10, Math.floor(F(e)) + t);
                    i === r && (i <= 0 ? (o(1), a(10)) : (o(s(i, -1)), a(s(r, 1)))), i <= 0 && o(s(r, -1)), r <= 0 && a(s(i, 1)), e._zero && e.min !== e._suggestedMin && i === s(e.min, 0) && o(s(i, -1)), e.min = i, e.max = r
                }
                buildTicks() {
                    const e = this,
                        t = e.options,
                        n = function (e, t) {
                            const n = Math.floor(F(t.max)),
                                i = Math.ceil(t.max / Math.pow(10, n)),
                                r = [];
                            let o = f(e.min, Math.pow(10, Math.floor(F(t.min)))),
                                a = Math.floor(F(o)),
                                s = Math.floor(o / Math.pow(10, a)),
                                l = a < 0 ? Math.pow(10, Math.abs(a)) : 1;
                            do {
                                r.push({
                                    value: o,
                                    major: Co(o)
                                }), ++s, 10 === s && (s = 1, ++a, l = a >= 0 ? 1 : l), o = Math.round(s * Math.pow(10, a) * l) / l
                            } while (a < n || a === n && s < i);
                            const c = f(e.max, o);
                            return r.push({
                                value: c,
                                major: Co(o)
                            }), r
                        }({
                            min: e._userMin,
                            max: e._userMax
                        }, e);
                    return "ticks" === t.bounds && U(n, e, "value"), t.reverse ? (n.reverse(), e.start = e.max, e.end = e.min) : (e.start = e.min, e.end = e.max), n
                }
                getLabelForValue(e) {
                    return void 0 === e ? "0" : Qt(e, this.chart.options.locale)
                }
                configure() {
                    const e = this,
                        t = e.min;
                    super.configure(), e._startValue = F(t), e._valueRange = F(e.max) - F(t)
                }
                getPixelForValue(e) {
                    const t = this;
                    return void 0 !== e && 0 !== e || (e = t.min), null === e || isNaN(e) ? NaN : t.getPixelForDecimal(e === t.min ? 0 : (F(e) - t._startValue) / t._valueRange)
                }
                getValueForPixel(e) {
                    const t = this,
                        n = t.getDecimalForPixel(e);
                    return Math.pow(10, t._startValue + n * t._valueRange)
                }
            }

            function Mo(e) {
                const t = e.ticks;
                if (t.display && e.display) {
                    const e = st(t.backdropPadding);
                    return p(t.font && t.font.size, ze.font.size) + e.height
                }
                return 0
            }

            function To(e, t, n, i, r) {
                return e === i || e === r ? {
                    start: t - n / 2,
                    end: t + n / 2
                } : e < i || e > r ? {
                    start: t - n,
                    end: t
                } : {
                    start: t,
                    end: t + n
                }
            }

            function Po(e) {
                const t = {
                        l: 0,
                        r: e.width,
                        t: 0,
                        b: e.height - e.paddingTop
                    },
                    n = {},
                    i = [],
                    r = [],
                    o = e.getLabels().length;
                for (let c = 0; c < o; c++) {
                    const o = e.options.pointLabels.setContext(e.getPointLabelContext(c));
                    r[c] = o.padding;
                    const d = e.getPointPosition(c, e.drawingArea + r[c]),
                        h = lt(o.font),
                        f = (a = e.ctx, s = h, l = u(l = e._pointLabels[c]) ? l : [l], {
                            w: Ue(a, s.string, l),
                            h: l.length * s.lineHeight
                        });
                    i[c] = f;
                    const p = e.getIndexAngle(c),
                        g = W(p),
                        m = To(g, d.x, f.w, 0, 180),
                        v = To(g, d.y, f.h, 90, 270);
                    m.start < t.l && (t.l = m.start, n.l = p), m.end > t.r && (t.r = m.end, n.r = p), v.start < t.t && (t.t = v.start, n.t = p), v.end > t.b && (t.b = v.end, n.b = p)
                }
                var a, s, l;
                e._setReductions(e.drawingArea, t, n), e._pointLabelItems = function (e, t, n) {
                    const i = [],
                        r = e.getLabels().length,
                        o = e.options,
                        a = Mo(o),
                        s = e.getDistanceFromCenterForValue(o.ticks.reverse ? e.min : e.max);
                    for (let o = 0; o < r; o++) {
                        const r = 0 === o ? a / 2 : 0,
                            l = e.getPointPosition(o, s + r + n[o]),
                            c = W(e.getIndexAngle(o)),
                            u = t[o],
                            d = No(l.y, u.h, c),
                            h = Do(c),
                            f = Lo(l.x, u.w, h);
                        i.push({
                            x: l.x,
                            y: d,
                            textAlign: h,
                            left: f,
                            top: d,
                            right: f + u.w,
                            bottom: d + u.h
                        })
                    }
                    return i
                }(e, i, r)
            }

            function Do(e) {
                return 0 === e || 180 === e ? "center" : e < 180 ? "left" : "right"
            }

            function Lo(e, t, n) {
                return "right" === n ? e -= t : "center" === n && (e -= t / 2), e
            }

            function No(e, t, n) {
                return 90 === n || 270 === n ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e
            }

            function jo(e, t, n, i) {
                const {
                    ctx: r
                } = e;
                if (n) r.arc(e.xCenter, e.yCenter, t, 0, P);
                else {
                    let n = e.getPointPosition(0, t);
                    r.moveTo(n.x, n.y);
                    for (let o = 1; o < i; o++) n = e.getPointPosition(o, t), r.lineTo(n.x, n.y)
                }
            }

            function Io(e) {
                return z(e) ? e : 0
            }
            Ao.id = "logarithmic", Ao.defaults = {
                ticks: {
                    callback: Mi.formatters.logarithmic,
                    major: {
                        enabled: !0
                    }
                }
            };
            class Ro extends Oo {
                constructor(e) {
                    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = []
                }
                setDimensions() {
                    const e = this;
                    e.width = e.maxWidth, e.height = e.maxHeight, e.paddingTop = Mo(e.options) / 2, e.xCenter = Math.floor(e.width / 2), e.yCenter = Math.floor((e.height - e.paddingTop) / 2), e.drawingArea = Math.min(e.height - e.paddingTop, e.width) / 2
                }
                determineDataLimits() {
                    const e = this,
                        {
                            min: t,
                            max: n
                        } = e.getMinMax(!1);
                    e.min = h(t) && !isNaN(t) ? t : 0, e.max = h(n) && !isNaN(n) ? n : 0, e.handleTickRangeOptions()
                }
                computeTickLimit() {
                    return Math.ceil(this.drawingArea / Mo(this.options))
                }
                generateTickLabels(e) {
                    const t = this;
                    Oo.prototype.generateTickLabels.call(t, e), t._pointLabels = t.getLabels().map(((e, n) => {
                        const i = m(t.options.pointLabels.callback, [e, n], t);
                        return i || 0 === i ? i : ""
                    }))
                }
                fit() {
                    const e = this,
                        t = e.options;
                    t.display && t.pointLabels.display ? Po(e) : e.setCenterPoint(0, 0, 0, 0)
                }
                _setReductions(e, t, n) {
                    const i = this;
                    let r = t.l / Math.sin(n.l),
                        o = Math.max(t.r - i.width, 0) / Math.sin(n.r),
                        a = -t.t / Math.cos(n.t),
                        s = -Math.max(t.b - (i.height - i.paddingTop), 0) / Math.cos(n.b);
                    r = Io(r), o = Io(o), a = Io(a), s = Io(s), i.drawingArea = Math.max(e / 2, Math.min(Math.floor(e - (r + o) / 2), Math.floor(e - (a + s) / 2))), i.setCenterPoint(r, o, a, s)
                }
                setCenterPoint(e, t, n, i) {
                    const r = this,
                        o = r.width - t - r.drawingArea,
                        a = e + r.drawingArea,
                        s = n + r.drawingArea,
                        l = r.height - r.paddingTop - i - r.drawingArea;
                    r.xCenter = Math.floor((a + o) / 2 + r.left), r.yCenter = Math.floor((s + l) / 2 + r.top + r.paddingTop)
                }
                getIndexAngle(e) {
                    return G(e * (P / this.getLabels().length) + V(this.options.startAngle || 0))
                }
                getDistanceFromCenterForValue(e) {
                    const t = this;
                    if (c(e)) return NaN;
                    const n = t.drawingArea / (t.max - t.min);
                    return t.options.reverse ? (t.max - e) * n : (e - t.min) * n
                }
                getValueForDistanceFromCenter(e) {
                    if (c(e)) return NaN;
                    const t = this,
                        n = e / (t.drawingArea / (t.max - t.min));
                    return t.options.reverse ? t.max - n : t.min + n
                }
                getPointLabelContext(e) {
                    const t = this,
                        n = t._pointLabels || [];
                    if (e >= 0 && e < n.length) {
                        const i = n[e];
                        return function (e, t, n) {
                            return Object.assign(Object.create(e), {
                                label: n,
                                index: t,
                                type: "pointLabel"
                            })
                        }(t.getContext(), e, i)
                    }
                }
                getPointPosition(e, t) {
                    const n = this,
                        i = n.getIndexAngle(e) - j;
                    return {
                        x: Math.cos(i) * t + n.xCenter,
                        y: Math.sin(i) * t + n.yCenter,
                        angle: i
                    }
                }
                getPointPositionForValue(e, t) {
                    return this.getPointPosition(e, this.getDistanceFromCenterForValue(t))
                }
                getBasePosition(e) {
                    return this.getPointPositionForValue(e || 0, this.getBaseValue())
                }
                getPointLabelPosition(e) {
                    const {
                        left: t,
                        top: n,
                        right: i,
                        bottom: r
                    } = this._pointLabelItems[e];
                    return {
                        left: t,
                        top: n,
                        right: i,
                        bottom: r
                    }
                }
                drawBackground() {
                    const e = this,
                        {
                            backgroundColor: t,
                            grid: {
                                circular: n
                            }
                        } = e.options;
                    if (t) {
                        const i = e.ctx;
                        i.save(), i.beginPath(), jo(e, e.getDistanceFromCenterForValue(e._endValue), n, e.getLabels().length), i.closePath(), i.fillStyle = t, i.fill(), i.restore()
                    }
                }
                drawGrid() {
                    const e = this,
                        t = e.ctx,
                        n = e.options,
                        {
                            angleLines: i,
                            grid: r
                        } = n,
                        o = e.getLabels().length;
                    let a, s, l;
                    if (n.pointLabels.display && function (e, t) {
                            const {
                                ctx: n,
                                options: {
                                    pointLabels: i
                                }
                            } = e;
                            for (let r = t - 1; r >= 0; r--) {
                                const t = i.setContext(e.getPointLabelContext(r)),
                                    o = lt(t.font),
                                    {
                                        x: a,
                                        y: s,
                                        textAlign: l,
                                        left: u,
                                        top: d,
                                        right: h,
                                        bottom: f
                                    } = e._pointLabelItems[r],
                                    {
                                        backdropColor: p
                                    } = t;
                                if (!c(p)) {
                                    const e = st(t.backdropPadding);
                                    n.fillStyle = p, n.fillRect(u - e.left, d - e.top, h - u + e.width, f - d + e.height)
                                }
                                Qe(n, e._pointLabels[r], a, s + o.lineHeight / 2, o, {
                                    color: t.color,
                                    textAlign: l,
                                    textBaseline: "middle"
                                })
                            }
                        }(e, o), r.display && e.ticks.forEach(((t, n) => {
                            if (0 !== n) {
                                s = e.getDistanceFromCenterForValue(t.value);
                                const i = r.setContext(e.getContext(n - 1));
                                ! function (e, t, n, i) {
                                    const r = e.ctx,
                                        o = t.circular,
                                        {
                                            color: a,
                                            lineWidth: s
                                        } = t;
                                    !o && !i || !a || !s || n < 0 || (r.save(), r.strokeStyle = a, r.lineWidth = s, r.setLineDash(t.borderDash), r.lineDashOffset = t.borderDashOffset, r.beginPath(), jo(e, n, o, i), r.closePath(), r.stroke(), r.restore())
                                }(e, i, s, o)
                            }
                        })), i.display) {
                        for (t.save(), a = e.getLabels().length - 1; a >= 0; a--) {
                            const r = i.setContext(e.getPointLabelContext(a)),
                                {
                                    color: o,
                                    lineWidth: c
                                } = r;
                            c && o && (t.lineWidth = c, t.strokeStyle = o, t.setLineDash(r.borderDash), t.lineDashOffset = r.borderDashOffset, s = e.getDistanceFromCenterForValue(n.ticks.reverse ? e.min : e.max), l = e.getPointPosition(a, s), t.beginPath(), t.moveTo(e.xCenter, e.yCenter), t.lineTo(l.x, l.y), t.stroke())
                        }
                        t.restore()
                    }
                }
                drawBorder() {}
                drawLabels() {
                    const e = this,
                        t = e.ctx,
                        n = e.options,
                        i = n.ticks;
                    if (!i.display) return;
                    const r = e.getIndexAngle(0);
                    let o, a;
                    t.save(), t.translate(e.xCenter, e.yCenter), t.rotate(r), t.textAlign = "center", t.textBaseline = "middle", e.ticks.forEach(((r, s) => {
                        if (0 === s && !n.reverse) return;
                        const l = i.setContext(e.getContext(s)),
                            c = lt(l.font);
                        if (o = e.getDistanceFromCenterForValue(e.ticks[s].value), l.showLabelBackdrop) {
                            t.font = c.string, a = t.measureText(r.label).width, t.fillStyle = l.backdropColor;
                            const e = st(l.backdropPadding);
                            t.fillRect(-a / 2 - e.left, -o - c.size / 2 - e.top, a + e.width, c.size + e.height)
                        }
                        Qe(t, r.label, 0, -o, c, {
                            color: l.color
                        })
                    })), t.restore()
                }
                drawTitle() {}
            }
            Ro.id = "radialLinear", Ro.defaults = {
                display: !0,
                animate: !0,
                position: "chartArea",
                angleLines: {
                    display: !0,
                    lineWidth: 1,
                    borderDash: [],
                    borderDashOffset: 0
                },
                grid: {
                    circular: !1
                },
                startAngle: 0,
                ticks: {
                    showLabelBackdrop: !0,
                    callback: Mi.formatters.numeric
                },
                pointLabels: {
                    backdropColor: void 0,
                    backdropPadding: 2,
                    display: !0,
                    font: {
                        size: 10
                    },
                    callback: e => e,
                    padding: 5
                }
            }, Ro.defaultRoutes = {
                "angleLines.color": "borderColor",
                "pointLabels.color": "color",
                "ticks.color": "color"
            }, Ro.descriptors = {
                angleLines: {
                    _fallback: "grid"
                }
            };
            const Fo = {
                    millisecond: {
                        common: !0,
                        size: 1,
                        steps: 1e3
                    },
                    second: {
                        common: !0,
                        size: 1e3,
                        steps: 60
                    },
                    minute: {
                        common: !0,
                        size: 6e4,
                        steps: 60
                    },
                    hour: {
                        common: !0,
                        size: 36e5,
                        steps: 24
                    },
                    day: {
                        common: !0,
                        size: 864e5,
                        steps: 30
                    },
                    week: {
                        common: !1,
                        size: 6048e5,
                        steps: 4
                    },
                    month: {
                        common: !0,
                        size: 2628e6,
                        steps: 12
                    },
                    quarter: {
                        common: !1,
                        size: 7884e6,
                        steps: 4
                    },
                    year: {
                        common: !0,
                        size: 3154e7
                    }
                },
                Bo = Object.keys(Fo);

            function qo(e, t) {
                return e - t
            }

            function zo(e, t) {
                if (c(t)) return null;
                const n = e._adapter,
                    {
                        parser: i,
                        round: r,
                        isoWeekday: o
                    } = e._parseOpts;
                let a = t;
                return "function" == typeof i && (a = i(a)), h(a) || (a = "string" == typeof i ? n.parse(a, i) : n.parse(a)), null === a ? null : (r && (a = "week" !== r || !z(o) && !0 !== o ? n.startOf(a, r) : n.startOf(a, "isoWeek", o)), +a)
            }

            function Ho(e, t, n, i) {
                const r = Bo.length;
                for (let o = Bo.indexOf(e); o < r - 1; ++o) {
                    const e = Fo[Bo[o]],
                        r = e.steps ? e.steps : Number.MAX_SAFE_INTEGER;
                    if (e.common && Math.ceil((n - t) / (r * e.size)) <= i) return Bo[o]
                }
                return Bo[r - 1]
            }

            function Uo(e, t, n) {
                if (n) {
                    if (n.length) {
                        const {
                            lo: i,
                            hi: r
                        } = ut(n, t);
                        e[n[i] >= t ? n[i] : n[r]] = !0
                    }
                } else e[t] = !0
            }

            function Vo(e, t, n) {
                const i = [],
                    r = {},
                    o = t.length;
                let a, s;
                for (a = 0; a < o; ++a) s = t[a], r[s] = a, i.push({
                    value: s,
                    major: !1
                });
                return 0 !== o && n ? function (e, t, n, i) {
                    const r = e._adapter,
                        o = +r.startOf(t[0].value, i),
                        a = t[t.length - 1].value;
                    let s, l;
                    for (s = o; s <= a; s = +r.add(s, 1, i)) l = n[s], l >= 0 && (t[l].major = !0);
                    return t
                }(e, i, r, n) : i
            }
            class Wo extends Fi {
                constructor(e) {
                    super(e), this._cache = {
                        data: [],
                        labels: [],
                        all: []
                    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0
                }
                init(e, t) {
                    const n = e.time || (e.time = {}),
                        i = this._adapter = new Wn._date(e.adapters.date);
                    E(n.displayFormats, i.formats()), this._parseOpts = {
                        parser: n.parser,
                        round: n.round,
                        isoWeekday: n.isoWeekday
                    }, super.init(e), this._normalized = t.normalized
                }
                parse(e, t) {
                    return void 0 === e ? null : zo(this, e)
                }
                beforeLayout() {
                    super.beforeLayout(), this._cache = {
                        data: [],
                        labels: [],
                        all: []
                    }
                }
                determineDataLimits() {
                    const e = this,
                        t = e.options,
                        n = e._adapter,
                        i = t.time.unit || "day";
                    let {
                        min: r,
                        max: o,
                        minDefined: a,
                        maxDefined: s
                    } = e.getUserBounds();

                    function l(e) {
                        a || isNaN(e.min) || (r = Math.min(r, e.min)), s || isNaN(e.max) || (o = Math.max(o, e.max))
                    }
                    a && s || (l(e._getLabelBounds()), "ticks" === t.bounds && "labels" === t.ticks.source || l(e.getMinMax(!1))), r = h(r) && !isNaN(r) ? r : +n.startOf(Date.now(), i), o = h(o) && !isNaN(o) ? o : +n.endOf(Date.now(), i) + 1, e.min = Math.min(r, o - 1), e.max = Math.max(r + 1, o)
                }
                _getLabelBounds() {
                    const e = this.getLabelTimestamps();
                    let t = Number.POSITIVE_INFINITY,
                        n = Number.NEGATIVE_INFINITY;
                    return e.length && (t = e[0], n = e[e.length - 1]), {
                        min: t,
                        max: n
                    }
                }
                buildTicks() {
                    const e = this,
                        t = e.options,
                        n = t.time,
                        i = t.ticks,
                        r = "labels" === i.source ? e.getLabelTimestamps() : e._generate();
                    "ticks" === t.bounds && r.length && (e.min = e._userMin || r[0], e.max = e._userMax || r[r.length - 1]);
                    const o = e.min,
                        a = function (e, t, n) {
                            let i = 0,
                                r = e.length;
                            for (; i < r && e[i] < t;) i++;
                            for (; r > i && e[r - 1] > n;) r--;
                            return i > 0 || r < e.length ? e.slice(i, r) : e
                        }(r, o, e.max);
                    return e._unit = n.unit || (i.autoSkip ? Ho(n.minUnit, e.min, e.max, e._getLabelCapacity(o)) : function (e, t, n, i, r) {
                        for (let o = Bo.length - 1; o >= Bo.indexOf(n); o--) {
                            const n = Bo[o];
                            if (Fo[n].common && e._adapter.diff(r, i, n) >= t - 1) return n
                        }
                        return Bo[n ? Bo.indexOf(n) : 0]
                    }(e, a.length, n.minUnit, e.min, e.max)), e._majorUnit = i.major.enabled && "year" !== e._unit ? function (e) {
                        for (let t = Bo.indexOf(e) + 1, n = Bo.length; t < n; ++t)
                            if (Fo[Bo[t]].common) return Bo[t]
                    }(e._unit) : void 0, e.initOffsets(r), t.reverse && a.reverse(), Vo(e, a, e._majorUnit)
                }
                initOffsets(e) {
                    const t = this;
                    let n, i, r = 0,
                        o = 0;
                    t.options.offset && e.length && (n = t.getDecimalForValue(e[0]), r = 1 === e.length ? 1 - n : (t.getDecimalForValue(e[1]) - n) / 2, i = t.getDecimalForValue(e[e.length - 1]), o = 1 === e.length ? i : (i - t.getDecimalForValue(e[e.length - 2])) / 2);
                    const a = e.length < 3 ? .5 : .25;
                    r = Z(r, 0, a), o = Z(o, 0, a), t._offsets = {
                        start: r,
                        end: o,
                        factor: 1 / (r + 1 + o)
                    }
                }
                _generate() {
                    const e = this,
                        t = e._adapter,
                        n = e.min,
                        i = e.max,
                        r = e.options,
                        o = r.time,
                        a = o.unit || Ho(o.minUnit, n, i, e._getLabelCapacity(n)),
                        s = p(o.stepSize, 1),
                        l = "week" === a && o.isoWeekday,
                        c = z(l) || !0 === l,
                        u = {};
                    let d, h, f = n;
                    if (c && (f = +t.startOf(f, "isoWeek", l)), f = +t.startOf(f, c ? "day" : a), t.diff(i, n, a) > 1e5 * s) throw new Error(n + " and " + i + " are too far apart with stepSize of " + s + " " + a);
                    const g = "data" === r.ticks.source && e.getDataTimestamps();
                    for (d = f, h = 0; d < i; d = +t.add(d, s, a), h++) Uo(u, d, g);
                    return d !== i && "ticks" !== r.bounds && 1 !== h || Uo(u, d, g), Object.keys(u).sort(((e, t) => e - t)).map((e => +e))
                }
                getLabelForValue(e) {
                    const t = this._adapter,
                        n = this.options.time;
                    return n.tooltipFormat ? t.format(e, n.tooltipFormat) : t.format(e, n.displayFormats.datetime)
                }
                _tickFormatFunction(e, t, n, i) {
                    const r = this,
                        o = r.options,
                        a = o.time.displayFormats,
                        s = r._unit,
                        l = r._majorUnit,
                        c = s && a[s],
                        u = l && a[l],
                        d = n[t],
                        h = l && u && d && d.major,
                        f = r._adapter.format(e, i || (h ? u : c)),
                        p = o.ticks.callback;
                    return p ? m(p, [f, t, n], r) : f
                }
                generateTickLabels(e) {
                    let t, n, i;
                    for (t = 0, n = e.length; t < n; ++t) i = e[t], i.label = this._tickFormatFunction(i.value, t, e)
                }
                getDecimalForValue(e) {
                    const t = this;
                    return null === e ? NaN : (e - t.min) / (t.max - t.min)
                }
                getPixelForValue(e) {
                    const t = this,
                        n = t._offsets,
                        i = t.getDecimalForValue(e);
                    return t.getPixelForDecimal((n.start + i) * n.factor)
                }
                getValueForPixel(e) {
                    const t = this,
                        n = t._offsets,
                        i = t.getDecimalForPixel(e) / n.factor - n.end;
                    return t.min + i * (t.max - t.min)
                }
                _getLabelSize(e) {
                    const t = this,
                        n = t.options.ticks,
                        i = t.ctx.measureText(e).width,
                        r = V(t.isHorizontal() ? n.maxRotation : n.minRotation),
                        o = Math.cos(r),
                        a = Math.sin(r),
                        s = t._resolveTickFontOptions(0).size;
                    return {
                        w: i * o + s * a,
                        h: i * a + s * o
                    }
                }
                _getLabelCapacity(e) {
                    const t = this,
                        n = t.options.time,
                        i = n.displayFormats,
                        r = i[n.unit] || i.millisecond,
                        o = t._tickFormatFunction(e, 0, Vo(t, [e], t._majorUnit), r),
                        a = t._getLabelSize(o),
                        s = Math.floor(t.isHorizontal() ? t.width / a.w : t.height / a.h) - 1;
                    return s > 0 ? s : 1
                }
                getDataTimestamps() {
                    const e = this;
                    let t, n, i = e._cache.data || [];
                    if (i.length) return i;
                    const r = e.getMatchingVisibleMetas();
                    if (e._normalized && r.length) return e._cache.data = r[0].controller.getAllParsedValues(e);
                    for (t = 0, n = r.length; t < n; ++t) i = i.concat(r[t].controller.getAllParsedValues(e));
                    return e._cache.data = e.normalize(i)
                }
                getLabelTimestamps() {
                    const e = this,
                        t = e._cache.labels || [];
                    let n, i;
                    if (t.length) return t;
                    const r = e.getLabels();
                    for (n = 0, i = r.length; n < i; ++n) t.push(zo(e, r[n]));
                    return e._cache.labels = e._normalized ? t : e.normalize(t)
                }
                normalize(e) {
                    return gt(e.sort(qo))
                }
            }

            function Yo(e, t, n) {
                let i, r, o, a, s = 0,
                    l = e.length - 1;
                n ? (t >= e[s].pos && t <= e[l].pos && ({
                    lo: s,
                    hi: l
                } = dt(e, "pos", t)), ({
                    pos: i,
                    time: o
                } = e[s]), ({
                    pos: r,
                    time: a
                } = e[l])) : (t >= e[s].time && t <= e[l].time && ({
                    lo: s,
                    hi: l
                } = dt(e, "time", t)), ({
                    time: i,
                    pos: o
                } = e[s]), ({
                    time: r,
                    pos: a
                } = e[l]));
                const c = r - i;
                return c ? o + (a - o) * (t - i) / c : o
            }
            Wo.id = "time", Wo.defaults = {
                bounds: "data",
                adapters: {},
                time: {
                    parser: !1,
                    unit: !1,
                    round: !1,
                    isoWeekday: !1,
                    minUnit: "millisecond",
                    displayFormats: {}
                },
                ticks: {
                    source: "auto",
                    major: {
                        enabled: !1
                    }
                }
            };
            class $o extends Wo {
                constructor(e) {
                    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0
                }
                initOffsets() {
                    const e = this,
                        t = e._getTimestampsForTable(),
                        n = e._table = e.buildLookupTable(t);
                    e._minPos = Yo(n, e.min), e._tableRange = Yo(n, e.max) - e._minPos, super.initOffsets(t)
                }
                buildLookupTable(e) {
                    const {
                        min: t,
                        max: n
                    } = this, i = [], r = [];
                    let o, a, s, l, c;
                    for (o = 0, a = e.length; o < a; ++o) l = e[o], l >= t && l <= n && i.push(l);
                    if (i.length < 2) return [{
                        time: t,
                        pos: 0
                    }, {
                        time: n,
                        pos: 1
                    }];
                    for (o = 0, a = i.length; o < a; ++o) c = i[o + 1], s = i[o - 1], l = i[o], Math.round((c + s) / 2) !== l && r.push({
                        time: l,
                        pos: o / (a - 1)
                    });
                    return r
                }
                _getTimestampsForTable() {
                    const e = this;
                    let t = e._cache.all || [];
                    if (t.length) return t;
                    const n = e.getDataTimestamps(),
                        i = e.getLabelTimestamps();
                    return t = n.length && i.length ? e.normalize(n.concat(i)) : n.length ? n : i, t = e._cache.all = t, t
                }
                getDecimalForValue(e) {
                    return (Yo(this._table, e) - this._minPos) / this._tableRange
                }
                getValueForPixel(e) {
                    const t = this,
                        n = t._offsets,
                        i = t.getDecimalForPixel(e) / n.factor - n.end;
                    return Yo(t._table, i * t._tableRange + t._minPos, !0)
                }
            }
            $o.id = "timeseries", $o.defaults = Wo.defaults
        },
        529: e => {
            var t;
            window, t = function () {
                return function (e) {
                    var t = {};

                    function n(i) {
                        if (t[i]) return t[i].exports;
                        var r = t[i] = {
                            i,
                            l: !1,
                            exports: {}
                        };
                        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
                    }
                    return n.m = e, n.c = t, n.d = function (e, t, i) {
                        n.o(e, t) || Object.defineProperty(e, t, {
                            enumerable: !0,
                            get: i
                        })
                    }, n.r = function (e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        })
                    }, n.t = function (e, t) {
                        if (1 & t && (e = n(e)), 8 & t) return e;
                        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                        var i = Object.create(null);
                        if (n.r(i), Object.defineProperty(i, "default", {
                                enumerable: !0,
                                value: e
                            }), 2 & t && "string" != typeof e)
                            for (var r in e) n.d(i, r, function (t) {
                                return e[t]
                            }.bind(null, r));
                        return i
                    }, n.n = function (e) {
                        var t = e && e.__esModule ? function () {
                            return e.default
                        } : function () {
                            return e
                        };
                        return n.d(t, "a", t), t
                    }, n.o = function (e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }, n.p = "/public/assets/scripts/", n(n.s = 4)
                }([function (e, t, n) {
                    "use strict";
                    var i = function (e) {
                            return function (e) {
                                return !!e && "object" == typeof e
                            }(e) && ! function (e) {
                                var t = Object.prototype.toString.call(e);
                                return "[object RegExp]" === t || "[object Date]" === t || function (e) {
                                    return e.$$typeof === r
                                }(e)
                            }(e)
                        },
                        r = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

                    function o(e, t) {
                        return !1 !== t.clone && t.isMergeableObject(e) ? c((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
                        var n
                    }

                    function a(e, t, n) {
                        return e.concat(t).map((function (e) {
                            return o(e, n)
                        }))
                    }

                    function s(e) {
                        return Object.keys(e).concat(function (e) {
                            return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter((function (t) {
                                return e.propertyIsEnumerable(t)
                            })) : []
                        }(e))
                    }

                    function l(e, t, n) {
                        var i = {};
                        return n.isMergeableObject(e) && s(e).forEach((function (t) {
                            i[t] = o(e[t], n)
                        })), s(t).forEach((function (r) {
                            (function (e, t) {
                                try {
                                    return t in e && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t))
                                } catch (e) {
                                    return !1
                                }
                            })(e, r) || (n.isMergeableObject(t[r]) && e[r] ? i[r] = function (e, t) {
                                if (!t.customMerge) return c;
                                var n = t.customMerge(e);
                                return "function" == typeof n ? n : c
                            }(r, n)(e[r], t[r], n) : i[r] = o(t[r], n))
                        })), i
                    }

                    function c(e, t, n) {
                        (n = n || {}).arrayMerge = n.arrayMerge || a, n.isMergeableObject = n.isMergeableObject || i, n.cloneUnlessOtherwiseSpecified = o;
                        var r = Array.isArray(t);
                        return r === Array.isArray(e) ? r ? n.arrayMerge(e, t, n) : l(e, t, n) : o(t, n)
                    }
                    c.all = function (e, t) {
                        if (!Array.isArray(e)) throw new Error("first argument should be an array");
                        return e.reduce((function (e, n) {
                            return c(e, n, t)
                        }), {})
                    };
                    var u = c;
                    e.exports = u
                }, function (e, t, n) {
                    "use strict";
                    (function (e, i) {
                        var r, o = n(3);
                        r = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : i;
                        var a = Object(o.a)(r);
                        t.a = a
                    }).call(this, n(5), n(6)(e))
                }, function (e, t, n) {
                    e.exports = function (e) {
                        var t = {};

                        function n(i) {
                            if (t[i]) return t[i].exports;
                            var r = t[i] = {
                                i,
                                l: !1,
                                exports: {}
                            };
                            return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
                        }
                        return n.m = e, n.c = t, n.d = function (e, t, i) {
                            n.o(e, t) || Object.defineProperty(e, t, {
                                enumerable: !0,
                                get: i
                            })
                        }, n.r = function (e) {
                            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                                value: "Module"
                            }), Object.defineProperty(e, "__esModule", {
                                value: !0
                            })
                        }, n.t = function (e, t) {
                            if (1 & t && (e = n(e)), 8 & t) return e;
                            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
                            var i = Object.create(null);
                            if (n.r(i), Object.defineProperty(i, "default", {
                                    enumerable: !0,
                                    value: e
                                }), 2 & t && "string" != typeof e)
                                for (var r in e) n.d(i, r, function (t) {
                                    return e[t]
                                }.bind(null, r));
                            return i
                        }, n.n = function (e) {
                            var t = e && e.__esModule ? function () {
                                return e.default
                            } : function () {
                                return e
                            };
                            return n.d(t, "a", t), t
                        }, n.o = function (e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t)
                        }, n.p = "", n(n.s = 1)
                    }([function (e, t) {
                        e.exports = function (e) {
                            return Array.isArray ? Array.isArray(e) : "[object Array]" === Object.prototype.toString.call(e)
                        }
                    }, function (e, t, n) {
                        function i(e) {
                            return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                return typeof e
                            } : function (e) {
                                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                            })(e)
                        }

                        function r(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                            }
                        }
                        var o = n(2),
                            a = n(8),
                            s = n(0),
                            l = function () {
                                function e(t, n) {
                                    var i = n.location,
                                        r = void 0 === i ? 0 : i,
                                        o = n.distance,
                                        s = void 0 === o ? 100 : o,
                                        l = n.threshold,
                                        c = void 0 === l ? .6 : l,
                                        u = n.maxPatternLength,
                                        d = void 0 === u ? 32 : u,
                                        h = n.caseSensitive,
                                        f = void 0 !== h && h,
                                        p = n.tokenSeparator,
                                        g = void 0 === p ? / +/g : p,
                                        m = n.findAllMatches,
                                        v = void 0 !== m && m,
                                        b = n.minMatchCharLength,
                                        y = void 0 === b ? 1 : b,
                                        _ = n.id,
                                        x = void 0 === _ ? null : _,
                                        w = n.keys,
                                        E = void 0 === w ? [] : w,
                                        k = n.shouldSort,
                                        O = void 0 === k || k,
                                        S = n.getFn,
                                        C = void 0 === S ? a : S,
                                        A = n.sortFn,
                                        M = void 0 === A ? function (e, t) {
                                            return e.score - t.score
                                        } : A,
                                        T = n.tokenize,
                                        P = void 0 !== T && T,
                                        D = n.matchAllTokens,
                                        L = void 0 !== D && D,
                                        N = n.includeMatches,
                                        j = void 0 !== N && N,
                                        I = n.includeScore,
                                        R = void 0 !== I && I,
                                        F = n.verbose,
                                        B = void 0 !== F && F;
                                    ! function (e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                    }(this, e), this.options = {
                                        location: r,
                                        distance: s,
                                        threshold: c,
                                        maxPatternLength: d,
                                        isCaseSensitive: f,
                                        tokenSeparator: g,
                                        findAllMatches: v,
                                        minMatchCharLength: y,
                                        id: x,
                                        keys: E,
                                        includeMatches: j,
                                        includeScore: R,
                                        shouldSort: O,
                                        getFn: C,
                                        sortFn: M,
                                        verbose: B,
                                        tokenize: P,
                                        matchAllTokens: L
                                    }, this.setCollection(t)
                                }
                                var t, n, l;
                                return t = e, (n = [{
                                    key: "setCollection",
                                    value: function (e) {
                                        return this.list = e, e
                                    }
                                }, {
                                    key: "search",
                                    value: function (e) {
                                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                                            limit: !1
                                        };
                                        this._log('---------\nSearch pattern: "'.concat(e, '"'));
                                        var n = this._prepareSearchers(e),
                                            i = n.tokenSearchers,
                                            r = n.fullSearcher,
                                            o = this._search(i, r),
                                            a = o.weights,
                                            s = o.results;
                                        return this._computeScore(a, s), this.options.shouldSort && this._sort(s), t.limit && "number" == typeof t.limit && (s = s.slice(0, t.limit)), this._format(s)
                                    }
                                }, {
                                    key: "_prepareSearchers",
                                    value: function () {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
                                            t = [];
                                        if (this.options.tokenize)
                                            for (var n = e.split(this.options.tokenSeparator), i = 0, r = n.length; i < r; i += 1) t.push(new o(n[i], this.options));
                                        return {
                                            tokenSearchers: t,
                                            fullSearcher: new o(e, this.options)
                                        }
                                    }
                                }, {
                                    key: "_search",
                                    value: function () {
                                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                                            t = arguments.length > 1 ? arguments[1] : void 0,
                                            n = this.list,
                                            i = {},
                                            r = [];
                                        if ("string" == typeof n[0]) {
                                            for (var o = 0, a = n.length; o < a; o += 1) this._analyze({
                                                key: "",
                                                value: n[o],
                                                record: o,
                                                index: o
                                            }, {
                                                resultMap: i,
                                                results: r,
                                                tokenSearchers: e,
                                                fullSearcher: t
                                            });
                                            return {
                                                weights: null,
                                                results: r
                                            }
                                        }
                                        for (var s = {}, l = 0, c = n.length; l < c; l += 1)
                                            for (var u = n[l], d = 0, h = this.options.keys.length; d < h; d += 1) {
                                                var f = this.options.keys[d];
                                                if ("string" != typeof f) {
                                                    if (s[f.name] = {
                                                            weight: 1 - f.weight || 1
                                                        }, f.weight <= 0 || f.weight > 1) throw new Error("Key weight has to be > 0 and <= 1");
                                                    f = f.name
                                                } else s[f] = {
                                                    weight: 1
                                                };
                                                this._analyze({
                                                    key: f,
                                                    value: this.options.getFn(u, f),
                                                    record: u,
                                                    index: l
                                                }, {
                                                    resultMap: i,
                                                    results: r,
                                                    tokenSearchers: e,
                                                    fullSearcher: t
                                                })
                                            }
                                        return {
                                            weights: s,
                                            results: r
                                        }
                                    }
                                }, {
                                    key: "_analyze",
                                    value: function (e, t) {
                                        var n = e.key,
                                            i = e.arrayIndex,
                                            r = void 0 === i ? -1 : i,
                                            o = e.value,
                                            a = e.record,
                                            l = e.index,
                                            c = t.tokenSearchers,
                                            u = void 0 === c ? [] : c,
                                            d = t.fullSearcher,
                                            h = void 0 === d ? [] : d,
                                            f = t.resultMap,
                                            p = void 0 === f ? {} : f,
                                            g = t.results,
                                            m = void 0 === g ? [] : g;
                                        if (null != o) {
                                            var v = !1,
                                                b = -1,
                                                y = 0;
                                            if ("string" == typeof o) {
                                                this._log("\nKey: ".concat("" === n ? "-" : n));
                                                var _ = h.search(o);
                                                if (this._log('Full text: "'.concat(o, '", score: ').concat(_.score)), this.options.tokenize) {
                                                    for (var x = o.split(this.options.tokenSeparator), w = [], E = 0; E < u.length; E += 1) {
                                                        var k = u[E];
                                                        this._log('\nPattern: "'.concat(k.pattern, '"'));
                                                        for (var O = !1, S = 0; S < x.length; S += 1) {
                                                            var C = x[S],
                                                                A = k.search(C),
                                                                M = {};
                                                            A.isMatch ? (M[C] = A.score, v = !0, O = !0, w.push(A.score)) : (M[C] = 1, this.options.matchAllTokens || w.push(1)), this._log('Token: "'.concat(C, '", score: ').concat(M[C]))
                                                        }
                                                        O && (y += 1)
                                                    }
                                                    b = w[0];
                                                    for (var T = w.length, P = 1; P < T; P += 1) b += w[P];
                                                    b /= T, this._log("Token score average:", b)
                                                }
                                                var D = _.score;
                                                b > -1 && (D = (D + b) / 2), this._log("Score average:", D);
                                                var L = !this.options.tokenize || !this.options.matchAllTokens || y >= u.length;
                                                if (this._log("\nCheck Matches: ".concat(L)), (v || _.isMatch) && L) {
                                                    var N = p[l];
                                                    N ? N.output.push({
                                                        key: n,
                                                        arrayIndex: r,
                                                        value: o,
                                                        score: D,
                                                        matchedIndices: _.matchedIndices
                                                    }) : (p[l] = {
                                                        item: a,
                                                        output: [{
                                                            key: n,
                                                            arrayIndex: r,
                                                            value: o,
                                                            score: D,
                                                            matchedIndices: _.matchedIndices
                                                        }]
                                                    }, m.push(p[l]))
                                                }
                                            } else if (s(o))
                                                for (var j = 0, I = o.length; j < I; j += 1) this._analyze({
                                                    key: n,
                                                    arrayIndex: j,
                                                    value: o[j],
                                                    record: a,
                                                    index: l
                                                }, {
                                                    resultMap: p,
                                                    results: m,
                                                    tokenSearchers: u,
                                                    fullSearcher: h
                                                })
                                        }
                                    }
                                }, {
                                    key: "_computeScore",
                                    value: function (e, t) {
                                        this._log("\n\nComputing score:\n");
                                        for (var n = 0, i = t.length; n < i; n += 1) {
                                            for (var r = t[n].output, o = r.length, a = 1, s = 1, l = 0; l < o; l += 1) {
                                                var c = e ? e[r[l].key].weight : 1,
                                                    u = (1 === c ? r[l].score : r[l].score || .001) * c;
                                                1 !== c ? s = Math.min(s, u) : (r[l].nScore = u, a *= u)
                                            }
                                            t[n].score = 1 === s ? a : s, this._log(t[n])
                                        }
                                    }
                                }, {
                                    key: "_sort",
                                    value: function (e) {
                                        this._log("\n\nSorting...."), e.sort(this.options.sortFn)
                                    }
                                }, {
                                    key: "_format",
                                    value: function (e) {
                                        var t = [];
                                        if (this.options.verbose) {
                                            var n = [];
                                            this._log("\n\nOutput:\n\n", JSON.stringify(e, (function (e, t) {
                                                if ("object" === i(t) && null !== t) {
                                                    if (-1 !== n.indexOf(t)) return;
                                                    n.push(t)
                                                }
                                                return t
                                            }))), n = null
                                        }
                                        var r = [];
                                        this.options.includeMatches && r.push((function (e, t) {
                                            var n = e.output;
                                            t.matches = [];
                                            for (var i = 0, r = n.length; i < r; i += 1) {
                                                var o = n[i];
                                                if (0 !== o.matchedIndices.length) {
                                                    var a = {
                                                        indices: o.matchedIndices,
                                                        value: o.value
                                                    };
                                                    o.key && (a.key = o.key), o.hasOwnProperty("arrayIndex") && o.arrayIndex > -1 && (a.arrayIndex = o.arrayIndex), t.matches.push(a)
                                                }
                                            }
                                        })), this.options.includeScore && r.push((function (e, t) {
                                            t.score = e.score
                                        }));
                                        for (var o = 0, a = e.length; o < a; o += 1) {
                                            var s = e[o];
                                            if (this.options.id && (s.item = this.options.getFn(s.item, this.options.id)[0]), r.length) {
                                                for (var l = {
                                                        item: s.item
                                                    }, c = 0, u = r.length; c < u; c += 1) r[c](s, l);
                                                t.push(l)
                                            } else t.push(s.item)
                                        }
                                        return t
                                    }
                                }, {
                                    key: "_log",
                                    value: function () {
                                        var e;
                                        this.options.verbose && (e = console).log.apply(e, arguments)
                                    }
                                }]) && r(t.prototype, n), l && r(t, l), e
                            }();
                        e.exports = l
                    }, function (e, t, n) {
                        function i(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                            }
                        }
                        var r = n(3),
                            o = n(4),
                            a = n(7),
                            s = function () {
                                function e(t, n) {
                                    var i = n.location,
                                        r = void 0 === i ? 0 : i,
                                        o = n.distance,
                                        s = void 0 === o ? 100 : o,
                                        l = n.threshold,
                                        c = void 0 === l ? .6 : l,
                                        u = n.maxPatternLength,
                                        d = void 0 === u ? 32 : u,
                                        h = n.isCaseSensitive,
                                        f = void 0 !== h && h,
                                        p = n.tokenSeparator,
                                        g = void 0 === p ? / +/g : p,
                                        m = n.findAllMatches,
                                        v = void 0 !== m && m,
                                        b = n.minMatchCharLength,
                                        y = void 0 === b ? 1 : b;
                                    ! function (e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                    }(this, e), this.options = {
                                        location: r,
                                        distance: s,
                                        threshold: c,
                                        maxPatternLength: d,
                                        isCaseSensitive: f,
                                        tokenSeparator: g,
                                        findAllMatches: v,
                                        minMatchCharLength: y
                                    }, this.pattern = this.options.isCaseSensitive ? t : t.toLowerCase(), this.pattern.length <= d && (this.patternAlphabet = a(this.pattern))
                                }
                                var t, n, s;
                                return t = e, (n = [{
                                    key: "search",
                                    value: function (e) {
                                        if (this.options.isCaseSensitive || (e = e.toLowerCase()), this.pattern === e) return {
                                            isMatch: !0,
                                            score: 0,
                                            matchedIndices: [
                                                [0, e.length - 1]
                                            ]
                                        };
                                        var t = this.options,
                                            n = t.maxPatternLength,
                                            i = t.tokenSeparator;
                                        if (this.pattern.length > n) return r(e, this.pattern, i);
                                        var a = this.options,
                                            s = a.location,
                                            l = a.distance,
                                            c = a.threshold,
                                            u = a.findAllMatches,
                                            d = a.minMatchCharLength;
                                        return o(e, this.pattern, this.patternAlphabet, {
                                            location: s,
                                            distance: l,
                                            threshold: c,
                                            findAllMatches: u,
                                            minMatchCharLength: d
                                        })
                                    }
                                }]) && i(t.prototype, n), s && i(t, s), e
                            }();
                        e.exports = s
                    }, function (e, t) {
                        var n = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
                        e.exports = function (e, t) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : / +/g,
                                r = new RegExp(t.replace(n, "\\$&").replace(i, "|")),
                                o = e.match(r),
                                a = !!o,
                                s = [];
                            if (a)
                                for (var l = 0, c = o.length; l < c; l += 1) {
                                    var u = o[l];
                                    s.push([e.indexOf(u), u.length - 1])
                                }
                            return {
                                score: a ? .5 : 1,
                                isMatch: a,
                                matchedIndices: s
                            }
                        }
                    }, function (e, t, n) {
                        var i = n(5),
                            r = n(6);
                        e.exports = function (e, t, n, o) {
                            for (var a = o.location, s = void 0 === a ? 0 : a, l = o.distance, c = void 0 === l ? 100 : l, u = o.threshold, d = void 0 === u ? .6 : u, h = o.findAllMatches, f = void 0 !== h && h, p = o.minMatchCharLength, g = void 0 === p ? 1 : p, m = s, v = e.length, b = d, y = e.indexOf(t, m), _ = t.length, x = [], w = 0; w < v; w += 1) x[w] = 0;
                            if (-1 !== y) {
                                var E = i(t, {
                                    errors: 0,
                                    currentLocation: y,
                                    expectedLocation: m,
                                    distance: c
                                });
                                if (b = Math.min(E, b), -1 !== (y = e.lastIndexOf(t, m + _))) {
                                    var k = i(t, {
                                        errors: 0,
                                        currentLocation: y,
                                        expectedLocation: m,
                                        distance: c
                                    });
                                    b = Math.min(k, b)
                                }
                            }
                            y = -1;
                            for (var O = [], S = 1, C = _ + v, A = 1 << _ - 1, M = 0; M < _; M += 1) {
                                for (var T = 0, P = C; T < P;) i(t, {
                                    errors: M,
                                    currentLocation: m + P,
                                    expectedLocation: m,
                                    distance: c
                                }) <= b ? T = P : C = P, P = Math.floor((C - T) / 2 + T);
                                C = P;
                                var D = Math.max(1, m - P + 1),
                                    L = f ? v : Math.min(m + P, v) + _,
                                    N = Array(L + 2);
                                N[L + 1] = (1 << M) - 1;
                                for (var j = L; j >= D; j -= 1) {
                                    var I = j - 1,
                                        R = n[e.charAt(I)];
                                    if (R && (x[I] = 1), N[j] = (N[j + 1] << 1 | 1) & R, 0 !== M && (N[j] |= (O[j + 1] | O[j]) << 1 | 1 | O[j + 1]), N[j] & A && (S = i(t, {
                                            errors: M,
                                            currentLocation: I,
                                            expectedLocation: m,
                                            distance: c
                                        })) <= b) {
                                        if (b = S, (y = I) <= m) break;
                                        D = Math.max(1, 2 * m - y)
                                    }
                                }
                                if (i(t, {
                                        errors: M + 1,
                                        currentLocation: m,
                                        expectedLocation: m,
                                        distance: c
                                    }) > b) break;
                                O = N
                            }
                            return {
                                isMatch: y >= 0,
                                score: 0 === S ? .001 : S,
                                matchedIndices: r(x, g)
                            }
                        }
                    }, function (e, t) {
                        e.exports = function (e, t) {
                            var n = t.errors,
                                i = void 0 === n ? 0 : n,
                                r = t.currentLocation,
                                o = void 0 === r ? 0 : r,
                                a = t.expectedLocation,
                                s = void 0 === a ? 0 : a,
                                l = t.distance,
                                c = void 0 === l ? 100 : l,
                                u = i / e.length,
                                d = Math.abs(s - o);
                            return c ? u + d / c : d ? 1 : u
                        }
                    }, function (e, t) {
                        e.exports = function () {
                            for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = [], i = -1, r = -1, o = 0, a = e.length; o < a; o += 1) {
                                var s = e[o];
                                s && -1 === i ? i = o : s || -1 === i || ((r = o - 1) - i + 1 >= t && n.push([i, r]), i = -1)
                            }
                            return e[o - 1] && o - i >= t && n.push([i, o - 1]), n
                        }
                    }, function (e, t) {
                        e.exports = function (e) {
                            for (var t = {}, n = e.length, i = 0; i < n; i += 1) t[e.charAt(i)] = 0;
                            for (var r = 0; r < n; r += 1) t[e.charAt(r)] |= 1 << n - r - 1;
                            return t
                        }
                    }, function (e, t, n) {
                        var i = n(0);
                        e.exports = function (e, t) {
                            return function e(t, n, r) {
                                if (n) {
                                    var o = n.indexOf("."),
                                        a = n,
                                        s = null; - 1 !== o && (a = n.slice(0, o), s = n.slice(o + 1));
                                    var l = t[a];
                                    if (null != l)
                                        if (s || "string" != typeof l && "number" != typeof l)
                                            if (i(l))
                                                for (var c = 0, u = l.length; c < u; c += 1) e(l[c], s, r);
                                            else s && e(l, s, r);
                                    else r.push(l.toString())
                                } else r.push(t);
                                return r
                            }(e, t, [])
                        }
                    }])
                }, function (e, t, n) {
                    "use strict";

                    function i(e) {
                        var t, n = e.Symbol;
                        return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t
                    }
                    n.d(t, "a", (function () {
                        return i
                    }))
                }, function (e, t, n) {
                    e.exports = n(7)
                }, function (e, t) {
                    var n;
                    n = function () {
                        return this
                    }();
                    try {
                        n = n || new Function("return this")()
                    } catch (e) {
                        "object" == typeof window && (n = window)
                    }
                    e.exports = n
                }, function (e, t) {
                    e.exports = function (e) {
                        if (!e.webpackPolyfill) {
                            var t = Object.create(e);
                            t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                                enumerable: !0,
                                get: function () {
                                    return t.l
                                }
                            }), Object.defineProperty(t, "id", {
                                enumerable: !0,
                                get: function () {
                                    return t.i
                                }
                            }), Object.defineProperty(t, "exports", {
                                enumerable: !0
                            }), t.webpackPolyfill = 1
                        }
                        return t
                    }
                }, function (e, t, n) {
                    "use strict";
                    n.r(t);
                    var i = n(2),
                        r = n.n(i),
                        o = n(0),
                        a = n.n(o),
                        s = n(1),
                        l = function () {
                            return Math.random().toString(36).substring(7).split("").join(".")
                        },
                        c = {
                            INIT: "@@redux/INIT" + l(),
                            REPLACE: "@@redux/REPLACE" + l(),
                            PROBE_UNKNOWN_ACTION: function () {
                                return "@@redux/PROBE_UNKNOWN_ACTION" + l()
                            }
                        };

                    function u(e) {
                        if ("object" != typeof e || null === e) return !1;
                        for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
                        return Object.getPrototypeOf(e) === t
                    }

                    function d(e, t, n) {
                        var i;
                        if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function.");
                        if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
                            if ("function" != typeof n) throw new Error("Expected the enhancer to be a function.");
                            return n(d)(e, t)
                        }
                        if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
                        var r = e,
                            o = t,
                            a = [],
                            l = a,
                            h = !1;

                        function f() {
                            l === a && (l = a.slice())
                        }

                        function p() {
                            if (h) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
                            return o
                        }

                        function g(e) {
                            if ("function" != typeof e) throw new Error("Expected the listener to be a function.");
                            if (h) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
                            var t = !0;
                            return f(), l.push(e),
                                function () {
                                    if (t) {
                                        if (h) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
                                        t = !1, f();
                                        var n = l.indexOf(e);
                                        l.splice(n, 1)
                                    }
                                }
                        }

                        function m(e) {
                            if (!u(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
                            if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
                            if (h) throw new Error("Reducers may not dispatch actions.");
                            try {
                                h = !0, o = r(o, e)
                            } finally {
                                h = !1
                            }
                            for (var t = a = l, n = 0; n < t.length; n++)(0, t[n])();
                            return e
                        }

                        function v(e) {
                            if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
                            r = e, m({
                                type: c.REPLACE
                            })
                        }

                        function b() {
                            var e, t = g;
                            return (e = {
                                subscribe: function (e) {
                                    if ("object" != typeof e || null === e) throw new TypeError("Expected the observer to be an object.");

                                    function n() {
                                        e.next && e.next(p())
                                    }
                                    return n(), {
                                        unsubscribe: t(n)
                                    }
                                }
                            })[s.a] = function () {
                                return this
                            }, e
                        }
                        return m({
                            type: c.INIT
                        }), (i = {
                            dispatch: m,
                            subscribe: g,
                            getState: p,
                            replaceReducer: v
                        })[s.a] = b, i
                    }

                    function h(e, t) {
                        var n = t && t.type;
                        return "Given " + (n && 'action "' + String(n) + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.'
                    }
                    var f, p = [],
                        g = [],
                        m = [],
                        v = {
                            loading: !1
                        },
                        b = function (e, t) {
                            return void 0 === e && (e = v), "SET_IS_LOADING" === t.type ? {
                                loading: t.isLoading
                            } : e
                        },
                        y = function (e) {
                            return Array.from({
                                length: e
                            }, (function () {
                                return (e = 0, t = 36, Math.floor(Math.random() * (t - e) + e)).toString(36);
                                var e, t
                            })).join("")
                        },
                        _ = function (e) {
                            return Object.prototype.toString.call(e).slice(8, -1)
                        },
                        x = function (e, t) {
                            return null != t && _(t) === e
                        },
                        w = function (e) {
                            return "string" != typeof e ? e : e.replace(/&/g, "&amp;").replace(/>/g, "&rt;").replace(/</g, "&lt;").replace(/"/g, "&quot;")
                        },
                        E = (f = document.createElement("div"), function (e) {
                            var t = e.trim();
                            f.innerHTML = t;
                            for (var n = f.children[0]; f.firstChild;) f.removeChild(f.firstChild);
                            return n
                        }),
                        k = function (e, t) {
                            return e.score - t.score
                        },
                        O = function (e) {
                            return JSON.parse(JSON.stringify(e))
                        },
                        S = function (e) {
                            for (var t = Object.keys(e), n = {}, i = 0; i < t.length; i++) {
                                var r = t[i];
                                "function" == typeof e[r] && (n[r] = e[r])
                            }
                            var o, a = Object.keys(n);
                            try {
                                ! function (e) {
                                    Object.keys(e).forEach((function (t) {
                                        var n = e[t];
                                        if (void 0 === n(void 0, {
                                                type: c.INIT
                                            })) throw new Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
                                        if (void 0 === n(void 0, {
                                                type: c.PROBE_UNKNOWN_ACTION()
                                            })) throw new Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + c.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.')
                                    }))
                                }(n)
                            } catch (e) {
                                o = e
                            }
                            return function (e, t) {
                                if (void 0 === e && (e = {}), o) throw o;
                                for (var i = !1, r = {}, s = 0; s < a.length; s++) {
                                    var l = a[s],
                                        c = n[l],
                                        u = e[l],
                                        d = c(u, t);
                                    if (void 0 === d) {
                                        var f = h(l, t);
                                        throw new Error(f)
                                    }
                                    r[l] = d, i = i || d !== u
                                }
                                return i ? r : e
                            }
                        }({
                            items: function (e, t) {
                                switch (void 0 === e && (e = p), t.type) {
                                    case "ADD_ITEM":
                                        return [].concat(e, [{
                                            id: t.id,
                                            choiceId: t.choiceId,
                                            groupId: t.groupId,
                                            value: t.value,
                                            label: t.label,
                                            active: !0,
                                            highlighted: !1,
                                            customProperties: t.customProperties,
                                            placeholder: t.placeholder || !1,
                                            keyCode: null
                                        }]).map((function (e) {
                                            var t = e;
                                            return t.highlighted = !1, t
                                        }));
                                    case "REMOVE_ITEM":
                                        return e.map((function (e) {
                                            var n = e;
                                            return n.id === t.id && (n.active = !1), n
                                        }));
                                    case "HIGHLIGHT_ITEM":
                                        return e.map((function (e) {
                                            var n = e;
                                            return n.id === t.id && (n.highlighted = t.highlighted), n
                                        }));
                                    default:
                                        return e
                                }
                            },
                            groups: function (e, t) {
                                switch (void 0 === e && (e = g), t.type) {
                                    case "ADD_GROUP":
                                        return [].concat(e, [{
                                            id: t.id,
                                            value: t.value,
                                            active: t.active,
                                            disabled: t.disabled
                                        }]);
                                    case "CLEAR_CHOICES":
                                        return [];
                                    default:
                                        return e
                                }
                            },
                            choices: function (e, t) {
                                switch (void 0 === e && (e = m), t.type) {
                                    case "ADD_CHOICE":
                                        return [].concat(e, [{
                                            id: t.id,
                                            elementId: t.elementId,
                                            groupId: t.groupId,
                                            value: t.value,
                                            label: t.label || t.value,
                                            disabled: t.disabled || !1,
                                            selected: !1,
                                            active: !0,
                                            score: 9999,
                                            customProperties: t.customProperties,
                                            placeholder: t.placeholder || !1,
                                            keyCode: null
                                        }]);
                                    case "ADD_ITEM":
                                        return t.activateOptions ? e.map((function (e) {
                                            var n = e;
                                            return n.active = t.active, n
                                        })) : t.choiceId > -1 ? e.map((function (e) {
                                            var n = e;
                                            return n.id === parseInt(t.choiceId, 10) && (n.selected = !0), n
                                        })) : e;
                                    case "REMOVE_ITEM":
                                        return t.choiceId > -1 ? e.map((function (e) {
                                            var n = e;
                                            return n.id === parseInt(t.choiceId, 10) && (n.selected = !1), n
                                        })) : e;
                                    case "FILTER_CHOICES":
                                        return e.map((function (e) {
                                            var n = e;
                                            return n.active = t.results.some((function (e) {
                                                var t = e.item,
                                                    i = e.score;
                                                return t.id === n.id && (n.score = i, !0)
                                            })), n
                                        }));
                                    case "ACTIVATE_CHOICES":
                                        return e.map((function (e) {
                                            var n = e;
                                            return n.active = t.active, n
                                        }));
                                    case "CLEAR_CHOICES":
                                        return m;
                                    default:
                                        return e
                                }
                            },
                            general: b
                        }),
                        C = function (e, t) {
                            var n = e;
                            if ("CLEAR_ALL" === t.type) n = void 0;
                            else if ("RESET_TO" === t.type) return O(t.state);
                            return S(n, t)
                        };

                    function A(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var M = function () {
                        function e() {
                            this._store = d(C, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
                        }
                        var t, n, i, r = e.prototype;
                        return r.subscribe = function (e) {
                            this._store.subscribe(e)
                        }, r.dispatch = function (e) {
                            this._store.dispatch(e)
                        }, r.isLoading = function () {
                            return this.state.general.loading
                        }, r.getChoiceById = function (e) {
                            return this.activeChoices.find((function (t) {
                                return t.id === parseInt(e, 10)
                            }))
                        }, r.getGroupById = function (e) {
                            return this.groups.find((function (t) {
                                return t.id === e
                            }))
                        }, t = e, n = [{
                            key: "state",
                            get: function () {
                                return this._store.getState()
                            }
                        }, {
                            key: "items",
                            get: function () {
                                return this.state.items
                            }
                        }, {
                            key: "activeItems",
                            get: function () {
                                return this.items.filter((function (e) {
                                    return !0 === e.active
                                }))
                            }
                        }, {
                            key: "highlightedActiveItems",
                            get: function () {
                                return this.items.filter((function (e) {
                                    return e.active && e.highlighted
                                }))
                            }
                        }, {
                            key: "choices",
                            get: function () {
                                return this.state.choices
                            }
                        }, {
                            key: "activeChoices",
                            get: function () {
                                return this.choices.filter((function (e) {
                                    return !0 === e.active
                                }))
                            }
                        }, {
                            key: "selectableChoices",
                            get: function () {
                                return this.choices.filter((function (e) {
                                    return !0 !== e.disabled
                                }))
                            }
                        }, {
                            key: "searchableChoices",
                            get: function () {
                                return this.selectableChoices.filter((function (e) {
                                    return !0 !== e.placeholder
                                }))
                            }
                        }, {
                            key: "placeholderChoice",
                            get: function () {
                                return [].concat(this.choices).reverse().find((function (e) {
                                    return !0 === e.placeholder
                                }))
                            }
                        }, {
                            key: "groups",
                            get: function () {
                                return this.state.groups
                            }
                        }, {
                            key: "activeGroups",
                            get: function () {
                                var e = this.groups,
                                    t = this.choices;
                                return e.filter((function (e) {
                                    var n = !0 === e.active && !1 === e.disabled,
                                        i = t.some((function (e) {
                                            return !0 === e.active && !1 === e.disabled
                                        }));
                                    return n && i
                                }), [])
                            }
                        }], n && A(t.prototype, n), i && A(t, i), e
                    }();

                    function T(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var P = function () {
                            function e(e) {
                                var t = e.element,
                                    n = e.type,
                                    i = e.classNames;
                                this.element = t, this.classNames = i, this.type = n, this.isActive = !1
                            }
                            var t, n, i, r = e.prototype;
                            return r.getChild = function (e) {
                                return this.element.querySelector(e)
                            }, r.show = function () {
                                return this.element.classList.add(this.classNames.activeState), this.element.setAttribute("aria-expanded", "true"), this.isActive = !0, this
                            }, r.hide = function () {
                                return this.element.classList.remove(this.classNames.activeState), this.element.setAttribute("aria-expanded", "false"), this.isActive = !1, this
                            }, t = e, (n = [{
                                key: "distanceFromTopWindow",
                                get: function () {
                                    return this.element.getBoundingClientRect().bottom
                                }
                            }]) && T(t.prototype, n), i && T(t, i), e
                        }(),
                        D = {
                            items: [],
                            choices: [],
                            silent: !1,
                            renderChoiceLimit: -1,
                            maxItemCount: -1,
                            addItems: !0,
                            addItemFilter: null,
                            removeItems: !0,
                            removeItemButton: !1,
                            editItems: !1,
                            duplicateItemsAllowed: !0,
                            delimiter: ",",
                            paste: !0,
                            searchEnabled: !0,
                            searchChoices: !0,
                            searchFloor: 1,
                            searchResultLimit: 4,
                            searchFields: ["label", "value"],
                            position: "auto",
                            resetScrollPosition: !0,
                            shouldSort: !0,
                            shouldSortItems: !1,
                            sorter: function (e, t) {
                                var n = e.value,
                                    i = e.label,
                                    r = void 0 === i ? n : i,
                                    o = t.value,
                                    a = t.label,
                                    s = void 0 === a ? o : a;
                                return r.localeCompare(s, [], {
                                    sensitivity: "base",
                                    ignorePunctuation: !0,
                                    numeric: !0
                                })
                            },
                            placeholder: !0,
                            placeholderValue: null,
                            searchPlaceholderValue: null,
                            prependValue: null,
                            appendValue: null,
                            renderSelectedChoices: "auto",
                            loadingText: "Loading...",
                            noResultsText: "No results found",
                            noChoicesText: "No choices to choose from",
                            itemSelectText: "Press to select",
                            uniqueItemText: "Only unique values can be added",
                            customAddItemText: "Only values matching specific conditions can be added",
                            addItemText: function (e) {
                                return 'Press Enter to add <b>"' + w(e) + '"</b>'
                            },
                            maxItemText: function (e) {
                                return "Only " + e + " values can be added"
                            },
                            valueComparer: function (e, t) {
                                return e === t
                            },
                            fuseOptions: {
                                includeScore: !0
                            },
                            callbackOnInit: null,
                            callbackOnCreateTemplates: null,
                            classNames: {
                                containerOuter: "choices",
                                containerInner: "choices__inner",
                                input: "choices__input",
                                inputCloned: "choices__input--cloned",
                                list: "choices__list",
                                listItems: "choices__list--multiple",
                                listSingle: "choices__list--single",
                                listDropdown: "choices__list--dropdown",
                                item: "choices__item",
                                itemSelectable: "choices__item--selectable",
                                itemDisabled: "choices__item--disabled",
                                itemChoice: "choices__item--choice",
                                placeholder: "choices__placeholder",
                                group: "choices__group",
                                groupHeading: "choices__heading",
                                button: "choices__button",
                                activeState: "is-active",
                                focusState: "is-focused",
                                openState: "is-open",
                                disabledState: "is-disabled",
                                highlightedState: "is-highlighted",
                                selectedState: "is-selected",
                                flippedState: "is-flipped",
                                loadingState: "is-loading",
                                noResults: "has-no-results",
                                noChoices: "has-no-choices"
                            }
                        },
                        L = "showDropdown",
                        N = "hideDropdown",
                        j = "change",
                        I = "choice",
                        R = "search",
                        F = "addItem",
                        B = "removeItem",
                        q = "highlightItem",
                        z = "highlightChoice",
                        H = "ADD_CHOICE",
                        U = "FILTER_CHOICES",
                        V = "ACTIVATE_CHOICES",
                        W = "CLEAR_CHOICES",
                        Y = "ADD_GROUP",
                        $ = "ADD_ITEM",
                        K = "REMOVE_ITEM",
                        G = "HIGHLIGHT_ITEM",
                        X = 46,
                        Z = 8,
                        Q = 13,
                        J = 65,
                        ee = 27,
                        te = 38,
                        ne = 40,
                        ie = 33,
                        re = 34,
                        oe = "text",
                        ae = "select-one",
                        se = "select-multiple",
                        le = function () {
                            function e(e) {
                                var t = e.element,
                                    n = e.type,
                                    i = e.classNames,
                                    r = e.position;
                                this.element = t, this.classNames = i, this.type = n, this.position = r, this.isOpen = !1, this.isFlipped = !1, this.isFocussed = !1, this.isDisabled = !1, this.isLoading = !1, this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this)
                            }
                            var t = e.prototype;
                            return t.addEventListeners = function () {
                                this.element.addEventListener("focus", this._onFocus), this.element.addEventListener("blur", this._onBlur)
                            }, t.removeEventListeners = function () {
                                this.element.removeEventListener("focus", this._onFocus), this.element.removeEventListener("blur", this._onBlur)
                            }, t.shouldFlip = function (e) {
                                if ("number" != typeof e) return !1;
                                var t = !1;
                                return "auto" === this.position ? t = !window.matchMedia("(min-height: " + (e + 1) + "px)").matches : "top" === this.position && (t = !0), t
                            }, t.setActiveDescendant = function (e) {
                                this.element.setAttribute("aria-activedescendant", e)
                            }, t.removeActiveDescendant = function () {
                                this.element.removeAttribute("aria-activedescendant")
                            }, t.open = function (e) {
                                this.element.classList.add(this.classNames.openState), this.element.setAttribute("aria-expanded", "true"), this.isOpen = !0, this.shouldFlip(e) && (this.element.classList.add(this.classNames.flippedState), this.isFlipped = !0)
                            }, t.close = function () {
                                this.element.classList.remove(this.classNames.openState), this.element.setAttribute("aria-expanded", "false"), this.removeActiveDescendant(), this.isOpen = !1, this.isFlipped && (this.element.classList.remove(this.classNames.flippedState), this.isFlipped = !1)
                            }, t.focus = function () {
                                this.isFocussed || this.element.focus()
                            }, t.addFocusState = function () {
                                this.element.classList.add(this.classNames.focusState)
                            }, t.removeFocusState = function () {
                                this.element.classList.remove(this.classNames.focusState)
                            }, t.enable = function () {
                                this.element.classList.remove(this.classNames.disabledState), this.element.removeAttribute("aria-disabled"), this.type === ae && this.element.setAttribute("tabindex", "0"), this.isDisabled = !1
                            }, t.disable = function () {
                                this.element.classList.add(this.classNames.disabledState), this.element.setAttribute("aria-disabled", "true"), this.type === ae && this.element.setAttribute("tabindex", "-1"), this.isDisabled = !0
                            }, t.wrap = function (e) {
                                ! function (e, t) {
                                    void 0 === t && (t = document.createElement("div")), e.nextSibling ? e.parentNode.insertBefore(t, e.nextSibling) : e.parentNode.appendChild(t), t.appendChild(e)
                                }(e, this.element)
                            }, t.unwrap = function (e) {
                                this.element.parentNode.insertBefore(e, this.element), this.element.parentNode.removeChild(this.element)
                            }, t.addLoadingState = function () {
                                this.element.classList.add(this.classNames.loadingState), this.element.setAttribute("aria-busy", "true"), this.isLoading = !0
                            }, t.removeLoadingState = function () {
                                this.element.classList.remove(this.classNames.loadingState), this.element.removeAttribute("aria-busy"), this.isLoading = !1
                            }, t._onFocus = function () {
                                this.isFocussed = !0
                            }, t._onBlur = function () {
                                this.isFocussed = !1
                            }, e
                        }();

                    function ce(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var ue = function () {
                            function e(e) {
                                var t = e.element,
                                    n = e.type,
                                    i = e.classNames,
                                    r = e.preventPaste;
                                this.element = t, this.type = n, this.classNames = i, this.preventPaste = r, this.isFocussed = this.element === document.activeElement, this.isDisabled = t.disabled, this._onPaste = this._onPaste.bind(this), this._onInput = this._onInput.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this)
                            }
                            var t, n, i, r = e.prototype;
                            return r.addEventListeners = function () {
                                this.element.addEventListener("paste", this._onPaste), this.element.addEventListener("input", this._onInput, {
                                    passive: !0
                                }), this.element.addEventListener("focus", this._onFocus, {
                                    passive: !0
                                }), this.element.addEventListener("blur", this._onBlur, {
                                    passive: !0
                                })
                            }, r.removeEventListeners = function () {
                                this.element.removeEventListener("input", this._onInput, {
                                    passive: !0
                                }), this.element.removeEventListener("paste", this._onPaste), this.element.removeEventListener("focus", this._onFocus, {
                                    passive: !0
                                }), this.element.removeEventListener("blur", this._onBlur, {
                                    passive: !0
                                })
                            }, r.enable = function () {
                                this.element.removeAttribute("disabled"), this.isDisabled = !1
                            }, r.disable = function () {
                                this.element.setAttribute("disabled", ""), this.isDisabled = !0
                            }, r.focus = function () {
                                this.isFocussed || this.element.focus()
                            }, r.blur = function () {
                                this.isFocussed && this.element.blur()
                            }, r.clear = function (e) {
                                return void 0 === e && (e = !0), this.element.value && (this.element.value = ""), e && this.setWidth(), this
                            }, r.setWidth = function () {
                                var e = this.element,
                                    t = e.style,
                                    n = e.value,
                                    i = e.placeholder;
                                t.minWidth = i.length + 1 + "ch", t.width = n.length + 1 + "ch"
                            }, r.setActiveDescendant = function (e) {
                                this.element.setAttribute("aria-activedescendant", e)
                            }, r.removeActiveDescendant = function () {
                                this.element.removeAttribute("aria-activedescendant")
                            }, r._onInput = function () {
                                this.type !== ae && this.setWidth()
                            }, r._onPaste = function (e) {
                                this.preventPaste && e.preventDefault()
                            }, r._onFocus = function () {
                                this.isFocussed = !0
                            }, r._onBlur = function () {
                                this.isFocussed = !1
                            }, t = e, (n = [{
                                key: "placeholder",
                                set: function (e) {
                                    this.element.placeholder = e
                                }
                            }, {
                                key: "value",
                                get: function () {
                                    return w(this.element.value)
                                },
                                set: function (e) {
                                    this.element.value = e
                                }
                            }]) && ce(t.prototype, n), i && ce(t, i), e
                        }(),
                        de = function () {
                            function e(e) {
                                var t = e.element;
                                this.element = t, this.scrollPos = this.element.scrollTop, this.height = this.element.offsetHeight
                            }
                            var t = e.prototype;
                            return t.clear = function () {
                                this.element.innerHTML = ""
                            }, t.append = function (e) {
                                this.element.appendChild(e)
                            }, t.getChild = function (e) {
                                return this.element.querySelector(e)
                            }, t.hasChildren = function () {
                                return this.element.hasChildNodes()
                            }, t.scrollToTop = function () {
                                this.element.scrollTop = 0
                            }, t.scrollToChildElement = function (e, t) {
                                var n = this;
                                if (e) {
                                    var i = this.element.offsetHeight,
                                        r = this.element.scrollTop + i,
                                        o = e.offsetHeight,
                                        a = e.offsetTop + o,
                                        s = t > 0 ? this.element.scrollTop + a - r : e.offsetTop;
                                    requestAnimationFrame((function () {
                                        n._animateScroll(s, t)
                                    }))
                                }
                            }, t._scrollDown = function (e, t, n) {
                                var i = (n - e) / t,
                                    r = i > 1 ? i : 1;
                                this.element.scrollTop = e + r
                            }, t._scrollUp = function (e, t, n) {
                                var i = (e - n) / t,
                                    r = i > 1 ? i : 1;
                                this.element.scrollTop = e - r
                            }, t._animateScroll = function (e, t) {
                                var n = this,
                                    i = this.element.scrollTop,
                                    r = !1;
                                t > 0 ? (this._scrollDown(i, 4, e), i < e && (r = !0)) : (this._scrollUp(i, 4, e), i > e && (r = !0)), r && requestAnimationFrame((function () {
                                    n._animateScroll(e, t)
                                }))
                            }, e
                        }();

                    function he(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var fe = function () {
                        function e(e) {
                            var t = e.element,
                                n = e.classNames;
                            if (this.element = t, this.classNames = n, !(t instanceof HTMLInputElement || t instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                            this.isDisabled = !1
                        }
                        var t, n, i, r = e.prototype;
                        return r.conceal = function () {
                            this.element.classList.add(this.classNames.input), this.element.hidden = !0, this.element.tabIndex = -1;
                            var e = this.element.getAttribute("style");
                            e && this.element.setAttribute("data-choice-orig-style", e), this.element.setAttribute("data-choice", "active")
                        }, r.reveal = function () {
                            this.element.classList.remove(this.classNames.input), this.element.hidden = !1, this.element.removeAttribute("tabindex");
                            var e = this.element.getAttribute("data-choice-orig-style");
                            e ? (this.element.removeAttribute("data-choice-orig-style"), this.element.setAttribute("style", e)) : this.element.removeAttribute("style"), this.element.removeAttribute("data-choice"), this.element.value = this.element.value
                        }, r.enable = function () {
                            this.element.removeAttribute("disabled"), this.element.disabled = !1, this.isDisabled = !1
                        }, r.disable = function () {
                            this.element.setAttribute("disabled", ""), this.element.disabled = !0, this.isDisabled = !0
                        }, r.triggerEvent = function (e, t) {
                            ! function (e, t, n) {
                                void 0 === n && (n = null);
                                var i = new CustomEvent(t, {
                                    detail: n,
                                    bubbles: !0,
                                    cancelable: !0
                                });
                                e.dispatchEvent(i)
                            }(this.element, e, t)
                        }, t = e, (n = [{
                            key: "isActive",
                            get: function () {
                                return "active" === this.element.dataset.choice
                            }
                        }, {
                            key: "dir",
                            get: function () {
                                return this.element.dir
                            }
                        }, {
                            key: "value",
                            get: function () {
                                return this.element.value
                            },
                            set: function (e) {
                                this.element.value = e
                            }
                        }]) && he(t.prototype, n), i && he(t, i), e
                    }();

                    function pe(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var ge = function (e) {
                        var t, n, i, r, o;

                        function a(t) {
                            var n, i = t.element,
                                r = t.classNames,
                                o = t.delimiter;
                            return (n = e.call(this, {
                                element: i,
                                classNames: r
                            }) || this).delimiter = o, n
                        }
                        return n = e, (t = a).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, i = a, (r = [{
                            key: "value",
                            get: function () {
                                return this.element.value
                            },
                            set: function (e) {
                                var t = e.map((function (e) {
                                    return e.value
                                })).join(this.delimiter);
                                this.element.setAttribute("value", t), this.element.value = t
                            }
                        }]) && pe(i.prototype, r), o && pe(i, o), a
                    }(fe);

                    function me(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var ve = function (e) {
                            var t, n, i, r, o;

                            function a(t) {
                                var n, i = t.element,
                                    r = t.classNames,
                                    o = t.template;
                                return (n = e.call(this, {
                                    element: i,
                                    classNames: r
                                }) || this).template = o, n
                            }
                            return n = e, (t = a).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n, a.prototype.appendDocFragment = function (e) {
                                this.element.innerHTML = "", this.element.appendChild(e)
                            }, i = a, (r = [{
                                key: "placeholderOption",
                                get: function () {
                                    return this.element.querySelector('option[value=""]') || this.element.querySelector("option[placeholder]")
                                }
                            }, {
                                key: "optionGroups",
                                get: function () {
                                    return Array.from(this.element.getElementsByTagName("OPTGROUP"))
                                }
                            }, {
                                key: "options",
                                get: function () {
                                    return Array.from(this.element.options)
                                },
                                set: function (e) {
                                    var t = this,
                                        n = document.createDocumentFragment();
                                    e.forEach((function (e) {
                                        return i = e, r = t.template(i), void n.appendChild(r);
                                        var i, r
                                    })), this.appendDocFragment(n)
                                }
                            }]) && me(i.prototype, r), o && me(i, o), a
                        }(fe),
                        be = {
                            containerOuter: function (e, t, n, i, r, o) {
                                var a = e.containerOuter,
                                    s = Object.assign(document.createElement("div"), {
                                        className: a
                                    });
                                return s.dataset.type = o, t && (s.dir = t), i && (s.tabIndex = 0), n && (s.setAttribute("role", r ? "combobox" : "listbox"), r && s.setAttribute("aria-autocomplete", "list")), s.setAttribute("aria-haspopup", "true"), s.setAttribute("aria-expanded", "false"), s
                            },
                            containerInner: function (e) {
                                var t = e.containerInner;
                                return Object.assign(document.createElement("div"), {
                                    className: t
                                })
                            },
                            itemList: function (e, t) {
                                var n = e.list,
                                    i = e.listSingle,
                                    r = e.listItems;
                                return Object.assign(document.createElement("div"), {
                                    className: n + " " + (t ? i : r)
                                })
                            },
                            placeholder: function (e, t) {
                                var n = e.placeholder;
                                return Object.assign(document.createElement("div"), {
                                    className: n,
                                    innerHTML: t
                                })
                            },
                            item: function (e, t, n) {
                                var i = e.item,
                                    r = e.button,
                                    o = e.highlightedState,
                                    a = e.itemSelectable,
                                    s = e.placeholder,
                                    l = t.id,
                                    c = t.value,
                                    u = t.label,
                                    d = t.customProperties,
                                    h = t.active,
                                    f = t.disabled,
                                    p = t.highlighted,
                                    g = t.placeholder,
                                    m = Object.assign(document.createElement("div"), {
                                        className: i,
                                        innerHTML: u
                                    });
                                if (Object.assign(m.dataset, {
                                        item: "",
                                        id: l,
                                        value: c,
                                        customProperties: d
                                    }), h && m.setAttribute("aria-selected", "true"), f && m.setAttribute("aria-disabled", "true"), g && m.classList.add(s), m.classList.add(p ? o : a), n) {
                                    f && m.classList.remove(a), m.dataset.deletable = "";
                                    var v = "Remove item",
                                        b = Object.assign(document.createElement("button"), {
                                            type: "button",
                                            className: r,
                                            innerHTML: v
                                        });
                                    b.setAttribute("aria-label", "Remove item: '" + c + "'"), b.dataset.button = "", m.appendChild(b)
                                }
                                return m
                            },
                            choiceList: function (e, t) {
                                var n = e.list,
                                    i = Object.assign(document.createElement("div"), {
                                        className: n
                                    });
                                return t || i.setAttribute("aria-multiselectable", "true"), i.setAttribute("role", "listbox"), i
                            },
                            choiceGroup: function (e, t) {
                                var n = e.group,
                                    i = e.groupHeading,
                                    r = e.itemDisabled,
                                    o = t.id,
                                    a = t.value,
                                    s = t.disabled,
                                    l = Object.assign(document.createElement("div"), {
                                        className: n + " " + (s ? r : "")
                                    });
                                return l.setAttribute("role", "group"), Object.assign(l.dataset, {
                                    group: "",
                                    id: o,
                                    value: a
                                }), s && l.setAttribute("aria-disabled", "true"), l.appendChild(Object.assign(document.createElement("div"), {
                                    className: i,
                                    innerHTML: a
                                })), l
                            },
                            choice: function (e, t, n) {
                                var i = e.item,
                                    r = e.itemChoice,
                                    o = e.itemSelectable,
                                    a = e.selectedState,
                                    s = e.itemDisabled,
                                    l = e.placeholder,
                                    c = t.id,
                                    u = t.value,
                                    d = t.label,
                                    h = t.groupId,
                                    f = t.elementId,
                                    p = t.disabled,
                                    g = t.selected,
                                    m = t.placeholder,
                                    v = Object.assign(document.createElement("div"), {
                                        id: f,
                                        innerHTML: d,
                                        className: i + " " + r
                                    });
                                return g && v.classList.add(a), m && v.classList.add(l), v.setAttribute("role", h > 0 ? "treeitem" : "option"), Object.assign(v.dataset, {
                                    choice: "",
                                    id: c,
                                    value: u,
                                    selectText: n
                                }), p ? (v.classList.add(s), v.dataset.choiceDisabled = "", v.setAttribute("aria-disabled", "true")) : (v.classList.add(o), v.dataset.choiceSelectable = ""), v
                            },
                            input: function (e, t) {
                                var n = e.input,
                                    i = e.inputCloned,
                                    r = Object.assign(document.createElement("input"), {
                                        type: "text",
                                        className: n + " " + i,
                                        autocomplete: "off",
                                        autocapitalize: "off",
                                        spellcheck: !1
                                    });
                                return r.setAttribute("role", "textbox"), r.setAttribute("aria-autocomplete", "list"), r.setAttribute("aria-label", t), r
                            },
                            dropdown: function (e) {
                                var t = e.list,
                                    n = e.listDropdown,
                                    i = document.createElement("div");
                                return i.classList.add(t, n), i.setAttribute("aria-expanded", "false"), i
                            },
                            notice: function (e, t, n) {
                                var i = e.item,
                                    r = e.itemChoice,
                                    o = e.noResults,
                                    a = e.noChoices;
                                void 0 === n && (n = "");
                                var s = [i, r];
                                return "no-choices" === n ? s.push(a) : "no-results" === n && s.push(o), Object.assign(document.createElement("div"), {
                                    innerHTML: t,
                                    className: s.join(" ")
                                })
                            },
                            option: function (e) {
                                var t = e.label,
                                    n = e.value,
                                    i = e.customProperties,
                                    r = e.active,
                                    o = e.disabled,
                                    a = new Option(t, n, !1, r);
                                return i && (a.dataset.customProperties = i), a.disabled = o, a
                            }
                        },
                        ye = function (e) {
                            return void 0 === e && (e = !0), {
                                type: V,
                                active: e
                            }
                        },
                        _e = function (e, t) {
                            return {
                                type: G,
                                id: e,
                                highlighted: t
                            }
                        },
                        xe = function (e) {
                            var t = e.value,
                                n = e.id,
                                i = e.active,
                                r = e.disabled;
                            return {
                                type: Y,
                                value: t,
                                id: n,
                                active: i,
                                disabled: r
                            }
                        },
                        we = function (e) {
                            return {
                                type: "SET_IS_LOADING",
                                isLoading: e
                            }
                        };

                    function Ee(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }
                    var ke = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style,
                        Oe = {},
                        Se = function () {
                            var e, t, n;

                            function i(e, t) {
                                var n = this;
                                void 0 === e && (e = "[data-choice]"), void 0 === t && (t = {}), this.config = a.a.all([D, i.defaults.options, t], {
                                    arrayMerge: function (e, t) {
                                        return [].concat(t)
                                    }
                                });
                                var r, o, s, l, c = (r = this.config, o = D, s = Object.keys(r).sort(), l = Object.keys(o).sort(), s.filter((function (e) {
                                    return l.indexOf(e) < 0
                                })));
                                c.length && console.warn("Unknown config option(s) passed", c.join(", "));
                                var u = "string" == typeof e ? document.querySelector(e) : e;
                                if (!(u instanceof HTMLInputElement || u instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                                if (this._isTextElement = u.type === oe, this._isSelectOneElement = u.type === ae, this._isSelectMultipleElement = u.type === se, this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement, this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled, ["auto", "always"].includes(this.config.renderSelectedChoices) || (this.config.renderSelectedChoices = "auto"), t.addItemFilter && "function" != typeof t.addItemFilter) {
                                    var d = t.addItemFilter instanceof RegExp ? t.addItemFilter : new RegExp(t.addItemFilter);
                                    this.config.addItemFilter = d.test.bind(d)
                                }
                                if (this._isTextElement ? this.passedElement = new ge({
                                        element: u,
                                        classNames: this.config.classNames,
                                        delimiter: this.config.delimiter
                                    }) : this.passedElement = new ve({
                                        element: u,
                                        classNames: this.config.classNames,
                                        template: function (e) {
                                            return n._templates.option(e)
                                        }
                                    }), this.initialised = !1, this._store = new M, this._initialState = {}, this._currentState = {}, this._prevState = {}, this._currentValue = "", this._canSearch = this.config.searchEnabled, this._isScrollingOnIe = !1, this._highlightPosition = 0, this._wasTap = !0, this._placeholderValue = this._generatePlaceholderValue(), this._baseId = function (e, t) {
                                        var n = e.id || e.name && e.name + "-" + y(2) || y(4);
                                        return t + "-" + n.replace(/(:|\.|\[|\]|,)/g, "")
                                    }(this.passedElement.element, "choices-"), this._direction = this.passedElement.dir, !this._direction) {
                                    var h = window.getComputedStyle(this.passedElement.element).direction;
                                    h !== window.getComputedStyle(document.documentElement).direction && (this._direction = h)
                                }
                                if (this._idNames = {
                                        itemChoice: "item-choice"
                                    }, this._presetGroups = this.passedElement.optionGroups, this._presetOptions = this.passedElement.options, this._presetChoices = this.config.choices, this._presetItems = this.config.items, this.passedElement.value && (this._presetItems = this._presetItems.concat(this.passedElement.value.split(this.config.delimiter))), this.passedElement.options && this.passedElement.options.forEach((function (e) {
                                        n._presetChoices.push({
                                            value: e.value,
                                            label: e.innerHTML,
                                            selected: e.selected,
                                            disabled: e.disabled || e.parentNode.disabled,
                                            placeholder: "" === e.value || e.hasAttribute("placeholder"),
                                            customProperties: e.getAttribute("data-custom-properties")
                                        })
                                    })), this._render = this._render.bind(this), this._onFocus = this._onFocus.bind(this), this._onBlur = this._onBlur.bind(this), this._onKeyUp = this._onKeyUp.bind(this), this._onKeyDown = this._onKeyDown.bind(this), this._onClick = this._onClick.bind(this), this._onTouchMove = this._onTouchMove.bind(this), this._onTouchEnd = this._onTouchEnd.bind(this), this._onMouseDown = this._onMouseDown.bind(this), this._onMouseOver = this._onMouseOver.bind(this), this._onFormReset = this._onFormReset.bind(this), this._onAKey = this._onAKey.bind(this), this._onEnterKey = this._onEnterKey.bind(this), this._onEscapeKey = this._onEscapeKey.bind(this), this._onDirectionKey = this._onDirectionKey.bind(this), this._onDeleteKey = this._onDeleteKey.bind(this), this.passedElement.isActive) return this.config.silent || console.warn("Trying to initialise Choices on element already initialised"), void(this.initialised = !0);
                                this.init()
                            }
                            e = i, n = [{
                                key: "defaults",
                                get: function () {
                                    return Object.preventExtensions({
                                        get options() {
                                            return Oe
                                        },
                                        get templates() {
                                            return be
                                        }
                                    })
                                }
                            }], (t = null) && Ee(e.prototype, t), n && Ee(e, n);
                            var o = i.prototype;
                            return o.init = function () {
                                if (!this.initialised) {
                                    this._createTemplates(), this._createElements(), this._createStructure(), this._initialState = O(this._store.state), this._store.subscribe(this._render), this._render(), this._addEventListeners(), (!this.config.addItems || this.passedElement.element.hasAttribute("disabled")) && this.disable(), this.initialised = !0;
                                    var e = this.config.callbackOnInit;
                                    e && "function" == typeof e && e.call(this)
                                }
                            }, o.destroy = function () {
                                this.initialised && (this._removeEventListeners(), this.passedElement.reveal(), this.containerOuter.unwrap(this.passedElement.element), this.clearStore(), this._isSelectElement && (this.passedElement.options = this._presetOptions), this._templates = null, this.initialised = !1)
                            }, o.enable = function () {
                                return this.passedElement.isDisabled && this.passedElement.enable(), this.containerOuter.isDisabled && (this._addEventListeners(), this.input.enable(), this.containerOuter.enable()), this
                            }, o.disable = function () {
                                return this.passedElement.isDisabled || this.passedElement.disable(), this.containerOuter.isDisabled || (this._removeEventListeners(), this.input.disable(), this.containerOuter.disable()), this
                            }, o.highlightItem = function (e, t) {
                                if (void 0 === t && (t = !0), !e) return this;
                                var n = e.id,
                                    i = e.groupId,
                                    r = void 0 === i ? -1 : i,
                                    o = e.value,
                                    a = void 0 === o ? "" : o,
                                    s = e.label,
                                    l = void 0 === s ? "" : s,
                                    c = r >= 0 ? this._store.getGroupById(r) : null;
                                return this._store.dispatch(_e(n, !0)), t && this.passedElement.triggerEvent(q, {
                                    id: n,
                                    value: a,
                                    label: l,
                                    groupValue: c && c.value ? c.value : null
                                }), this
                            }, o.unhighlightItem = function (e) {
                                if (!e) return this;
                                var t = e.id,
                                    n = e.groupId,
                                    i = void 0 === n ? -1 : n,
                                    r = e.value,
                                    o = void 0 === r ? "" : r,
                                    a = e.label,
                                    s = void 0 === a ? "" : a,
                                    l = i >= 0 ? this._store.getGroupById(i) : null;
                                return this._store.dispatch(_e(t, !1)), this.passedElement.triggerEvent(q, {
                                    id: t,
                                    value: o,
                                    label: s,
                                    groupValue: l && l.value ? l.value : null
                                }), this
                            }, o.highlightAll = function () {
                                var e = this;
                                return this._store.items.forEach((function (t) {
                                    return e.highlightItem(t)
                                })), this
                            }, o.unhighlightAll = function () {
                                var e = this;
                                return this._store.items.forEach((function (t) {
                                    return e.unhighlightItem(t)
                                })), this
                            }, o.removeActiveItemsByValue = function (e) {
                                var t = this;
                                return this._store.activeItems.filter((function (t) {
                                    return t.value === e
                                })).forEach((function (e) {
                                    return t._removeItem(e)
                                })), this
                            }, o.removeActiveItems = function (e) {
                                var t = this;
                                return this._store.activeItems.filter((function (t) {
                                    return t.id !== e
                                })).forEach((function (e) {
                                    return t._removeItem(e)
                                })), this
                            }, o.removeHighlightedItems = function (e) {
                                var t = this;
                                return void 0 === e && (e = !1), this._store.highlightedActiveItems.forEach((function (n) {
                                    t._removeItem(n), e && t._triggerChange(n.value)
                                })), this
                            }, o.showDropdown = function (e) {
                                var t = this;
                                return this.dropdown.isActive || requestAnimationFrame((function () {
                                    t.dropdown.show(), t.containerOuter.open(t.dropdown.distanceFromTopWindow), !e && t._canSearch && t.input.focus(), t.passedElement.triggerEvent(L, {})
                                })), this
                            }, o.hideDropdown = function (e) {
                                var t = this;
                                return this.dropdown.isActive ? (requestAnimationFrame((function () {
                                    t.dropdown.hide(), t.containerOuter.close(), !e && t._canSearch && (t.input.removeActiveDescendant(), t.input.blur()), t.passedElement.triggerEvent(N, {})
                                })), this) : this
                            }, o.getValue = function (e) {
                                void 0 === e && (e = !1);
                                var t = this._store.activeItems.reduce((function (t, n) {
                                    var i = e ? n.value : n;
                                    return t.push(i), t
                                }), []);
                                return this._isSelectOneElement ? t[0] : t
                            }, o.setValue = function (e) {
                                var t = this;
                                return this.initialised ? (e.forEach((function (e) {
                                    return t._setChoiceOrItem(e)
                                })), this) : this
                            }, o.setChoiceByValue = function (e) {
                                var t = this;
                                return !this.initialised || this._isTextElement || (Array.isArray(e) ? e : [e]).forEach((function (e) {
                                    return t._findAndSelectChoiceByValue(e)
                                })), this
                            }, o.setChoices = function (e, t, n, i) {
                                var r = this;
                                if (void 0 === e && (e = []), void 0 === t && (t = "value"), void 0 === n && (n = "label"), void 0 === i && (i = !1), !this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                                if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                                if ("string" != typeof t || !t) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                                if (i && this.clearChoices(), "function" == typeof e) {
                                    var o = e(this);
                                    if ("function" == typeof Promise && o instanceof Promise) return new Promise((function (e) {
                                        return requestAnimationFrame(e)
                                    })).then((function () {
                                        return r._handleLoadingState(!0)
                                    })).then((function () {
                                        return o
                                    })).then((function (e) {
                                        return r.setChoices(e, t, n, i)
                                    })).catch((function (e) {
                                        r.config.silent || console.error(e)
                                    })).then((function () {
                                        return r._handleLoadingState(!1)
                                    })).then((function () {
                                        return r
                                    }));
                                    if (!Array.isArray(o)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: " + typeof o);
                                    return this.setChoices(o, t, n, !1)
                                }
                                if (!Array.isArray(e)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                                return this.containerOuter.removeLoadingState(), this._startLoading(), e.forEach((function (e) {
                                    e.choices ? r._addGroup({
                                        id: parseInt(e.id, 10) || null,
                                        group: e,
                                        valueKey: t,
                                        labelKey: n
                                    }) : r._addChoice({
                                        value: e[t],
                                        label: e[n],
                                        isSelected: e.selected,
                                        isDisabled: e.disabled,
                                        customProperties: e.customProperties,
                                        placeholder: e.placeholder
                                    })
                                })), this._stopLoading(), this
                            }, o.clearChoices = function () {
                                return this._store.dispatch({
                                    type: W
                                }), this
                            }, o.clearStore = function () {
                                return this._store.dispatch({
                                    type: "CLEAR_ALL"
                                }), this
                            }, o.clearInput = function () {
                                var e = !this._isSelectOneElement;
                                return this.input.clear(e), !this._isTextElement && this._canSearch && (this._isSearching = !1, this._store.dispatch(ye(!0))), this
                            }, o._render = function () {
                                if (!this._store.isLoading()) {
                                    this._currentState = this._store.state;
                                    var e = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items,
                                        t = this._isSelectElement,
                                        n = this._currentState.items !== this._prevState.items;
                                    e && (t && this._renderChoices(), n && this._renderItems(), this._prevState = this._currentState)
                                }
                            }, o._renderChoices = function () {
                                var e = this,
                                    t = this._store,
                                    n = t.activeGroups,
                                    i = t.activeChoices,
                                    r = document.createDocumentFragment();
                                if (this.choiceList.clear(), this.config.resetScrollPosition && requestAnimationFrame((function () {
                                        return e.choiceList.scrollToTop()
                                    })), n.length >= 1 && !this._isSearching) {
                                    var o = i.filter((function (e) {
                                        return !0 === e.placeholder && -1 === e.groupId
                                    }));
                                    o.length >= 1 && (r = this._createChoicesFragment(o, r)), r = this._createGroupsFragment(n, i, r)
                                } else i.length >= 1 && (r = this._createChoicesFragment(i, r));
                                if (r.childNodes && r.childNodes.length > 0) {
                                    var a = this._store.activeItems,
                                        s = this._canAddItem(a, this.input.value);
                                    s.response ? (this.choiceList.append(r), this._highlightChoice()) : this.choiceList.append(this._getTemplate("notice", s.notice))
                                } else {
                                    var l, c;
                                    this._isSearching ? (c = "function" == typeof this.config.noResultsText ? this.config.noResultsText() : this.config.noResultsText, l = this._getTemplate("notice", c, "no-results")) : (c = "function" == typeof this.config.noChoicesText ? this.config.noChoicesText() : this.config.noChoicesText, l = this._getTemplate("notice", c, "no-choices")), this.choiceList.append(l)
                                }
                            }, o._renderItems = function () {
                                var e = this._store.activeItems || [];
                                this.itemList.clear();
                                var t = this._createItemsFragment(e);
                                t.childNodes && this.itemList.append(t)
                            }, o._createGroupsFragment = function (e, t, n) {
                                var i = this;
                                return void 0 === n && (n = document.createDocumentFragment()), this.config.shouldSort && e.sort(this.config.sorter), e.forEach((function (e) {
                                    var r = function (e) {
                                        return t.filter((function (t) {
                                            return i._isSelectOneElement ? t.groupId === e.id : t.groupId === e.id && ("always" === i.config.renderSelectedChoices || !t.selected)
                                        }))
                                    }(e);
                                    if (r.length >= 1) {
                                        var o = i._getTemplate("choiceGroup", e);
                                        n.appendChild(o), i._createChoicesFragment(r, n, !0)
                                    }
                                })), n
                            }, o._createChoicesFragment = function (e, t, n) {
                                var i = this;
                                void 0 === t && (t = document.createDocumentFragment()), void 0 === n && (n = !1);
                                var r = this.config,
                                    o = r.renderSelectedChoices,
                                    a = r.searchResultLimit,
                                    s = r.renderChoiceLimit,
                                    l = this._isSearching ? k : this.config.sorter,
                                    c = function (e) {
                                        if ("auto" !== o || i._isSelectOneElement || !e.selected) {
                                            var n = i._getTemplate("choice", e, i.config.itemSelectText);
                                            t.appendChild(n)
                                        }
                                    },
                                    u = e;
                                "auto" !== o || this._isSelectOneElement || (u = e.filter((function (e) {
                                    return !e.selected
                                })));
                                var d = u.reduce((function (e, t) {
                                        return t.placeholder ? e.placeholderChoices.push(t) : e.normalChoices.push(t), e
                                    }), {
                                        placeholderChoices: [],
                                        normalChoices: []
                                    }),
                                    h = d.placeholderChoices,
                                    f = d.normalChoices;
                                (this.config.shouldSort || this._isSearching) && f.sort(l);
                                var p = u.length,
                                    g = this._isSelectOneElement ? [].concat(h, f) : f;
                                this._isSearching ? p = a : s && s > 0 && !n && (p = s);
                                for (var m = 0; m < p; m += 1) g[m] && c(g[m]);
                                return t
                            }, o._createItemsFragment = function (e, t) {
                                var n = this;
                                void 0 === t && (t = document.createDocumentFragment());
                                var i = this.config,
                                    r = i.shouldSortItems,
                                    o = i.sorter,
                                    a = i.removeItemButton;
                                return r && !this._isSelectOneElement && e.sort(o), this._isTextElement ? this.passedElement.value = e : this.passedElement.options = e, e.forEach((function (e) {
                                    var i = n._getTemplate("item", e, a);
                                    t.appendChild(i)
                                })), t
                            }, o._triggerChange = function (e) {
                                null != e && this.passedElement.triggerEvent(j, {
                                    value: e
                                })
                            }, o._selectPlaceholderChoice = function () {
                                var e = this._store.placeholderChoice;
                                e && (this._addItem({
                                    value: e.value,
                                    label: e.label,
                                    choiceId: e.id,
                                    groupId: e.groupId,
                                    placeholder: e.placeholder
                                }), this._triggerChange(e.value))
                            }, o._handleButtonAction = function (e, t) {
                                if (e && t && this.config.removeItems && this.config.removeItemButton) {
                                    var n = t.parentNode.getAttribute("data-id"),
                                        i = e.find((function (e) {
                                            return e.id === parseInt(n, 10)
                                        }));
                                    this._removeItem(i), this._triggerChange(i.value), this._isSelectOneElement && this._selectPlaceholderChoice()
                                }
                            }, o._handleItemAction = function (e, t, n) {
                                var i = this;
                                if (void 0 === n && (n = !1), e && t && this.config.removeItems && !this._isSelectOneElement) {
                                    var r = t.getAttribute("data-id");
                                    e.forEach((function (e) {
                                        e.id !== parseInt(r, 10) || e.highlighted ? !n && e.highlighted && i.unhighlightItem(e) : i.highlightItem(e)
                                    })), this.input.focus()
                                }
                            }, o._handleChoiceAction = function (e, t) {
                                if (e && t) {
                                    var n = t.dataset.id,
                                        i = this._store.getChoiceById(n);
                                    if (i) {
                                        var r = e[0] && e[0].keyCode ? e[0].keyCode : null,
                                            o = this.dropdown.isActive;
                                        i.keyCode = r, this.passedElement.triggerEvent(I, {
                                            choice: i
                                        }), i.selected || i.disabled || this._canAddItem(e, i.value).response && (this._addItem({
                                            value: i.value,
                                            label: i.label,
                                            choiceId: i.id,
                                            groupId: i.groupId,
                                            customProperties: i.customProperties,
                                            placeholder: i.placeholder,
                                            keyCode: i.keyCode
                                        }), this._triggerChange(i.value)), this.clearInput(), o && this._isSelectOneElement && (this.hideDropdown(!0), this.containerOuter.focus())
                                    }
                                }
                            }, o._handleBackspace = function (e) {
                                if (this.config.removeItems && e) {
                                    var t = e[e.length - 1],
                                        n = e.some((function (e) {
                                            return e.highlighted
                                        }));
                                    this.config.editItems && !n && t ? (this.input.value = t.value, this.input.setWidth(), this._removeItem(t), this._triggerChange(t.value)) : (n || this.highlightItem(t, !1), this.removeHighlightedItems(!0))
                                }
                            }, o._startLoading = function () {
                                this._store.dispatch(we(!0))
                            }, o._stopLoading = function () {
                                this._store.dispatch(we(!1))
                            }, o._handleLoadingState = function (e) {
                                void 0 === e && (e = !0);
                                var t = this.itemList.getChild("." + this.config.classNames.placeholder);
                                e ? (this.disable(), this.containerOuter.addLoadingState(), this._isSelectOneElement ? t ? t.innerHTML = this.config.loadingText : (t = this._getTemplate("placeholder", this.config.loadingText), this.itemList.append(t)) : this.input.placeholder = this.config.loadingText) : (this.enable(), this.containerOuter.removeLoadingState(), this._isSelectOneElement ? t.innerHTML = this._placeholderValue || "" : this.input.placeholder = this._placeholderValue || "")
                            }, o._handleSearch = function (e) {
                                if (e && this.input.isFocussed) {
                                    var t = this._store.choices,
                                        n = this.config,
                                        i = n.searchFloor,
                                        r = n.searchChoices,
                                        o = t.some((function (e) {
                                            return !e.active
                                        }));
                                    if (e && e.length >= i) {
                                        var a = r ? this._searchChoices(e) : 0;
                                        this.passedElement.triggerEvent(R, {
                                            value: e,
                                            resultCount: a
                                        })
                                    } else o && (this._isSearching = !1, this._store.dispatch(ye(!0)))
                                }
                            }, o._canAddItem = function (e, t) {
                                var n = !0,
                                    i = "function" == typeof this.config.addItemText ? this.config.addItemText(t) : this.config.addItemText;
                                if (!this._isSelectOneElement) {
                                    var r = function (e, t, n) {
                                        return void 0 === n && (n = "value"), e.some((function (e) {
                                            return "string" == typeof t ? e[n] === t.trim() : e[n] === t
                                        }))
                                    }(e, t);
                                    this.config.maxItemCount > 0 && this.config.maxItemCount <= e.length && (n = !1, i = "function" == typeof this.config.maxItemText ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText), !this.config.duplicateItemsAllowed && r && n && (n = !1, i = "function" == typeof this.config.uniqueItemText ? this.config.uniqueItemText(t) : this.config.uniqueItemText), this._isTextElement && this.config.addItems && n && "function" == typeof this.config.addItemFilter && !this.config.addItemFilter(t) && (n = !1, i = "function" == typeof this.config.customAddItemText ? this.config.customAddItemText(t) : this.config.customAddItemText)
                                }
                                return {
                                    response: n,
                                    notice: i
                                }
                            }, o._searchChoices = function (e) {
                                var t = "string" == typeof e ? e.trim() : e,
                                    n = "string" == typeof this._currentValue ? this._currentValue.trim() : this._currentValue;
                                if (t.length < 1 && t === n + " ") return 0;
                                var i = this._store.searchableChoices,
                                    o = t,
                                    a = [].concat(this.config.searchFields),
                                    s = Object.assign(this.config.fuseOptions, {
                                        keys: a
                                    }),
                                    l = new r.a(i, s).search(o);
                                return this._currentValue = t, this._highlightPosition = 0, this._isSearching = !0, this._store.dispatch(function (e) {
                                    return {
                                        type: U,
                                        results: e
                                    }
                                }(l)), l.length
                            }, o._addEventListeners = function () {
                                var e = document.documentElement;
                                e.addEventListener("touchend", this._onTouchEnd, !0), this.containerOuter.element.addEventListener("keydown", this._onKeyDown, !0), this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, !0), e.addEventListener("click", this._onClick, {
                                    passive: !0
                                }), e.addEventListener("touchmove", this._onTouchMove, {
                                    passive: !0
                                }), this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                                    passive: !0
                                }), this._isSelectOneElement && (this.containerOuter.element.addEventListener("focus", this._onFocus, {
                                    passive: !0
                                }), this.containerOuter.element.addEventListener("blur", this._onBlur, {
                                    passive: !0
                                })), this.input.element.addEventListener("keyup", this._onKeyUp, {
                                    passive: !0
                                }), this.input.element.addEventListener("focus", this._onFocus, {
                                    passive: !0
                                }), this.input.element.addEventListener("blur", this._onBlur, {
                                    passive: !0
                                }), this.input.element.form && this.input.element.form.addEventListener("reset", this._onFormReset, {
                                    passive: !0
                                }), this.input.addEventListeners()
                            }, o._removeEventListeners = function () {
                                var e = document.documentElement;
                                e.removeEventListener("touchend", this._onTouchEnd, !0), this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, !0), this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, !0), e.removeEventListener("click", this._onClick), e.removeEventListener("touchmove", this._onTouchMove), this.dropdown.element.removeEventListener("mouseover", this._onMouseOver), this._isSelectOneElement && (this.containerOuter.element.removeEventListener("focus", this._onFocus), this.containerOuter.element.removeEventListener("blur", this._onBlur)), this.input.element.removeEventListener("keyup", this._onKeyUp), this.input.element.removeEventListener("focus", this._onFocus), this.input.element.removeEventListener("blur", this._onBlur), this.input.element.form && this.input.element.form.removeEventListener("reset", this._onFormReset), this.input.removeEventListeners()
                            }, o._onKeyDown = function (e) {
                                var t, n = e.target,
                                    i = e.keyCode,
                                    r = e.ctrlKey,
                                    o = e.metaKey,
                                    a = this._store.activeItems,
                                    s = this.input.isFocussed,
                                    l = this.dropdown.isActive,
                                    c = this.itemList.hasChildren(),
                                    u = String.fromCharCode(i),
                                    d = X,
                                    h = Z,
                                    f = Q,
                                    p = J,
                                    g = ee,
                                    m = te,
                                    v = ne,
                                    b = ie,
                                    y = re,
                                    _ = r || o;
                                !this._isTextElement && /[a-zA-Z0-9-_ ]/.test(u) && this.showDropdown();
                                var x = ((t = {})[p] = this._onAKey, t[f] = this._onEnterKey, t[g] = this._onEscapeKey, t[m] = this._onDirectionKey, t[b] = this._onDirectionKey, t[v] = this._onDirectionKey, t[y] = this._onDirectionKey, t[h] = this._onDeleteKey, t[d] = this._onDeleteKey, t);
                                x[i] && x[i]({
                                    event: e,
                                    target: n,
                                    keyCode: i,
                                    metaKey: o,
                                    activeItems: a,
                                    hasFocusedInput: s,
                                    hasActiveDropdown: l,
                                    hasItems: c,
                                    hasCtrlDownKeyPressed: _
                                })
                            }, o._onKeyUp = function (e) {
                                var t = e.target,
                                    n = e.keyCode,
                                    i = this.input.value,
                                    r = this._store.activeItems,
                                    o = this._canAddItem(r, i),
                                    a = X,
                                    s = Z;
                                if (this._isTextElement)
                                    if (o.notice && i) {
                                        var l = this._getTemplate("notice", o.notice);
                                        this.dropdown.element.innerHTML = l.outerHTML, this.showDropdown(!0)
                                    } else this.hideDropdown(!0);
                                else {
                                    var c = (n === a || n === s) && !t.value,
                                        u = !this._isTextElement && this._isSearching,
                                        d = this._canSearch && o.response;
                                    c && u ? (this._isSearching = !1, this._store.dispatch(ye(!0))) : d && this._handleSearch(this.input.value)
                                }
                                this._canSearch = this.config.searchEnabled
                            }, o._onAKey = function (e) {
                                var t = e.hasItems;
                                e.hasCtrlDownKeyPressed && t && (this._canSearch = !1, this.config.removeItems && !this.input.value && this.input.element === document.activeElement && this.highlightAll())
                            }, o._onEnterKey = function (e) {
                                var t = e.event,
                                    n = e.target,
                                    i = e.activeItems,
                                    r = e.hasActiveDropdown,
                                    o = Q,
                                    a = n.hasAttribute("data-button");
                                if (this._isTextElement && n.value) {
                                    var s = this.input.value;
                                    this._canAddItem(i, s).response && (this.hideDropdown(!0), this._addItem({
                                        value: s
                                    }), this._triggerChange(s), this.clearInput())
                                }
                                if (a && (this._handleButtonAction(i, n), t.preventDefault()), r) {
                                    var l = this.dropdown.getChild("." + this.config.classNames.highlightedState);
                                    l && (i[0] && (i[0].keyCode = o), this._handleChoiceAction(i, l)), t.preventDefault()
                                } else this._isSelectOneElement && (this.showDropdown(), t.preventDefault())
                            }, o._onEscapeKey = function (e) {
                                e.hasActiveDropdown && (this.hideDropdown(!0), this.containerOuter.focus())
                            }, o._onDirectionKey = function (e) {
                                var t, n, i, r = e.event,
                                    o = e.hasActiveDropdown,
                                    a = e.keyCode,
                                    s = e.metaKey,
                                    l = ne,
                                    c = ie,
                                    u = re;
                                if (o || this._isSelectOneElement) {
                                    this.showDropdown(), this._canSearch = !1;
                                    var d, h = a === l || a === u ? 1 : -1,
                                        f = "[data-choice-selectable]";
                                    if (s || a === u || a === c) d = h > 0 ? this.dropdown.element.querySelector("[data-choice-selectable]:last-of-type") : this.dropdown.element.querySelector(f);
                                    else {
                                        var p = this.dropdown.element.querySelector("." + this.config.classNames.highlightedState);
                                        d = p ? function (e, t, n) {
                                            if (void 0 === n && (n = 1), e instanceof Element && "string" == typeof t) {
                                                for (var i = (n > 0 ? "next" : "previous") + "ElementSibling", r = e[i]; r;) {
                                                    if (r.matches(t)) return r;
                                                    r = r[i]
                                                }
                                                return r
                                            }
                                        }(p, f, h) : this.dropdown.element.querySelector(f)
                                    }
                                    d && (t = d, n = this.choiceList.element, void 0 === (i = h) && (i = 1), t && (i > 0 ? n.scrollTop + n.offsetHeight >= t.offsetTop + t.offsetHeight : t.offsetTop >= n.scrollTop) || this.choiceList.scrollToChildElement(d, h), this._highlightChoice(d)), r.preventDefault()
                                }
                            }, o._onDeleteKey = function (e) {
                                var t = e.event,
                                    n = e.target,
                                    i = e.hasFocusedInput,
                                    r = e.activeItems;
                                !i || n.value || this._isSelectOneElement || (this._handleBackspace(r), t.preventDefault())
                            }, o._onTouchMove = function () {
                                this._wasTap && (this._wasTap = !1)
                            }, o._onTouchEnd = function (e) {
                                var t = (e || e.touches[0]).target;
                                this._wasTap && this.containerOuter.element.contains(t) && ((t === this.containerOuter.element || t === this.containerInner.element) && (this._isTextElement ? this.input.focus() : this._isSelectMultipleElement && this.showDropdown()), e.stopPropagation()), this._wasTap = !0
                            }, o._onMouseDown = function (e) {
                                var t = e.target;
                                if (t instanceof HTMLElement) {
                                    if (ke && this.choiceList.element.contains(t)) {
                                        var n = this.choiceList.element.firstElementChild,
                                            i = "ltr" === this._direction ? e.offsetX >= n.offsetWidth : e.offsetX < n.offsetLeft;
                                        this._isScrollingOnIe = i
                                    }
                                    if (t !== this.input.element) {
                                        var r = t.closest("[data-button],[data-item],[data-choice]");
                                        if (r instanceof HTMLElement) {
                                            var o = e.shiftKey,
                                                a = this._store.activeItems,
                                                s = r.dataset;
                                            "button" in s ? this._handleButtonAction(a, r) : "item" in s ? this._handleItemAction(a, r, o) : "choice" in s && this._handleChoiceAction(a, r)
                                        }
                                        e.preventDefault()
                                    }
                                }
                            }, o._onMouseOver = function (e) {
                                var t = e.target;
                                t instanceof HTMLElement && "choice" in t.dataset && this._highlightChoice(t)
                            }, o._onClick = function (e) {
                                var t = e.target;
                                this.containerOuter.element.contains(t) ? this.dropdown.isActive || this.containerOuter.isDisabled ? this._isSelectOneElement && t !== this.input.element && !this.dropdown.element.contains(t) && this.hideDropdown() : this._isTextElement ? document.activeElement !== this.input.element && this.input.focus() : (this.showDropdown(), this.containerOuter.focus()) : (this._store.highlightedActiveItems.length > 0 && this.unhighlightAll(), this.containerOuter.removeFocusState(), this.hideDropdown(!0))
                            }, o._onFocus = function (e) {
                                var t, n = this,
                                    i = e.target;
                                this.containerOuter.element.contains(i) && ((t = {}).text = function () {
                                    i === n.input.element && n.containerOuter.addFocusState()
                                }, t["select-one"] = function () {
                                    n.containerOuter.addFocusState(), i === n.input.element && n.showDropdown(!0)
                                }, t["select-multiple"] = function () {
                                    i === n.input.element && (n.showDropdown(!0), n.containerOuter.addFocusState())
                                }, t)[this.passedElement.element.type]()
                            }, o._onBlur = function (e) {
                                var t = this,
                                    n = e.target;
                                if (this.containerOuter.element.contains(n) && !this._isScrollingOnIe) {
                                    var i, r = this._store.activeItems.some((function (e) {
                                        return e.highlighted
                                    }));
                                    ((i = {}).text = function () {
                                        n === t.input.element && (t.containerOuter.removeFocusState(), r && t.unhighlightAll(), t.hideDropdown(!0))
                                    }, i["select-one"] = function () {
                                        t.containerOuter.removeFocusState(), (n === t.input.element || n === t.containerOuter.element && !t._canSearch) && t.hideDropdown(!0)
                                    }, i["select-multiple"] = function () {
                                        n === t.input.element && (t.containerOuter.removeFocusState(), t.hideDropdown(!0), r && t.unhighlightAll())
                                    }, i)[this.passedElement.element.type]()
                                } else this._isScrollingOnIe = !1, this.input.element.focus()
                            }, o._onFormReset = function () {
                                this._store.dispatch({
                                    type: "RESET_TO",
                                    state: this._initialState
                                })
                            }, o._highlightChoice = function (e) {
                                var t = this;
                                void 0 === e && (e = null);
                                var n = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                                if (n.length) {
                                    var i = e;
                                    Array.from(this.dropdown.element.querySelectorAll("." + this.config.classNames.highlightedState)).forEach((function (e) {
                                        e.classList.remove(t.config.classNames.highlightedState), e.setAttribute("aria-selected", "false")
                                    })), i ? this._highlightPosition = n.indexOf(i) : (i = n.length > this._highlightPosition ? n[this._highlightPosition] : n[n.length - 1]) || (i = n[0]), i.classList.add(this.config.classNames.highlightedState), i.setAttribute("aria-selected", "true"), this.passedElement.triggerEvent(z, {
                                        el: i
                                    }), this.dropdown.isActive && (this.input.setActiveDescendant(i.id), this.containerOuter.setActiveDescendant(i.id))
                                }
                            }, o._addItem = function (e) {
                                var t = e.value,
                                    n = e.label,
                                    i = void 0 === n ? null : n,
                                    r = e.choiceId,
                                    o = void 0 === r ? -1 : r,
                                    a = e.groupId,
                                    s = void 0 === a ? -1 : a,
                                    l = e.customProperties,
                                    c = void 0 === l ? null : l,
                                    u = e.placeholder,
                                    d = void 0 !== u && u,
                                    h = e.keyCode,
                                    f = void 0 === h ? null : h,
                                    p = "string" == typeof t ? t.trim() : t,
                                    g = f,
                                    m = c,
                                    v = this._store.items,
                                    b = i || p,
                                    y = o || -1,
                                    _ = s >= 0 ? this._store.getGroupById(s) : null,
                                    x = v ? v.length + 1 : 1;
                                return this.config.prependValue && (p = this.config.prependValue + p.toString()), this.config.appendValue && (p += this.config.appendValue.toString()), this._store.dispatch(function (e) {
                                    var t = e.value,
                                        n = e.label,
                                        i = e.id,
                                        r = e.choiceId,
                                        o = e.groupId,
                                        a = e.customProperties,
                                        s = e.placeholder,
                                        l = e.keyCode;
                                    return {
                                        type: $,
                                        value: t,
                                        label: n,
                                        id: i,
                                        choiceId: r,
                                        groupId: o,
                                        customProperties: a,
                                        placeholder: s,
                                        keyCode: l
                                    }
                                }({
                                    value: p,
                                    label: b,
                                    id: x,
                                    choiceId: y,
                                    groupId: s,
                                    customProperties: c,
                                    placeholder: d,
                                    keyCode: g
                                })), this._isSelectOneElement && this.removeActiveItems(x), this.passedElement.triggerEvent(F, {
                                    id: x,
                                    value: p,
                                    label: b,
                                    customProperties: m,
                                    groupValue: _ && _.value ? _.value : void 0,
                                    keyCode: g
                                }), this
                            }, o._removeItem = function (e) {
                                if (!e || !x("Object", e)) return this;
                                var t = e.id,
                                    n = e.value,
                                    i = e.label,
                                    r = e.choiceId,
                                    o = e.groupId,
                                    a = o >= 0 ? this._store.getGroupById(o) : null;
                                return this._store.dispatch(function (e, t) {
                                    return {
                                        type: K,
                                        id: e,
                                        choiceId: t
                                    }
                                }(t, r)), a && a.value ? this.passedElement.triggerEvent(B, {
                                    id: t,
                                    value: n,
                                    label: i,
                                    groupValue: a.value
                                }) : this.passedElement.triggerEvent(B, {
                                    id: t,
                                    value: n,
                                    label: i
                                }), this
                            }, o._addChoice = function (e) {
                                var t = e.value,
                                    n = e.label,
                                    i = void 0 === n ? null : n,
                                    r = e.isSelected,
                                    o = void 0 !== r && r,
                                    a = e.isDisabled,
                                    s = void 0 !== a && a,
                                    l = e.groupId,
                                    c = void 0 === l ? -1 : l,
                                    u = e.customProperties,
                                    d = void 0 === u ? null : u,
                                    h = e.placeholder,
                                    f = void 0 !== h && h,
                                    p = e.keyCode,
                                    g = void 0 === p ? null : p;
                                if (null != t) {
                                    var m = this._store.choices,
                                        v = i || t,
                                        b = m ? m.length + 1 : 1,
                                        y = this._baseId + "-" + this._idNames.itemChoice + "-" + b;
                                    this._store.dispatch(function (e) {
                                        var t = e.value,
                                            n = e.label,
                                            i = e.id,
                                            r = e.groupId,
                                            o = e.disabled,
                                            a = e.elementId,
                                            s = e.customProperties,
                                            l = e.placeholder,
                                            c = e.keyCode;
                                        return {
                                            type: H,
                                            value: t,
                                            label: n,
                                            id: i,
                                            groupId: r,
                                            disabled: o,
                                            elementId: a,
                                            customProperties: s,
                                            placeholder: l,
                                            keyCode: c
                                        }
                                    }({
                                        id: b,
                                        groupId: c,
                                        elementId: y,
                                        value: t,
                                        label: v,
                                        disabled: s,
                                        customProperties: d,
                                        placeholder: f,
                                        keyCode: g
                                    })), o && this._addItem({
                                        value: t,
                                        label: v,
                                        choiceId: b,
                                        customProperties: d,
                                        placeholder: f,
                                        keyCode: g
                                    })
                                }
                            }, o._addGroup = function (e) {
                                var t = this,
                                    n = e.group,
                                    i = e.id,
                                    r = e.valueKey,
                                    o = void 0 === r ? "value" : r,
                                    a = e.labelKey,
                                    s = void 0 === a ? "label" : a,
                                    l = x("Object", n) ? n.choices : Array.from(n.getElementsByTagName("OPTION")),
                                    c = i || Math.floor((new Date).valueOf() * Math.random()),
                                    u = !!n.disabled && n.disabled;
                                l ? (this._store.dispatch(xe({
                                    value: n.label,
                                    id: c,
                                    active: !0,
                                    disabled: u
                                })), l.forEach((function (e) {
                                    var n = e.disabled || e.parentNode && e.parentNode.disabled;
                                    t._addChoice({
                                        value: e[o],
                                        label: x("Object", e) ? e[s] : e.innerHTML,
                                        isSelected: e.selected,
                                        isDisabled: n,
                                        groupId: c,
                                        customProperties: e.customProperties,
                                        placeholder: e.placeholder
                                    })
                                }))) : this._store.dispatch(xe({
                                    value: n.label,
                                    id: n.id,
                                    active: !1,
                                    disabled: n.disabled
                                }))
                            }, o._getTemplate = function (e) {
                                var t;
                                if (!e) return null;
                                for (var n = this.config.classNames, i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) r[o - 1] = arguments[o];
                                return (t = this._templates[e]).call.apply(t, [this, n].concat(r))
                            }, o._createTemplates = function () {
                                var e = this.config.callbackOnCreateTemplates,
                                    t = {};
                                e && "function" == typeof e && (t = e.call(this, E)), this._templates = a()(be, t)
                            }, o._createElements = function () {
                                this.containerOuter = new le({
                                    element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type),
                                    classNames: this.config.classNames,
                                    type: this.passedElement.element.type,
                                    position: this.config.position
                                }), this.containerInner = new le({
                                    element: this._getTemplate("containerInner"),
                                    classNames: this.config.classNames,
                                    type: this.passedElement.element.type,
                                    position: this.config.position
                                }), this.input = new ue({
                                    element: this._getTemplate("input", this._placeholderValue),
                                    classNames: this.config.classNames,
                                    type: this.passedElement.element.type,
                                    preventPaste: !this.config.paste
                                }), this.choiceList = new de({
                                    element: this._getTemplate("choiceList", this._isSelectOneElement)
                                }), this.itemList = new de({
                                    element: this._getTemplate("itemList", this._isSelectOneElement)
                                }), this.dropdown = new P({
                                    element: this._getTemplate("dropdown"),
                                    classNames: this.config.classNames,
                                    type: this.passedElement.element.type
                                })
                            }, o._createStructure = function () {
                                this.passedElement.conceal(), this.containerInner.wrap(this.passedElement.element), this.containerOuter.wrap(this.containerInner.element), this._isSelectOneElement ? this.input.placeholder = this.config.searchPlaceholderValue || "" : this._placeholderValue && (this.input.placeholder = this._placeholderValue, this.input.setWidth()), this.containerOuter.element.appendChild(this.containerInner.element), this.containerOuter.element.appendChild(this.dropdown.element), this.containerInner.element.appendChild(this.itemList.element), this._isTextElement || this.dropdown.element.appendChild(this.choiceList.element), this._isSelectOneElement ? this.config.searchEnabled && this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild) : this.containerInner.element.appendChild(this.input.element), this._isSelectElement && (this._highlightPosition = 0, this._isSearching = !1, this._startLoading(), this._presetGroups.length ? this._addPredefinedGroups(this._presetGroups) : this._addPredefinedChoices(this._presetChoices), this._stopLoading()), this._isTextElement && this._addPredefinedItems(this._presetItems)
                            }, o._addPredefinedGroups = function (e) {
                                var t = this,
                                    n = this.passedElement.placeholderOption;
                                n && "SELECT" === n.parentNode.tagName && this._addChoice({
                                    value: n.value,
                                    label: n.innerHTML,
                                    isSelected: n.selected,
                                    isDisabled: n.disabled,
                                    placeholder: !0
                                }), e.forEach((function (e) {
                                    return t._addGroup({
                                        group: e,
                                        id: e.id || null
                                    })
                                }))
                            }, o._addPredefinedChoices = function (e) {
                                var t = this;
                                this.config.shouldSort && e.sort(this.config.sorter);
                                var n = e.some((function (e) {
                                        return e.selected
                                    })),
                                    i = e.findIndex((function (e) {
                                        return void 0 === e.disabled || !e.disabled
                                    }));
                                e.forEach((function (e, r) {
                                    var o = e.value,
                                        a = e.label,
                                        s = e.customProperties,
                                        l = e.placeholder;
                                    if (t._isSelectElement)
                                        if (e.choices) t._addGroup({
                                            group: e,
                                            id: e.id || null
                                        });
                                        else {
                                            var c = !(!t._isSelectOneElement || n || r !== i) || e.selected,
                                                u = e.disabled;
                                            t._addChoice({
                                                value: o,
                                                label: a,
                                                isSelected: c,
                                                isDisabled: u,
                                                customProperties: s,
                                                placeholder: l
                                            })
                                        }
                                    else t._addChoice({
                                        value: o,
                                        label: a,
                                        isSelected: e.selected,
                                        isDisabled: e.disabled,
                                        customProperties: s,
                                        placeholder: l
                                    })
                                }))
                            }, o._addPredefinedItems = function (e) {
                                var t = this;
                                e.forEach((function (e) {
                                    "object" == typeof e && e.value && t._addItem({
                                        value: e.value,
                                        label: e.label,
                                        choiceId: e.id,
                                        customProperties: e.customProperties,
                                        placeholder: e.placeholder
                                    }), "string" == typeof e && t._addItem({
                                        value: e
                                    })
                                }))
                            }, o._setChoiceOrItem = function (e) {
                                var t = this;
                                ({
                                    object: function () {
                                        e.value && (t._isTextElement ? t._addItem({
                                            value: e.value,
                                            label: e.label,
                                            choiceId: e.id,
                                            customProperties: e.customProperties,
                                            placeholder: e.placeholder
                                        }) : t._addChoice({
                                            value: e.value,
                                            label: e.label,
                                            isSelected: !0,
                                            isDisabled: !1,
                                            customProperties: e.customProperties,
                                            placeholder: e.placeholder
                                        }))
                                    },
                                    string: function () {
                                        t._isTextElement ? t._addItem({
                                            value: e
                                        }) : t._addChoice({
                                            value: e,
                                            label: e,
                                            isSelected: !0,
                                            isDisabled: !1
                                        })
                                    }
                                })[_(e).toLowerCase()]()
                            }, o._findAndSelectChoiceByValue = function (e) {
                                var t = this,
                                    n = this._store.choices.find((function (n) {
                                        return t.config.valueComparer(n.value, e)
                                    }));
                                n && !n.selected && this._addItem({
                                    value: n.value,
                                    label: n.label,
                                    choiceId: n.id,
                                    groupId: n.groupId,
                                    customProperties: n.customProperties,
                                    placeholder: n.placeholder,
                                    keyCode: n.keyCode
                                })
                            }, o._generatePlaceholderValue = function () {
                                if (this._isSelectElement) {
                                    var e = this.passedElement.placeholderOption;
                                    return !!e && e.text
                                }
                                var t = this.config,
                                    n = t.placeholder,
                                    i = t.placeholderValue,
                                    r = this.passedElement.element.dataset;
                                if (n) {
                                    if (i) return i;
                                    if (r.placeholder) return r.placeholder
                                }
                                return !1
                            }, i
                        }();
                    t.default = Se
                }]).default
            }, e.exports = t()
        },
        25: e => {
            var t;
            self, t = function () {
                return function () {
                    var e = {
                            3099: function (e) {
                                e.exports = function (e) {
                                    if ("function" != typeof e) throw TypeError(String(e) + " is not a function");
                                    return e
                                }
                            },
                            6077: function (e, t, n) {
                                var i = n(111);
                                e.exports = function (e) {
                                    if (!i(e) && null !== e) throw TypeError("Can't set " + String(e) + " as a prototype");
                                    return e
                                }
                            },
                            1223: function (e, t, n) {
                                var i = n(5112),
                                    r = n(30),
                                    o = n(3070),
                                    a = i("unscopables"),
                                    s = Array.prototype;
                                null == s[a] && o.f(s, a, {
                                    configurable: !0,
                                    value: r(null)
                                }), e.exports = function (e) {
                                    s[a][e] = !0
                                }
                            },
                            1530: function (e, t, n) {
                                "use strict";
                                var i = n(8710).charAt;
                                e.exports = function (e, t, n) {
                                    return t + (n ? i(e, t).length : 1)
                                }
                            },
                            5787: function (e) {
                                e.exports = function (e, t, n) {
                                    if (!(e instanceof t)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
                                    return e
                                }
                            },
                            9670: function (e, t, n) {
                                var i = n(111);
                                e.exports = function (e) {
                                    if (!i(e)) throw TypeError(String(e) + " is not an object");
                                    return e
                                }
                            },
                            4019: function (e) {
                                e.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView
                            },
                            260: function (e, t, n) {
                                "use strict";
                                var i, r = n(4019),
                                    o = n(9781),
                                    a = n(7854),
                                    s = n(111),
                                    l = n(6656),
                                    c = n(648),
                                    u = n(8880),
                                    d = n(1320),
                                    h = n(3070).f,
                                    f = n(9518),
                                    p = n(7674),
                                    g = n(5112),
                                    m = n(9711),
                                    v = a.Int8Array,
                                    b = v && v.prototype,
                                    y = a.Uint8ClampedArray,
                                    _ = y && y.prototype,
                                    x = v && f(v),
                                    w = b && f(b),
                                    E = Object.prototype,
                                    k = E.isPrototypeOf,
                                    O = g("toStringTag"),
                                    S = m("TYPED_ARRAY_TAG"),
                                    C = r && !!p && "Opera" !== c(a.opera),
                                    A = !1,
                                    M = {
                                        Int8Array: 1,
                                        Uint8Array: 1,
                                        Uint8ClampedArray: 1,
                                        Int16Array: 2,
                                        Uint16Array: 2,
                                        Int32Array: 4,
                                        Uint32Array: 4,
                                        Float32Array: 4,
                                        Float64Array: 8
                                    },
                                    T = {
                                        BigInt64Array: 8,
                                        BigUint64Array: 8
                                    },
                                    P = function (e) {
                                        if (!s(e)) return !1;
                                        var t = c(e);
                                        return l(M, t) || l(T, t)
                                    };
                                for (i in M) a[i] || (C = !1);
                                if ((!C || "function" != typeof x || x === Function.prototype) && (x = function () {
                                        throw TypeError("Incorrect invocation")
                                    }, C))
                                    for (i in M) a[i] && p(a[i], x);
                                if ((!C || !w || w === E) && (w = x.prototype, C))
                                    for (i in M) a[i] && p(a[i].prototype, w);
                                if (C && f(_) !== w && p(_, w), o && !l(w, O))
                                    for (i in A = !0, h(w, O, {
                                            get: function () {
                                                return s(this) ? this[S] : void 0
                                            }
                                        }), M) a[i] && u(a[i], S, i);
                                e.exports = {
                                    NATIVE_ARRAY_BUFFER_VIEWS: C,
                                    TYPED_ARRAY_TAG: A && S,
                                    aTypedArray: function (e) {
                                        if (P(e)) return e;
                                        throw TypeError("Target is not a typed array")
                                    },
                                    aTypedArrayConstructor: function (e) {
                                        if (p) {
                                            if (k.call(x, e)) return e
                                        } else
                                            for (var t in M)
                                                if (l(M, i)) {
                                                    var n = a[t];
                                                    if (n && (e === n || k.call(n, e))) return e
                                                } throw TypeError("Target is not a typed array constructor")
                                    },
                                    exportTypedArrayMethod: function (e, t, n) {
                                        if (o) {
                                            if (n)
                                                for (var i in M) {
                                                    var r = a[i];
                                                    r && l(r.prototype, e) && delete r.prototype[e]
                                                }
                                            w[e] && !n || d(w, e, n ? t : C && b[e] || t)
                                        }
                                    },
                                    exportTypedArrayStaticMethod: function (e, t, n) {
                                        var i, r;
                                        if (o) {
                                            if (p) {
                                                if (n)
                                                    for (i in M)(r = a[i]) && l(r, e) && delete r[e];
                                                if (x[e] && !n) return;
                                                try {
                                                    return d(x, e, n ? t : C && v[e] || t)
                                                } catch (e) {}
                                            }
                                            for (i in M) !(r = a[i]) || r[e] && !n || d(r, e, t)
                                        }
                                    },
                                    isView: function (e) {
                                        if (!s(e)) return !1;
                                        var t = c(e);
                                        return "DataView" === t || l(M, t) || l(T, t)
                                    },
                                    isTypedArray: P,
                                    TypedArray: x,
                                    TypedArrayPrototype: w
                                }
                            },
                            3331: function (e, t, n) {
                                "use strict";
                                var i = n(7854),
                                    r = n(9781),
                                    o = n(4019),
                                    a = n(8880),
                                    s = n(2248),
                                    l = n(7293),
                                    c = n(5787),
                                    u = n(9958),
                                    d = n(7466),
                                    h = n(7067),
                                    f = n(1179),
                                    p = n(9518),
                                    g = n(7674),
                                    m = n(8006).f,
                                    v = n(3070).f,
                                    b = n(1285),
                                    y = n(8003),
                                    _ = n(9909),
                                    x = _.get,
                                    w = _.set,
                                    E = "ArrayBuffer",
                                    k = "DataView",
                                    O = "Wrong index",
                                    S = i.ArrayBuffer,
                                    C = S,
                                    A = i.DataView,
                                    M = A && A.prototype,
                                    T = Object.prototype,
                                    P = i.RangeError,
                                    D = f.pack,
                                    L = f.unpack,
                                    N = function (e) {
                                        return [255 & e]
                                    },
                                    j = function (e) {
                                        return [255 & e, e >> 8 & 255]
                                    },
                                    I = function (e) {
                                        return [255 & e, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255]
                                    },
                                    R = function (e) {
                                        return e[3] << 24 | e[2] << 16 | e[1] << 8 | e[0]
                                    },
                                    F = function (e) {
                                        return D(e, 23, 4)
                                    },
                                    B = function (e) {
                                        return D(e, 52, 8)
                                    },
                                    q = function (e, t) {
                                        v(e.prototype, t, {
                                            get: function () {
                                                return x(this)[t]
                                            }
                                        })
                                    },
                                    z = function (e, t, n, i) {
                                        var r = h(n),
                                            o = x(e);
                                        if (r + t > o.byteLength) throw P(O);
                                        var a = x(o.buffer).bytes,
                                            s = r + o.byteOffset,
                                            l = a.slice(s, s + t);
                                        return i ? l : l.reverse()
                                    },
                                    H = function (e, t, n, i, r, o) {
                                        var a = h(n),
                                            s = x(e);
                                        if (a + t > s.byteLength) throw P(O);
                                        for (var l = x(s.buffer).bytes, c = a + s.byteOffset, u = i(+r), d = 0; d < t; d++) l[c + d] = u[o ? d : t - d - 1]
                                    };
                                if (o) {
                                    if (!l((function () {
                                            S(1)
                                        })) || !l((function () {
                                            new S(-1)
                                        })) || l((function () {
                                            return new S, new S(1.5), new S(NaN), S.name != E
                                        }))) {
                                        for (var U, V = (C = function (e) {
                                                return c(this, C), new S(h(e))
                                            }).prototype = S.prototype, W = m(S), Y = 0; W.length > Y;)(U = W[Y++]) in C || a(C, U, S[U]);
                                        V.constructor = C
                                    }
                                    g && p(M) !== T && g(M, T);
                                    var $ = new A(new C(2)),
                                        K = M.setInt8;
                                    $.setInt8(0, 2147483648), $.setInt8(1, 2147483649), !$.getInt8(0) && $.getInt8(1) || s(M, {
                                        setInt8: function (e, t) {
                                            K.call(this, e, t << 24 >> 24)
                                        },
                                        setUint8: function (e, t) {
                                            K.call(this, e, t << 24 >> 24)
                                        }
                                    }, {
                                        unsafe: !0
                                    })
                                } else C = function (e) {
                                    c(this, C, E);
                                    var t = h(e);
                                    w(this, {
                                        bytes: b.call(new Array(t), 0),
                                        byteLength: t
                                    }), r || (this.byteLength = t)
                                }, A = function (e, t, n) {
                                    c(this, A, k), c(e, C, k);
                                    var i = x(e).byteLength,
                                        o = u(t);
                                    if (o < 0 || o > i) throw P("Wrong offset");
                                    if (o + (n = void 0 === n ? i - o : d(n)) > i) throw P("Wrong length");
                                    w(this, {
                                        buffer: e,
                                        byteLength: n,
                                        byteOffset: o
                                    }), r || (this.buffer = e, this.byteLength = n, this.byteOffset = o)
                                }, r && (q(C, "byteLength"), q(A, "buffer"), q(A, "byteLength"), q(A, "byteOffset")), s(A.prototype, {
                                    getInt8: function (e) {
                                        return z(this, 1, e)[0] << 24 >> 24
                                    },
                                    getUint8: function (e) {
                                        return z(this, 1, e)[0]
                                    },
                                    getInt16: function (e) {
                                        var t = z(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
                                        return (t[1] << 8 | t[0]) << 16 >> 16
                                    },
                                    getUint16: function (e) {
                                        var t = z(this, 2, e, arguments.length > 1 ? arguments[1] : void 0);
                                        return t[1] << 8 | t[0]
                                    },
                                    getInt32: function (e) {
                                        return R(z(this, 4, e, arguments.length > 1 ? arguments[1] : void 0))
                                    },
                                    getUint32: function (e) {
                                        return R(z(this, 4, e, arguments.length > 1 ? arguments[1] : void 0)) >>> 0
                                    },
                                    getFloat32: function (e) {
                                        return L(z(this, 4, e, arguments.length > 1 ? arguments[1] : void 0), 23)
                                    },
                                    getFloat64: function (e) {
                                        return L(z(this, 8, e, arguments.length > 1 ? arguments[1] : void 0), 52)
                                    },
                                    setInt8: function (e, t) {
                                        H(this, 1, e, N, t)
                                    },
                                    setUint8: function (e, t) {
                                        H(this, 1, e, N, t)
                                    },
                                    setInt16: function (e, t) {
                                        H(this, 2, e, j, t, arguments.length > 2 ? arguments[2] : void 0)
                                    },
                                    setUint16: function (e, t) {
                                        H(this, 2, e, j, t, arguments.length > 2 ? arguments[2] : void 0)
                                    },
                                    setInt32: function (e, t) {
                                        H(this, 4, e, I, t, arguments.length > 2 ? arguments[2] : void 0)
                                    },
                                    setUint32: function (e, t) {
                                        H(this, 4, e, I, t, arguments.length > 2 ? arguments[2] : void 0)
                                    },
                                    setFloat32: function (e, t) {
                                        H(this, 4, e, F, t, arguments.length > 2 ? arguments[2] : void 0)
                                    },
                                    setFloat64: function (e, t) {
                                        H(this, 8, e, B, t, arguments.length > 2 ? arguments[2] : void 0)
                                    }
                                });
                                y(C, E), y(A, k), e.exports = {
                                    ArrayBuffer: C,
                                    DataView: A
                                }
                            },
                            1048: function (e, t, n) {
                                "use strict";
                                var i = n(7908),
                                    r = n(1400),
                                    o = n(7466),
                                    a = Math.min;
                                e.exports = [].copyWithin || function (e, t) {
                                    var n = i(this),
                                        s = o(n.length),
                                        l = r(e, s),
                                        c = r(t, s),
                                        u = arguments.length > 2 ? arguments[2] : void 0,
                                        d = a((void 0 === u ? s : r(u, s)) - c, s - l),
                                        h = 1;
                                    for (c < l && l < c + d && (h = -1, c += d - 1, l += d - 1); d-- > 0;) c in n ? n[l] = n[c] : delete n[l], l += h, c += h;
                                    return n
                                }
                            },
                            1285: function (e, t, n) {
                                "use strict";
                                var i = n(7908),
                                    r = n(1400),
                                    o = n(7466);
                                e.exports = function (e) {
                                    for (var t = i(this), n = o(t.length), a = arguments.length, s = r(a > 1 ? arguments[1] : void 0, n), l = a > 2 ? arguments[2] : void 0, c = void 0 === l ? n : r(l, n); c > s;) t[s++] = e;
                                    return t
                                }
                            },
                            8533: function (e, t, n) {
                                "use strict";
                                var i = n(2092).forEach,
                                    r = n(9341)("forEach");
                                e.exports = r ? [].forEach : function (e) {
                                    return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
                                }
                            },
                            8457: function (e, t, n) {
                                "use strict";
                                var i = n(9974),
                                    r = n(7908),
                                    o = n(3411),
                                    a = n(7659),
                                    s = n(7466),
                                    l = n(6135),
                                    c = n(1246);
                                e.exports = function (e) {
                                    var t, n, u, d, h, f, p = r(e),
                                        g = "function" == typeof this ? this : Array,
                                        m = arguments.length,
                                        v = m > 1 ? arguments[1] : void 0,
                                        b = void 0 !== v,
                                        y = c(p),
                                        _ = 0;
                                    if (b && (v = i(v, m > 2 ? arguments[2] : void 0, 2)), null == y || g == Array && a(y))
                                        for (n = new g(t = s(p.length)); t > _; _++) f = b ? v(p[_], _) : p[_], l(n, _, f);
                                    else
                                        for (h = (d = y.call(p)).next, n = new g; !(u = h.call(d)).done; _++) f = b ? o(d, v, [u.value, _], !0) : u.value, l(n, _, f);
                                    return n.length = _, n
                                }
                            },
                            1318: function (e, t, n) {
                                var i = n(5656),
                                    r = n(7466),
                                    o = n(1400),
                                    a = function (e) {
                                        return function (t, n, a) {
                                            var s, l = i(t),
                                                c = r(l.length),
                                                u = o(a, c);
                                            if (e && n != n) {
                                                for (; c > u;)
                                                    if ((s = l[u++]) != s) return !0
                                            } else
                                                for (; c > u; u++)
                                                    if ((e || u in l) && l[u] === n) return e || u || 0;
                                            return !e && -1
                                        }
                                    };
                                e.exports = {
                                    includes: a(!0),
                                    indexOf: a(!1)
                                }
                            },
                            2092: function (e, t, n) {
                                var i = n(9974),
                                    r = n(8361),
                                    o = n(7908),
                                    a = n(7466),
                                    s = n(5417),
                                    l = [].push,
                                    c = function (e) {
                                        var t = 1 == e,
                                            n = 2 == e,
                                            c = 3 == e,
                                            u = 4 == e,
                                            d = 6 == e,
                                            h = 7 == e,
                                            f = 5 == e || d;
                                        return function (p, g, m, v) {
                                            for (var b, y, _ = o(p), x = r(_), w = i(g, m, 3), E = a(x.length), k = 0, O = v || s, S = t ? O(p, E) : n || h ? O(p, 0) : void 0; E > k; k++)
                                                if ((f || k in x) && (y = w(b = x[k], k, _), e))
                                                    if (t) S[k] = y;
                                                    else if (y) switch (e) {
                                                case 3:
                                                    return !0;
                                                case 5:
                                                    return b;
                                                case 6:
                                                    return k;
                                                case 2:
                                                    l.call(S, b)
                                            } else switch (e) {
                                                case 4:
                                                    return !1;
                                                case 7:
                                                    l.call(S, b)
                                            }
                                            return d ? -1 : c || u ? u : S
                                        }
                                    };
                                e.exports = {
                                    forEach: c(0),
                                    map: c(1),
                                    filter: c(2),
                                    some: c(3),
                                    every: c(4),
                                    find: c(5),
                                    findIndex: c(6),
                                    filterOut: c(7)
                                }
                            },
                            6583: function (e, t, n) {
                                "use strict";
                                var i = n(5656),
                                    r = n(9958),
                                    o = n(7466),
                                    a = n(9341),
                                    s = Math.min,
                                    l = [].lastIndexOf,
                                    c = !!l && 1 / [1].lastIndexOf(1, -0) < 0,
                                    u = a("lastIndexOf"),
                                    d = c || !u;
                                e.exports = d ? function (e) {
                                    if (c) return l.apply(this, arguments) || 0;
                                    var t = i(this),
                                        n = o(t.length),
                                        a = n - 1;
                                    for (arguments.length > 1 && (a = s(a, r(arguments[1]))), a < 0 && (a = n + a); a >= 0; a--)
                                        if (a in t && t[a] === e) return a || 0;
                                    return -1
                                } : l
                            },
                            1194: function (e, t, n) {
                                var i = n(7293),
                                    r = n(5112),
                                    o = n(7392),
                                    a = r("species");
                                e.exports = function (e) {
                                    return o >= 51 || !i((function () {
                                        var t = [];
                                        return (t.constructor = {})[a] = function () {
                                            return {
                                                foo: 1
                                            }
                                        }, 1 !== t[e](Boolean).foo
                                    }))
                                }
                            },
                            9341: function (e, t, n) {
                                "use strict";
                                var i = n(7293);
                                e.exports = function (e, t) {
                                    var n = [][e];
                                    return !!n && i((function () {
                                        n.call(null, t || function () {
                                            throw 1
                                        }, 1)
                                    }))
                                }
                            },
                            3671: function (e, t, n) {
                                var i = n(3099),
                                    r = n(7908),
                                    o = n(8361),
                                    a = n(7466),
                                    s = function (e) {
                                        return function (t, n, s, l) {
                                            i(n);
                                            var c = r(t),
                                                u = o(c),
                                                d = a(c.length),
                                                h = e ? d - 1 : 0,
                                                f = e ? -1 : 1;
                                            if (s < 2)
                                                for (;;) {
                                                    if (h in u) {
                                                        l = u[h], h += f;
                                                        break
                                                    }
                                                    if (h += f, e ? h < 0 : d <= h) throw TypeError("Reduce of empty array with no initial value")
                                                }
                                            for (; e ? h >= 0 : d > h; h += f) h in u && (l = n(l, u[h], h, c));
                                            return l
                                        }
                                    };
                                e.exports = {
                                    left: s(!1),
                                    right: s(!0)
                                }
                            },
                            5417: function (e, t, n) {
                                var i = n(111),
                                    r = n(3157),
                                    o = n(5112)("species");
                                e.exports = function (e, t) {
                                    var n;
                                    return r(e) && ("function" != typeof (n = e.constructor) || n !== Array && !r(n.prototype) ? i(n) && null === (n = n[o]) && (n = void 0) : n = void 0), new(void 0 === n ? Array : n)(0 === t ? 0 : t)
                                }
                            },
                            3411: function (e, t, n) {
                                var i = n(9670),
                                    r = n(9212);
                                e.exports = function (e, t, n, o) {
                                    try {
                                        return o ? t(i(n)[0], n[1]) : t(n)
                                    } catch (t) {
                                        throw r(e), t
                                    }
                                }
                            },
                            7072: function (e, t, n) {
                                var i = n(5112)("iterator"),
                                    r = !1;
                                try {
                                    var o = 0,
                                        a = {
                                            next: function () {
                                                return {
                                                    done: !!o++
                                                }
                                            },
                                            return: function () {
                                                r = !0
                                            }
                                        };
                                    a[i] = function () {
                                        return this
                                    }, Array.from(a, (function () {
                                        throw 2
                                    }))
                                } catch (e) {}
                                e.exports = function (e, t) {
                                    if (!t && !r) return !1;
                                    var n = !1;
                                    try {
                                        var o = {};
                                        o[i] = function () {
                                            return {
                                                next: function () {
                                                    return {
                                                        done: n = !0
                                                    }
                                                }
                                            }
                                        }, e(o)
                                    } catch (e) {}
                                    return n
                                }
                            },
                            4326: function (e) {
                                var t = {}.toString;
                                e.exports = function (e) {
                                    return t.call(e).slice(8, -1)
                                }
                            },
                            648: function (e, t, n) {
                                var i = n(1694),
                                    r = n(4326),
                                    o = n(5112)("toStringTag"),
                                    a = "Arguments" == r(function () {
                                        return arguments
                                    }());
                                e.exports = i ? r : function (e) {
                                    var t, n, i;
                                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
                                        try {
                                            return e[t]
                                        } catch (e) {}
                                    }(t = Object(e), o)) ? n : a ? r(t) : "Object" == (i = r(t)) && "function" == typeof t.callee ? "Arguments" : i
                                }
                            },
                            9920: function (e, t, n) {
                                var i = n(6656),
                                    r = n(3887),
                                    o = n(1236),
                                    a = n(3070);
                                e.exports = function (e, t) {
                                    for (var n = r(t), s = a.f, l = o.f, c = 0; c < n.length; c++) {
                                        var u = n[c];
                                        i(e, u) || s(e, u, l(t, u))
                                    }
                                }
                            },
                            8544: function (e, t, n) {
                                var i = n(7293);
                                e.exports = !i((function () {
                                    function e() {}
                                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype
                                }))
                            },
                            4994: function (e, t, n) {
                                "use strict";
                                var i = n(3383).IteratorPrototype,
                                    r = n(30),
                                    o = n(9114),
                                    a = n(8003),
                                    s = n(7497),
                                    l = function () {
                                        return this
                                    };
                                e.exports = function (e, t, n) {
                                    var c = t + " Iterator";
                                    return e.prototype = r(i, {
                                        next: o(1, n)
                                    }), a(e, c, !1, !0), s[c] = l, e
                                }
                            },
                            8880: function (e, t, n) {
                                var i = n(9781),
                                    r = n(3070),
                                    o = n(9114);
                                e.exports = i ? function (e, t, n) {
                                    return r.f(e, t, o(1, n))
                                } : function (e, t, n) {
                                    return e[t] = n, e
                                }
                            },
                            9114: function (e) {
                                e.exports = function (e, t) {
                                    return {
                                        enumerable: !(1 & e),
                                        configurable: !(2 & e),
                                        writable: !(4 & e),
                                        value: t
                                    }
                                }
                            },
                            6135: function (e, t, n) {
                                "use strict";
                                var i = n(7593),
                                    r = n(3070),
                                    o = n(9114);
                                e.exports = function (e, t, n) {
                                    var a = i(t);
                                    a in e ? r.f(e, a, o(0, n)) : e[a] = n
                                }
                            },
                            654: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(4994),
                                    o = n(9518),
                                    a = n(7674),
                                    s = n(8003),
                                    l = n(8880),
                                    c = n(1320),
                                    u = n(5112),
                                    d = n(1913),
                                    h = n(7497),
                                    f = n(3383),
                                    p = f.IteratorPrototype,
                                    g = f.BUGGY_SAFARI_ITERATORS,
                                    m = u("iterator"),
                                    v = "keys",
                                    b = "values",
                                    y = "entries",
                                    _ = function () {
                                        return this
                                    };
                                e.exports = function (e, t, n, u, f, x, w) {
                                    r(n, t, u);
                                    var E, k, O, S = function (e) {
                                            if (e === f && P) return P;
                                            if (!g && e in M) return M[e];
                                            switch (e) {
                                                case v:
                                                case b:
                                                case y:
                                                    return function () {
                                                        return new n(this, e)
                                                    }
                                            }
                                            return function () {
                                                return new n(this)
                                            }
                                        },
                                        C = t + " Iterator",
                                        A = !1,
                                        M = e.prototype,
                                        T = M[m] || M["@@iterator"] || f && M[f],
                                        P = !g && T || S(f),
                                        D = "Array" == t && M.entries || T;
                                    if (D && (E = o(D.call(new e)), p !== Object.prototype && E.next && (d || o(E) === p || (a ? a(E, p) : "function" != typeof E[m] && l(E, m, _)), s(E, C, !0, !0), d && (h[C] = _))), f == b && T && T.name !== b && (A = !0, P = function () {
                                            return T.call(this)
                                        }), d && !w || M[m] === P || l(M, m, P), h[t] = P, f)
                                        if (k = {
                                                values: S(b),
                                                keys: x ? P : S(v),
                                                entries: S(y)
                                            }, w)
                                            for (O in k)(g || A || !(O in M)) && c(M, O, k[O]);
                                        else i({
                                            target: t,
                                            proto: !0,
                                            forced: g || A
                                        }, k);
                                    return k
                                }
                            },
                            9781: function (e, t, n) {
                                var i = n(7293);
                                e.exports = !i((function () {
                                    return 7 != Object.defineProperty({}, 1, {
                                        get: function () {
                                            return 7
                                        }
                                    })[1]
                                }))
                            },
                            317: function (e, t, n) {
                                var i = n(7854),
                                    r = n(111),
                                    o = i.document,
                                    a = r(o) && r(o.createElement);
                                e.exports = function (e) {
                                    return a ? o.createElement(e) : {}
                                }
                            },
                            8324: function (e) {
                                e.exports = {
                                    CSSRuleList: 0,
                                    CSSStyleDeclaration: 0,
                                    CSSValueList: 0,
                                    ClientRectList: 0,
                                    DOMRectList: 0,
                                    DOMStringList: 0,
                                    DOMTokenList: 1,
                                    DataTransferItemList: 0,
                                    FileList: 0,
                                    HTMLAllCollection: 0,
                                    HTMLCollection: 0,
                                    HTMLFormElement: 0,
                                    HTMLSelectElement: 0,
                                    MediaList: 0,
                                    MimeTypeArray: 0,
                                    NamedNodeMap: 0,
                                    NodeList: 1,
                                    PaintRequestList: 0,
                                    Plugin: 0,
                                    PluginArray: 0,
                                    SVGLengthList: 0,
                                    SVGNumberList: 0,
                                    SVGPathSegList: 0,
                                    SVGPointList: 0,
                                    SVGStringList: 0,
                                    SVGTransformList: 0,
                                    SourceBufferList: 0,
                                    StyleSheetList: 0,
                                    TextTrackCueList: 0,
                                    TextTrackList: 0,
                                    TouchList: 0
                                }
                            },
                            8113: function (e, t, n) {
                                var i = n(5005);
                                e.exports = i("navigator", "userAgent") || ""
                            },
                            7392: function (e, t, n) {
                                var i, r, o = n(7854),
                                    a = n(8113),
                                    s = o.process,
                                    l = s && s.versions,
                                    c = l && l.v8;
                                c ? r = (i = c.split("."))[0] + i[1] : a && (!(i = a.match(/Edge\/(\d+)/)) || i[1] >= 74) && (i = a.match(/Chrome\/(\d+)/)) && (r = i[1]), e.exports = r && +r
                            },
                            748: function (e) {
                                e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
                            },
                            2109: function (e, t, n) {
                                var i = n(7854),
                                    r = n(1236).f,
                                    o = n(8880),
                                    a = n(1320),
                                    s = n(3505),
                                    l = n(9920),
                                    c = n(4705);
                                e.exports = function (e, t) {
                                    var n, u, d, h, f, p = e.target,
                                        g = e.global,
                                        m = e.stat;
                                    if (n = g ? i : m ? i[p] || s(p, {}) : (i[p] || {}).prototype)
                                        for (u in t) {
                                            if (h = t[u], d = e.noTargetGet ? (f = r(n, u)) && f.value : n[u], !c(g ? u : p + (m ? "." : "#") + u, e.forced) && void 0 !== d) {
                                                if (typeof h == typeof d) continue;
                                                l(h, d)
                                            }(e.sham || d && d.sham) && o(h, "sham", !0), a(n, u, h, e)
                                        }
                                }
                            },
                            7293: function (e) {
                                e.exports = function (e) {
                                    try {
                                        return !!e()
                                    } catch (e) {
                                        return !0
                                    }
                                }
                            },
                            7007: function (e, t, n) {
                                "use strict";
                                n(4916);
                                var i = n(1320),
                                    r = n(7293),
                                    o = n(5112),
                                    a = n(2261),
                                    s = n(8880),
                                    l = o("species"),
                                    c = !r((function () {
                                        var e = /./;
                                        return e.exec = function () {
                                            var e = [];
                                            return e.groups = {
                                                a: "7"
                                            }, e
                                        }, "7" !== "".replace(e, "$<a>")
                                    })),
                                    u = "$0" === "a".replace(/./, "$0"),
                                    d = o("replace"),
                                    h = !!/./ [d] && "" === /./ [d]("a", "$0"),
                                    f = !r((function () {
                                        var e = /(?:)/,
                                            t = e.exec;
                                        e.exec = function () {
                                            return t.apply(this, arguments)
                                        };
                                        var n = "ab".split(e);
                                        return 2 !== n.length || "a" !== n[0] || "b" !== n[1]
                                    }));
                                e.exports = function (e, t, n, d) {
                                    var p = o(e),
                                        g = !r((function () {
                                            var t = {};
                                            return t[p] = function () {
                                                return 7
                                            }, 7 != "" [e](t)
                                        })),
                                        m = g && !r((function () {
                                            var t = !1,
                                                n = /a/;
                                            return "split" === e && ((n = {}).constructor = {}, n.constructor[l] = function () {
                                                return n
                                            }, n.flags = "", n[p] = /./ [p]), n.exec = function () {
                                                return t = !0, null
                                            }, n[p](""), !t
                                        }));
                                    if (!g || !m || "replace" === e && (!c || !u || h) || "split" === e && !f) {
                                        var v = /./ [p],
                                            b = n(p, "" [e], (function (e, t, n, i, r) {
                                                return t.exec === a ? g && !r ? {
                                                    done: !0,
                                                    value: v.call(t, n, i)
                                                } : {
                                                    done: !0,
                                                    value: e.call(n, t, i)
                                                } : {
                                                    done: !1
                                                }
                                            }), {
                                                REPLACE_KEEPS_$0: u,
                                                REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: h
                                            }),
                                            y = b[0],
                                            _ = b[1];
                                        i(String.prototype, e, y), i(RegExp.prototype, p, 2 == t ? function (e, t) {
                                            return _.call(e, this, t)
                                        } : function (e) {
                                            return _.call(e, this)
                                        })
                                    }
                                    d && s(RegExp.prototype[p], "sham", !0)
                                }
                            },
                            9974: function (e, t, n) {
                                var i = n(3099);
                                e.exports = function (e, t, n) {
                                    if (i(e), void 0 === t) return e;
                                    switch (n) {
                                        case 0:
                                            return function () {
                                                return e.call(t)
                                            };
                                        case 1:
                                            return function (n) {
                                                return e.call(t, n)
                                            };
                                        case 2:
                                            return function (n, i) {
                                                return e.call(t, n, i)
                                            };
                                        case 3:
                                            return function (n, i, r) {
                                                return e.call(t, n, i, r)
                                            }
                                    }
                                    return function () {
                                        return e.apply(t, arguments)
                                    }
                                }
                            },
                            5005: function (e, t, n) {
                                var i = n(857),
                                    r = n(7854),
                                    o = function (e) {
                                        return "function" == typeof e ? e : void 0
                                    };
                                e.exports = function (e, t) {
                                    return arguments.length < 2 ? o(i[e]) || o(r[e]) : i[e] && i[e][t] || r[e] && r[e][t]
                                }
                            },
                            1246: function (e, t, n) {
                                var i = n(648),
                                    r = n(7497),
                                    o = n(5112)("iterator");
                                e.exports = function (e) {
                                    if (null != e) return e[o] || e["@@iterator"] || r[i(e)]
                                }
                            },
                            8554: function (e, t, n) {
                                var i = n(9670),
                                    r = n(1246);
                                e.exports = function (e) {
                                    var t = r(e);
                                    if ("function" != typeof t) throw TypeError(String(e) + " is not iterable");
                                    return i(t.call(e))
                                }
                            },
                            647: function (e, t, n) {
                                var i = n(7908),
                                    r = Math.floor,
                                    o = "".replace,
                                    a = /\$([$&'`]|\d\d?|<[^>]*>)/g,
                                    s = /\$([$&'`]|\d\d?)/g;
                                e.exports = function (e, t, n, l, c, u) {
                                    var d = n + e.length,
                                        h = l.length,
                                        f = s;
                                    return void 0 !== c && (c = i(c), f = a), o.call(u, f, (function (i, o) {
                                        var a;
                                        switch (o.charAt(0)) {
                                            case "$":
                                                return "$";
                                            case "&":
                                                return e;
                                            case "`":
                                                return t.slice(0, n);
                                            case "'":
                                                return t.slice(d);
                                            case "<":
                                                a = c[o.slice(1, -1)];
                                                break;
                                            default:
                                                var s = +o;
                                                if (0 === s) return i;
                                                if (s > h) {
                                                    var u = r(s / 10);
                                                    return 0 === u ? i : u <= h ? void 0 === l[u - 1] ? o.charAt(1) : l[u - 1] + o.charAt(1) : i
                                                }
                                                a = l[s - 1]
                                        }
                                        return void 0 === a ? "" : a
                                    }))
                                }
                            },
                            7854: function (e, t, n) {
                                var i = function (e) {
                                    return e && e.Math == Math && e
                                };
                                e.exports = i("object" == typeof globalThis && globalThis) || i("object" == typeof window && window) || i("object" == typeof self && self) || i("object" == typeof n.g && n.g) || function () {
                                    return this
                                }() || Function("return this")()
                            },
                            6656: function (e) {
                                var t = {}.hasOwnProperty;
                                e.exports = function (e, n) {
                                    return t.call(e, n)
                                }
                            },
                            3501: function (e) {
                                e.exports = {}
                            },
                            490: function (e, t, n) {
                                var i = n(5005);
                                e.exports = i("document", "documentElement")
                            },
                            4664: function (e, t, n) {
                                var i = n(9781),
                                    r = n(7293),
                                    o = n(317);
                                e.exports = !i && !r((function () {
                                    return 7 != Object.defineProperty(o("div"), "a", {
                                        get: function () {
                                            return 7
                                        }
                                    }).a
                                }))
                            },
                            1179: function (e) {
                                var t = Math.abs,
                                    n = Math.pow,
                                    i = Math.floor,
                                    r = Math.log,
                                    o = Math.LN2;
                                e.exports = {
                                    pack: function (e, a, s) {
                                        var l, c, u, d = new Array(s),
                                            h = 8 * s - a - 1,
                                            f = (1 << h) - 1,
                                            p = f >> 1,
                                            g = 23 === a ? n(2, -24) - n(2, -77) : 0,
                                            m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0,
                                            v = 0;
                                        for ((e = t(e)) != e || e === 1 / 0 ? (c = e != e ? 1 : 0, l = f) : (l = i(r(e) / o), e * (u = n(2, -l)) < 1 && (l--, u *= 2), (e += l + p >= 1 ? g / u : g * n(2, 1 - p)) * u >= 2 && (l++, u /= 2), l + p >= f ? (c = 0, l = f) : l + p >= 1 ? (c = (e * u - 1) * n(2, a), l += p) : (c = e * n(2, p - 1) * n(2, a), l = 0)); a >= 8; d[v++] = 255 & c, c /= 256, a -= 8);
                                        for (l = l << a | c, h += a; h > 0; d[v++] = 255 & l, l /= 256, h -= 8);
                                        return d[--v] |= 128 * m, d
                                    },
                                    unpack: function (e, t) {
                                        var i, r = e.length,
                                            o = 8 * r - t - 1,
                                            a = (1 << o) - 1,
                                            s = a >> 1,
                                            l = o - 7,
                                            c = r - 1,
                                            u = e[c--],
                                            d = 127 & u;
                                        for (u >>= 7; l > 0; d = 256 * d + e[c], c--, l -= 8);
                                        for (i = d & (1 << -l) - 1, d >>= -l, l += t; l > 0; i = 256 * i + e[c], c--, l -= 8);
                                        if (0 === d) d = 1 - s;
                                        else {
                                            if (d === a) return i ? NaN : u ? -1 / 0 : 1 / 0;
                                            i += n(2, t), d -= s
                                        }
                                        return (u ? -1 : 1) * i * n(2, d - t)
                                    }
                                }
                            },
                            8361: function (e, t, n) {
                                var i = n(7293),
                                    r = n(4326),
                                    o = "".split;
                                e.exports = i((function () {
                                    return !Object("z").propertyIsEnumerable(0)
                                })) ? function (e) {
                                    return "String" == r(e) ? o.call(e, "") : Object(e)
                                } : Object
                            },
                            9587: function (e, t, n) {
                                var i = n(111),
                                    r = n(7674);
                                e.exports = function (e, t, n) {
                                    var o, a;
                                    return r && "function" == typeof (o = t.constructor) && o !== n && i(a = o.prototype) && a !== n.prototype && r(e, a), e
                                }
                            },
                            2788: function (e, t, n) {
                                var i = n(5465),
                                    r = Function.toString;
                                "function" != typeof i.inspectSource && (i.inspectSource = function (e) {
                                    return r.call(e)
                                }), e.exports = i.inspectSource
                            },
                            9909: function (e, t, n) {
                                var i, r, o, a = n(8536),
                                    s = n(7854),
                                    l = n(111),
                                    c = n(8880),
                                    u = n(6656),
                                    d = n(5465),
                                    h = n(6200),
                                    f = n(3501),
                                    p = s.WeakMap;
                                if (a) {
                                    var g = d.state || (d.state = new p),
                                        m = g.get,
                                        v = g.has,
                                        b = g.set;
                                    i = function (e, t) {
                                        return t.facade = e, b.call(g, e, t), t
                                    }, r = function (e) {
                                        return m.call(g, e) || {}
                                    }, o = function (e) {
                                        return v.call(g, e)
                                    }
                                } else {
                                    var y = h("state");
                                    f[y] = !0, i = function (e, t) {
                                        return t.facade = e, c(e, y, t), t
                                    }, r = function (e) {
                                        return u(e, y) ? e[y] : {}
                                    }, o = function (e) {
                                        return u(e, y)
                                    }
                                }
                                e.exports = {
                                    set: i,
                                    get: r,
                                    has: o,
                                    enforce: function (e) {
                                        return o(e) ? r(e) : i(e, {})
                                    },
                                    getterFor: function (e) {
                                        return function (t) {
                                            var n;
                                            if (!l(t) || (n = r(t)).type !== e) throw TypeError("Incompatible receiver, " + e + " required");
                                            return n
                                        }
                                    }
                                }
                            },
                            7659: function (e, t, n) {
                                var i = n(5112),
                                    r = n(7497),
                                    o = i("iterator"),
                                    a = Array.prototype;
                                e.exports = function (e) {
                                    return void 0 !== e && (r.Array === e || a[o] === e)
                                }
                            },
                            3157: function (e, t, n) {
                                var i = n(4326);
                                e.exports = Array.isArray || function (e) {
                                    return "Array" == i(e)
                                }
                            },
                            4705: function (e, t, n) {
                                var i = n(7293),
                                    r = /#|\.prototype\./,
                                    o = function (e, t) {
                                        var n = s[a(e)];
                                        return n == c || n != l && ("function" == typeof t ? i(t) : !!t)
                                    },
                                    a = o.normalize = function (e) {
                                        return String(e).replace(r, ".").toLowerCase()
                                    },
                                    s = o.data = {},
                                    l = o.NATIVE = "N",
                                    c = o.POLYFILL = "P";
                                e.exports = o
                            },
                            111: function (e) {
                                e.exports = function (e) {
                                    return "object" == typeof e ? null !== e : "function" == typeof e
                                }
                            },
                            1913: function (e) {
                                e.exports = !1
                            },
                            7850: function (e, t, n) {
                                var i = n(111),
                                    r = n(4326),
                                    o = n(5112)("match");
                                e.exports = function (e) {
                                    var t;
                                    return i(e) && (void 0 !== (t = e[o]) ? !!t : "RegExp" == r(e))
                                }
                            },
                            9212: function (e, t, n) {
                                var i = n(9670);
                                e.exports = function (e) {
                                    var t = e.return;
                                    if (void 0 !== t) return i(t.call(e)).value
                                }
                            },
                            3383: function (e, t, n) {
                                "use strict";
                                var i, r, o, a = n(7293),
                                    s = n(9518),
                                    l = n(8880),
                                    c = n(6656),
                                    u = n(5112),
                                    d = n(1913),
                                    h = u("iterator"),
                                    f = !1;
                                [].keys && ("next" in (o = [].keys()) ? (r = s(s(o))) !== Object.prototype && (i = r) : f = !0);
                                var p = null == i || a((function () {
                                    var e = {};
                                    return i[h].call(e) !== e
                                }));
                                p && (i = {}), d && !p || c(i, h) || l(i, h, (function () {
                                    return this
                                })), e.exports = {
                                    IteratorPrototype: i,
                                    BUGGY_SAFARI_ITERATORS: f
                                }
                            },
                            7497: function (e) {
                                e.exports = {}
                            },
                            133: function (e, t, n) {
                                var i = n(7293);
                                e.exports = !!Object.getOwnPropertySymbols && !i((function () {
                                    return !String(Symbol())
                                }))
                            },
                            590: function (e, t, n) {
                                var i = n(7293),
                                    r = n(5112),
                                    o = n(1913),
                                    a = r("iterator");
                                e.exports = !i((function () {
                                    var e = new URL("b?a=1&b=2&c=3", "http://a"),
                                        t = e.searchParams,
                                        n = "";
                                    return e.pathname = "c%20d", t.forEach((function (e, i) {
                                        t.delete("b"), n += i + e
                                    })), o && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host
                                }))
                            },
                            8536: function (e, t, n) {
                                var i = n(7854),
                                    r = n(2788),
                                    o = i.WeakMap;
                                e.exports = "function" == typeof o && /native code/.test(r(o))
                            },
                            1574: function (e, t, n) {
                                "use strict";
                                var i = n(9781),
                                    r = n(7293),
                                    o = n(1956),
                                    a = n(5181),
                                    s = n(5296),
                                    l = n(7908),
                                    c = n(8361),
                                    u = Object.assign,
                                    d = Object.defineProperty;
                                e.exports = !u || r((function () {
                                    if (i && 1 !== u({
                                            b: 1
                                        }, u(d({}, "a", {
                                            enumerable: !0,
                                            get: function () {
                                                d(this, "b", {
                                                    value: 3,
                                                    enumerable: !1
                                                })
                                            }
                                        }), {
                                            b: 2
                                        })).b) return !0;
                                    var e = {},
                                        t = {},
                                        n = Symbol(),
                                        r = "abcdefghijklmnopqrst";
                                    return e[n] = 7, r.split("").forEach((function (e) {
                                        t[e] = e
                                    })), 7 != u({}, e)[n] || o(u({}, t)).join("") != r
                                })) ? function (e, t) {
                                    for (var n = l(e), r = arguments.length, u = 1, d = a.f, h = s.f; r > u;)
                                        for (var f, p = c(arguments[u++]), g = d ? o(p).concat(d(p)) : o(p), m = g.length, v = 0; m > v;) f = g[v++], i && !h.call(p, f) || (n[f] = p[f]);
                                    return n
                                } : u
                            },
                            30: function (e, t, n) {
                                var i, r = n(9670),
                                    o = n(6048),
                                    a = n(748),
                                    s = n(3501),
                                    l = n(490),
                                    c = n(317),
                                    u = n(6200),
                                    d = u("IE_PROTO"),
                                    h = function () {},
                                    f = function (e) {
                                        return "<script>" + e + "<\/script>"
                                    },
                                    p = function () {
                                        try {
                                            i = document.domain && new ActiveXObject("htmlfile")
                                        } catch (e) {}
                                        var e, t;
                                        p = i ? function (e) {
                                            e.write(f("")), e.close();
                                            var t = e.parentWindow.Object;
                                            return e = null, t
                                        }(i) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(f("document.F=Object")), e.close(), e.F);
                                        for (var n = a.length; n--;) delete p.prototype[a[n]];
                                        return p()
                                    };
                                s[d] = !0, e.exports = Object.create || function (e, t) {
                                    var n;
                                    return null !== e ? (h.prototype = r(e), n = new h, h.prototype = null, n[d] = e) : n = p(), void 0 === t ? n : o(n, t)
                                }
                            },
                            6048: function (e, t, n) {
                                var i = n(9781),
                                    r = n(3070),
                                    o = n(9670),
                                    a = n(1956);
                                e.exports = i ? Object.defineProperties : function (e, t) {
                                    o(e);
                                    for (var n, i = a(t), s = i.length, l = 0; s > l;) r.f(e, n = i[l++], t[n]);
                                    return e
                                }
                            },
                            3070: function (e, t, n) {
                                var i = n(9781),
                                    r = n(4664),
                                    o = n(9670),
                                    a = n(7593),
                                    s = Object.defineProperty;
                                t.f = i ? s : function (e, t, n) {
                                    if (o(e), t = a(t, !0), o(n), r) try {
                                        return s(e, t, n)
                                    } catch (e) {}
                                    if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
                                    return "value" in n && (e[t] = n.value), e
                                }
                            },
                            1236: function (e, t, n) {
                                var i = n(9781),
                                    r = n(5296),
                                    o = n(9114),
                                    a = n(5656),
                                    s = n(7593),
                                    l = n(6656),
                                    c = n(4664),
                                    u = Object.getOwnPropertyDescriptor;
                                t.f = i ? u : function (e, t) {
                                    if (e = a(e), t = s(t, !0), c) try {
                                        return u(e, t)
                                    } catch (e) {}
                                    if (l(e, t)) return o(!r.f.call(e, t), e[t])
                                }
                            },
                            8006: function (e, t, n) {
                                var i = n(6324),
                                    r = n(748).concat("length", "prototype");
                                t.f = Object.getOwnPropertyNames || function (e) {
                                    return i(e, r)
                                }
                            },
                            5181: function (e, t) {
                                t.f = Object.getOwnPropertySymbols
                            },
                            9518: function (e, t, n) {
                                var i = n(6656),
                                    r = n(7908),
                                    o = n(6200),
                                    a = n(8544),
                                    s = o("IE_PROTO"),
                                    l = Object.prototype;
                                e.exports = a ? Object.getPrototypeOf : function (e) {
                                    return e = r(e), i(e, s) ? e[s] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? l : null
                                }
                            },
                            6324: function (e, t, n) {
                                var i = n(6656),
                                    r = n(5656),
                                    o = n(1318).indexOf,
                                    a = n(3501);
                                e.exports = function (e, t) {
                                    var n, s = r(e),
                                        l = 0,
                                        c = [];
                                    for (n in s) !i(a, n) && i(s, n) && c.push(n);
                                    for (; t.length > l;) i(s, n = t[l++]) && (~o(c, n) || c.push(n));
                                    return c
                                }
                            },
                            1956: function (e, t, n) {
                                var i = n(6324),
                                    r = n(748);
                                e.exports = Object.keys || function (e) {
                                    return i(e, r)
                                }
                            },
                            5296: function (e, t) {
                                "use strict";
                                var n = {}.propertyIsEnumerable,
                                    i = Object.getOwnPropertyDescriptor,
                                    r = i && !n.call({
                                        1: 2
                                    }, 1);
                                t.f = r ? function (e) {
                                    var t = i(this, e);
                                    return !!t && t.enumerable
                                } : n
                            },
                            7674: function (e, t, n) {
                                var i = n(9670),
                                    r = n(6077);
                                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
                                    var e, t = !1,
                                        n = {};
                                    try {
                                        (e = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(n, []), t = n instanceof Array
                                    } catch (e) {}
                                    return function (n, o) {
                                        return i(n), r(o), t ? e.call(n, o) : n.__proto__ = o, n
                                    }
                                }() : void 0)
                            },
                            288: function (e, t, n) {
                                "use strict";
                                var i = n(1694),
                                    r = n(648);
                                e.exports = i ? {}.toString : function () {
                                    return "[object " + r(this) + "]"
                                }
                            },
                            3887: function (e, t, n) {
                                var i = n(5005),
                                    r = n(8006),
                                    o = n(5181),
                                    a = n(9670);
                                e.exports = i("Reflect", "ownKeys") || function (e) {
                                    var t = r.f(a(e)),
                                        n = o.f;
                                    return n ? t.concat(n(e)) : t
                                }
                            },
                            857: function (e, t, n) {
                                var i = n(7854);
                                e.exports = i
                            },
                            2248: function (e, t, n) {
                                var i = n(1320);
                                e.exports = function (e, t, n) {
                                    for (var r in t) i(e, r, t[r], n);
                                    return e
                                }
                            },
                            1320: function (e, t, n) {
                                var i = n(7854),
                                    r = n(8880),
                                    o = n(6656),
                                    a = n(3505),
                                    s = n(2788),
                                    l = n(9909),
                                    c = l.get,
                                    u = l.enforce,
                                    d = String(String).split("String");
                                (e.exports = function (e, t, n, s) {
                                    var l, c = !!s && !!s.unsafe,
                                        h = !!s && !!s.enumerable,
                                        f = !!s && !!s.noTargetGet;
                                    "function" == typeof n && ("string" != typeof t || o(n, "name") || r(n, "name", t), (l = u(n)).source || (l.source = d.join("string" == typeof t ? t : ""))), e !== i ? (c ? !f && e[t] && (h = !0) : delete e[t], h ? e[t] = n : r(e, t, n)) : h ? e[t] = n : a(t, n)
                                })(Function.prototype, "toString", (function () {
                                    return "function" == typeof this && c(this).source || s(this)
                                }))
                            },
                            7651: function (e, t, n) {
                                var i = n(4326),
                                    r = n(2261);
                                e.exports = function (e, t) {
                                    var n = e.exec;
                                    if ("function" == typeof n) {
                                        var o = n.call(e, t);
                                        if ("object" != typeof o) throw TypeError("RegExp exec method returned something other than an Object or null");
                                        return o
                                    }
                                    if ("RegExp" !== i(e)) throw TypeError("RegExp#exec called on incompatible receiver");
                                    return r.call(e, t)
                                }
                            },
                            2261: function (e, t, n) {
                                "use strict";
                                var i, r, o = n(7066),
                                    a = n(2999),
                                    s = RegExp.prototype.exec,
                                    l = String.prototype.replace,
                                    c = s,
                                    u = (i = /a/, r = /b*/g, s.call(i, "a"), s.call(r, "a"), 0 !== i.lastIndex || 0 !== r.lastIndex),
                                    d = a.UNSUPPORTED_Y || a.BROKEN_CARET,
                                    h = void 0 !== /()??/.exec("")[1];
                                (u || h || d) && (c = function (e) {
                                    var t, n, i, r, a = this,
                                        c = d && a.sticky,
                                        f = o.call(a),
                                        p = a.source,
                                        g = 0,
                                        m = e;
                                    return c && (-1 === (f = f.replace("y", "")).indexOf("g") && (f += "g"), m = String(e).slice(a.lastIndex), a.lastIndex > 0 && (!a.multiline || a.multiline && "\n" !== e[a.lastIndex - 1]) && (p = "(?: " + p + ")", m = " " + m, g++), n = new RegExp("^(?:" + p + ")", f)), h && (n = new RegExp("^" + p + "$(?!\\s)", f)), u && (t = a.lastIndex), i = s.call(c ? n : a, m), c ? i ? (i.input = i.input.slice(g), i[0] = i[0].slice(g), i.index = a.lastIndex, a.lastIndex += i[0].length) : a.lastIndex = 0 : u && i && (a.lastIndex = a.global ? i.index + i[0].length : t), h && i && i.length > 1 && l.call(i[0], n, (function () {
                                        for (r = 1; r < arguments.length - 2; r++) void 0 === arguments[r] && (i[r] = void 0)
                                    })), i
                                }), e.exports = c
                            },
                            7066: function (e, t, n) {
                                "use strict";
                                var i = n(9670);
                                e.exports = function () {
                                    var e = i(this),
                                        t = "";
                                    return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t
                                }
                            },
                            2999: function (e, t, n) {
                                "use strict";
                                var i = n(7293);

                                function r(e, t) {
                                    return RegExp(e, t)
                                }
                                t.UNSUPPORTED_Y = i((function () {
                                    var e = r("a", "y");
                                    return e.lastIndex = 2, null != e.exec("abcd")
                                })), t.BROKEN_CARET = i((function () {
                                    var e = r("^r", "gy");
                                    return e.lastIndex = 2, null != e.exec("str")
                                }))
                            },
                            4488: function (e) {
                                e.exports = function (e) {
                                    if (null == e) throw TypeError("Can't call method on " + e);
                                    return e
                                }
                            },
                            3505: function (e, t, n) {
                                var i = n(7854),
                                    r = n(8880);
                                e.exports = function (e, t) {
                                    try {
                                        r(i, e, t)
                                    } catch (n) {
                                        i[e] = t
                                    }
                                    return t
                                }
                            },
                            6340: function (e, t, n) {
                                "use strict";
                                var i = n(5005),
                                    r = n(3070),
                                    o = n(5112),
                                    a = n(9781),
                                    s = o("species");
                                e.exports = function (e) {
                                    var t = i(e),
                                        n = r.f;
                                    a && t && !t[s] && n(t, s, {
                                        configurable: !0,
                                        get: function () {
                                            return this
                                        }
                                    })
                                }
                            },
                            8003: function (e, t, n) {
                                var i = n(3070).f,
                                    r = n(6656),
                                    o = n(5112)("toStringTag");
                                e.exports = function (e, t, n) {
                                    e && !r(e = n ? e : e.prototype, o) && i(e, o, {
                                        configurable: !0,
                                        value: t
                                    })
                                }
                            },
                            6200: function (e, t, n) {
                                var i = n(2309),
                                    r = n(9711),
                                    o = i("keys");
                                e.exports = function (e) {
                                    return o[e] || (o[e] = r(e))
                                }
                            },
                            5465: function (e, t, n) {
                                var i = n(7854),
                                    r = n(3505),
                                    o = "__core-js_shared__",
                                    a = i[o] || r(o, {});
                                e.exports = a
                            },
                            2309: function (e, t, n) {
                                var i = n(1913),
                                    r = n(5465);
                                (e.exports = function (e, t) {
                                    return r[e] || (r[e] = void 0 !== t ? t : {})
                                })("versions", []).push({
                                    version: "3.9.0",
                                    mode: i ? "pure" : "global",
                                    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
                                })
                            },
                            6707: function (e, t, n) {
                                var i = n(9670),
                                    r = n(3099),
                                    o = n(5112)("species");
                                e.exports = function (e, t) {
                                    var n, a = i(e).constructor;
                                    return void 0 === a || null == (n = i(a)[o]) ? t : r(n)
                                }
                            },
                            8710: function (e, t, n) {
                                var i = n(9958),
                                    r = n(4488),
                                    o = function (e) {
                                        return function (t, n) {
                                            var o, a, s = String(r(t)),
                                                l = i(n),
                                                c = s.length;
                                            return l < 0 || l >= c ? e ? "" : void 0 : (o = s.charCodeAt(l)) < 55296 || o > 56319 || l + 1 === c || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? e ? s.charAt(l) : o : e ? s.slice(l, l + 2) : a - 56320 + (o - 55296 << 10) + 65536
                                        }
                                    };
                                e.exports = {
                                    codeAt: o(!1),
                                    charAt: o(!0)
                                }
                            },
                            3197: function (e) {
                                "use strict";
                                var t = 2147483647,
                                    n = /[^\0-\u007E]/,
                                    i = /[.\u3002\uFF0E\uFF61]/g,
                                    r = "Overflow: input needs wider integers to process",
                                    o = Math.floor,
                                    a = String.fromCharCode,
                                    s = function (e) {
                                        return e + 22 + 75 * (e < 26)
                                    },
                                    l = function (e, t, n) {
                                        var i = 0;
                                        for (e = n ? o(e / 700) : e >> 1, e += o(e / t); e > 455; i += 36) e = o(e / 35);
                                        return o(i + 36 * e / (e + 38))
                                    },
                                    c = function (e) {
                                        var n = [];
                                        e = function (e) {
                                            for (var t = [], n = 0, i = e.length; n < i;) {
                                                var r = e.charCodeAt(n++);
                                                if (r >= 55296 && r <= 56319 && n < i) {
                                                    var o = e.charCodeAt(n++);
                                                    56320 == (64512 & o) ? t.push(((1023 & r) << 10) + (1023 & o) + 65536) : (t.push(r), n--)
                                                } else t.push(r)
                                            }
                                            return t
                                        }(e);
                                        var i, c, u = e.length,
                                            d = 128,
                                            h = 0,
                                            f = 72;
                                        for (i = 0; i < e.length; i++)(c = e[i]) < 128 && n.push(a(c));
                                        var p = n.length,
                                            g = p;
                                        for (p && n.push("-"); g < u;) {
                                            var m = t;
                                            for (i = 0; i < e.length; i++)(c = e[i]) >= d && c < m && (m = c);
                                            var v = g + 1;
                                            if (m - d > o((t - h) / v)) throw RangeError(r);
                                            for (h += (m - d) * v, d = m, i = 0; i < e.length; i++) {
                                                if ((c = e[i]) < d && ++h > t) throw RangeError(r);
                                                if (c == d) {
                                                    for (var b = h, y = 36;; y += 36) {
                                                        var _ = y <= f ? 1 : y >= f + 26 ? 26 : y - f;
                                                        if (b < _) break;
                                                        var x = b - _,
                                                            w = 36 - _;
                                                        n.push(a(s(_ + x % w))), b = o(x / w)
                                                    }
                                                    n.push(a(s(b))), f = l(h, v, g == p), h = 0, ++g
                                                }
                                            }++h, ++d
                                        }
                                        return n.join("")
                                    };
                                e.exports = function (e) {
                                    var t, r, o = [],
                                        a = e.toLowerCase().replace(i, ".").split(".");
                                    for (t = 0; t < a.length; t++) r = a[t], o.push(n.test(r) ? "xn--" + c(r) : r);
                                    return o.join(".")
                                }
                            },
                            6091: function (e, t, n) {
                                var i = n(7293),
                                    r = n(1361);
                                e.exports = function (e) {
                                    return i((function () {
                                        return !!r[e]() || "​᠎" != "​᠎" [e]() || r[e].name !== e
                                    }))
                                }
                            },
                            3111: function (e, t, n) {
                                var i = n(4488),
                                    r = "[" + n(1361) + "]",
                                    o = RegExp("^" + r + r + "*"),
                                    a = RegExp(r + r + "*$"),
                                    s = function (e) {
                                        return function (t) {
                                            var n = String(i(t));
                                            return 1 & e && (n = n.replace(o, "")), 2 & e && (n = n.replace(a, "")), n
                                        }
                                    };
                                e.exports = {
                                    start: s(1),
                                    end: s(2),
                                    trim: s(3)
                                }
                            },
                            1400: function (e, t, n) {
                                var i = n(9958),
                                    r = Math.max,
                                    o = Math.min;
                                e.exports = function (e, t) {
                                    var n = i(e);
                                    return n < 0 ? r(n + t, 0) : o(n, t)
                                }
                            },
                            7067: function (e, t, n) {
                                var i = n(9958),
                                    r = n(7466);
                                e.exports = function (e) {
                                    if (void 0 === e) return 0;
                                    var t = i(e),
                                        n = r(t);
                                    if (t !== n) throw RangeError("Wrong length or index");
                                    return n
                                }
                            },
                            5656: function (e, t, n) {
                                var i = n(8361),
                                    r = n(4488);
                                e.exports = function (e) {
                                    return i(r(e))
                                }
                            },
                            9958: function (e) {
                                var t = Math.ceil,
                                    n = Math.floor;
                                e.exports = function (e) {
                                    return isNaN(e = +e) ? 0 : (e > 0 ? n : t)(e)
                                }
                            },
                            7466: function (e, t, n) {
                                var i = n(9958),
                                    r = Math.min;
                                e.exports = function (e) {
                                    return e > 0 ? r(i(e), 9007199254740991) : 0
                                }
                            },
                            7908: function (e, t, n) {
                                var i = n(4488);
                                e.exports = function (e) {
                                    return Object(i(e))
                                }
                            },
                            4590: function (e, t, n) {
                                var i = n(3002);
                                e.exports = function (e, t) {
                                    var n = i(e);
                                    if (n % t) throw RangeError("Wrong offset");
                                    return n
                                }
                            },
                            3002: function (e, t, n) {
                                var i = n(9958);
                                e.exports = function (e) {
                                    var t = i(e);
                                    if (t < 0) throw RangeError("The argument can't be less than 0");
                                    return t
                                }
                            },
                            7593: function (e, t, n) {
                                var i = n(111);
                                e.exports = function (e, t) {
                                    if (!i(e)) return e;
                                    var n, r;
                                    if (t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
                                    if ("function" == typeof (n = e.valueOf) && !i(r = n.call(e))) return r;
                                    if (!t && "function" == typeof (n = e.toString) && !i(r = n.call(e))) return r;
                                    throw TypeError("Can't convert object to primitive value")
                                }
                            },
                            1694: function (e, t, n) {
                                var i = {};
                                i[n(5112)("toStringTag")] = "z", e.exports = "[object z]" === String(i)
                            },
                            9843: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(7854),
                                    o = n(9781),
                                    a = n(3832),
                                    s = n(260),
                                    l = n(3331),
                                    c = n(5787),
                                    u = n(9114),
                                    d = n(8880),
                                    h = n(7466),
                                    f = n(7067),
                                    p = n(4590),
                                    g = n(7593),
                                    m = n(6656),
                                    v = n(648),
                                    b = n(111),
                                    y = n(30),
                                    _ = n(7674),
                                    x = n(8006).f,
                                    w = n(7321),
                                    E = n(2092).forEach,
                                    k = n(6340),
                                    O = n(3070),
                                    S = n(1236),
                                    C = n(9909),
                                    A = n(9587),
                                    M = C.get,
                                    T = C.set,
                                    P = O.f,
                                    D = S.f,
                                    L = Math.round,
                                    N = r.RangeError,
                                    j = l.ArrayBuffer,
                                    I = l.DataView,
                                    R = s.NATIVE_ARRAY_BUFFER_VIEWS,
                                    F = s.TYPED_ARRAY_TAG,
                                    B = s.TypedArray,
                                    q = s.TypedArrayPrototype,
                                    z = s.aTypedArrayConstructor,
                                    H = s.isTypedArray,
                                    U = "BYTES_PER_ELEMENT",
                                    V = "Wrong length",
                                    W = function (e, t) {
                                        for (var n = 0, i = t.length, r = new(z(e))(i); i > n;) r[n] = t[n++];
                                        return r
                                    },
                                    Y = function (e, t) {
                                        P(e, t, {
                                            get: function () {
                                                return M(this)[t]
                                            }
                                        })
                                    },
                                    $ = function (e) {
                                        var t;
                                        return e instanceof j || "ArrayBuffer" == (t = v(e)) || "SharedArrayBuffer" == t
                                    },
                                    K = function (e, t) {
                                        return H(e) && "symbol" != typeof t && t in e && String(+t) == String(t)
                                    },
                                    G = function (e, t) {
                                        return K(e, t = g(t, !0)) ? u(2, e[t]) : D(e, t)
                                    },
                                    X = function (e, t, n) {
                                        return !(K(e, t = g(t, !0)) && b(n) && m(n, "value")) || m(n, "get") || m(n, "set") || n.configurable || m(n, "writable") && !n.writable || m(n, "enumerable") && !n.enumerable ? P(e, t, n) : (e[t] = n.value, e)
                                    };
                                o ? (R || (S.f = G, O.f = X, Y(q, "buffer"), Y(q, "byteOffset"), Y(q, "byteLength"), Y(q, "length")), i({
                                    target: "Object",
                                    stat: !0,
                                    forced: !R
                                }, {
                                    getOwnPropertyDescriptor: G,
                                    defineProperty: X
                                }), e.exports = function (e, t, n) {
                                    var o = e.match(/\d+$/)[0] / 8,
                                        s = e + (n ? "Clamped" : "") + "Array",
                                        l = "get" + e,
                                        u = "set" + e,
                                        g = r[s],
                                        m = g,
                                        v = m && m.prototype,
                                        O = {},
                                        S = function (e, t) {
                                            P(e, t, {
                                                get: function () {
                                                    return function (e, t) {
                                                        var n = M(e);
                                                        return n.view[l](t * o + n.byteOffset, !0)
                                                    }(this, t)
                                                },
                                                set: function (e) {
                                                    return function (e, t, i) {
                                                        var r = M(e);
                                                        n && (i = (i = L(i)) < 0 ? 0 : i > 255 ? 255 : 255 & i), r.view[u](t * o + r.byteOffset, i, !0)
                                                    }(this, t, e)
                                                },
                                                enumerable: !0
                                            })
                                        };
                                    R ? a && (m = t((function (e, t, n, i) {
                                        return c(e, m, s), A(b(t) ? $(t) ? void 0 !== i ? new g(t, p(n, o), i) : void 0 !== n ? new g(t, p(n, o)) : new g(t) : H(t) ? W(m, t) : w.call(m, t) : new g(f(t)), e, m)
                                    })), _ && _(m, B), E(x(g), (function (e) {
                                        e in m || d(m, e, g[e])
                                    })), m.prototype = v) : (m = t((function (e, t, n, i) {
                                        c(e, m, s);
                                        var r, a, l, u = 0,
                                            d = 0;
                                        if (b(t)) {
                                            if (!$(t)) return H(t) ? W(m, t) : w.call(m, t);
                                            r = t, d = p(n, o);
                                            var g = t.byteLength;
                                            if (void 0 === i) {
                                                if (g % o) throw N(V);
                                                if ((a = g - d) < 0) throw N(V)
                                            } else if ((a = h(i) * o) + d > g) throw N(V);
                                            l = a / o
                                        } else l = f(t), r = new j(a = l * o);
                                        for (T(e, {
                                                buffer: r,
                                                byteOffset: d,
                                                byteLength: a,
                                                length: l,
                                                view: new I(r)
                                            }); u < l;) S(e, u++)
                                    })), _ && _(m, B), v = m.prototype = y(q)), v.constructor !== m && d(v, "constructor", m), F && d(v, F, s), O[s] = m, i({
                                        global: !0,
                                        forced: m != g,
                                        sham: !R
                                    }, O), U in m || d(m, U, o), U in v || d(v, U, o), k(s)
                                }) : e.exports = function () {}
                            },
                            3832: function (e, t, n) {
                                var i = n(7854),
                                    r = n(7293),
                                    o = n(7072),
                                    a = n(260).NATIVE_ARRAY_BUFFER_VIEWS,
                                    s = i.ArrayBuffer,
                                    l = i.Int8Array;
                                e.exports = !a || !r((function () {
                                    l(1)
                                })) || !r((function () {
                                    new l(-1)
                                })) || !o((function (e) {
                                    new l, new l(null), new l(1.5), new l(e)
                                }), !0) || r((function () {
                                    return 1 !== new l(new s(2), 1, void 0).length
                                }))
                            },
                            3074: function (e, t, n) {
                                var i = n(260).aTypedArrayConstructor,
                                    r = n(6707);
                                e.exports = function (e, t) {
                                    for (var n = r(e, e.constructor), o = 0, a = t.length, s = new(i(n))(a); a > o;) s[o] = t[o++];
                                    return s
                                }
                            },
                            7321: function (e, t, n) {
                                var i = n(7908),
                                    r = n(7466),
                                    o = n(1246),
                                    a = n(7659),
                                    s = n(9974),
                                    l = n(260).aTypedArrayConstructor;
                                e.exports = function (e) {
                                    var t, n, c, u, d, h, f = i(e),
                                        p = arguments.length,
                                        g = p > 1 ? arguments[1] : void 0,
                                        m = void 0 !== g,
                                        v = o(f);
                                    if (null != v && !a(v))
                                        for (h = (d = v.call(f)).next, f = []; !(u = h.call(d)).done;) f.push(u.value);
                                    for (m && p > 2 && (g = s(g, arguments[2], 2)), n = r(f.length), c = new(l(this))(n), t = 0; n > t; t++) c[t] = m ? g(f[t], t) : f[t];
                                    return c
                                }
                            },
                            9711: function (e) {
                                var t = 0,
                                    n = Math.random();
                                e.exports = function (e) {
                                    return "Symbol(" + String(void 0 === e ? "" : e) + ")_" + (++t + n).toString(36)
                                }
                            },
                            3307: function (e, t, n) {
                                var i = n(133);
                                e.exports = i && !Symbol.sham && "symbol" == typeof Symbol.iterator
                            },
                            5112: function (e, t, n) {
                                var i = n(7854),
                                    r = n(2309),
                                    o = n(6656),
                                    a = n(9711),
                                    s = n(133),
                                    l = n(3307),
                                    c = r("wks"),
                                    u = i.Symbol,
                                    d = l ? u : u && u.withoutSetter || a;
                                e.exports = function (e) {
                                    return o(c, e) || (s && o(u, e) ? c[e] = u[e] : c[e] = d("Symbol." + e)), c[e]
                                }
                            },
                            1361: function (e) {
                                e.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff"
                            },
                            8264: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(7854),
                                    o = n(3331),
                                    a = n(6340),
                                    s = "ArrayBuffer",
                                    l = o.ArrayBuffer;
                                i({
                                    global: !0,
                                    forced: r.ArrayBuffer !== l
                                }, {
                                    ArrayBuffer: l
                                }), a(s)
                            },
                            2222: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(7293),
                                    o = n(3157),
                                    a = n(111),
                                    s = n(7908),
                                    l = n(7466),
                                    c = n(6135),
                                    u = n(5417),
                                    d = n(1194),
                                    h = n(5112),
                                    f = n(7392),
                                    p = h("isConcatSpreadable"),
                                    g = 9007199254740991,
                                    m = "Maximum allowed index exceeded",
                                    v = f >= 51 || !r((function () {
                                        var e = [];
                                        return e[p] = !1, e.concat()[0] !== e
                                    })),
                                    b = d("concat"),
                                    y = function (e) {
                                        if (!a(e)) return !1;
                                        var t = e[p];
                                        return void 0 !== t ? !!t : o(e)
                                    };
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: !v || !b
                                }, {
                                    concat: function (e) {
                                        var t, n, i, r, o, a = s(this),
                                            d = u(a, 0),
                                            h = 0;
                                        for (t = -1, i = arguments.length; t < i; t++)
                                            if (y(o = -1 === t ? a : arguments[t])) {
                                                if (h + (r = l(o.length)) > g) throw TypeError(m);
                                                for (n = 0; n < r; n++, h++) n in o && c(d, h, o[n])
                                            } else {
                                                if (h >= g) throw TypeError(m);
                                                c(d, h++, o)
                                            } return d.length = h, d
                                    }
                                })
                            },
                            7327: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(2092).filter;
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: !n(1194)("filter")
                                }, {
                                    filter: function (e) {
                                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0)
                                    }
                                })
                            },
                            2772: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(1318).indexOf,
                                    o = n(9341),
                                    a = [].indexOf,
                                    s = !!a && 1 / [1].indexOf(1, -0) < 0,
                                    l = o("indexOf");
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: s || !l
                                }, {
                                    indexOf: function (e) {
                                        return s ? a.apply(this, arguments) || 0 : r(this, e, arguments.length > 1 ? arguments[1] : void 0)
                                    }
                                })
                            },
                            6992: function (e, t, n) {
                                "use strict";
                                var i = n(5656),
                                    r = n(1223),
                                    o = n(7497),
                                    a = n(9909),
                                    s = n(654),
                                    l = "Array Iterator",
                                    c = a.set,
                                    u = a.getterFor(l);
                                e.exports = s(Array, "Array", (function (e, t) {
                                    c(this, {
                                        type: l,
                                        target: i(e),
                                        index: 0,
                                        kind: t
                                    })
                                }), (function () {
                                    var e = u(this),
                                        t = e.target,
                                        n = e.kind,
                                        i = e.index++;
                                    return !t || i >= t.length ? (e.target = void 0, {
                                        value: void 0,
                                        done: !0
                                    }) : "keys" == n ? {
                                        value: i,
                                        done: !1
                                    } : "values" == n ? {
                                        value: t[i],
                                        done: !1
                                    } : {
                                        value: [i, t[i]],
                                        done: !1
                                    }
                                }), "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries")
                            },
                            1249: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(2092).map;
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: !n(1194)("map")
                                }, {
                                    map: function (e) {
                                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0)
                                    }
                                })
                            },
                            7042: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(111),
                                    o = n(3157),
                                    a = n(1400),
                                    s = n(7466),
                                    l = n(5656),
                                    c = n(6135),
                                    u = n(5112),
                                    d = n(1194)("slice"),
                                    h = u("species"),
                                    f = [].slice,
                                    p = Math.max;
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: !d
                                }, {
                                    slice: function (e, t) {
                                        var n, i, u, d = l(this),
                                            g = s(d.length),
                                            m = a(e, g),
                                            v = a(void 0 === t ? g : t, g);
                                        if (o(d) && ("function" != typeof (n = d.constructor) || n !== Array && !o(n.prototype) ? r(n) && null === (n = n[h]) && (n = void 0) : n = void 0, n === Array || void 0 === n)) return f.call(d, m, v);
                                        for (i = new(void 0 === n ? Array : n)(p(v - m, 0)), u = 0; m < v; m++, u++) m in d && c(i, u, d[m]);
                                        return i.length = u, i
                                    }
                                })
                            },
                            561: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(1400),
                                    o = n(9958),
                                    a = n(7466),
                                    s = n(7908),
                                    l = n(5417),
                                    c = n(6135),
                                    u = n(1194)("splice"),
                                    d = Math.max,
                                    h = Math.min,
                                    f = 9007199254740991,
                                    p = "Maximum allowed length exceeded";
                                i({
                                    target: "Array",
                                    proto: !0,
                                    forced: !u
                                }, {
                                    splice: function (e, t) {
                                        var n, i, u, g, m, v, b = s(this),
                                            y = a(b.length),
                                            _ = r(e, y),
                                            x = arguments.length;
                                        if (0 === x ? n = i = 0 : 1 === x ? (n = 0, i = y - _) : (n = x - 2, i = h(d(o(t), 0), y - _)), y + n - i > f) throw TypeError(p);
                                        for (u = l(b, i), g = 0; g < i; g++)(m = _ + g) in b && c(u, g, b[m]);
                                        if (u.length = i, n < i) {
                                            for (g = _; g < y - i; g++) v = g + n, (m = g + i) in b ? b[v] = b[m] : delete b[v];
                                            for (g = y; g > y - i + n; g--) delete b[g - 1]
                                        } else if (n > i)
                                            for (g = y - i; g > _; g--) v = g + n - 1, (m = g + i - 1) in b ? b[v] = b[m] : delete b[v];
                                        for (g = 0; g < n; g++) b[g + _] = arguments[g + 2];
                                        return b.length = y - i + n, u
                                    }
                                })
                            },
                            8309: function (e, t, n) {
                                var i = n(9781),
                                    r = n(3070).f,
                                    o = Function.prototype,
                                    a = o.toString,
                                    s = /^\s*function ([^ (]*)/,
                                    l = "name";
                                i && !(l in o) && r(o, l, {
                                    configurable: !0,
                                    get: function () {
                                        try {
                                            return a.call(this).match(s)[1]
                                        } catch (e) {
                                            return ""
                                        }
                                    }
                                })
                            },
                            489: function (e, t, n) {
                                var i = n(2109),
                                    r = n(7293),
                                    o = n(7908),
                                    a = n(9518),
                                    s = n(8544);
                                i({
                                    target: "Object",
                                    stat: !0,
                                    forced: r((function () {
                                        a(1)
                                    })),
                                    sham: !s
                                }, {
                                    getPrototypeOf: function (e) {
                                        return a(o(e))
                                    }
                                })
                            },
                            1539: function (e, t, n) {
                                var i = n(1694),
                                    r = n(1320),
                                    o = n(288);
                                i || r(Object.prototype, "toString", o, {
                                    unsafe: !0
                                })
                            },
                            4916: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(2261);
                                i({
                                    target: "RegExp",
                                    proto: !0,
                                    forced: /./.exec !== r
                                }, {
                                    exec: r
                                })
                            },
                            9714: function (e, t, n) {
                                "use strict";
                                var i = n(1320),
                                    r = n(9670),
                                    o = n(7293),
                                    a = n(7066),
                                    s = "toString",
                                    l = RegExp.prototype,
                                    c = l.toString,
                                    u = o((function () {
                                        return "/a/b" != c.call({
                                            source: "a",
                                            flags: "b"
                                        })
                                    })),
                                    d = c.name != s;
                                (u || d) && i(RegExp.prototype, s, (function () {
                                    var e = r(this),
                                        t = String(e.source),
                                        n = e.flags;
                                    return "/" + t + "/" + String(void 0 === n && e instanceof RegExp && !("flags" in l) ? a.call(e) : n)
                                }), {
                                    unsafe: !0
                                })
                            },
                            8783: function (e, t, n) {
                                "use strict";
                                var i = n(8710).charAt,
                                    r = n(9909),
                                    o = n(654),
                                    a = "String Iterator",
                                    s = r.set,
                                    l = r.getterFor(a);
                                o(String, "String", (function (e) {
                                    s(this, {
                                        type: a,
                                        string: String(e),
                                        index: 0
                                    })
                                }), (function () {
                                    var e, t = l(this),
                                        n = t.string,
                                        r = t.index;
                                    return r >= n.length ? {
                                        value: void 0,
                                        done: !0
                                    } : (e = i(n, r), t.index += e.length, {
                                        value: e,
                                        done: !1
                                    })
                                }))
                            },
                            4723: function (e, t, n) {
                                "use strict";
                                var i = n(7007),
                                    r = n(9670),
                                    o = n(7466),
                                    a = n(4488),
                                    s = n(1530),
                                    l = n(7651);
                                i("match", 1, (function (e, t, n) {
                                    return [function (t) {
                                        var n = a(this),
                                            i = null == t ? void 0 : t[e];
                                        return void 0 !== i ? i.call(t, n) : new RegExp(t)[e](String(n))
                                    }, function (e) {
                                        var i = n(t, e, this);
                                        if (i.done) return i.value;
                                        var a = r(e),
                                            c = String(this);
                                        if (!a.global) return l(a, c);
                                        var u = a.unicode;
                                        a.lastIndex = 0;
                                        for (var d, h = [], f = 0; null !== (d = l(a, c));) {
                                            var p = String(d[0]);
                                            h[f] = p, "" === p && (a.lastIndex = s(c, o(a.lastIndex), u)), f++
                                        }
                                        return 0 === f ? null : h
                                    }]
                                }))
                            },
                            5306: function (e, t, n) {
                                "use strict";
                                var i = n(7007),
                                    r = n(9670),
                                    o = n(7466),
                                    a = n(9958),
                                    s = n(4488),
                                    l = n(1530),
                                    c = n(647),
                                    u = n(7651),
                                    d = Math.max,
                                    h = Math.min;
                                i("replace", 2, (function (e, t, n, i) {
                                    var f = i.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
                                        p = i.REPLACE_KEEPS_$0,
                                        g = f ? "$" : "$0";
                                    return [function (n, i) {
                                        var r = s(this),
                                            o = null == n ? void 0 : n[e];
                                        return void 0 !== o ? o.call(n, r, i) : t.call(String(r), n, i)
                                    }, function (e, i) {
                                        if (!f && p || "string" == typeof i && -1 === i.indexOf(g)) {
                                            var s = n(t, e, this, i);
                                            if (s.done) return s.value
                                        }
                                        var m = r(e),
                                            v = String(this),
                                            b = "function" == typeof i;
                                        b || (i = String(i));
                                        var y = m.global;
                                        if (y) {
                                            var _ = m.unicode;
                                            m.lastIndex = 0
                                        }
                                        for (var x = [];;) {
                                            var w = u(m, v);
                                            if (null === w) break;
                                            if (x.push(w), !y) break;
                                            "" === String(w[0]) && (m.lastIndex = l(v, o(m.lastIndex), _))
                                        }
                                        for (var E, k = "", O = 0, S = 0; S < x.length; S++) {
                                            w = x[S];
                                            for (var C = String(w[0]), A = d(h(a(w.index), v.length), 0), M = [], T = 1; T < w.length; T++) M.push(void 0 === (E = w[T]) ? E : String(E));
                                            var P = w.groups;
                                            if (b) {
                                                var D = [C].concat(M, A, v);
                                                void 0 !== P && D.push(P);
                                                var L = String(i.apply(void 0, D))
                                            } else L = c(C, v, A, M, P, i);
                                            A >= O && (k += v.slice(O, A) + L, O = A + C.length)
                                        }
                                        return k + v.slice(O)
                                    }]
                                }))
                            },
                            3123: function (e, t, n) {
                                "use strict";
                                var i = n(7007),
                                    r = n(7850),
                                    o = n(9670),
                                    a = n(4488),
                                    s = n(6707),
                                    l = n(1530),
                                    c = n(7466),
                                    u = n(7651),
                                    d = n(2261),
                                    h = n(7293),
                                    f = [].push,
                                    p = Math.min,
                                    g = 4294967295,
                                    m = !h((function () {
                                        return !RegExp(g, "y")
                                    }));
                                i("split", 2, (function (e, t, n) {
                                    var i;
                                    return i = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (e, n) {
                                        var i = String(a(this)),
                                            o = void 0 === n ? g : n >>> 0;
                                        if (0 === o) return [];
                                        if (void 0 === e) return [i];
                                        if (!r(e)) return t.call(i, e, o);
                                        for (var s, l, c, u = [], h = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), p = 0, m = new RegExp(e.source, h + "g");
                                            (s = d.call(m, i)) && !((l = m.lastIndex) > p && (u.push(i.slice(p, s.index)), s.length > 1 && s.index < i.length && f.apply(u, s.slice(1)), c = s[0].length, p = l, u.length >= o));) m.lastIndex === s.index && m.lastIndex++;
                                        return p === i.length ? !c && m.test("") || u.push("") : u.push(i.slice(p)), u.length > o ? u.slice(0, o) : u
                                    } : "0".split(void 0, 0).length ? function (e, n) {
                                        return void 0 === e && 0 === n ? [] : t.call(this, e, n)
                                    } : t, [function (t, n) {
                                        var r = a(this),
                                            o = null == t ? void 0 : t[e];
                                        return void 0 !== o ? o.call(t, r, n) : i.call(String(r), t, n)
                                    }, function (e, r) {
                                        var a = n(i, e, this, r, i !== t);
                                        if (a.done) return a.value;
                                        var d = o(e),
                                            h = String(this),
                                            f = s(d, RegExp),
                                            v = d.unicode,
                                            b = (d.ignoreCase ? "i" : "") + (d.multiline ? "m" : "") + (d.unicode ? "u" : "") + (m ? "y" : "g"),
                                            y = new f(m ? d : "^(?:" + d.source + ")", b),
                                            _ = void 0 === r ? g : r >>> 0;
                                        if (0 === _) return [];
                                        if (0 === h.length) return null === u(y, h) ? [h] : [];
                                        for (var x = 0, w = 0, E = []; w < h.length;) {
                                            y.lastIndex = m ? w : 0;
                                            var k, O = u(y, m ? h : h.slice(w));
                                            if (null === O || (k = p(c(y.lastIndex + (m ? 0 : w)), h.length)) === x) w = l(h, w, v);
                                            else {
                                                if (E.push(h.slice(x, w)), E.length === _) return E;
                                                for (var S = 1; S <= O.length - 1; S++)
                                                    if (E.push(O[S]), E.length === _) return E;
                                                w = x = k
                                            }
                                        }
                                        return E.push(h.slice(x)), E
                                    }]
                                }), !m)
                            },
                            3210: function (e, t, n) {
                                "use strict";
                                var i = n(2109),
                                    r = n(3111).trim;
                                i({
                                    target: "String",
                                    proto: !0,
                                    forced: n(6091)("trim")
                                }, {
                                    trim: function () {
                                        return r(this)
                                    }
                                })
                            },
                            2990: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(1048),
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("copyWithin", (function (e, t) {
                                    return r.call(o(this), e, t, arguments.length > 2 ? arguments[2] : void 0)
                                }))
                            },
                            8927: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).every,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("every", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            3105: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(1285),
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("fill", (function (e) {
                                    return r.apply(o(this), arguments)
                                }))
                            },
                            5035: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).filter,
                                    o = n(3074),
                                    a = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("filter", (function (e) {
                                    var t = r(a(this), e, arguments.length > 1 ? arguments[1] : void 0);
                                    return o(this, t)
                                }))
                            },
                            7174: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).findIndex,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("findIndex", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            4345: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).find,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("find", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            2846: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).forEach,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("forEach", (function (e) {
                                    r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            4731: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(1318).includes,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("includes", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            7209: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(1318).indexOf,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("indexOf", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            6319: function (e, t, n) {
                                "use strict";
                                var i = n(7854),
                                    r = n(260),
                                    o = n(6992),
                                    a = n(5112)("iterator"),
                                    s = i.Uint8Array,
                                    l = o.values,
                                    c = o.keys,
                                    u = o.entries,
                                    d = r.aTypedArray,
                                    h = r.exportTypedArrayMethod,
                                    f = s && s.prototype[a],
                                    p = !!f && ("values" == f.name || null == f.name),
                                    g = function () {
                                        return l.call(d(this))
                                    };
                                h("entries", (function () {
                                    return u.call(d(this))
                                })), h("keys", (function () {
                                    return c.call(d(this))
                                })), h("values", g, !p), h(a, g, !p)
                            },
                            8867: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = i.aTypedArray,
                                    o = i.exportTypedArrayMethod,
                                    a = [].join;
                                o("join", (function (e) {
                                    return a.apply(r(this), arguments)
                                }))
                            },
                            7789: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(6583),
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("lastIndexOf", (function (e) {
                                    return r.apply(o(this), arguments)
                                }))
                            },
                            3739: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).map,
                                    o = n(6707),
                                    a = i.aTypedArray,
                                    s = i.aTypedArrayConstructor;
                                (0, i.exportTypedArrayMethod)("map", (function (e) {
                                    return r(a(this), e, arguments.length > 1 ? arguments[1] : void 0, (function (e, t) {
                                        return new(s(o(e, e.constructor)))(t)
                                    }))
                                }))
                            },
                            4483: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(3671).right,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("reduceRight", (function (e) {
                                    return r(o(this), e, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            9368: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(3671).left,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("reduce", (function (e) {
                                    return r(o(this), e, arguments.length, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            2056: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = i.aTypedArray,
                                    o = i.exportTypedArrayMethod,
                                    a = Math.floor;
                                o("reverse", (function () {
                                    for (var e, t = this, n = r(t).length, i = a(n / 2), o = 0; o < i;) e = t[o], t[o++] = t[--n], t[n] = e;
                                    return t
                                }))
                            },
                            3462: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(7466),
                                    o = n(4590),
                                    a = n(7908),
                                    s = n(7293),
                                    l = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("set", (function (e) {
                                    l(this);
                                    var t = o(arguments.length > 1 ? arguments[1] : void 0, 1),
                                        n = this.length,
                                        i = a(e),
                                        s = r(i.length),
                                        c = 0;
                                    if (s + t > n) throw RangeError("Wrong length");
                                    for (; c < s;) this[t + c] = i[c++]
                                }), s((function () {
                                    new Int8Array(1).set({})
                                })))
                            },
                            678: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(6707),
                                    o = n(7293),
                                    a = i.aTypedArray,
                                    s = i.aTypedArrayConstructor,
                                    l = i.exportTypedArrayMethod,
                                    c = [].slice;
                                l("slice", (function (e, t) {
                                    for (var n = c.call(a(this), e, t), i = r(this, this.constructor), o = 0, l = n.length, u = new(s(i))(l); l > o;) u[o] = n[o++];
                                    return u
                                }), o((function () {
                                    new Int8Array(1).slice()
                                })))
                            },
                            7462: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(2092).some,
                                    o = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("some", (function (e) {
                                    return r(o(this), e, arguments.length > 1 ? arguments[1] : void 0)
                                }))
                            },
                            3824: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = i.aTypedArray,
                                    o = i.exportTypedArrayMethod,
                                    a = [].sort;
                                o("sort", (function (e) {
                                    return a.call(r(this), e)
                                }))
                            },
                            5021: function (e, t, n) {
                                "use strict";
                                var i = n(260),
                                    r = n(7466),
                                    o = n(1400),
                                    a = n(6707),
                                    s = i.aTypedArray;
                                (0, i.exportTypedArrayMethod)("subarray", (function (e, t) {
                                    var n = s(this),
                                        i = n.length,
                                        l = o(e, i);
                                    return new(a(n, n.constructor))(n.buffer, n.byteOffset + l * n.BYTES_PER_ELEMENT, r((void 0 === t ? i : o(t, i)) - l))
                                }))
                            },
                            2974: function (e, t, n) {
                                "use strict";
                                var i = n(7854),
                                    r = n(260),
                                    o = n(7293),
                                    a = i.Int8Array,
                                    s = r.aTypedArray,
                                    l = r.exportTypedArrayMethod,
                                    c = [].toLocaleString,
                                    u = [].slice,
                                    d = !!a && o((function () {
                                        c.call(new a(1))
                                    }));
                                l("toLocaleString", (function () {
                                    return c.apply(d ? u.call(s(this)) : s(this), arguments)
                                }), o((function () {
                                    return [1, 2].toLocaleString() != new a([1, 2]).toLocaleString()
                                })) || !o((function () {
                                    a.prototype.toLocaleString.call([1, 2])
                                })))
                            },
                            5016: function (e, t, n) {
                                "use strict";
                                var i = n(260).exportTypedArrayMethod,
                                    r = n(7293),
                                    o = n(7854).Uint8Array,
                                    a = o && o.prototype || {},
                                    s = [].toString,
                                    l = [].join;
                                r((function () {
                                    s.call({})
                                })) && (s = function () {
                                    return l.call(this)
                                });
                                var c = a.toString != s;
                                i("toString", s, c)
                            },
                            2472: function (e, t, n) {
                                n(9843)("Uint8", (function (e) {
                                    return function (t, n, i) {
                                        return e(this, t, n, i)
                                    }
                                }))
                            },
                            4747: function (e, t, n) {
                                var i = n(7854),
                                    r = n(8324),
                                    o = n(8533),
                                    a = n(8880);
                                for (var s in r) {
                                    var l = i[s],
                                        c = l && l.prototype;
                                    if (c && c.forEach !== o) try {
                                        a(c, "forEach", o)
                                    } catch (e) {
                                        c.forEach = o
                                    }
                                }
                            },
                            3948: function (e, t, n) {
                                var i = n(7854),
                                    r = n(8324),
                                    o = n(6992),
                                    a = n(8880),
                                    s = n(5112),
                                    l = s("iterator"),
                                    c = s("toStringTag"),
                                    u = o.values;
                                for (var d in r) {
                                    var h = i[d],
                                        f = h && h.prototype;
                                    if (f) {
                                        if (f[l] !== u) try {
                                            a(f, l, u)
                                        } catch (e) {
                                            f[l] = u
                                        }
                                        if (f[c] || a(f, c, d), r[d])
                                            for (var p in o)
                                                if (f[p] !== o[p]) try {
                                                    a(f, p, o[p])
                                                } catch (e) {
                                                    f[p] = o[p]
                                                }
                                    }
                                }
                            },
                            1637: function (e, t, n) {
                                "use strict";
                                n(6992);
                                var i = n(2109),
                                    r = n(5005),
                                    o = n(590),
                                    a = n(1320),
                                    s = n(2248),
                                    l = n(8003),
                                    c = n(4994),
                                    u = n(9909),
                                    d = n(5787),
                                    h = n(6656),
                                    f = n(9974),
                                    p = n(648),
                                    g = n(9670),
                                    m = n(111),
                                    v = n(30),
                                    b = n(9114),
                                    y = n(8554),
                                    _ = n(1246),
                                    x = n(5112),
                                    w = r("fetch"),
                                    E = r("Headers"),
                                    k = x("iterator"),
                                    O = "URLSearchParams",
                                    S = "URLSearchParamsIterator",
                                    C = u.set,
                                    A = u.getterFor(O),
                                    M = u.getterFor(S),
                                    T = /\+/g,
                                    P = Array(4),
                                    D = function (e) {
                                        return P[e - 1] || (P[e - 1] = RegExp("((?:%[\\da-f]{2}){" + e + "})", "gi"))
                                    },
                                    L = function (e) {
                                        try {
                                            return decodeURIComponent(e)
                                        } catch (t) {
                                            return e
                                        }
                                    },
                                    N = function (e) {
                                        var t = e.replace(T, " "),
                                            n = 4;
                                        try {
                                            return decodeURIComponent(t)
                                        } catch (e) {
                                            for (; n;) t = t.replace(D(n--), L);
                                            return t
                                        }
                                    },
                                    j = /[!'()~]|%20/g,
                                    I = {
                                        "!": "%21",
                                        "'": "%27",
                                        "(": "%28",
                                        ")": "%29",
                                        "~": "%7E",
                                        "%20": "+"
                                    },
                                    R = function (e) {
                                        return I[e]
                                    },
                                    F = function (e) {
                                        return encodeURIComponent(e).replace(j, R)
                                    },
                                    B = function (e, t) {
                                        if (t)
                                            for (var n, i, r = t.split("&"), o = 0; o < r.length;)(n = r[o++]).length && (i = n.split("="), e.push({
                                                key: N(i.shift()),
                                                value: N(i.join("="))
                                            }))
                                    },
                                    q = function (e) {
                                        this.entries.length = 0, B(this.entries, e)
                                    },
                                    z = function (e, t) {
                                        if (e < t) throw TypeError("Not enough arguments")
                                    },
                                    H = c((function (e, t) {
                                        C(this, {
                                            type: S,
                                            iterator: y(A(e).entries),
                                            kind: t
                                        })
                                    }), "Iterator", (function () {
                                        var e = M(this),
                                            t = e.kind,
                                            n = e.iterator.next(),
                                            i = n.value;
                                        return n.done || (n.value = "keys" === t ? i.key : "values" === t ? i.value : [i.key, i.value]), n
                                    })),
                                    U = function () {
                                        d(this, U, O);
                                        var e, t, n, i, r, o, a, s, l, c = arguments.length > 0 ? arguments[0] : void 0,
                                            u = this,
                                            f = [];
                                        if (C(u, {
                                                type: O,
                                                entries: f,
                                                updateURL: function () {},
                                                updateSearchParams: q
                                            }), void 0 !== c)
                                            if (m(c))
                                                if ("function" == typeof (e = _(c)))
                                                    for (n = (t = e.call(c)).next; !(i = n.call(t)).done;) {
                                                        if ((a = (o = (r = y(g(i.value))).next).call(r)).done || (s = o.call(r)).done || !o.call(r).done) throw TypeError("Expected sequence with length 2");
                                                        f.push({
                                                            key: a.value + "",
                                                            value: s.value + ""
                                                        })
                                                    } else
                                                        for (l in c) h(c, l) && f.push({
                                                            key: l,
                                                            value: c[l] + ""
                                                        });
                                                else B(f, "string" == typeof c ? "?" === c.charAt(0) ? c.slice(1) : c : c + "")
                                    },
                                    V = U.prototype;
                                s(V, {
                                    append: function (e, t) {
                                        z(arguments.length, 2);
                                        var n = A(this);
                                        n.entries.push({
                                            key: e + "",
                                            value: t + ""
                                        }), n.updateURL()
                                    },
                                    delete: function (e) {
                                        z(arguments.length, 1);
                                        for (var t = A(this), n = t.entries, i = e + "", r = 0; r < n.length;) n[r].key === i ? n.splice(r, 1) : r++;
                                        t.updateURL()
                                    },
                                    get: function (e) {
                                        z(arguments.length, 1);
                                        for (var t = A(this).entries, n = e + "", i = 0; i < t.length; i++)
                                            if (t[i].key === n) return t[i].value;
                                        return null
                                    },
                                    getAll: function (e) {
                                        z(arguments.length, 1);
                                        for (var t = A(this).entries, n = e + "", i = [], r = 0; r < t.length; r++) t[r].key === n && i.push(t[r].value);
                                        return i
                                    },
                                    has: function (e) {
                                        z(arguments.length, 1);
                                        for (var t = A(this).entries, n = e + "", i = 0; i < t.length;)
                                            if (t[i++].key === n) return !0;
                                        return !1
                                    },
                                    set: function (e, t) {
                                        z(arguments.length, 1);
                                        for (var n, i = A(this), r = i.entries, o = !1, a = e + "", s = t + "", l = 0; l < r.length; l++)(n = r[l]).key === a && (o ? r.splice(l--, 1) : (o = !0, n.value = s));
                                        o || r.push({
                                            key: a,
                                            value: s
                                        }), i.updateURL()
                                    },
                                    sort: function () {
                                        var e, t, n, i = A(this),
                                            r = i.entries,
                                            o = r.slice();
                                        for (r.length = 0, n = 0; n < o.length; n++) {
                                            for (e = o[n], t = 0; t < n; t++)
                                                if (r[t].key > e.key) {
                                                    r.splice(t, 0, e);
                                                    break
                                                } t === n && r.push(e)
                                        }
                                        i.updateURL()
                                    },
                                    forEach: function (e) {
                                        for (var t, n = A(this).entries, i = f(e, arguments.length > 1 ? arguments[1] : void 0, 3), r = 0; r < n.length;) i((t = n[r++]).value, t.key, this)
                                    },
                                    keys: function () {
                                        return new H(this, "keys")
                                    },
                                    values: function () {
                                        return new H(this, "values")
                                    },
                                    entries: function () {
                                        return new H(this, "entries")
                                    }
                                }, {
                                    enumerable: !0
                                }), a(V, k, V.entries), a(V, "toString", (function () {
                                    for (var e, t = A(this).entries, n = [], i = 0; i < t.length;) e = t[i++], n.push(F(e.key) + "=" + F(e.value));
                                    return n.join("&")
                                }), {
                                    enumerable: !0
                                }), l(U, O), i({
                                    global: !0,
                                    forced: !o
                                }, {
                                    URLSearchParams: U
                                }), o || "function" != typeof w || "function" != typeof E || i({
                                    global: !0,
                                    enumerable: !0,
                                    forced: !0
                                }, {
                                    fetch: function (e) {
                                        var t, n, i, r = [e];
                                        return arguments.length > 1 && (m(t = arguments[1]) && (n = t.body, p(n) === O && ((i = t.headers ? new E(t.headers) : new E).has("content-type") || i.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), t = v(t, {
                                            body: b(0, String(n)),
                                            headers: b(0, i)
                                        }))), r.push(t)), w.apply(this, r)
                                    }
                                }), e.exports = {
                                    URLSearchParams: U,
                                    getState: A
                                }
                            },
                            285: function (e, t, n) {
                                "use strict";
                                n(8783);
                                var i, r = n(2109),
                                    o = n(9781),
                                    a = n(590),
                                    s = n(7854),
                                    l = n(6048),
                                    c = n(1320),
                                    u = n(5787),
                                    d = n(6656),
                                    h = n(1574),
                                    f = n(8457),
                                    p = n(8710).codeAt,
                                    g = n(3197),
                                    m = n(8003),
                                    v = n(1637),
                                    b = n(9909),
                                    y = s.URL,
                                    _ = v.URLSearchParams,
                                    x = v.getState,
                                    w = b.set,
                                    E = b.getterFor("URL"),
                                    k = Math.floor,
                                    O = Math.pow,
                                    S = "Invalid scheme",
                                    C = "Invalid host",
                                    A = "Invalid port",
                                    M = /[A-Za-z]/,
                                    T = /[\d+-.A-Za-z]/,
                                    P = /\d/,
                                    D = /^(0x|0X)/,
                                    L = /^[0-7]+$/,
                                    N = /^\d+$/,
                                    j = /^[\dA-Fa-f]+$/,
                                    I = /[\u0000\t\u000A\u000D #%/:?@[\\]]/,
                                    R = /[\u0000\t\u000A\u000D #/:?@[\\]]/,
                                    F = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g,
                                    B = /[\t\u000A\u000D]/g,
                                    q = function (e, t) {
                                        var n, i, r;
                                        if ("[" == t.charAt(0)) {
                                            if ("]" != t.charAt(t.length - 1)) return C;
                                            if (!(n = H(t.slice(1, -1)))) return C;
                                            e.host = n
                                        } else if (X(e)) {
                                            if (t = g(t), I.test(t)) return C;
                                            if (null === (n = z(t))) return C;
                                            e.host = n
                                        } else {
                                            if (R.test(t)) return C;
                                            for (n = "", i = f(t), r = 0; r < i.length; r++) n += K(i[r], V);
                                            e.host = n
                                        }
                                    },
                                    z = function (e) {
                                        var t, n, i, r, o, a, s, l = e.split(".");
                                        if (l.length && "" == l[l.length - 1] && l.pop(), (t = l.length) > 4) return e;
                                        for (n = [], i = 0; i < t; i++) {
                                            if ("" == (r = l[i])) return e;
                                            if (o = 10, r.length > 1 && "0" == r.charAt(0) && (o = D.test(r) ? 16 : 8, r = r.slice(8 == o ? 1 : 2)), "" === r) a = 0;
                                            else {
                                                if (!(10 == o ? N : 8 == o ? L : j).test(r)) return e;
                                                a = parseInt(r, o)
                                            }
                                            n.push(a)
                                        }
                                        for (i = 0; i < t; i++)
                                            if (a = n[i], i == t - 1) {
                                                if (a >= O(256, 5 - t)) return null
                                            } else if (a > 255) return null;
                                        for (s = n.pop(), i = 0; i < n.length; i++) s += n[i] * O(256, 3 - i);
                                        return s
                                    },
                                    H = function (e) {
                                        var t, n, i, r, o, a, s, l = [0, 0, 0, 0, 0, 0, 0, 0],
                                            c = 0,
                                            u = null,
                                            d = 0,
                                            h = function () {
                                                return e.charAt(d)
                                            };
                                        if (":" == h()) {
                                            if (":" != e.charAt(1)) return;
                                            d += 2, u = ++c
                                        }
                                        for (; h();) {
                                            if (8 == c) return;
                                            if (":" != h()) {
                                                for (t = n = 0; n < 4 && j.test(h());) t = 16 * t + parseInt(h(), 16), d++, n++;
                                                if ("." == h()) {
                                                    if (0 == n) return;
                                                    if (d -= n, c > 6) return;
                                                    for (i = 0; h();) {
                                                        if (r = null, i > 0) {
                                                            if (!("." == h() && i < 4)) return;
                                                            d++
                                                        }
                                                        if (!P.test(h())) return;
                                                        for (; P.test(h());) {
                                                            if (o = parseInt(h(), 10), null === r) r = o;
                                                            else {
                                                                if (0 == r) return;
                                                                r = 10 * r + o
                                                            }
                                                            if (r > 255) return;
                                                            d++
                                                        }
                                                        l[c] = 256 * l[c] + r, 2 != ++i && 4 != i || c++
                                                    }
                                                    if (4 != i) return;
                                                    break
                                                }
                                                if (":" == h()) {
                                                    if (d++, !h()) return
                                                } else if (h()) return;
                                                l[c++] = t
                                            } else {
                                                if (null !== u) return;
                                                d++, u = ++c
                                            }
                                        }
                                        if (null !== u)
                                            for (a = c - u, c = 7; 0 != c && a > 0;) s = l[c], l[c--] = l[u + a - 1], l[u + --a] = s;
                                        else if (8 != c) return;
                                        return l
                                    },
                                    U = function (e) {
                                        var t, n, i, r;
                                        if ("number" == typeof e) {
                                            for (t = [], n = 0; n < 4; n++) t.unshift(e % 256), e = k(e / 256);
                                            return t.join(".")
                                        }
                                        if ("object" == typeof e) {
                                            for (t = "", i = function (e) {
                                                    for (var t = null, n = 1, i = null, r = 0, o = 0; o < 8; o++) 0 !== e[o] ? (r > n && (t = i, n = r), i = null, r = 0) : (null === i && (i = o), ++r);
                                                    return r > n && (t = i, n = r), t
                                                }(e), n = 0; n < 8; n++) r && 0 === e[n] || (r && (r = !1), i === n ? (t += n ? ":" : "::", r = !0) : (t += e[n].toString(16), n < 7 && (t += ":")));
                                            return "[" + t + "]"
                                        }
                                        return e
                                    },
                                    V = {},
                                    W = h({}, V, {
                                        " ": 1,
                                        '"': 1,
                                        "<": 1,
                                        ">": 1,
                                        "`": 1
                                    }),
                                    Y = h({}, W, {
                                        "#": 1,
                                        "?": 1,
                                        "{": 1,
                                        "}": 1
                                    }),
                                    $ = h({}, Y, {
                                        "/": 1,
                                        ":": 1,
                                        ";": 1,
                                        "=": 1,
                                        "@": 1,
                                        "[": 1,
                                        "\\": 1,
                                        "]": 1,
                                        "^": 1,
                                        "|": 1
                                    }),
                                    K = function (e, t) {
                                        var n = p(e, 0);
                                        return n > 32 && n < 127 && !d(t, e) ? e : encodeURIComponent(e)
                                    },
                                    G = {
                                        ftp: 21,
                                        file: null,
                                        http: 80,
                                        https: 443,
                                        ws: 80,
                                        wss: 443
                                    },
                                    X = function (e) {
                                        return d(G, e.scheme)
                                    },
                                    Z = function (e) {
                                        return "" != e.username || "" != e.password
                                    },
                                    Q = function (e) {
                                        return !e.host || e.cannotBeABaseURL || "file" == e.scheme
                                    },
                                    J = function (e, t) {
                                        var n;
                                        return 2 == e.length && M.test(e.charAt(0)) && (":" == (n = e.charAt(1)) || !t && "|" == n)
                                    },
                                    ee = function (e) {
                                        var t;
                                        return e.length > 1 && J(e.slice(0, 2)) && (2 == e.length || "/" === (t = e.charAt(2)) || "\\" === t || "?" === t || "#" === t)
                                    },
                                    te = function (e) {
                                        var t = e.path,
                                            n = t.length;
                                        !n || "file" == e.scheme && 1 == n && J(t[0], !0) || t.pop()
                                    },
                                    ne = function (e) {
                                        return "." === e || "%2e" === e.toLowerCase()
                                    },
                                    ie = {},
                                    re = {},
                                    oe = {},
                                    ae = {},
                                    se = {},
                                    le = {},
                                    ce = {},
                                    ue = {},
                                    de = {},
                                    he = {},
                                    fe = {},
                                    pe = {},
                                    ge = {},
                                    me = {},
                                    ve = {},
                                    be = {},
                                    ye = {},
                                    _e = {},
                                    xe = {},
                                    we = {},
                                    Ee = {},
                                    ke = function (e, t, n, r) {
                                        var o, a, s, l, c, u = n || ie,
                                            h = 0,
                                            p = "",
                                            g = !1,
                                            m = !1,
                                            v = !1;
                                        for (n || (e.scheme = "", e.username = "", e.password = "", e.host = null, e.port = null, e.path = [], e.query = null, e.fragment = null, e.cannotBeABaseURL = !1, t = t.replace(F, "")), t = t.replace(B, ""), o = f(t); h <= o.length;) {
                                            switch (a = o[h], u) {
                                                case ie:
                                                    if (!a || !M.test(a)) {
                                                        if (n) return S;
                                                        u = oe;
                                                        continue
                                                    }
                                                    p += a.toLowerCase(), u = re;
                                                    break;
                                                case re:
                                                    if (a && (T.test(a) || "+" == a || "-" == a || "." == a)) p += a.toLowerCase();
                                                    else {
                                                        if (":" != a) {
                                                            if (n) return S;
                                                            p = "", u = oe, h = 0;
                                                            continue
                                                        }
                                                        if (n && (X(e) != d(G, p) || "file" == p && (Z(e) || null !== e.port) || "file" == e.scheme && !e.host)) return;
                                                        if (e.scheme = p, n) return void(X(e) && G[e.scheme] == e.port && (e.port = null));
                                                        p = "", "file" == e.scheme ? u = me : X(e) && r && r.scheme == e.scheme ? u = ae : X(e) ? u = ue : "/" == o[h + 1] ? (u = se, h++) : (e.cannotBeABaseURL = !0, e.path.push(""), u = xe)
                                                    }
                                                    break;
                                                case oe:
                                                    if (!r || r.cannotBeABaseURL && "#" != a) return S;
                                                    if (r.cannotBeABaseURL && "#" == a) {
                                                        e.scheme = r.scheme, e.path = r.path.slice(), e.query = r.query, e.fragment = "", e.cannotBeABaseURL = !0, u = Ee;
                                                        break
                                                    }
                                                    u = "file" == r.scheme ? me : le;
                                                    continue;
                                                case ae:
                                                    if ("/" != a || "/" != o[h + 1]) {
                                                        u = le;
                                                        continue
                                                    }
                                                    u = de, h++;
                                                    break;
                                                case se:
                                                    if ("/" == a) {
                                                        u = he;
                                                        break
                                                    }
                                                    u = _e;
                                                    continue;
                                                case le:
                                                    if (e.scheme = r.scheme, a == i) e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = r.query;
                                                    else if ("/" == a || "\\" == a && X(e)) u = ce;
                                                    else if ("?" == a) e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = "", u = we;
                                                    else {
                                                        if ("#" != a) {
                                                            e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.path.pop(), u = _e;
                                                            continue
                                                        }
                                                        e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, e.path = r.path.slice(), e.query = r.query, e.fragment = "", u = Ee
                                                    }
                                                    break;
                                                case ce:
                                                    if (!X(e) || "/" != a && "\\" != a) {
                                                        if ("/" != a) {
                                                            e.username = r.username, e.password = r.password, e.host = r.host, e.port = r.port, u = _e;
                                                            continue
                                                        }
                                                        u = he
                                                    } else u = de;
                                                    break;
                                                case ue:
                                                    if (u = de, "/" != a || "/" != p.charAt(h + 1)) continue;
                                                    h++;
                                                    break;
                                                case de:
                                                    if ("/" != a && "\\" != a) {
                                                        u = he;
                                                        continue
                                                    }
                                                    break;
                                                case he:
                                                    if ("@" == a) {
                                                        g && (p = "%40" + p), g = !0, s = f(p);
                                                        for (var b = 0; b < s.length; b++) {
                                                            var y = s[b];
                                                            if (":" != y || v) {
                                                                var _ = K(y, $);
                                                                v ? e.password += _ : e.username += _
                                                            } else v = !0
                                                        }
                                                        p = ""
                                                    } else if (a == i || "/" == a || "?" == a || "#" == a || "\\" == a && X(e)) {
                                                        if (g && "" == p) return "Invalid authority";
                                                        h -= f(p).length + 1, p = "", u = fe
                                                    } else p += a;
                                                    break;
                                                case fe:
                                                case pe:
                                                    if (n && "file" == e.scheme) {
                                                        u = be;
                                                        continue
                                                    }
                                                    if (":" != a || m) {
                                                        if (a == i || "/" == a || "?" == a || "#" == a || "\\" == a && X(e)) {
                                                            if (X(e) && "" == p) return C;
                                                            if (n && "" == p && (Z(e) || null !== e.port)) return;
                                                            if (l = q(e, p)) return l;
                                                            if (p = "", u = ye, n) return;
                                                            continue
                                                        }
                                                        "[" == a ? m = !0 : "]" == a && (m = !1), p += a
                                                    } else {
                                                        if ("" == p) return C;
                                                        if (l = q(e, p)) return l;
                                                        if (p = "", u = ge, n == pe) return
                                                    }
                                                    break;
                                                case ge:
                                                    if (!P.test(a)) {
                                                        if (a == i || "/" == a || "?" == a || "#" == a || "\\" == a && X(e) || n) {
                                                            if ("" != p) {
                                                                var x = parseInt(p, 10);
                                                                if (x > 65535) return A;
                                                                e.port = X(e) && x === G[e.scheme] ? null : x, p = ""
                                                            }
                                                            if (n) return;
                                                            u = ye;
                                                            continue
                                                        }
                                                        return A
                                                    }
                                                    p += a;
                                                    break;
                                                case me:
                                                    if (e.scheme = "file", "/" == a || "\\" == a) u = ve;
                                                    else {
                                                        if (!r || "file" != r.scheme) {
                                                            u = _e;
                                                            continue
                                                        }
                                                        if (a == i) e.host = r.host, e.path = r.path.slice(), e.query = r.query;
                                                        else if ("?" == a) e.host = r.host, e.path = r.path.slice(), e.query = "", u = we;
                                                        else {
                                                            if ("#" != a) {
                                                                ee(o.slice(h).join("")) || (e.host = r.host, e.path = r.path.slice(), te(e)), u = _e;
                                                                continue
                                                            }
                                                            e.host = r.host, e.path = r.path.slice(), e.query = r.query, e.fragment = "", u = Ee
                                                        }
                                                    }
                                                    break;
                                                case ve:
                                                    if ("/" == a || "\\" == a) {
                                                        u = be;
                                                        break
                                                    }
                                                    r && "file" == r.scheme && !ee(o.slice(h).join("")) && (J(r.path[0], !0) ? e.path.push(r.path[0]) : e.host = r.host), u = _e;
                                                    continue;
                                                case be:
                                                    if (a == i || "/" == a || "\\" == a || "?" == a || "#" == a) {
                                                        if (!n && J(p)) u = _e;
                                                        else if ("" == p) {
                                                            if (e.host = "", n) return;
                                                            u = ye
                                                        } else {
                                                            if (l = q(e, p)) return l;
                                                            if ("localhost" == e.host && (e.host = ""), n) return;
                                                            p = "", u = ye
                                                        }
                                                        continue
                                                    }
                                                    p += a;
                                                    break;
                                                case ye:
                                                    if (X(e)) {
                                                        if (u = _e, "/" != a && "\\" != a) continue
                                                    } else if (n || "?" != a)
                                                        if (n || "#" != a) {
                                                            if (a != i && (u = _e, "/" != a)) continue
                                                        } else e.fragment = "", u = Ee;
                                                    else e.query = "", u = we;
                                                    break;
                                                case _e:
                                                    if (a == i || "/" == a || "\\" == a && X(e) || !n && ("?" == a || "#" == a)) {
                                                        if (".." === (c = (c = p).toLowerCase()) || "%2e." === c || ".%2e" === c || "%2e%2e" === c ? (te(e), "/" == a || "\\" == a && X(e) || e.path.push("")) : ne(p) ? "/" == a || "\\" == a && X(e) || e.path.push("") : ("file" == e.scheme && !e.path.length && J(p) && (e.host && (e.host = ""), p = p.charAt(0) + ":"), e.path.push(p)), p = "", "file" == e.scheme && (a == i || "?" == a || "#" == a))
                                                            for (; e.path.length > 1 && "" === e.path[0];) e.path.shift();
                                                        "?" == a ? (e.query = "", u = we) : "#" == a && (e.fragment = "", u = Ee)
                                                    } else p += K(a, Y);
                                                    break;
                                                case xe:
                                                    "?" == a ? (e.query = "", u = we) : "#" == a ? (e.fragment = "", u = Ee) : a != i && (e.path[0] += K(a, V));
                                                    break;
                                                case we:
                                                    n || "#" != a ? a != i && ("'" == a && X(e) ? e.query += "%27" : e.query += "#" == a ? "%23" : K(a, V)) : (e.fragment = "", u = Ee);
                                                    break;
                                                case Ee:
                                                    a != i && (e.fragment += K(a, W))
                                            }
                                            h++
                                        }
                                    },
                                    Oe = function (e) {
                                        var t, n, i = u(this, Oe, "URL"),
                                            r = arguments.length > 1 ? arguments[1] : void 0,
                                            a = String(e),
                                            s = w(i, {
                                                type: "URL"
                                            });
                                        if (void 0 !== r)
                                            if (r instanceof Oe) t = E(r);
                                            else if (n = ke(t = {}, String(r))) throw TypeError(n);
                                        if (n = ke(s, a, null, t)) throw TypeError(n);
                                        var l = s.searchParams = new _,
                                            c = x(l);
                                        c.updateSearchParams(s.query), c.updateURL = function () {
                                            s.query = String(l) || null
                                        }, o || (i.href = Ce.call(i), i.origin = Ae.call(i), i.protocol = Me.call(i), i.username = Te.call(i), i.password = Pe.call(i), i.host = De.call(i), i.hostname = Le.call(i), i.port = Ne.call(i), i.pathname = je.call(i), i.search = Ie.call(i), i.searchParams = Re.call(i), i.hash = Fe.call(i))
                                    },
                                    Se = Oe.prototype,
                                    Ce = function () {
                                        var e = E(this),
                                            t = e.scheme,
                                            n = e.username,
                                            i = e.password,
                                            r = e.host,
                                            o = e.port,
                                            a = e.path,
                                            s = e.query,
                                            l = e.fragment,
                                            c = t + ":";
                                        return null !== r ? (c += "//", Z(e) && (c += n + (i ? ":" + i : "") + "@"), c += U(r), null !== o && (c += ":" + o)) : "file" == t && (c += "//"), c += e.cannotBeABaseURL ? a[0] : a.length ? "/" + a.join("/") : "", null !== s && (c += "?" + s), null !== l && (c += "#" + l), c
                                    },
                                    Ae = function () {
                                        var e = E(this),
                                            t = e.scheme,
                                            n = e.port;
                                        if ("blob" == t) try {
                                            return new URL(t.path[0]).origin
                                        } catch (e) {
                                            return "null"
                                        }
                                        return "file" != t && X(e) ? t + "://" + U(e.host) + (null !== n ? ":" + n : "") : "null"
                                    },
                                    Me = function () {
                                        return E(this).scheme + ":"
                                    },
                                    Te = function () {
                                        return E(this).username
                                    },
                                    Pe = function () {
                                        return E(this).password
                                    },
                                    De = function () {
                                        var e = E(this),
                                            t = e.host,
                                            n = e.port;
                                        return null === t ? "" : null === n ? U(t) : U(t) + ":" + n
                                    },
                                    Le = function () {
                                        var e = E(this).host;
                                        return null === e ? "" : U(e)
                                    },
                                    Ne = function () {
                                        var e = E(this).port;
                                        return null === e ? "" : String(e)
                                    },
                                    je = function () {
                                        var e = E(this),
                                            t = e.path;
                                        return e.cannotBeABaseURL ? t[0] : t.length ? "/" + t.join("/") : ""
                                    },
                                    Ie = function () {
                                        var e = E(this).query;
                                        return e ? "?" + e : ""
                                    },
                                    Re = function () {
                                        return E(this).searchParams
                                    },
                                    Fe = function () {
                                        var e = E(this).fragment;
                                        return e ? "#" + e : ""
                                    },
                                    Be = function (e, t) {
                                        return {
                                            get: e,
                                            set: t,
                                            configurable: !0,
                                            enumerable: !0
                                        }
                                    };
                                if (o && l(Se, {
                                        href: Be(Ce, (function (e) {
                                            var t = E(this),
                                                n = String(e),
                                                i = ke(t, n);
                                            if (i) throw TypeError(i);
                                            x(t.searchParams).updateSearchParams(t.query)
                                        })),
                                        origin: Be(Ae),
                                        protocol: Be(Me, (function (e) {
                                            var t = E(this);
                                            ke(t, String(e) + ":", ie)
                                        })),
                                        username: Be(Te, (function (e) {
                                            var t = E(this),
                                                n = f(String(e));
                                            if (!Q(t)) {
                                                t.username = "";
                                                for (var i = 0; i < n.length; i++) t.username += K(n[i], $)
                                            }
                                        })),
                                        password: Be(Pe, (function (e) {
                                            var t = E(this),
                                                n = f(String(e));
                                            if (!Q(t)) {
                                                t.password = "";
                                                for (var i = 0; i < n.length; i++) t.password += K(n[i], $)
                                            }
                                        })),
                                        host: Be(De, (function (e) {
                                            var t = E(this);
                                            t.cannotBeABaseURL || ke(t, String(e), fe)
                                        })),
                                        hostname: Be(Le, (function (e) {
                                            var t = E(this);
                                            t.cannotBeABaseURL || ke(t, String(e), pe)
                                        })),
                                        port: Be(Ne, (function (e) {
                                            var t = E(this);
                                            Q(t) || ("" == (e = String(e)) ? t.port = null : ke(t, e, ge))
                                        })),
                                        pathname: Be(je, (function (e) {
                                            var t = E(this);
                                            t.cannotBeABaseURL || (t.path = [], ke(t, e + "", ye))
                                        })),
                                        search: Be(Ie, (function (e) {
                                            var t = E(this);
                                            "" == (e = String(e)) ? t.query = null: ("?" == e.charAt(0) && (e = e.slice(1)), t.query = "", ke(t, e, we)), x(t.searchParams).updateSearchParams(t.query)
                                        })),
                                        searchParams: Be(Re),
                                        hash: Be(Fe, (function (e) {
                                            var t = E(this);
                                            "" != (e = String(e)) ? ("#" == e.charAt(0) && (e = e.slice(1)), t.fragment = "", ke(t, e, Ee)) : t.fragment = null
                                        }))
                                    }), c(Se, "toJSON", (function () {
                                        return Ce.call(this)
                                    }), {
                                        enumerable: !0
                                    }), c(Se, "toString", (function () {
                                        return Ce.call(this)
                                    }), {
                                        enumerable: !0
                                    }), y) {
                                    var qe = y.createObjectURL,
                                        ze = y.revokeObjectURL;
                                    qe && c(Oe, "createObjectURL", (function (e) {
                                        return qe.apply(y, arguments)
                                    })), ze && c(Oe, "revokeObjectURL", (function (e) {
                                        return ze.apply(y, arguments)
                                    }))
                                }
                                m(Oe, "URL"), r({
                                    global: !0,
                                    forced: !a,
                                    sham: !o
                                }, {
                                    URL: Oe
                                })
                            }
                        },
                        t = {};

                    function n(i) {
                        if (t[i]) return t[i].exports;
                        var r = t[i] = {
                            exports: {}
                        };
                        return e[i](r, r.exports, n), r.exports
                    }
                    n.d = function (e, t) {
                        for (var i in t) n.o(t, i) && !n.o(e, i) && Object.defineProperty(e, i, {
                            enumerable: !0,
                            get: t[i]
                        })
                    }, n.g = function () {
                        if ("object" == typeof globalThis) return globalThis;
                        try {
                            return this || new Function("return this")()
                        } catch (e) {
                            if ("object" == typeof window) return window
                        }
                    }(), n.o = function (e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }, n.r = function (e) {
                        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                            value: "Module"
                        }), Object.defineProperty(e, "__esModule", {
                            value: !0
                        })
                    };
                    var i = {};
                    return function () {
                        "use strict";

                        function e(e, n) {
                            var i;
                            if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                if (Array.isArray(e) || (i = function (e, n) {
                                        if (e) {
                                            if ("string" == typeof e) return t(e, n);
                                            var i = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? t(e, n) : void 0
                                        }
                                    }(e)) || n && e && "number" == typeof e.length) {
                                    i && (e = i);
                                    var r = 0,
                                        o = function () {};
                                    return {
                                        s: o,
                                        n: function () {
                                            return r >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[r++]
                                            }
                                        },
                                        e: function (e) {
                                            throw e
                                        },
                                        f: o
                                    }
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                            }
                            var a, s = !0,
                                l = !1;
                            return {
                                s: function () {
                                    i = e[Symbol.iterator]()
                                },
                                n: function () {
                                    var e = i.next();
                                    return s = e.done, e
                                },
                                e: function (e) {
                                    l = !0, a = e
                                },
                                f: function () {
                                    try {
                                        s || null == i.return || i.return()
                                    } finally {
                                        if (l) throw a
                                    }
                                }
                            }
                        }

                        function t(e, t) {
                            (null == t || t > e.length) && (t = e.length);
                            for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                            return i
                        }

                        function r(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                            }
                        }
                        n.r(i), n.d(i, {
                            Dropzone: function () {
                                return _
                            },
                            default: function () {
                                return O
                            }
                        }), n(2222), n(7327), n(2772), n(6992), n(1249), n(7042), n(561), n(8264), n(8309), n(489), n(1539), n(4916), n(9714), n(8783), n(4723), n(5306), n(3123), n(3210), n(2472), n(2990), n(8927), n(3105), n(5035), n(4345), n(7174), n(2846), n(4731), n(7209), n(6319), n(8867), n(7789), n(3739), n(9368), n(4483), n(2056), n(3462), n(678), n(7462), n(3824), n(5021), n(2974), n(5016), n(4747), n(3948), n(285);
                        var o = function () {
                            function t() {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t)
                            }
                            var n, i, o;
                            return n = t, i = [{
                                key: "on",
                                value: function (e, t) {
                                    return this._callbacks = this._callbacks || {}, this._callbacks[e] || (this._callbacks[e] = []), this._callbacks[e].push(t), this
                                }
                            }, {
                                key: "emit",
                                value: function (t) {
                                    this._callbacks = this._callbacks || {};
                                    for (var n = this._callbacks[t], i = arguments.length, r = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) r[o - 1] = arguments[o];
                                    if (n) {
                                        var a, s = e(n, !0);
                                        try {
                                            for (s.s(); !(a = s.n()).done;) {
                                                var l = a.value;
                                                l.apply(this, r)
                                            }
                                        } catch (e) {
                                            s.e(e)
                                        } finally {
                                            s.f()
                                        }
                                    }
                                    return this.element && this.element.dispatchEvent(this.makeEvent("dropzone:" + t, {
                                        args: r
                                    })), this
                                }
                            }, {
                                key: "makeEvent",
                                value: function (e, t) {
                                    var n = {
                                        bubbles: !0,
                                        cancelable: !0,
                                        detail: t
                                    };
                                    if ("function" == typeof window.CustomEvent) return new CustomEvent(e, n);
                                    var i = document.createEvent("CustomEvent");
                                    return i.initCustomEvent(e, n.bubbles, n.cancelable, n.detail), i
                                }
                            }, {
                                key: "off",
                                value: function (e, t) {
                                    if (!this._callbacks || 0 === arguments.length) return this._callbacks = {}, this;
                                    var n = this._callbacks[e];
                                    if (!n) return this;
                                    if (1 === arguments.length) return delete this._callbacks[e], this;
                                    for (var i = 0; i < n.length; i++) {
                                        var r = n[i];
                                        if (r === t) {
                                            n.splice(i, 1);
                                            break
                                        }
                                    }
                                    return this
                                }
                            }], i && r(n.prototype, i), o && r(n, o), t
                        }();

                        function a(e, t) {
                            var n;
                            if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                if (Array.isArray(e) || (n = function (e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return s(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                    n && (e = n);
                                    var i = 0,
                                        r = function () {};
                                    return {
                                        s: r,
                                        n: function () {
                                            return i >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[i++]
                                            }
                                        },
                                        e: function (e) {
                                            throw e
                                        },
                                        f: r
                                    }
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                            }
                            var o, a = !0,
                                l = !1;
                            return {
                                s: function () {
                                    n = e[Symbol.iterator]()
                                },
                                n: function () {
                                    var e = n.next();
                                    return a = e.done, e
                                },
                                e: function (e) {
                                    l = !0, o = e
                                },
                                f: function () {
                                    try {
                                        a || null == n.return || n.return()
                                    } finally {
                                        if (l) throw o
                                    }
                                }
                            }
                        }

                        function s(e, t) {
                            (null == t || t > e.length) && (t = e.length);
                            for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                            return i
                        }
                        var l = {
                            url: null,
                            method: "post",
                            withCredentials: !1,
                            timeout: null,
                            parallelUploads: 2,
                            uploadMultiple: !1,
                            chunking: !1,
                            forceChunking: !1,
                            chunkSize: 2e6,
                            parallelChunkUploads: !1,
                            retryChunks: !1,
                            retryChunksLimit: 3,
                            maxFilesize: 256,
                            paramName: "file",
                            createImageThumbnails: !0,
                            maxThumbnailFilesize: 10,
                            thumbnailWidth: 120,
                            thumbnailHeight: 120,
                            thumbnailMethod: "crop",
                            resizeWidth: null,
                            resizeHeight: null,
                            resizeMimeType: null,
                            resizeQuality: .8,
                            resizeMethod: "contain",
                            filesizeBase: 1e3,
                            maxFiles: null,
                            headers: null,
                            clickable: !0,
                            ignoreHiddenFiles: !0,
                            acceptedFiles: null,
                            acceptedMimeTypes: null,
                            autoProcessQueue: !0,
                            autoQueue: !0,
                            addRemoveLinks: !1,
                            previewsContainer: null,
                            disablePreviews: !1,
                            hiddenInputContainer: "body",
                            capture: null,
                            renameFilename: null,
                            renameFile: null,
                            forceFallback: !1,
                            dictDefaultMessage: "Drop files here to upload",
                            dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
                            dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
                            dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
                            dictInvalidFileType: "You can't upload files of this type.",
                            dictResponseError: "Server responded with {{statusCode}} code.",
                            dictCancelUpload: "Cancel upload",
                            dictUploadCanceled: "Upload canceled.",
                            dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
                            dictRemoveFile: "Remove file",
                            dictRemoveFileConfirmation: null,
                            dictMaxFilesExceeded: "You can not upload any more files.",
                            dictFileSizeUnits: {
                                tb: "TB",
                                gb: "GB",
                                mb: "MB",
                                kb: "KB",
                                b: "b"
                            },
                            init: function () {},
                            params: function (e, t, n) {
                                if (n) return {
                                    dzuuid: n.file.upload.uuid,
                                    dzchunkindex: n.index,
                                    dztotalfilesize: n.file.size,
                                    dzchunksize: this.options.chunkSize,
                                    dztotalchunkcount: n.file.upload.totalChunkCount,
                                    dzchunkbyteoffset: n.index * this.options.chunkSize
                                }
                            },
                            accept: function (e, t) {
                                return t()
                            },
                            chunksUploaded: function (e, t) {
                                t()
                            },
                            fallback: function () {
                                var e;
                                this.element.className = "".concat(this.element.className, " dz-browser-not-supported");
                                var t, n = a(this.element.getElementsByTagName("div"), !0);
                                try {
                                    for (n.s(); !(t = n.n()).done;) {
                                        var i = t.value;
                                        if (/(^| )dz-message($| )/.test(i.className)) {
                                            e = i, i.className = "dz-message";
                                            break
                                        }
                                    }
                                } catch (e) {
                                    n.e(e)
                                } finally {
                                    n.f()
                                }
                                e || (e = _.createElement('<div class="dz-message"><span></span></div>'), this.element.appendChild(e));
                                var r = e.getElementsByTagName("span")[0];
                                return r && (null != r.textContent ? r.textContent = this.options.dictFallbackMessage : null != r.innerText && (r.innerText = this.options.dictFallbackMessage)), this.element.appendChild(this.getFallbackForm())
                            },
                            resize: function (e, t, n, i) {
                                var r = {
                                        srcX: 0,
                                        srcY: 0,
                                        srcWidth: e.width,
                                        srcHeight: e.height
                                    },
                                    o = e.width / e.height;
                                null == t && null == n ? (t = r.srcWidth, n = r.srcHeight) : null == t ? t = n * o : null == n && (n = t / o);
                                var a = (t = Math.min(t, r.srcWidth)) / (n = Math.min(n, r.srcHeight));
                                if (r.srcWidth > t || r.srcHeight > n)
                                    if ("crop" === i) o > a ? (r.srcHeight = e.height, r.srcWidth = r.srcHeight * a) : (r.srcWidth = e.width, r.srcHeight = r.srcWidth / a);
                                    else {
                                        if ("contain" !== i) throw new Error("Unknown resizeMethod '".concat(i, "'"));
                                        o > a ? n = t / o : t = n * o
                                    } return r.srcX = (e.width - r.srcWidth) / 2, r.srcY = (e.height - r.srcHeight) / 2, r.trgWidth = t, r.trgHeight = n, r
                            },
                            transformFile: function (e, t) {
                                return (this.options.resizeWidth || this.options.resizeHeight) && e.type.match(/image.*/) ? this.resizeImage(e, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, t) : t(e)
                            },
                            previewTemplate: '<div class="dz-preview dz-file-preview"> <div class="dz-image"><img data-dz-thumbnail/></div> <div class="dz-details"> <div class="dz-size"><span data-dz-size></span></div> <div class="dz-filename"><span data-dz-name></span></div> </div> <div class="dz-progress"> <span class="dz-upload" data-dz-uploadprogress></span> </div> <div class="dz-error-message"><span data-dz-errormessage></span></div> <div class="dz-success-mark"> <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Check</title> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF"></path> </g> </svg> </div> <div class="dz-error-mark"> <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <title>Error</title> <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475"> <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z"></path> </g> </g> </svg> </div> </div> ',
                            drop: function (e) {
                                return this.element.classList.remove("dz-drag-hover")
                            },
                            dragstart: function (e) {},
                            dragend: function (e) {
                                return this.element.classList.remove("dz-drag-hover")
                            },
                            dragenter: function (e) {
                                return this.element.classList.add("dz-drag-hover")
                            },
                            dragover: function (e) {
                                return this.element.classList.add("dz-drag-hover")
                            },
                            dragleave: function (e) {
                                return this.element.classList.remove("dz-drag-hover")
                            },
                            paste: function (e) {},
                            reset: function () {
                                return this.element.classList.remove("dz-started")
                            },
                            addedfile: function (e) {
                                var t = this;
                                if (this.element === this.previewsContainer && this.element.classList.add("dz-started"), this.previewsContainer && !this.options.disablePreviews) {
                                    e.previewElement = _.createElement(this.options.previewTemplate.trim()), e.previewTemplate = e.previewElement, this.previewsContainer.appendChild(e.previewElement);
                                    var n, i = a(e.previewElement.querySelectorAll("[data-dz-name]"), !0);
                                    try {
                                        for (i.s(); !(n = i.n()).done;) {
                                            var r = n.value;
                                            r.textContent = e.name
                                        }
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                    var o, s = a(e.previewElement.querySelectorAll("[data-dz-size]"), !0);
                                    try {
                                        for (s.s(); !(o = s.n()).done;)(r = o.value).innerHTML = this.filesize(e.size)
                                    } catch (e) {
                                        s.e(e)
                                    } finally {
                                        s.f()
                                    }
                                    this.options.addRemoveLinks && (e._removeLink = _.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'.concat(this.options.dictRemoveFile, "</a>")), e.previewElement.appendChild(e._removeLink));
                                    var l, c = function (n) {
                                            return n.preventDefault(), n.stopPropagation(), e.status === _.UPLOADING ? _.confirm(t.options.dictCancelUploadConfirmation, (function () {
                                                return t.removeFile(e)
                                            })) : t.options.dictRemoveFileConfirmation ? _.confirm(t.options.dictRemoveFileConfirmation, (function () {
                                                return t.removeFile(e)
                                            })) : t.removeFile(e)
                                        },
                                        u = a(e.previewElement.querySelectorAll("[data-dz-remove]"), !0);
                                    try {
                                        for (u.s(); !(l = u.n()).done;) l.value.addEventListener("click", c)
                                    } catch (e) {
                                        u.e(e)
                                    } finally {
                                        u.f()
                                    }
                                }
                            },
                            removedfile: function (e) {
                                return null != e.previewElement && null != e.previewElement.parentNode && e.previewElement.parentNode.removeChild(e.previewElement), this._updateMaxFilesReachedClass()
                            },
                            thumbnail: function (e, t) {
                                if (e.previewElement) {
                                    e.previewElement.classList.remove("dz-file-preview");
                                    var n, i = a(e.previewElement.querySelectorAll("[data-dz-thumbnail]"), !0);
                                    try {
                                        for (i.s(); !(n = i.n()).done;) {
                                            var r = n.value;
                                            r.alt = e.name, r.src = t
                                        }
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                    return setTimeout((function () {
                                        return e.previewElement.classList.add("dz-image-preview")
                                    }), 1)
                                }
                            },
                            error: function (e, t) {
                                if (e.previewElement) {
                                    e.previewElement.classList.add("dz-error"), "string" != typeof t && t.error && (t = t.error);
                                    var n, i = a(e.previewElement.querySelectorAll("[data-dz-errormessage]"), !0);
                                    try {
                                        for (i.s(); !(n = i.n()).done;) n.value.textContent = t
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                }
                            },
                            errormultiple: function () {},
                            processing: function (e) {
                                if (e.previewElement && (e.previewElement.classList.add("dz-processing"), e._removeLink)) return e._removeLink.innerHTML = this.options.dictCancelUpload
                            },
                            processingmultiple: function () {},
                            uploadprogress: function (e, t, n) {
                                if (e.previewElement) {
                                    var i, r = a(e.previewElement.querySelectorAll("[data-dz-uploadprogress]"), !0);
                                    try {
                                        for (r.s(); !(i = r.n()).done;) {
                                            var o = i.value;
                                            "PROGRESS" === o.nodeName ? o.value = t : o.style.width = "".concat(t, "%")
                                        }
                                    } catch (e) {
                                        r.e(e)
                                    } finally {
                                        r.f()
                                    }
                                }
                            },
                            totaluploadprogress: function () {},
                            sending: function () {},
                            sendingmultiple: function () {},
                            success: function (e) {
                                if (e.previewElement) return e.previewElement.classList.add("dz-success")
                            },
                            successmultiple: function () {},
                            canceled: function (e) {
                                return this.emit("error", e, this.options.dictUploadCanceled)
                            },
                            canceledmultiple: function () {},
                            complete: function (e) {
                                if (e._removeLink && (e._removeLink.innerHTML = this.options.dictRemoveFile), e.previewElement) return e.previewElement.classList.add("dz-complete")
                            },
                            completemultiple: function () {},
                            maxfilesexceeded: function () {},
                            maxfilesreached: function () {},
                            queuecomplete: function () {},
                            addedfiles: function () {}
                        };

                        function c(e) {
                            return c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                return typeof e
                            } : function (e) {
                                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                            }, c(e)
                        }

                        function u(e, t) {
                            var n;
                            if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
                                if (Array.isArray(e) || (n = function (e, t) {
                                        if (e) {
                                            if ("string" == typeof e) return d(e, t);
                                            var n = Object.prototype.toString.call(e).slice(8, -1);
                                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e, t) : void 0
                                        }
                                    }(e)) || t && e && "number" == typeof e.length) {
                                    n && (e = n);
                                    var i = 0,
                                        r = function () {};
                                    return {
                                        s: r,
                                        n: function () {
                                            return i >= e.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: e[i++]
                                            }
                                        },
                                        e: function (e) {
                                            throw e
                                        },
                                        f: r
                                    }
                                }
                                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                            }
                            var o, a = !0,
                                s = !1;
                            return {
                                s: function () {
                                    n = e[Symbol.iterator]()
                                },
                                n: function () {
                                    var e = n.next();
                                    return a = e.done, e
                                },
                                e: function (e) {
                                    s = !0, o = e
                                },
                                f: function () {
                                    try {
                                        a || null == n.return || n.return()
                                    } finally {
                                        if (s) throw o
                                    }
                                }
                            }
                        }

                        function d(e, t) {
                            (null == t || t > e.length) && (t = e.length);
                            for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
                            return i
                        }

                        function h(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                        }

                        function f(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                            }
                        }

                        function p(e, t, n) {
                            return t && f(e.prototype, t), n && f(e, n), e
                        }

                        function g(e, t) {
                            return g = Object.setPrototypeOf || function (e, t) {
                                return e.__proto__ = t, e
                            }, g(e, t)
                        }

                        function m(e) {
                            var t = function () {
                                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                if (Reflect.construct.sham) return !1;
                                if ("function" == typeof Proxy) return !0;
                                try {
                                    return Date.prototype.toString.call(Reflect.construct(Date, [], (function () {}))), !0
                                } catch (e) {
                                    return !1
                                }
                            }();
                            return function () {
                                var n, i = y(e);
                                if (t) {
                                    var r = y(this).constructor;
                                    n = Reflect.construct(i, arguments, r)
                                } else n = i.apply(this, arguments);
                                return v(this, n)
                            }
                        }

                        function v(e, t) {
                            return !t || "object" !== c(t) && "function" != typeof t ? b(e) : t
                        }

                        function b(e) {
                            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return e
                        }

                        function y(e) {
                            return y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                                return e.__proto__ || Object.getPrototypeOf(e)
                            }, y(e)
                        }
                        var _ = function (e) {
                            ! function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && g(e, t)
                            }(n, e);
                            var t = m(n);

                            function n(e, i) {
                                var r, o, a;
                                if (h(this, n), (r = t.call(this)).element = e, r.version = n.version, r.clickableElements = [], r.listeners = [], r.files = [], "string" == typeof r.element && (r.element = document.querySelector(r.element)), !r.element || null == r.element.nodeType) throw new Error("Invalid dropzone element.");
                                if (r.element.dropzone) throw new Error("Dropzone already attached.");
                                n.instances.push(b(r)), r.element.dropzone = b(r);
                                var s = null != (a = n.optionsForElement(r.element)) ? a : {};
                                if (r.options = n.extend({}, l, s, null != i ? i : {}), r.options.previewTemplate = r.options.previewTemplate.replace(/\n*/g, ""), r.options.forceFallback || !n.isBrowserSupported()) return v(r, r.options.fallback.call(b(r)));
                                if (null == r.options.url && (r.options.url = r.element.getAttribute("action")), !r.options.url) throw new Error("No URL provided.");
                                if (r.options.acceptedFiles && r.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
                                if (r.options.uploadMultiple && r.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
                                return r.options.acceptedMimeTypes && (r.options.acceptedFiles = r.options.acceptedMimeTypes, delete r.options.acceptedMimeTypes), null != r.options.renameFilename && (r.options.renameFile = function (e) {
                                    return r.options.renameFilename.call(b(r), e.name, e)
                                }), "string" == typeof r.options.method && (r.options.method = r.options.method.toUpperCase()), (o = r.getExistingFallback()) && o.parentNode && o.parentNode.removeChild(o), !1 !== r.options.previewsContainer && (r.options.previewsContainer ? r.previewsContainer = n.getElement(r.options.previewsContainer, "previewsContainer") : r.previewsContainer = r.element), r.options.clickable && (!0 === r.options.clickable ? r.clickableElements = [r.element] : r.clickableElements = n.getElements(r.options.clickable, "clickable")), r.init(), r
                            }
                            return p(n, [{
                                key: "getAcceptedFiles",
                                value: function () {
                                    return this.files.filter((function (e) {
                                        return e.accepted
                                    })).map((function (e) {
                                        return e
                                    }))
                                }
                            }, {
                                key: "getRejectedFiles",
                                value: function () {
                                    return this.files.filter((function (e) {
                                        return !e.accepted
                                    })).map((function (e) {
                                        return e
                                    }))
                                }
                            }, {
                                key: "getFilesWithStatus",
                                value: function (e) {
                                    return this.files.filter((function (t) {
                                        return t.status === e
                                    })).map((function (e) {
                                        return e
                                    }))
                                }
                            }, {
                                key: "getQueuedFiles",
                                value: function () {
                                    return this.getFilesWithStatus(n.QUEUED)
                                }
                            }, {
                                key: "getUploadingFiles",
                                value: function () {
                                    return this.getFilesWithStatus(n.UPLOADING)
                                }
                            }, {
                                key: "getAddedFiles",
                                value: function () {
                                    return this.getFilesWithStatus(n.ADDED)
                                }
                            }, {
                                key: "getActiveFiles",
                                value: function () {
                                    return this.files.filter((function (e) {
                                        return e.status === n.UPLOADING || e.status === n.QUEUED
                                    })).map((function (e) {
                                        return e
                                    }))
                                }
                            }, {
                                key: "init",
                                value: function () {
                                    var e = this;
                                    "form" === this.element.tagName && this.element.setAttribute("enctype", "multipart/form-data"), this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message") && this.element.appendChild(n.createElement('<div class="dz-default dz-message"><button class="dz-button" type="button">'.concat(this.options.dictDefaultMessage, "</button></div>"))), this.clickableElements.length && function t() {
                                        e.hiddenFileInput && e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput), e.hiddenFileInput = document.createElement("input"), e.hiddenFileInput.setAttribute("type", "file"), (null === e.options.maxFiles || e.options.maxFiles > 1) && e.hiddenFileInput.setAttribute("multiple", "multiple"), e.hiddenFileInput.className = "dz-hidden-input", null !== e.options.acceptedFiles && e.hiddenFileInput.setAttribute("accept", e.options.acceptedFiles), null !== e.options.capture && e.hiddenFileInput.setAttribute("capture", e.options.capture), e.hiddenFileInput.setAttribute("tabindex", "-1"), e.hiddenFileInput.style.visibility = "hidden", e.hiddenFileInput.style.position = "absolute", e.hiddenFileInput.style.top = "0", e.hiddenFileInput.style.left = "0", e.hiddenFileInput.style.height = "0", e.hiddenFileInput.style.width = "0", n.getElement(e.options.hiddenInputContainer, "hiddenInputContainer").appendChild(e.hiddenFileInput), e.hiddenFileInput.addEventListener("change", (function () {
                                            var n = e.hiddenFileInput.files;
                                            if (n.length) {
                                                var i, r = u(n, !0);
                                                try {
                                                    for (r.s(); !(i = r.n()).done;) {
                                                        var o = i.value;
                                                        e.addFile(o)
                                                    }
                                                } catch (e) {
                                                    r.e(e)
                                                } finally {
                                                    r.f()
                                                }
                                            }
                                            e.emit("addedfiles", n), t()
                                        }))
                                    }(), this.URL = null !== window.URL ? window.URL : window.webkitURL;
                                    var t, i = u(this.events, !0);
                                    try {
                                        for (i.s(); !(t = i.n()).done;) {
                                            var r = t.value;
                                            this.on(r, this.options[r])
                                        }
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                    this.on("uploadprogress", (function () {
                                        return e.updateTotalUploadProgress()
                                    })), this.on("removedfile", (function () {
                                        return e.updateTotalUploadProgress()
                                    })), this.on("canceled", (function (t) {
                                        return e.emit("complete", t)
                                    })), this.on("complete", (function (t) {
                                        if (0 === e.getAddedFiles().length && 0 === e.getUploadingFiles().length && 0 === e.getQueuedFiles().length) return setTimeout((function () {
                                            return e.emit("queuecomplete")
                                        }), 0)
                                    }));
                                    var o = function (e) {
                                        if (function (e) {
                                                if (e.dataTransfer.types)
                                                    for (var t = 0; t < e.dataTransfer.types.length; t++)
                                                        if ("Files" === e.dataTransfer.types[t]) return !0;
                                                return !1
                                            }(e)) return e.stopPropagation(), e.preventDefault ? e.preventDefault() : e.returnValue = !1
                                    };
                                    return this.listeners = [{
                                        element: this.element,
                                        events: {
                                            dragstart: function (t) {
                                                return e.emit("dragstart", t)
                                            },
                                            dragenter: function (t) {
                                                return o(t), e.emit("dragenter", t)
                                            },
                                            dragover: function (t) {
                                                var n;
                                                try {
                                                    n = t.dataTransfer.effectAllowed
                                                } catch (e) {}
                                                return t.dataTransfer.dropEffect = "move" === n || "linkMove" === n ? "move" : "copy", o(t), e.emit("dragover", t)
                                            },
                                            dragleave: function (t) {
                                                return e.emit("dragleave", t)
                                            },
                                            drop: function (t) {
                                                return o(t), e.drop(t)
                                            },
                                            dragend: function (t) {
                                                return e.emit("dragend", t)
                                            }
                                        }
                                    }], this.clickableElements.forEach((function (t) {
                                        return e.listeners.push({
                                            element: t,
                                            events: {
                                                click: function (i) {
                                                    return (t !== e.element || i.target === e.element || n.elementInside(i.target, e.element.querySelector(".dz-message"))) && e.hiddenFileInput.click(), !0
                                                }
                                            }
                                        })
                                    })), this.enable(), this.options.init.call(this)
                                }
                            }, {
                                key: "destroy",
                                value: function () {
                                    return this.disable(), this.removeAllFiles(!0), (null != this.hiddenFileInput ? this.hiddenFileInput.parentNode : void 0) && (this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput), this.hiddenFileInput = null), delete this.element.dropzone, n.instances.splice(n.instances.indexOf(this), 1)
                                }
                            }, {
                                key: "updateTotalUploadProgress",
                                value: function () {
                                    var e, t = 0,
                                        n = 0;
                                    if (this.getActiveFiles().length) {
                                        var i, r = u(this.getActiveFiles(), !0);
                                        try {
                                            for (r.s(); !(i = r.n()).done;) {
                                                var o = i.value;
                                                t += o.upload.bytesSent, n += o.upload.total
                                            }
                                        } catch (e) {
                                            r.e(e)
                                        } finally {
                                            r.f()
                                        }
                                        e = 100 * t / n
                                    } else e = 100;
                                    return this.emit("totaluploadprogress", e, n, t)
                                }
                            }, {
                                key: "_getParamName",
                                value: function (e) {
                                    return "function" == typeof this.options.paramName ? this.options.paramName(e) : "".concat(this.options.paramName).concat(this.options.uploadMultiple ? "[".concat(e, "]") : "")
                                }
                            }, {
                                key: "_renameFile",
                                value: function (e) {
                                    return "function" != typeof this.options.renameFile ? e.name : this.options.renameFile(e)
                                }
                            }, {
                                key: "getFallbackForm",
                                value: function () {
                                    var e, t;
                                    if (e = this.getExistingFallback()) return e;
                                    var i = '<div class="dz-fallback">';
                                    this.options.dictFallbackText && (i += "<p>".concat(this.options.dictFallbackText, "</p>")), i += '<input type="file" name="'.concat(this._getParamName(0), '" ').concat(this.options.uploadMultiple ? 'multiple="multiple"' : void 0, ' /><input type="submit" value="Upload!"></div>');
                                    var r = n.createElement(i);
                                    return "FORM" !== this.element.tagName ? (t = n.createElement('<form action="'.concat(this.options.url, '" enctype="multipart/form-data" method="').concat(this.options.method, '"></form>'))).appendChild(r) : (this.element.setAttribute("enctype", "multipart/form-data"), this.element.setAttribute("method", this.options.method)), null != t ? t : r
                                }
                            }, {
                                key: "getExistingFallback",
                                value: function () {
                                    for (var e = function (e) {
                                            var t, n = u(e, !0);
                                            try {
                                                for (n.s(); !(t = n.n()).done;) {
                                                    var i = t.value;
                                                    if (/(^| )fallback($| )/.test(i.className)) return i
                                                }
                                            } catch (e) {
                                                n.e(e)
                                            } finally {
                                                n.f()
                                            }
                                        }, t = 0, n = ["div", "form"]; t < n.length; t++) {
                                        var i, r = n[t];
                                        if (i = e(this.element.getElementsByTagName(r))) return i
                                    }
                                }
                            }, {
                                key: "setupEventListeners",
                                value: function () {
                                    return this.listeners.map((function (e) {
                                        return function () {
                                            var t = [];
                                            for (var n in e.events) {
                                                var i = e.events[n];
                                                t.push(e.element.addEventListener(n, i, !1))
                                            }
                                            return t
                                        }()
                                    }))
                                }
                            }, {
                                key: "removeEventListeners",
                                value: function () {
                                    return this.listeners.map((function (e) {
                                        return function () {
                                            var t = [];
                                            for (var n in e.events) {
                                                var i = e.events[n];
                                                t.push(e.element.removeEventListener(n, i, !1))
                                            }
                                            return t
                                        }()
                                    }))
                                }
                            }, {
                                key: "disable",
                                value: function () {
                                    var e = this;
                                    return this.clickableElements.forEach((function (e) {
                                        return e.classList.remove("dz-clickable")
                                    })), this.removeEventListeners(), this.disabled = !0, this.files.map((function (t) {
                                        return e.cancelUpload(t)
                                    }))
                                }
                            }, {
                                key: "enable",
                                value: function () {
                                    return delete this.disabled, this.clickableElements.forEach((function (e) {
                                        return e.classList.add("dz-clickable")
                                    })), this.setupEventListeners()
                                }
                            }, {
                                key: "filesize",
                                value: function (e) {
                                    var t = 0,
                                        n = "b";
                                    if (e > 0) {
                                        for (var i = ["tb", "gb", "mb", "kb", "b"], r = 0; r < i.length; r++) {
                                            var o = i[r];
                                            if (e >= Math.pow(this.options.filesizeBase, 4 - r) / 10) {
                                                t = e / Math.pow(this.options.filesizeBase, 4 - r), n = o;
                                                break
                                            }
                                        }
                                        t = Math.round(10 * t) / 10
                                    }
                                    return "<strong>".concat(t, "</strong> ").concat(this.options.dictFileSizeUnits[n])
                                }
                            }, {
                                key: "_updateMaxFilesReachedClass",
                                value: function () {
                                    return null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (this.getAcceptedFiles().length === this.options.maxFiles && this.emit("maxfilesreached", this.files), this.element.classList.add("dz-max-files-reached")) : this.element.classList.remove("dz-max-files-reached")
                                }
                            }, {
                                key: "drop",
                                value: function (e) {
                                    if (e.dataTransfer) {
                                        this.emit("drop", e);
                                        for (var t = [], n = 0; n < e.dataTransfer.files.length; n++) t[n] = e.dataTransfer.files[n];
                                        if (t.length) {
                                            var i = e.dataTransfer.items;
                                            i && i.length && null != i[0].webkitGetAsEntry ? this._addFilesFromItems(i) : this.handleFiles(t)
                                        }
                                        this.emit("addedfiles", t)
                                    }
                                }
                            }, {
                                key: "paste",
                                value: function (e) {
                                    if (null != (t = null != e ? e.clipboardData : void 0, n = function (e) {
                                            return e.items
                                        }, null != t ? n(t) : void 0)) {
                                        var t, n;
                                        this.emit("paste", e);
                                        var i = e.clipboardData.items;
                                        return i.length ? this._addFilesFromItems(i) : void 0
                                    }
                                }
                            }, {
                                key: "handleFiles",
                                value: function (e) {
                                    var t, n = u(e, !0);
                                    try {
                                        for (n.s(); !(t = n.n()).done;) {
                                            var i = t.value;
                                            this.addFile(i)
                                        }
                                    } catch (e) {
                                        n.e(e)
                                    } finally {
                                        n.f()
                                    }
                                }
                            }, {
                                key: "_addFilesFromItems",
                                value: function (e) {
                                    var t = this;
                                    return function () {
                                        var n, i = [],
                                            r = u(e, !0);
                                        try {
                                            for (r.s(); !(n = r.n()).done;) {
                                                var o, a = n.value;
                                                null != a.webkitGetAsEntry && (o = a.webkitGetAsEntry()) ? o.isFile ? i.push(t.addFile(a.getAsFile())) : o.isDirectory ? i.push(t._addFilesFromDirectory(o, o.name)) : i.push(void 0) : null == a.getAsFile || null != a.kind && "file" !== a.kind ? i.push(void 0) : i.push(t.addFile(a.getAsFile()))
                                            }
                                        } catch (e) {
                                            r.e(e)
                                        } finally {
                                            r.f()
                                        }
                                        return i
                                    }()
                                }
                            }, {
                                key: "_addFilesFromDirectory",
                                value: function (e, t) {
                                    var n = this,
                                        i = e.createReader(),
                                        r = function (e) {
                                            return t = console, n = "log", i = function (t) {
                                                return t.log(e)
                                            }, null != t && "function" == typeof t[n] ? i(t, n) : void 0;
                                            var t, n, i
                                        };
                                    return function e() {
                                        return i.readEntries((function (i) {
                                            if (i.length > 0) {
                                                var r, o = u(i, !0);
                                                try {
                                                    for (o.s(); !(r = o.n()).done;) {
                                                        var a = r.value;
                                                        a.isFile ? a.file((function (e) {
                                                            if (!n.options.ignoreHiddenFiles || "." !== e.name.substring(0, 1)) return e.fullPath = "".concat(t, "/").concat(e.name), n.addFile(e)
                                                        })) : a.isDirectory && n._addFilesFromDirectory(a, "".concat(t, "/").concat(a.name))
                                                    }
                                                } catch (e) {
                                                    o.e(e)
                                                } finally {
                                                    o.f()
                                                }
                                                e()
                                            }
                                            return null
                                        }), r)
                                    }()
                                }
                            }, {
                                key: "accept",
                                value: function (e, t) {
                                    this.options.maxFilesize && e.size > 1024 * this.options.maxFilesize * 1024 ? t(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(e.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize)) : n.isValidFile(e, this.options.acceptedFiles) ? null != this.options.maxFiles && this.getAcceptedFiles().length >= this.options.maxFiles ? (t(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles)), this.emit("maxfilesexceeded", e)) : this.options.accept.call(this, e, t) : t(this.options.dictInvalidFileType)
                                }
                            }, {
                                key: "addFile",
                                value: function (e) {
                                    var t = this;
                                    e.upload = {
                                        uuid: n.uuidv4(),
                                        progress: 0,
                                        total: e.size,
                                        bytesSent: 0,
                                        filename: this._renameFile(e)
                                    }, this.files.push(e), e.status = n.ADDED, this.emit("addedfile", e), this._enqueueThumbnail(e), this.accept(e, (function (n) {
                                        n ? (e.accepted = !1, t._errorProcessing([e], n)) : (e.accepted = !0, t.options.autoQueue && t.enqueueFile(e)), t._updateMaxFilesReachedClass()
                                    }))
                                }
                            }, {
                                key: "enqueueFiles",
                                value: function (e) {
                                    var t, n = u(e, !0);
                                    try {
                                        for (n.s(); !(t = n.n()).done;) {
                                            var i = t.value;
                                            this.enqueueFile(i)
                                        }
                                    } catch (e) {
                                        n.e(e)
                                    } finally {
                                        n.f()
                                    }
                                    return null
                                }
                            }, {
                                key: "enqueueFile",
                                value: function (e) {
                                    var t = this;
                                    if (e.status !== n.ADDED || !0 !== e.accepted) throw new Error("This file can't be queued because it has already been processed or was rejected.");
                                    if (e.status = n.QUEUED, this.options.autoProcessQueue) return setTimeout((function () {
                                        return t.processQueue()
                                    }), 0)
                                }
                            }, {
                                key: "_enqueueThumbnail",
                                value: function (e) {
                                    var t = this;
                                    if (this.options.createImageThumbnails && e.type.match(/image.*/) && e.size <= 1024 * this.options.maxThumbnailFilesize * 1024) return this._thumbnailQueue.push(e), setTimeout((function () {
                                        return t._processThumbnailQueue()
                                    }), 0)
                                }
                            }, {
                                key: "_processThumbnailQueue",
                                value: function () {
                                    var e = this;
                                    if (!this._processingThumbnail && 0 !== this._thumbnailQueue.length) {
                                        this._processingThumbnail = !0;
                                        var t = this._thumbnailQueue.shift();
                                        return this.createThumbnail(t, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, !0, (function (n) {
                                            return e.emit("thumbnail", t, n), e._processingThumbnail = !1, e._processThumbnailQueue()
                                        }))
                                    }
                                }
                            }, {
                                key: "removeFile",
                                value: function (e) {
                                    if (e.status === n.UPLOADING && this.cancelUpload(e), this.files = x(this.files, e), this.emit("removedfile", e), 0 === this.files.length) return this.emit("reset")
                                }
                            }, {
                                key: "removeAllFiles",
                                value: function (e) {
                                    null == e && (e = !1);
                                    var t, i = u(this.files.slice(), !0);
                                    try {
                                        for (i.s(); !(t = i.n()).done;) {
                                            var r = t.value;
                                            (r.status !== n.UPLOADING || e) && this.removeFile(r)
                                        }
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                    return null
                                }
                            }, {
                                key: "resizeImage",
                                value: function (e, t, i, r, o) {
                                    var a = this;
                                    return this.createThumbnail(e, t, i, r, !0, (function (t, i) {
                                        if (null == i) return o(e);
                                        var r = a.options.resizeMimeType;
                                        null == r && (r = e.type);
                                        var s = i.toDataURL(r, a.options.resizeQuality);
                                        return "image/jpeg" !== r && "image/jpg" !== r || (s = k.restore(e.dataURL, s)), o(n.dataURItoBlob(s))
                                    }))
                                }
                            }, {
                                key: "createThumbnail",
                                value: function (e, t, n, i, r, o) {
                                    var a = this,
                                        s = new FileReader;
                                    s.onload = function () {
                                        e.dataURL = s.result, "image/svg+xml" !== e.type ? a.createThumbnailFromUrl(e, t, n, i, r, o) : null != o && o(s.result)
                                    }, s.readAsDataURL(e)
                                }
                            }, {
                                key: "displayExistingFile",
                                value: function (e, t, n, i) {
                                    var r = this,
                                        o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4];
                                    if (this.emit("addedfile", e), this.emit("complete", e), o) {
                                        var a = function (t) {
                                            r.emit("thumbnail", e, t), n && n()
                                        };
                                        e.dataURL = t, this.createThumbnailFromUrl(e, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, a, i)
                                    } else this.emit("thumbnail", e, t), n && n()
                                }
                            }, {
                                key: "createThumbnailFromUrl",
                                value: function (e, t, n, i, r, o, a) {
                                    var s = this,
                                        l = document.createElement("img");
                                    return a && (l.crossOrigin = a), r = "from-image" != getComputedStyle(document.body).imageOrientation && r, l.onload = function () {
                                        var a = function (e) {
                                            return e(1)
                                        };
                                        return "undefined" != typeof EXIF && null !== EXIF && r && (a = function (e) {
                                            return EXIF.getData(l, (function () {
                                                return e(EXIF.getTag(this, "Orientation"))
                                            }))
                                        }), a((function (r) {
                                            e.width = l.width, e.height = l.height;
                                            var a = s.options.resize.call(s, e, t, n, i),
                                                c = document.createElement("canvas"),
                                                u = c.getContext("2d");
                                            switch (c.width = a.trgWidth, c.height = a.trgHeight, r > 4 && (c.width = a.trgHeight, c.height = a.trgWidth), r) {
                                                case 2:
                                                    u.translate(c.width, 0), u.scale(-1, 1);
                                                    break;
                                                case 3:
                                                    u.translate(c.width, c.height), u.rotate(Math.PI);
                                                    break;
                                                case 4:
                                                    u.translate(0, c.height), u.scale(1, -1);
                                                    break;
                                                case 5:
                                                    u.rotate(.5 * Math.PI), u.scale(1, -1);
                                                    break;
                                                case 6:
                                                    u.rotate(.5 * Math.PI), u.translate(0, -c.width);
                                                    break;
                                                case 7:
                                                    u.rotate(.5 * Math.PI), u.translate(c.height, -c.width), u.scale(-1, 1);
                                                    break;
                                                case 8:
                                                    u.rotate(-.5 * Math.PI), u.translate(-c.height, 0)
                                            }
                                            E(u, l, null != a.srcX ? a.srcX : 0, null != a.srcY ? a.srcY : 0, a.srcWidth, a.srcHeight, null != a.trgX ? a.trgX : 0, null != a.trgY ? a.trgY : 0, a.trgWidth, a.trgHeight);
                                            var d = c.toDataURL("image/png");
                                            if (null != o) return o(d, c)
                                        }))
                                    }, null != o && (l.onerror = o), l.src = e.dataURL
                                }
                            }, {
                                key: "processQueue",
                                value: function () {
                                    var e = this.options.parallelUploads,
                                        t = this.getUploadingFiles().length,
                                        n = t;
                                    if (!(t >= e)) {
                                        var i = this.getQueuedFiles();
                                        if (i.length > 0) {
                                            if (this.options.uploadMultiple) return this.processFiles(i.slice(0, e - t));
                                            for (; n < e;) {
                                                if (!i.length) return;
                                                this.processFile(i.shift()), n++
                                            }
                                        }
                                    }
                                }
                            }, {
                                key: "processFile",
                                value: function (e) {
                                    return this.processFiles([e])
                                }
                            }, {
                                key: "processFiles",
                                value: function (e) {
                                    var t, i = u(e, !0);
                                    try {
                                        for (i.s(); !(t = i.n()).done;) {
                                            var r = t.value;
                                            r.processing = !0, r.status = n.UPLOADING, this.emit("processing", r)
                                        }
                                    } catch (e) {
                                        i.e(e)
                                    } finally {
                                        i.f()
                                    }
                                    return this.options.uploadMultiple && this.emit("processingmultiple", e), this.uploadFiles(e)
                                }
                            }, {
                                key: "_getFilesWithXhr",
                                value: function (e) {
                                    return this.files.filter((function (t) {
                                        return t.xhr === e
                                    })).map((function (e) {
                                        return e
                                    }))
                                }
                            }, {
                                key: "cancelUpload",
                                value: function (e) {
                                    if (e.status === n.UPLOADING) {
                                        var t, i = this._getFilesWithXhr(e.xhr),
                                            r = u(i, !0);
                                        try {
                                            for (r.s(); !(t = r.n()).done;) t.value.status = n.CANCELED
                                        } catch (e) {
                                            r.e(e)
                                        } finally {
                                            r.f()
                                        }
                                        void 0 !== e.xhr && e.xhr.abort();
                                        var o, a = u(i, !0);
                                        try {
                                            for (a.s(); !(o = a.n()).done;) {
                                                var s = o.value;
                                                this.emit("canceled", s)
                                            }
                                        } catch (e) {
                                            a.e(e)
                                        } finally {
                                            a.f()
                                        }
                                        this.options.uploadMultiple && this.emit("canceledmultiple", i)
                                    } else e.status !== n.ADDED && e.status !== n.QUEUED || (e.status = n.CANCELED, this.emit("canceled", e), this.options.uploadMultiple && this.emit("canceledmultiple", [e]));
                                    if (this.options.autoProcessQueue) return this.processQueue()
                                }
                            }, {
                                key: "resolveOption",
                                value: function (e) {
                                    if ("function" == typeof e) {
                                        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
                                        return e.apply(this, n)
                                    }
                                    return e
                                }
                            }, {
                                key: "uploadFile",
                                value: function (e) {
                                    return this.uploadFiles([e])
                                }
                            }, {
                                key: "uploadFiles",
                                value: function (e) {
                                    var t = this;
                                    this._transformFiles(e, (function (i) {
                                        if (t.options.chunking) {
                                            var r = i[0];
                                            e[0].upload.chunked = t.options.chunking && (t.options.forceChunking || r.size > t.options.chunkSize), e[0].upload.totalChunkCount = Math.ceil(r.size / t.options.chunkSize)
                                        }
                                        if (e[0].upload.chunked) {
                                            var o = e[0],
                                                a = i[0];
                                            o.upload.chunks = [];
                                            var s = function () {
                                                for (var i = 0; void 0 !== o.upload.chunks[i];) i++;
                                                if (!(i >= o.upload.totalChunkCount)) {
                                                    var r = i * t.options.chunkSize,
                                                        s = Math.min(r + t.options.chunkSize, a.size),
                                                        l = {
                                                            name: t._getParamName(0),
                                                            data: a.webkitSlice ? a.webkitSlice(r, s) : a.slice(r, s),
                                                            filename: o.upload.filename,
                                                            chunkIndex: i
                                                        };
                                                    o.upload.chunks[i] = {
                                                        file: o,
                                                        index: i,
                                                        dataBlock: l,
                                                        status: n.UPLOADING,
                                                        progress: 0,
                                                        retries: 0
                                                    }, t._uploadData(e, [l])
                                                }
                                            };
                                            if (o.upload.finishedChunkUpload = function (i, r) {
                                                    var a = !0;
                                                    i.status = n.SUCCESS, i.dataBlock = null, i.xhr = null;
                                                    for (var l = 0; l < o.upload.totalChunkCount; l++) {
                                                        if (void 0 === o.upload.chunks[l]) return s();
                                                        o.upload.chunks[l].status !== n.SUCCESS && (a = !1)
                                                    }
                                                    a && t.options.chunksUploaded(o, (function () {
                                                        t._finished(e, r, null)
                                                    }))
                                                }, t.options.parallelChunkUploads)
                                                for (var l = 0; l < o.upload.totalChunkCount; l++) s();
                                            else s()
                                        } else {
                                            for (var c = [], u = 0; u < e.length; u++) c[u] = {
                                                name: t._getParamName(u),
                                                data: i[u],
                                                filename: e[u].upload.filename
                                            };
                                            t._uploadData(e, c)
                                        }
                                    }))
                                }
                            }, {
                                key: "_getChunk",
                                value: function (e, t) {
                                    for (var n = 0; n < e.upload.totalChunkCount; n++)
                                        if (void 0 !== e.upload.chunks[n] && e.upload.chunks[n].xhr === t) return e.upload.chunks[n]
                                }
                            }, {
                                key: "_uploadData",
                                value: function (e, t) {
                                    var i, r = this,
                                        o = new XMLHttpRequest,
                                        a = u(e, !0);
                                    try {
                                        for (a.s(); !(i = a.n()).done;) i.value.xhr = o
                                    } catch (e) {
                                        a.e(e)
                                    } finally {
                                        a.f()
                                    }
                                    e[0].upload.chunked && (e[0].upload.chunks[t[0].chunkIndex].xhr = o);
                                    var s = this.resolveOption(this.options.method, e),
                                        l = this.resolveOption(this.options.url, e);
                                    o.open(s, l, !0), this.resolveOption(this.options.timeout, e) && (o.timeout = this.resolveOption(this.options.timeout, e)), o.withCredentials = !!this.options.withCredentials, o.onload = function (t) {
                                        r._finishedUploading(e, o, t)
                                    }, o.ontimeout = function () {
                                        r._handleUploadError(e, o, "Request timedout after ".concat(r.options.timeout / 1e3, " seconds"))
                                    }, o.onerror = function () {
                                        r._handleUploadError(e, o)
                                    }, (null != o.upload ? o.upload : o).onprogress = function (t) {
                                        return r._updateFilesUploadProgress(e, o, t)
                                    };
                                    var c = {
                                        Accept: "application/json",
                                        "Cache-Control": "no-cache",
                                        "X-Requested-With": "XMLHttpRequest"
                                    };
                                    for (var d in this.options.headers && n.extend(c, this.options.headers), c) {
                                        var h = c[d];
                                        h && o.setRequestHeader(d, h)
                                    }
                                    var f = new FormData;
                                    if (this.options.params) {
                                        var p = this.options.params;
                                        for (var g in "function" == typeof p && (p = p.call(this, e, o, e[0].upload.chunked ? this._getChunk(e[0], o) : null)), p) {
                                            var m = p[g];
                                            if (Array.isArray(m))
                                                for (var v = 0; v < m.length; v++) f.append(g, m[v]);
                                            else f.append(g, m)
                                        }
                                    }
                                    var b, y = u(e, !0);
                                    try {
                                        for (y.s(); !(b = y.n()).done;) {
                                            var _ = b.value;
                                            this.emit("sending", _, o, f)
                                        }
                                    } catch (e) {
                                        y.e(e)
                                    } finally {
                                        y.f()
                                    }
                                    this.options.uploadMultiple && this.emit("sendingmultiple", e, o, f), this._addFormElementData(f);
                                    for (var x = 0; x < t.length; x++) {
                                        var w = t[x];
                                        f.append(w.name, w.data, w.filename)
                                    }
                                    this.submitRequest(o, f, e)
                                }
                            }, {
                                key: "_transformFiles",
                                value: function (e, t) {
                                    for (var n = this, i = [], r = 0, o = function (o) {
                                            n.options.transformFile.call(n, e[o], (function (n) {
                                                i[o] = n, ++r === e.length && t(i)
                                            }))
                                        }, a = 0; a < e.length; a++) o(a)
                                }
                            }, {
                                key: "_addFormElementData",
                                value: function (e) {
                                    if ("FORM" === this.element.tagName) {
                                        var t, n = u(this.element.querySelectorAll("input, textarea, select, button"), !0);
                                        try {
                                            for (n.s(); !(t = n.n()).done;) {
                                                var i = t.value,
                                                    r = i.getAttribute("name"),
                                                    o = i.getAttribute("type");
                                                if (o && (o = o.toLowerCase()), null != r)
                                                    if ("SELECT" === i.tagName && i.hasAttribute("multiple")) {
                                                        var a, s = u(i.options, !0);
                                                        try {
                                                            for (s.s(); !(a = s.n()).done;) {
                                                                var l = a.value;
                                                                l.selected && e.append(r, l.value)
                                                            }
                                                        } catch (e) {
                                                            s.e(e)
                                                        } finally {
                                                            s.f()
                                                        }
                                                    } else(!o || "checkbox" !== o && "radio" !== o || i.checked) && e.append(r, i.value)
                                            }
                                        } catch (e) {
                                            n.e(e)
                                        } finally {
                                            n.f()
                                        }
                                    }
                                }
                            }, {
                                key: "_updateFilesUploadProgress",
                                value: function (e, t, n) {
                                    if (e[0].upload.chunked) {
                                        var i = e[0],
                                            r = this._getChunk(i, t);
                                        n ? (r.progress = 100 * n.loaded / n.total, r.total = n.total, r.bytesSent = n.loaded) : (r.progress = 100, r.bytesSent = r.total), i.upload.progress = 0, i.upload.total = 0, i.upload.bytesSent = 0;
                                        for (var o = 0; o < i.upload.totalChunkCount; o++) i.upload.chunks[o] && void 0 !== i.upload.chunks[o].progress && (i.upload.progress += i.upload.chunks[o].progress, i.upload.total += i.upload.chunks[o].total, i.upload.bytesSent += i.upload.chunks[o].bytesSent);
                                        i.upload.progress = i.upload.progress / i.upload.totalChunkCount, this.emit("uploadprogress", i, i.upload.progress, i.upload.bytesSent)
                                    } else {
                                        var a, s = u(e, !0);
                                        try {
                                            for (s.s(); !(a = s.n()).done;) {
                                                var l = a.value;
                                                l.upload.total && l.upload.bytesSent && l.upload.bytesSent == l.upload.total || (n ? (l.upload.progress = 100 * n.loaded / n.total, l.upload.total = n.total, l.upload.bytesSent = n.loaded) : (l.upload.progress = 100, l.upload.bytesSent = l.upload.total), this.emit("uploadprogress", l, l.upload.progress, l.upload.bytesSent))
                                            }
                                        } catch (e) {
                                            s.e(e)
                                        } finally {
                                            s.f()
                                        }
                                    }
                                }
                            }, {
                                key: "_finishedUploading",
                                value: function (e, t, i) {
                                    var r;
                                    if (e[0].status !== n.CANCELED && 4 === t.readyState) {
                                        if ("arraybuffer" !== t.responseType && "blob" !== t.responseType && (r = t.responseText, t.getResponseHeader("content-type") && ~t.getResponseHeader("content-type").indexOf("application/json"))) try {
                                            r = JSON.parse(r)
                                        } catch (e) {
                                            i = e, r = "Invalid JSON response from server."
                                        }
                                        this._updateFilesUploadProgress(e, t), 200 <= t.status && t.status < 300 ? e[0].upload.chunked ? e[0].upload.finishedChunkUpload(this._getChunk(e[0], t), r) : this._finished(e, r, i) : this._handleUploadError(e, t, r)
                                    }
                                }
                            }, {
                                key: "_handleUploadError",
                                value: function (e, t, i) {
                                    if (e[0].status !== n.CANCELED) {
                                        if (e[0].upload.chunked && this.options.retryChunks) {
                                            var r = this._getChunk(e[0], t);
                                            if (r.retries++ < this.options.retryChunksLimit) return void this._uploadData(e, [r.dataBlock]);
                                            console.warn("Retried this chunk too often. Giving up.")
                                        }
                                        this._errorProcessing(e, i || this.options.dictResponseError.replace("{{statusCode}}", t.status), t)
                                    }
                                }
                            }, {
                                key: "submitRequest",
                                value: function (e, t, n) {
                                    1 == e.readyState ? e.send(t) : console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.")
                                }
                            }, {
                                key: "_finished",
                                value: function (e, t, i) {
                                    var r, o = u(e, !0);
                                    try {
                                        for (o.s(); !(r = o.n()).done;) {
                                            var a = r.value;
                                            a.status = n.SUCCESS, this.emit("success", a, t, i), this.emit("complete", a)
                                        }
                                    } catch (e) {
                                        o.e(e)
                                    } finally {
                                        o.f()
                                    }
                                    if (this.options.uploadMultiple && (this.emit("successmultiple", e, t, i), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue()
                                }
                            }, {
                                key: "_errorProcessing",
                                value: function (e, t, i) {
                                    var r, o = u(e, !0);
                                    try {
                                        for (o.s(); !(r = o.n()).done;) {
                                            var a = r.value;
                                            a.status = n.ERROR, this.emit("error", a, t, i), this.emit("complete", a)
                                        }
                                    } catch (e) {
                                        o.e(e)
                                    } finally {
                                        o.f()
                                    }
                                    if (this.options.uploadMultiple && (this.emit("errormultiple", e, t, i), this.emit("completemultiple", e)), this.options.autoProcessQueue) return this.processQueue()
                                }
                            }], [{
                                key: "initClass",
                                value: function () {
                                    this.prototype.Emitter = o, this.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"], this.prototype._thumbnailQueue = [], this.prototype._processingThumbnail = !1
                                }
                            }, {
                                key: "extend",
                                value: function (e) {
                                    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
                                    for (var r = 0, o = n; r < o.length; r++) {
                                        var a = o[r];
                                        for (var s in a) {
                                            var l = a[s];
                                            e[s] = l
                                        }
                                    }
                                    return e
                                }
                            }, {
                                key: "uuidv4",
                                value: function () {
                                    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (function (e) {
                                        var t = 16 * Math.random() | 0;
                                        return ("x" === e ? t : 3 & t | 8).toString(16)
                                    }))
                                }
                            }]), n
                        }(o);
                        _.initClass(), _.version = "5.9.3", _.options = {}, _.optionsForElement = function (e) {
                            return e.getAttribute("id") ? _.options[w(e.getAttribute("id"))] : void 0
                        }, _.instances = [], _.forElement = function (e) {
                            if ("string" == typeof e && (e = document.querySelector(e)), null == (null != e ? e.dropzone : void 0)) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
                            return e.dropzone
                        }, _.autoDiscover = !0, _.discover = function () {
                            var e;
                            if (document.querySelectorAll) e = document.querySelectorAll(".dropzone");
                            else {
                                e = [];
                                var t = function (t) {
                                    return function () {
                                        var n, i = [],
                                            r = u(t, !0);
                                        try {
                                            for (r.s(); !(n = r.n()).done;) {
                                                var o = n.value;
                                                /(^| )dropzone($| )/.test(o.className) ? i.push(e.push(o)) : i.push(void 0)
                                            }
                                        } catch (e) {
                                            r.e(e)
                                        } finally {
                                            r.f()
                                        }
                                        return i
                                    }()
                                };
                                t(document.getElementsByTagName("div")), t(document.getElementsByTagName("form"))
                            }
                            return function () {
                                var t, n = [],
                                    i = u(e, !0);
                                try {
                                    for (i.s(); !(t = i.n()).done;) {
                                        var r = t.value;
                                        !1 !== _.optionsForElement(r) ? n.push(new _(r)) : n.push(void 0)
                                    }
                                } catch (e) {
                                    i.e(e)
                                } finally {
                                    i.f()
                                }
                                return n
                            }()
                        }, _.blockedBrowsers = [/opera.*(Macintosh|Windows Phone).*version\/12/i], _.isBrowserSupported = function () {
                            var e = !0;
                            if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector)
                                if ("classList" in document.createElement("a")) {
                                    void 0 !== _.blacklistedBrowsers && (_.blockedBrowsers = _.blacklistedBrowsers);
                                    var t, n = u(_.blockedBrowsers, !0);
                                    try {
                                        for (n.s(); !(t = n.n()).done;) t.value.test(navigator.userAgent) && (e = !1)
                                    } catch (e) {
                                        n.e(e)
                                    } finally {
                                        n.f()
                                    }
                                } else e = !1;
                            else e = !1;
                            return e
                        }, _.dataURItoBlob = function (e) {
                            for (var t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], i = new ArrayBuffer(t.length), r = new Uint8Array(i), o = 0, a = t.length, s = 0 <= a; s ? o <= a : o >= a; s ? o++ : o--) r[o] = t.charCodeAt(o);
                            return new Blob([i], {
                                type: n
                            })
                        };
                        var x = function (e, t) {
                                return e.filter((function (e) {
                                    return e !== t
                                })).map((function (e) {
                                    return e
                                }))
                            },
                            w = function (e) {
                                return e.replace(/[\-_](\w)/g, (function (e) {
                                    return e.charAt(1).toUpperCase()
                                }))
                            };
                        _.createElement = function (e) {
                            var t = document.createElement("div");
                            return t.innerHTML = e, t.childNodes[0]
                        }, _.elementInside = function (e, t) {
                            if (e === t) return !0;
                            for (; e = e.parentNode;)
                                if (e === t) return !0;
                            return !1
                        }, _.getElement = function (e, t) {
                            var n;
                            if ("string" == typeof e ? n = document.querySelector(e) : null != e.nodeType && (n = e), null == n) throw new Error("Invalid `".concat(t, "` option provided. Please provide a CSS selector or a plain HTML element."));
                            return n
                        }, _.getElements = function (e, t) {
                            var n, i;
                            if (e instanceof Array) {
                                i = [];
                                try {
                                    var r, o = u(e, !0);
                                    try {
                                        for (o.s(); !(r = o.n()).done;) n = r.value, i.push(this.getElement(n, t))
                                    } catch (e) {
                                        o.e(e)
                                    } finally {
                                        o.f()
                                    }
                                } catch (e) {
                                    i = null
                                }
                            } else if ("string" == typeof e) {
                                i = [];
                                var a, s = u(document.querySelectorAll(e), !0);
                                try {
                                    for (s.s(); !(a = s.n()).done;) n = a.value, i.push(n)
                                } catch (e) {
                                    s.e(e)
                                } finally {
                                    s.f()
                                }
                            } else null != e.nodeType && (i = [e]);
                            if (null == i || !i.length) throw new Error("Invalid `".concat(t, "` option provided. Please provide a CSS selector, a plain HTML element or a list of those."));
                            return i
                        }, _.confirm = function (e, t, n) {
                            return window.confirm(e) ? t() : null != n ? n() : void 0
                        }, _.isValidFile = function (e, t) {
                            if (!t) return !0;
                            t = t.split(",");
                            var n, i = e.type,
                                r = i.replace(/\/.*$/, ""),
                                o = u(t, !0);
                            try {
                                for (o.s(); !(n = o.n()).done;) {
                                    var a = n.value;
                                    if ("." === (a = a.trim()).charAt(0)) {
                                        if (-1 !== e.name.toLowerCase().indexOf(a.toLowerCase(), e.name.length - a.length)) return !0
                                    } else if (/\/\*$/.test(a)) {
                                        if (r === a.replace(/\/.*$/, "")) return !0
                                    } else if (i === a) return !0
                                }
                            } catch (e) {
                                o.e(e)
                            } finally {
                                o.f()
                            }
                            return !1
                        }, "undefined" != typeof jQuery && null !== jQuery && (jQuery.fn.dropzone = function (e) {
                            return this.each((function () {
                                return new _(this, e)
                            }))
                        }), _.ADDED = "added", _.QUEUED = "queued", _.ACCEPTED = _.QUEUED, _.UPLOADING = "uploading", _.PROCESSING = _.UPLOADING, _.CANCELED = "canceled", _.ERROR = "error", _.SUCCESS = "success";
                        var E = function (e, t, n, i, r, o, a, s, l, c) {
                                var u = function (e) {
                                    e.naturalWidth;
                                    var t = e.naturalHeight,
                                        n = document.createElement("canvas");
                                    n.width = 1, n.height = t;
                                    var i = n.getContext("2d");
                                    i.drawImage(e, 0, 0);
                                    for (var r = i.getImageData(1, 0, 1, t).data, o = 0, a = t, s = t; s > o;) 0 === r[4 * (s - 1) + 3] ? a = s : o = s, s = a + o >> 1;
                                    var l = s / t;
                                    return 0 === l ? 1 : l
                                }(t);
                                return e.drawImage(t, n, i, r, o, a, s, l, c / u)
                            },
                            k = function () {
                                function e() {
                                    h(this, e)
                                }
                                return p(e, null, [{
                                    key: "initClass",
                                    value: function () {
                                        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
                                    }
                                }, {
                                    key: "encode64",
                                    value: function (e) {
                                        for (var t = "", n = void 0, i = void 0, r = "", o = void 0, a = void 0, s = void 0, l = "", c = 0; o = (n = e[c++]) >> 2, a = (3 & n) << 4 | (i = e[c++]) >> 4, s = (15 & i) << 2 | (r = e[c++]) >> 6, l = 63 & r, isNaN(i) ? s = l = 64 : isNaN(r) && (l = 64), t = t + this.KEY_STR.charAt(o) + this.KEY_STR.charAt(a) + this.KEY_STR.charAt(s) + this.KEY_STR.charAt(l), n = i = r = "", o = a = s = l = "", c < e.length;);
                                        return t
                                    }
                                }, {
                                    key: "restore",
                                    value: function (e, t) {
                                        if (!e.match("data:image/jpeg;base64,")) return t;
                                        var n = this.decode64(e.replace("data:image/jpeg;base64,", "")),
                                            i = this.slice2Segments(n),
                                            r = this.exifManipulation(t, i);
                                        return "data:image/jpeg;base64,".concat(this.encode64(r))
                                    }
                                }, {
                                    key: "exifManipulation",
                                    value: function (e, t) {
                                        var n = this.getExifArray(t),
                                            i = this.insertExif(e, n);
                                        return new Uint8Array(i)
                                    }
                                }, {
                                    key: "getExifArray",
                                    value: function (e) {
                                        for (var t = void 0, n = 0; n < e.length;) {
                                            if (255 === (t = e[n])[0] & 225 === t[1]) return t;
                                            n++
                                        }
                                        return []
                                    }
                                }, {
                                    key: "insertExif",
                                    value: function (e, t) {
                                        var n = e.replace("data:image/jpeg;base64,", ""),
                                            i = this.decode64(n),
                                            r = i.indexOf(255, 3),
                                            o = i.slice(0, r),
                                            a = i.slice(r),
                                            s = o;
                                        return s = (s = s.concat(t)).concat(a)
                                    }
                                }, {
                                    key: "slice2Segments",
                                    value: function (e) {
                                        for (var t = 0, n = []; !(255 === e[t] & 218 === e[t + 1]);) {
                                            if (255 === e[t] & 216 === e[t + 1]) t += 2;
                                            else {
                                                var i = t + (256 * e[t + 2] + e[t + 3]) + 2,
                                                    r = e.slice(t, i);
                                                n.push(r), t = i
                                            }
                                            if (t > e.length) break
                                        }
                                        return n
                                    }
                                }, {
                                    key: "decode64",
                                    value: function (e) {
                                        var t = void 0,
                                            n = void 0,
                                            i = "",
                                            r = void 0,
                                            o = void 0,
                                            a = "",
                                            s = 0,
                                            l = [];
                                        for (/[^A-Za-z0-9\+\/\=]/g.exec(e) && console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."), e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); t = this.KEY_STR.indexOf(e.charAt(s++)) << 2 | (r = this.KEY_STR.indexOf(e.charAt(s++))) >> 4, n = (15 & r) << 4 | (o = this.KEY_STR.indexOf(e.charAt(s++))) >> 2, i = (3 & o) << 6 | (a = this.KEY_STR.indexOf(e.charAt(s++))), l.push(t), 64 !== o && l.push(n), 64 !== a && l.push(i), t = n = i = "", r = o = a = "", s < e.length;);
                                        return l
                                    }
                                }]), e
                            }();
                        k.initClass(), _._autoDiscoverFunction = function () {
                                if (_.autoDiscover) return _.discover()
                            },
                            function (e, t) {
                                var n = !1,
                                    i = !0,
                                    r = e.document,
                                    o = r.documentElement,
                                    a = r.addEventListener ? "addEventListener" : "attachEvent",
                                    s = r.addEventListener ? "removeEventListener" : "detachEvent",
                                    l = r.addEventListener ? "" : "on",
                                    c = function i(o) {
                                        if ("readystatechange" !== o.type || "complete" === r.readyState) return ("load" === o.type ? e : r)[s](l + o.type, i, !1), !n && (n = !0) ? t.call(e, o.type || o) : void 0
                                    };
                                if ("complete" !== r.readyState) {
                                    if (r.createEventObject && o.doScroll) {
                                        try {
                                            i = !e.frameElement
                                        } catch (e) {}
                                        i && function e() {
                                            try {
                                                o.doScroll("left")
                                            } catch (t) {
                                                return void setTimeout(e, 50)
                                            }
                                            return c("poll")
                                        }()
                                    }
                                    r[a](l + "DOMContentLoaded", c, !1), r[a](l + "readystatechange", c, !1), e[a](l + "load", c, !1)
                                }
                            }(window, _._autoDiscoverFunction), window.Dropzone = _;
                        var O = _
                    }(), i
                }()
            }, e.exports = t()
        },
        527: (e, t, n) => {
            "use strict";
            n.d(t, {
                Z: () => T
            });
            const i = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"],
                r = {
                    _disable: [],
                    allowInput: !1,
                    allowInvalidPreload: !1,
                    altFormat: "F j, Y",
                    altInput: !1,
                    altInputClass: "form-control input",
                    animate: "object" == typeof window && -1 === window.navigator.userAgent.indexOf("MSIE"),
                    ariaDateFormat: "F j, Y",
                    autoFillDefaultTime: !0,
                    clickOpens: !0,
                    closeOnSelect: !0,
                    conjunction: ", ",
                    dateFormat: "Y-m-d",
                    defaultHour: 12,
                    defaultMinute: 0,
                    defaultSeconds: 0,
                    disable: [],
                    disableMobile: !1,
                    enableSeconds: !1,
                    enableTime: !1,
                    errorHandler: e => "undefined" != typeof console && console.warn(e),
                    getWeek: e => {
                        const t = new Date(e.getTime());
                        t.setHours(0, 0, 0, 0), t.setDate(t.getDate() + 3 - (t.getDay() + 6) % 7);
                        var n = new Date(t.getFullYear(), 0, 4);
                        return 1 + Math.round(((t.getTime() - n.getTime()) / 864e5 - 3 + (n.getDay() + 6) % 7) / 7)
                    },
                    hourIncrement: 1,
                    ignoredFocusElements: [],
                    inline: !1,
                    locale: "default",
                    minuteIncrement: 5,
                    mode: "single",
                    monthSelectorType: "dropdown",
                    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
                    noCalendar: !1,
                    now: new Date,
                    onChange: [],
                    onClose: [],
                    onDayCreate: [],
                    onDestroy: [],
                    onKeyDown: [],
                    onMonthChange: [],
                    onOpen: [],
                    onParseConfig: [],
                    onReady: [],
                    onValueUpdate: [],
                    onYearChange: [],
                    onPreCalendarPosition: [],
                    plugins: [],
                    position: "auto",
                    positionElement: void 0,
                    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
                    shorthandCurrentMonth: !1,
                    showMonths: 1,
                    static: !1,
                    time_24hr: !1,
                    weekNumbers: !1,
                    wrap: !1
                },
                o = {
                    weekdays: {
                        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                        longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
                    },
                    months: {
                        shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
                    },
                    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                    firstDayOfWeek: 0,
                    ordinal: e => {
                        const t = e % 100;
                        if (t > 3 && t < 21) return "th";
                        switch (t % 10) {
                            case 1:
                                return "st";
                            case 2:
                                return "nd";
                            case 3:
                                return "rd";
                            default:
                                return "th"
                        }
                    },
                    rangeSeparator: " to ",
                    weekAbbreviation: "Wk",
                    scrollTitle: "Scroll to increment",
                    toggleTitle: "Click to toggle",
                    amPM: ["AM", "PM"],
                    yearAriaLabel: "Year",
                    monthAriaLabel: "Month",
                    hourAriaLabel: "Hour",
                    minuteAriaLabel: "Minute",
                    time_24hr: !1
                },
                a = o,
                s = (e, t = 2) => `000${e}`.slice(-1 * t),
                l = e => !0 === e ? 1 : 0;

            function c(e, t) {
                let n;
                return function () {
                    clearTimeout(n), n = setTimeout((() => e.apply(this, arguments)), t)
                }
            }
            const u = e => e instanceof Array ? e : [e];

            function d(e, t, n) {
                if (!0 === n) return e.classList.add(t);
                e.classList.remove(t)
            }

            function h(e, t, n) {
                const i = window.document.createElement(e);
                return t = t || "", n = n || "", i.className = t, void 0 !== n && (i.textContent = n), i
            }

            function f(e) {
                for (; e.firstChild;) e.removeChild(e.firstChild)
            }

            function p(e, t) {
                return t(e) ? e : e.parentNode ? p(e.parentNode, t) : void 0
            }

            function g(e, t) {
                const n = h("div", "numInputWrapper"),
                    i = h("input", "numInput " + e),
                    r = h("span", "arrowUp"),
                    o = h("span", "arrowDown");
                if (-1 === navigator.userAgent.indexOf("MSIE 9.0") ? i.type = "number" : (i.type = "text", i.pattern = "\\d*"), void 0 !== t)
                    for (const e in t) i.setAttribute(e, t[e]);
                return n.appendChild(i), n.appendChild(r), n.appendChild(o), n
            }

            function m(e) {
                try {
                    if ("function" == typeof e.composedPath) {
                        return e.composedPath()[0]
                    }
                    return e.target
                } catch (t) {
                    return e.target
                }
            }
            const v = () => {},
                b = (e, t, n) => n.months[t ? "shorthand" : "longhand"][e],
                y = {
                    D: v,
                    F: function (e, t, n) {
                        e.setMonth(n.months.longhand.indexOf(t))
                    },
                    G: (e, t) => {
                        e.setHours(parseFloat(t))
                    },
                    H: (e, t) => {
                        e.setHours(parseFloat(t))
                    },
                    J: (e, t) => {
                        e.setDate(parseFloat(t))
                    },
                    K: (e, t, n) => {
                        e.setHours(e.getHours() % 12 + 12 * l(new RegExp(n.amPM[1], "i").test(t)))
                    },
                    M: function (e, t, n) {
                        e.setMonth(n.months.shorthand.indexOf(t))
                    },
                    S: (e, t) => {
                        e.setSeconds(parseFloat(t))
                    },
                    U: (e, t) => new Date(1e3 * parseFloat(t)),
                    W: function (e, t, n) {
                        const i = parseInt(t),
                            r = new Date(e.getFullYear(), 0, 2 + 7 * (i - 1), 0, 0, 0, 0);
                        return r.setDate(r.getDate() - r.getDay() + n.firstDayOfWeek), r
                    },
                    Y: (e, t) => {
                        e.setFullYear(parseFloat(t))
                    },
                    Z: (e, t) => new Date(t),
                    d: (e, t) => {
                        e.setDate(parseFloat(t))
                    },
                    h: (e, t) => {
                        e.setHours(parseFloat(t))
                    },
                    i: (e, t) => {
                        e.setMinutes(parseFloat(t))
                    },
                    j: (e, t) => {
                        e.setDate(parseFloat(t))
                    },
                    l: v,
                    m: (e, t) => {
                        e.setMonth(parseFloat(t) - 1)
                    },
                    n: (e, t) => {
                        e.setMonth(parseFloat(t) - 1)
                    },
                    s: (e, t) => {
                        e.setSeconds(parseFloat(t))
                    },
                    u: (e, t) => new Date(parseFloat(t)),
                    w: v,
                    y: (e, t) => {
                        e.setFullYear(2e3 + parseFloat(t))
                    }
                },
                _ = {
                    D: "(\\w+)",
                    F: "(\\w+)",
                    G: "(\\d\\d|\\d)",
                    H: "(\\d\\d|\\d)",
                    J: "(\\d\\d|\\d)\\w+",
                    K: "",
                    M: "(\\w+)",
                    S: "(\\d\\d|\\d)",
                    U: "(.+)",
                    W: "(\\d\\d|\\d)",
                    Y: "(\\d{4})",
                    Z: "(.+)",
                    d: "(\\d\\d|\\d)",
                    h: "(\\d\\d|\\d)",
                    i: "(\\d\\d|\\d)",
                    j: "(\\d\\d|\\d)",
                    l: "(\\w+)",
                    m: "(\\d\\d|\\d)",
                    n: "(\\d\\d|\\d)",
                    s: "(\\d\\d|\\d)",
                    u: "(.+)",
                    w: "(\\d\\d|\\d)",
                    y: "(\\d{2})"
                },
                x = {
                    Z: e => e.toISOString(),
                    D: function (e, t, n) {
                        return t.weekdays.shorthand[x.w(e, t, n)]
                    },
                    F: function (e, t, n) {
                        return b(x.n(e, t, n) - 1, !1, t)
                    },
                    G: function (e, t, n) {
                        return s(x.h(e, t, n))
                    },
                    H: e => s(e.getHours()),
                    J: function (e, t) {
                        return void 0 !== t.ordinal ? e.getDate() + t.ordinal(e.getDate()) : e.getDate()
                    },
                    K: (e, t) => t.amPM[l(e.getHours() > 11)],
                    M: function (e, t) {
                        return b(e.getMonth(), !0, t)
                    },
                    S: e => s(e.getSeconds()),
                    U: e => e.getTime() / 1e3,
                    W: function (e, t, n) {
                        return n.getWeek(e)
                    },
                    Y: e => s(e.getFullYear(), 4),
                    d: e => s(e.getDate()),
                    h: e => e.getHours() % 12 ? e.getHours() % 12 : 12,
                    i: e => s(e.getMinutes()),
                    j: e => e.getDate(),
                    l: function (e, t) {
                        return t.weekdays.longhand[e.getDay()]
                    },
                    m: e => s(e.getMonth() + 1),
                    n: e => e.getMonth() + 1,
                    s: e => e.getSeconds(),
                    u: e => e.getTime(),
                    w: e => e.getDay(),
                    y: e => String(e.getFullYear()).substring(2)
                },
                w = ({
                    config: e = r,
                    l10n: t = o,
                    isMobile: n = !1
                }) => (i, r, o) => {
                    const a = o || t;
                    return void 0 === e.formatDate || n ? r.split("").map(((t, n, r) => x[t] && "\\" !== r[n - 1] ? x[t](i, a, e) : "\\" !== t ? t : "")).join("") : e.formatDate(i, r, a)
                },
                E = ({
                    config: e = r,
                    l10n: t = o
                }) => (n, i, o, a) => {
                    if (0 !== n && !n) return;
                    const s = a || t;
                    let l;
                    const c = n;
                    if (n instanceof Date) l = new Date(n.getTime());
                    else if ("string" != typeof n && void 0 !== n.toFixed) l = new Date(n);
                    else if ("string" == typeof n) {
                        const t = i || (e || r).dateFormat,
                            a = String(n).trim();
                        if ("today" === a) l = new Date, o = !0;
                        else if (/Z$/.test(a) || /GMT$/.test(a)) l = new Date(n);
                        else if (e && e.parseDate) l = e.parseDate(n, t);
                        else {
                            l = e && e.noCalendar ? new Date((new Date).setHours(0, 0, 0, 0)) : new Date((new Date).getFullYear(), 0, 1, 0, 0, 0, 0);
                            let i, r = [];
                            for (let e = 0, o = 0, a = ""; e < t.length; e++) {
                                const c = t[e],
                                    u = "\\" === c,
                                    d = "\\" === t[e - 1] || u;
                                if (_[c] && !d) {
                                    a += _[c];
                                    const e = new RegExp(a).exec(n);
                                    e && (i = !0) && r["Y" !== c ? "push" : "unshift"]({
                                        fn: y[c],
                                        val: e[++o]
                                    })
                                } else u || (a += ".");
                                r.forEach((({
                                    fn: e,
                                    val: t
                                }) => l = e(l, t, s) || l))
                            }
                            l = i ? l : void 0
                        }
                    }
                    if (l instanceof Date && !isNaN(l.getTime())) return !0 === o && l.setHours(0, 0, 0, 0), l;
                    e.errorHandler(new Error(`Invalid date provided: ${c}`))
                };

            function k(e, t, n = !0) {
                return !1 !== n ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(t.getTime()).setHours(0, 0, 0, 0) : e.getTime() - t.getTime()
            }
            const O = 864e5;

            function S(e) {
                let t = e.defaultHour,
                    n = e.defaultMinute,
                    i = e.defaultSeconds;
                if (void 0 !== e.minDate) {
                    const r = e.minDate.getHours(),
                        o = e.minDate.getMinutes(),
                        a = e.minDate.getSeconds();
                    t < r && (t = r), t === r && n < o && (n = o), t === r && n === o && i < a && (i = e.minDate.getSeconds())
                }
                if (void 0 !== e.maxDate) {
                    const r = e.maxDate.getHours(),
                        o = e.maxDate.getMinutes();
                    t = Math.min(t, r), t === r && (n = Math.min(o, n)), t === r && n === o && (i = e.maxDate.getSeconds())
                }
                return {
                    hours: t,
                    minutes: n,
                    seconds: i
                }
            }
            n(895);

            function C(e, t) {
                const n = {
                    config: Object.assign(Object.assign({}, r), M.defaultConfig),
                    l10n: a
                };

                function o(e) {
                    return e.bind(n)
                }

                function v() {
                    const e = n.config;
                    !1 === e.weekNumbers && 1 === e.showMonths || !0 !== e.noCalendar && window.requestAnimationFrame((function () {
                        if (void 0 !== n.calendarContainer && (n.calendarContainer.style.visibility = "hidden", n.calendarContainer.style.display = "block"), void 0 !== n.daysContainer) {
                            const t = (n.days.offsetWidth + 1) * e.showMonths;
                            n.daysContainer.style.width = t + "px", n.calendarContainer.style.width = t + (void 0 !== n.weekWrapper ? n.weekWrapper.offsetWidth : 0) + "px", n.calendarContainer.style.removeProperty("visibility"), n.calendarContainer.style.removeProperty("display")
                        }
                    }))
                }

                function y(e) {
                    if (0 === n.selectedDates.length) {
                        const e = void 0 === n.config.minDate || k(new Date, n.config.minDate) >= 0 ? new Date : new Date(n.config.minDate.getTime()),
                            t = S(n.config);
                        e.setHours(t.hours, t.minutes, t.seconds, e.getMilliseconds()), n.selectedDates = [e], n.latestSelectedDateObj = e
                    }
                    void 0 !== e && "blur" !== e.type && function (e) {
                        e.preventDefault();
                        const t = "keydown" === e.type,
                            i = m(e),
                            r = i;
                        void 0 !== n.amPM && i === n.amPM && (n.amPM.textContent = n.l10n.amPM[l(n.amPM.textContent === n.l10n.amPM[0])]);
                        const o = parseFloat(r.getAttribute("min")),
                            a = parseFloat(r.getAttribute("max")),
                            c = parseFloat(r.getAttribute("step")),
                            u = parseInt(r.value, 10),
                            d = e.delta || (t ? 38 === e.which ? 1 : -1 : 0);
                        let h = u + c * d;
                        if (void 0 !== r.value && 2 === r.value.length) {
                            const e = r === n.hourElement,
                                t = r === n.minuteElement;
                            h < o ? (h = a + h + l(!e) + (l(e) && l(!n.amPM)), t && j(void 0, -1, n.hourElement)) : h > a && (h = r === n.hourElement ? h - a - l(!n.amPM) : o, t && j(void 0, 1, n.hourElement)), n.amPM && e && (1 === c ? h + u === 23 : Math.abs(h - u) > c) && (n.amPM.textContent = n.l10n.amPM[l(n.amPM.textContent === n.l10n.amPM[0])]), r.value = s(h)
                        }
                    }(e);
                    const t = n._input.value;
                    x(), be(), n._input.value !== t && n._debouncedChange()
                }

                function x() {
                    if (void 0 === n.hourElement || void 0 === n.minuteElement) return;
                    let e = (parseInt(n.hourElement.value.slice(-2), 10) || 0) % 24,
                        t = (parseInt(n.minuteElement.value, 10) || 0) % 60,
                        i = void 0 !== n.secondElement ? (parseInt(n.secondElement.value, 10) || 0) % 60 : 0;
                    var r, o;
                    void 0 !== n.amPM && (r = e, o = n.amPM.textContent, e = r % 12 + 12 * l(o === n.l10n.amPM[1]));
                    const a = void 0 !== n.config.minTime || n.config.minDate && n.minDateHasTime && n.latestSelectedDateObj && 0 === k(n.latestSelectedDateObj, n.config.minDate, !0);
                    if (void 0 !== n.config.maxTime || n.config.maxDate && n.maxDateHasTime && n.latestSelectedDateObj && 0 === k(n.latestSelectedDateObj, n.config.maxDate, !0)) {
                        const r = void 0 !== n.config.maxTime ? n.config.maxTime : n.config.maxDate;
                        e = Math.min(e, r.getHours()), e === r.getHours() && (t = Math.min(t, r.getMinutes())), t === r.getMinutes() && (i = Math.min(i, r.getSeconds()))
                    }
                    if (a) {
                        const r = void 0 !== n.config.minTime ? n.config.minTime : n.config.minDate;
                        e = Math.max(e, r.getHours()), e === r.getHours() && t < r.getMinutes() && (t = r.getMinutes()), t === r.getMinutes() && (i = Math.max(i, r.getSeconds()))
                    }
                    A(e, t, i)
                }

                function C(e) {
                    const t = e || n.latestSelectedDateObj;
                    t && A(t.getHours(), t.getMinutes(), t.getSeconds())
                }

                function A(e, t, i) {
                    void 0 !== n.latestSelectedDateObj && n.latestSelectedDateObj.setHours(e % 24, t, i || 0, 0), n.hourElement && n.minuteElement && !n.isMobile && (n.hourElement.value = s(n.config.time_24hr ? e : (12 + e) % 12 + 12 * l(e % 12 == 0)), n.minuteElement.value = s(t), void 0 !== n.amPM && (n.amPM.textContent = n.l10n.amPM[l(e >= 12)]), void 0 !== n.secondElement && (n.secondElement.value = s(i)))
                }

                function T(e) {
                    const t = m(e),
                        n = parseInt(t.value) + (e.delta || 0);
                    (n / 1e3 > 1 || "Enter" === e.key && !/[^\d]/.test(n.toString())) && X(n)
                }

                function P(e, t, i, r) {
                    return t instanceof Array ? t.forEach((t => P(e, t, i, r))) : e instanceof Array ? e.forEach((e => P(e, t, i, r))) : (e.addEventListener(t, i, r), void n._handlers.push({
                        remove: () => e.removeEventListener(t, i)
                    }))
                }

                function D() {
                    fe("onChange")
                }

                function L(e, t) {
                    const i = void 0 !== e ? n.parseDate(e) : n.latestSelectedDateObj || (n.config.minDate && n.config.minDate > n.now ? n.config.minDate : n.config.maxDate && n.config.maxDate < n.now ? n.config.maxDate : n.now),
                        r = n.currentYear,
                        o = n.currentMonth;
                    try {
                        void 0 !== i && (n.currentYear = i.getFullYear(), n.currentMonth = i.getMonth())
                    } catch (e) {
                        e.message = "Invalid date supplied: " + i, n.config.errorHandler(e)
                    }
                    t && n.currentYear !== r && (fe("onYearChange"), H()), !t || n.currentYear === r && n.currentMonth === o || fe("onMonthChange"), n.redraw()
                }

                function N(e) {
                    const t = m(e);
                    ~t.className.indexOf("arrow") && j(e, t.classList.contains("arrowUp") ? 1 : -1)
                }

                function j(e, t, n) {
                    const i = e && m(e),
                        r = n || i && i.parentNode && i.parentNode.firstChild,
                        o = pe("increment");
                    o.delta = t, r && r.dispatchEvent(o)
                }

                function I(e, t, i, r) {
                    const o = Z(t, !0),
                        a = h("span", "flatpickr-day " + e, t.getDate().toString());
                    return a.dateObj = t, a.$i = r, a.setAttribute("aria-label", n.formatDate(t, n.config.ariaDateFormat)), -1 === e.indexOf("hidden") && 0 === k(t, n.now) && (n.todayDateElem = a, a.classList.add("today"), a.setAttribute("aria-current", "date")), o ? (a.tabIndex = -1, ge(t) && (a.classList.add("selected"), n.selectedDateElem = a, "range" === n.config.mode && (d(a, "startRange", n.selectedDates[0] && 0 === k(t, n.selectedDates[0], !0)), d(a, "endRange", n.selectedDates[1] && 0 === k(t, n.selectedDates[1], !0)), "nextMonthDay" === e && a.classList.add("inRange")))) : a.classList.add("flatpickr-disabled"), "range" === n.config.mode && function (e) {
                        return !("range" !== n.config.mode || n.selectedDates.length < 2) && (k(e, n.selectedDates[0]) >= 0 && k(e, n.selectedDates[1]) <= 0)
                    }(t) && !ge(t) && a.classList.add("inRange"), n.weekNumbers && 1 === n.config.showMonths && "prevMonthDay" !== e && i % 7 == 1 && n.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + n.config.getWeek(t) + "</span>"), fe("onDayCreate", a), a
                }

                function R(e) {
                    e.focus(), "range" === n.config.mode && te(e)
                }

                function F(e) {
                    const t = e > 0 ? 0 : n.config.showMonths - 1,
                        i = e > 0 ? n.config.showMonths : -1;
                    for (let r = t; r != i; r += e) {
                        const t = n.daysContainer.children[r],
                            i = e > 0 ? 0 : t.children.length - 1,
                            o = e > 0 ? t.children.length : -1;
                        for (let n = i; n != o; n += e) {
                            const e = t.children[n];
                            if (-1 === e.className.indexOf("hidden") && Z(e.dateObj)) return e
                        }
                    }
                }

                function B(e, t) {
                    const i = Q(document.activeElement || document.body),
                        r = void 0 !== e ? e : i ? document.activeElement : void 0 !== n.selectedDateElem && Q(n.selectedDateElem) ? n.selectedDateElem : void 0 !== n.todayDateElem && Q(n.todayDateElem) ? n.todayDateElem : F(t > 0 ? 1 : -1);
                    void 0 === r ? n._input.focus() : i ? function (e, t) {
                        const i = -1 === e.className.indexOf("Month") ? e.dateObj.getMonth() : n.currentMonth,
                            r = t > 0 ? n.config.showMonths : -1,
                            o = t > 0 ? 1 : -1;
                        for (let a = i - n.currentMonth; a != r; a += o) {
                            const r = n.daysContainer.children[a],
                                s = i - n.currentMonth === a ? e.$i + t : t < 0 ? r.children.length - 1 : 0,
                                l = r.children.length;
                            for (let n = s; n >= 0 && n < l && n != (t > 0 ? l : -1); n += o) {
                                const i = r.children[n];
                                if (-1 === i.className.indexOf("hidden") && Z(i.dateObj) && Math.abs(e.$i - n) >= Math.abs(t)) return R(i)
                            }
                        }
                        n.changeMonth(o), B(F(o), 0)
                    }(r, t) : R(r)
                }

                function q(e, t) {
                    const i = (new Date(e, t, 1).getDay() - n.l10n.firstDayOfWeek + 7) % 7,
                        r = n.utils.getDaysInMonth((t - 1 + 12) % 12, e),
                        o = n.utils.getDaysInMonth(t, e),
                        a = window.document.createDocumentFragment(),
                        s = n.config.showMonths > 1,
                        l = s ? "prevMonthDay hidden" : "prevMonthDay",
                        c = s ? "nextMonthDay hidden" : "nextMonthDay";
                    let u = r + 1 - i,
                        d = 0;
                    for (; u <= r; u++, d++) a.appendChild(I(l, new Date(e, t - 1, u), u, d));
                    for (u = 1; u <= o; u++, d++) a.appendChild(I("", new Date(e, t, u), u, d));
                    for (let r = o + 1; r <= 42 - i && (1 === n.config.showMonths || d % 7 != 0); r++, d++) a.appendChild(I(c, new Date(e, t + 1, r % o), r, d));
                    const f = h("div", "dayContainer");
                    return f.appendChild(a), f
                }

                function z() {
                    if (void 0 === n.daysContainer) return;
                    f(n.daysContainer), n.weekNumbers && f(n.weekNumbers);
                    const e = document.createDocumentFragment();
                    for (let t = 0; t < n.config.showMonths; t++) {
                        const i = new Date(n.currentYear, n.currentMonth, 1);
                        i.setMonth(n.currentMonth + t), e.appendChild(q(i.getFullYear(), i.getMonth()))
                    }
                    n.daysContainer.appendChild(e), n.days = n.daysContainer.firstChild, "range" === n.config.mode && 1 === n.selectedDates.length && te()
                }

                function H() {
                    if (n.config.showMonths > 1 || "dropdown" !== n.config.monthSelectorType) return;
                    const e = function (e) {
                        return !(void 0 !== n.config.minDate && n.currentYear === n.config.minDate.getFullYear() && e < n.config.minDate.getMonth()) && !(void 0 !== n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear() && e > n.config.maxDate.getMonth())
                    };
                    n.monthsDropdownContainer.tabIndex = -1, n.monthsDropdownContainer.innerHTML = "";
                    for (let t = 0; t < 12; t++) {
                        if (!e(t)) continue;
                        const i = h("option", "flatpickr-monthDropdown-month");
                        i.value = new Date(n.currentYear, t).getMonth().toString(), i.textContent = b(t, n.config.shorthandCurrentMonth, n.l10n), i.tabIndex = -1, n.currentMonth === t && (i.selected = !0), n.monthsDropdownContainer.appendChild(i)
                    }
                }

                function U() {
                    const e = h("div", "flatpickr-month"),
                        t = window.document.createDocumentFragment();
                    let i;
                    n.config.showMonths > 1 || "static" === n.config.monthSelectorType ? i = h("span", "cur-month") : (n.monthsDropdownContainer = h("select", "flatpickr-monthDropdown-months"), n.monthsDropdownContainer.setAttribute("aria-label", n.l10n.monthAriaLabel), P(n.monthsDropdownContainer, "change", (e => {
                        const t = m(e),
                            i = parseInt(t.value, 10);
                        n.changeMonth(i - n.currentMonth), fe("onMonthChange")
                    })), H(), i = n.monthsDropdownContainer);
                    const r = g("cur-year", {
                            tabindex: "-1"
                        }),
                        o = r.getElementsByTagName("input")[0];
                    o.setAttribute("aria-label", n.l10n.yearAriaLabel), n.config.minDate && o.setAttribute("min", n.config.minDate.getFullYear().toString()), n.config.maxDate && (o.setAttribute("max", n.config.maxDate.getFullYear().toString()), o.disabled = !!n.config.minDate && n.config.minDate.getFullYear() === n.config.maxDate.getFullYear());
                    const a = h("div", "flatpickr-current-month");
                    return a.appendChild(i), a.appendChild(r), t.appendChild(a), e.appendChild(t), {
                        container: e,
                        yearElement: o,
                        monthElement: i
                    }
                }

                function V() {
                    f(n.monthNav), n.monthNav.appendChild(n.prevMonthNav), n.config.showMonths && (n.yearElements = [], n.monthElements = []);
                    for (let e = n.config.showMonths; e--;) {
                        const e = U();
                        n.yearElements.push(e.yearElement), n.monthElements.push(e.monthElement), n.monthNav.appendChild(e.container)
                    }
                    n.monthNav.appendChild(n.nextMonthNav)
                }

                function W() {
                    n.weekdayContainer ? f(n.weekdayContainer) : n.weekdayContainer = h("div", "flatpickr-weekdays");
                    for (let e = n.config.showMonths; e--;) {
                        const e = h("div", "flatpickr-weekdaycontainer");
                        n.weekdayContainer.appendChild(e)
                    }
                    return Y(), n.weekdayContainer
                }

                function Y() {
                    if (!n.weekdayContainer) return;
                    const e = n.l10n.firstDayOfWeek;
                    let t = [...n.l10n.weekdays.shorthand];
                    e > 0 && e < t.length && (t = [...t.splice(e, t.length), ...t.splice(0, e)]);
                    for (let e = n.config.showMonths; e--;) n.weekdayContainer.children[e].innerHTML = `\n      <span class='flatpickr-weekday'>\n        ${t.join("</span><span class='flatpickr-weekday'>")}\n      </span>\n      `
                }

                function $(e, t = !0) {
                    const i = t ? e : e - n.currentMonth;
                    i < 0 && !0 === n._hidePrevMonthArrow || i > 0 && !0 === n._hideNextMonthArrow || (n.currentMonth += i, (n.currentMonth < 0 || n.currentMonth > 11) && (n.currentYear += n.currentMonth > 11 ? 1 : -1, n.currentMonth = (n.currentMonth + 12) % 12, fe("onYearChange"), H()), z(), fe("onMonthChange"), me())
                }

                function K(e) {
                    return !(!n.config.appendTo || !n.config.appendTo.contains(e)) || n.calendarContainer.contains(e)
                }

                function G(e) {
                    if (n.isOpen && !n.config.inline) {
                        const t = m(e),
                            i = K(t),
                            r = t === n.input || t === n.altInput || n.element.contains(t) || e.path && e.path.indexOf && (~e.path.indexOf(n.input) || ~e.path.indexOf(n.altInput)),
                            o = "blur" === e.type ? r && e.relatedTarget && !K(e.relatedTarget) : !r && !i && !K(e.relatedTarget),
                            a = !n.config.ignoredFocusElements.some((e => e.contains(t)));
                        o && a && (void 0 !== n.timeContainer && void 0 !== n.minuteElement && void 0 !== n.hourElement && "" !== n.input.value && void 0 !== n.input.value && y(), n.close(), n.config && "range" === n.config.mode && 1 === n.selectedDates.length && (n.clear(!1), n.redraw()))
                    }
                }

                function X(e) {
                    if (!e || n.config.minDate && e < n.config.minDate.getFullYear() || n.config.maxDate && e > n.config.maxDate.getFullYear()) return;
                    const t = e,
                        i = n.currentYear !== t;
                    n.currentYear = t || n.currentYear, n.config.maxDate && n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth = Math.min(n.config.maxDate.getMonth(), n.currentMonth) : n.config.minDate && n.currentYear === n.config.minDate.getFullYear() && (n.currentMonth = Math.max(n.config.minDate.getMonth(), n.currentMonth)), i && (n.redraw(), fe("onYearChange"), H())
                }

                function Z(e, t = !0) {
                    var i;
                    const r = n.parseDate(e, void 0, t);
                    if (n.config.minDate && r && k(r, n.config.minDate, void 0 !== t ? t : !n.minDateHasTime) < 0 || n.config.maxDate && r && k(r, n.config.maxDate, void 0 !== t ? t : !n.maxDateHasTime) > 0) return !1;
                    if (!n.config.enable && 0 === n.config.disable.length) return !0;
                    if (void 0 === r) return !1;
                    const o = !!n.config.enable,
                        a = null !== (i = n.config.enable) && void 0 !== i ? i : n.config.disable;
                    for (let e, t = 0; t < a.length; t++) {
                        if (e = a[t], "function" == typeof e && e(r)) return o;
                        if (e instanceof Date && void 0 !== r && e.getTime() === r.getTime()) return o;
                        if ("string" == typeof e) {
                            const t = n.parseDate(e, void 0, !0);
                            return t && t.getTime() === r.getTime() ? o : !o
                        }
                        if ("object" == typeof e && void 0 !== r && e.from && e.to && r.getTime() >= e.from.getTime() && r.getTime() <= e.to.getTime()) return o
                    }
                    return !o
                }

                function Q(e) {
                    return void 0 !== n.daysContainer && (-1 === e.className.indexOf("hidden") && -1 === e.className.indexOf("flatpickr-disabled") && n.daysContainer.contains(e))
                }

                function J(e) {
                    !(e.target === n._input) || !(n.selectedDates.length > 0 || n._input.value.length > 0) || e.relatedTarget && K(e.relatedTarget) || n.setDate(n._input.value, !0, e.target === n.altInput ? n.config.altFormat : n.config.dateFormat)
                }

                function ee(t) {
                    const i = m(t),
                        r = n.config.wrap ? e.contains(i) : i === n._input,
                        o = n.config.allowInput,
                        a = n.isOpen && (!o || !r),
                        s = n.config.inline && r && !o;
                    if (13 === t.keyCode && r) {
                        if (o) return n.setDate(n._input.value, !0, i === n.altInput ? n.config.altFormat : n.config.dateFormat), i.blur();
                        n.open()
                    } else if (K(i) || a || s) {
                        const e = !!n.timeContainer && n.timeContainer.contains(i);
                        switch (t.keyCode) {
                            case 13:
                                e ? (t.preventDefault(), y(), le()) : ce(t);
                                break;
                            case 27:
                                t.preventDefault(), le();
                                break;
                            case 8:
                            case 46:
                                r && !n.config.allowInput && (t.preventDefault(), n.clear());
                                break;
                            case 37:
                            case 39:
                                if (e || r) n.hourElement && n.hourElement.focus();
                                else if (t.preventDefault(), void 0 !== n.daysContainer && (!1 === o || document.activeElement && Q(document.activeElement))) {
                                    const e = 39 === t.keyCode ? 1 : -1;
                                    t.ctrlKey ? (t.stopPropagation(), $(e), B(F(1), 0)) : B(void 0, e)
                                }
                                break;
                            case 38:
                            case 40:
                                t.preventDefault();
                                const a = 40 === t.keyCode ? 1 : -1;
                                n.daysContainer && void 0 !== i.$i || i === n.input || i === n.altInput ? t.ctrlKey ? (t.stopPropagation(), X(n.currentYear - a), B(F(1), 0)) : e || B(void 0, 7 * a) : i === n.currentYearElement ? X(n.currentYear - a) : n.config.enableTime && (!e && n.hourElement && n.hourElement.focus(), y(t), n._debouncedChange());
                                break;
                            case 9:
                                if (e) {
                                    const e = [n.hourElement, n.minuteElement, n.secondElement, n.amPM].concat(n.pluginElements).filter((e => e)),
                                        r = e.indexOf(i);
                                    if (-1 !== r) {
                                        const i = e[r + (t.shiftKey ? -1 : 1)];
                                        t.preventDefault(), (i || n._input).focus()
                                    }
                                } else !n.config.noCalendar && n.daysContainer && n.daysContainer.contains(i) && t.shiftKey && (t.preventDefault(), n._input.focus())
                        }
                    }
                    if (void 0 !== n.amPM && i === n.amPM) switch (t.key) {
                        case n.l10n.amPM[0].charAt(0):
                        case n.l10n.amPM[0].charAt(0).toLowerCase():
                            n.amPM.textContent = n.l10n.amPM[0], x(), be();
                            break;
                        case n.l10n.amPM[1].charAt(0):
                        case n.l10n.amPM[1].charAt(0).toLowerCase():
                            n.amPM.textContent = n.l10n.amPM[1], x(), be()
                    }(r || K(i)) && fe("onKeyDown", t)
                }

                function te(e) {
                    if (1 !== n.selectedDates.length || e && (!e.classList.contains("flatpickr-day") || e.classList.contains("flatpickr-disabled"))) return;
                    const t = e ? e.dateObj.getTime() : n.days.firstElementChild.dateObj.getTime(),
                        i = n.parseDate(n.selectedDates[0], void 0, !0).getTime(),
                        r = Math.min(t, n.selectedDates[0].getTime()),
                        o = Math.max(t, n.selectedDates[0].getTime());
                    let a = !1,
                        s = 0,
                        l = 0;
                    for (let e = r; e < o; e += O) Z(new Date(e), !0) || (a = a || e > r && e < o, e < i && (!s || e > s) ? s = e : e > i && (!l || e < l) && (l = e));
                    for (let r = 0; r < n.config.showMonths; r++) {
                        const o = n.daysContainer.children[r];
                        for (let r = 0, h = o.children.length; r < h; r++) {
                            const h = o.children[r],
                                f = h.dateObj.getTime(),
                                p = s > 0 && f < s || l > 0 && f > l;
                            p ? (h.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach((e => {
                                h.classList.remove(e)
                            }))) : a && !p || (["startRange", "inRange", "endRange", "notAllowed"].forEach((e => {
                                h.classList.remove(e)
                            })), void 0 !== e && (e.classList.add(t <= n.selectedDates[0].getTime() ? "startRange" : "endRange"), i < t && f === i ? h.classList.add("startRange") : i > t && f === i && h.classList.add("endRange"), f >= s && (0 === l || f <= l) && (u = i, d = t, (c = f) > Math.min(u, d) && c < Math.max(u, d)) && h.classList.add("inRange")))
                        }
                    }
                    var c, u, d
                }

                function ne() {
                    !n.isOpen || n.config.static || n.config.inline || ae()
                }

                function ie(e) {
                    return t => {
                        const i = n.config[`_${e}Date`] = n.parseDate(t, n.config.dateFormat),
                            r = n.config[`_${"min"===e?"max":"min"}Date`];
                        void 0 !== i && (n["min" === e ? "minDateHasTime" : "maxDateHasTime"] = i.getHours() > 0 || i.getMinutes() > 0 || i.getSeconds() > 0), n.selectedDates && (n.selectedDates = n.selectedDates.filter((e => Z(e))), n.selectedDates.length || "min" !== e || C(i), be()), n.daysContainer && (se(), void 0 !== i ? n.currentYearElement[e] = i.getFullYear().toString() : n.currentYearElement.removeAttribute(e), n.currentYearElement.disabled = !!r && void 0 !== i && r.getFullYear() === i.getFullYear())
                    }
                }

                function re() {
                    return n.config.wrap ? e.querySelector("[data-input]") : e
                }

                function oe() {
                    "object" != typeof n.config.locale && void 0 === M.l10ns[n.config.locale] && n.config.errorHandler(new Error(`flatpickr: invalid locale ${n.config.locale}`)), n.l10n = Object.assign(Object.assign({}, M.l10ns.default), "object" == typeof n.config.locale ? n.config.locale : "default" !== n.config.locale ? M.l10ns[n.config.locale] : void 0), _.K = `(${n.l10n.amPM[0]}|${n.l10n.amPM[1]}|${n.l10n.amPM[0].toLowerCase()}|${n.l10n.amPM[1].toLowerCase()})`;
                    void 0 === Object.assign(Object.assign({}, t), JSON.parse(JSON.stringify(e.dataset || {}))).time_24hr && void 0 === M.defaultConfig.time_24hr && (n.config.time_24hr = n.l10n.time_24hr), n.formatDate = w(n), n.parseDate = E({
                        config: n.config,
                        l10n: n.l10n
                    })
                }

                function ae(e) {
                    if ("function" == typeof n.config.position) return void n.config.position(n, e);
                    if (void 0 === n.calendarContainer) return;
                    fe("onPreCalendarPosition");
                    const t = e || n._positionElement,
                        i = Array.prototype.reduce.call(n.calendarContainer.children, ((e, t) => e + t.offsetHeight), 0),
                        r = n.calendarContainer.offsetWidth,
                        o = n.config.position.split(" "),
                        a = o[0],
                        s = o.length > 1 ? o[1] : null,
                        l = t.getBoundingClientRect(),
                        c = window.innerHeight - l.bottom,
                        u = "above" === a || "below" !== a && c < i && l.top > i,
                        h = window.pageYOffset + l.top + (u ? -i - 2 : t.offsetHeight + 2);
                    if (d(n.calendarContainer, "arrowTop", !u), d(n.calendarContainer, "arrowBottom", u), n.config.inline) return;
                    let f = window.pageXOffset + l.left,
                        p = !1,
                        g = !1;
                    "center" === s ? (f -= (r - l.width) / 2, p = !0) : "right" === s && (f -= r - l.width, g = !0), d(n.calendarContainer, "arrowLeft", !p && !g), d(n.calendarContainer, "arrowCenter", p), d(n.calendarContainer, "arrowRight", g);
                    const m = window.document.body.offsetWidth - (window.pageXOffset + l.right),
                        v = f + r > window.document.body.offsetWidth,
                        b = m + r > window.document.body.offsetWidth;
                    if (d(n.calendarContainer, "rightMost", v), !n.config.static)
                        if (n.calendarContainer.style.top = `${h}px`, v)
                            if (b) {
                                const e = function () {
                                    let e = null;
                                    for (let t = 0; t < document.styleSheets.length; t++) {
                                        const n = document.styleSheets[t];
                                        try {
                                            n.cssRules
                                        } catch (e) {
                                            continue
                                        }
                                        e = n;
                                        break
                                    }
                                    return null != e ? e : function () {
                                        const e = document.createElement("style");
                                        return document.head.appendChild(e), e.sheet
                                    }()
                                }();
                                if (void 0 === e) return;
                                const t = window.document.body.offsetWidth,
                                    i = Math.max(0, t / 2 - r / 2),
                                    o = ".flatpickr-calendar.centerMost:before",
                                    a = ".flatpickr-calendar.centerMost:after",
                                    s = e.cssRules.length,
                                    c = `{left:${l.left}px;right:auto;}`;
                                d(n.calendarContainer, "rightMost", !1), d(n.calendarContainer, "centerMost", !0), e.insertRule(`${o},${a}${c}`, s), n.calendarContainer.style.left = `${i}px`, n.calendarContainer.style.right = "auto"
                            } else n.calendarContainer.style.left = "auto", n.calendarContainer.style.right = `${m}px`;
                    else n.calendarContainer.style.left = `${f}px`, n.calendarContainer.style.right = "auto"
                }

                function se() {
                    n.config.noCalendar || n.isMobile || (H(), me(), z())
                }

                function le() {
                    n._input.focus(), -1 !== window.navigator.userAgent.indexOf("MSIE") || void 0 !== navigator.msMaxTouchPoints ? setTimeout(n.close, 0) : n.close()
                }

                function ce(e) {
                    e.preventDefault(), e.stopPropagation();
                    const t = p(m(e), (e => e.classList && e.classList.contains("flatpickr-day") && !e.classList.contains("flatpickr-disabled") && !e.classList.contains("notAllowed")));
                    if (void 0 === t) return;
                    const i = t,
                        r = n.latestSelectedDateObj = new Date(i.dateObj.getTime()),
                        o = (r.getMonth() < n.currentMonth || r.getMonth() > n.currentMonth + n.config.showMonths - 1) && "range" !== n.config.mode;
                    if (n.selectedDateElem = i, "single" === n.config.mode) n.selectedDates = [r];
                    else if ("multiple" === n.config.mode) {
                        const e = ge(r);
                        e ? n.selectedDates.splice(parseInt(e), 1) : n.selectedDates.push(r)
                    } else "range" === n.config.mode && (2 === n.selectedDates.length && n.clear(!1, !1), n.latestSelectedDateObj = r, n.selectedDates.push(r), 0 !== k(r, n.selectedDates[0], !0) && n.selectedDates.sort(((e, t) => e.getTime() - t.getTime())));
                    if (x(), o) {
                        const e = n.currentYear !== r.getFullYear();
                        n.currentYear = r.getFullYear(), n.currentMonth = r.getMonth(), e && (fe("onYearChange"), H()), fe("onMonthChange")
                    }
                    if (me(), z(), be(), o || "range" === n.config.mode || 1 !== n.config.showMonths ? void 0 !== n.selectedDateElem && void 0 === n.hourElement && n.selectedDateElem && n.selectedDateElem.focus() : R(i), void 0 !== n.hourElement && void 0 !== n.hourElement && n.hourElement.focus(), n.config.closeOnSelect) {
                        const e = "single" === n.config.mode && !n.config.enableTime,
                            t = "range" === n.config.mode && 2 === n.selectedDates.length && !n.config.enableTime;
                        (e || t) && le()
                    }
                    D()
                }
                n.parseDate = E({
                    config: n.config,
                    l10n: n.l10n
                }), n._handlers = [], n.pluginElements = [], n.loadedPlugins = [], n._bind = P, n._setHoursFromDate = C, n._positionCalendar = ae, n.changeMonth = $, n.changeYear = X, n.clear = function (e = !0, t = !0) {
                    n.input.value = "", void 0 !== n.altInput && (n.altInput.value = "");
                    void 0 !== n.mobileInput && (n.mobileInput.value = "");
                    n.selectedDates = [], n.latestSelectedDateObj = void 0, !0 === t && (n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth());
                    if (!0 === n.config.enableTime) {
                        const {
                            hours: e,
                            minutes: t,
                            seconds: i
                        } = S(n.config);
                        A(e, t, i)
                    }
                    n.redraw(), e && fe("onChange")
                }, n.close = function () {
                    n.isOpen = !1, n.isMobile || (void 0 !== n.calendarContainer && n.calendarContainer.classList.remove("open"), void 0 !== n._input && n._input.classList.remove("active"));
                    fe("onClose")
                }, n._createElement = h, n.destroy = function () {
                    void 0 !== n.config && fe("onDestroy");
                    for (let e = n._handlers.length; e--;) n._handlers[e].remove();
                    if (n._handlers = [], n.mobileInput) n.mobileInput.parentNode && n.mobileInput.parentNode.removeChild(n.mobileInput), n.mobileInput = void 0;
                    else if (n.calendarContainer && n.calendarContainer.parentNode)
                        if (n.config.static && n.calendarContainer.parentNode) {
                            const e = n.calendarContainer.parentNode;
                            if (e.lastChild && e.removeChild(e.lastChild), e.parentNode) {
                                for (; e.firstChild;) e.parentNode.insertBefore(e.firstChild, e);
                                e.parentNode.removeChild(e)
                            }
                        } else n.calendarContainer.parentNode.removeChild(n.calendarContainer);
                    n.altInput && (n.input.type = "text", n.altInput.parentNode && n.altInput.parentNode.removeChild(n.altInput), delete n.altInput);
                    n.input && (n.input.type = n.input._type, n.input.classList.remove("flatpickr-input"), n.input.removeAttribute("readonly"));
                    ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "monthsDropdownContainer", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach((e => {
                        try {
                            delete n[e]
                        } catch (e) {}
                    }))
                }, n.isEnabled = Z, n.jumpToDate = L, n.open = function (e, t = n._positionElement) {
                    if (!0 === n.isMobile) {
                        if (e) {
                            e.preventDefault();
                            const t = m(e);
                            t && t.blur()
                        }
                        return void 0 !== n.mobileInput && (n.mobileInput.focus(), n.mobileInput.click()), void fe("onOpen")
                    }
                    if (n._input.disabled || n.config.inline) return;
                    const i = n.isOpen;
                    n.isOpen = !0, i || (n.calendarContainer.classList.add("open"), n._input.classList.add("active"), fe("onOpen"), ae(t));
                    !0 === n.config.enableTime && !0 === n.config.noCalendar && (!1 !== n.config.allowInput || void 0 !== e && n.timeContainer.contains(e.relatedTarget) || setTimeout((() => n.hourElement.select()), 50))
                }, n.redraw = se, n.set = function (e, t) {
                    if (null !== e && "object" == typeof e) {
                        Object.assign(n.config, e);
                        for (const t in e) void 0 !== ue[t] && ue[t].forEach((e => e()))
                    } else n.config[e] = t, void 0 !== ue[e] ? ue[e].forEach((e => e())) : i.indexOf(e) > -1 && (n.config[e] = u(t));
                    n.redraw(), be(!0)
                }, n.setDate = function (e, t = !1, i = n.config.dateFormat) {
                    if (0 !== e && !e || e instanceof Array && 0 === e.length) return n.clear(t);
                    de(e, i), n.latestSelectedDateObj = n.selectedDates[n.selectedDates.length - 1], n.redraw(), L(void 0, t), C(), 0 === n.selectedDates.length && n.clear(!1);
                    be(t), t && fe("onChange")
                }, n.toggle = function (e) {
                    if (!0 === n.isOpen) return n.close();
                    n.open(e)
                };
                const ue = {
                    locale: [oe, Y],
                    showMonths: [V, v, W],
                    minDate: [L],
                    maxDate: [L],
                    clickOpens: [() => {
                        !0 === n.config.clickOpens ? (P(n._input, "focus", n.open), P(n._input, "click", n.open)) : (n._input.removeEventListener("focus", n.open), n._input.removeEventListener("click", n.open))
                    }]
                };

                function de(e, t) {
                    let i = [];
                    if (e instanceof Array) i = e.map((e => n.parseDate(e, t)));
                    else if (e instanceof Date || "number" == typeof e) i = [n.parseDate(e, t)];
                    else if ("string" == typeof e) switch (n.config.mode) {
                        case "single":
                        case "time":
                            i = [n.parseDate(e, t)];
                            break;
                        case "multiple":
                            i = e.split(n.config.conjunction).map((e => n.parseDate(e, t)));
                            break;
                        case "range":
                            i = e.split(n.l10n.rangeSeparator).map((e => n.parseDate(e, t)))
                    } else n.config.errorHandler(new Error(`Invalid date supplied: ${JSON.stringify(e)}`));
                    n.selectedDates = n.config.allowInvalidPreload ? i : i.filter((e => e instanceof Date && Z(e, !1))), "range" === n.config.mode && n.selectedDates.sort(((e, t) => e.getTime() - t.getTime()))
                }

                function he(e) {
                    return e.slice().map((e => "string" == typeof e || "number" == typeof e || e instanceof Date ? n.parseDate(e, void 0, !0) : e && "object" == typeof e && e.from && e.to ? {
                        from: n.parseDate(e.from, void 0),
                        to: n.parseDate(e.to, void 0)
                    } : e)).filter((e => e))
                }

                function fe(e, t) {
                    if (void 0 === n.config) return;
                    const i = n.config[e];
                    if (void 0 !== i && i.length > 0)
                        for (let e = 0; i[e] && e < i.length; e++) i[e](n.selectedDates, n.input.value, n, t);
                    "onChange" === e && (n.input.dispatchEvent(pe("change")), n.input.dispatchEvent(pe("input")))
                }

                function pe(e) {
                    const t = document.createEvent("Event");
                    return t.initEvent(e, !0, !0), t
                }

                function ge(e) {
                    for (let t = 0; t < n.selectedDates.length; t++)
                        if (0 === k(n.selectedDates[t], e)) return "" + t;
                    return !1
                }

                function me() {
                    n.config.noCalendar || n.isMobile || !n.monthNav || (n.yearElements.forEach(((e, t) => {
                        const i = new Date(n.currentYear, n.currentMonth, 1);
                        i.setMonth(n.currentMonth + t), n.config.showMonths > 1 || "static" === n.config.monthSelectorType ? n.monthElements[t].textContent = b(i.getMonth(), n.config.shorthandCurrentMonth, n.l10n) + " " : n.monthsDropdownContainer.value = i.getMonth().toString(), e.value = i.getFullYear().toString()
                    })), n._hidePrevMonthArrow = void 0 !== n.config.minDate && (n.currentYear === n.config.minDate.getFullYear() ? n.currentMonth <= n.config.minDate.getMonth() : n.currentYear < n.config.minDate.getFullYear()), n._hideNextMonthArrow = void 0 !== n.config.maxDate && (n.currentYear === n.config.maxDate.getFullYear() ? n.currentMonth + 1 > n.config.maxDate.getMonth() : n.currentYear > n.config.maxDate.getFullYear()))
                }

                function ve(e) {
                    return n.selectedDates.map((t => n.formatDate(t, e))).filter(((e, t, i) => "range" !== n.config.mode || n.config.enableTime || i.indexOf(e) === t)).join("range" !== n.config.mode ? n.config.conjunction : n.l10n.rangeSeparator)
                }

                function be(e = !0) {
                    void 0 !== n.mobileInput && n.mobileFormatStr && (n.mobileInput.value = void 0 !== n.latestSelectedDateObj ? n.formatDate(n.latestSelectedDateObj, n.mobileFormatStr) : ""), n.input.value = ve(n.config.dateFormat), void 0 !== n.altInput && (n.altInput.value = ve(n.config.altFormat)), !1 !== e && fe("onValueUpdate")
                }

                function ye(e) {
                    const t = m(e),
                        i = n.prevMonthNav.contains(t),
                        r = n.nextMonthNav.contains(t);
                    i || r ? $(i ? -1 : 1) : n.yearElements.indexOf(t) >= 0 ? t.select() : t.classList.contains("arrowUp") ? n.changeYear(n.currentYear + 1) : t.classList.contains("arrowDown") && n.changeYear(n.currentYear - 1)
                }
                return function () {
                    n.element = n.input = e, n.isOpen = !1,
                        function () {
                            const a = ["wrap", "weekNumbers", "allowInput", "allowInvalidPreload", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"],
                                s = Object.assign(Object.assign({}, JSON.parse(JSON.stringify(e.dataset || {}))), t),
                                l = {};
                            n.config.parseDate = s.parseDate, n.config.formatDate = s.formatDate, Object.defineProperty(n.config, "enable", {
                                get: () => n.config._enable,
                                set: e => {
                                    n.config._enable = he(e)
                                }
                            }), Object.defineProperty(n.config, "disable", {
                                get: () => n.config._disable,
                                set: e => {
                                    n.config._disable = he(e)
                                }
                            });
                            const c = "time" === s.mode;
                            if (!s.dateFormat && (s.enableTime || c)) {
                                const e = M.defaultConfig.dateFormat || r.dateFormat;
                                l.dateFormat = s.noCalendar || c ? "H:i" + (s.enableSeconds ? ":S" : "") : e + " H:i" + (s.enableSeconds ? ":S" : "")
                            }
                            if (s.altInput && (s.enableTime || c) && !s.altFormat) {
                                const e = M.defaultConfig.altFormat || r.altFormat;
                                l.altFormat = s.noCalendar || c ? "h:i" + (s.enableSeconds ? ":S K" : " K") : e + ` h:i${s.enableSeconds?":S":""} K`
                            }
                            Object.defineProperty(n.config, "minDate", {
                                get: () => n.config._minDate,
                                set: ie("min")
                            }), Object.defineProperty(n.config, "maxDate", {
                                get: () => n.config._maxDate,
                                set: ie("max")
                            });
                            const d = e => t => {
                                n.config["min" === e ? "_minTime" : "_maxTime"] = n.parseDate(t, "H:i:S")
                            };
                            Object.defineProperty(n.config, "minTime", {
                                get: () => n.config._minTime,
                                set: d("min")
                            }), Object.defineProperty(n.config, "maxTime", {
                                get: () => n.config._maxTime,
                                set: d("max")
                            }), "time" === s.mode && (n.config.noCalendar = !0, n.config.enableTime = !0);
                            Object.assign(n.config, l, s);
                            for (let e = 0; e < a.length; e++) n.config[a[e]] = !0 === n.config[a[e]] || "true" === n.config[a[e]];
                            i.filter((e => void 0 !== n.config[e])).forEach((e => {
                                n.config[e] = u(n.config[e] || []).map(o)
                            })), n.isMobile = !n.config.disableMobile && !n.config.inline && "single" === n.config.mode && !n.config.disable.length && !n.config.enable && !n.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                            for (let e = 0; e < n.config.plugins.length; e++) {
                                const t = n.config.plugins[e](n) || {};
                                for (const e in t) i.indexOf(e) > -1 ? n.config[e] = u(t[e]).map(o).concat(n.config[e]) : void 0 === s[e] && (n.config[e] = t[e])
                            }
                            s.altInputClass || (n.config.altInputClass = re().className + " " + n.config.altInputClass);
                            fe("onParseConfig")
                        }(), oe(),
                        function () {
                            if (n.input = re(), !n.input) return void n.config.errorHandler(new Error("Invalid input element specified"));
                            n.input._type = n.input.type, n.input.type = "text", n.input.classList.add("flatpickr-input"), n._input = n.input, n.config.altInput && (n.altInput = h(n.input.nodeName, n.config.altInputClass), n._input = n.altInput, n.altInput.placeholder = n.input.placeholder, n.altInput.disabled = n.input.disabled, n.altInput.required = n.input.required, n.altInput.tabIndex = n.input.tabIndex, n.altInput.type = "text", n.input.setAttribute("type", "hidden"), !n.config.static && n.input.parentNode && n.input.parentNode.insertBefore(n.altInput, n.input.nextSibling));
                            n.config.allowInput || n._input.setAttribute("readonly", "readonly");
                            n._positionElement = n.config.positionElement || n._input
                        }(),
                        function () {
                            n.selectedDates = [], n.now = n.parseDate(n.config.now) || new Date;
                            const e = n.config.defaultDate || ("INPUT" !== n.input.nodeName && "TEXTAREA" !== n.input.nodeName || !n.input.placeholder || n.input.value !== n.input.placeholder ? n.input.value : null);
                            e && de(e, n.config.dateFormat);
                            n._initialDate = n.selectedDates.length > 0 ? n.selectedDates[0] : n.config.minDate && n.config.minDate.getTime() > n.now.getTime() ? n.config.minDate : n.config.maxDate && n.config.maxDate.getTime() < n.now.getTime() ? n.config.maxDate : n.now, n.currentYear = n._initialDate.getFullYear(), n.currentMonth = n._initialDate.getMonth(), n.selectedDates.length > 0 && (n.latestSelectedDateObj = n.selectedDates[0]);
                            void 0 !== n.config.minTime && (n.config.minTime = n.parseDate(n.config.minTime, "H:i"));
                            void 0 !== n.config.maxTime && (n.config.maxTime = n.parseDate(n.config.maxTime, "H:i"));
                            n.minDateHasTime = !!n.config.minDate && (n.config.minDate.getHours() > 0 || n.config.minDate.getMinutes() > 0 || n.config.minDate.getSeconds() > 0), n.maxDateHasTime = !!n.config.maxDate && (n.config.maxDate.getHours() > 0 || n.config.maxDate.getMinutes() > 0 || n.config.maxDate.getSeconds() > 0)
                        }(), n.utils = {
                            getDaysInMonth: (e = n.currentMonth, t = n.currentYear) => 1 === e && (t % 4 == 0 && t % 100 != 0 || t % 400 == 0) ? 29 : n.l10n.daysInMonth[e]
                        }, n.isMobile || function () {
                            const e = window.document.createDocumentFragment();
                            if (n.calendarContainer = h("div", "flatpickr-calendar"), n.calendarContainer.tabIndex = -1, !n.config.noCalendar) {
                                if (e.appendChild((n.monthNav = h("div", "flatpickr-months"), n.yearElements = [], n.monthElements = [], n.prevMonthNav = h("span", "flatpickr-prev-month"), n.prevMonthNav.innerHTML = n.config.prevArrow, n.nextMonthNav = h("span", "flatpickr-next-month"), n.nextMonthNav.innerHTML = n.config.nextArrow, V(), Object.defineProperty(n, "_hidePrevMonthArrow", {
                                        get: () => n.__hidePrevMonthArrow,
                                        set(e) {
                                            n.__hidePrevMonthArrow !== e && (d(n.prevMonthNav, "flatpickr-disabled", e), n.__hidePrevMonthArrow = e)
                                        }
                                    }), Object.defineProperty(n, "_hideNextMonthArrow", {
                                        get: () => n.__hideNextMonthArrow,
                                        set(e) {
                                            n.__hideNextMonthArrow !== e && (d(n.nextMonthNav, "flatpickr-disabled", e), n.__hideNextMonthArrow = e)
                                        }
                                    }), n.currentYearElement = n.yearElements[0], me(), n.monthNav)), n.innerContainer = h("div", "flatpickr-innerContainer"), n.config.weekNumbers) {
                                    const {
                                        weekWrapper: e,
                                        weekNumbers: t
                                    } = function () {
                                        n.calendarContainer.classList.add("hasWeeks");
                                        const e = h("div", "flatpickr-weekwrapper");
                                        e.appendChild(h("span", "flatpickr-weekday", n.l10n.weekAbbreviation));
                                        const t = h("div", "flatpickr-weeks");
                                        return e.appendChild(t), {
                                            weekWrapper: e,
                                            weekNumbers: t
                                        }
                                    }();
                                    n.innerContainer.appendChild(e), n.weekNumbers = t, n.weekWrapper = e
                                }
                                n.rContainer = h("div", "flatpickr-rContainer"), n.rContainer.appendChild(W()), n.daysContainer || (n.daysContainer = h("div", "flatpickr-days"), n.daysContainer.tabIndex = -1), z(), n.rContainer.appendChild(n.daysContainer), n.innerContainer.appendChild(n.rContainer), e.appendChild(n.innerContainer)
                            }
                            n.config.enableTime && e.appendChild(function () {
                                n.calendarContainer.classList.add("hasTime"), n.config.noCalendar && n.calendarContainer.classList.add("noCalendar");
                                const e = S(n.config);
                                n.timeContainer = h("div", "flatpickr-time"), n.timeContainer.tabIndex = -1;
                                const t = h("span", "flatpickr-time-separator", ":"),
                                    i = g("flatpickr-hour", {
                                        "aria-label": n.l10n.hourAriaLabel
                                    });
                                n.hourElement = i.getElementsByTagName("input")[0];
                                const r = g("flatpickr-minute", {
                                    "aria-label": n.l10n.minuteAriaLabel
                                });
                                n.minuteElement = r.getElementsByTagName("input")[0], n.hourElement.tabIndex = n.minuteElement.tabIndex = -1, n.hourElement.value = s(n.latestSelectedDateObj ? n.latestSelectedDateObj.getHours() : n.config.time_24hr ? e.hours : function (e) {
                                    switch (e % 24) {
                                        case 0:
                                        case 12:
                                            return 12;
                                        default:
                                            return e % 12
                                    }
                                }(e.hours)), n.minuteElement.value = s(n.latestSelectedDateObj ? n.latestSelectedDateObj.getMinutes() : e.minutes), n.hourElement.setAttribute("step", n.config.hourIncrement.toString()), n.minuteElement.setAttribute("step", n.config.minuteIncrement.toString()), n.hourElement.setAttribute("min", n.config.time_24hr ? "0" : "1"), n.hourElement.setAttribute("max", n.config.time_24hr ? "23" : "12"), n.hourElement.setAttribute("maxlength", "2"), n.minuteElement.setAttribute("min", "0"), n.minuteElement.setAttribute("max", "59"), n.minuteElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(i), n.timeContainer.appendChild(t), n.timeContainer.appendChild(r), n.config.time_24hr && n.timeContainer.classList.add("time24hr");
                                if (n.config.enableSeconds) {
                                    n.timeContainer.classList.add("hasSeconds");
                                    const t = g("flatpickr-second");
                                    n.secondElement = t.getElementsByTagName("input")[0], n.secondElement.value = s(n.latestSelectedDateObj ? n.latestSelectedDateObj.getSeconds() : e.seconds), n.secondElement.setAttribute("step", n.minuteElement.getAttribute("step")), n.secondElement.setAttribute("min", "0"), n.secondElement.setAttribute("max", "59"), n.secondElement.setAttribute("maxlength", "2"), n.timeContainer.appendChild(h("span", "flatpickr-time-separator", ":")), n.timeContainer.appendChild(t)
                                }
                                n.config.time_24hr || (n.amPM = h("span", "flatpickr-am-pm", n.l10n.amPM[l((n.latestSelectedDateObj ? n.hourElement.value : n.config.defaultHour) > 11)]), n.amPM.title = n.l10n.toggleTitle, n.amPM.tabIndex = -1, n.timeContainer.appendChild(n.amPM));
                                return n.timeContainer
                            }());
                            d(n.calendarContainer, "rangeMode", "range" === n.config.mode), d(n.calendarContainer, "animate", !0 === n.config.animate), d(n.calendarContainer, "multiMonth", n.config.showMonths > 1), n.calendarContainer.appendChild(e);
                            const t = void 0 !== n.config.appendTo && void 0 !== n.config.appendTo.nodeType;
                            if ((n.config.inline || n.config.static) && (n.calendarContainer.classList.add(n.config.inline ? "inline" : "static"), n.config.inline && (!t && n.element.parentNode ? n.element.parentNode.insertBefore(n.calendarContainer, n._input.nextSibling) : void 0 !== n.config.appendTo && n.config.appendTo.appendChild(n.calendarContainer)), n.config.static)) {
                                const e = h("div", "flatpickr-wrapper");
                                n.element.parentNode && n.element.parentNode.insertBefore(e, n.element), e.appendChild(n.element), n.altInput && e.appendChild(n.altInput), e.appendChild(n.calendarContainer)
                            }
                            n.config.static || n.config.inline || (void 0 !== n.config.appendTo ? n.config.appendTo : window.document.body).appendChild(n.calendarContainer)
                        }(),
                        function () {
                            n.config.wrap && ["open", "close", "toggle", "clear"].forEach((e => {
                                Array.prototype.forEach.call(n.element.querySelectorAll(`[data-${e}]`), (t => P(t, "click", n[e])))
                            }));
                            if (n.isMobile) return void
                            function () {
                                const e = n.config.enableTime ? n.config.noCalendar ? "time" : "datetime-local" : "date";
                                n.mobileInput = h("input", n.input.className + " flatpickr-mobile"), n.mobileInput.tabIndex = 1, n.mobileInput.type = e, n.mobileInput.disabled = n.input.disabled, n.mobileInput.required = n.input.required, n.mobileInput.placeholder = n.input.placeholder, n.mobileFormatStr = "datetime-local" === e ? "Y-m-d\\TH:i:S" : "date" === e ? "Y-m-d" : "H:i:S", n.selectedDates.length > 0 && (n.mobileInput.defaultValue = n.mobileInput.value = n.formatDate(n.selectedDates[0], n.mobileFormatStr));
                                n.config.minDate && (n.mobileInput.min = n.formatDate(n.config.minDate, "Y-m-d"));
                                n.config.maxDate && (n.mobileInput.max = n.formatDate(n.config.maxDate, "Y-m-d"));
                                n.input.getAttribute("step") && (n.mobileInput.step = String(n.input.getAttribute("step")));
                                n.input.type = "hidden", void 0 !== n.altInput && (n.altInput.type = "hidden");
                                try {
                                    n.input.parentNode && n.input.parentNode.insertBefore(n.mobileInput, n.input.nextSibling)
                                } catch (e) {}
                                P(n.mobileInput, "change", (e => {
                                    n.setDate(m(e).value, !1, n.mobileFormatStr), fe("onChange"), fe("onClose")
                                }))
                            }();
                            const e = c(ne, 50);
                            n._debouncedChange = c(D, 300), n.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && P(n.daysContainer, "mouseover", (e => {
                                "range" === n.config.mode && te(m(e))
                            }));
                            P(window.document.body, "keydown", ee), n.config.inline || n.config.static || P(window, "resize", e);
                            void 0 !== window.ontouchstart ? P(window.document, "touchstart", G) : P(window.document, "mousedown", G);
                            P(window.document, "focus", G, {
                                capture: !0
                            }), !0 === n.config.clickOpens && (P(n._input, "focus", n.open), P(n._input, "click", n.open));
                            void 0 !== n.daysContainer && (P(n.monthNav, "click", ye), P(n.monthNav, ["keyup", "increment"], T), P(n.daysContainer, "click", ce));
                            if (void 0 !== n.timeContainer && void 0 !== n.minuteElement && void 0 !== n.hourElement) {
                                const e = e => m(e).select();
                                P(n.timeContainer, ["increment"], y), P(n.timeContainer, "blur", y, {
                                    capture: !0
                                }), P(n.timeContainer, "click", N), P([n.hourElement, n.minuteElement], ["focus", "click"], e), void 0 !== n.secondElement && P(n.secondElement, "focus", (() => n.secondElement && n.secondElement.select())), void 0 !== n.amPM && P(n.amPM, "click", (e => {
                                    y(e), D()
                                }))
                            }
                            n.config.allowInput && P(n._input, "blur", J)
                        }(), (n.selectedDates.length || n.config.noCalendar) && (n.config.enableTime && C(n.config.noCalendar ? n.latestSelectedDateObj : void 0), be(!1)), v();
                    const a = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    !n.isMobile && a && ae(), fe("onReady")
                }(), n
            }

            function A(e, t) {
                const n = Array.prototype.slice.call(e).filter((e => e instanceof HTMLElement)),
                    i = [];
                for (let e = 0; e < n.length; e++) {
                    const r = n[e];
                    try {
                        if (null !== r.getAttribute("data-fp-omit")) continue;
                        void 0 !== r._flatpickr && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = C(r, t || {}), i.push(r._flatpickr)
                    } catch (e) {
                        console.error(e)
                    }
                }
                return 1 === i.length ? i[0] : i
            }
            "undefined" != typeof HTMLElement && "undefined" != typeof HTMLCollection && "undefined" != typeof NodeList && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (e) {
                return A(this, e)
            }, HTMLElement.prototype.flatpickr = function (e) {
                return A([this], e)
            });
            var M = function (e, t) {
                return "string" == typeof e ? A(window.document.querySelectorAll(e), t) : e instanceof Node ? A([e], t) : A(e, t)
            };
            M.defaultConfig = {}, M.l10ns = {
                en: Object.assign({}, a),
                default: Object.assign({}, a)
            }, M.localize = e => {
                M.l10ns.default = Object.assign(Object.assign({}, M.l10ns.default), e)
            }, M.setDefaults = e => {
                M.defaultConfig = Object.assign(Object.assign({}, M.defaultConfig), e)
            }, M.parseDate = E({}), M.formatDate = w({}), M.compareDates = k, "undefined" != typeof jQuery && void 0 !== jQuery.fn && (jQuery.fn.flatpickr = function (e) {
                return A(this, e)
            }), Date.prototype.fp_incr = function (e) {
                return new Date(this.getFullYear(), this.getMonth(), this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e))
            }, "undefined" != typeof window && (window.flatpickr = M);
            const T = M
        },
        895: () => {
            "use strict";
            "function" != typeof Object.assign && (Object.assign = function (e, ...t) {
                if (!e) throw TypeError("Cannot convert undefined or null to object");
                for (const n of t) n && Object.keys(n).forEach((t => e[t] = n[t]));
                return e
            })
        },
        802: e => {
            function t(e) {
                return e instanceof Map ? e.clear = e.delete = e.set = function () {
                    throw new Error("map is read-only")
                } : e instanceof Set && (e.add = e.clear = e.delete = function () {
                    throw new Error("set is read-only")
                }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((function (n) {
                    var i = e[n];
                    "object" != typeof i || Object.isFrozen(i) || t(i)
                })), e
            }
            var n = t,
                i = t;
            n.default = i;
            class r {
                constructor(e) {
                    void 0 === e.data && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1
                }
                ignoreMatch() {
                    this.isMatchIgnored = !0
                }
            }

            function o(e) {
                return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;")
            }

            function a(e, ...t) {
                const n = Object.create(null);
                for (const t in e) n[t] = e[t];
                return t.forEach((function (e) {
                    for (const t in e) n[t] = e[t]
                })), n
            }
            const s = e => !!e.kind;
            class l {
                constructor(e, t) {
                    this.buffer = "", this.classPrefix = t.classPrefix, e.walk(this)
                }
                addText(e) {
                    this.buffer += o(e)
                }
                openNode(e) {
                    if (!s(e)) return;
                    let t = e.kind;
                    e.sublanguage || (t = `${this.classPrefix}${t}`), this.span(t)
                }
                closeNode(e) {
                    s(e) && (this.buffer += "</span>")
                }
                value() {
                    return this.buffer
                }
                span(e) {
                    this.buffer += `<span class="${e}">`
                }
            }
            class c {
                constructor() {
                    this.rootNode = {
                        children: []
                    }, this.stack = [this.rootNode]
                }
                get top() {
                    return this.stack[this.stack.length - 1]
                }
                get root() {
                    return this.rootNode
                }
                add(e) {
                    this.top.children.push(e)
                }
                openNode(e) {
                    const t = {
                        kind: e,
                        children: []
                    };
                    this.add(t), this.stack.push(t)
                }
                closeNode() {
                    if (this.stack.length > 1) return this.stack.pop()
                }
                closeAllNodes() {
                    for (; this.closeNode(););
                }
                toJSON() {
                    return JSON.stringify(this.rootNode, null, 4)
                }
                walk(e) {
                    return this.constructor._walk(e, this.rootNode)
                }
                static _walk(e, t) {
                    return "string" == typeof t ? e.addText(t) : t.children && (e.openNode(t), t.children.forEach((t => this._walk(e, t))), e.closeNode(t)), e
                }
                static _collapse(e) {
                    "string" != typeof e && e.children && (e.children.every((e => "string" == typeof e)) ? e.children = [e.children.join("")] : e.children.forEach((e => {
                        c._collapse(e)
                    })))
                }
            }
            class u extends c {
                constructor(e) {
                    super(), this.options = e
                }
                addKeyword(e, t) {
                    "" !== e && (this.openNode(t), this.addText(e), this.closeNode())
                }
                addText(e) {
                    "" !== e && this.add(e)
                }
                addSublanguage(e, t) {
                    const n = e.root;
                    n.kind = t, n.sublanguage = !0, this.add(n)
                }
                toHTML() {
                    return new l(this, this.options).value()
                }
                finalize() {
                    return !0
                }
            }

            function d(e) {
                return e ? "string" == typeof e ? e : e.source : null
            }
            const h = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
            const f = "[a-zA-Z]\\w*",
                p = "[a-zA-Z_]\\w*",
                g = "\\b\\d+(\\.\\d+)?",
                m = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
                v = "\\b(0b[01]+)",
                b = {
                    begin: "\\\\[\\s\\S]",
                    relevance: 0
                },
                y = {
                    className: "string",
                    begin: "'",
                    end: "'",
                    illegal: "\\n",
                    contains: [b]
                },
                _ = {
                    className: "string",
                    begin: '"',
                    end: '"',
                    illegal: "\\n",
                    contains: [b]
                },
                x = {
                    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
                },
                w = function (e, t, n = {}) {
                    const i = a({
                        className: "comment",
                        begin: e,
                        end: t,
                        contains: []
                    }, n);
                    return i.contains.push(x), i.contains.push({
                        className: "doctag",
                        begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
                        relevance: 0
                    }), i
                },
                E = w("//", "$"),
                k = w("/\\*", "\\*/"),
                O = w("#", "$"),
                S = {
                    className: "number",
                    begin: g,
                    relevance: 0
                },
                C = {
                    className: "number",
                    begin: m,
                    relevance: 0
                },
                A = {
                    className: "number",
                    begin: v,
                    relevance: 0
                },
                M = {
                    className: "number",
                    begin: g + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
                    relevance: 0
                },
                T = {
                    begin: /(?=\/[^/\n]*\/)/,
                    contains: [{
                        className: "regexp",
                        begin: /\//,
                        end: /\/[gimuy]*/,
                        illegal: /\n/,
                        contains: [b, {
                            begin: /\[/,
                            end: /\]/,
                            relevance: 0,
                            contains: [b]
                        }]
                    }]
                },
                P = {
                    className: "title",
                    begin: f,
                    relevance: 0
                },
                D = {
                    className: "title",
                    begin: p,
                    relevance: 0
                },
                L = {
                    begin: "\\.\\s*[a-zA-Z_]\\w*",
                    relevance: 0
                };
            var N = Object.freeze({
                __proto__: null,
                MATCH_NOTHING_RE: /\b\B/,
                IDENT_RE: f,
                UNDERSCORE_IDENT_RE: p,
                NUMBER_RE: g,
                C_NUMBER_RE: m,
                BINARY_NUMBER_RE: v,
                RE_STARTERS_RE: "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",
                SHEBANG: (e = {}) => {
                    const t = /^#![ ]*\//;
                    return e.binary && (e.begin = function (...e) {
                        return e.map((e => d(e))).join("")
                    }(t, /.*\b/, e.binary, /\b.*/)), a({
                        className: "meta",
                        begin: t,
                        end: /$/,
                        relevance: 0,
                        "on:begin": (e, t) => {
                            0 !== e.index && t.ignoreMatch()
                        }
                    }, e)
                },
                BACKSLASH_ESCAPE: b,
                APOS_STRING_MODE: y,
                QUOTE_STRING_MODE: _,
                PHRASAL_WORDS_MODE: x,
                COMMENT: w,
                C_LINE_COMMENT_MODE: E,
                C_BLOCK_COMMENT_MODE: k,
                HASH_COMMENT_MODE: O,
                NUMBER_MODE: S,
                C_NUMBER_MODE: C,
                BINARY_NUMBER_MODE: A,
                CSS_NUMBER_MODE: M,
                REGEXP_MODE: T,
                TITLE_MODE: P,
                UNDERSCORE_TITLE_MODE: D,
                METHOD_GUARD: L,
                END_SAME_AS_BEGIN: function (e) {
                    return Object.assign(e, {
                        "on:begin": (e, t) => {
                            t.data._beginMatch = e[1]
                        },
                        "on:end": (e, t) => {
                            t.data._beginMatch !== e[1] && t.ignoreMatch()
                        }
                    })
                }
            });

            function j(e, t) {
                "." === e.input[e.index - 1] && t.ignoreMatch()
            }

            function I(e, t) {
                t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = j, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, void 0 === e.relevance && (e.relevance = 0))
            }

            function R(e, t) {
                Array.isArray(e.illegal) && (e.illegal = function (...e) {
                    return "(" + e.map((e => d(e))).join("|") + ")"
                }(...e.illegal))
            }

            function F(e, t) {
                if (e.match) {
                    if (e.begin || e.end) throw new Error("begin & end are not supported with match");
                    e.begin = e.match, delete e.match
                }
            }

            function B(e, t) {
                void 0 === e.relevance && (e.relevance = 1)
            }
            const q = ["of", "and", "for", "in", "not", "or", "if", "then", "parent", "list", "value"];

            function z(e, t, n = "keyword") {
                const i = {};
                return "string" == typeof e ? r(n, e.split(" ")) : Array.isArray(e) ? r(n, e) : Object.keys(e).forEach((function (n) {
                    Object.assign(i, z(e[n], t, n))
                })), i;

                function r(e, n) {
                    t && (n = n.map((e => e.toLowerCase()))), n.forEach((function (t) {
                        const n = t.split("|");
                        i[n[0]] = [e, H(n[0], n[1])]
                    }))
                }
            }

            function H(e, t) {
                return t ? Number(t) : function (e) {
                    return q.includes(e.toLowerCase())
                }(e) ? 0 : 1
            }

            function U(e, {
                plugins: t
            }) {
                function n(t, n) {
                    return new RegExp(d(t), "m" + (e.case_insensitive ? "i" : "") + (n ? "g" : ""))
                }
                class i {
                    constructor() {
                        this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0
                    }
                    addRule(e, t) {
                        t.position = this.position++, this.matchIndexes[this.matchAt] = t, this.regexes.push([t, e]), this.matchAt += function (e) {
                            return new RegExp(e.toString() + "|").exec("").length - 1
                        }(e) + 1
                    }
                    compile() {
                        0 === this.regexes.length && (this.exec = () => null);
                        const e = this.regexes.map((e => e[1]));
                        this.matcherRe = n(function (e, t = "|") {
                            let n = 0;
                            return e.map((e => {
                                n += 1;
                                const t = n;
                                let i = d(e),
                                    r = "";
                                for (; i.length > 0;) {
                                    const e = h.exec(i);
                                    if (!e) {
                                        r += i;
                                        break
                                    }
                                    r += i.substring(0, e.index), i = i.substring(e.index + e[0].length), "\\" === e[0][0] && e[1] ? r += "\\" + String(Number(e[1]) + t) : (r += e[0], "(" === e[0] && n++)
                                }
                                return r
                            })).map((e => `(${e})`)).join(t)
                        }(e), !0), this.lastIndex = 0
                    }
                    exec(e) {
                        this.matcherRe.lastIndex = this.lastIndex;
                        const t = this.matcherRe.exec(e);
                        if (!t) return null;
                        const n = t.findIndex(((e, t) => t > 0 && void 0 !== e)),
                            i = this.matchIndexes[n];
                        return t.splice(0, n), Object.assign(t, i)
                    }
                }
                class r {
                    constructor() {
                        this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0
                    }
                    getMatcher(e) {
                        if (this.multiRegexes[e]) return this.multiRegexes[e];
                        const t = new i;
                        return this.rules.slice(e).forEach((([e, n]) => t.addRule(e, n))), t.compile(), this.multiRegexes[e] = t, t
                    }
                    resumingScanAtSamePosition() {
                        return 0 !== this.regexIndex
                    }
                    considerAll() {
                        this.regexIndex = 0
                    }
                    addRule(e, t) {
                        this.rules.push([e, t]), "begin" === t.type && this.count++
                    }
                    exec(e) {
                        const t = this.getMatcher(this.regexIndex);
                        t.lastIndex = this.lastIndex;
                        let n = t.exec(e);
                        if (this.resumingScanAtSamePosition())
                            if (n && n.index === this.lastIndex);
                            else {
                                const t = this.getMatcher(0);
                                t.lastIndex = this.lastIndex + 1, n = t.exec(e)
                            } return n && (this.regexIndex += n.position + 1, this.regexIndex === this.count && this.considerAll()), n
                    }
                }
                if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
                return e.classNameAliases = a(e.classNameAliases || {}),
                    function t(i, o) {
                        const s = i;
                        if (i.isCompiled) return s;
                        [F].forEach((e => e(i, o))), e.compilerExtensions.forEach((e => e(i, o))), i.__beforeBegin = null, [I, R, B].forEach((e => e(i, o))), i.isCompiled = !0;
                        let l = null;
                        if ("object" == typeof i.keywords && (l = i.keywords.$pattern, delete i.keywords.$pattern), i.keywords && (i.keywords = z(i.keywords, e.case_insensitive)), i.lexemes && l) throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
                        return l = l || i.lexemes || /\w+/, s.keywordPatternRe = n(l, !0), o && (i.begin || (i.begin = /\B|\b/), s.beginRe = n(i.begin), i.endSameAsBegin && (i.end = i.begin), i.end || i.endsWithParent || (i.end = /\B|\b/), i.end && (s.endRe = n(i.end)), s.terminatorEnd = d(i.end) || "", i.endsWithParent && o.terminatorEnd && (s.terminatorEnd += (i.end ? "|" : "") + o.terminatorEnd)), i.illegal && (s.illegalRe = n(i.illegal)), i.contains || (i.contains = []), i.contains = [].concat(...i.contains.map((function (e) {
                            return function (e) {
                                e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map((function (t) {
                                    return a(e, {
                                        variants: null
                                    }, t)
                                })));
                                if (e.cachedVariants) return e.cachedVariants;
                                if (V(e)) return a(e, {
                                    starts: e.starts ? a(e.starts) : null
                                });
                                if (Object.isFrozen(e)) return a(e);
                                return e
                            }("self" === e ? i : e)
                        }))), i.contains.forEach((function (e) {
                            t(e, s)
                        })), i.starts && t(i.starts, o), s.matcher = function (e) {
                            const t = new r;
                            return e.contains.forEach((e => t.addRule(e.begin, {
                                rule: e,
                                type: "begin"
                            }))), e.terminatorEnd && t.addRule(e.terminatorEnd, {
                                type: "end"
                            }), e.illegal && t.addRule(e.illegal, {
                                type: "illegal"
                            }), t
                        }(s), s
                    }(e)
            }

            function V(e) {
                return !!e && (e.endsWithParent || V(e.starts))
            }

            function W(e) {
                const t = {
                    props: ["language", "code", "autodetect"],
                    data: function () {
                        return {
                            detectedLanguage: "",
                            unknownLanguage: !1
                        }
                    },
                    computed: {
                        className() {
                            return this.unknownLanguage ? "" : "hljs " + this.detectedLanguage
                        },
                        highlighted() {
                            if (!this.autoDetect && !e.getLanguage(this.language)) return console.warn(`The language "${this.language}" you specified could not be found.`), this.unknownLanguage = !0, o(this.code);
                            let t = {};
                            return this.autoDetect ? (t = e.highlightAuto(this.code), this.detectedLanguage = t.language) : (t = e.highlight(this.language, this.code, this.ignoreIllegals), this.detectedLanguage = this.language), t.value
                        },
                        autoDetect() {
                            return !this.language || (e = this.autodetect, Boolean(e || "" === e));
                            var e
                        },
                        ignoreIllegals: () => !0
                    },
                    render(e) {
                        return e("pre", {}, [e("code", {
                            class: this.className,
                            domProps: {
                                innerHTML: this.highlighted
                            }
                        })])
                    }
                };
                return {
                    Component: t,
                    VuePlugin: {
                        install(e) {
                            e.component("highlightjs", t)
                        }
                    }
                }
            }
            const Y = {
                "after:highlightElement": ({
                    el: e,
                    result: t,
                    text: n
                }) => {
                    const i = K(e);
                    if (!i.length) return;
                    const r = document.createElement("div");
                    r.innerHTML = t.value, t.value = function (e, t, n) {
                        let i = 0,
                            r = "";
                        const a = [];

                        function s() {
                            return e.length && t.length ? e[0].offset !== t[0].offset ? e[0].offset < t[0].offset ? e : t : "start" === t[0].event ? e : t : e.length ? e : t
                        }

                        function l(e) {
                            function t(e) {
                                return " " + e.nodeName + '="' + o(e.value) + '"'
                            }
                            r += "<" + $(e) + [].map.call(e.attributes, t).join("") + ">"
                        }

                        function c(e) {
                            r += "</" + $(e) + ">"
                        }

                        function u(e) {
                            ("start" === e.event ? l : c)(e.node)
                        }
                        for (; e.length || t.length;) {
                            let t = s();
                            if (r += o(n.substring(i, t[0].offset)), i = t[0].offset, t === e) {
                                a.reverse().forEach(c);
                                do {
                                    u(t.splice(0, 1)[0]), t = s()
                                } while (t === e && t.length && t[0].offset === i);
                                a.reverse().forEach(l)
                            } else "start" === t[0].event ? a.push(t[0].node) : a.pop(), u(t.splice(0, 1)[0])
                        }
                        return r + o(n.substr(i))
                    }(i, K(r), n)
                }
            };

            function $(e) {
                return e.nodeName.toLowerCase()
            }

            function K(e) {
                const t = [];
                return function e(n, i) {
                    for (let r = n.firstChild; r; r = r.nextSibling) 3 === r.nodeType ? i += r.nodeValue.length : 1 === r.nodeType && (t.push({
                        event: "start",
                        offset: i,
                        node: r
                    }), i = e(r, i), $(r).match(/br|hr|img|input/) || t.push({
                        event: "stop",
                        offset: i,
                        node: r
                    }));
                    return i
                }(e, 0), t
            }
            const G = {},
                X = e => {
                    console.error(e)
                },
                Z = (e, ...t) => {
                    console.log(`WARN: ${e}`, ...t)
                },
                Q = (e, t) => {
                    G[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), G[`${e}/${t}`] = !0)
                },
                J = o,
                ee = a,
                te = Symbol("nomatch");
            var ne = function (e) {
                const t = Object.create(null),
                    i = Object.create(null),
                    o = [];
                let a = !0;
                const s = /(^(<[^>]+>|\t|)+|\n)/gm,
                    l = "Could not find the language '{}', did you forget to load/include a language module?",
                    c = {
                        disableAutodetect: !0,
                        name: "Plain text",
                        contains: []
                    };
                let d = {
                    noHighlightRe: /^(no-?highlight)$/i,
                    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
                    classPrefix: "hljs-",
                    tabReplace: null,
                    useBR: !1,
                    languages: null,
                    __emitter: u
                };

                function h(e) {
                    return d.noHighlightRe.test(e)
                }

                function f(e, t, n, i) {
                    let r = "",
                        o = "";
                    "object" == typeof t ? (r = e, n = t.ignoreIllegals, o = t.language, i = void 0) : (Q("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Q("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277"), o = e, r = t);
                    const a = {
                        code: r,
                        language: o
                    };
                    S("before:highlight", a);
                    const s = a.result ? a.result : p(a.language, a.code, n, i);
                    return s.code = a.code, S("after:highlight", s), s
                }

                function p(e, n, i, s) {
                    function c(e, t) {
                        const n = x.case_insensitive ? t[0].toLowerCase() : t[0];
                        return Object.prototype.hasOwnProperty.call(e.keywords, n) && e.keywords[n]
                    }

                    function u() {
                        null != O.subLanguage ? function () {
                            if ("" === A) return;
                            let e = null;
                            if ("string" == typeof O.subLanguage) {
                                if (!t[O.subLanguage]) return void C.addText(A);
                                e = p(O.subLanguage, A, !0, S[O.subLanguage]), S[O.subLanguage] = e.top
                            } else e = g(A, O.subLanguage.length ? O.subLanguage : null);
                            O.relevance > 0 && (M += e.relevance), C.addSublanguage(e.emitter, e.language)
                        }() : function () {
                            if (!O.keywords) return void C.addText(A);
                            let e = 0;
                            O.keywordPatternRe.lastIndex = 0;
                            let t = O.keywordPatternRe.exec(A),
                                n = "";
                            for (; t;) {
                                n += A.substring(e, t.index);
                                const i = c(O, t);
                                if (i) {
                                    const [e, r] = i;
                                    if (C.addText(n), n = "", M += r, e.startsWith("_")) n += t[0];
                                    else {
                                        const n = x.classNameAliases[e] || e;
                                        C.addKeyword(t[0], n)
                                    }
                                } else n += t[0];
                                e = O.keywordPatternRe.lastIndex, t = O.keywordPatternRe.exec(A)
                            }
                            n += A.substr(e), C.addText(n)
                        }(), A = ""
                    }

                    function h(e) {
                        return e.className && C.openNode(x.classNameAliases[e.className] || e.className), O = Object.create(e, {
                            parent: {
                                value: O
                            }
                        }), O
                    }

                    function f(e, t, n) {
                        let i = function (e, t) {
                            const n = e && e.exec(t);
                            return n && 0 === n.index
                        }(e.endRe, n);
                        if (i) {
                            if (e["on:end"]) {
                                const n = new r(e);
                                e["on:end"](t, n), n.isMatchIgnored && (i = !1)
                            }
                            if (i) {
                                for (; e.endsParent && e.parent;) e = e.parent;
                                return e
                            }
                        }
                        if (e.endsWithParent) return f(e.parent, t, n)
                    }

                    function m(e) {
                        return 0 === O.matcher.regexIndex ? (A += e[0], 1) : (D = !0, 0)
                    }

                    function v(e) {
                        const t = e[0],
                            n = e.rule,
                            i = new r(n),
                            o = [n.__beforeBegin, n["on:begin"]];
                        for (const n of o)
                            if (n && (n(e, i), i.isMatchIgnored)) return m(t);
                        return n && n.endSameAsBegin && (n.endRe = new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m")), n.skip ? A += t : (n.excludeBegin && (A += t), u(), n.returnBegin || n.excludeBegin || (A = t)), h(n), n.returnBegin ? 0 : t.length
                    }

                    function b(e) {
                        const t = e[0],
                            i = n.substr(e.index),
                            r = f(O, e, i);
                        if (!r) return te;
                        const o = O;
                        o.skip ? A += t : (o.returnEnd || o.excludeEnd || (A += t), u(), o.excludeEnd && (A = t));
                        do {
                            O.className && C.closeNode(), O.skip || O.subLanguage || (M += O.relevance), O = O.parent
                        } while (O !== r.parent);
                        return r.starts && (r.endSameAsBegin && (r.starts.endRe = r.endRe), h(r.starts)), o.returnEnd ? 0 : t.length
                    }
                    let y = {};

                    function _(t, r) {
                        const o = r && r[0];
                        if (A += t, null == o) return u(), 0;
                        if ("begin" === y.type && "end" === r.type && y.index === r.index && "" === o) {
                            if (A += n.slice(r.index, r.index + 1), !a) {
                                const t = new Error("0 width match regex");
                                throw t.languageName = e, t.badRule = y.rule, t
                            }
                            return 1
                        }
                        if (y = r, "begin" === r.type) return v(r);
                        if ("illegal" === r.type && !i) {
                            const e = new Error('Illegal lexeme "' + o + '" for mode "' + (O.className || "<unnamed>") + '"');
                            throw e.mode = O, e
                        }
                        if ("end" === r.type) {
                            const e = b(r);
                            if (e !== te) return e
                        }
                        if ("illegal" === r.type && "" === o) return 1;
                        if (P > 1e5 && P > 3 * r.index) {
                            throw new Error("potential infinite loop, way more iterations than matches")
                        }
                        return A += o, o.length
                    }
                    const x = E(e);
                    if (!x) throw X(l.replace("{}", e)), new Error('Unknown language: "' + e + '"');
                    const w = U(x, {
                        plugins: o
                    });
                    let k = "",
                        O = s || w;
                    const S = {},
                        C = new d.__emitter(d);
                    ! function () {
                        const e = [];
                        for (let t = O; t !== x; t = t.parent) t.className && e.unshift(t.className);
                        e.forEach((e => C.openNode(e)))
                    }();
                    let A = "",
                        M = 0,
                        T = 0,
                        P = 0,
                        D = !1;
                    try {
                        for (O.matcher.considerAll();;) {
                            P++, D ? D = !1 : O.matcher.considerAll(), O.matcher.lastIndex = T;
                            const e = O.matcher.exec(n);
                            if (!e) break;
                            const t = _(n.substring(T, e.index), e);
                            T = e.index + t
                        }
                        return _(n.substr(T)), C.closeAllNodes(), C.finalize(), k = C.toHTML(), {
                            relevance: Math.floor(M),
                            value: k,
                            language: e,
                            illegal: !1,
                            emitter: C,
                            top: O
                        }
                    } catch (t) {
                        if (t.message && t.message.includes("Illegal")) return {
                            illegal: !0,
                            illegalBy: {
                                msg: t.message,
                                context: n.slice(T - 100, T + 100),
                                mode: t.mode
                            },
                            sofar: k,
                            relevance: 0,
                            value: J(n),
                            emitter: C
                        };
                        if (a) return {
                            illegal: !1,
                            relevance: 0,
                            value: J(n),
                            emitter: C,
                            language: e,
                            top: O,
                            errorRaised: t
                        };
                        throw t
                    }
                }

                function g(e, n) {
                    n = n || d.languages || Object.keys(t);
                    const i = function (e) {
                            const t = {
                                relevance: 0,
                                emitter: new d.__emitter(d),
                                value: J(e),
                                illegal: !1,
                                top: c
                            };
                            return t.emitter.addText(e), t
                        }(e),
                        r = n.filter(E).filter(O).map((t => p(t, e, !1)));
                    r.unshift(i);
                    const o = r.sort(((e, t) => {
                            if (e.relevance !== t.relevance) return t.relevance - e.relevance;
                            if (e.language && t.language) {
                                if (E(e.language).supersetOf === t.language) return 1;
                                if (E(t.language).supersetOf === e.language) return -1
                            }
                            return 0
                        })),
                        [a, s] = o,
                        l = a;
                    return l.second_best = s, l
                }
                const m = {
                        "before:highlightElement": ({
                            el: e
                        }) => {
                            d.useBR && (e.innerHTML = e.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, "\n"))
                        },
                        "after:highlightElement": ({
                            result: e
                        }) => {
                            d.useBR && (e.value = e.value.replace(/\n/g, "<br>"))
                        }
                    },
                    v = /^(<[^>]+>|\t)+/gm,
                    b = {
                        "after:highlightElement": ({
                            result: e
                        }) => {
                            d.tabReplace && (e.value = e.value.replace(v, (e => e.replace(/\t/g, d.tabReplace))))
                        }
                    };

                function y(e) {
                    let t = null;
                    const n = function (e) {
                        let t = e.className + " ";
                        t += e.parentNode ? e.parentNode.className : "";
                        const n = d.languageDetectRe.exec(t);
                        if (n) {
                            const t = E(n[1]);
                            return t || (Z(l.replace("{}", n[1])), Z("Falling back to no-highlight mode for this block.", e)), t ? n[1] : "no-highlight"
                        }
                        return t.split(/\s+/).find((e => h(e) || E(e)))
                    }(e);
                    if (h(n)) return;
                    S("before:highlightElement", {
                        el: e,
                        language: n
                    }), t = e;
                    const r = t.textContent,
                        o = n ? f(r, {
                            language: n,
                            ignoreIllegals: !0
                        }) : g(r);
                    S("after:highlightElement", {
                            el: e,
                            result: o,
                            text: r
                        }), e.innerHTML = o.value,
                        function (e, t, n) {
                            const r = t ? i[t] : n;
                            e.classList.add("hljs"), r && e.classList.add(r)
                        }(e, n, o.language), e.result = {
                            language: o.language,
                            re: o.relevance,
                            relavance: o.relevance
                        }, o.second_best && (e.second_best = {
                            language: o.second_best.language,
                            re: o.second_best.relevance,
                            relavance: o.second_best.relevance
                        })
                }
                const _ = () => {
                    if (_.called) return;
                    _.called = !0, Q("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead.");
                    document.querySelectorAll("pre code").forEach(y)
                };
                let x = !1;

                function w() {
                    if ("loading" === document.readyState) return void(x = !0);
                    document.querySelectorAll("pre code").forEach(y)
                }

                function E(e) {
                    return e = (e || "").toLowerCase(), t[e] || t[i[e]]
                }

                function k(e, {
                    languageName: t
                }) {
                    "string" == typeof e && (e = [e]), e.forEach((e => {
                        i[e.toLowerCase()] = t
                    }))
                }

                function O(e) {
                    const t = E(e);
                    return t && !t.disableAutodetect
                }

                function S(e, t) {
                    const n = e;
                    o.forEach((function (e) {
                        e[n] && e[n](t)
                    }))
                }
                "undefined" != typeof window && window.addEventListener && window.addEventListener("DOMContentLoaded", (function () {
                    x && w()
                }), !1), Object.assign(e, {
                    highlight: f,
                    highlightAuto: g,
                    highlightAll: w,
                    fixMarkup: function (e) {
                        return Q("10.2.0", "fixMarkup will be removed entirely in v11.0"), Q("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534"), t = e, d.tabReplace || d.useBR ? t.replace(s, (e => "\n" === e ? d.useBR ? "<br>" : e : d.tabReplace ? e.replace(/\t/g, d.tabReplace) : e)) : t;
                        var t
                    },
                    highlightElement: y,
                    highlightBlock: function (e) {
                        return Q("10.7.0", "highlightBlock will be removed entirely in v12.0"), Q("10.7.0", "Please use highlightElement now."), y(e)
                    },
                    configure: function (e) {
                        e.useBR && (Q("10.3.0", "'useBR' will be removed entirely in v11.0"), Q("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559")), d = ee(d, e)
                    },
                    initHighlighting: _,
                    initHighlightingOnLoad: function () {
                        Q("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."), x = !0
                    },
                    registerLanguage: function (n, i) {
                        let r = null;
                        try {
                            r = i(e)
                        } catch (e) {
                            if (X("Language definition for '{}' could not be registered.".replace("{}", n)), !a) throw e;
                            X(e), r = c
                        }
                        r.name || (r.name = n), t[n] = r, r.rawDefinition = i.bind(null, e), r.aliases && k(r.aliases, {
                            languageName: n
                        })
                    },
                    unregisterLanguage: function (e) {
                        delete t[e];
                        for (const t of Object.keys(i)) i[t] === e && delete i[t]
                    },
                    listLanguages: function () {
                        return Object.keys(t)
                    },
                    getLanguage: E,
                    registerAliases: k,
                    requireLanguage: function (e) {
                        Q("10.4.0", "requireLanguage will be removed entirely in v11."), Q("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
                        const t = E(e);
                        if (t) return t;
                        throw new Error("The '{}' language is required, but not loaded.".replace("{}", e))
                    },
                    autoDetection: O,
                    inherit: ee,
                    addPlugin: function (e) {
                        ! function (e) {
                            e["before:highlightBlock"] && !e["before:highlightElement"] && (e["before:highlightElement"] = t => {
                                e["before:highlightBlock"](Object.assign({
                                    block: t.el
                                }, t))
                            }), e["after:highlightBlock"] && !e["after:highlightElement"] && (e["after:highlightElement"] = t => {
                                e["after:highlightBlock"](Object.assign({
                                    block: t.el
                                }, t))
                            })
                        }(e), o.push(e)
                    },
                    vuePlugin: W(e).VuePlugin
                }), e.debugMode = function () {
                    a = !1
                }, e.safeMode = function () {
                    a = !0
                }, e.versionString = "10.7.2";
                for (const e in N) "object" == typeof N[e] && n(N[e]);
                return Object.assign(e, N), e.addPlugin(m), e.addPlugin(Y), e.addPlugin(b), e
            }({});
            e.exports = ne
        },
        344: e => {
            const t = "[A-Za-z$_][0-9A-Za-z$_]*",
                n = ["as", "in", "of", "if", "for", "while", "finally", "var", "new", "function", "do", "return", "void", "else", "break", "catch", "instanceof", "with", "throw", "case", "default", "try", "switch", "continue", "typeof", "delete", "let", "yield", "const", "class", "debugger", "async", "await", "static", "import", "from", "export", "extends"],
                i = ["true", "false", "null", "undefined", "NaN", "Infinity"],
                r = [].concat(["setInterval", "setTimeout", "clearInterval", "clearTimeout", "require", "exports", "eval", "isFinite", "isNaN", "parseFloat", "parseInt", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "unescape"], ["arguments", "this", "super", "console", "window", "document", "localStorage", "module", "global"], ["Intl", "DataView", "Number", "Math", "Date", "String", "RegExp", "Object", "Function", "Boolean", "Error", "Symbol", "Set", "Map", "WeakSet", "WeakMap", "Proxy", "Reflect", "JSON", "Promise", "Float64Array", "Int16Array", "Int32Array", "Int8Array", "Uint16Array", "Uint32Array", "Float32Array", "Array", "Uint8Array", "Uint8ClampedArray", "ArrayBuffer", "BigInt64Array", "BigUint64Array", "BigInt"], ["EvalError", "InternalError", "RangeError", "ReferenceError", "SyntaxError", "TypeError", "URIError"]);

            function o(e) {
                return a("(?=", e, ")")
            }

            function a(...e) {
                return e.map((e => {
                    return (t = e) ? "string" == typeof t ? t : t.source : null;
                    var t
                })).join("")
            }
            e.exports = function (e) {
                const s = t,
                    l = "<>",
                    c = "</>",
                    u = {
                        begin: /<[A-Za-z0-9\\._:-]+/,
                        end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
                        isTrulyOpeningTag: (e, t) => {
                            const n = e[0].length + e.index,
                                i = e.input[n];
                            "<" !== i ? ">" === i && (((e, {
                                after: t
                            }) => {
                                const n = "</" + e[0].slice(1);
                                return -1 !== e.input.indexOf(n, t)
                            })(e, {
                                after: n
                            }) || t.ignoreMatch()) : t.ignoreMatch()
                        }
                    },
                    d = {
                        $pattern: t,
                        keyword: n,
                        literal: i,
                        built_in: r
                    },
                    h = "\\.([0-9](_?[0-9])*)",
                    f = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*",
                    p = {
                        className: "number",
                        variants: [{
                            begin: `(\\b(${f})((${h})|\\.)?|(${h}))[eE][+-]?([0-9](_?[0-9])*)\\b`
                        }, {
                            begin: `\\b(${f})\\b((${h})\\b|\\.)?|(${h})\\b`
                        }, {
                            begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
                        }, {
                            begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
                        }, {
                            begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
                        }, {
                            begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
                        }, {
                            begin: "\\b0[0-7]+n?\\b"
                        }],
                        relevance: 0
                    },
                    g = {
                        className: "subst",
                        begin: "\\$\\{",
                        end: "\\}",
                        keywords: d,
                        contains: []
                    },
                    m = {
                        begin: "html`",
                        end: "",
                        starts: {
                            end: "`",
                            returnEnd: !1,
                            contains: [e.BACKSLASH_ESCAPE, g],
                            subLanguage: "xml"
                        }
                    },
                    v = {
                        begin: "css`",
                        end: "",
                        starts: {
                            end: "`",
                            returnEnd: !1,
                            contains: [e.BACKSLASH_ESCAPE, g],
                            subLanguage: "css"
                        }
                    },
                    b = {
                        className: "string",
                        begin: "`",
                        end: "`",
                        contains: [e.BACKSLASH_ESCAPE, g]
                    },
                    y = {
                        className: "comment",
                        variants: [e.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                            relevance: 0,
                            contains: [{
                                className: "doctag",
                                begin: "@[A-Za-z]+",
                                contains: [{
                                    className: "type",
                                    begin: "\\{",
                                    end: "\\}",
                                    relevance: 0
                                }, {
                                    className: "variable",
                                    begin: s + "(?=\\s*(-)|$)",
                                    endsParent: !0,
                                    relevance: 0
                                }, {
                                    begin: /(?=[^\n])\s/,
                                    relevance: 0
                                }]
                            }]
                        }), e.C_BLOCK_COMMENT_MODE, e.C_LINE_COMMENT_MODE]
                    },
                    _ = [e.APOS_STRING_MODE, e.QUOTE_STRING_MODE, m, v, b, p, e.REGEXP_MODE];
                g.contains = _.concat({
                    begin: /\{/,
                    end: /\}/,
                    keywords: d,
                    contains: ["self"].concat(_)
                });
                const x = [].concat(y, g.contains),
                    w = x.concat([{
                        begin: /\(/,
                        end: /\)/,
                        keywords: d,
                        contains: ["self"].concat(x)
                    }]),
                    E = {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        excludeBegin: !0,
                        excludeEnd: !0,
                        keywords: d,
                        contains: w
                    };
                return {
                    name: "Javascript",
                    aliases: ["js", "jsx", "mjs", "cjs"],
                    keywords: d,
                    exports: {
                        PARAMS_CONTAINS: w
                    },
                    illegal: /#(?![$_A-z])/,
                    contains: [e.SHEBANG({
                        label: "shebang",
                        binary: "node",
                        relevance: 5
                    }), {
                        label: "use_strict",
                        className: "meta",
                        relevance: 10,
                        begin: /^\s*['"]use (strict|asm)['"]/
                    }, e.APOS_STRING_MODE, e.QUOTE_STRING_MODE, m, v, b, y, p, {
                        begin: a(/[{,\n]\s*/, o(a(/(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/, s + "\\s*:"))),
                        relevance: 0,
                        contains: [{
                            className: "attr",
                            begin: s + o("\\s*:"),
                            relevance: 0
                        }]
                    }, {
                        begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                        keywords: "return throw case",
                        contains: [y, e.REGEXP_MODE, {
                            className: "function",
                            begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>",
                            returnBegin: !0,
                            end: "\\s*=>",
                            contains: [{
                                className: "params",
                                variants: [{
                                    begin: e.UNDERSCORE_IDENT_RE,
                                    relevance: 0
                                }, {
                                    className: null,
                                    begin: /\(\s*\)/,
                                    skip: !0
                                }, {
                                    begin: /\(/,
                                    end: /\)/,
                                    excludeBegin: !0,
                                    excludeEnd: !0,
                                    keywords: d,
                                    contains: w
                                }]
                            }]
                        }, {
                            begin: /,/,
                            relevance: 0
                        }, {
                            className: "",
                            begin: /\s/,
                            end: /\s*/,
                            skip: !0
                        }, {
                            variants: [{
                                begin: l,
                                end: c
                            }, {
                                begin: u.begin,
                                "on:begin": u.isTrulyOpeningTag,
                                end: u.end
                            }],
                            subLanguage: "xml",
                            contains: [{
                                begin: u.begin,
                                end: u.end,
                                skip: !0,
                                contains: ["self"]
                            }]
                        }],
                        relevance: 0
                    }, {
                        className: "function",
                        beginKeywords: "function",
                        end: /[{;]/,
                        excludeEnd: !0,
                        keywords: d,
                        contains: ["self", e.inherit(e.TITLE_MODE, {
                            begin: s
                        }), E],
                        illegal: /%/
                    }, {
                        beginKeywords: "while if switch catch for"
                    }, {
                        className: "function",
                        begin: e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                        returnBegin: !0,
                        contains: [E, e.inherit(e.TITLE_MODE, {
                            begin: s
                        })]
                    }, {
                        variants: [{
                            begin: "\\." + s
                        }, {
                            begin: "\\$" + s
                        }],
                        relevance: 0
                    }, {
                        className: "class",
                        beginKeywords: "class",
                        end: /[{;=]/,
                        excludeEnd: !0,
                        illegal: /[:"[\]]/,
                        contains: [{
                            beginKeywords: "extends"
                        }, e.UNDERSCORE_TITLE_MODE]
                    }, {
                        begin: /\b(?=constructor)/,
                        end: /[{;]/,
                        excludeEnd: !0,
                        contains: [e.inherit(e.TITLE_MODE, {
                            begin: s
                        }), "self", E]
                    }, {
                        begin: "(get|set)\\s+(?=" + s + "\\()",
                        end: /\{/,
                        keywords: "get set",
                        contains: [e.inherit(e.TITLE_MODE, {
                            begin: s
                        }), {
                            begin: /\(\)/
                        }, E]
                    }, {
                        begin: /\$[(.]/
                    }]
                }
            }
        },
        157: e => {
            function t(e) {
                return e ? "string" == typeof e ? e : e.source : null
            }

            function n(e) {
                return i("(?=", e, ")")
            }

            function i(...e) {
                return e.map((e => t(e))).join("")
            }

            function r(...e) {
                return "(" + e.map((e => t(e))).join("|") + ")"
            }
            e.exports = function (e) {
                const t = i(/[A-Z_]/, i("(", /[A-Z0-9_.-]*:/, ")?"), /[A-Z0-9_.-]*/),
                    o = {
                        className: "symbol",
                        begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
                    },
                    a = {
                        begin: /\s/,
                        contains: [{
                            className: "meta-keyword",
                            begin: /#?[a-z_][a-z1-9_-]+/,
                            illegal: /\n/
                        }]
                    },
                    s = e.inherit(a, {
                        begin: /\(/,
                        end: /\)/
                    }),
                    l = e.inherit(e.APOS_STRING_MODE, {
                        className: "meta-string"
                    }),
                    c = e.inherit(e.QUOTE_STRING_MODE, {
                        className: "meta-string"
                    }),
                    u = {
                        endsWithParent: !0,
                        illegal: /</,
                        relevance: 0,
                        contains: [{
                            className: "attr",
                            begin: /[A-Za-z0-9._:-]+/,
                            relevance: 0
                        }, {
                            begin: /=\s*/,
                            relevance: 0,
                            contains: [{
                                className: "string",
                                endsParent: !0,
                                variants: [{
                                    begin: /"/,
                                    end: /"/,
                                    contains: [o]
                                }, {
                                    begin: /'/,
                                    end: /'/,
                                    contains: [o]
                                }, {
                                    begin: /[^\s"'=<>`]+/
                                }]
                            }]
                        }]
                    };
                return {
                    name: "HTML, XML",
                    aliases: ["html", "xhtml", "rss", "atom", "xjb", "xsd", "xsl", "plist", "wsf", "svg"],
                    case_insensitive: !0,
                    contains: [{
                        className: "meta",
                        begin: /<![a-z]/,
                        end: />/,
                        relevance: 10,
                        contains: [a, c, l, s, {
                            begin: /\[/,
                            end: /\]/,
                            contains: [{
                                className: "meta",
                                begin: /<![a-z]/,
                                end: />/,
                                contains: [a, s, c, l]
                            }]
                        }]
                    }, e.COMMENT(/<!--/, /-->/, {
                        relevance: 10
                    }), {
                        begin: /<!\[CDATA\[/,
                        end: /\]\]>/,
                        relevance: 10
                    }, o, {
                        className: "meta",
                        begin: /<\?xml/,
                        end: /\?>/,
                        relevance: 10
                    }, {
                        className: "tag",
                        begin: /<style(?=\s|>)/,
                        end: />/,
                        keywords: {
                            name: "style"
                        },
                        contains: [u],
                        starts: {
                            end: /<\/style>/,
                            returnEnd: !0,
                            subLanguage: ["css", "xml"]
                        }
                    }, {
                        className: "tag",
                        begin: /<script(?=\s|>)/,
                        end: />/,
                        keywords: {
                            name: "script"
                        },
                        contains: [u],
                        starts: {
                            end: /<\/script>/,
                            returnEnd: !0,
                            subLanguage: ["javascript", "handlebars", "xml"]
                        }
                    }, {
                        className: "tag",
                        begin: /<>|<\/>/
                    }, {
                        className: "tag",
                        begin: i(/</, n(i(t, r(/\/>/, />/, /\s/)))),
                        end: /\/?>/,
                        contains: [{
                            className: "name",
                            begin: t,
                            relevance: 0,
                            starts: u
                        }]
                    }, {
                        className: "tag",
                        begin: i(/<\//, n(i(t, />/))),
                        contains: [{
                            className: "name",
                            begin: t,
                            relevance: 0
                        }, {
                            begin: />/,
                            relevance: 0,
                            endsParent: !0
                        }]
                    }]
                }
            }
        },
        382: function (e) {
            e.exports = function () {
                "use strict";
                var e = {
                        4528: function (e) {
                            e.exports = JSON.parse('{"BACKSPACE":8,"BACKSPACE_SAFARI":127,"DELETE":46,"DOWN":40,"END":35,"ENTER":13,"ESCAPE":27,"HOME":36,"INSERT":45,"LEFT":37,"PAGE_DOWN":34,"PAGE_UP":33,"RIGHT":39,"SPACE":32,"TAB":9,"UP":38,"X":88,"Z":90,"CONTROL":17,"PAUSE/BREAK":19,"WINDOWS_LEFT":91,"WINDOWS_RIGHT":92,"KEY_229":229}')
                        },
                        8741: function (e, t) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0;
                            var n = !("undefined" == typeof window || !window.document || !window.document.createElement);
                            t.default = n
                        },
                        3976: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0;
                            var i, r = (i = n(4528)) && i.__esModule ? i : {
                                    default: i
                                },
                                o = {
                                    _maxTestPos: 500,
                                    placeholder: "_",
                                    optionalmarker: ["[", "]"],
                                    quantifiermarker: ["{", "}"],
                                    groupmarker: ["(", ")"],
                                    alternatormarker: "|",
                                    escapeChar: "\\",
                                    mask: null,
                                    regex: null,
                                    oncomplete: function () {},
                                    onincomplete: function () {},
                                    oncleared: function () {},
                                    repeat: 0,
                                    greedy: !1,
                                    autoUnmask: !1,
                                    removeMaskOnSubmit: !1,
                                    clearMaskOnLostFocus: !0,
                                    insertMode: !0,
                                    insertModeVisual: !0,
                                    clearIncomplete: !1,
                                    alias: null,
                                    onKeyDown: function () {},
                                    onBeforeMask: null,
                                    onBeforePaste: function (e, t) {
                                        return "function" == typeof t.onBeforeMask ? t.onBeforeMask.call(this, e, t) : e
                                    },
                                    onBeforeWrite: null,
                                    onUnMask: null,
                                    showMaskOnFocus: !0,
                                    showMaskOnHover: !0,
                                    onKeyValidation: function () {},
                                    skipOptionalPartCharacter: " ",
                                    numericInput: !1,
                                    rightAlign: !1,
                                    undoOnEscape: !0,
                                    radixPoint: "",
                                    _radixDance: !1,
                                    groupSeparator: "",
                                    keepStatic: null,
                                    positionCaretOnTab: !0,
                                    tabThrough: !1,
                                    supportsInputType: ["text", "tel", "url", "password", "search"],
                                    ignorables: [r.default.BACKSPACE, r.default.TAB, r.default["PAUSE/BREAK"], r.default.ESCAPE, r.default.PAGE_UP, r.default.PAGE_DOWN, r.default.END, r.default.HOME, r.default.LEFT, r.default.UP, r.default.RIGHT, r.default.DOWN, r.default.INSERT, r.default.DELETE, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 0, 229],
                                    isComplete: null,
                                    preValidation: null,
                                    postValidation: null,
                                    staticDefinitionSymbol: void 0,
                                    jitMasking: !1,
                                    nullable: !0,
                                    inputEventOnly: !1,
                                    noValuePatching: !1,
                                    positionCaretOnClick: "lvp",
                                    casing: null,
                                    inputmode: "text",
                                    importDataAttributes: !0,
                                    shiftPositions: !0,
                                    usePrototypeDefinitions: !0,
                                    validationEventTimeOut: 3e3
                                };
                            t.default = o
                        },
                        7392: function (e, t) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0, t.default = {
                                9: {
                                    validator: "[0-9０-９]",
                                    definitionSymbol: "*"
                                },
                                a: {
                                    validator: "[A-Za-zА-яЁёÀ-ÿµ]",
                                    definitionSymbol: "*"
                                },
                                "*": {
                                    validator: "[0-9０-９A-Za-zА-яЁёÀ-ÿµ]"
                                }
                            }
                        },
                        253: function (e, t) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = function (e, t, n) {
                                if (void 0 === n) return e.__data ? e.__data[t] : null;
                                e.__data = e.__data || {}, e.__data[t] = n
                            }
                        },
                        3776: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.on = function (e, t) {
                                function n(e, n) {
                                    r.addEventListener ? r.addEventListener(e, t, !1) : r.attachEvent && r.attachEvent("on" + e, t), i[e] = i[e] || {}, i[e][n] = i[e][n] || [], i[e][n].push(t)
                                }
                                if (c(this[0]))
                                    for (var i = this[0].eventRegistry, r = this[0], o = e.split(" "), a = 0; a < o.length; a++) {
                                        var s = o[a].split(".");
                                        n(s[0], s[1] || "global")
                                    }
                                return this
                            }, t.off = function (e, t) {
                                var n, i;

                                function r(e, t, r) {
                                    if (e in n == 1)
                                        if (i.removeEventListener ? i.removeEventListener(e, r, !1) : i.detachEvent && i.detachEvent("on" + e, r), "global" === t)
                                            for (var o in n[e]) n[e][o].splice(n[e][o].indexOf(r), 1);
                                        else n[e][t].splice(n[e][t].indexOf(r), 1)
                                }

                                function o(e, i) {
                                    var r, o, a = [];
                                    if (e.length > 0)
                                        if (void 0 === t)
                                            for (r = 0, o = n[e][i].length; r < o; r++) a.push({
                                                ev: e,
                                                namespace: i && i.length > 0 ? i : "global",
                                                handler: n[e][i][r]
                                            });
                                        else a.push({
                                            ev: e,
                                            namespace: i && i.length > 0 ? i : "global",
                                            handler: t
                                        });
                                    else if (i.length > 0)
                                        for (var s in n)
                                            for (var l in n[s])
                                                if (l === i)
                                                    if (void 0 === t)
                                                        for (r = 0, o = n[s][l].length; r < o; r++) a.push({
                                                            ev: s,
                                                            namespace: l,
                                                            handler: n[s][l][r]
                                                        });
                                                    else a.push({
                                                        ev: s,
                                                        namespace: l,
                                                        handler: t
                                                    });
                                    return a
                                }
                                if (c(this[0]) && e) {
                                    n = this[0].eventRegistry, i = this[0];
                                    for (var a = e.split(" "), s = 0; s < a.length; s++)
                                        for (var l = a[s].split("."), u = o(l[0], l[1]), d = 0, h = u.length; d < h; d++) r(u[d].ev, u[d].namespace, u[d].handler)
                                }
                                return this
                            }, t.trigger = function (e) {
                                if (c(this[0]))
                                    for (var t = this[0].eventRegistry, n = this[0], i = "string" == typeof e ? e.split(" ") : [e.type], o = 0; o < i.length; o++) {
                                        var s = i[o].split("."),
                                            l = s[0],
                                            u = s[1] || "global";
                                        if (void 0 !== document && "global" === u) {
                                            var d, h, f = {
                                                bubbles: !0,
                                                cancelable: !0,
                                                detail: arguments[1]
                                            };
                                            if (document.createEvent) {
                                                try {
                                                    "input" === l ? (f.inputType = "insertText", d = new InputEvent(l, f)) : d = new CustomEvent(l, f)
                                                } catch (e) {
                                                    (d = document.createEvent("CustomEvent")).initCustomEvent(l, f.bubbles, f.cancelable, f.detail)
                                                }
                                                e.type && (0, r.default)(d, e), n.dispatchEvent(d)
                                            } else(d = document.createEventObject()).eventType = l, d.detail = arguments[1], e.type && (0, r.default)(d, e), n.fireEvent("on" + d.eventType, d)
                                        } else if (void 0 !== t[l])
                                            if (arguments[0] = arguments[0].type ? arguments[0] : a.default.Event(arguments[0]), arguments[0].detail = arguments.slice(1), "global" === u)
                                                for (var p in t[l])
                                                    for (h = 0; h < t[l][p].length; h++) t[l][p][h].apply(n, arguments);
                                            else
                                                for (h = 0; h < t[l][u].length; h++) t[l][u][h].apply(n, arguments)
                                    }
                                return this
                            }, t.Event = void 0;
                            var i, r = l(n(600)),
                                o = l(n(9380)),
                                a = l(n(4963)),
                                s = l(n(8741));

                            function l(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }

                            function c(e) {
                                return e instanceof Element
                            }
                            t.Event = i, "function" == typeof o.default.CustomEvent ? t.Event = i = o.default.CustomEvent : s.default && (t.Event = i = function (e, t) {
                                t = t || {
                                    bubbles: !1,
                                    cancelable: !1,
                                    detail: void 0
                                };
                                var n = document.createEvent("CustomEvent");
                                return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n
                            }, i.prototype = o.default.Event.prototype)
                        },
                        600: function (e, t) {
                            function n(e) {
                                return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                    return typeof e
                                } : function (e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                                })(e)
                            }
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = function e() {
                                var t, i, r, o, a, s, l = arguments[0] || {},
                                    c = 1,
                                    u = arguments.length,
                                    d = !1;
                                for ("boolean" == typeof l && (d = l, l = arguments[c] || {}, c++), "object" !== n(l) && "function" != typeof l && (l = {}); c < u; c++)
                                    if (null != (t = arguments[c]))
                                        for (i in t) r = l[i], l !== (o = t[i]) && (d && o && ("[object Object]" === Object.prototype.toString.call(o) || (a = Array.isArray(o))) ? (a ? (a = !1, s = r && Array.isArray(r) ? r : []) : s = r && "[object Object]" === Object.prototype.toString.call(r) ? r : {}, l[i] = e(d, s, o)) : void 0 !== o && (l[i] = o));
                                return l
                            }
                        },
                        4963: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0;
                            var i = s(n(600)),
                                r = s(n(9380)),
                                o = s(n(253)),
                                a = n(3776);

                            function s(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var l = r.default.document;

                            function c(e) {
                                return e instanceof c ? e : this instanceof c ? void(null != e && e !== r.default && (this[0] = e.nodeName ? e : void 0 !== e[0] && e[0].nodeName ? e[0] : l.querySelector(e), void 0 !== this[0] && null !== this[0] && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new c(e)
                            }
                            c.prototype = {
                                on: a.on,
                                off: a.off,
                                trigger: a.trigger
                            }, c.extend = i.default, c.data = o.default, c.Event = a.Event;
                            var u = c;
                            t.default = u
                        },
                        9845: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.iphone = t.iemobile = t.mobile = t.ie = t.ua = void 0;
                            var i, r = (i = n(9380)) && i.__esModule ? i : {
                                    default: i
                                },
                                o = r.default.navigator && r.default.navigator.userAgent || "",
                                a = o.indexOf("MSIE ") > 0 || o.indexOf("Trident/") > 0,
                                s = "ontouchstart" in r.default,
                                l = /iemobile/i.test(o),
                                c = /iphone/i.test(o) && !l;
                            t.iphone = c, t.iemobile = l, t.mobile = s, t.ie = a, t.ua = o
                        },
                        7184: function (e, t) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = function (e) {
                                return e.replace(n, "\\$1")
                            };
                            var n = new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^"].join("|\\") + ")", "gim")
                        },
                        6030: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.EventHandlers = void 0;
                            var i, r = n(8711),
                                o = (i = n(4528)) && i.__esModule ? i : {
                                    default: i
                                },
                                a = n(9845),
                                s = n(7215),
                                l = n(7760),
                                c = n(4713),
                                u = {
                                    keydownEvent: function (e) {
                                        var t = this.inputmask,
                                            n = t.opts,
                                            i = t.dependencyLib,
                                            u = t.maskset,
                                            d = this,
                                            h = i(d),
                                            f = e.keyCode,
                                            p = r.caret.call(t, d),
                                            g = n.onKeyDown.call(this, e, r.getBuffer.call(t), p, n);
                                        if (void 0 !== g) return g;
                                        if (f === o.default.BACKSPACE || f === o.default.DELETE || a.iphone && f === o.default.BACKSPACE_SAFARI || e.ctrlKey && f === o.default.X && !("oncut" in d)) e.preventDefault(), s.handleRemove.call(t, d, f, p), (0, l.writeBuffer)(d, r.getBuffer.call(t, !0), u.p, e, d.inputmask._valueGet() !== r.getBuffer.call(t).join(""));
                                        else if (f === o.default.END || f === o.default.PAGE_DOWN) {
                                            e.preventDefault();
                                            var m = r.seekNext.call(t, r.getLastValidPosition.call(t));
                                            r.caret.call(t, d, e.shiftKey ? p.begin : m, m, !0)
                                        } else f === o.default.HOME && !e.shiftKey || f === o.default.PAGE_UP ? (e.preventDefault(), r.caret.call(t, d, 0, e.shiftKey ? p.begin : 0, !0)) : n.undoOnEscape && f === o.default.ESCAPE && !0 !== e.altKey ? ((0, l.checkVal)(d, !0, !1, t.undoValue.split("")), h.trigger("click")) : !0 === n.tabThrough && f === o.default.TAB ? !0 === e.shiftKey ? (p.end = r.seekPrevious.call(t, p.end, !0), !0 === c.getTest.call(t, p.end - 1).match.static && p.end--, p.begin = r.seekPrevious.call(t, p.end, !0), p.begin >= 0 && p.end > 0 && (e.preventDefault(), r.caret.call(t, d, p.begin, p.end))) : (p.begin = r.seekNext.call(t, p.begin, !0), p.end = r.seekNext.call(t, p.begin, !0), p.end < u.maskLength && p.end--, p.begin <= u.maskLength && (e.preventDefault(), r.caret.call(t, d, p.begin, p.end))) : e.shiftKey || n.insertModeVisual && !1 === n.insertMode && (f === o.default.RIGHT ? setTimeout((function () {
                                            var e = r.caret.call(t, d);
                                            r.caret.call(t, d, e.begin)
                                        }), 0) : f === o.default.LEFT && setTimeout((function () {
                                            var e = r.translatePosition.call(t, d.inputmask.caretPos.begin);
                                            r.translatePosition.call(t, d.inputmask.caretPos.end), t.isRTL ? r.caret.call(t, d, e + (e === u.maskLength ? 0 : 1)) : r.caret.call(t, d, e - (0 === e ? 0 : 1))
                                        }), 0));
                                        t.ignorable = n.ignorables.includes(f)
                                    },
                                    keypressEvent: function (e, t, n, i, a) {
                                        var c = this.inputmask || this,
                                            u = c.opts,
                                            d = c.dependencyLib,
                                            h = c.maskset,
                                            f = c.el,
                                            p = d(f),
                                            g = e.which || e.charCode || e.keyCode;
                                        if (!(!0 === t || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || c.ignorable)) return g === o.default.ENTER && c.undoValue !== c._valueGet(!0) && (c.undoValue = c._valueGet(!0), setTimeout((function () {
                                            p.trigger("change")
                                        }), 0)), c.skipInputEvent = !0, !0;
                                        if (g) {
                                            44 !== g && 46 !== g || 3 !== e.location || "" === u.radixPoint || (g = u.radixPoint.charCodeAt(0));
                                            var m, v = t ? {
                                                    begin: a,
                                                    end: a
                                                } : r.caret.call(c, f),
                                                b = String.fromCharCode(g);
                                            h.writeOutBuffer = !0;
                                            var y = s.isValid.call(c, v, b, i, void 0, void 0, void 0, t);
                                            if (!1 !== y && (r.resetMaskSet.call(c, !0), m = void 0 !== y.caret ? y.caret : r.seekNext.call(c, y.pos.begin ? y.pos.begin : y.pos), h.p = m), m = u.numericInput && void 0 === y.caret ? r.seekPrevious.call(c, m) : m, !1 !== n && (setTimeout((function () {
                                                    u.onKeyValidation.call(f, g, y)
                                                }), 0), h.writeOutBuffer && !1 !== y)) {
                                                var _ = r.getBuffer.call(c);
                                                (0, l.writeBuffer)(f, _, m, e, !0 !== t)
                                            }
                                            if (e.preventDefault(), t) return !1 !== y && (y.forwardPosition = m), y
                                        }
                                    },
                                    keyupEvent: function (e) {
                                        var t = this.inputmask;
                                        !t.isComposing || e.keyCode !== o.default.KEY_229 && e.keyCode !== o.default.ENTER || t.$el.trigger("input")
                                    },
                                    pasteEvent: function (e) {
                                        var t, n = this.inputmask,
                                            i = n.opts,
                                            o = n._valueGet(!0),
                                            a = r.caret.call(n, this);
                                        n.isRTL && (t = a.end, a.end = a.begin, a.begin = t);
                                        var s = o.substr(0, a.begin),
                                            c = o.substr(a.end, o.length);
                                        if (s == (n.isRTL ? r.getBufferTemplate.call(n).slice().reverse() : r.getBufferTemplate.call(n)).slice(0, a.begin).join("") && (s = ""), c == (n.isRTL ? r.getBufferTemplate.call(n).slice().reverse() : r.getBufferTemplate.call(n)).slice(a.end).join("") && (c = ""), window.clipboardData && window.clipboardData.getData) o = s + window.clipboardData.getData("Text") + c;
                                        else {
                                            if (!e.clipboardData || !e.clipboardData.getData) return !0;
                                            o = s + e.clipboardData.getData("text/plain") + c
                                        }
                                        var u = o;
                                        if ("function" == typeof i.onBeforePaste) {
                                            if (!1 === (u = i.onBeforePaste.call(n, o, i))) return e.preventDefault();
                                            u || (u = o)
                                        }
                                        return (0, l.checkVal)(this, !0, !1, u.toString().split(""), e), e.preventDefault()
                                    },
                                    inputFallBackEvent: function (e) {
                                        var t = this.inputmask,
                                            n = t.opts,
                                            i = t.dependencyLib,
                                            s = this,
                                            d = s.inputmask._valueGet(!0),
                                            h = (t.isRTL ? r.getBuffer.call(t).slice().reverse() : r.getBuffer.call(t)).join(""),
                                            f = r.caret.call(t, s, void 0, void 0, !0);
                                        if (h !== d) {
                                            var p = function (e, i, o) {
                                                for (var a, s, l, u = e.substr(0, o.begin).split(""), d = e.substr(o.begin).split(""), h = i.substr(0, o.begin).split(""), f = i.substr(o.begin).split(""), p = u.length >= h.length ? u.length : h.length, g = d.length >= f.length ? d.length : f.length, m = "", v = [], b = "~"; u.length < p;) u.push(b);
                                                for (; h.length < p;) h.push(b);
                                                for (; d.length < g;) d.unshift(b);
                                                for (; f.length < g;) f.unshift(b);
                                                var y = u.concat(d),
                                                    _ = h.concat(f);
                                                for (s = 0, a = y.length; s < a; s++) switch (l = c.getPlaceholder.call(t, r.translatePosition.call(t, s)), m) {
                                                    case "insertText":
                                                        _[s - 1] === y[s] && o.begin == y.length - 1 && v.push(y[s]), s = a;
                                                        break;
                                                    case "insertReplacementText":
                                                    case "deleteContentBackward":
                                                        y[s] === b ? o.end++ : s = a;
                                                        break;
                                                    default:
                                                        y[s] !== _[s] && (y[s + 1] !== b && y[s + 1] !== l && void 0 !== y[s + 1] || (_[s] !== l || _[s + 1] !== b) && _[s] !== b ? _[s + 1] === b && _[s] === y[s + 1] ? (m = "insertText", v.push(y[s]), o.begin--, o.end--) : y[s] !== l && y[s] !== b && (y[s + 1] === b || _[s] !== y[s] && _[s + 1] === y[s + 1]) ? (m = "insertReplacementText", v.push(y[s]), o.begin--) : y[s] === b ? (m = "deleteContentBackward", (r.isMask.call(t, r.translatePosition.call(t, s), !0) || _[s] === n.radixPoint) && o.end++) : s = a : (m = "insertText", v.push(y[s]), o.begin--, o.end--))
                                                }
                                                return {
                                                    action: m,
                                                    data: v,
                                                    caret: o
                                                }
                                            }(d = function (e, n, i) {
                                                if (a.iemobile) {
                                                    var o = n.replace(r.getBuffer.call(t).join(""), "");
                                                    if (1 === o.length) {
                                                        var s = n.split("");
                                                        s.splice(i.begin, 0, o), n = s.join("")
                                                    }
                                                }
                                                return n
                                            }(0, d, f), h, f);
                                            switch ((s.inputmask.shadowRoot || s.ownerDocument).activeElement !== s && s.focus(), (0, l.writeBuffer)(s, r.getBuffer.call(t)), r.caret.call(t, s, f.begin, f.end, !0), p.action) {
                                                case "insertText":
                                                case "insertReplacementText":
                                                    p.data.forEach((function (e, n) {
                                                        var r = new i.Event("keypress");
                                                        r.which = e.charCodeAt(0), t.ignorable = !1, u.keypressEvent.call(s, r)
                                                    })), setTimeout((function () {
                                                        t.$el.trigger("keyup")
                                                    }), 0);
                                                    break;
                                                case "deleteContentBackward":
                                                    var g = new i.Event("keydown");
                                                    g.keyCode = o.default.BACKSPACE, u.keydownEvent.call(s, g);
                                                    break;
                                                default:
                                                    (0, l.applyInputValue)(s, d)
                                            }
                                            e.preventDefault()
                                        }
                                    },
                                    compositionendEvent: function (e) {
                                        var t = this.inputmask;
                                        t.isComposing = !1, t.$el.trigger("input")
                                    },
                                    setValueEvent: function (e) {
                                        var t = this.inputmask,
                                            n = this,
                                            i = e && e.detail ? e.detail[0] : arguments[1];
                                        void 0 === i && (i = n.inputmask._valueGet(!0)), (0, l.applyInputValue)(n, i), (e.detail && void 0 !== e.detail[1] || void 0 !== arguments[2]) && r.caret.call(t, n, e.detail ? e.detail[1] : arguments[2])
                                    },
                                    focusEvent: function (e) {
                                        var t = this.inputmask,
                                            n = t.opts,
                                            i = this,
                                            o = i.inputmask._valueGet();
                                        n.showMaskOnFocus && o !== r.getBuffer.call(t).join("") && (0, l.writeBuffer)(i, r.getBuffer.call(t), r.seekNext.call(t, r.getLastValidPosition.call(t))), !0 !== n.positionCaretOnTab || !1 !== t.mouseEnter || s.isComplete.call(t, r.getBuffer.call(t)) && -1 !== r.getLastValidPosition.call(t) || u.clickEvent.apply(i, [e, !0]), t.undoValue = t._valueGet(!0)
                                    },
                                    invalidEvent: function (e) {
                                        this.inputmask.validationEvent = !0
                                    },
                                    mouseleaveEvent: function () {
                                        var e = this.inputmask,
                                            t = e.opts,
                                            n = this;
                                        e.mouseEnter = !1, t.clearMaskOnLostFocus && (n.inputmask.shadowRoot || n.ownerDocument).activeElement !== n && (0, l.HandleNativePlaceholder)(n, e.originalPlaceholder)
                                    },
                                    clickEvent: function (e, t) {
                                        var n = this.inputmask,
                                            i = this;
                                        if ((i.inputmask.shadowRoot || i.ownerDocument).activeElement === i) {
                                            var o = r.determineNewCaretPosition.call(n, r.caret.call(n, i), t);
                                            void 0 !== o && r.caret.call(n, i, o)
                                        }
                                    },
                                    cutEvent: function (e) {
                                        var t = this.inputmask,
                                            n = t.maskset,
                                            i = this,
                                            a = r.caret.call(t, i),
                                            c = window.clipboardData || e.clipboardData,
                                            u = t.isRTL ? r.getBuffer.call(t).slice(a.end, a.begin) : r.getBuffer.call(t).slice(a.begin, a.end);
                                        c.setData("text", t.isRTL ? u.reverse().join("") : u.join("")), document.execCommand && document.execCommand("copy"), s.handleRemove.call(t, i, o.default.DELETE, a), (0, l.writeBuffer)(i, r.getBuffer.call(t), n.p, e, t.undoValue !== t._valueGet(!0))
                                    },
                                    blurEvent: function (e) {
                                        var t = this.inputmask,
                                            n = t.opts,
                                            i = (0, t.dependencyLib)(this),
                                            o = this;
                                        if (o.inputmask) {
                                            (0, l.HandleNativePlaceholder)(o, t.originalPlaceholder);
                                            var a = o.inputmask._valueGet(),
                                                c = r.getBuffer.call(t).slice();
                                            "" !== a && (n.clearMaskOnLostFocus && (-1 === r.getLastValidPosition.call(t) && a === r.getBufferTemplate.call(t).join("") ? c = [] : l.clearOptionalTail.call(t, c)), !1 === s.isComplete.call(t, c) && (setTimeout((function () {
                                                i.trigger("incomplete")
                                            }), 0), n.clearIncomplete && (r.resetMaskSet.call(t), c = n.clearMaskOnLostFocus ? [] : r.getBufferTemplate.call(t).slice())), (0, l.writeBuffer)(o, c, void 0, e)), t.undoValue !== t._valueGet(!0) && (t.undoValue = t._valueGet(!0), i.trigger("change"))
                                        }
                                    },
                                    mouseenterEvent: function () {
                                        var e = this.inputmask,
                                            t = e.opts,
                                            n = this;
                                        if (e.mouseEnter = !0, (n.inputmask.shadowRoot || n.ownerDocument).activeElement !== n) {
                                            var i = (e.isRTL ? r.getBufferTemplate.call(e).slice().reverse() : r.getBufferTemplate.call(e)).join("");
                                            e.placeholder !== i && n.placeholder !== e.originalPlaceholder && (e.originalPlaceholder = n.placeholder), t.showMaskOnHover && (0, l.HandleNativePlaceholder)(n, i)
                                        }
                                    },
                                    submitEvent: function () {
                                        var e = this.inputmask,
                                            t = e.opts;
                                        e.undoValue !== e._valueGet(!0) && e.$el.trigger("change"), t.clearMaskOnLostFocus && -1 === r.getLastValidPosition.call(e) && e._valueGet && e._valueGet() === r.getBufferTemplate.call(e).join("") && e._valueSet(""), t.clearIncomplete && !1 === s.isComplete.call(e, r.getBuffer.call(e)) && e._valueSet(""), t.removeMaskOnSubmit && (e._valueSet(e.unmaskedvalue(), !0), setTimeout((function () {
                                            (0, l.writeBuffer)(e.el, r.getBuffer.call(e))
                                        }), 0))
                                    },
                                    resetEvent: function () {
                                        var e = this.inputmask;
                                        e.refreshValue = !0, setTimeout((function () {
                                            (0, l.applyInputValue)(e.el, e._valueGet(!0))
                                        }), 0)
                                    }
                                };
                            t.EventHandlers = u
                        },
                        9716: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.EventRuler = void 0;
                            var i = s(n(2394)),
                                r = s(n(4528)),
                                o = n(8711),
                                a = n(7760);

                            function s(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var l = {
                                on: function (e, t, n) {
                                    var s = e.inputmask.dependencyLib,
                                        l = function (t) {
                                            t.originalEvent && (t = t.originalEvent || t, arguments[0] = t);
                                            var l, c = this,
                                                u = c.inputmask,
                                                d = u ? u.opts : void 0;
                                            if (void 0 === u && "FORM" !== this.nodeName) {
                                                var h = s.data(c, "_inputmask_opts");
                                                s(c).off(), h && new i.default(h).mask(c)
                                            } else {
                                                if (["submit", "reset", "setvalue"].includes(t.type) || "FORM" === this.nodeName || !(c.disabled || c.readOnly && !("keydown" === t.type && t.ctrlKey && 67 === t.keyCode || !1 === d.tabThrough && t.keyCode === r.default.TAB))) {
                                                    switch (t.type) {
                                                        case "input":
                                                            if (!0 === u.skipInputEvent || t.inputType && "insertCompositionText" === t.inputType) return u.skipInputEvent = !1, t.preventDefault();
                                                            break;
                                                        case "keydown":
                                                            u.skipKeyPressEvent = !1, u.skipInputEvent = u.isComposing = t.keyCode === r.default.KEY_229;
                                                            break;
                                                        case "keyup":
                                                        case "compositionend":
                                                            u.isComposing && (u.skipInputEvent = !1);
                                                            break;
                                                        case "keypress":
                                                            if (!0 === u.skipKeyPressEvent) return t.preventDefault();
                                                            u.skipKeyPressEvent = !0;
                                                            break;
                                                        case "click":
                                                        case "focus":
                                                            return u.validationEvent ? (u.validationEvent = !1, e.blur(), (0, a.HandleNativePlaceholder)(e, (u.isRTL ? o.getBufferTemplate.call(u).slice().reverse() : o.getBufferTemplate.call(u)).join("")), setTimeout((function () {
                                                                e.focus()
                                                            }), d.validationEventTimeOut), !1) : (l = arguments, setTimeout((function () {
                                                                e.inputmask && n.apply(c, l)
                                                            }), 0), !1)
                                                    }
                                                    var f = n.apply(c, arguments);
                                                    return !1 === f && (t.preventDefault(), t.stopPropagation()), f
                                                }
                                                t.preventDefault()
                                            }
                                        };
                                    ["submit", "reset"].includes(t) ? (l = l.bind(e), null !== e.form && s(e.form).on(t, l)) : s(e).on(t, l), e.inputmask.events[t] = e.inputmask.events[t] || [], e.inputmask.events[t].push(l)
                                },
                                off: function (e, t) {
                                    if (e.inputmask && e.inputmask.events) {
                                        var n = e.inputmask.dependencyLib,
                                            i = e.inputmask.events;
                                        for (var r in t && ((i = [])[t] = e.inputmask.events[t]), i) {
                                            for (var o = i[r]; o.length > 0;) {
                                                var a = o.pop();
                                                ["submit", "reset"].includes(r) ? null !== e.form && n(e.form).off(r, a) : n(e).off(r, a)
                                            }
                                            delete e.inputmask.events[r]
                                        }
                                    }
                                }
                            };
                            t.EventRuler = l
                        },
                        219: function (e, t, n) {
                            var i = l(n(2394)),
                                r = l(n(4528)),
                                o = l(n(7184)),
                                a = n(8711);

                            function s(e) {
                                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                    return typeof e
                                } : function (e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                                })(e)
                            }

                            function l(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var c = i.default.dependencyLib,
                                u = (new Date).getFullYear(),
                                d = {
                                    d: ["[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", Date.prototype.getDate],
                                    dd: ["0[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", function () {
                                        return y(Date.prototype.getDate.call(this), 2)
                                    }],
                                    ddd: [""],
                                    dddd: [""],
                                    m: ["[1-9]|1[012]", Date.prototype.setMonth, "month", function () {
                                        return Date.prototype.getMonth.call(this) + 1
                                    }],
                                    mm: ["0[1-9]|1[012]", Date.prototype.setMonth, "month", function () {
                                        return y(Date.prototype.getMonth.call(this) + 1, 2)
                                    }],
                                    mmm: [""],
                                    mmmm: [""],
                                    yy: ["[0-9]{2}", Date.prototype.setFullYear, "year", function () {
                                        return y(Date.prototype.getFullYear.call(this), 2)
                                    }],
                                    yyyy: ["[0-9]{4}", Date.prototype.setFullYear, "year", function () {
                                        return y(Date.prototype.getFullYear.call(this), 4)
                                    }],
                                    h: ["[1-9]|1[0-2]", Date.prototype.setHours, "hours", Date.prototype.getHours],
                                    hh: ["0[1-9]|1[0-2]", Date.prototype.setHours, "hours", function () {
                                        return y(Date.prototype.getHours.call(this), 2)
                                    }],
                                    hx: [function (e) {
                                        return "[0-9]{".concat(e, "}")
                                    }, Date.prototype.setHours, "hours", function (e) {
                                        return Date.prototype.getHours
                                    }],
                                    H: ["1?[0-9]|2[0-3]", Date.prototype.setHours, "hours", Date.prototype.getHours],
                                    HH: ["0[0-9]|1[0-9]|2[0-3]", Date.prototype.setHours, "hours", function () {
                                        return y(Date.prototype.getHours.call(this), 2)
                                    }],
                                    Hx: [function (e) {
                                        return "[0-9]{".concat(e, "}")
                                    }, Date.prototype.setHours, "hours", function (e) {
                                        return function () {
                                            return y(Date.prototype.getHours.call(this), e)
                                        }
                                    }],
                                    M: ["[1-5]?[0-9]", Date.prototype.setMinutes, "minutes", Date.prototype.getMinutes],
                                    MM: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setMinutes, "minutes", function () {
                                        return y(Date.prototype.getMinutes.call(this), 2)
                                    }],
                                    s: ["[1-5]?[0-9]", Date.prototype.setSeconds, "seconds", Date.prototype.getSeconds],
                                    ss: ["0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]", Date.prototype.setSeconds, "seconds", function () {
                                        return y(Date.prototype.getSeconds.call(this), 2)
                                    }],
                                    l: ["[0-9]{3}", Date.prototype.setMilliseconds, "milliseconds", function () {
                                        return y(Date.prototype.getMilliseconds.call(this), 3)
                                    }],
                                    L: ["[0-9]{2}", Date.prototype.setMilliseconds, "milliseconds", function () {
                                        return y(Date.prototype.getMilliseconds.call(this), 2)
                                    }],
                                    t: ["[ap]", f, "ampm", p, 1],
                                    tt: ["[ap]m", f, "ampm", p, 2],
                                    T: ["[AP]", f, "ampm", p, 1],
                                    TT: ["[AP]M", f, "ampm", p, 2],
                                    Z: [""],
                                    o: [""],
                                    S: [""]
                                },
                                h = {
                                    isoDate: "yyyy-mm-dd",
                                    isoTime: "HH:MM:ss",
                                    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
                                    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
                                };

                            function f(e) {
                                e.toLowerCase().includes("p") && this.setHours(this.getHours() + 12)
                            }

                            function p() {}

                            function g(e) {
                                var t = new RegExp("\\d+$").exec(e[0]);
                                if (t && void 0 !== t[0]) {
                                    var n = d[e[0][0] + "x"].slice("");
                                    return n[0] = n[0](t[0]), n[3] = n[3](t[0]), n
                                }
                                if (d[e[0]]) return d[e[0]]
                            }

                            function m(e) {
                                if (!e.tokenizer) {
                                    var t = [],
                                        n = [];
                                    for (var i in d)
                                        if (/\.*x$/.test(i)) {
                                            var r = i[0] + "\\d+"; - 1 === n.indexOf(r) && n.push(r)
                                        } else -1 === t.indexOf(i[0]) && t.push(i[0]);
                                    e.tokenizer = "(" + (n.length > 0 ? n.join("|") + "|" : "") + t.join("+|") + ")+?|.", e.tokenizer = new RegExp(e.tokenizer, "g")
                                }
                                return e.tokenizer
                            }

                            function v(e, t, n) {
                                if (void 0 === e.rawday || !isFinite(e.rawday) && new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day || "29" == e.day && !Number.isFinite(e.rawyear) || new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day) return t;
                                if ("29" == e.day) {
                                    var i = w(t.pos, n);
                                    if ("yyyy" === i.targetMatch[0] && t.pos - i.targetMatchIndex == 2) return t.remove = t.pos + 1, t
                                } else if ("02" == e.month && "30" == e.day && void 0 !== t.c) return e.day = "03", e.date.setDate(3), e.date.setMonth(1), t.insert = [{
                                    pos: t.pos,
                                    c: "0"
                                }, {
                                    pos: t.pos + 1,
                                    c: t.c
                                }], t.caret = a.seekNext.call(this, t.pos + 1), t;
                                return !1
                            }

                            function b(e, t, n, i) {
                                var r, a, s = "";
                                for (m(n).lastIndex = 0; r = m(n).exec(e);)
                                    if (void 0 === t)
                                        if (a = g(r)) s += "(" + a[0] + ")";
                                        else switch (r[0]) {
                                            case "[":
                                                s += "(";
                                                break;
                                            case "]":
                                                s += ")?";
                                                break;
                                            default:
                                                s += (0, o.default)(r[0])
                                        } else(a = g(r)) ? !0 !== i && a[3] ? s += a[3].call(t.date) : a[2] ? s += t["raw" + a[2]] : s += r[0] : s += r[0];
                                return s
                            }

                            function y(e, t, n) {
                                for (e = String(e), t = t || 2; e.length < t;) e = n ? e + "0" : "0" + e;
                                return e
                            }

                            function _(e, t, n) {
                                var i, r, o, a = {
                                        date: new Date(1, 0, 1)
                                    },
                                    l = e;

                                function c(e, t, n) {
                                    if (e[i] = "ampm" === i ? t : t.replace(/[^0-9]/g, "0"), e["raw" + i] = t, void 0 !== o) {
                                        var r = e[i];
                                        ("day" === i && 29 === parseInt(r) || "month" === i && 2 === parseInt(r)) && (29 !== parseInt(e.day) || 2 !== parseInt(e.month) || "" !== e.year && void 0 !== e.year || e.date.setFullYear(2012, 1, 29)), "day" === i && 0 === parseInt(r) && (r = 1), "month" === i && (r = parseInt(r)) > 0 && (r -= 1), "year" === i && r.length < 4 && (r = y(r, 4, !0)), "" === r || isNaN(r) || o.call(e.date, r), "ampm" === i && o.call(e.date, r)
                                    }
                                }
                                if ("string" == typeof l) {
                                    for (m(n).lastIndex = 0; r = m(n).exec(t);) {
                                        var u = new RegExp("\\d+$").exec(r[0]),
                                            h = u ? r[0][0] + "x" : r[0],
                                            f = void 0;
                                        if (u) {
                                            var p = m(n).lastIndex,
                                                g = w(r.index, n);
                                            m(n).lastIndex = p, f = l.slice(0, l.indexOf(g.nextMatch[0]))
                                        } else f = l.slice(0, h.length);
                                        Object.prototype.hasOwnProperty.call(d, h) && (i = d[h][2], o = d[h][1], c(a, f)), l = l.slice(f.length)
                                    }
                                    return a
                                }
                                if (l && "object" === s(l) && Object.prototype.hasOwnProperty.call(l, "date")) return l
                            }

                            function x(e, t) {
                                return b(t.inputFormat, {
                                    date: e
                                }, t)
                            }

                            function w(e, t) {
                                var n, i, r = 0,
                                    o = 0;
                                for (m(t).lastIndex = 0; i = m(t).exec(t.inputFormat);) {
                                    var a = new RegExp("\\d+$").exec(i[0]);
                                    if ((r += o = a ? parseInt(a[0]) : i[0].length) >= e) {
                                        n = i, i = m(t).exec(t.inputFormat);
                                        break
                                    }
                                }
                                return {
                                    targetMatchIndex: r - o,
                                    nextMatch: i,
                                    targetMatch: n
                                }
                            }
                            i.default.extendAliases({
                                datetime: {
                                    mask: function (e) {
                                        return e.numericInput = !1, d.S = e.i18n.ordinalSuffix.join("|"), e.inputFormat = h[e.inputFormat] || e.inputFormat, e.displayFormat = h[e.displayFormat] || e.displayFormat || e.inputFormat, e.outputFormat = h[e.outputFormat] || e.outputFormat || e.inputFormat, e.placeholder = "" !== e.placeholder ? e.placeholder : e.inputFormat.replace(/[[\]]/, ""), e.regex = b(e.inputFormat, void 0, e), e.min = _(e.min, e.inputFormat, e), e.max = _(e.max, e.inputFormat, e), null
                                    },
                                    placeholder: "",
                                    inputFormat: "isoDateTime",
                                    displayFormat: void 0,
                                    outputFormat: void 0,
                                    min: null,
                                    max: null,
                                    skipOptionalPartCharacter: "",
                                    i18n: {
                                        dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                                        monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                                        ordinalSuffix: ["st", "nd", "rd", "th"]
                                    },
                                    preValidation: function (e, t, n, i, r, o, a, s) {
                                        if (s) return !0;
                                        if (isNaN(n) && e[t] !== n) {
                                            var l = w(t, r);
                                            if (l.nextMatch && l.nextMatch[0] === n && l.targetMatch[0].length > 1) {
                                                var c = d[l.targetMatch[0]][0];
                                                if (new RegExp(c).test("0" + e[t - 1])) return e[t] = e[t - 1], e[t - 1] = "0", {
                                                    fuzzy: !0,
                                                    buffer: e,
                                                    refreshFromBuffer: {
                                                        start: t - 1,
                                                        end: t + 1
                                                    },
                                                    pos: t + 1
                                                }
                                            }
                                        }
                                        return !0
                                    },
                                    postValidation: function (e, t, n, i, r, o, a, s) {
                                        var l, c;
                                        if (a) return !0;
                                        if (!1 === i && (((l = w(t + 1, r)).targetMatch && l.targetMatchIndex === t && l.targetMatch[0].length > 1 && void 0 !== d[l.targetMatch[0]] || (l = w(t + 2, r)).targetMatch && l.targetMatchIndex === t + 1 && l.targetMatch[0].length > 1 && void 0 !== d[l.targetMatch[0]]) && (c = d[l.targetMatch[0]][0]), void 0 !== c && (void 0 !== o.validPositions[t + 1] && new RegExp(c).test(n + "0") ? (e[t] = n, e[t + 1] = "0", i = {
                                                pos: t + 2,
                                                caret: t
                                            }) : new RegExp(c).test("0" + n) && (e[t] = "0", e[t + 1] = n, i = {
                                                pos: t + 2
                                            })), !1 === i)) return i;
                                        if (i.fuzzy && (e = i.buffer, t = i.pos), (l = w(t, r)).targetMatch && l.targetMatch[0] && void 0 !== d[l.targetMatch[0]]) {
                                            c = d[l.targetMatch[0]][0];
                                            var h = e.slice(l.targetMatchIndex, l.targetMatchIndex + l.targetMatch[0].length);
                                            !1 === new RegExp(c).test(h.join("")) && 2 === l.targetMatch[0].length && o.validPositions[l.targetMatchIndex] && o.validPositions[l.targetMatchIndex + 1] && (o.validPositions[l.targetMatchIndex + 1].input = "0")
                                        }
                                        var f = i,
                                            p = _(e.join(""), r.inputFormat, r);
                                        return f && p.date.getTime() == p.date.getTime() && (r.prefillYear && (f = function (e, t, n) {
                                            if (e.year !== e.rawyear) {
                                                var i = u.toString(),
                                                    r = e.rawyear.replace(/[^0-9]/g, ""),
                                                    o = i.slice(0, r.length),
                                                    a = i.slice(r.length);
                                                if (2 === r.length && r === o) {
                                                    var s = new Date(u, e.month - 1, e.day);
                                                    e.day == s.getDate() && (!n.max || n.max.date.getTime() >= s.getTime()) && (e.date.setFullYear(u), e.year = i, t.insert = [{
                                                        pos: t.pos + 1,
                                                        c: a[0]
                                                    }, {
                                                        pos: t.pos + 2,
                                                        c: a[1]
                                                    }])
                                                }
                                            }
                                            return t
                                        }(p, f, r)), f = function (e, t, n, i, r) {
                                            if (!t) return t;
                                            if (n.min) {
                                                if (e.rawyear) {
                                                    var o, a = e.rawyear.replace(/[^0-9]/g, ""),
                                                        s = n.min.year.substr(0, a.length);
                                                    if (a < s) {
                                                        var l = w(t.pos, n);
                                                        if (a = e.rawyear.substr(0, t.pos - l.targetMatchIndex + 1).replace(/[^0-9]/g, "0"), (s = n.min.year.substr(0, a.length)) <= a) return t.remove = l.targetMatchIndex + a.length, t;
                                                        if (a = "yyyy" === l.targetMatch[0] ? e.rawyear.substr(1, 1) : e.rawyear.substr(0, 1), s = n.min.year.substr(2, 1), o = n.max ? n.max.year.substr(2, 1) : a, 1 === a.length && s <= a && a <= o && !0 !== r) return "yyyy" === l.targetMatch[0] ? (t.insert = [{
                                                            pos: t.pos + 1,
                                                            c: a,
                                                            strict: !0
                                                        }], t.caret = t.pos + 2, i.validPositions[t.pos].input = n.min.year[1]) : (t.insert = [{
                                                            pos: t.pos + 1,
                                                            c: n.min.year[1],
                                                            strict: !0
                                                        }, {
                                                            pos: t.pos + 2,
                                                            c: a,
                                                            strict: !0
                                                        }], t.caret = t.pos + 3, i.validPositions[t.pos].input = n.min.year[0]), t;
                                                        t = !1
                                                    }
                                                }
                                                for (var c in e) - 1 === c.indexOf("raw") && e["raw".concat(c)] && (e[c], e["raw".concat(c)]);
                                                t && e.year && e.year === e.rawyear && n.min.date.getTime() == n.min.date.getTime() && (t = n.min.date.getTime() <= e.date.getTime())
                                            }
                                            return t && n.max && n.max.date.getTime() == n.max.date.getTime() && (t = n.max.date.getTime() >= e.date.getTime()), t
                                        }(p, f = v.call(this, p, f, r), r, o, s)), void 0 !== t && f && i.pos !== t ? {
                                            buffer: b(r.inputFormat, p, r).split(""),
                                            refreshFromBuffer: {
                                                start: t,
                                                end: i.pos
                                            },
                                            pos: i.caret || i.pos
                                        } : f
                                    },
                                    onKeyDown: function (e, t, n, i) {
                                        e.ctrlKey && e.keyCode === r.default.RIGHT && (this.inputmask._valueSet(x(new Date, i)), c(this).trigger("setvalue"))
                                    },
                                    onUnMask: function (e, t, n) {
                                        return t ? b(n.outputFormat, _(e, n.inputFormat, n), n, !0) : t
                                    },
                                    casing: function (e, t, n, i) {
                                        return 0 == t.nativeDef.indexOf("[ap]") ? e.toLowerCase() : 0 == t.nativeDef.indexOf("[AP]") ? e.toUpperCase() : e
                                    },
                                    onBeforeMask: function (e, t) {
                                        return "[object Date]" === Object.prototype.toString.call(e) && (e = x(e, t)), e
                                    },
                                    insertMode: !1,
                                    shiftPositions: !1,
                                    keepStatic: !1,
                                    inputmode: "numeric",
                                    prefillYear: !0
                                }
                            })
                        },
                        3851: function (e, t, n) {
                            var i, r = (i = n(2394)) && i.__esModule ? i : {
                                    default: i
                                },
                                o = n(8711),
                                a = n(4713);
                            r.default.extendDefinitions({
                                A: {
                                    validator: "[A-Za-zА-яЁёÀ-ÿµ]",
                                    casing: "upper"
                                },
                                "&": {
                                    validator: "[0-9A-Za-zА-яЁёÀ-ÿµ]",
                                    casing: "upper"
                                },
                                "#": {
                                    validator: "[0-9A-Fa-f]",
                                    casing: "upper"
                                }
                            });
                            var s = new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]");

                            function l(e, t, n, i, r) {
                                return n - 1 > -1 && "." !== t.buffer[n - 1] ? (e = t.buffer[n - 1] + e, e = n - 2 > -1 && "." !== t.buffer[n - 2] ? t.buffer[n - 2] + e : "0" + e) : e = "00" + e, s.test(e)
                            }
                            r.default.extendAliases({
                                cssunit: {
                                    regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
                                },
                                url: {
                                    regex: "(https?|ftp)://.*",
                                    autoUnmask: !1,
                                    keepStatic: !1,
                                    tabThrough: !0
                                },
                                ip: {
                                    mask: "i[i[i]].j[j[j]].k[k[k]].l[l[l]]",
                                    definitions: {
                                        i: {
                                            validator: l
                                        },
                                        j: {
                                            validator: l
                                        },
                                        k: {
                                            validator: l
                                        },
                                        l: {
                                            validator: l
                                        }
                                    },
                                    onUnMask: function (e, t, n) {
                                        return e
                                    },
                                    inputmode: "numeric"
                                },
                                email: {
                                    mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
                                    greedy: !1,
                                    casing: "lower",
                                    onBeforePaste: function (e, t) {
                                        return (e = e.toLowerCase()).replace("mailto:", "")
                                    },
                                    definitions: {
                                        "*": {
                                            validator: "[0-9１-９A-Za-zА-яЁёÀ-ÿµ!#$%&'*+/=?^_`{|}~-]"
                                        },
                                        "-": {
                                            validator: "[0-9A-Za-z-]"
                                        }
                                    },
                                    onUnMask: function (e, t, n) {
                                        return e
                                    },
                                    inputmode: "email"
                                },
                                mac: {
                                    mask: "##:##:##:##:##:##"
                                },
                                vin: {
                                    mask: "V{13}9{4}",
                                    definitions: {
                                        V: {
                                            validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
                                            casing: "upper"
                                        }
                                    },
                                    clearIncomplete: !0,
                                    autoUnmask: !0
                                },
                                ssn: {
                                    mask: "999-99-9999",
                                    postValidation: function (e, t, n, i, r, s, l) {
                                        var c = a.getMaskTemplate.call(this, !0, o.getLastValidPosition.call(this), !0, !0);
                                        return /^(?!219-09-9999|078-05-1120)(?!666|000|9.{2}).{3}-(?!00).{2}-(?!0{4}).{4}$/.test(c.join(""))
                                    }
                                }
                            })
                        },
                        207: function (e, t, n) {
                            var i = s(n(2394)),
                                r = s(n(4528)),
                                o = s(n(7184)),
                                a = n(8711);

                            function s(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var l = i.default.dependencyLib;

                            function c(e, t) {
                                for (var n = "", r = 0; r < e.length; r++) i.default.prototype.definitions[e.charAt(r)] || t.definitions[e.charAt(r)] || t.optionalmarker[0] === e.charAt(r) || t.optionalmarker[1] === e.charAt(r) || t.quantifiermarker[0] === e.charAt(r) || t.quantifiermarker[1] === e.charAt(r) || t.groupmarker[0] === e.charAt(r) || t.groupmarker[1] === e.charAt(r) || t.alternatormarker === e.charAt(r) ? n += "\\" + e.charAt(r) : n += e.charAt(r);
                                return n
                            }

                            function u(e, t, n, i) {
                                if (e.length > 0 && t > 0 && (!n.digitsOptional || i)) {
                                    var r = e.indexOf(n.radixPoint),
                                        o = !1;
                                    n.negationSymbol.back === e[e.length - 1] && (o = !0, e.length--), -1 === r && (e.push(n.radixPoint), r = e.length - 1);
                                    for (var a = 1; a <= t; a++) isFinite(e[r + a]) || (e[r + a] = "0")
                                }
                                return o && e.push(n.negationSymbol.back), e
                            }

                            function d(e, t) {
                                var n = 0;
                                if ("+" === e) {
                                    for (n in t.validPositions);
                                    n = a.seekNext.call(this, parseInt(n))
                                }
                                for (var i in t.tests)
                                    if ((i = parseInt(i)) >= n)
                                        for (var r = 0, o = t.tests[i].length; r < o; r++)
                                            if ((void 0 === t.validPositions[i] || "-" === e) && t.tests[i][r].match.def === e) return i + (void 0 !== t.validPositions[i] && "-" !== e ? 1 : 0);
                                return n
                            }

                            function h(e, t) {
                                var n = -1;
                                for (var i in t.validPositions) {
                                    var r = t.validPositions[i];
                                    if (r && r.match.def === e) {
                                        n = parseInt(i);
                                        break
                                    }
                                }
                                return n
                            }

                            function f(e, t, n, i, r) {
                                var o = t.buffer ? t.buffer.indexOf(r.radixPoint) : -1,
                                    a = (-1 !== o || i && r.jitMasking) && new RegExp(r.definitions[9].validator).test(e);
                                return r._radixDance && -1 !== o && a && null == t.validPositions[o] ? {
                                    insert: {
                                        pos: o === n ? o + 1 : o,
                                        c: r.radixPoint
                                    },
                                    pos: n
                                } : a
                            }
                            i.default.extendAliases({
                                numeric: {
                                    mask: function (e) {
                                        e.repeat = 0, e.groupSeparator === e.radixPoint && e.digits && "0" !== e.digits && ("." === e.radixPoint ? e.groupSeparator = "," : "," === e.radixPoint ? e.groupSeparator = "." : e.groupSeparator = ""), " " === e.groupSeparator && (e.skipOptionalPartCharacter = void 0), e.placeholder.length > 1 && (e.placeholder = e.placeholder.charAt(0)), "radixFocus" === e.positionCaretOnClick && "" === e.placeholder && (e.positionCaretOnClick = "lvp");
                                        var t = "0",
                                            n = e.radixPoint;
                                        !0 === e.numericInput && void 0 === e.__financeInput ? (t = "1", e.positionCaretOnClick = "radixFocus" === e.positionCaretOnClick ? "lvp" : e.positionCaretOnClick, e.digitsOptional = !1, isNaN(e.digits) && (e.digits = 2), e._radixDance = !1, n = "," === e.radixPoint ? "?" : "!", "" !== e.radixPoint && void 0 === e.definitions[n] && (e.definitions[n] = {}, e.definitions[n].validator = "[" + e.radixPoint + "]", e.definitions[n].placeholder = e.radixPoint, e.definitions[n].static = !0, e.definitions[n].generated = !0)) : (e.__financeInput = !1, e.numericInput = !0);
                                        var i, r = "[+]";
                                        if (r += c(e.prefix, e), "" !== e.groupSeparator ? (void 0 === e.definitions[e.groupSeparator] && (e.definitions[e.groupSeparator] = {}, e.definitions[e.groupSeparator].validator = "[" + e.groupSeparator + "]", e.definitions[e.groupSeparator].placeholder = e.groupSeparator, e.definitions[e.groupSeparator].static = !0, e.definitions[e.groupSeparator].generated = !0), r += e._mask(e)) : r += "9{+}", void 0 !== e.digits && 0 !== e.digits) {
                                            var a = e.digits.toString().split(",");
                                            isFinite(a[0]) && a[1] && isFinite(a[1]) ? r += n + t + "{" + e.digits + "}" : (isNaN(e.digits) || parseInt(e.digits) > 0) && (e.digitsOptional || e.jitMasking ? (i = r + n + t + "{0," + e.digits + "}", e.keepStatic = !0) : r += n + t + "{" + e.digits + "}")
                                        } else e.inputmode = "numeric";
                                        return r += c(e.suffix, e), r += "[-]", i && (r = [i + c(e.suffix, e) + "[-]", r]), e.greedy = !1,
                                            function (e) {
                                                void 0 === e.parseMinMaxOptions && (null !== e.min && (e.min = e.min.toString().replace(new RegExp((0, o.default)(e.groupSeparator), "g"), ""), "," === e.radixPoint && (e.min = e.min.replace(e.radixPoint, ".")), e.min = isFinite(e.min) ? parseFloat(e.min) : NaN, isNaN(e.min) && (e.min = Number.MIN_VALUE)), null !== e.max && (e.max = e.max.toString().replace(new RegExp((0, o.default)(e.groupSeparator), "g"), ""), "," === e.radixPoint && (e.max = e.max.replace(e.radixPoint, ".")), e.max = isFinite(e.max) ? parseFloat(e.max) : NaN, isNaN(e.max) && (e.max = Number.MAX_VALUE)), e.parseMinMaxOptions = "done")
                                            }(e), r
                                    },
                                    _mask: function (e) {
                                        return "(" + e.groupSeparator + "999){+|1}"
                                    },
                                    digits: "*",
                                    digitsOptional: !0,
                                    enforceDigitsOnBlur: !1,
                                    radixPoint: ".",
                                    positionCaretOnClick: "radixFocus",
                                    _radixDance: !0,
                                    groupSeparator: "",
                                    allowMinus: !0,
                                    negationSymbol: {
                                        front: "-",
                                        back: ""
                                    },
                                    prefix: "",
                                    suffix: "",
                                    min: null,
                                    max: null,
                                    SetMaxOnOverflow: !1,
                                    step: 1,
                                    inputType: "text",
                                    unmaskAsNumber: !1,
                                    roundingFN: Math.round,
                                    inputmode: "decimal",
                                    shortcuts: {
                                        k: "000",
                                        m: "000000"
                                    },
                                    placeholder: "0",
                                    greedy: !1,
                                    rightAlign: !0,
                                    insertMode: !0,
                                    autoUnmask: !1,
                                    skipOptionalPartCharacter: "",
                                    usePrototypeDefinitions: !1,
                                    definitions: {
                                        0: {
                                            validator: f
                                        },
                                        1: {
                                            validator: f,
                                            definitionSymbol: "9"
                                        },
                                        9: {
                                            validator: "[0-9０-９٠-٩۰-۹]",
                                            definitionSymbol: "*"
                                        },
                                        "+": {
                                            validator: function (e, t, n, i, r) {
                                                return r.allowMinus && ("-" === e || e === r.negationSymbol.front)
                                            }
                                        },
                                        "-": {
                                            validator: function (e, t, n, i, r) {
                                                return r.allowMinus && e === r.negationSymbol.back
                                            }
                                        }
                                    },
                                    preValidation: function (e, t, n, i, r, o, a, s) {
                                        var l;
                                        if (!1 !== r.__financeInput && n === r.radixPoint) return !1;
                                        if (l = r.shortcuts && r.shortcuts[n]) {
                                            if (l.length > 1)
                                                for (var c = [], u = 0; u < l.length; u++) c.push({
                                                    pos: t + u,
                                                    c: l[u],
                                                    strict: !1
                                                });
                                            return {
                                                insert: c
                                            }
                                        }
                                        var f = e.indexOf(r.radixPoint),
                                            p = t;
                                        if (t = function (e, t, n, i, r) {
                                                return r._radixDance && r.numericInput && t !== r.negationSymbol.back && e <= n && (n > 0 || t == r.radixPoint) && (void 0 === i.validPositions[e - 1] || i.validPositions[e - 1].input !== r.negationSymbol.back) && (e -= 1), e
                                            }(t, n, f, o, r), "-" === n || n === r.negationSymbol.front) {
                                            if (!0 !== r.allowMinus) return !1;
                                            var g = !1,
                                                m = h("+", o),
                                                v = h("-", o);
                                            return -1 !== m && (g = [m, v]), !1 !== g ? {
                                                remove: g,
                                                caret: p - r.negationSymbol.back.length
                                            } : {
                                                insert: [{
                                                    pos: d.call(this, "+", o),
                                                    c: r.negationSymbol.front,
                                                    fromIsValid: !0
                                                }, {
                                                    pos: d.call(this, "-", o),
                                                    c: r.negationSymbol.back,
                                                    fromIsValid: void 0
                                                }],
                                                caret: p + r.negationSymbol.back.length
                                            }
                                        }
                                        if (n === r.groupSeparator) return {
                                            caret: p
                                        };
                                        if (s) return !0;
                                        if (-1 !== f && !0 === r._radixDance && !1 === i && n === r.radixPoint && void 0 !== r.digits && (isNaN(r.digits) || parseInt(r.digits) > 0) && f !== t) return {
                                            caret: r._radixDance && t === f - 1 ? f + 1 : f
                                        };
                                        if (!1 === r.__financeInput)
                                            if (i) {
                                                if (r.digitsOptional) return {
                                                    rewritePosition: a.end
                                                };
                                                if (!r.digitsOptional) {
                                                    if (a.begin > f && a.end <= f) return n === r.radixPoint ? {
                                                        insert: {
                                                            pos: f + 1,
                                                            c: "0",
                                                            fromIsValid: !0
                                                        },
                                                        rewritePosition: f
                                                    } : {
                                                        rewritePosition: f + 1
                                                    };
                                                    if (a.begin < f) return {
                                                        rewritePosition: a.begin - 1
                                                    }
                                                }
                                            } else if (!r.showMaskOnHover && !r.showMaskOnFocus && !r.digitsOptional && r.digits > 0 && "" === this.__valueGet.call(this.el)) return {
                                            rewritePosition: f
                                        };
                                        return {
                                            rewritePosition: t
                                        }
                                    },
                                    postValidation: function (e, t, n, i, r, o, a) {
                                        if (!1 === i) return i;
                                        if (a) return !0;
                                        if (null !== r.min || null !== r.max) {
                                            var s = r.onUnMask(e.slice().reverse().join(""), void 0, l.extend({}, r, {
                                                unmaskAsNumber: !0
                                            }));
                                            if (null !== r.min && s < r.min && (s.toString().length > r.min.toString().length || s < 0)) return !1;
                                            if (null !== r.max && s > r.max) return !!r.SetMaxOnOverflow && {
                                                refreshFromBuffer: !0,
                                                buffer: u(r.max.toString().replace(".", r.radixPoint).split(""), r.digits, r).reverse()
                                            }
                                        }
                                        return i
                                    },
                                    onUnMask: function (e, t, n) {
                                        if ("" === t && !0 === n.nullable) return t;
                                        var i = e.replace(n.prefix, "");
                                        return i = (i = i.replace(n.suffix, "")).replace(new RegExp((0, o.default)(n.groupSeparator), "g"), ""), "" !== n.placeholder.charAt(0) && (i = i.replace(new RegExp(n.placeholder.charAt(0), "g"), "0")), n.unmaskAsNumber ? ("" !== n.radixPoint && -1 !== i.indexOf(n.radixPoint) && (i = i.replace(o.default.call(this, n.radixPoint), ".")), i = (i = i.replace(new RegExp("^" + (0, o.default)(n.negationSymbol.front)), "-")).replace(new RegExp((0, o.default)(n.negationSymbol.back) + "$"), ""), Number(i)) : i
                                    },
                                    isComplete: function (e, t) {
                                        var n = (t.numericInput ? e.slice().reverse() : e).join("");
                                        return n = (n = (n = (n = (n = n.replace(new RegExp("^" + (0, o.default)(t.negationSymbol.front)), "-")).replace(new RegExp((0, o.default)(t.negationSymbol.back) + "$"), "")).replace(t.prefix, "")).replace(t.suffix, "")).replace(new RegExp((0, o.default)(t.groupSeparator) + "([0-9]{3})", "g"), "$1"), "," === t.radixPoint && (n = n.replace((0, o.default)(t.radixPoint), ".")), isFinite(n)
                                    },
                                    onBeforeMask: function (e, t) {
                                        var n = t.radixPoint || ",";
                                        isFinite(t.digits) && (t.digits = parseInt(t.digits)), "number" != typeof e && "number" !== t.inputType || "" === n || (e = e.toString().replace(".", n));
                                        var i = "-" === e.charAt(0) || e.charAt(0) === t.negationSymbol.front,
                                            r = e.split(n),
                                            a = r[0].replace(/[^\-0-9]/g, ""),
                                            s = r.length > 1 ? r[1].replace(/[^0-9]/g, "") : "",
                                            l = r.length > 1;
                                        e = a + ("" !== s ? n + s : s);
                                        var c = 0;
                                        if ("" !== n && (c = t.digitsOptional ? t.digits < s.length ? t.digits : s.length : t.digits, "" !== s || !t.digitsOptional)) {
                                            var d = Math.pow(10, c || 1);
                                            e = e.replace((0, o.default)(n), "."), isNaN(parseFloat(e)) || (e = (t.roundingFN(parseFloat(e) * d) / d).toFixed(c)), e = e.toString().replace(".", n)
                                        }
                                        if (0 === t.digits && -1 !== e.indexOf(n) && (e = e.substring(0, e.indexOf(n))), null !== t.min || null !== t.max) {
                                            var h = e.toString().replace(n, ".");
                                            null !== t.min && h < t.min ? e = t.min.toString().replace(".", n) : null !== t.max && h > t.max && (e = t.max.toString().replace(".", n))
                                        }
                                        return i && "-" !== e.charAt(0) && (e = "-" + e), u(e.toString().split(""), c, t, l).join("")
                                    },
                                    onBeforeWrite: function (e, t, n, i) {
                                        function r(e, t) {
                                            if (!1 !== i.__financeInput || t) {
                                                var n = e.indexOf(i.radixPoint); - 1 !== n && e.splice(n, 1)
                                            }
                                            if ("" !== i.groupSeparator)
                                                for (; - 1 !== (n = e.indexOf(i.groupSeparator));) e.splice(n, 1);
                                            return e
                                        }
                                        var a, s = function (e, t) {
                                            var n = new RegExp("(^" + ("" !== t.negationSymbol.front ? (0, o.default)(t.negationSymbol.front) + "?" : "") + (0, o.default)(t.prefix) + ")(.*)(" + (0, o.default)(t.suffix) + ("" != t.negationSymbol.back ? (0, o.default)(t.negationSymbol.back) + "?" : "") + "$)").exec(e.slice().reverse().join("")),
                                                i = n ? n[2] : "",
                                                r = !1;
                                            return i && (i = i.split(t.radixPoint.charAt(0))[0], r = new RegExp("^[0" + t.groupSeparator + "]*").exec(i)), !(!r || !(r[0].length > 1 || r[0].length > 0 && r[0].length < i.length)) && r
                                        }(t, i);
                                        if (s)
                                            for (var c = t.join("").lastIndexOf(s[0].split("").reverse().join("")) - (s[0] == s.input ? 0 : 1), d = s[0] == s.input ? 1 : 0, h = s[0].length - d; h > 0; h--) delete this.maskset.validPositions[c + h], delete t[c + h];
                                        if (e) switch (e.type) {
                                            case "blur":
                                            case "checkval":
                                                if (null !== i.min) {
                                                    var f = i.onUnMask(t.slice().reverse().join(""), void 0, l.extend({}, i, {
                                                        unmaskAsNumber: !0
                                                    }));
                                                    if (null !== i.min && f < i.min) return {
                                                        refreshFromBuffer: !0,
                                                        buffer: u(i.min.toString().replace(".", i.radixPoint).split(""), i.digits, i).reverse()
                                                    }
                                                }
                                                if (t[t.length - 1] === i.negationSymbol.front) {
                                                    var p = new RegExp("(^" + ("" != i.negationSymbol.front ? (0, o.default)(i.negationSymbol.front) + "?" : "") + (0, o.default)(i.prefix) + ")(.*)(" + (0, o.default)(i.suffix) + ("" != i.negationSymbol.back ? (0, o.default)(i.negationSymbol.back) + "?" : "") + "$)").exec(r(t.slice(), !0).reverse().join(""));
                                                    0 == (p ? p[2] : "") && (a = {
                                                        refreshFromBuffer: !0,
                                                        buffer: [0]
                                                    })
                                                } else "" !== i.radixPoint && t[0] === i.radixPoint && (a && a.buffer ? a.buffer.shift() : (t.shift(), a = {
                                                    refreshFromBuffer: !0,
                                                    buffer: r(t)
                                                }));
                                                if (i.enforceDigitsOnBlur) {
                                                    var g = (a = a || {}) && a.buffer || t.slice().reverse();
                                                    a.refreshFromBuffer = !0, a.buffer = u(g, i.digits, i, !0).reverse()
                                                }
                                        }
                                        return a
                                    },
                                    onKeyDown: function (e, t, n, i) {
                                        var o, a = l(this);
                                        if (e.ctrlKey) switch (e.keyCode) {
                                            case r.default.UP:
                                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) + parseInt(i.step)), a.trigger("setvalue"), !1;
                                            case r.default.DOWN:
                                                return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) - parseInt(i.step)), a.trigger("setvalue"), !1
                                        }
                                        if (!e.shiftKey && (e.keyCode === r.default.DELETE || e.keyCode === r.default.BACKSPACE || e.keyCode === r.default.BACKSPACE_SAFARI) && n.begin !== t.length) {
                                            if (t[e.keyCode === r.default.DELETE ? n.begin - 1 : n.end] === i.negationSymbol.front) return o = t.slice().reverse(), "" !== i.negationSymbol.front && o.shift(), "" !== i.negationSymbol.back && o.pop(), a.trigger("setvalue", [o.join(""), n.begin]), !1;
                                            if (!0 === i._radixDance) {
                                                var s = t.indexOf(i.radixPoint);
                                                if (i.digitsOptional) {
                                                    if (0 === s) return (o = t.slice().reverse()).pop(), a.trigger("setvalue", [o.join(""), n.begin >= o.length ? o.length : n.begin]), !1
                                                } else if (-1 !== s && (n.begin < s || n.end < s || e.keyCode === r.default.DELETE && n.begin === s)) return n.begin !== n.end || e.keyCode !== r.default.BACKSPACE && e.keyCode !== r.default.BACKSPACE_SAFARI || n.begin++, (o = t.slice().reverse()).splice(o.length - n.begin, n.begin - n.end + 1), o = u(o, i.digits, i).join(""), a.trigger("setvalue", [o, n.begin >= o.length ? s + 1 : n.begin]), !1
                                            }
                                        }
                                    }
                                },
                                currency: {
                                    prefix: "",
                                    groupSeparator: ",",
                                    alias: "numeric",
                                    digits: 2,
                                    digitsOptional: !1
                                },
                                decimal: {
                                    alias: "numeric"
                                },
                                integer: {
                                    alias: "numeric",
                                    inputmode: "numeric",
                                    digits: 0
                                },
                                percentage: {
                                    alias: "numeric",
                                    min: 0,
                                    max: 100,
                                    suffix: " %",
                                    digits: 0,
                                    allowMinus: !1
                                },
                                indianns: {
                                    alias: "numeric",
                                    _mask: function (e) {
                                        return "(" + e.groupSeparator + "99){*|1}(" + e.groupSeparator + "999){1|1}"
                                    },
                                    groupSeparator: ",",
                                    radixPoint: ".",
                                    placeholder: "0",
                                    digits: 2,
                                    digitsOptional: !1
                                }
                            })
                        },
                        9380: function (e, t, n) {
                            var i;
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0;
                            var r = ((i = n(8741)) && i.__esModule ? i : {
                                default: i
                            }).default ? window : {};
                            t.default = r
                        },
                        7760: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.applyInputValue = u, t.clearOptionalTail = d, t.checkVal = h, t.HandleNativePlaceholder = function (e, t) {
                                var n = e ? e.inputmask : this;
                                if (l.ie) {
                                    if (e.inputmask._valueGet() !== t && (e.placeholder !== t || "" === e.placeholder)) {
                                        var i = a.getBuffer.call(n).slice(),
                                            r = e.inputmask._valueGet();
                                        if (r !== t) {
                                            var o = a.getLastValidPosition.call(n); - 1 === o && r === a.getBufferTemplate.call(n).join("") ? i = [] : -1 !== o && d.call(n, i), f(e, i)
                                        }
                                    }
                                } else e.placeholder !== t && (e.placeholder = t, "" === e.placeholder && e.removeAttribute("placeholder"))
                            }, t.unmaskedvalue = function (e) {
                                var t = e ? e.inputmask : this,
                                    n = t.opts,
                                    i = t.maskset;
                                if (e) {
                                    if (void 0 === e.inputmask) return e.value;
                                    e.inputmask && e.inputmask.refreshValue && u(e, e.inputmask._valueGet(!0))
                                }
                                var r = [],
                                    o = i.validPositions;
                                for (var s in o) o[s] && o[s].match && (1 != o[s].match.static || Array.isArray(i.metadata) && !0 !== o[s].generatedInput) && r.push(o[s].input);
                                var l = 0 === r.length ? "" : (t.isRTL ? r.reverse() : r).join("");
                                if ("function" == typeof n.onUnMask) {
                                    var c = (t.isRTL ? a.getBuffer.call(t).slice().reverse() : a.getBuffer.call(t)).join("");
                                    l = n.onUnMask.call(t, c, l, n)
                                }
                                return l
                            }, t.writeBuffer = f;
                            var i, r = (i = n(4528)) && i.__esModule ? i : {
                                    default: i
                                },
                                o = n(4713),
                                a = n(8711),
                                s = n(7215),
                                l = n(9845),
                                c = n(6030);

                            function u(e, t) {
                                var n = e ? e.inputmask : this,
                                    i = n.opts;
                                e.inputmask.refreshValue = !1, "function" == typeof i.onBeforeMask && (t = i.onBeforeMask.call(n, t, i) || t), h(e, !0, !1, t = t.toString().split("")), n.undoValue = n._valueGet(!0), (i.clearMaskOnLostFocus || i.clearIncomplete) && e.inputmask._valueGet() === a.getBufferTemplate.call(n).join("") && -1 === a.getLastValidPosition.call(n) && e.inputmask._valueSet("")
                            }

                            function d(e) {
                                e.length = 0;
                                for (var t, n = o.getMaskTemplate.call(this, !0, 0, !0, void 0, !0); void 0 !== (t = n.shift());) e.push(t);
                                return e
                            }

                            function h(e, t, n, i, r) {
                                var l = e ? e.inputmask : this,
                                    u = l.maskset,
                                    d = l.opts,
                                    h = l.dependencyLib,
                                    p = i.slice(),
                                    g = "",
                                    m = -1,
                                    v = void 0,
                                    b = d.skipOptionalPartCharacter;
                                d.skipOptionalPartCharacter = "", a.resetMaskSet.call(l), u.tests = {}, m = d.radixPoint ? a.determineNewCaretPosition.call(l, {
                                    begin: 0,
                                    end: 0
                                }, !1, !1 === d.__financeInput ? "radixFocus" : void 0).begin : 0, u.p = m, l.caretPos = {
                                    begin: m
                                };
                                var y = [],
                                    _ = l.caretPos;
                                if (p.forEach((function (e, t) {
                                        if (void 0 !== e) {
                                            var i = new h.Event("_checkval");
                                            i.which = e.toString().charCodeAt(0), g += e;
                                            var r = a.getLastValidPosition.call(l, void 0, !0);
                                            ! function (e, t) {
                                                for (var n = o.getMaskTemplate.call(l, !0, 0).slice(e, a.seekNext.call(l, e, !1, !1)).join("").replace(/'/g, ""), i = n.indexOf(t); i > 0 && " " === n[i - 1];) i--;
                                                var r = 0 === i && !a.isMask.call(l, e) && (o.getTest.call(l, e).match.nativeDef === t.charAt(0) || !0 === o.getTest.call(l, e).match.static && o.getTest.call(l, e).match.nativeDef === "'" + t.charAt(0) || " " === o.getTest.call(l, e).match.nativeDef && (o.getTest.call(l, e + 1).match.nativeDef === t.charAt(0) || !0 === o.getTest.call(l, e + 1).match.static && o.getTest.call(l, e + 1).match.nativeDef === "'" + t.charAt(0)));
                                                if (!r && i > 0 && !a.isMask.call(l, e, !1, !0)) {
                                                    var s = a.seekNext.call(l, e);
                                                    l.caretPos.begin < s && (l.caretPos = {
                                                        begin: s
                                                    })
                                                }
                                                return r
                                            }(m, g) ? (v = c.EventHandlers.keypressEvent.call(l, i, !0, !1, n, l.caretPos.begin)) && (m = l.caretPos.begin + 1, g = "") : v = c.EventHandlers.keypressEvent.call(l, i, !0, !1, n, r + 1), v ? (void 0 !== v.pos && u.validPositions[v.pos] && !0 === u.validPositions[v.pos].match.static && void 0 === u.validPositions[v.pos].alternation && (y.push(v.pos), l.isRTL || (v.forwardPosition = v.pos + 1)), f.call(l, void 0, a.getBuffer.call(l), v.forwardPosition, i, !1), l.caretPos = {
                                                begin: v.forwardPosition,
                                                end: v.forwardPosition
                                            }, _ = l.caretPos) : void 0 === u.validPositions[t] && p[t] === o.getPlaceholder.call(l, t) && a.isMask.call(l, t, !0) ? l.caretPos.begin++ : l.caretPos = _
                                        }
                                    })), y.length > 0) {
                                    var x, w, E = a.seekNext.call(l, -1, void 0, !1);
                                    if (!s.isComplete.call(l, a.getBuffer.call(l)) && y.length <= E || s.isComplete.call(l, a.getBuffer.call(l)) && y.length > 0 && y.length !== E && 0 === y[0])
                                        for (var k = E; void 0 !== (x = y.shift());) {
                                            var O = new h.Event("_checkval");
                                            if ((w = u.validPositions[x]).generatedInput = !0, O.which = w.input.charCodeAt(0), (v = c.EventHandlers.keypressEvent.call(l, O, !0, !1, n, k)) && void 0 !== v.pos && v.pos !== x && u.validPositions[v.pos] && !0 === u.validPositions[v.pos].match.static) y.push(v.pos);
                                            else if (!v) break;
                                            k++
                                        }
                                }
                                t && f.call(l, e, a.getBuffer.call(l), v ? v.forwardPosition : l.caretPos.begin, r || new h.Event("checkval"), r && "input" === r.type && l.undoValue !== l._valueGet(!0)), d.skipOptionalPartCharacter = b
                            }

                            function f(e, t, n, i, o) {
                                var l = e ? e.inputmask : this,
                                    c = l.opts,
                                    u = l.dependencyLib;
                                if (i && "function" == typeof c.onBeforeWrite) {
                                    var d = c.onBeforeWrite.call(l, i, t, n, c);
                                    if (d) {
                                        if (d.refreshFromBuffer) {
                                            var h = d.refreshFromBuffer;
                                            s.refreshFromBuffer.call(l, !0 === h ? h : h.start, h.end, d.buffer || t), t = a.getBuffer.call(l, !0)
                                        }
                                        void 0 !== n && (n = void 0 !== d.caret ? d.caret : n)
                                    }
                                }
                                if (void 0 !== e && (e.inputmask._valueSet(t.join("")), void 0 === n || void 0 !== i && "blur" === i.type || a.caret.call(l, e, n, void 0, void 0, void 0 !== i && "keydown" === i.type && (i.keyCode === r.default.DELETE || i.keyCode === r.default.BACKSPACE)), !0 === o)) {
                                    var f = u(e),
                                        p = e.inputmask._valueGet();
                                    e.inputmask.skipInputEvent = !0, f.trigger("input"), setTimeout((function () {
                                        p === a.getBufferTemplate.call(l).join("") ? f.trigger("cleared") : !0 === s.isComplete.call(l, t) && f.trigger("complete")
                                    }), 0)
                                }
                            }
                        },
                        2394: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = void 0, n(7149), n(3194);
                            var i = n(157),
                                r = m(n(4963)),
                                o = m(n(9380)),
                                a = n(2391),
                                s = n(4713),
                                l = n(8711),
                                c = n(7215),
                                u = n(7760),
                                d = n(9716),
                                h = m(n(7392)),
                                f = m(n(3976)),
                                p = m(n(8741));

                            function g(e) {
                                return (g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                    return typeof e
                                } : function (e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                                })(e)
                            }

                            function m(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var v = o.default.document,
                                b = "_inputmask_opts";

                            function y(e, t, n) {
                                if (p.default) {
                                    if (!(this instanceof y)) return new y(e, t, n);
                                    this.dependencyLib = r.default, this.el = void 0, this.events = {}, this.maskset = void 0, !0 !== n && ("[object Object]" === Object.prototype.toString.call(e) ? t = e : (t = t || {}, e && (t.alias = e)), this.opts = r.default.extend(!0, {}, this.defaults, t), this.noMasksCache = t && void 0 !== t.definitions, this.userOptions = t || {}, _(this.opts.alias, t, this.opts)), this.refreshValue = !1, this.undoValue = void 0, this.$el = void 0, this.skipKeyPressEvent = !1, this.skipInputEvent = !1, this.validationEvent = !1, this.ignorable = !1, this.maxLength, this.mouseEnter = !1, this.originalPlaceholder = void 0, this.isComposing = !1
                                }
                            }

                            function _(e, t, n) {
                                var i = y.prototype.aliases[e];
                                return i ? (i.alias && _(i.alias, void 0, n), r.default.extend(!0, n, i), r.default.extend(!0, n, t), !0) : (null === n.mask && (n.mask = e), !1)
                            }
                            y.prototype = {
                                dataAttribute: "data-inputmask",
                                defaults: f.default,
                                definitions: h.default,
                                aliases: {},
                                masksCache: {},
                                get isRTL() {
                                    return this.opts.isRTL || this.opts.numericInput
                                },
                                mask: function (e) {
                                    var t = this;
                                    return "string" == typeof e && (e = v.getElementById(e) || v.querySelectorAll(e)), (e = e.nodeName ? [e] : Array.isArray(e) ? e : Array.from(e)).forEach((function (e, n) {
                                        var s = r.default.extend(!0, {}, t.opts);
                                        if (function (e, t, n, i) {
                                                function a(t, r) {
                                                    var a = "" === i ? t : i + "-" + t;
                                                    null !== (r = void 0 !== r ? r : e.getAttribute(a)) && ("string" == typeof r && (0 === t.indexOf("on") ? r = o.default[r] : "false" === r ? r = !1 : "true" === r && (r = !0)), n[t] = r)
                                                }
                                                if (!0 === t.importDataAttributes) {
                                                    var s, l, c, u, d = e.getAttribute(i);
                                                    if (d && "" !== d && (d = d.replace(/'/g, '"'), l = JSON.parse("{" + d + "}")), l)
                                                        for (u in c = void 0, l)
                                                            if ("alias" === u.toLowerCase()) {
                                                                c = l[u];
                                                                break
                                                            } for (s in a("alias", c), n.alias && _(n.alias, n, t), t) {
                                                        if (l)
                                                            for (u in c = void 0, l)
                                                                if (u.toLowerCase() === s.toLowerCase()) {
                                                                    c = l[u];
                                                                    break
                                                                } a(s, c)
                                                    }
                                                }
                                                return r.default.extend(!0, t, n), ("rtl" === e.dir || t.rightAlign) && (e.style.textAlign = "right"), ("rtl" === e.dir || t.numericInput) && (e.dir = "ltr", e.removeAttribute("dir"), t.isRTL = !0), Object.keys(n).length
                                            }(e, s, r.default.extend(!0, {}, t.userOptions), t.dataAttribute)) {
                                            var l = (0, a.generateMaskSet)(s, t.noMasksCache);
                                            void 0 !== l && (void 0 !== e.inputmask && (e.inputmask.opts.autoUnmask = !0, e.inputmask.remove()), e.inputmask = new y(void 0, void 0, !0), e.inputmask.opts = s, e.inputmask.noMasksCache = t.noMasksCache, e.inputmask.userOptions = r.default.extend(!0, {}, t.userOptions), e.inputmask.el = e, e.inputmask.$el = (0, r.default)(e), e.inputmask.maskset = l, r.default.data(e, b, t.userOptions), i.mask.call(e.inputmask))
                                        }
                                    })), e && e[0] && e[0].inputmask || this
                                },
                                option: function (e, t) {
                                    return "string" == typeof e ? this.opts[e] : "object" === g(e) ? (r.default.extend(this.userOptions, e), this.el && !0 !== t && this.mask(this.el), this) : void 0
                                },
                                unmaskedvalue: function (e) {
                                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), void 0 === this.el || void 0 !== e) {
                                        var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                                        u.checkVal.call(this, void 0, !1, !1, t), "function" == typeof this.opts.onBeforeWrite && this.opts.onBeforeWrite.call(this, void 0, l.getBuffer.call(this), 0, this.opts)
                                    }
                                    return u.unmaskedvalue.call(this, this.el)
                                },
                                remove: function () {
                                    if (this.el) {
                                        r.default.data(this.el, b, null);
                                        var e = this.opts.autoUnmask ? (0, u.unmaskedvalue)(this.el) : this._valueGet(this.opts.autoUnmask);
                                        e !== l.getBufferTemplate.call(this).join("") ? this._valueSet(e, this.opts.autoUnmask) : this._valueSet(""), d.EventRuler.off(this.el), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.el), "value") && this.__valueGet && Object.defineProperty(this.el, "value", {
                                            get: this.__valueGet,
                                            set: this.__valueSet,
                                            configurable: !0
                                        }) : v.__lookupGetter__ && this.el.__lookupGetter__("value") && this.__valueGet && (this.el.__defineGetter__("value", this.__valueGet), this.el.__defineSetter__("value", this.__valueSet)), this.el.inputmask = void 0
                                    }
                                    return this.el
                                },
                                getemptymask: function () {
                                    return this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), l.getBufferTemplate.call(this).join("")
                                },
                                hasMaskedValue: function () {
                                    return !this.opts.autoUnmask
                                },
                                isComplete: function () {
                                    return this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), c.isComplete.call(this, l.getBuffer.call(this))
                                },
                                getmetadata: function () {
                                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), Array.isArray(this.maskset.metadata)) {
                                        var e = s.getMaskTemplate.call(this, !0, 0, !1).join("");
                                        return this.maskset.metadata.forEach((function (t) {
                                            return t.mask !== e || (e = t, !1)
                                        })), e
                                    }
                                    return this.maskset.metadata
                                },
                                isValid: function (e) {
                                    if (this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache), e) {
                                        var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                                        u.checkVal.call(this, void 0, !0, !1, t)
                                    } else e = this.isRTL ? l.getBuffer.call(this).slice().reverse().join("") : l.getBuffer.call(this).join("");
                                    for (var n = l.getBuffer.call(this), i = l.determineLastRequiredPosition.call(this), r = n.length - 1; r > i && !l.isMask.call(this, r); r--);
                                    return n.splice(i, r + 1 - i), c.isComplete.call(this, n) && e === (this.isRTL ? l.getBuffer.call(this).slice().reverse().join("") : l.getBuffer.call(this).join(""))
                                },
                                format: function (e, t) {
                                    this.maskset = this.maskset || (0, a.generateMaskSet)(this.opts, this.noMasksCache);
                                    var n = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                                    u.checkVal.call(this, void 0, !0, !1, n);
                                    var i = this.isRTL ? l.getBuffer.call(this).slice().reverse().join("") : l.getBuffer.call(this).join("");
                                    return t ? {
                                        value: i,
                                        metadata: this.getmetadata()
                                    } : i
                                },
                                setValue: function (e) {
                                    this.el && (0, r.default)(this.el).trigger("setvalue", [e])
                                },
                                analyseMask: a.analyseMask
                            }, y.extendDefaults = function (e) {
                                r.default.extend(!0, y.prototype.defaults, e)
                            }, y.extendDefinitions = function (e) {
                                r.default.extend(!0, y.prototype.definitions, e)
                            }, y.extendAliases = function (e) {
                                r.default.extend(!0, y.prototype.aliases, e)
                            }, y.format = function (e, t, n) {
                                return y(t).format(e, n)
                            }, y.unmask = function (e, t) {
                                return y(t).unmaskedvalue(e)
                            }, y.isValid = function (e, t) {
                                return y(t).isValid(e)
                            }, y.remove = function (e) {
                                "string" == typeof e && (e = v.getElementById(e) || v.querySelectorAll(e)), (e = e.nodeName ? [e] : e).forEach((function (e) {
                                    e.inputmask && e.inputmask.remove()
                                }))
                            }, y.setValue = function (e, t) {
                                "string" == typeof e && (e = v.getElementById(e) || v.querySelectorAll(e)), (e = e.nodeName ? [e] : e).forEach((function (e) {
                                    e.inputmask ? e.inputmask.setValue(t) : (0, r.default)(e).trigger("setvalue", [t])
                                }))
                            }, y.dependencyLib = r.default, o.default.Inputmask = y;
                            var x = y;
                            t.default = x
                        },
                        5296: function (e, t, n) {
                            function i(e) {
                                return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                    return typeof e
                                } : function (e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                                })(e)
                            }
                            var r = f(n(9380)),
                                o = f(n(2394)),
                                a = f(n(8741));

                            function s(e, t) {
                                return !t || "object" !== i(t) && "function" != typeof t ? function (e) {
                                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return e
                                }(e) : t
                            }

                            function l(e) {
                                var t = "function" == typeof Map ? new Map : void 0;
                                return (l = function (e) {
                                    if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
                                    var n;
                                    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                                    if (void 0 !== t) {
                                        if (t.has(e)) return t.get(e);
                                        t.set(e, i)
                                    }

                                    function i() {
                                        return c(e, arguments, h(this).constructor)
                                    }
                                    return i.prototype = Object.create(e.prototype, {
                                        constructor: {
                                            value: i,
                                            enumerable: !1,
                                            writable: !0,
                                            configurable: !0
                                        }
                                    }), d(i, e)
                                })(e)
                            }

                            function c(e, t, n) {
                                return (c = u() ? Reflect.construct : function (e, t, n) {
                                    var i = [null];
                                    i.push.apply(i, t);
                                    var r = new(Function.bind.apply(e, i));
                                    return n && d(r, n.prototype), r
                                }).apply(null, arguments)
                            }

                            function u() {
                                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                                if (Reflect.construct.sham) return !1;
                                if ("function" == typeof Proxy) return !0;
                                try {
                                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {}))), !0
                                } catch (e) {
                                    return !1
                                }
                            }

                            function d(e, t) {
                                return (d = Object.setPrototypeOf || function (e, t) {
                                    return e.__proto__ = t, e
                                })(e, t)
                            }

                            function h(e) {
                                return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
                                    return e.__proto__ || Object.getPrototypeOf(e)
                                })(e)
                            }

                            function f(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                            var p = r.default.document;
                            if (a.default && p && p.head && p.head.attachShadow && r.default.customElements && void 0 === r.default.customElements.get("input-mask")) {
                                var g = function (e) {
                                    ! function (e, t) {
                                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                                        e.prototype = Object.create(t && t.prototype, {
                                            constructor: {
                                                value: e,
                                                writable: !0,
                                                configurable: !0
                                            }
                                        }), t && d(e, t)
                                    }(r, e);
                                    var t, n, i = (t = r, n = u(), function () {
                                        var e, i = h(t);
                                        if (n) {
                                            var r = h(this).constructor;
                                            e = Reflect.construct(i, arguments, r)
                                        } else e = i.apply(this, arguments);
                                        return s(this, e)
                                    });

                                    function r() {
                                        var e;
                                        ! function (e, t) {
                                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                        }(this, r);
                                        var t = (e = i.call(this)).getAttributeNames(),
                                            n = e.attachShadow({
                                                mode: "closed"
                                            }),
                                            a = p.createElement("input");
                                        for (var s in a.type = "text", n.appendChild(a), t) Object.prototype.hasOwnProperty.call(t, s) && a.setAttribute(t[s], e.getAttribute(t[s]));
                                        var l = new o.default;
                                        return l.dataAttribute = "", l.mask(a), a.inputmask.shadowRoot = n, e
                                    }
                                    return r
                                }(l(HTMLElement));
                                r.default.customElements.define("input-mask", g)
                            }
                        },
                        2391: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.generateMaskSet = function (e, t) {
                                function n(e, n, r) {
                                    var o, a, s = !1;
                                    if (null !== e && "" !== e || ((s = null !== r.regex) ? e = (e = r.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (s = !0, e = ".*")), 1 === e.length && !1 === r.greedy && 0 !== r.repeat && (r.placeholder = ""), r.repeat > 0 || "*" === r.repeat || "+" === r.repeat) {
                                        var l = "*" === r.repeat ? 0 : "+" === r.repeat ? 1 : r.repeat;
                                        e = r.groupmarker[0] + e + r.groupmarker[1] + r.quantifiermarker[0] + l + "," + r.repeat + r.quantifiermarker[1]
                                    }
                                    return a = s ? "regex_" + r.regex : r.numericInput ? e.split("").reverse().join("") : e, !1 !== r.keepStatic && (a = "ks_" + a), void 0 === Inputmask.prototype.masksCache[a] || !0 === t ? (o = {
                                        mask: e,
                                        maskToken: Inputmask.prototype.analyseMask(e, s, r),
                                        validPositions: {},
                                        _buffer: void 0,
                                        buffer: void 0,
                                        tests: {},
                                        excludes: {},
                                        metadata: n,
                                        maskLength: void 0,
                                        jitOffset: {}
                                    }, !0 !== t && (Inputmask.prototype.masksCache[a] = o, o = i.default.extend(!0, {}, Inputmask.prototype.masksCache[a]))) : o = i.default.extend(!0, {}, Inputmask.prototype.masksCache[a]), o
                                }
                                if ("function" == typeof e.mask && (e.mask = e.mask(e)), Array.isArray(e.mask)) {
                                    if (e.mask.length > 1) {
                                        null === e.keepStatic && (e.keepStatic = !0);
                                        var r = e.groupmarker[0];
                                        return (e.isRTL ? e.mask.reverse() : e.mask).forEach((function (t) {
                                            r.length > 1 && (r += e.groupmarker[1] + e.alternatormarker + e.groupmarker[0]), void 0 !== t.mask && "function" != typeof t.mask ? r += t.mask : r += t
                                        })), n(r += e.groupmarker[1], e.mask, e)
                                    }
                                    e.mask = e.mask.pop()
                                }
                                return null === e.keepStatic && (e.keepStatic = !1), e.mask && void 0 !== e.mask.mask && "function" != typeof e.mask.mask ? n(e.mask.mask, e.mask, e) : n(e.mask, e.mask, e)
                            }, t.analyseMask = function (e, t, n) {
                                var i, o, a, s, l, c, u = /(?:[?*+]|\{[0-9+*]+(?:,[0-9+*]*)?(?:\|[0-9+*]*)?\})|[^.?*+^${[]()|\\]+|./g,
                                    d = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
                                    h = !1,
                                    f = new r.default,
                                    p = [],
                                    g = [],
                                    m = !1;

                                function v(e, i, r) {
                                    r = void 0 !== r ? r : e.matches.length;
                                    var o = e.matches[r - 1];
                                    if (t) 0 === i.indexOf("[") || h && /\\d|\\s|\\w]/i.test(i) || "." === i ? e.matches.splice(r++, 0, {
                                        fn: new RegExp(i, n.casing ? "i" : ""),
                                        static: !1,
                                        optionality: !1,
                                        newBlockMarker: void 0 === o ? "master" : o.def !== i,
                                        casing: null,
                                        def: i,
                                        placeholder: void 0,
                                        nativeDef: i
                                    }) : (h && (i = i[i.length - 1]), i.split("").forEach((function (t, i) {
                                        o = e.matches[r - 1], e.matches.splice(r++, 0, {
                                            fn: /[a-z]/i.test(n.staticDefinitionSymbol || t) ? new RegExp("[" + (n.staticDefinitionSymbol || t) + "]", n.casing ? "i" : "") : null,
                                            static: !0,
                                            optionality: !1,
                                            newBlockMarker: void 0 === o ? "master" : o.def !== t && !0 !== o.static,
                                            casing: null,
                                            def: n.staticDefinitionSymbol || t,
                                            placeholder: void 0 !== n.staticDefinitionSymbol ? t : void 0,
                                            nativeDef: (h ? "'" : "") + t
                                        })
                                    }))), h = !1;
                                    else {
                                        var a = n.definitions && n.definitions[i] || n.usePrototypeDefinitions && Inputmask.prototype.definitions[i];
                                        a && !h ? e.matches.splice(r++, 0, {
                                            fn: a.validator ? "string" == typeof a.validator ? new RegExp(a.validator, n.casing ? "i" : "") : new function () {
                                                this.test = a.validator
                                            } : new RegExp("."),
                                            static: a.static || !1,
                                            optionality: !1,
                                            newBlockMarker: void 0 === o ? "master" : o.def !== (a.definitionSymbol || i),
                                            casing: a.casing,
                                            def: a.definitionSymbol || i,
                                            placeholder: a.placeholder,
                                            nativeDef: i,
                                            generated: a.generated
                                        }) : (e.matches.splice(r++, 0, {
                                            fn: /[a-z]/i.test(n.staticDefinitionSymbol || i) ? new RegExp("[" + (n.staticDefinitionSymbol || i) + "]", n.casing ? "i" : "") : null,
                                            static: !0,
                                            optionality: !1,
                                            newBlockMarker: void 0 === o ? "master" : o.def !== i && !0 !== o.static,
                                            casing: null,
                                            def: n.staticDefinitionSymbol || i,
                                            placeholder: void 0 !== n.staticDefinitionSymbol ? i : void 0,
                                            nativeDef: (h ? "'" : "") + i
                                        }), h = !1)
                                    }
                                }

                                function b() {
                                    if (p.length > 0) {
                                        if (v(s = p[p.length - 1], o), s.isAlternator) {
                                            l = p.pop();
                                            for (var e = 0; e < l.matches.length; e++) l.matches[e].isGroup && (l.matches[e].isGroup = !1);
                                            p.length > 0 ? (s = p[p.length - 1]).matches.push(l) : f.matches.push(l)
                                        }
                                    } else v(f, o)
                                }

                                function y(e) {
                                    var t = new r.default(!0);
                                    return t.openGroup = !1, t.matches = e, t
                                }

                                function _() {
                                    if ((a = p.pop()).openGroup = !1, void 0 !== a)
                                        if (p.length > 0) {
                                            if ((s = p[p.length - 1]).matches.push(a), s.isAlternator) {
                                                l = p.pop();
                                                for (var e = 0; e < l.matches.length; e++) l.matches[e].isGroup = !1, l.matches[e].alternatorGroup = !1;
                                                p.length > 0 ? (s = p[p.length - 1]).matches.push(l) : f.matches.push(l)
                                            }
                                        } else f.matches.push(a);
                                    else b()
                                }

                                function x(e) {
                                    var t = e.pop();
                                    return t.isQuantifier && (t = y([e.pop(), t])), t
                                }
                                for (t && (n.optionalmarker[0] = void 0, n.optionalmarker[1] = void 0); i = t ? d.exec(e) : u.exec(e);) {
                                    if (o = i[0], t) switch (o.charAt(0)) {
                                        case "?":
                                            o = "{0,1}";
                                            break;
                                        case "+":
                                        case "*":
                                            o = "{" + o + "}";
                                            break;
                                        case "|":
                                            if (0 === p.length) {
                                                var w = y(f.matches);
                                                w.openGroup = !0, p.push(w), f.matches = [], m = !0
                                            }
                                    }
                                    if (h) b();
                                    else switch (o.charAt(0)) {
                                        case "$":
                                        case "^":
                                            t || b();
                                            break;
                                        case "(?=":
                                        case "(?!":
                                        case "(?<=":
                                        case "(?<!":
                                            p.push(new r.default(!0));
                                            break;
                                        case n.escapeChar:
                                            h = !0, t && b();
                                            break;
                                        case n.optionalmarker[1]:
                                        case n.groupmarker[1]:
                                            _();
                                            break;
                                        case n.optionalmarker[0]:
                                            p.push(new r.default(!1, !0));
                                            break;
                                        case n.groupmarker[0]:
                                            p.push(new r.default(!0));
                                            break;
                                        case n.quantifiermarker[0]:
                                            var E = new r.default(!1, !1, !0),
                                                k = (o = o.replace(/[{}]/g, "")).split("|"),
                                                O = k[0].split(","),
                                                S = isNaN(O[0]) ? O[0] : parseInt(O[0]),
                                                C = 1 === O.length ? S : isNaN(O[1]) ? O[1] : parseInt(O[1]),
                                                A = isNaN(k[1]) ? k[1] : parseInt(k[1]);
                                            "*" !== S && "+" !== S || (S = "*" === C ? 0 : 1), E.quantifier = {
                                                min: S,
                                                max: C,
                                                jit: A
                                            };
                                            var M = p.length > 0 ? p[p.length - 1].matches : f.matches;
                                            if ((i = M.pop()).isAlternator) {
                                                M.push(i), M = i.matches;
                                                var T = new r.default(!0),
                                                    P = M.pop();
                                                M.push(T), M = T.matches, i = P
                                            }
                                            i.isGroup || (i = y([i])), M.push(i), M.push(E);
                                            break;
                                        case n.alternatormarker:
                                            if (p.length > 0) {
                                                var D = (s = p[p.length - 1]).matches[s.matches.length - 1];
                                                c = s.openGroup && (void 0 === D.matches || !1 === D.isGroup && !1 === D.isAlternator) ? p.pop() : x(s.matches)
                                            } else c = x(f.matches);
                                            if (c.isAlternator) p.push(c);
                                            else if (c.alternatorGroup ? (l = p.pop(), c.alternatorGroup = !1) : l = new r.default(!1, !1, !1, !0), l.matches.push(c), p.push(l), c.openGroup) {
                                                c.openGroup = !1;
                                                var L = new r.default(!0);
                                                L.alternatorGroup = !0, p.push(L)
                                            }
                                            break;
                                        default:
                                            b()
                                    }
                                }
                                for (m && _(); p.length > 0;) a = p.pop(), f.matches.push(a);
                                return f.matches.length > 0 && (function e(i) {
                                    i && i.matches && i.matches.forEach((function (r, o) {
                                        var a = i.matches[o + 1];
                                        (void 0 === a || void 0 === a.matches || !1 === a.isQuantifier) && r && r.isGroup && (r.isGroup = !1, t || (v(r, n.groupmarker[0], 0), !0 !== r.openGroup && v(r, n.groupmarker[1]))), e(r)
                                    }))
                                }(f), g.push(f)), (n.numericInput || n.isRTL) && function e(t) {
                                    for (var i in t.matches = t.matches.reverse(), t.matches)
                                        if (Object.prototype.hasOwnProperty.call(t.matches, i)) {
                                            var r = parseInt(i);
                                            if (t.matches[i].isQuantifier && t.matches[r + 1] && t.matches[r + 1].isGroup) {
                                                var o = t.matches[i];
                                                t.matches.splice(i, 1), t.matches.splice(r + 1, 0, o)
                                            }
                                            void 0 !== t.matches[i].matches ? t.matches[i] = e(t.matches[i]) : t.matches[i] = ((a = t.matches[i]) === n.optionalmarker[0] ? a = n.optionalmarker[1] : a === n.optionalmarker[1] ? a = n.optionalmarker[0] : a === n.groupmarker[0] ? a = n.groupmarker[1] : a === n.groupmarker[1] && (a = n.groupmarker[0]), a)
                                        } var a;
                                    return t
                                }(g[0]), g
                            };
                            var i = o(n(4963)),
                                r = o(n(9695));

                            function o(e) {
                                return e && e.__esModule ? e : {
                                    default: e
                                }
                            }
                        },
                        157: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.mask = function () {
                                var e = this,
                                    t = this.opts,
                                    n = this.el,
                                    i = this.dependencyLib;
                                s.EventRuler.off(n);
                                var d = function (t, n) {
                                    "textarea" !== t.tagName.toLowerCase() && n.ignorables.push(r.default.ENTER);
                                    var l = t.getAttribute("type"),
                                        c = "input" === t.tagName.toLowerCase() && n.supportsInputType.includes(l) || t.isContentEditable || "textarea" === t.tagName.toLowerCase();
                                    if (!c)
                                        if ("input" === t.tagName.toLowerCase()) {
                                            var u = document.createElement("input");
                                            u.setAttribute("type", l), c = "text" === u.type, u = null
                                        } else c = "partial";
                                    return !1 !== c ? function (t) {
                                        var r, l;

                                        function c() {
                                            return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== o.getLastValidPosition.call(e) || !0 !== n.nullable ? (this.inputmask.shadowRoot || this.ownerDocument).activeElement === this && n.clearMaskOnLostFocus ? (e.isRTL ? a.clearOptionalTail.call(e, o.getBuffer.call(e).slice()).reverse() : a.clearOptionalTail.call(e, o.getBuffer.call(e).slice())).join("") : r.call(this) : "" : r.call(this)
                                        }

                                        function u(e) {
                                            l.call(this, e), this.inputmask && (0, a.applyInputValue)(this, e)
                                        }
                                        if (!t.inputmask.__valueGet) {
                                            if (!0 !== n.noValuePatching) {
                                                if (Object.getOwnPropertyDescriptor) {
                                                    var d = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(t), "value") : void 0;
                                                    d && d.get && d.set ? (r = d.get, l = d.set, Object.defineProperty(t, "value", {
                                                        get: c,
                                                        set: u,
                                                        configurable: !0
                                                    })) : "input" !== t.tagName.toLowerCase() && (r = function () {
                                                        return this.textContent
                                                    }, l = function (e) {
                                                        this.textContent = e
                                                    }, Object.defineProperty(t, "value", {
                                                        get: c,
                                                        set: u,
                                                        configurable: !0
                                                    }))
                                                } else document.__lookupGetter__ && t.__lookupGetter__("value") && (r = t.__lookupGetter__("value"), l = t.__lookupSetter__("value"), t.__defineGetter__("value", c), t.__defineSetter__("value", u));
                                                t.inputmask.__valueGet = r, t.inputmask.__valueSet = l
                                            }
                                            t.inputmask._valueGet = function (t) {
                                                return e.isRTL && !0 !== t ? r.call(this.el).split("").reverse().join("") : r.call(this.el)
                                            }, t.inputmask._valueSet = function (t, n) {
                                                l.call(this.el, null == t ? "" : !0 !== n && e.isRTL ? t.split("").reverse().join("") : t)
                                            }, void 0 === r && (r = function () {
                                                return this.value
                                            }, l = function (e) {
                                                this.value = e
                                            }, function (t) {
                                                if (i.valHooks && (void 0 === i.valHooks[t] || !0 !== i.valHooks[t].inputmaskpatch)) {
                                                    var r = i.valHooks[t] && i.valHooks[t].get ? i.valHooks[t].get : function (e) {
                                                            return e.value
                                                        },
                                                        s = i.valHooks[t] && i.valHooks[t].set ? i.valHooks[t].set : function (e, t) {
                                                            return e.value = t, e
                                                        };
                                                    i.valHooks[t] = {
                                                        get: function (t) {
                                                            if (t.inputmask) {
                                                                if (t.inputmask.opts.autoUnmask) return t.inputmask.unmaskedvalue();
                                                                var i = r(t);
                                                                return -1 !== o.getLastValidPosition.call(e, void 0, void 0, t.inputmask.maskset.validPositions) || !0 !== n.nullable ? i : ""
                                                            }
                                                            return r(t)
                                                        },
                                                        set: function (e, t) {
                                                            var n = s(e, t);
                                                            return e.inputmask && (0, a.applyInputValue)(e, t), n
                                                        },
                                                        inputmaskpatch: !0
                                                    }
                                                }
                                            }(t.type), function (t) {
                                                s.EventRuler.on(t, "mouseenter", (function () {
                                                    var t = this.inputmask._valueGet(!0);
                                                    t !== (e.isRTL ? o.getBuffer.call(e).reverse() : o.getBuffer.call(e)).join("") && (0, a.applyInputValue)(this, t)
                                                }))
                                            }(t))
                                        }
                                    }(t) : t.inputmask = void 0, c
                                }(n, t);
                                if (!1 !== d) {
                                    e.originalPlaceholder = n.placeholder, e.maxLength = void 0 !== n ? n.maxLength : void 0, -1 === e.maxLength && (e.maxLength = void 0), "inputMode" in n && null === n.getAttribute("inputmode") && (n.inputMode = t.inputmode, n.setAttribute("inputmode", t.inputmode)), !0 === d && (t.showMaskOnFocus = t.showMaskOnFocus && -1 === ["cc-number", "cc-exp"].indexOf(n.autocomplete), l.iphone && (t.insertModeVisual = !1), s.EventRuler.on(n, "submit", u.EventHandlers.submitEvent), s.EventRuler.on(n, "reset", u.EventHandlers.resetEvent), s.EventRuler.on(n, "blur", u.EventHandlers.blurEvent), s.EventRuler.on(n, "focus", u.EventHandlers.focusEvent), s.EventRuler.on(n, "invalid", u.EventHandlers.invalidEvent), s.EventRuler.on(n, "click", u.EventHandlers.clickEvent), s.EventRuler.on(n, "mouseleave", u.EventHandlers.mouseleaveEvent), s.EventRuler.on(n, "mouseenter", u.EventHandlers.mouseenterEvent), s.EventRuler.on(n, "paste", u.EventHandlers.pasteEvent), s.EventRuler.on(n, "cut", u.EventHandlers.cutEvent), s.EventRuler.on(n, "complete", t.oncomplete), s.EventRuler.on(n, "incomplete", t.onincomplete), s.EventRuler.on(n, "cleared", t.oncleared), !0 !== t.inputEventOnly && (s.EventRuler.on(n, "keydown", u.EventHandlers.keydownEvent), s.EventRuler.on(n, "keypress", u.EventHandlers.keypressEvent), s.EventRuler.on(n, "keyup", u.EventHandlers.keyupEvent)), (l.mobile || t.inputEventOnly) && n.removeAttribute("maxLength"), s.EventRuler.on(n, "input", u.EventHandlers.inputFallBackEvent), s.EventRuler.on(n, "compositionend", u.EventHandlers.compositionendEvent)), s.EventRuler.on(n, "setvalue", u.EventHandlers.setValueEvent), o.getBufferTemplate.call(e).join(""), e.undoValue = e._valueGet(!0);
                                    var h = (n.inputmask.shadowRoot || n.ownerDocument).activeElement;
                                    if ("" !== n.inputmask._valueGet(!0) || !1 === t.clearMaskOnLostFocus || h === n) {
                                        (0, a.applyInputValue)(n, n.inputmask._valueGet(!0), t);
                                        var f = o.getBuffer.call(e).slice();
                                        !1 === c.isComplete.call(e, f) && t.clearIncomplete && o.resetMaskSet.call(e), t.clearMaskOnLostFocus && h !== n && (-1 === o.getLastValidPosition.call(e) ? f = [] : a.clearOptionalTail.call(e, f)), (!1 === t.clearMaskOnLostFocus || t.showMaskOnFocus && h === n || "" !== n.inputmask._valueGet(!0)) && (0, a.writeBuffer)(n, f), h === n && o.caret.call(e, n, o.seekNext.call(e, o.getLastValidPosition.call(e)))
                                    }
                                }
                            };
                            var i, r = (i = n(4528)) && i.__esModule ? i : {
                                    default: i
                                },
                                o = n(8711),
                                a = n(7760),
                                s = n(9716),
                                l = n(9845),
                                c = n(7215),
                                u = n(6030)
                        },
                        9695: function (e, t) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.default = function (e, t, n, i) {
                                this.matches = [], this.openGroup = e || !1, this.alternatorGroup = !1, this.isGroup = e || !1, this.isOptional = t || !1, this.isQuantifier = n || !1, this.isAlternator = i || !1, this.quantifier = {
                                    min: 1,
                                    max: 1
                                }
                            }
                        },
                        3194: function () {
                            Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
                                value: function (e, t) {
                                    if (null == this) throw new TypeError('"this" is null or not defined');
                                    var n = Object(this),
                                        i = n.length >>> 0;
                                    if (0 === i) return !1;
                                    for (var r = 0 | t, o = Math.max(r >= 0 ? r : i - Math.abs(r), 0); o < i;) {
                                        if (n[o] === e) return !0;
                                        o++
                                    }
                                    return !1
                                }
                            })
                        },
                        7149: function () {
                            function e(t) {
                                return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                                    return typeof e
                                } : function (e) {
                                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                                })(t)
                            }
                            "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === e("test".__proto__) ? function (e) {
                                return e.__proto__
                            } : function (e) {
                                return e.constructor.prototype
                            })
                        },
                        8711: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.caret = function (e, t, n, i, r) {
                                var o, a = this,
                                    s = this.opts;
                                if (void 0 === t) return "selectionStart" in e && "selectionEnd" in e ? (t = e.selectionStart, n = e.selectionEnd) : window.getSelection ? (o = window.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== e && o.commonAncestorContainer !== e || (t = o.startOffset, n = o.endOffset) : document.selection && document.selection.createRange && (n = (t = 0 - (o = document.selection.createRange()).duplicate().moveStart("character", -e.inputmask._valueGet().length)) + o.text.length), {
                                    begin: i ? t : c.call(a, t),
                                    end: i ? n : c.call(a, n)
                                };
                                if (Array.isArray(t) && (n = a.isRTL ? t[0] : t[1], t = a.isRTL ? t[1] : t[0]), void 0 !== t.begin && (n = a.isRTL ? t.begin : t.end, t = a.isRTL ? t.end : t.begin), "number" == typeof t) {
                                    t = i ? t : c.call(a, t), n = "number" == typeof (n = i ? n : c.call(a, n)) ? n : t;
                                    var l = parseInt(((e.ownerDocument.defaultView || window).getComputedStyle ? (e.ownerDocument.defaultView || window).getComputedStyle(e, null) : e.currentStyle).fontSize) * n;
                                    if (e.scrollLeft = l > e.scrollWidth ? l : 0, e.inputmask.caretPos = {
                                            begin: t,
                                            end: n
                                        }, s.insertModeVisual && !1 === s.insertMode && t === n && (r || n++), e === (e.inputmask.shadowRoot || e.ownerDocument).activeElement)
                                        if ("setSelectionRange" in e) e.setSelectionRange(t, n);
                                        else if (window.getSelection) {
                                        if (o = document.createRange(), void 0 === e.firstChild || null === e.firstChild) {
                                            var u = document.createTextNode("");
                                            e.appendChild(u)
                                        }
                                        o.setStart(e.firstChild, t < e.inputmask._valueGet().length ? t : e.inputmask._valueGet().length), o.setEnd(e.firstChild, n < e.inputmask._valueGet().length ? n : e.inputmask._valueGet().length), o.collapse(!0);
                                        var d = window.getSelection();
                                        d.removeAllRanges(), d.addRange(o)
                                    } else e.createTextRange && ((o = e.createTextRange()).collapse(!0), o.moveEnd("character", n), o.moveStart("character", t), o.select())
                                }
                            }, t.determineLastRequiredPosition = function (e) {
                                var t, n, o = this,
                                    s = this.maskset,
                                    l = this.dependencyLib,
                                    c = i.getMaskTemplate.call(o, !0, a.call(o), !0, !0),
                                    u = c.length,
                                    d = a.call(o),
                                    h = {},
                                    f = s.validPositions[d],
                                    p = void 0 !== f ? f.locator.slice() : void 0;
                                for (t = d + 1; t < c.length; t++) p = (n = i.getTestTemplate.call(o, t, p, t - 1)).locator.slice(), h[t] = l.extend(!0, {}, n);
                                var g = f && void 0 !== f.alternation ? f.locator[f.alternation] : void 0;
                                for (t = u - 1; t > d && ((n = h[t]).match.optionality || n.match.optionalQuantifier && n.match.newBlockMarker || g && (g !== h[t].locator[f.alternation] && 1 != n.match.static || !0 === n.match.static && n.locator[f.alternation] && r.checkAlternationMatch.call(o, n.locator[f.alternation].toString().split(","), g.toString().split(",")) && "" !== i.getTests.call(o, t)[0].def)) && c[t] === i.getPlaceholder.call(o, t, n.match); t--) u--;
                                return e ? {
                                    l: u,
                                    def: h[u] ? h[u].match : void 0
                                } : u
                            }, t.determineNewCaretPosition = function (e, t, n) {
                                var r = this,
                                    c = this.maskset,
                                    u = this.opts;
                                if (t && (r.isRTL ? e.end = e.begin : e.begin = e.end), e.begin === e.end) {
                                    switch (n = n || u.positionCaretOnClick) {
                                        case "none":
                                            break;
                                        case "select":
                                            e = {
                                                begin: 0,
                                                end: o.call(r).length
                                            };
                                            break;
                                        case "ignore":
                                            e.end = e.begin = l.call(r, a.call(r));
                                            break;
                                        case "radixFocus":
                                            if (function (e) {
                                                    if ("" !== u.radixPoint && 0 !== u.digits) {
                                                        var t = c.validPositions;
                                                        if (void 0 === t[e] || t[e].input === i.getPlaceholder.call(r, e)) {
                                                            if (e < l.call(r, -1)) return !0;
                                                            var n = o.call(r).indexOf(u.radixPoint);
                                                            if (-1 !== n) {
                                                                for (var a in t)
                                                                    if (t[a] && n < a && t[a].input !== i.getPlaceholder.call(r, a)) return !1;
                                                                return !0
                                                            }
                                                        }
                                                    }
                                                    return !1
                                                }(e.begin)) {
                                                var d = o.call(r).join("").indexOf(u.radixPoint);
                                                e.end = e.begin = u.numericInput ? l.call(r, d) : d;
                                                break
                                            }
                                            default:
                                                var h = e.begin,
                                                    f = a.call(r, h, !0),
                                                    p = l.call(r, -1 !== f || s.call(r, 0) ? f : -1);
                                                if (h <= p) e.end = e.begin = s.call(r, h, !1, !0) ? h : l.call(r, h);
                                                else {
                                                    var g = c.validPositions[f],
                                                        m = i.getTestTemplate.call(r, p, g ? g.match.locator : void 0, g),
                                                        v = i.getPlaceholder.call(r, p, m.match);
                                                    if ("" !== v && o.call(r)[p] !== v && !0 !== m.match.optionalQuantifier && !0 !== m.match.newBlockMarker || !s.call(r, p, u.keepStatic, !0) && m.match.def === v) {
                                                        var b = l.call(r, p);
                                                        (h >= b || h === p) && (p = b)
                                                    }
                                                    e.end = e.begin = p
                                                }
                                    }
                                    return e
                                }
                            }, t.getBuffer = o, t.getBufferTemplate = function () {
                                var e = this.maskset;
                                return void 0 === e._buffer && (e._buffer = i.getMaskTemplate.call(this, !1, 1), void 0 === e.buffer && (e.buffer = e._buffer.slice())), e._buffer
                            }, t.getLastValidPosition = a, t.isMask = s, t.resetMaskSet = function (e) {
                                var t = this.maskset;
                                t.buffer = void 0, !0 !== e && (t.validPositions = {}, t.p = 0)
                            }, t.seekNext = l, t.seekPrevious = function (e, t) {
                                var n = this,
                                    r = e - 1;
                                if (e <= 0) return 0;
                                for (; r > 0 && (!0 === t && (!0 !== i.getTest.call(n, r).match.newBlockMarker || !s.call(n, r, void 0, !0)) || !0 !== t && !s.call(n, r, void 0, !0));) r--;
                                return r
                            }, t.translatePosition = c;
                            var i = n(4713),
                                r = n(7215);

                            function o(e) {
                                var t = this.maskset;
                                return void 0 !== t.buffer && !0 !== e || (t.buffer = i.getMaskTemplate.call(this, !0, a.call(this), !0), void 0 === t._buffer && (t._buffer = t.buffer.slice())), t.buffer
                            }

                            function a(e, t, n) {
                                var i = this.maskset,
                                    r = -1,
                                    o = -1,
                                    a = n || i.validPositions;
                                for (var s in void 0 === e && (e = -1), a) {
                                    var l = parseInt(s);
                                    a[l] && (t || !0 !== a[l].generatedInput) && (l <= e && (r = l), l >= e && (o = l))
                                }
                                return -1 === r || r == e ? o : -1 == o || e - r < o - e ? r : o
                            }

                            function s(e, t, n) {
                                var r = this,
                                    o = this.maskset,
                                    a = i.getTestTemplate.call(r, e).match;
                                if ("" === a.def && (a = i.getTest.call(r, e).match), !0 !== a.static) return a.fn;
                                if (!0 === n && void 0 !== o.validPositions[e] && !0 !== o.validPositions[e].generatedInput) return !0;
                                if (!0 !== t && e > -1) {
                                    if (n) {
                                        var s = i.getTests.call(r, e);
                                        return s.length > 1 + ("" === s[s.length - 1].match.def ? 1 : 0)
                                    }
                                    var l = i.determineTestTemplate.call(r, e, i.getTests.call(r, e)),
                                        c = i.getPlaceholder.call(r, e, l.match);
                                    return l.match.def !== c
                                }
                                return !1
                            }

                            function l(e, t, n) {
                                var r = this;
                                void 0 === n && (n = !0);
                                for (var o = e + 1;
                                    "" !== i.getTest.call(r, o).match.def && (!0 === t && (!0 !== i.getTest.call(r, o).match.newBlockMarker || !s.call(r, o, void 0, !0)) || !0 !== t && !s.call(r, o, void 0, n));) o++;
                                return o
                            }

                            function c(e) {
                                var t = this.opts,
                                    n = this.el;
                                return !this.isRTL || "number" != typeof e || t.greedy && "" === t.placeholder || !n || (e = Math.abs(this._valueGet().length - e)), e
                            }
                        },
                        4713: function (e, t) {
                            function n(e, t) {
                                var n = (null != e.alternation ? e.mloc[i(e)] : e.locator).join("");
                                if ("" !== n)
                                    for (; n.length < t;) n += "0";
                                return n
                            }

                            function i(e) {
                                var t = e.locator[e.alternation];
                                return "string" == typeof t && t.length > 0 && (t = t.split(",")[0]), void 0 !== t ? t.toString() : ""
                            }

                            function r(e, t, n) {
                                var i = this.opts,
                                    r = this.maskset;
                                if (void 0 !== (t = t || s.call(this, e).match).placeholder || !0 === n) return "function" == typeof t.placeholder ? t.placeholder(i) : t.placeholder;
                                if (!0 === t.static) {
                                    if (e > -1 && void 0 === r.validPositions[e]) {
                                        var o, a = c.call(this, e),
                                            l = [];
                                        if (a.length > 1 + ("" === a[a.length - 1].match.def ? 1 : 0))
                                            for (var u = 0; u < a.length; u++)
                                                if ("" !== a[u].match.def && !0 !== a[u].match.optionality && !0 !== a[u].match.optionalQuantifier && (!0 === a[u].match.static || void 0 === o || !1 !== a[u].match.fn.test(o.match.def, r, e, !0, i)) && (l.push(a[u]), !0 === a[u].match.static && (o = a[u]), l.length > 1 && /[0-9a-bA-Z]/.test(l[0].match.def))) return i.placeholder.charAt(e % i.placeholder.length)
                                    }
                                    return t.def
                                }
                                return i.placeholder.charAt(e % i.placeholder.length)
                            }

                            function o(e, t, n) {
                                return this.maskset.validPositions[e] || a.call(this, e, c.call(this, e, t ? t.slice() : t, n))
                            }

                            function a(e, t) {
                                var i = this.opts;
                                e = e > 0 ? e - 1 : 0;
                                for (var r, o, a, l = n(s.call(this, e)), c = 0; c < t.length; c++) {
                                    var u = t[c];
                                    r = n(u, l.length);
                                    var d = Math.abs(r - l);
                                    (void 0 === o || "" !== r && d < o || a && !i.greedy && a.match.optionality && "master" === a.match.newBlockMarker && (!u.match.optionality || !u.match.newBlockMarker) || a && a.match.optionalQuantifier && !u.match.optionalQuantifier) && (o = d, a = u)
                                }
                                return a
                            }

                            function s(e, t) {
                                var n = this.maskset;
                                return n.validPositions[e] ? n.validPositions[e] : (t || c.call(this, e))[0]
                            }

                            function l(e, t, n) {
                                function i(e) {
                                    for (var t, n = [], i = -1, r = 0, o = e.length; r < o; r++)
                                        if ("-" === e.charAt(r))
                                            for (t = e.charCodeAt(r + 1); ++i < t;) n.push(String.fromCharCode(i));
                                        else i = e.charCodeAt(r), n.push(e.charAt(r));
                                    return n.join("")
                                }
                                return e.match.def === t.match.nativeDef || !(!(n.regex || e.match.fn instanceof RegExp && t.match.fn instanceof RegExp) || !0 === e.match.static || !0 === t.match.static) && -1 !== i(t.match.fn.toString().replace(/[[\]/]/g, "")).indexOf(i(e.match.fn.toString().replace(/[[\]/]/g, "")))
                            }

                            function c(e, t, n) {
                                var i, r = this,
                                    o = this.dependencyLib,
                                    s = this.maskset,
                                    c = this.opts,
                                    u = this.el,
                                    d = s.maskToken,
                                    h = t ? n : 0,
                                    f = t ? t.slice() : [0],
                                    p = [],
                                    g = !1,
                                    m = t ? t.join("") : "";

                                function v(t, n, r, o) {
                                    function a(r, o, d) {
                                        function f(e, t) {
                                            var n = 0 === t.matches.indexOf(e);
                                            return n || t.matches.every((function (i, r) {
                                                return !0 === i.isQuantifier ? n = f(e, t.matches[r - 1]) : Object.prototype.hasOwnProperty.call(i, "matches") && (n = f(e, i)), !n
                                            })), n
                                        }

                                        function b(e, t, n) {
                                            var i, r;
                                            if ((s.tests[e] || s.validPositions[e]) && (s.tests[e] || [s.validPositions[e]]).every((function (e, o) {
                                                    if (e.mloc[t]) return i = e, !1;
                                                    var a = void 0 !== n ? n : e.alternation,
                                                        s = void 0 !== e.locator[a] ? e.locator[a].toString().indexOf(t) : -1;
                                                    return (void 0 === r || s < r) && -1 !== s && (i = e, r = s), !0
                                                })), i) {
                                                var o = i.locator[i.alternation];
                                                return (i.mloc[t] || i.mloc[o] || i.locator).slice((void 0 !== n ? n : i.alternation) + 1)
                                            }
                                            return void 0 !== n ? b(e, t) : void 0
                                        }

                                        function y(e, t) {
                                            var n = e.alternation,
                                                i = void 0 === t || n === t.alternation && -1 === e.locator[n].toString().indexOf(t.locator[n]);
                                            if (!i && n > t.alternation)
                                                for (var r = t.alternation; r < n; r++)
                                                    if (e.locator[r] !== t.locator[r]) {
                                                        n = r, i = !0;
                                                        break
                                                    } if (i) {
                                                e.mloc = e.mloc || {};
                                                var o = e.locator[n];
                                                if (void 0 !== o) {
                                                    if ("string" == typeof o && (o = o.split(",")[0]), void 0 === e.mloc[o] && (e.mloc[o] = e.locator.slice()), void 0 !== t) {
                                                        for (var a in t.mloc) "string" == typeof a && (a = a.split(",")[0]), void 0 === e.mloc[a] && (e.mloc[a] = t.mloc[a]);
                                                        e.locator[n] = Object.keys(e.mloc).join(",")
                                                    }
                                                    return !0
                                                }
                                                e.alternation = void 0
                                            }
                                            return !1
                                        }

                                        function _(e, t) {
                                            if (e.locator.length !== t.locator.length) return !1;
                                            for (var n = e.alternation + 1; n < e.locator.length; n++)
                                                if (e.locator[n] !== t.locator[n]) return !1;
                                            return !0
                                        }
                                        if (h > e + c._maxTestPos) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + s.mask;
                                        if (h === e && void 0 === r.matches) return p.push({
                                            match: r,
                                            locator: o.reverse(),
                                            cd: m,
                                            mloc: {}
                                        }), !0;
                                        if (void 0 !== r.matches) {
                                            if (r.isGroup && d !== r) {
                                                if (r = a(t.matches[t.matches.indexOf(r) + 1], o, d)) return !0
                                            } else if (r.isOptional) {
                                                var x = r,
                                                    w = p.length;
                                                if (r = v(r, n, o, d)) {
                                                    if (p.forEach((function (e, t) {
                                                            t >= w && (e.match.optionality = !0)
                                                        })), i = p[p.length - 1].match, void 0 !== d || !f(i, x)) return !0;
                                                    g = !0, h = e
                                                }
                                            } else if (r.isAlternator) {
                                                var E, k = r,
                                                    O = [],
                                                    S = p.slice(),
                                                    C = o.length,
                                                    A = !1,
                                                    M = n.length > 0 ? n.shift() : -1;
                                                if (-1 === M || "string" == typeof M) {
                                                    var T, P = h,
                                                        D = n.slice(),
                                                        L = [];
                                                    if ("string" == typeof M) L = M.split(",");
                                                    else
                                                        for (T = 0; T < k.matches.length; T++) L.push(T.toString());
                                                    if (void 0 !== s.excludes[e]) {
                                                        for (var N = L.slice(), j = 0, I = s.excludes[e].length; j < I; j++) {
                                                            var R = s.excludes[e][j].toString().split(":");
                                                            o.length == R[1] && L.splice(L.indexOf(R[0]), 1)
                                                        }
                                                        0 === L.length && (delete s.excludes[e], L = N)
                                                    }(!0 === c.keepStatic || isFinite(parseInt(c.keepStatic)) && P >= c.keepStatic) && (L = L.slice(0, 1));
                                                    for (var F = 0; F < L.length; F++) {
                                                        T = parseInt(L[F]), p = [], n = "string" == typeof M && b(h, T, C) || D.slice();
                                                        var B = k.matches[T];
                                                        if (B && a(B, [T].concat(o), d)) r = !0;
                                                        else if (0 === F && (A = !0), B && B.matches && B.matches.length > k.matches[0].matches.length) break;
                                                        E = p.slice(), h = P, p = [];
                                                        for (var q = 0; q < E.length; q++) {
                                                            var z = E[q],
                                                                H = !1;
                                                            z.match.jit = z.match.jit || A, z.alternation = z.alternation || C, y(z);
                                                            for (var U = 0; U < O.length; U++) {
                                                                var V = O[U];
                                                                if ("string" != typeof M || void 0 !== z.alternation && L.includes(z.locator[z.alternation].toString())) {
                                                                    if (z.match.nativeDef === V.match.nativeDef) {
                                                                        H = !0, y(V, z);
                                                                        break
                                                                    }
                                                                    if (l(z, V, c)) {
                                                                        y(z, V) && (H = !0, O.splice(O.indexOf(V), 0, z));
                                                                        break
                                                                    }
                                                                    if (l(V, z, c)) {
                                                                        y(V, z);
                                                                        break
                                                                    }
                                                                    if (G = V, !0 === (K = z).match.static && !0 !== G.match.static && G.match.fn.test(K.match.def, s, e, !1, c, !1)) {
                                                                        _(z, V) || void 0 !== u.inputmask.userOptions.keepStatic ? y(z, V) && (H = !0, O.splice(O.indexOf(V), 0, z)) : c.keepStatic = !0;
                                                                        break
                                                                    }
                                                                }
                                                            }
                                                            H || O.push(z)
                                                        }
                                                    }
                                                    p = S.concat(O), h = e, g = p.length > 0, r = O.length > 0, n = D.slice()
                                                } else r = a(k.matches[M] || t.matches[M], [M].concat(o), d);
                                                if (r) return !0
                                            } else if (r.isQuantifier && d !== t.matches[t.matches.indexOf(r) - 1])
                                                for (var W = r, Y = n.length > 0 ? n.shift() : 0; Y < (isNaN(W.quantifier.max) ? Y + 1 : W.quantifier.max) && h <= e; Y++) {
                                                    var $ = t.matches[t.matches.indexOf(W) - 1];
                                                    if (r = a($, [Y].concat(o), $)) {
                                                        if ((i = p[p.length - 1].match).optionalQuantifier = Y >= W.quantifier.min, i.jit = (Y + 1) * ($.matches.indexOf(i) + 1) > W.quantifier.jit, i.optionalQuantifier && f(i, $)) {
                                                            g = !0, h = e;
                                                            break
                                                        }
                                                        return i.jit && (s.jitOffset[e] = $.matches.length - $.matches.indexOf(i)), !0
                                                    }
                                                } else if (r = v(r, n, o, d)) return !0
                                        } else h++;
                                        var K, G
                                    }
                                    for (var d = n.length > 0 ? n.shift() : 0; d < t.matches.length; d++)
                                        if (!0 !== t.matches[d].isQuantifier) {
                                            var f = a(t.matches[d], [d].concat(r), o);
                                            if (f && h === e) return f;
                                            if (h > e) break
                                        }
                                }
                                if (e > -1) {
                                    if (void 0 === t) {
                                        for (var b, y = e - 1; void 0 === (b = s.validPositions[y] || s.tests[y]) && y > -1;) y--;
                                        void 0 !== b && y > -1 && (f = function (e, t) {
                                            var n, i = [];
                                            return Array.isArray(t) || (t = [t]), t.length > 0 && (void 0 === t[0].alternation || !0 === c.keepStatic ? 0 === (i = a.call(r, e, t.slice()).locator.slice()).length && (i = t[0].locator.slice()) : t.forEach((function (e) {
                                                "" !== e.def && (0 === i.length ? (n = e.alternation, i = e.locator.slice()) : e.locator[n] && -1 === i[n].toString().indexOf(e.locator[n]) && (i[n] += "," + e.locator[n]))
                                            }))), i
                                        }(y, b), m = f.join(""), h = y)
                                    }
                                    if (s.tests[e] && s.tests[e][0].cd === m) return s.tests[e];
                                    for (var _ = f.shift(); _ < d.length && !(v(d[_], f, [_]) && h === e || h > e); _++);
                                }
                                return (0 === p.length || g) && p.push({
                                    match: {
                                        fn: null,
                                        static: !0,
                                        optionality: !1,
                                        casing: null,
                                        def: "",
                                        placeholder: ""
                                    },
                                    locator: [],
                                    mloc: {},
                                    cd: m
                                }), void 0 !== t && s.tests[e] ? o.extend(!0, [], p) : (s.tests[e] = o.extend(!0, [], p), s.tests[e])
                            }
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.determineTestTemplate = a, t.getDecisionTaker = i, t.getMaskTemplate = function (e, t, n, i, s) {
                                var l = this,
                                    u = this.opts,
                                    d = this.maskset,
                                    h = u.greedy;
                                s && (u.greedy = !1), t = t || 0;
                                var f, p, g, m, v = [],
                                    b = 0;
                                do {
                                    if (!0 === e && d.validPositions[b]) p = (g = s && !0 === d.validPositions[b].match.optionality && void 0 === d.validPositions[b + 1] && (!0 === d.validPositions[b].generatedInput || d.validPositions[b].input == u.skipOptionalPartCharacter && b > 0) ? a.call(l, b, c.call(l, b, f, b - 1)) : d.validPositions[b]).match, f = g.locator.slice(), v.push(!0 === n ? g.input : !1 === n ? p.nativeDef : r.call(l, b, p));
                                    else {
                                        p = (g = o.call(l, b, f, b - 1)).match, f = g.locator.slice();
                                        var y = !0 !== i && (!1 !== u.jitMasking ? u.jitMasking : p.jit);
                                        (m = (m && p.static && p.def !== u.groupSeparator && null === p.fn || d.validPositions[b - 1] && p.static && p.def !== u.groupSeparator && null === p.fn) && d.tests[b] && 1 === d.tests[b].length) || !1 === y || void 0 === y || "number" == typeof y && isFinite(y) && y > b ? v.push(!1 === n ? p.nativeDef : r.call(l, b, p)) : m = !1
                                    }
                                    b++
                                } while (!0 !== p.static || "" !== p.def || t > b);
                                return "" === v[v.length - 1] && v.pop(), !1 === n && void 0 !== d.maskLength || (d.maskLength = b - 1), u.greedy = h, v
                            }, t.getPlaceholder = r, t.getTest = s, t.getTests = c, t.getTestTemplate = o, t.isSubsetOf = l
                        },
                        7215: function (e, t, n) {
                            Object.defineProperty(t, "__esModule", {
                                value: !0
                            }), t.alternate = l, t.checkAlternationMatch = function (e, t, n) {
                                for (var i, r = this.opts.greedy ? t : t.slice(0, 1), o = !1, a = void 0 !== n ? n.split(",") : [], s = 0; s < a.length; s++) - 1 !== (i = e.indexOf(a[s])) && e.splice(i, 1);
                                for (var l = 0; l < e.length; l++)
                                    if (r.includes(e[l])) {
                                        o = !0;
                                        break
                                    } return o
                            }, t.isComplete = u, t.isValid = d, t.refreshFromBuffer = f, t.revalidateMask = g, t.handleRemove = function (e, t, n, i, s) {
                                var c = this,
                                    u = this.maskset,
                                    d = this.opts;
                                if ((d.numericInput || c.isRTL) && (t === o.default.BACKSPACE ? t = o.default.DELETE : t === o.default.DELETE && (t = o.default.BACKSPACE), c.isRTL)) {
                                    var h = n.end;
                                    n.end = n.begin, n.begin = h
                                }
                                var f, p = a.getLastValidPosition.call(c, void 0, !0);
                                if (n.end >= a.getBuffer.call(c).length && p >= n.end && (n.end = p + 1), t === o.default.BACKSPACE ? n.end - n.begin < 1 && (n.begin = a.seekPrevious.call(c, n.begin)) : t === o.default.DELETE && n.begin === n.end && (n.end = a.isMask.call(c, n.end, !0, !0) ? n.end + 1 : a.seekNext.call(c, n.end) + 1), !1 !== (f = g.call(c, n))) {
                                    if (!0 !== i && !1 !== d.keepStatic || null !== d.regex && -1 !== r.getTest.call(c, n.begin).match.def.indexOf("|")) {
                                        var m = l.call(c, !0);
                                        if (m) {
                                            var v = void 0 !== m.caret ? m.caret : m.pos ? a.seekNext.call(c, m.pos.begin ? m.pos.begin : m.pos) : a.getLastValidPosition.call(c, -1, !0);
                                            (t !== o.default.DELETE || n.begin > v) && n.begin
                                        }
                                    }!0 !== i && (u.p = t === o.default.DELETE ? n.begin + f : n.begin, u.p = a.determineNewCaretPosition.call(c, {
                                        begin: u.p,
                                        end: u.p
                                    }, !1).begin)
                                }
                            };
                            var i, r = n(4713),
                                o = (i = n(4528)) && i.__esModule ? i : {
                                    default: i
                                },
                                a = n(8711),
                                s = n(6030);

                            function l(e, t, n, i, o, s) {
                                var c, u, h, f, p, g, m, v, b, y, _, x = this,
                                    w = this.dependencyLib,
                                    E = this.opts,
                                    k = x.maskset,
                                    O = w.extend(!0, {}, k.validPositions),
                                    S = w.extend(!0, {}, k.tests),
                                    C = !1,
                                    A = !1,
                                    M = void 0 !== o ? o : a.getLastValidPosition.call(x);
                                if (s && (y = s.begin, _ = s.end, s.begin > s.end && (y = s.end, _ = s.begin)), -1 === M && void 0 === o) c = 0, u = (f = r.getTest.call(x, c)).alternation;
                                else
                                    for (; M >= 0; M--)
                                        if ((h = k.validPositions[M]) && void 0 !== h.alternation) {
                                            if (f && f.locator[h.alternation] !== h.locator[h.alternation]) break;
                                            c = M, u = k.validPositions[c].alternation, f = h
                                        } if (void 0 !== u) {
                                    m = parseInt(c), k.excludes[m] = k.excludes[m] || [], !0 !== e && k.excludes[m].push((0, r.getDecisionTaker)(f) + ":" + f.alternation);
                                    var T = [],
                                        P = -1;
                                    for (p = m; p < a.getLastValidPosition.call(x, void 0, !0) + 1; p++) - 1 === P && e <= p && void 0 !== t && (T.push(t), P = T.length - 1), (g = k.validPositions[p]) && !0 !== g.generatedInput && (void 0 === s || p < y || p >= _) && T.push(g.input), delete k.validPositions[p];
                                    for (-1 === P && void 0 !== t && (T.push(t), P = T.length - 1); void 0 !== k.excludes[m] && k.excludes[m].length < 10;) {
                                        for (k.tests = {}, a.resetMaskSet.call(x, !0), C = !0, p = 0; p < T.length && (v = C.caret || a.getLastValidPosition.call(x, void 0, !0) + 1, b = T[p], C = d.call(x, v, b, !1, i, !0)); p++) p === P && (A = C), 1 == e && C && (A = {
                                            caretPos: p
                                        });
                                        if (C) break;
                                        if (a.resetMaskSet.call(x), f = r.getTest.call(x, m), k.validPositions = w.extend(!0, {}, O), k.tests = w.extend(!0, {}, S), !k.excludes[m]) {
                                            A = l.call(x, e, t, n, i, m - 1, s);
                                            break
                                        }
                                        var D = (0, r.getDecisionTaker)(f);
                                        if (-1 !== k.excludes[m].indexOf(D + ":" + f.alternation)) {
                                            A = l.call(x, e, t, n, i, m - 1, s);
                                            break
                                        }
                                        for (k.excludes[m].push(D + ":" + f.alternation), p = m; p < a.getLastValidPosition.call(x, void 0, !0) + 1; p++) delete k.validPositions[p]
                                    }
                                }
                                return A && !1 === E.keepStatic || delete k.excludes[m], A
                            }

                            function c(e, t, n) {
                                var i = this.opts,
                                    r = this.maskset;
                                switch (i.casing || t.casing) {
                                    case "upper":
                                        e = e.toUpperCase();
                                        break;
                                    case "lower":
                                        e = e.toLowerCase();
                                        break;
                                    case "title":
                                        var a = r.validPositions[n - 1];
                                        e = 0 === n || a && a.input === String.fromCharCode(o.default.SPACE) ? e.toUpperCase() : e.toLowerCase();
                                        break;
                                    default:
                                        if ("function" == typeof i.casing) {
                                            var s = Array.prototype.slice.call(arguments);
                                            s.push(r.validPositions), e = i.casing.apply(this, s)
                                        }
                                }
                                return e
                            }

                            function u(e) {
                                var t = this,
                                    n = this.opts,
                                    i = this.maskset;
                                if ("function" == typeof n.isComplete) return n.isComplete(e, n);
                                if ("*" !== n.repeat) {
                                    var o = !1,
                                        s = a.determineLastRequiredPosition.call(t, !0),
                                        l = a.seekPrevious.call(t, s.l);
                                    if (void 0 === s.def || s.def.newBlockMarker || s.def.optionality || s.def.optionalQuantifier) {
                                        o = !0;
                                        for (var c = 0; c <= l; c++) {
                                            var u = r.getTestTemplate.call(t, c).match;
                                            if (!0 !== u.static && void 0 === i.validPositions[c] && !0 !== u.optionality && !0 !== u.optionalQuantifier || !0 === u.static && e[c] !== r.getPlaceholder.call(t, c, u)) {
                                                o = !1;
                                                break
                                            }
                                        }
                                    }
                                    return o
                                }
                            }

                            function d(e, t, n, i, o, s, h) {
                                var m = this,
                                    v = this.dependencyLib,
                                    b = this.opts,
                                    y = m.maskset;

                                function _(e) {
                                    return m.isRTL ? e.begin - e.end > 1 || e.begin - e.end == 1 : e.end - e.begin > 1 || e.end - e.begin == 1
                                }
                                n = !0 === n;
                                var x = e;

                                function w(e) {
                                    if (void 0 !== e) {
                                        if (void 0 !== e.remove && (Array.isArray(e.remove) || (e.remove = [e.remove]), e.remove.sort((function (e, t) {
                                                return t.pos - e.pos
                                            })).forEach((function (e) {
                                                g.call(m, {
                                                    begin: e,
                                                    end: e + 1
                                                })
                                            })), e.remove = void 0), void 0 !== e.insert && (Array.isArray(e.insert) || (e.insert = [e.insert]), e.insert.sort((function (e, t) {
                                                return e.pos - t.pos
                                            })).forEach((function (e) {
                                                "" !== e.c && d.call(m, e.pos, e.c, void 0 === e.strict || e.strict, void 0 !== e.fromIsValid ? e.fromIsValid : i)
                                            })), e.insert = void 0), e.refreshFromBuffer && e.buffer) {
                                            var t = e.refreshFromBuffer;
                                            f.call(m, !0 === t ? t : t.start, t.end, e.buffer), e.refreshFromBuffer = void 0
                                        }
                                        void 0 !== e.rewritePosition && (x = e.rewritePosition, e = !0)
                                    }
                                    return e
                                }

                                function E(t, n, o) {
                                    var s = !1;
                                    return r.getTests.call(m, t).every((function (l, u) {
                                        var d = l.match;
                                        if (a.getBuffer.call(m, !0), !1 !== (s = (!d.jit || void 0 !== y.validPositions[a.seekPrevious.call(m, t)]) && (null != d.fn ? d.fn.test(n, y, t, o, b, _(e)) : (n === d.def || n === b.skipOptionalPartCharacter) && "" !== d.def && {
                                                c: r.getPlaceholder.call(m, t, d, !0) || d.def,
                                                pos: t
                                            }))) {
                                            var h = void 0 !== s.c ? s.c : n,
                                                f = t;
                                            return h = h === b.skipOptionalPartCharacter && !0 === d.static ? r.getPlaceholder.call(m, t, d, !0) || d.def : h, !0 !== (s = w(s)) && void 0 !== s.pos && s.pos !== t && (f = s.pos), !0 !== s && void 0 === s.pos && void 0 === s.c || !1 === g.call(m, e, v.extend({}, l, {
                                                input: c.call(m, h, d, f)
                                            }), i, f) && (s = !1), !1
                                        }
                                        return !0
                                    })), s
                                }
                                void 0 !== e.begin && (x = m.isRTL ? e.end : e.begin);
                                var k = !0,
                                    O = v.extend(!0, {}, y.validPositions);
                                if (!1 === b.keepStatic && void 0 !== y.excludes[x] && !0 !== o && !0 !== i)
                                    for (var S = x; S < (m.isRTL ? e.begin : e.end); S++) void 0 !== y.excludes[S] && (y.excludes[S] = void 0, delete y.tests[S]);
                                if ("function" == typeof b.preValidation && !0 !== i && !0 !== s && (k = w(k = b.preValidation.call(m, a.getBuffer.call(m), x, t, _(e), b, y, e, n || o))), !0 === k) {
                                    if (k = E(x, t, n), (!n || !0 === i) && !1 === k && !0 !== s) {
                                        var C = y.validPositions[x];
                                        if (!C || !0 !== C.match.static || C.match.def !== t && t !== b.skipOptionalPartCharacter) {
                                            if (b.insertMode || void 0 === y.validPositions[a.seekNext.call(m, x)] || e.end > x) {
                                                var A = !1;
                                                if (y.jitOffset[x] && void 0 === y.validPositions[a.seekNext.call(m, x)] && !1 !== (k = d.call(m, x + y.jitOffset[x], t, !0, !0)) && (!0 !== o && (k.caret = x), A = !0), e.end > x && (y.validPositions[x] = void 0), !A && !a.isMask.call(m, x, b.keepStatic && 0 === x))
                                                    for (var M = x + 1, T = a.seekNext.call(m, x, !1, 0 !== x); M <= T; M++)
                                                        if (!1 !== (k = E(M, t, n))) {
                                                            k = p.call(m, x, void 0 !== k.pos ? k.pos : M) || k, x = M;
                                                            break
                                                        }
                                            }
                                        } else k = {
                                            caret: a.seekNext.call(m, x)
                                        }
                                    }!1 !== k || !b.keepStatic || !u.call(m, a.getBuffer.call(m)) && 0 !== x || n || !0 === o ? _(e) && y.tests[x] && y.tests[x].length > 1 && b.keepStatic && !n && !0 !== o && (k = l.call(m, !0)) : k = l.call(m, x, t, n, i, void 0, e), !0 === k && (k = {
                                        pos: x
                                    })
                                }
                                if ("function" == typeof b.postValidation && !0 !== i && !0 !== s) {
                                    var P = b.postValidation.call(m, a.getBuffer.call(m, !0), void 0 !== e.begin ? m.isRTL ? e.end : e.begin : e, t, k, b, y, n, h);
                                    void 0 !== P && (k = !0 === P ? k : P)
                                }
                                k && void 0 === k.pos && (k.pos = x), !1 === k || !0 === s ? (a.resetMaskSet.call(m, !0), y.validPositions = v.extend(!0, {}, O)) : p.call(m, void 0, x, !0);
                                var D = w(k);
                                return void 0 !== m.maxLength && a.getBuffer.call(m).length > m.maxLength && !i && (a.resetMaskSet.call(m, !0), y.validPositions = v.extend(!0, {}, O), D = !1), D
                            }

                            function h(e, t, n) {
                                for (var i = this.maskset, o = !1, a = r.getTests.call(this, e), s = 0; s < a.length; s++) {
                                    if (a[s].match && (a[s].match.nativeDef === t.match[n.shiftPositions ? "def" : "nativeDef"] && (!n.shiftPositions || !t.match.static) || a[s].match.nativeDef === t.match.nativeDef || n.regex && !a[s].match.static && a[s].match.fn.test(t.input))) {
                                        o = !0;
                                        break
                                    }
                                    if (a[s].match && a[s].match.def === t.match.nativeDef) {
                                        o = void 0;
                                        break
                                    }
                                }
                                return !1 === o && void 0 !== i.jitOffset[e] && (o = h.call(this, e + i.jitOffset[e], t, n)), o
                            }

                            function f(e, t, n) {
                                var i, r, o = this,
                                    l = this.maskset,
                                    c = this.opts,
                                    u = this.dependencyLib,
                                    d = c.skipOptionalPartCharacter,
                                    h = o.isRTL ? n.slice().reverse() : n;
                                if (c.skipOptionalPartCharacter = "", !0 === e) a.resetMaskSet.call(o), l.tests = {}, e = 0, t = n.length, r = a.determineNewCaretPosition.call(o, {
                                    begin: 0,
                                    end: 0
                                }, !1).begin;
                                else {
                                    for (i = e; i < t; i++) delete l.validPositions[i];
                                    r = e
                                }
                                var f = new u.Event("keypress");
                                for (i = e; i < t; i++) {
                                    f.which = h[i].toString().charCodeAt(0), o.ignorable = !1;
                                    var p = s.EventHandlers.keypressEvent.call(o, f, !0, !1, !1, r);
                                    !1 !== p && void 0 !== p && (r = p.forwardPosition)
                                }
                                c.skipOptionalPartCharacter = d
                            }

                            function p(e, t, n) {
                                var i = this,
                                    o = this.maskset,
                                    s = this.dependencyLib;
                                if (void 0 === e)
                                    for (e = t - 1; e > 0 && !o.validPositions[e]; e--);
                                for (var l = e; l < t; l++)
                                    if (void 0 === o.validPositions[l] && !a.isMask.call(i, l, !1) && (0 == l ? r.getTest.call(i, l) : o.validPositions[l - 1])) {
                                        var c = r.getTests.call(i, l).slice();
                                        "" === c[c.length - 1].match.def && c.pop();
                                        var u, h = r.determineTestTemplate.call(i, l, c);
                                        if (h && (!0 !== h.match.jit || "master" === h.match.newBlockMarker && (u = o.validPositions[l + 1]) && !0 === u.match.optionalQuantifier) && ((h = s.extend({}, h, {
                                                input: r.getPlaceholder.call(i, l, h.match, !0) || h.match.def
                                            })).generatedInput = !0, g.call(i, l, h, !0), !0 !== n)) {
                                            var f = o.validPositions[t].input;
                                            return o.validPositions[t] = void 0, d.call(i, t, f, !0, !0)
                                        }
                                    }
                            }

                            function g(e, t, n, i) {
                                var o = this,
                                    s = this.maskset,
                                    l = this.opts,
                                    c = this.dependencyLib;

                                function u(e, t, n) {
                                    var i = t[e];
                                    if (void 0 !== i && !0 === i.match.static && !0 !== i.match.optionality && (void 0 === t[0] || void 0 === t[0].alternation)) {
                                        var r = n.begin <= e - 1 ? t[e - 1] && !0 === t[e - 1].match.static && t[e - 1] : t[e - 1],
                                            o = n.end > e + 1 ? t[e + 1] && !0 === t[e + 1].match.static && t[e + 1] : t[e + 1];
                                        return r && o
                                    }
                                    return !1
                                }
                                var f = 0,
                                    p = void 0 !== e.begin ? e.begin : e,
                                    g = void 0 !== e.end ? e.end : e,
                                    m = !0;
                                if (e.begin > e.end && (p = e.end, g = e.begin), i = void 0 !== i ? i : p, p !== g || l.insertMode && void 0 !== s.validPositions[i] && void 0 === n || void 0 === t) {
                                    var v, b = c.extend(!0, {}, s.validPositions),
                                        y = a.getLastValidPosition.call(o, void 0, !0);
                                    for (s.p = p, v = y; v >= p; v--) delete s.validPositions[v], void 0 === t && delete s.tests[v + 1];
                                    var _, x, w = i,
                                        E = w;
                                    for (t && (s.validPositions[i] = c.extend(!0, {}, t), E++, w++), v = t ? g : g - 1; v <= y; v++) {
                                        if (void 0 !== (_ = b[v]) && !0 !== _.generatedInput && (v >= g || v >= p && u(v, b, {
                                                begin: p,
                                                end: g
                                            }))) {
                                            for (;
                                                "" !== r.getTest.call(o, E).match.def;) {
                                                if (!1 !== (x = h.call(o, E, _, l)) || "+" === _.match.def) {
                                                    "+" === _.match.def && a.getBuffer.call(o, !0);
                                                    var k = d.call(o, E, _.input, "+" !== _.match.def, !0);
                                                    if (m = !1 !== k, w = (k.pos || E) + 1, !m && x) break
                                                } else m = !1;
                                                if (m) {
                                                    void 0 === t && _.match.static && v === e.begin && f++;
                                                    break
                                                }
                                                if (!m && E > s.maskLength) break;
                                                E++
                                            }
                                            "" == r.getTest.call(o, E).match.def && (m = !1), E = w
                                        }
                                        if (!m) break
                                    }
                                    if (!m) return s.validPositions = c.extend(!0, {}, b), a.resetMaskSet.call(o, !0), !1
                                } else t && r.getTest.call(o, i).match.cd === t.match.cd && (s.validPositions[i] = c.extend(!0, {}, t));
                                return a.resetMaskSet.call(o, !0), f
                            }
                        }
                    },
                    t = {};

                function n(i) {
                    var r = t[i];
                    if (void 0 !== r) return r.exports;
                    var o = t[i] = {
                        exports: {}
                    };
                    return e[i](o, o.exports, n), o.exports
                }
                var i = {};
                return function () {
                    var e, t = i;
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = void 0, n(3851), n(219), n(207), n(5296);
                    var r = ((e = n(2394)) && e.__esModule ? e : {
                        default: e
                    }).default;
                    t.default = r
                }(), i
            }()
        },
        281: e => {
            e.exports = function (e) {
                var t = function (n, i, r) {
                    var o = n.splice(0, 50);
                    r = (r = r || []).concat(e.add(o)), n.length > 0 ? setTimeout((function () {
                        t(n, i, r)
                    }), 1) : (e.update(), i(r))
                };
                return t
            }
        },
        332: e => {
            e.exports = function (e) {
                return e.handlers.filterStart = e.handlers.filterStart || [], e.handlers.filterComplete = e.handlers.filterComplete || [],
                    function (t) {
                        if (e.trigger("filterStart"), e.i = 1, e.reset.filter(), void 0 === t) e.filtered = !1;
                        else {
                            e.filtered = !0;
                            for (var n = e.items, i = 0, r = n.length; i < r; i++) {
                                var o = n[i];
                                t(o) ? o.filtered = !0 : o.filtered = !1
                            }
                        }
                        return e.update(), e.trigger("filterComplete"), e.visibleItems
                    }
            }
        },
        916: (e, t, n) => {
            n(650);
            var i = n(744),
                r = n(841),
                o = n(631),
                a = n(209),
                s = n(294);
            e.exports = function (e, t) {
                t = r({
                    location: 0,
                    distance: 100,
                    threshold: .4,
                    multiSearch: !0,
                    searchClass: "fuzzy-search"
                }, t = t || {});
                var n = {
                    search: function (i, r) {
                        for (var o = t.multiSearch ? i.replace(/ +$/, "").split(/ +/) : [i], a = 0, s = e.items.length; a < s; a++) n.item(e.items[a], r, o)
                    },
                    item: function (e, t, i) {
                        for (var r = !0, o = 0; o < i.length; o++) {
                            for (var a = !1, s = 0, l = t.length; s < l; s++) n.values(e.values(), t[s], i[o]) && (a = !0);
                            a || (r = !1)
                        }
                        e.found = r
                    },
                    values: function (e, n, i) {
                        if (e.hasOwnProperty(n)) {
                            var r = o(e[n]).toLowerCase();
                            if (s(r, i, t)) return !0
                        }
                        return !1
                    }
                };
                return i.bind(a(e.listContainer, t.searchClass), "keyup", e.utils.events.debounce((function (t) {
                        var i = t.target || t.srcElement;
                        e.search(i.value, n.search)
                    }), e.searchDelay)),
                    function (t, i) {
                        e.search(t, i, n.search)
                    }
            }
        },
        709: (e, t, n) => {
            var i = n(915),
                r = n(209),
                o = n(841),
                a = n(191),
                s = n(744),
                l = n(631),
                c = n(650),
                u = n(961),
                d = n(63);
            e.exports = function (e, t, h) {
                var f, p = this,
                    g = n(266)(p),
                    m = n(281)(p),
                    v = n(101)(p);
                f = {
                    start: function () {
                        p.listClass = "list", p.searchClass = "search", p.sortClass = "sort", p.page = 1e4, p.i = 1, p.items = [], p.visibleItems = [], p.matchingItems = [], p.searched = !1, p.filtered = !1, p.searchColumns = void 0, p.searchDelay = 0, p.handlers = {
                            updated: []
                        }, p.valueNames = [], p.utils = {
                            getByClass: r,
                            extend: o,
                            indexOf: a,
                            events: s,
                            toString: l,
                            naturalSort: i,
                            classes: c,
                            getAttribute: u,
                            toArray: d
                        }, p.utils.extend(p, t), p.listContainer = "string" == typeof e ? document.getElementById(e) : e, p.listContainer && (p.list = r(p.listContainer, p.listClass, !0), p.parse = n(607)(p), p.templater = n(269)(p), p.search = n(108)(p), p.filter = n(332)(p), p.sort = n(771)(p), p.fuzzySearch = n(916)(p, t.fuzzySearch), this.handlers(), this.items(), this.pagination(), p.update())
                    },
                    handlers: function () {
                        for (var e in p.handlers) p[e] && p.handlers.hasOwnProperty(e) && p.on(e, p[e])
                    },
                    items: function () {
                        p.parse(p.list), void 0 !== h && p.add(h)
                    },
                    pagination: function () {
                        if (void 0 !== t.pagination) {
                            !0 === t.pagination && (t.pagination = [{}]), void 0 === t.pagination[0] && (t.pagination = [t.pagination]);
                            for (var e = 0, n = t.pagination.length; e < n; e++) v(t.pagination[e])
                        }
                    }
                }, this.reIndex = function () {
                    p.items = [], p.visibleItems = [], p.matchingItems = [], p.searched = !1, p.filtered = !1, p.parse(p.list)
                }, this.toJSON = function () {
                    for (var e = [], t = 0, n = p.items.length; t < n; t++) e.push(p.items[t].values());
                    return e
                }, this.add = function (e, t) {
                    if (0 !== e.length) {
                        if (!t) {
                            var n = [],
                                i = !1;
                            void 0 === e[0] && (e = [e]);
                            for (var r = 0, o = e.length; r < o; r++) {
                                var a;
                                i = p.items.length > p.page, a = new g(e[r], void 0, i), p.items.push(a), n.push(a)
                            }
                            return p.update(), n
                        }
                        m(e.slice(0), t)
                    }
                }, this.show = function (e, t) {
                    return this.i = e, this.page = t, p.update(), p
                }, this.remove = function (e, t, n) {
                    for (var i = 0, r = 0, o = p.items.length; r < o; r++) p.items[r].values()[e] == t && (p.templater.remove(p.items[r], n), p.items.splice(r, 1), o--, r--, i++);
                    return p.update(), i
                }, this.get = function (e, t) {
                    for (var n = [], i = 0, r = p.items.length; i < r; i++) {
                        var o = p.items[i];
                        o.values()[e] == t && n.push(o)
                    }
                    return n
                }, this.size = function () {
                    return p.items.length
                }, this.clear = function () {
                    return p.templater.clear(), p.items = [], p
                }, this.on = function (e, t) {
                    return p.handlers[e].push(t), p
                }, this.off = function (e, t) {
                    var n = p.handlers[e],
                        i = a(n, t);
                    return i > -1 && n.splice(i, 1), p
                }, this.trigger = function (e) {
                    for (var t = p.handlers[e].length; t--;) p.handlers[e][t](p);
                    return p
                }, this.reset = {
                    filter: function () {
                        for (var e = p.items, t = e.length; t--;) e[t].filtered = !1;
                        return p
                    },
                    search: function () {
                        for (var e = p.items, t = e.length; t--;) e[t].found = !1;
                        return p
                    }
                }, this.update = function () {
                    var e = p.items,
                        t = e.length;
                    p.visibleItems = [], p.matchingItems = [], p.templater.clear();
                    for (var n = 0; n < t; n++) e[n].matching() && p.matchingItems.length + 1 >= p.i && p.visibleItems.length < p.page ? (e[n].show(), p.visibleItems.push(e[n]), p.matchingItems.push(e[n])) : e[n].matching() ? (p.matchingItems.push(e[n]), e[n].hide()) : e[n].hide();
                    return p.trigger("updated"), p
                }, f.start()
            }
        },
        266: e => {
            e.exports = function (e) {
                return function (t, n, i) {
                    var r = this;
                    this._values = {}, this.found = !1, this.filtered = !1;
                    this.values = function (t, n) {
                            if (void 0 === t) return r._values;
                            for (var i in t) r._values[i] = t[i];
                            !0 !== n && e.templater.set(r, r.values())
                        }, this.show = function () {
                            e.templater.show(r)
                        }, this.hide = function () {
                            e.templater.hide(r)
                        }, this.matching = function () {
                            return e.filtered && e.searched && r.found && r.filtered || e.filtered && !e.searched && r.filtered || !e.filtered && e.searched && r.found || !e.filtered && !e.searched
                        }, this.visible = function () {
                            return !(!r.elm || r.elm.parentNode != e.list)
                        },
                        function (t, n, i) {
                            if (void 0 === n) i ? r.values(t, i) : r.values(t);
                            else {
                                r.elm = n;
                                var o = e.templater.get(r, t);
                                r.values(o)
                            }
                        }(t, n, i)
                }
            }
        },
        101: (e, t, n) => {
            var i = n(650),
                r = n(744),
                o = n(709);
            e.exports = function (e) {
                var t = !1,
                    n = function (n, r) {
                        if (e.page < 1) return e.listContainer.style.display = "none", void(t = !0);
                        t && (e.listContainer.style.display = "block");
                        var o, s = e.matchingItems.length,
                            l = e.i,
                            c = e.page,
                            u = Math.ceil(s / c),
                            d = Math.ceil(l / c),
                            h = r.innerWindow || 2,
                            f = r.left || r.outerWindow || 0,
                            p = r.right || r.outerWindow || 0;
                        p = u - p, n.clear();
                        for (var g = 1; g <= u; g++) {
                            var m = d === g ? "active" : "";
                            a.number(g, f, p, d, h) ? (o = n.add({
                                page: g,
                                dotted: !1
                            })[0], m && i(o.elm).add(m), o.elm.firstChild.setAttribute("data-i", g), o.elm.firstChild.setAttribute("data-page", c)) : a.dotted(n, g, f, p, d, h, n.size()) && (o = n.add({
                                page: "...",
                                dotted: !0
                            })[0], i(o.elm).add("disabled"))
                        }
                    },
                    a = {
                        number: function (e, t, n, i, r) {
                            return this.left(e, t) || this.right(e, n) || this.innerWindow(e, i, r)
                        },
                        left: function (e, t) {
                            return e <= t
                        },
                        right: function (e, t) {
                            return e > t
                        },
                        innerWindow: function (e, t, n) {
                            return e >= t - n && e <= t + n
                        },
                        dotted: function (e, t, n, i, r, o, a) {
                            return this.dottedLeft(e, t, n, i, r, o) || this.dottedRight(e, t, n, i, r, o, a)
                        },
                        dottedLeft: function (e, t, n, i, r, o) {
                            return t == n + 1 && !this.innerWindow(t, r, o) && !this.right(t, i)
                        },
                        dottedRight: function (e, t, n, i, r, o, a) {
                            return !e.items[a - 1].values().dotted && (t == i && !this.innerWindow(t, r, o) && !this.right(t, i))
                        }
                    };
                return function (t) {
                    var i = new o(e.listContainer.id, {
                        listClass: t.paginationClass || "pagination",
                        item: t.item || "<li><a class='page' href='#'></a></li>",
                        valueNames: ["page", "dotted"],
                        searchClass: "pagination-search-that-is-not-supposed-to-exist",
                        sortClass: "pagination-sort-that-is-not-supposed-to-exist"
                    });
                    r.bind(i.listContainer, "click", (function (t) {
                        var n = t.target || t.srcElement,
                            i = e.utils.getAttribute(n, "data-page"),
                            r = e.utils.getAttribute(n, "data-i");
                        r && e.show((r - 1) * i + 1, i)
                    })), e.on("updated", (function () {
                        n(i, t)
                    })), n(i, t)
                }
            }
        },
        607: (e, t, n) => {
            e.exports = function (e) {
                var t = n(266)(e),
                    i = function (n, i) {
                        for (var r = 0, o = n.length; r < o; r++) e.items.push(new t(i, n[r]))
                    },
                    r = function (t, n) {
                        var o = t.splice(0, 50);
                        i(o, n), t.length > 0 ? setTimeout((function () {
                            r(t, n)
                        }), 1) : (e.update(), e.trigger("parseComplete"))
                    };
                return e.handlers.parseComplete = e.handlers.parseComplete || [],
                    function () {
                        var t = function (e) {
                                for (var t = e.childNodes, n = [], i = 0, r = t.length; i < r; i++) void 0 === t[i].data && n.push(t[i]);
                                return n
                            }(e.list),
                            n = e.valueNames;
                        e.indexAsync ? r(t, n) : i(t, n)
                    }
            }
        },
        108: e => {
            e.exports = function (e) {
                var t, n, i, r = {
                        resetList: function () {
                            e.i = 1, e.templater.clear(), i = void 0
                        },
                        setOptions: function (e) {
                            2 == e.length && e[1] instanceof Array ? t = e[1] : 2 == e.length && "function" == typeof e[1] ? (t = void 0, i = e[1]) : 3 == e.length ? (t = e[1], i = e[2]) : t = void 0
                        },
                        setColumns: function () {
                            0 !== e.items.length && void 0 === t && (t = void 0 === e.searchColumns ? r.toArray(e.items[0].values()) : e.searchColumns)
                        },
                        setSearchString: function (t) {
                            t = (t = e.utils.toString(t).toLowerCase()).replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"), n = t
                        },
                        toArray: function (e) {
                            var t = [];
                            for (var n in e) t.push(n);
                            return t
                        }
                    },
                    o = function () {
                        for (var i, r = [], o = n; null !== (i = o.match(/"([^"]+)"/));) r.push(i[1]), o = o.substring(0, i.index) + o.substring(i.index + i[0].length);
                        (o = o.trim()).length && (r = r.concat(o.split(/\s+/)));
                        for (var a = 0, s = e.items.length; a < s; a++) {
                            var l = e.items[a];
                            if (l.found = !1, r.length) {
                                for (var c = 0, u = r.length; c < u; c++) {
                                    for (var d = !1, h = 0, f = t.length; h < f; h++) {
                                        var p = l.values(),
                                            g = t[h];
                                        if (p.hasOwnProperty(g) && void 0 !== p[g] && null !== p[g])
                                            if (-1 !== ("string" != typeof p[g] ? p[g].toString() : p[g]).toLowerCase().indexOf(r[c])) {
                                                d = !0;
                                                break
                                            }
                                    }
                                    if (!d) break
                                }
                                l.found = d
                            }
                        }
                    },
                    a = function () {
                        e.reset.search(), e.searched = !1
                    },
                    s = function (s) {
                        return e.trigger("searchStart"), r.resetList(), r.setSearchString(s), r.setOptions(arguments), r.setColumns(), "" === n ? a() : (e.searched = !0, i ? i(n, t) : o()), e.update(), e.trigger("searchComplete"), e.visibleItems
                    };
                return e.handlers.searchStart = e.handlers.searchStart || [], e.handlers.searchComplete = e.handlers.searchComplete || [], e.utils.events.bind(e.utils.getByClass(e.listContainer, e.searchClass), "keyup", e.utils.events.debounce((function (t) {
                    var n = t.target || t.srcElement;
                    "" === n.value && !e.searched || s(n.value)
                }), e.searchDelay)), e.utils.events.bind(e.utils.getByClass(e.listContainer, e.searchClass), "input", (function (e) {
                    "" === (e.target || e.srcElement).value && s("")
                })), s
            }
        },
        771: e => {
            e.exports = function (e) {
                var t = {
                        els: void 0,
                        clear: function () {
                            for (var n = 0, i = t.els.length; n < i; n++) e.utils.classes(t.els[n]).remove("asc"), e.utils.classes(t.els[n]).remove("desc")
                        },
                        getOrder: function (t) {
                            var n = e.utils.getAttribute(t, "data-order");
                            return "asc" == n || "desc" == n ? n : e.utils.classes(t).has("desc") ? "asc" : e.utils.classes(t).has("asc") ? "desc" : "asc"
                        },
                        getInSensitive: function (t, n) {
                            var i = e.utils.getAttribute(t, "data-insensitive");
                            n.insensitive = "false" !== i
                        },
                        setOrder: function (n) {
                            for (var i = 0, r = t.els.length; i < r; i++) {
                                var o = t.els[i];
                                if (e.utils.getAttribute(o, "data-sort") === n.valueName) {
                                    var a = e.utils.getAttribute(o, "data-order");
                                    "asc" == a || "desc" == a ? a == n.order && e.utils.classes(o).add(n.order) : e.utils.classes(o).add(n.order)
                                }
                            }
                        }
                    },
                    n = function () {
                        e.trigger("sortStart");
                        var n = {},
                            i = arguments[0].currentTarget || arguments[0].srcElement || void 0;
                        i ? (n.valueName = e.utils.getAttribute(i, "data-sort"), t.getInSensitive(i, n), n.order = t.getOrder(i)) : ((n = arguments[1] || n).valueName = arguments[0], n.order = n.order || "asc", n.insensitive = void 0 === n.insensitive || n.insensitive), t.clear(), t.setOrder(n);
                        var r, o = n.sortFunction || e.sortFunction || null,
                            a = "desc" === n.order ? -1 : 1;
                        r = o ? function (e, t) {
                            return o(e, t, n) * a
                        } : function (t, i) {
                            var r = e.utils.naturalSort;
                            return r.alphabet = e.alphabet || n.alphabet || void 0, !r.alphabet && n.insensitive && (r = e.utils.naturalSort.caseInsensitive), r(t.values()[n.valueName], i.values()[n.valueName]) * a
                        }, e.items.sort(r), e.update(), e.trigger("sortComplete")
                    };
                return e.handlers.sortStart = e.handlers.sortStart || [], e.handlers.sortComplete = e.handlers.sortComplete || [], t.els = e.utils.getByClass(e.listContainer, e.sortClass), e.utils.events.bind(t.els, "click", n), e.on("searchStart", t.clear), e.on("filterStart", t.clear), n
            }
        },
        269: e => {
            var t = function (e) {
                var t, n = this,
                    i = function (t, n) {
                        var i = t.cloneNode(!0);
                        i.removeAttribute("id");
                        for (var r = 0, o = n.length; r < o; r++) {
                            var a = void 0,
                                s = n[r];
                            if (s.data)
                                for (var l = 0, c = s.data.length; l < c; l++) i.setAttribute("data-" + s.data[l], "");
                            else s.attr && s.name ? (a = e.utils.getByClass(i, s.name, !0)) && a.setAttribute(s.attr, "") : (a = e.utils.getByClass(i, s, !0)) && (a.innerHTML = "")
                        }
                        return i
                    },
                    r = function () {
                        for (var t = e.list.childNodes, n = 0, i = t.length; n < i; n++)
                            if (void 0 === t[n].data) return t[n].cloneNode(!0)
                    },
                    o = function (e) {
                        if ("string" == typeof e) {
                            if (/<tr[\s>]/g.exec(e)) {
                                var t = document.createElement("tbody");
                                return t.innerHTML = e, t.firstElementChild
                            }
                            if (-1 !== e.indexOf("<")) {
                                var n = document.createElement("div");
                                return n.innerHTML = e, n.firstElementChild
                            }
                        }
                    },
                    a = function (t, n, i) {
                        var r = void 0,
                            o = function (t) {
                                for (var n = 0, i = e.valueNames.length; n < i; n++) {
                                    var r = e.valueNames[n];
                                    if (r.data) {
                                        for (var o = r.data, a = 0, s = o.length; a < s; a++)
                                            if (o[a] === t) return {
                                                data: t
                                            }
                                    } else {
                                        if (r.attr && r.name && r.name == t) return r;
                                        if (r === t) return t
                                    }
                                }
                            }(n);
                        o && (o.data ? t.elm.setAttribute("data-" + o.data, i) : o.attr && o.name ? (r = e.utils.getByClass(t.elm, o.name, !0)) && r.setAttribute(o.attr, i) : (r = e.utils.getByClass(t.elm, o, !0)) && (r.innerHTML = i))
                    };
                this.get = function (t, i) {
                        n.create(t);
                        for (var r = {}, o = 0, a = i.length; o < a; o++) {
                            var s = void 0,
                                l = i[o];
                            if (l.data)
                                for (var c = 0, u = l.data.length; c < u; c++) r[l.data[c]] = e.utils.getAttribute(t.elm, "data-" + l.data[c]);
                            else l.attr && l.name ? (s = e.utils.getByClass(t.elm, l.name, !0), r[l.name] = s ? e.utils.getAttribute(s, l.attr) : "") : (s = e.utils.getByClass(t.elm, l, !0), r[l] = s ? s.innerHTML : "")
                        }
                        return r
                    }, this.set = function (e, t) {
                        if (!n.create(e))
                            for (var i in t) t.hasOwnProperty(i) && a(e, i, t[i])
                    }, this.create = function (e) {
                        return void 0 === e.elm && (e.elm = t(e.values()), n.set(e, e.values()), !0)
                    }, this.remove = function (t) {
                        t.elm.parentNode === e.list && e.list.removeChild(t.elm)
                    }, this.show = function (t) {
                        n.create(t), e.list.appendChild(t.elm)
                    }, this.hide = function (t) {
                        void 0 !== t.elm && t.elm.parentNode === e.list && e.list.removeChild(t.elm)
                    }, this.clear = function () {
                        if (e.list.hasChildNodes())
                            for (; e.list.childNodes.length >= 1;) e.list.removeChild(e.list.firstChild)
                    },
                    function () {
                        var n;
                        if ("function" != typeof e.item) {
                            if (!(n = "string" == typeof e.item ? -1 === e.item.indexOf("<") ? document.getElementById(e.item) : o(e.item) : r())) throw new Error("The list needs to have at least one item on init otherwise you'll have to add a template.");
                            n = i(n, e.valueNames), t = function () {
                                return n.cloneNode(!0)
                            }
                        } else t = function (t) {
                            var n = e.item(t);
                            return o(n)
                        }
                    }()
            };
            e.exports = function (e) {
                return new t(e)
            }
        },
        650: (e, t, n) => {
            var i = n(191),
                r = /\s+/;
            Object.prototype.toString;

            function o(e) {
                if (!e || !e.nodeType) throw new Error("A DOM element reference is required");
                this.el = e, this.list = e.classList
            }
            e.exports = function (e) {
                return new o(e)
            }, o.prototype.add = function (e) {
                if (this.list) return this.list.add(e), this;
                var t = this.array();
                return ~i(t, e) || t.push(e), this.el.className = t.join(" "), this
            }, o.prototype.remove = function (e) {
                if (this.list) return this.list.remove(e), this;
                var t = this.array(),
                    n = i(t, e);
                return ~n && t.splice(n, 1), this.el.className = t.join(" "), this
            }, o.prototype.toggle = function (e, t) {
                return this.list ? (void 0 !== t ? t !== this.list.toggle(e, t) && this.list.toggle(e) : this.list.toggle(e), this) : (void 0 !== t ? t ? this.add(e) : this.remove(e) : this.has(e) ? this.remove(e) : this.add(e), this)
            }, o.prototype.array = function () {
                var e = (this.el.getAttribute("class") || "").replace(/^\s+|\s+$/g, "").split(r);
                return "" === e[0] && e.shift(), e
            }, o.prototype.has = o.prototype.contains = function (e) {
                return this.list ? this.list.contains(e) : !!~i(this.array(), e)
            }
        },
        744: (e, t, n) => {
            var i = window.addEventListener ? "addEventListener" : "attachEvent",
                r = window.removeEventListener ? "removeEventListener" : "detachEvent",
                o = "addEventListener" !== i ? "on" : "",
                a = n(63);
            t.bind = function (e, t, n, r) {
                for (var s = 0, l = (e = a(e)).length; s < l; s++) e[s][i](o + t, n, r || !1)
            }, t.unbind = function (e, t, n, i) {
                for (var s = 0, l = (e = a(e)).length; s < l; s++) e[s][r](o + t, n, i || !1)
            }, t.debounce = function (e, t, n) {
                var i;
                return t ? function () {
                    var r = this,
                        o = arguments,
                        a = function () {
                            i = null, n || e.apply(r, o)
                        },
                        s = n && !i;
                    clearTimeout(i), i = setTimeout(a, t), s && e.apply(r, o)
                } : e
            }
        },
        841: e => {
            e.exports = function (e) {
                for (var t, n = Array.prototype.slice.call(arguments, 1), i = 0; t = n[i]; i++)
                    if (t)
                        for (var r in t) e[r] = t[r];
                return e
            }
        },
        294: e => {
            e.exports = function (e, t, n) {
                var i = n.location || 0,
                    r = n.distance || 100,
                    o = n.threshold || .4;
                if (t === e) return !0;
                if (t.length > 32) return !1;
                var a = i,
                    s = function () {
                        var e, n = {};
                        for (e = 0; e < t.length; e++) n[t.charAt(e)] = 0;
                        for (e = 0; e < t.length; e++) n[t.charAt(e)] |= 1 << t.length - e - 1;
                        return n
                    }();

                function l(e, n) {
                    var i = e / t.length,
                        o = Math.abs(a - n);
                    return r ? i + o / r : o ? 1 : i
                }
                var c = o,
                    u = e.indexOf(t, a); - 1 != u && (c = Math.min(l(0, u), c), -1 != (u = e.lastIndexOf(t, a + t.length)) && (c = Math.min(l(0, u), c)));
                var d, h, f = 1 << t.length - 1;
                u = -1;
                for (var p, g = t.length + e.length, m = 0; m < t.length; m++) {
                    for (d = 0, h = g; d < h;) l(m, a + h) <= c ? d = h : g = h, h = Math.floor((g - d) / 2 + d);
                    g = h;
                    var v = Math.max(1, a - h + 1),
                        b = Math.min(a + h, e.length) + t.length,
                        y = Array(b + 2);
                    y[b + 1] = (1 << m) - 1;
                    for (var _ = b; _ >= v; _--) {
                        var x = s[e.charAt(_ - 1)];
                        if (y[_] = 0 === m ? (y[_ + 1] << 1 | 1) & x : (y[_ + 1] << 1 | 1) & x | (p[_ + 1] | p[_]) << 1 | 1 | p[_ + 1], y[_] & f) {
                            var w = l(m, _ - 1);
                            if (w <= c) {
                                if (c = w, !((u = _ - 1) > a)) break;
                                v = Math.max(1, 2 * a - u)
                            }
                        }
                    }
                    if (l(m + 1, a) > c) break;
                    p = y
                }
                return !(u < 0)
            }
        },
        961: e => {
            e.exports = function (e, t) {
                var n = e.getAttribute && e.getAttribute(t) || null;
                if (!n)
                    for (var i = e.attributes, r = i.length, o = 0; o < r; o++) void 0 !== i[o] && i[o].nodeName === t && (n = i[o].nodeValue);
                return n
            }
        },
        209: e => {
            e.exports = function (e, t, n, i) {
                return (i = i || {}).test && i.getElementsByClassName || !i.test && document.getElementsByClassName ? function (e, t, n) {
                    return n ? e.getElementsByClassName(t)[0] : e.getElementsByClassName(t)
                }(e, t, n) : i.test && i.querySelector || !i.test && document.querySelector ? function (e, t, n) {
                    return t = "." + t, n ? e.querySelector(t) : e.querySelectorAll(t)
                }(e, t, n) : function (e, t, n) {
                    for (var i = [], r = e.getElementsByTagName("*"), o = r.length, a = new RegExp("(^|\\s)" + t + "(\\s|$)"), s = 0, l = 0; s < o; s++)
                        if (a.test(r[s].className)) {
                            if (n) return r[s];
                            i[l] = r[s], l++
                        } return i
                }(e, t, n)
            }
        },
        191: e => {
            var t = [].indexOf;
            e.exports = function (e, n) {
                if (t) return e.indexOf(n);
                for (var i = 0, r = e.length; i < r; ++i)
                    if (e[i] === n) return i;
                return -1
            }
        },
        63: e => {
            e.exports = function (e) {
                if (void 0 === e) return [];
                if (null === e) return [null];
                if (e === window) return [window];
                if ("string" == typeof e) return [e];
                if (function (e) {
                        return "[object Array]" === Object.prototype.toString.call(e)
                    }(e)) return e;
                if ("number" != typeof e.length) return [e];
                if ("function" == typeof e && e instanceof Function) return [e];
                for (var t = [], n = 0, i = e.length; n < i; n++)(Object.prototype.hasOwnProperty.call(e, n) || n in e) && t.push(e[n]);
                return t.length ? t : []
            }
        },
        631: e => {
            e.exports = function (e) {
                return e = (e = null === (e = void 0 === e ? "" : e) ? "" : e).toString()
            }
        },
        95: function (e) {
            var t;
            "undefined" != typeof self && self, t = function () {
                return function (e) {
                    var t = {};

                    function n(i) {
                        if (t[i]) return t[i].exports;
                        var r = t[i] = {
                            i,
                            l: !1,
                            exports: {}
                        };
                        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports
                    }
                    return n.m = e, n.c = t, n.d = function (e, t, i) {
                        n.o(e, t) || Object.defineProperty(e, t, {
                            configurable: !1,
                            enumerable: !0,
                            get: i
                        })
                    }, n.n = function (e) {
                        var t = e && e.__esModule ? function () {
                            return e.default
                        } : function () {
                            return e
                        };
                        return n.d(t, "a", t), t
                    }, n.o = function (e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t)
                    }, n.p = "", n(n.s = 109)
                }([function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(17),
                        r = n(18),
                        o = n(19),
                        a = n(45),
                        s = n(46),
                        l = n(47),
                        c = n(48),
                        u = n(49),
                        d = n(12),
                        h = n(32),
                        f = n(33),
                        p = n(31),
                        g = n(1),
                        m = {
                            Scope: g.Scope,
                            create: g.create,
                            find: g.find,
                            query: g.query,
                            register: g.register,
                            Container: i.default,
                            Format: r.default,
                            Leaf: o.default,
                            Embed: c.default,
                            Scroll: a.default,
                            Block: l.default,
                            Inline: s.default,
                            Text: u.default,
                            Attributor: {
                                Attribute: d.default,
                                Class: h.default,
                                Style: f.default,
                                Store: p.default
                            }
                        };
                    t.default = m
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = function (e) {
                        function t(t) {
                            var n = this;
                            return t = "[Parchment] " + t, (n = e.call(this, t) || this).message = t, n.name = n.constructor.name, n
                        }
                        return r(t, e), t
                    }(Error);
                    t.ParchmentError = o;
                    var a, s = {},
                        l = {},
                        c = {},
                        u = {};

                    function d(e, t) {
                        var n;
                        if (void 0 === t && (t = a.ANY), "string" == typeof e) n = u[e] || s[e];
                        else if (e instanceof Text || e.nodeType === Node.TEXT_NODE) n = u.text;
                        else if ("number" == typeof e) e & a.LEVEL & a.BLOCK ? n = u.block : e & a.LEVEL & a.INLINE && (n = u.inline);
                        else if (e instanceof HTMLElement) {
                            var i = (e.getAttribute("class") || "").split(/\s+/);
                            for (var r in i)
                                if (n = l[i[r]]) break;
                            n = n || c[e.tagName]
                        }
                        return null == n ? null : t & a.LEVEL & n.scope && t & a.TYPE & n.scope ? n : null
                    }
                    t.DATA_KEY = "__blot",
                        function (e) {
                            e[e.TYPE = 3] = "TYPE", e[e.LEVEL = 12] = "LEVEL", e[e.ATTRIBUTE = 13] = "ATTRIBUTE", e[e.BLOT = 14] = "BLOT", e[e.INLINE = 7] = "INLINE", e[e.BLOCK = 11] = "BLOCK", e[e.BLOCK_BLOT = 10] = "BLOCK_BLOT", e[e.INLINE_BLOT = 6] = "INLINE_BLOT", e[e.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", e[e.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", e[e.ANY = 15] = "ANY"
                        }(a = t.Scope || (t.Scope = {})), t.create = function (e, t) {
                            var n = d(e);
                            if (null == n) throw new o("Unable to create " + e + " blot");
                            var i = n,
                                r = e instanceof Node || e.nodeType === Node.TEXT_NODE ? e : i.create(t);
                            return new i(r, t)
                        }, t.find = function e(n, i) {
                            return void 0 === i && (i = !1), null == n ? null : null != n[t.DATA_KEY] ? n[t.DATA_KEY].blot : i ? e(n.parentNode, i) : null
                        }, t.query = d, t.register = function e() {
                            for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                            if (t.length > 1) return t.map((function (t) {
                                return e(t)
                            }));
                            var i = t[0];
                            if ("string" != typeof i.blotName && "string" != typeof i.attrName) throw new o("Invalid definition");
                            if ("abstract" === i.blotName) throw new o("Cannot register abstract class");
                            if (u[i.blotName || i.attrName] = i, "string" == typeof i.keyName) s[i.keyName] = i;
                            else if (null != i.className && (l[i.className] = i), null != i.tagName) {
                                Array.isArray(i.tagName) ? i.tagName = i.tagName.map((function (e) {
                                    return e.toUpperCase()
                                })) : i.tagName = i.tagName.toUpperCase();
                                var r = Array.isArray(i.tagName) ? i.tagName : [i.tagName];
                                r.forEach((function (e) {
                                    null != c[e] && null != i.className || (c[e] = i)
                                }))
                            }
                            return i
                        }
                }, function (e, t, n) {
                    var i = n(51),
                        r = n(11),
                        o = n(3),
                        a = n(20),
                        s = String.fromCharCode(0),
                        l = function (e) {
                            Array.isArray(e) ? this.ops = e : null != e && Array.isArray(e.ops) ? this.ops = e.ops : this.ops = []
                        };
                    l.prototype.insert = function (e, t) {
                        var n = {};
                        return 0 === e.length ? this : (n.insert = e, null != t && "object" == typeof t && Object.keys(t).length > 0 && (n.attributes = t), this.push(n))
                    }, l.prototype.delete = function (e) {
                        return e <= 0 ? this : this.push({
                            delete: e
                        })
                    }, l.prototype.retain = function (e, t) {
                        if (e <= 0) return this;
                        var n = {
                            retain: e
                        };
                        return null != t && "object" == typeof t && Object.keys(t).length > 0 && (n.attributes = t), this.push(n)
                    }, l.prototype.push = function (e) {
                        var t = this.ops.length,
                            n = this.ops[t - 1];
                        if (e = o(!0, {}, e), "object" == typeof n) {
                            if ("number" == typeof e.delete && "number" == typeof n.delete) return this.ops[t - 1] = {
                                delete: n.delete + e.delete
                            }, this;
                            if ("number" == typeof n.delete && null != e.insert && (t -= 1, "object" != typeof (n = this.ops[t - 1]))) return this.ops.unshift(e), this;
                            if (r(e.attributes, n.attributes)) {
                                if ("string" == typeof e.insert && "string" == typeof n.insert) return this.ops[t - 1] = {
                                    insert: n.insert + e.insert
                                }, "object" == typeof e.attributes && (this.ops[t - 1].attributes = e.attributes), this;
                                if ("number" == typeof e.retain && "number" == typeof n.retain) return this.ops[t - 1] = {
                                    retain: n.retain + e.retain
                                }, "object" == typeof e.attributes && (this.ops[t - 1].attributes = e.attributes), this
                            }
                        }
                        return t === this.ops.length ? this.ops.push(e) : this.ops.splice(t, 0, e), this
                    }, l.prototype.chop = function () {
                        var e = this.ops[this.ops.length - 1];
                        return e && e.retain && !e.attributes && this.ops.pop(), this
                    }, l.prototype.filter = function (e) {
                        return this.ops.filter(e)
                    }, l.prototype.forEach = function (e) {
                        this.ops.forEach(e)
                    }, l.prototype.map = function (e) {
                        return this.ops.map(e)
                    }, l.prototype.partition = function (e) {
                        var t = [],
                            n = [];
                        return this.forEach((function (i) {
                            (e(i) ? t : n).push(i)
                        })), [t, n]
                    }, l.prototype.reduce = function (e, t) {
                        return this.ops.reduce(e, t)
                    }, l.prototype.changeLength = function () {
                        return this.reduce((function (e, t) {
                            return t.insert ? e + a.length(t) : t.delete ? e - t.delete : e
                        }), 0)
                    }, l.prototype.length = function () {
                        return this.reduce((function (e, t) {
                            return e + a.length(t)
                        }), 0)
                    }, l.prototype.slice = function (e, t) {
                        e = e || 0, "number" != typeof t && (t = 1 / 0);
                        for (var n = [], i = a.iterator(this.ops), r = 0; r < t && i.hasNext();) {
                            var o;
                            r < e ? o = i.next(e - r) : (o = i.next(t - r), n.push(o)), r += a.length(o)
                        }
                        return new l(n)
                    }, l.prototype.compose = function (e) {
                        var t = a.iterator(this.ops),
                            n = a.iterator(e.ops),
                            i = [],
                            o = n.peek();
                        if (null != o && "number" == typeof o.retain && null == o.attributes) {
                            for (var s = o.retain;
                                "insert" === t.peekType() && t.peekLength() <= s;) s -= t.peekLength(), i.push(t.next());
                            o.retain - s > 0 && n.next(o.retain - s)
                        }
                        for (var c = new l(i); t.hasNext() || n.hasNext();)
                            if ("insert" === n.peekType()) c.push(n.next());
                            else if ("delete" === t.peekType()) c.push(t.next());
                        else {
                            var u = Math.min(t.peekLength(), n.peekLength()),
                                d = t.next(u),
                                h = n.next(u);
                            if ("number" == typeof h.retain) {
                                var f = {};
                                "number" == typeof d.retain ? f.retain = u : f.insert = d.insert;
                                var p = a.attributes.compose(d.attributes, h.attributes, "number" == typeof d.retain);
                                if (p && (f.attributes = p), c.push(f), !n.hasNext() && r(c.ops[c.ops.length - 1], f)) {
                                    var g = new l(t.rest());
                                    return c.concat(g).chop()
                                }
                            } else "number" == typeof h.delete && "number" == typeof d.retain && c.push(h)
                        }
                        return c.chop()
                    }, l.prototype.concat = function (e) {
                        var t = new l(this.ops.slice());
                        return e.ops.length > 0 && (t.push(e.ops[0]), t.ops = t.ops.concat(e.ops.slice(1))), t
                    }, l.prototype.diff = function (e, t) {
                        if (this.ops === e.ops) return new l;
                        var n = [this, e].map((function (t) {
                                return t.map((function (n) {
                                    if (null != n.insert) return "string" == typeof n.insert ? n.insert : s;
                                    throw new Error("diff() called " + (t === e ? "on" : "with") + " non-document")
                                })).join("")
                            })),
                            o = new l,
                            c = i(n[0], n[1], t),
                            u = a.iterator(this.ops),
                            d = a.iterator(e.ops);
                        return c.forEach((function (e) {
                            for (var t = e[1].length; t > 0;) {
                                var n = 0;
                                switch (e[0]) {
                                    case i.INSERT:
                                        n = Math.min(d.peekLength(), t), o.push(d.next(n));
                                        break;
                                    case i.DELETE:
                                        n = Math.min(t, u.peekLength()), u.next(n), o.delete(n);
                                        break;
                                    case i.EQUAL:
                                        n = Math.min(u.peekLength(), d.peekLength(), t);
                                        var s = u.next(n),
                                            l = d.next(n);
                                        r(s.insert, l.insert) ? o.retain(n, a.attributes.diff(s.attributes, l.attributes)) : o.push(l).delete(n)
                                }
                                t -= n
                            }
                        })), o.chop()
                    }, l.prototype.eachLine = function (e, t) {
                        t = t || "\n";
                        for (var n = a.iterator(this.ops), i = new l, r = 0; n.hasNext();) {
                            if ("insert" !== n.peekType()) return;
                            var o = n.peek(),
                                s = a.length(o) - n.peekLength(),
                                c = "string" == typeof o.insert ? o.insert.indexOf(t, s) - s : -1;
                            if (c < 0) i.push(n.next());
                            else if (c > 0) i.push(n.next(c));
                            else {
                                if (!1 === e(i, n.next(1).attributes || {}, r)) return;
                                r += 1, i = new l
                            }
                        }
                        i.length() > 0 && e(i, {}, r)
                    }, l.prototype.transform = function (e, t) {
                        if (t = !!t, "number" == typeof e) return this.transformPosition(e, t);
                        for (var n = a.iterator(this.ops), i = a.iterator(e.ops), r = new l; n.hasNext() || i.hasNext();)
                            if ("insert" !== n.peekType() || !t && "insert" === i.peekType())
                                if ("insert" === i.peekType()) r.push(i.next());
                                else {
                                    var o = Math.min(n.peekLength(), i.peekLength()),
                                        s = n.next(o),
                                        c = i.next(o);
                                    if (s.delete) continue;
                                    c.delete ? r.push(c) : r.retain(o, a.attributes.transform(s.attributes, c.attributes, t))
                                }
                        else r.retain(a.length(n.next()));
                        return r.chop()
                    }, l.prototype.transformPosition = function (e, t) {
                        t = !!t;
                        for (var n = a.iterator(this.ops), i = 0; n.hasNext() && i <= e;) {
                            var r = n.peekLength(),
                                o = n.peekType();
                            n.next(), "delete" !== o ? ("insert" === o && (i < e || !t) && (e += r), i += r) : e -= Math.min(r, e - i)
                        }
                        return e
                    }, e.exports = l
                }, function (e, t) {
                    "use strict";
                    var n = Object.prototype.hasOwnProperty,
                        i = Object.prototype.toString,
                        r = Object.defineProperty,
                        o = Object.getOwnPropertyDescriptor,
                        a = function (e) {
                            return "function" == typeof Array.isArray ? Array.isArray(e) : "[object Array]" === i.call(e)
                        },
                        s = function (e) {
                            if (!e || "[object Object]" !== i.call(e)) return !1;
                            var t, r = n.call(e, "constructor"),
                                o = e.constructor && e.constructor.prototype && n.call(e.constructor.prototype, "isPrototypeOf");
                            if (e.constructor && !r && !o) return !1;
                            for (t in e);
                            return void 0 === t || n.call(e, t)
                        },
                        l = function (e, t) {
                            r && "__proto__" === t.name ? r(e, t.name, {
                                enumerable: !0,
                                configurable: !0,
                                value: t.newValue,
                                writable: !0
                            }) : e[t.name] = t.newValue
                        },
                        c = function (e, t) {
                            if ("__proto__" === t) {
                                if (!n.call(e, t)) return;
                                if (o) return o(e, t).value
                            }
                            return e[t]
                        };
                    e.exports = function e() {
                        var t, n, i, r, o, u, d = arguments[0],
                            h = 1,
                            f = arguments.length,
                            p = !1;
                        for ("boolean" == typeof d && (p = d, d = arguments[1] || {}, h = 2), (null == d || "object" != typeof d && "function" != typeof d) && (d = {}); h < f; ++h)
                            if (null != (t = arguments[h]))
                                for (n in t) i = c(d, n), d !== (r = c(t, n)) && (p && r && (s(r) || (o = a(r))) ? (o ? (o = !1, u = i && a(i) ? i : []) : u = i && s(i) ? i : {}, l(d, {
                                    name: n,
                                    newValue: e(p, u, r)
                                })) : void 0 !== r && l(d, {
                                    name: n,
                                    newValue: r
                                }));
                        return d
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.BlockEmbed = t.bubbleFormats = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = d(n(3)),
                        a = d(n(2)),
                        s = d(n(0)),
                        l = d(n(16)),
                        c = d(n(6)),
                        u = d(n(7));

                    function d(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function h(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function f(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function p(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var g = function (e) {
                        function t() {
                            return h(this, t), f(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return p(t, e), i(t, [{
                            key: "attach",
                            value: function () {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "attach", this).call(this), this.attributes = new s.default.Attributor.Store(this.domNode)
                            }
                        }, {
                            key: "delta",
                            value: function () {
                                return (new a.default).insert(this.value(), (0, o.default)(this.formats(), this.attributes.values()))
                            }
                        }, {
                            key: "format",
                            value: function (e, t) {
                                var n = s.default.query(e, s.default.Scope.BLOCK_ATTRIBUTE);
                                null != n && this.attributes.attribute(n, t)
                            }
                        }, {
                            key: "formatAt",
                            value: function (e, t, n, i) {
                                this.format(n, i)
                            }
                        }, {
                            key: "insertAt",
                            value: function (e, n, i) {
                                if ("string" == typeof n && n.endsWith("\n")) {
                                    var o = s.default.create(m.blotName);
                                    this.parent.insertBefore(o, 0 === e ? this : this.next), o.insertAt(0, n.slice(0, -1))
                                } else r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertAt", this).call(this, e, n, i)
                            }
                        }]), t
                    }(s.default.Embed);
                    g.scope = s.default.Scope.BLOCK_BLOT;
                    var m = function (e) {
                        function t(e) {
                            h(this, t);
                            var n = f(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                            return n.cache = {}, n
                        }
                        return p(t, e), i(t, [{
                            key: "delta",
                            value: function () {
                                return null == this.cache.delta && (this.cache.delta = this.descendants(s.default.Leaf).reduce((function (e, t) {
                                    return 0 === t.length() ? e : e.insert(t.value(), v(t))
                                }), new a.default).insert("\n", v(this))), this.cache.delta
                            }
                        }, {
                            key: "deleteAt",
                            value: function (e, n) {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "deleteAt", this).call(this, e, n), this.cache = {}
                            }
                        }, {
                            key: "formatAt",
                            value: function (e, n, i, o) {
                                n <= 0 || (s.default.query(i, s.default.Scope.BLOCK) ? e + n === this.length() && this.format(i, o) : r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "formatAt", this).call(this, e, Math.min(n, this.length() - e - 1), i, o), this.cache = {})
                            }
                        }, {
                            key: "insertAt",
                            value: function (e, n, i) {
                                if (null != i) return r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertAt", this).call(this, e, n, i);
                                if (0 !== n.length) {
                                    var o = n.split("\n"),
                                        a = o.shift();
                                    a.length > 0 && (e < this.length() - 1 || null == this.children.tail ? r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertAt", this).call(this, Math.min(e, this.length() - 1), a) : this.children.tail.insertAt(this.children.tail.length(), a), this.cache = {});
                                    var s = this;
                                    o.reduce((function (e, t) {
                                        return (s = s.split(e, !0)).insertAt(0, t), t.length
                                    }), e + a.length)
                                }
                            }
                        }, {
                            key: "insertBefore",
                            value: function (e, n) {
                                var i = this.children.head;
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertBefore", this).call(this, e, n), i instanceof l.default && i.remove(), this.cache = {}
                            }
                        }, {
                            key: "length",
                            value: function () {
                                return null == this.cache.length && (this.cache.length = r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "length", this).call(this) + 1), this.cache.length
                            }
                        }, {
                            key: "moveChildren",
                            value: function (e, n) {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "moveChildren", this).call(this, e, n), this.cache = {}
                            }
                        }, {
                            key: "optimize",
                            value: function (e) {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e), this.cache = {}
                            }
                        }, {
                            key: "path",
                            value: function (e) {
                                return r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "path", this).call(this, e, !0)
                            }
                        }, {
                            key: "removeChild",
                            value: function (e) {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "removeChild", this).call(this, e), this.cache = {}
                            }
                        }, {
                            key: "split",
                            value: function (e) {
                                var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                if (n && (0 === e || e >= this.length() - 1)) {
                                    var i = this.clone();
                                    return 0 === e ? (this.parent.insertBefore(i, this), this) : (this.parent.insertBefore(i, this.next), i)
                                }
                                var o = r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "split", this).call(this, e, n);
                                return this.cache = {}, o
                            }
                        }]), t
                    }(s.default.Block);

                    function v(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        return null == e ? t : ("function" == typeof e.formats && (t = (0, o.default)(t, e.formats())), null == e.parent || "scroll" == e.parent.blotName || e.parent.statics.scope !== e.statics.scope ? t : v(e.parent, t))
                    }
                    m.blotName = "block", m.tagName = "P", m.defaultChild = "break", m.allowedChildren = [c.default, s.default.Embed, u.default], t.bubbleFormats = v, t.BlockEmbed = g, t.default = m
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.overload = t.expandConfig = void 0;
                    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                            return typeof e
                        } : function (e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        },
                        r = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }();
                    n(50);
                    var a = m(n(2)),
                        s = m(n(14)),
                        l = m(n(8)),
                        c = m(n(9)),
                        u = m(n(0)),
                        d = n(15),
                        h = m(d),
                        f = m(n(3)),
                        p = m(n(10)),
                        g = m(n(34));

                    function m(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function v(e, t, n) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e
                    }

                    function b(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }
                    var y = (0, p.default)("quill"),
                        _ = function () {
                            function e(t) {
                                var n = this,
                                    i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                if (b(this, e), this.options = x(t, i), this.container = this.options.container, null == this.container) return y.error("Invalid Quill container", t);
                                this.options.debug && e.debug(this.options.debug);
                                var r = this.container.innerHTML.trim();
                                this.container.classList.add("ql-container"), this.container.innerHTML = "", this.container.__quill = this, this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.root.setAttribute("data-gramm", !1), this.scrollingContainer = this.options.scrollingContainer || this.root, this.emitter = new l.default, this.scroll = u.default.create(this.root, {
                                    emitter: this.emitter,
                                    whitelist: this.options.formats
                                }), this.editor = new s.default(this.scroll), this.selection = new h.default(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.theme.init(), this.emitter.on(l.default.events.EDITOR_CHANGE, (function (e) {
                                    e === l.default.events.TEXT_CHANGE && n.root.classList.toggle("ql-blank", n.editor.isBlank())
                                })), this.emitter.on(l.default.events.SCROLL_UPDATE, (function (e, t) {
                                    var i = n.selection.lastRange,
                                        r = i && 0 === i.length ? i.index : void 0;
                                    w.call(n, (function () {
                                        return n.editor.update(null, t, r)
                                    }), e)
                                }));
                                var o = this.clipboard.convert("<div class='ql-editor' style=\"white-space: normal;\">" + r + "<p><br></p></div>");
                                this.setContents(o), this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable()
                            }
                            return o(e, null, [{
                                key: "debug",
                                value: function (e) {
                                    !0 === e && (e = "log"), p.default.level(e)
                                }
                            }, {
                                key: "find",
                                value: function (e) {
                                    return e.__quill || u.default.find(e)
                                }
                            }, {
                                key: "import",
                                value: function (e) {
                                    return null == this.imports[e] && y.error("Cannot import " + e + ". Are you sure it was registered?"), this.imports[e]
                                }
                            }, {
                                key: "register",
                                value: function (e, t) {
                                    var n = this,
                                        i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                                    if ("string" != typeof e) {
                                        var r = e.attrName || e.blotName;
                                        "string" == typeof r ? this.register("formats/" + r, e, t) : Object.keys(e).forEach((function (i) {
                                            n.register(i, e[i], t)
                                        }))
                                    } else null == this.imports[e] || i || y.warn("Overwriting " + e + " with", t), this.imports[e] = t, (e.startsWith("blots/") || e.startsWith("formats/")) && "abstract" !== t.blotName ? u.default.register(t) : e.startsWith("modules") && "function" == typeof t.register && t.register()
                                }
                            }]), o(e, [{
                                key: "addContainer",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                    if ("string" == typeof e) {
                                        var n = e;
                                        (e = document.createElement("div")).classList.add(n)
                                    }
                                    return this.container.insertBefore(e, t), e
                                }
                            }, {
                                key: "blur",
                                value: function () {
                                    this.selection.setRange(null)
                                }
                            }, {
                                key: "deleteText",
                                value: function (e, t, n) {
                                    var i = this,
                                        o = E(e, t, n),
                                        a = r(o, 4);
                                    return e = a[0], t = a[1], n = a[3], w.call(this, (function () {
                                        return i.editor.deleteText(e, t)
                                    }), n, e, -1 * t)
                                }
                            }, {
                                key: "disable",
                                value: function () {
                                    this.enable(!1)
                                }
                            }, {
                                key: "enable",
                                value: function () {
                                    var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                                    this.scroll.enable(e), this.container.classList.toggle("ql-disabled", !e)
                                }
                            }, {
                                key: "focus",
                                value: function () {
                                    var e = this.scrollingContainer.scrollTop;
                                    this.selection.focus(), this.scrollingContainer.scrollTop = e, this.scrollIntoView()
                                }
                            }, {
                                key: "format",
                                value: function (e, t) {
                                    var n = this,
                                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l.default.sources.API;
                                    return w.call(this, (function () {
                                        var i = n.getSelection(!0),
                                            r = new a.default;
                                        if (null == i) return r;
                                        if (u.default.query(e, u.default.Scope.BLOCK)) r = n.editor.formatLine(i.index, i.length, v({}, e, t));
                                        else {
                                            if (0 === i.length) return n.selection.format(e, t), r;
                                            r = n.editor.formatText(i.index, i.length, v({}, e, t))
                                        }
                                        return n.setSelection(i, l.default.sources.SILENT), r
                                    }), i)
                                }
                            }, {
                                key: "formatLine",
                                value: function (e, t, n, i, o) {
                                    var a, s = this,
                                        l = E(e, t, n, i, o),
                                        c = r(l, 4);
                                    return e = c[0], t = c[1], a = c[2], o = c[3], w.call(this, (function () {
                                        return s.editor.formatLine(e, t, a)
                                    }), o, e, 0)
                                }
                            }, {
                                key: "formatText",
                                value: function (e, t, n, i, o) {
                                    var a, s = this,
                                        l = E(e, t, n, i, o),
                                        c = r(l, 4);
                                    return e = c[0], t = c[1], a = c[2], o = c[3], w.call(this, (function () {
                                        return s.editor.formatText(e, t, a)
                                    }), o, e, 0)
                                }
                            }, {
                                key: "getBounds",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                                        n = void 0;
                                    n = "number" == typeof e ? this.selection.getBounds(e, t) : this.selection.getBounds(e.index, e.length);
                                    var i = this.container.getBoundingClientRect();
                                    return {
                                        bottom: n.bottom - i.top,
                                        height: n.height,
                                        left: n.left - i.left,
                                        right: n.right - i.left,
                                        top: n.top - i.top,
                                        width: n.width
                                    }
                                }
                            }, {
                                key: "getContents",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.getLength() - e,
                                        n = E(e, t),
                                        i = r(n, 2);
                                    return e = i[0], t = i[1], this.editor.getContents(e, t)
                                }
                            }, {
                                key: "getFormat",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.getSelection(!0),
                                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                                    return "number" == typeof e ? this.editor.getFormat(e, t) : this.editor.getFormat(e.index, e.length)
                                }
                            }, {
                                key: "getIndex",
                                value: function (e) {
                                    return e.offset(this.scroll)
                                }
                            }, {
                                key: "getLength",
                                value: function () {
                                    return this.scroll.length()
                                }
                            }, {
                                key: "getLeaf",
                                value: function (e) {
                                    return this.scroll.leaf(e)
                                }
                            }, {
                                key: "getLine",
                                value: function (e) {
                                    return this.scroll.line(e)
                                }
                            }, {
                                key: "getLines",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE;
                                    return "number" != typeof e ? this.scroll.lines(e.index, e.length) : this.scroll.lines(e, t)
                                }
                            }, {
                                key: "getModule",
                                value: function (e) {
                                    return this.theme.modules[e]
                                }
                            }, {
                                key: "getSelection",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                                    return e && this.focus(), this.update(), this.selection.getRange()[0]
                                }
                            }, {
                                key: "getText",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                                        t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.getLength() - e,
                                        n = E(e, t),
                                        i = r(n, 2);
                                    return e = i[0], t = i[1], this.editor.getText(e, t)
                                }
                            }, {
                                key: "hasFocus",
                                value: function () {
                                    return this.selection.hasFocus()
                                }
                            }, {
                                key: "insertEmbed",
                                value: function (t, n, i) {
                                    var r = this,
                                        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.sources.API;
                                    return w.call(this, (function () {
                                        return r.editor.insertEmbed(t, n, i)
                                    }), o, t)
                                }
                            }, {
                                key: "insertText",
                                value: function (e, t, n, i, o) {
                                    var a, s = this,
                                        l = E(e, 0, n, i, o),
                                        c = r(l, 4);
                                    return e = c[0], a = c[2], o = c[3], w.call(this, (function () {
                                        return s.editor.insertText(e, t, a)
                                    }), o, e, t.length)
                                }
                            }, {
                                key: "isEnabled",
                                value: function () {
                                    return !this.container.classList.contains("ql-disabled")
                                }
                            }, {
                                key: "off",
                                value: function () {
                                    return this.emitter.off.apply(this.emitter, arguments)
                                }
                            }, {
                                key: "on",
                                value: function () {
                                    return this.emitter.on.apply(this.emitter, arguments)
                                }
                            }, {
                                key: "once",
                                value: function () {
                                    return this.emitter.once.apply(this.emitter, arguments)
                                }
                            }, {
                                key: "pasteHTML",
                                value: function (e, t, n) {
                                    this.clipboard.dangerouslyPasteHTML(e, t, n)
                                }
                            }, {
                                key: "removeFormat",
                                value: function (e, t, n) {
                                    var i = this,
                                        o = E(e, t, n),
                                        a = r(o, 4);
                                    return e = a[0], t = a[1], n = a[3], w.call(this, (function () {
                                        return i.editor.removeFormat(e, t)
                                    }), n, e)
                                }
                            }, {
                                key: "scrollIntoView",
                                value: function () {
                                    this.selection.scrollIntoView(this.scrollingContainer)
                                }
                            }, {
                                key: "setContents",
                                value: function (e) {
                                    var t = this,
                                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.default.sources.API;
                                    return w.call(this, (function () {
                                        e = new a.default(e);
                                        var n = t.getLength(),
                                            i = t.editor.deleteText(0, n),
                                            r = t.editor.applyDelta(e),
                                            o = r.ops[r.ops.length - 1];
                                        return null != o && "string" == typeof o.insert && "\n" === o.insert[o.insert.length - 1] && (t.editor.deleteText(t.getLength() - 1, 1), r.delete(1)), i.compose(r)
                                    }), n)
                                }
                            }, {
                                key: "setSelection",
                                value: function (t, n, i) {
                                    if (null == t) this.selection.setRange(null, n || e.sources.API);
                                    else {
                                        var o = E(t, n, i),
                                            a = r(o, 4);
                                        t = a[0], n = a[1], i = a[3], this.selection.setRange(new d.Range(t, n), i), i !== l.default.sources.SILENT && this.selection.scrollIntoView(this.scrollingContainer)
                                    }
                                }
                            }, {
                                key: "setText",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.default.sources.API,
                                        n = (new a.default).insert(e);
                                    return this.setContents(n, t)
                                }
                            }, {
                                key: "update",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l.default.sources.USER,
                                        t = this.scroll.update(e);
                                    return this.selection.update(e), t
                                }
                            }, {
                                key: "updateContents",
                                value: function (e) {
                                    var t = this,
                                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.default.sources.API;
                                    return w.call(this, (function () {
                                        return e = new a.default(e), t.editor.applyDelta(e, n)
                                    }), n, !0)
                                }
                            }]), e
                        }();

                    function x(e, t) {
                        if ((t = (0, f.default)(!0, {
                                container: e,
                                modules: {
                                    clipboard: !0,
                                    keyboard: !0,
                                    history: !0
                                }
                            }, t)).theme && t.theme !== _.DEFAULTS.theme) {
                            if (t.theme = _.import("themes/" + t.theme), null == t.theme) throw new Error("Invalid theme " + t.theme + ". Did you register it?")
                        } else t.theme = g.default;
                        var n = (0, f.default)(!0, {}, t.theme.DEFAULTS);
                        [n, t].forEach((function (e) {
                            e.modules = e.modules || {}, Object.keys(e.modules).forEach((function (t) {
                                !0 === e.modules[t] && (e.modules[t] = {})
                            }))
                        }));
                        var i = Object.keys(n.modules).concat(Object.keys(t.modules)).reduce((function (e, t) {
                            var n = _.import("modules/" + t);
                            return null == n ? y.error("Cannot load " + t + " module. Are you sure you registered it?") : e[t] = n.DEFAULTS || {}, e
                        }), {});
                        return null != t.modules && t.modules.toolbar && t.modules.toolbar.constructor !== Object && (t.modules.toolbar = {
                            container: t.modules.toolbar
                        }), t = (0, f.default)(!0, {}, _.DEFAULTS, {
                            modules: i
                        }, n, t), ["bounds", "container", "scrollingContainer"].forEach((function (e) {
                            "string" == typeof t[e] && (t[e] = document.querySelector(t[e]))
                        })), t.modules = Object.keys(t.modules).reduce((function (e, n) {
                            return t.modules[n] && (e[n] = t.modules[n]), e
                        }), {}), t
                    }

                    function w(e, t, n, i) {
                        if (this.options.strict && !this.isEnabled() && t === l.default.sources.USER) return new a.default;
                        var r = null == n ? null : this.getSelection(),
                            o = this.editor.delta,
                            s = e();
                        if (null != r && (!0 === n && (n = r.index), null == i ? r = k(r, s, t) : 0 !== i && (r = k(r, n, i, t)), this.setSelection(r, l.default.sources.SILENT)), s.length() > 0) {
                            var c, u, d = [l.default.events.TEXT_CHANGE, s, o, t];
                            (c = this.emitter).emit.apply(c, [l.default.events.EDITOR_CHANGE].concat(d)), t !== l.default.sources.SILENT && (u = this.emitter).emit.apply(u, d)
                        }
                        return s
                    }

                    function E(e, t, n, r, o) {
                        var a = {};
                        return "number" == typeof e.index && "number" == typeof e.length ? "number" != typeof t ? (o = r, r = n, n = t, t = e.length, e = e.index) : (t = e.length, e = e.index) : "number" != typeof t && (o = r, r = n, n = t, t = 0), "object" === (void 0 === n ? "undefined" : i(n)) ? (a = n, o = r) : "string" == typeof n && (null != r ? a[n] = r : o = n), [e, t, a, o = o || l.default.sources.API]
                    }

                    function k(e, t, n, i) {
                        if (null == e) return null;
                        var o = void 0,
                            s = void 0;
                        if (t instanceof a.default) {
                            var c = [e.index, e.index + e.length].map((function (e) {
                                    return t.transformPosition(e, i !== l.default.sources.USER)
                                })),
                                u = r(c, 2);
                            o = u[0], s = u[1]
                        } else {
                            var h = [e.index, e.index + e.length].map((function (e) {
                                    return e < t || e === t && i === l.default.sources.USER ? e : n >= 0 ? e + n : Math.max(t, e + n)
                                })),
                                f = r(h, 2);
                            o = f[0], s = f[1]
                        }
                        return new d.Range(o, s - o)
                    }
                    _.DEFAULTS = {
                        bounds: null,
                        formats: null,
                        modules: {},
                        placeholder: "",
                        readOnly: !1,
                        scrollingContainer: null,
                        strict: !0,
                        theme: "default"
                    }, _.events = l.default.events, _.sources = l.default.sources, _.version = "1.3.7", _.imports = {
                        delta: a.default,
                        parchment: u.default,
                        "core/module": c.default,
                        "core/theme": g.default
                    }, t.expandConfig = x, t.overload = E, t.default = _
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = s(n(7)),
                        a = s(n(0));

                    function s(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function l(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function c(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var u = function (e) {
                        function t() {
                            return l(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), i(t, [{
                            key: "formatAt",
                            value: function (e, n, i, o) {
                                if (t.compare(this.statics.blotName, i) < 0 && a.default.query(i, a.default.Scope.BLOT)) {
                                    var s = this.isolate(e, n);
                                    o && s.wrap(i, o)
                                } else r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "formatAt", this).call(this, e, n, i, o)
                            }
                        }, {
                            key: "optimize",
                            value: function (e) {
                                if (r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e), this.parent instanceof t && t.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                                    var n = this.parent.isolate(this.offset(), this.length());
                                    this.moveChildren(n), n.wrap(this)
                                }
                            }
                        }], [{
                            key: "compare",
                            value: function (e, n) {
                                var i = t.order.indexOf(e),
                                    r = t.order.indexOf(n);
                                return i >= 0 || r >= 0 ? i - r : e === n ? 0 : e < n ? -1 : 1
                            }
                        }]), t
                    }(a.default.Inline);
                    u.allowedChildren = [u, a.default.Embed, o.default], u.order = ["cursor", "inline", "underline", "strike", "italic", "bold", "script", "link", "code"], t.default = u
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(0);

                    function o(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function a(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var s = function (e) {
                        function t() {
                            return o(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(((i = r) && i.__esModule ? i : {
                        default: i
                    }).default.Text);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = a(n(54));

                    function a(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var s = (0, a(n(10)).default)("quill:events");
                    ["selectionchange", "mousedown", "mouseup", "click"].forEach((function (e) {
                        document.addEventListener(e, (function () {
                            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                            [].slice.call(document.querySelectorAll(".ql-container")).forEach((function (e) {
                                var n;
                                e.__quill && e.__quill.emitter && (n = e.__quill.emitter).handleDOM.apply(n, t)
                            }))
                        }))
                    }));
                    var l = function (e) {
                        function t() {
                            ! function (e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, t);
                            var e = function (e, t) {
                                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return !t || "object" != typeof t && "function" != typeof t ? e : t
                            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                            return e.listeners = {}, e.on("error", s.error), e
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), i(t, [{
                            key: "emit",
                            value: function () {
                                s.log.apply(s, arguments), r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "emit", this).apply(this, arguments)
                            }
                        }, {
                            key: "handleDOM",
                            value: function (e) {
                                for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
                                (this.listeners[e.type] || []).forEach((function (t) {
                                    var i = t.node,
                                        r = t.handler;
                                    (e.target === i || i.contains(e.target)) && r.apply(void 0, [e].concat(n))
                                }))
                            }
                        }, {
                            key: "listenDOM",
                            value: function (e, t, n) {
                                this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push({
                                    node: t,
                                    handler: n
                                })
                            }
                        }]), t
                    }(o.default);
                    l.events = {
                        EDITOR_CHANGE: "editor-change",
                        SCROLL_BEFORE_UPDATE: "scroll-before-update",
                        SCROLL_OPTIMIZE: "scroll-optimize",
                        SCROLL_UPDATE: "scroll-update",
                        SELECTION_CHANGE: "selection-change",
                        TEXT_CHANGE: "text-change"
                    }, l.sources = {
                        API: "api",
                        SILENT: "silent",
                        USER: "user"
                    }, t.default = l
                }, function (e, t, n) {
                    "use strict";

                    function i(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var r = function e(t) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        i(this, e), this.quill = t, this.options = n
                    };
                    r.DEFAULTS = {}, t.default = r
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = ["error", "warn", "log", "info"],
                        r = "warn";

                    function o(e) {
                        if (i.indexOf(e) <= i.indexOf(r)) {
                            for (var t, n = arguments.length, o = Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) o[a - 1] = arguments[a];
                            (t = console)[e].apply(t, o)
                        }
                    }

                    function a(e) {
                        return i.reduce((function (t, n) {
                            return t[n] = o.bind(console, n, e), t
                        }), {})
                    }
                    o.level = a.level = function (e) {
                        r = e
                    }, t.default = a
                }, function (e, t, n) {
                    var i = Array.prototype.slice,
                        r = n(52),
                        o = n(53),
                        a = e.exports = function (e, t, n) {
                            return n || (n = {}), e === t || (e instanceof Date && t instanceof Date ? e.getTime() === t.getTime() : !e || !t || "object" != typeof e && "object" != typeof t ? n.strict ? e === t : e == t : function (e, t, n) {
                                var c, u;
                                if (s(e) || s(t)) return !1;
                                if (e.prototype !== t.prototype) return !1;
                                if (o(e)) return !!o(t) && (e = i.call(e), t = i.call(t), a(e, t, n));
                                if (l(e)) {
                                    if (!l(t)) return !1;
                                    if (e.length !== t.length) return !1;
                                    for (c = 0; c < e.length; c++)
                                        if (e[c] !== t[c]) return !1;
                                    return !0
                                }
                                try {
                                    var d = r(e),
                                        h = r(t)
                                } catch (e) {
                                    return !1
                                }
                                if (d.length != h.length) return !1;
                                for (d.sort(), h.sort(), c = d.length - 1; c >= 0; c--)
                                    if (d[c] != h[c]) return !1;
                                for (c = d.length - 1; c >= 0; c--)
                                    if (u = d[c], !a(e[u], t[u], n)) return !1;
                                return typeof e == typeof t
                            }(e, t, n))
                        };

                    function s(e) {
                        return null == e
                    }

                    function l(e) {
                        return !(!e || "object" != typeof e || "number" != typeof e.length || "function" != typeof e.copy || "function" != typeof e.slice || e.length > 0 && "number" != typeof e[0])
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(1),
                        r = function () {
                            function e(e, t, n) {
                                void 0 === n && (n = {}), this.attrName = e, this.keyName = t;
                                var r = i.Scope.TYPE & i.Scope.ATTRIBUTE;
                                null != n.scope ? this.scope = n.scope & i.Scope.LEVEL | r : this.scope = i.Scope.ATTRIBUTE, null != n.whitelist && (this.whitelist = n.whitelist)
                            }
                            return e.keys = function (e) {
                                return [].map.call(e.attributes, (function (e) {
                                    return e.name
                                }))
                            }, e.prototype.add = function (e, t) {
                                return !!this.canAdd(e, t) && (e.setAttribute(this.keyName, t), !0)
                            }, e.prototype.canAdd = function (e, t) {
                                return null != i.query(e, i.Scope.BLOT & (this.scope | i.Scope.TYPE)) && (null == this.whitelist || ("string" == typeof t ? this.whitelist.indexOf(t.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(t) > -1))
                            }, e.prototype.remove = function (e) {
                                e.removeAttribute(this.keyName)
                            }, e.prototype.value = function (e) {
                                var t = e.getAttribute(this.keyName);
                                return this.canAdd(e, t) && t ? t : ""
                            }, e
                        }();
                    t.default = r
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.Code = void 0;
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = d(n(2)),
                        s = d(n(0)),
                        l = d(n(4)),
                        c = d(n(6)),
                        u = d(n(7));

                    function d(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function h(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function f(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function p(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var g = function (e) {
                        function t() {
                            return h(this, t), f(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return p(t, e), t
                    }(c.default);
                    g.blotName = "code", g.tagName = "CODE";
                    var m = function (e) {
                        function t() {
                            return h(this, t), f(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return p(t, e), r(t, [{
                            key: "delta",
                            value: function () {
                                var e = this,
                                    t = this.domNode.textContent;
                                return t.endsWith("\n") && (t = t.slice(0, -1)), t.split("\n").reduce((function (t, n) {
                                    return t.insert(n).insert("\n", e.formats())
                                }), new a.default)
                            }
                        }, {
                            key: "format",
                            value: function (e, n) {
                                if (e !== this.statics.blotName || !n) {
                                    var r = this.descendant(u.default, this.length() - 1),
                                        a = i(r, 1)[0];
                                    null != a && a.deleteAt(a.length() - 1, 1), o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n)
                                }
                            }
                        }, {
                            key: "formatAt",
                            value: function (e, n, i, r) {
                                if (0 !== n && null != s.default.query(i, s.default.Scope.BLOCK) && (i !== this.statics.blotName || r !== this.statics.formats(this.domNode))) {
                                    var o = this.newlineIndex(e);
                                    if (!(o < 0 || o >= e + n)) {
                                        var a = this.newlineIndex(e, !0) + 1,
                                            l = o - a + 1,
                                            c = this.isolate(a, l),
                                            u = c.next;
                                        c.format(i, r), u instanceof t && u.formatAt(0, e - a + n - l, i, r)
                                    }
                                }
                            }
                        }, {
                            key: "insertAt",
                            value: function (e, t, n) {
                                if (null == n) {
                                    var r = this.descendant(u.default, e),
                                        o = i(r, 2),
                                        a = o[0],
                                        s = o[1];
                                    a.insertAt(s, t)
                                }
                            }
                        }, {
                            key: "length",
                            value: function () {
                                var e = this.domNode.textContent.length;
                                return this.domNode.textContent.endsWith("\n") ? e : e + 1
                            }
                        }, {
                            key: "newlineIndex",
                            value: function (e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                if (t) return this.domNode.textContent.slice(0, e).lastIndexOf("\n");
                                var n = this.domNode.textContent.slice(e).indexOf("\n");
                                return n > -1 ? e + n : -1
                            }
                        }, {
                            key: "optimize",
                            value: function (e) {
                                this.domNode.textContent.endsWith("\n") || this.appendChild(s.default.create("text", "\n")), o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e);
                                var n = this.next;
                                null != n && n.prev === this && n.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === n.statics.formats(n.domNode) && (n.optimize(e), n.moveChildren(this), n.remove())
                            }
                        }, {
                            key: "replace",
                            value: function (e) {
                                o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "replace", this).call(this, e), [].slice.call(this.domNode.querySelectorAll("*")).forEach((function (e) {
                                    var t = s.default.find(e);
                                    null == t ? e.parentNode.removeChild(e) : t instanceof s.default.Embed ? t.remove() : t.unwrap()
                                }))
                            }
                        }], [{
                            key: "create",
                            value: function (e) {
                                var n = o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e);
                                return n.setAttribute("spellcheck", !1), n
                            }
                        }, {
                            key: "formats",
                            value: function () {
                                return !0
                            }
                        }]), t
                    }(l.default);
                    m.blotName = "code-block", m.tagName = "PRE", m.TAB = "  ", t.Code = g, t.default = m
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                            return typeof e
                        } : function (e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        },
                        r = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        a = v(n(2)),
                        s = v(n(20)),
                        l = v(n(0)),
                        c = v(n(13)),
                        u = v(n(24)),
                        d = n(4),
                        h = v(d),
                        f = v(n(16)),
                        p = v(n(21)),
                        g = v(n(11)),
                        m = v(n(3));

                    function v(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var b = /^[ -~]*$/,
                        y = function () {
                            function e(t) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, e), this.scroll = t, this.delta = this.getDelta()
                            }
                            return o(e, [{
                                key: "applyDelta",
                                value: function (e) {
                                    var t = this,
                                        n = !1;
                                    this.scroll.update();
                                    var o = this.scroll.length();
                                    return this.scroll.batchStart(), (e = function (e) {
                                        return e.reduce((function (e, t) {
                                            if (1 === t.insert) {
                                                var n = (0, p.default)(t.attributes);
                                                return delete n.image, e.insert({
                                                    image: t.attributes.image
                                                }, n)
                                            }
                                            if (null == t.attributes || !0 !== t.attributes.list && !0 !== t.attributes.bullet || ((t = (0, p.default)(t)).attributes.list ? t.attributes.list = "ordered" : (t.attributes.list = "bullet", delete t.attributes.bullet)), "string" == typeof t.insert) {
                                                var i = t.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                                                return e.insert(i, t.attributes)
                                            }
                                            return e.push(t)
                                        }), new a.default)
                                    }(e)).reduce((function (e, a) {
                                        var c = a.retain || a.delete || a.insert.length || 1,
                                            u = a.attributes || {};
                                        if (null != a.insert) {
                                            if ("string" == typeof a.insert) {
                                                var f = a.insert;
                                                f.endsWith("\n") && n && (n = !1, f = f.slice(0, -1)), e >= o && !f.endsWith("\n") && (n = !0), t.scroll.insertAt(e, f);
                                                var p = t.scroll.line(e),
                                                    g = r(p, 2),
                                                    v = g[0],
                                                    b = g[1],
                                                    y = (0, m.default)({}, (0, d.bubbleFormats)(v));
                                                if (v instanceof h.default) {
                                                    var _ = v.descendant(l.default.Leaf, b),
                                                        x = r(_, 1)[0];
                                                    y = (0, m.default)(y, (0, d.bubbleFormats)(x))
                                                }
                                                u = s.default.attributes.diff(y, u) || {}
                                            } else if ("object" === i(a.insert)) {
                                                var w = Object.keys(a.insert)[0];
                                                if (null == w) return e;
                                                t.scroll.insertAt(e, w, a.insert[w])
                                            }
                                            o += c
                                        }
                                        return Object.keys(u).forEach((function (n) {
                                            t.scroll.formatAt(e, c, n, u[n])
                                        })), e + c
                                    }), 0), e.reduce((function (e, n) {
                                        return "number" == typeof n.delete ? (t.scroll.deleteAt(e, n.delete), e) : e + (n.retain || n.insert.length || 1)
                                    }), 0), this.scroll.batchEnd(), this.update(e)
                                }
                            }, {
                                key: "deleteText",
                                value: function (e, t) {
                                    return this.scroll.deleteAt(e, t), this.update((new a.default).retain(e).delete(t))
                                }
                            }, {
                                key: "formatLine",
                                value: function (e, t) {
                                    var n = this,
                                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return this.scroll.update(), Object.keys(i).forEach((function (r) {
                                        if (null == n.scroll.whitelist || n.scroll.whitelist[r]) {
                                            var o = n.scroll.lines(e, Math.max(t, 1)),
                                                a = t;
                                            o.forEach((function (t) {
                                                var o = t.length();
                                                if (t instanceof c.default) {
                                                    var s = e - t.offset(n.scroll),
                                                        l = t.newlineIndex(s + a) - s + 1;
                                                    t.formatAt(s, l, r, i[r])
                                                } else t.format(r, i[r]);
                                                a -= o
                                            }))
                                        }
                                    })), this.scroll.optimize(), this.update((new a.default).retain(e).retain(t, (0, p.default)(i)))
                                }
                            }, {
                                key: "formatText",
                                value: function (e, t) {
                                    var n = this,
                                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return Object.keys(i).forEach((function (r) {
                                        n.scroll.formatAt(e, t, r, i[r])
                                    })), this.update((new a.default).retain(e).retain(t, (0, p.default)(i)))
                                }
                            }, {
                                key: "getContents",
                                value: function (e, t) {
                                    return this.delta.slice(e, e + t)
                                }
                            }, {
                                key: "getDelta",
                                value: function () {
                                    return this.scroll.lines().reduce((function (e, t) {
                                        return e.concat(t.delta())
                                    }), new a.default)
                                }
                            }, {
                                key: "getFormat",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                                        n = [],
                                        i = [];
                                    0 === t ? this.scroll.path(e).forEach((function (e) {
                                        var t = r(e, 1)[0];
                                        t instanceof h.default ? n.push(t) : t instanceof l.default.Leaf && i.push(t)
                                    })) : (n = this.scroll.lines(e, t), i = this.scroll.descendants(l.default.Leaf, e, t));
                                    var o = [n, i].map((function (e) {
                                        if (0 === e.length) return {};
                                        for (var t = (0, d.bubbleFormats)(e.shift()); Object.keys(t).length > 0;) {
                                            var n = e.shift();
                                            if (null == n) return t;
                                            t = _((0, d.bubbleFormats)(n), t)
                                        }
                                        return t
                                    }));
                                    return m.default.apply(m.default, o)
                                }
                            }, {
                                key: "getText",
                                value: function (e, t) {
                                    return this.getContents(e, t).filter((function (e) {
                                        return "string" == typeof e.insert
                                    })).map((function (e) {
                                        return e.insert
                                    })).join("")
                                }
                            }, {
                                key: "insertEmbed",
                                value: function (e, t, n) {
                                    return this.scroll.insertAt(e, t, n), this.update((new a.default).retain(e).insert(function (e, t, n) {
                                        return t in e ? Object.defineProperty(e, t, {
                                            value: n,
                                            enumerable: !0,
                                            configurable: !0,
                                            writable: !0
                                        }) : e[t] = n, e
                                    }({}, t, n)))
                                }
                            }, {
                                key: "insertText",
                                value: function (e, t) {
                                    var n = this,
                                        i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                                    return t = t.replace(/\r\n/g, "\n").replace(/\r/g, "\n"), this.scroll.insertAt(e, t), Object.keys(i).forEach((function (r) {
                                        n.scroll.formatAt(e, t.length, r, i[r])
                                    })), this.update((new a.default).retain(e).insert(t, (0, p.default)(i)))
                                }
                            }, {
                                key: "isBlank",
                                value: function () {
                                    if (0 == this.scroll.children.length) return !0;
                                    if (this.scroll.children.length > 1) return !1;
                                    var e = this.scroll.children.head;
                                    return e.statics.blotName === h.default.blotName && !(e.children.length > 1) && e.children.head instanceof f.default
                                }
                            }, {
                                key: "removeFormat",
                                value: function (e, t) {
                                    var n = this.getText(e, t),
                                        i = this.scroll.line(e + t),
                                        o = r(i, 2),
                                        s = o[0],
                                        l = o[1],
                                        u = 0,
                                        d = new a.default;
                                    null != s && (u = s instanceof c.default ? s.newlineIndex(l) - l + 1 : s.length() - l, d = s.delta().slice(l, l + u - 1).insert("\n"));
                                    var h = this.getContents(e, t + u).diff((new a.default).insert(n).concat(d)),
                                        f = (new a.default).retain(e).concat(h);
                                    return this.applyDelta(f)
                                }
                            }, {
                                key: "update",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0,
                                        i = this.delta;
                                    if (1 === t.length && "characterData" === t[0].type && t[0].target.data.match(b) && l.default.find(t[0].target)) {
                                        var r = l.default.find(t[0].target),
                                            o = (0, d.bubbleFormats)(r),
                                            s = r.offset(this.scroll),
                                            c = t[0].oldValue.replace(u.default.CONTENTS, ""),
                                            h = (new a.default).insert(c),
                                            f = (new a.default).insert(r.value()),
                                            p = (new a.default).retain(s).concat(h.diff(f, n));
                                        e = p.reduce((function (e, t) {
                                            return t.insert ? e.insert(t.insert, o) : e.push(t)
                                        }), new a.default), this.delta = i.compose(e)
                                    } else this.delta = this.getDelta(), e && (0, g.default)(i.compose(e), this.delta) || (e = i.diff(this.delta, n));
                                    return e
                                }
                            }]), e
                        }();

                    function _(e, t) {
                        return Object.keys(t).reduce((function (n, i) {
                            return null == e[i] || (t[i] === e[i] ? n[i] = t[i] : Array.isArray(t[i]) ? t[i].indexOf(e[i]) < 0 && (n[i] = t[i].concat([e[i]])) : n[i] = [t[i], e[i]]), n
                        }), {})
                    }
                    t.default = y
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.Range = void 0;
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = c(n(0)),
                        a = c(n(21)),
                        s = c(n(11)),
                        l = c(n(8));

                    function c(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function u(e) {
                        if (Array.isArray(e)) {
                            for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                            return n
                        }
                        return Array.from(e)
                    }

                    function d(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }
                    var h = (0, c(n(10)).default)("quill:selection"),
                        f = function e(t) {
                            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                            d(this, e), this.index = t, this.length = n
                        },
                        p = function () {
                            function e(t, n) {
                                var i = this;
                                d(this, e), this.emitter = n, this.scroll = t, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = o.default.create("cursor", this), this.lastRange = this.savedRange = new f(0, 0), this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, (function () {
                                    i.mouseDown || setTimeout(i.update.bind(i, l.default.sources.USER), 1)
                                })), this.emitter.on(l.default.events.EDITOR_CHANGE, (function (e, t) {
                                    e === l.default.events.TEXT_CHANGE && t.length() > 0 && i.update(l.default.sources.SILENT)
                                })), this.emitter.on(l.default.events.SCROLL_BEFORE_UPDATE, (function () {
                                    if (i.hasFocus()) {
                                        var e = i.getNativeRange();
                                        null != e && e.start.node !== i.cursor.textNode && i.emitter.once(l.default.events.SCROLL_UPDATE, (function () {
                                            try {
                                                i.setNativeRange(e.start.node, e.start.offset, e.end.node, e.end.offset)
                                            } catch (e) {}
                                        }))
                                    }
                                })), this.emitter.on(l.default.events.SCROLL_OPTIMIZE, (function (e, t) {
                                    if (t.range) {
                                        var n = t.range,
                                            r = n.startNode,
                                            o = n.startOffset,
                                            a = n.endNode,
                                            s = n.endOffset;
                                        i.setNativeRange(r, o, a, s)
                                    }
                                })), this.update(l.default.sources.SILENT)
                            }
                            return r(e, [{
                                key: "handleComposition",
                                value: function () {
                                    var e = this;
                                    this.root.addEventListener("compositionstart", (function () {
                                        e.composing = !0
                                    })), this.root.addEventListener("compositionend", (function () {
                                        if (e.composing = !1, e.cursor.parent) {
                                            var t = e.cursor.restore();
                                            if (!t) return;
                                            setTimeout((function () {
                                                e.setNativeRange(t.startNode, t.startOffset, t.endNode, t.endOffset)
                                            }), 1)
                                        }
                                    }))
                                }
                            }, {
                                key: "handleDragging",
                                value: function () {
                                    var e = this;
                                    this.emitter.listenDOM("mousedown", document.body, (function () {
                                        e.mouseDown = !0
                                    })), this.emitter.listenDOM("mouseup", document.body, (function () {
                                        e.mouseDown = !1, e.update(l.default.sources.USER)
                                    }))
                                }
                            }, {
                                key: "focus",
                                value: function () {
                                    this.hasFocus() || (this.root.focus(), this.setRange(this.savedRange))
                                }
                            }, {
                                key: "format",
                                value: function (e, t) {
                                    if (null == this.scroll.whitelist || this.scroll.whitelist[e]) {
                                        this.scroll.update();
                                        var n = this.getNativeRange();
                                        if (null != n && n.native.collapsed && !o.default.query(e, o.default.Scope.BLOCK)) {
                                            if (n.start.node !== this.cursor.textNode) {
                                                var i = o.default.find(n.start.node, !1);
                                                if (null == i) return;
                                                if (i instanceof o.default.Leaf) {
                                                    var r = i.split(n.start.offset);
                                                    i.parent.insertBefore(this.cursor, r)
                                                } else i.insertBefore(this.cursor, n.start.node);
                                                this.cursor.attach()
                                            }
                                            this.cursor.format(e, t), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update()
                                        }
                                    }
                                }
                            }, {
                                key: "getBounds",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                                        n = this.scroll.length();
                                    e = Math.min(e, n - 1), t = Math.min(e + t, n - 1) - e;
                                    var r = void 0,
                                        o = this.scroll.leaf(e),
                                        a = i(o, 2),
                                        s = a[0],
                                        l = a[1];
                                    if (null == s) return null;
                                    var c = s.position(l, !0),
                                        u = i(c, 2);
                                    r = u[0], l = u[1];
                                    var d = document.createRange();
                                    if (t > 0) {
                                        d.setStart(r, l);
                                        var h = this.scroll.leaf(e + t),
                                            f = i(h, 2);
                                        if (s = f[0], l = f[1], null == s) return null;
                                        var p = s.position(l, !0),
                                            g = i(p, 2);
                                        return r = g[0], l = g[1], d.setEnd(r, l), d.getBoundingClientRect()
                                    }
                                    var m = "left",
                                        v = void 0;
                                    return r instanceof Text ? (l < r.data.length ? (d.setStart(r, l), d.setEnd(r, l + 1)) : (d.setStart(r, l - 1), d.setEnd(r, l), m = "right"), v = d.getBoundingClientRect()) : (v = s.domNode.getBoundingClientRect(), l > 0 && (m = "right")), {
                                        bottom: v.top + v.height,
                                        height: v.height,
                                        left: v[m],
                                        right: v[m],
                                        top: v.top,
                                        width: 0
                                    }
                                }
                            }, {
                                key: "getNativeRange",
                                value: function () {
                                    var e = document.getSelection();
                                    if (null == e || e.rangeCount <= 0) return null;
                                    var t = e.getRangeAt(0);
                                    if (null == t) return null;
                                    var n = this.normalizeNative(t);
                                    return h.info("getNativeRange", n), n
                                }
                            }, {
                                key: "getRange",
                                value: function () {
                                    var e = this.getNativeRange();
                                    return null == e ? [null, null] : [this.normalizedToRange(e), e]
                                }
                            }, {
                                key: "hasFocus",
                                value: function () {
                                    return document.activeElement === this.root
                                }
                            }, {
                                key: "normalizedToRange",
                                value: function (e) {
                                    var t = this,
                                        n = [
                                            [e.start.node, e.start.offset]
                                        ];
                                    e.native.collapsed || n.push([e.end.node, e.end.offset]);
                                    var r = n.map((function (e) {
                                            var n = i(e, 2),
                                                r = n[0],
                                                a = n[1],
                                                s = o.default.find(r, !0),
                                                l = s.offset(t.scroll);
                                            return 0 === a ? l : s instanceof o.default.Container ? l + s.length() : l + s.index(r, a)
                                        })),
                                        a = Math.min(Math.max.apply(Math, u(r)), this.scroll.length() - 1),
                                        s = Math.min.apply(Math, [a].concat(u(r)));
                                    return new f(s, a - s)
                                }
                            }, {
                                key: "normalizeNative",
                                value: function (e) {
                                    if (!g(this.root, e.startContainer) || !e.collapsed && !g(this.root, e.endContainer)) return null;
                                    var t = {
                                        start: {
                                            node: e.startContainer,
                                            offset: e.startOffset
                                        },
                                        end: {
                                            node: e.endContainer,
                                            offset: e.endOffset
                                        },
                                        native: e
                                    };
                                    return [t.start, t.end].forEach((function (e) {
                                        for (var t = e.node, n = e.offset; !(t instanceof Text) && t.childNodes.length > 0;)
                                            if (t.childNodes.length > n) t = t.childNodes[n], n = 0;
                                            else {
                                                if (t.childNodes.length !== n) break;
                                                n = (t = t.lastChild) instanceof Text ? t.data.length : t.childNodes.length + 1
                                            } e.node = t, e.offset = n
                                    })), t
                                }
                            }, {
                                key: "rangeToNative",
                                value: function (e) {
                                    var t = this,
                                        n = e.collapsed ? [e.index] : [e.index, e.index + e.length],
                                        r = [],
                                        o = this.scroll.length();
                                    return n.forEach((function (e, n) {
                                        e = Math.min(o - 1, e);
                                        var a, s = t.scroll.leaf(e),
                                            l = i(s, 2),
                                            c = l[0],
                                            u = l[1],
                                            d = c.position(u, 0 !== n),
                                            h = i(d, 2);
                                        a = h[0], u = h[1], r.push(a, u)
                                    })), r.length < 2 && (r = r.concat(r)), r
                                }
                            }, {
                                key: "scrollIntoView",
                                value: function (e) {
                                    var t = this.lastRange;
                                    if (null != t) {
                                        var n = this.getBounds(t.index, t.length);
                                        if (null != n) {
                                            var r = this.scroll.length() - 1,
                                                o = this.scroll.line(Math.min(t.index, r)),
                                                a = i(o, 1)[0],
                                                s = a;
                                            if (t.length > 0) {
                                                var l = this.scroll.line(Math.min(t.index + t.length, r));
                                                s = i(l, 1)[0]
                                            }
                                            if (null != a && null != s) {
                                                var c = e.getBoundingClientRect();
                                                n.top < c.top ? e.scrollTop -= c.top - n.top : n.bottom > c.bottom && (e.scrollTop += n.bottom - c.bottom)
                                            }
                                        }
                                    }
                                }
                            }, {
                                key: "setNativeRange",
                                value: function (e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e,
                                        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t,
                                        r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                                    if (h.info("setNativeRange", e, t, n, i), null == e || null != this.root.parentNode && null != e.parentNode && null != n.parentNode) {
                                        var o = document.getSelection();
                                        if (null != o)
                                            if (null != e) {
                                                this.hasFocus() || this.root.focus();
                                                var a = (this.getNativeRange() || {}).native;
                                                if (null == a || r || e !== a.startContainer || t !== a.startOffset || n !== a.endContainer || i !== a.endOffset) {
                                                    "BR" == e.tagName && (t = [].indexOf.call(e.parentNode.childNodes, e), e = e.parentNode), "BR" == n.tagName && (i = [].indexOf.call(n.parentNode.childNodes, n), n = n.parentNode);
                                                    var s = document.createRange();
                                                    s.setStart(e, t), s.setEnd(n, i), o.removeAllRanges(), o.addRange(s)
                                                }
                                            } else o.removeAllRanges(), this.root.blur(), document.body.focus()
                                    }
                                }
                            }, {
                                key: "setRange",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l.default.sources.API;
                                    if ("string" == typeof t && (n = t, t = !1), h.info("setRange", e), null != e) {
                                        var i = this.rangeToNative(e);
                                        this.setNativeRange.apply(this, u(i).concat([t]))
                                    } else this.setNativeRange(null);
                                    this.update(n)
                                }
                            }, {
                                key: "update",
                                value: function () {
                                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l.default.sources.USER,
                                        t = this.lastRange,
                                        n = this.getRange(),
                                        r = i(n, 2),
                                        o = r[0],
                                        c = r[1];
                                    if (this.lastRange = o, null != this.lastRange && (this.savedRange = this.lastRange), !(0, s.default)(t, this.lastRange)) {
                                        var u;
                                        !this.composing && null != c && c.native.collapsed && c.start.node !== this.cursor.textNode && this.cursor.restore();
                                        var d, h = [l.default.events.SELECTION_CHANGE, (0, a.default)(this.lastRange), (0, a.default)(t), e];
                                        (u = this.emitter).emit.apply(u, [l.default.events.EDITOR_CHANGE].concat(h)), e !== l.default.sources.SILENT && (d = this.emitter).emit.apply(d, h)
                                    }
                                }
                            }]), e
                        }();

                    function g(e, t) {
                        try {
                            t.parentNode
                        } catch (e) {
                            return !1
                        }
                        return t instanceof Text && (t = t.parentNode), e.contains(t)
                    }
                    t.Range = f, t.default = p
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(0);

                    function s(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function l(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var c = function (e) {
                        function t() {
                            return s(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, [{
                            key: "insertInto",
                            value: function (e, n) {
                                0 === e.children.length ? o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertInto", this).call(this, e, n) : this.remove()
                            }
                        }, {
                            key: "length",
                            value: function () {
                                return 0
                            }
                        }, {
                            key: "value",
                            value: function () {
                                return ""
                            }
                        }], [{
                            key: "value",
                            value: function () {}
                        }]), t
                    }(((i = a) && i.__esModule ? i : {
                        default: i
                    }).default.Embed);
                    c.blotName = "break", c.tagName = "BR", t.default = c
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(44),
                        a = n(30),
                        s = n(1),
                        l = function (e) {
                            function t(t) {
                                var n = e.call(this, t) || this;
                                return n.build(), n
                            }
                            return r(t, e), t.prototype.appendChild = function (e) {
                                this.insertBefore(e)
                            }, t.prototype.attach = function () {
                                e.prototype.attach.call(this), this.children.forEach((function (e) {
                                    e.attach()
                                }))
                            }, t.prototype.build = function () {
                                var e = this;
                                this.children = new o.default, [].slice.call(this.domNode.childNodes).reverse().forEach((function (t) {
                                    try {
                                        var n = c(t);
                                        e.insertBefore(n, e.children.head || void 0)
                                    } catch (e) {
                                        if (e instanceof s.ParchmentError) return;
                                        throw e
                                    }
                                }))
                            }, t.prototype.deleteAt = function (e, t) {
                                if (0 === e && t === this.length()) return this.remove();
                                this.children.forEachAt(e, t, (function (e, t, n) {
                                    e.deleteAt(t, n)
                                }))
                            }, t.prototype.descendant = function (e, n) {
                                var i = this.children.find(n),
                                    r = i[0],
                                    o = i[1];
                                return null == e.blotName && e(r) || null != e.blotName && r instanceof e ? [r, o] : r instanceof t ? r.descendant(e, o) : [null, -1]
                            }, t.prototype.descendants = function (e, n, i) {
                                void 0 === n && (n = 0), void 0 === i && (i = Number.MAX_VALUE);
                                var r = [],
                                    o = i;
                                return this.children.forEachAt(n, i, (function (n, i, a) {
                                    (null == e.blotName && e(n) || null != e.blotName && n instanceof e) && r.push(n), n instanceof t && (r = r.concat(n.descendants(e, i, o))), o -= a
                                })), r
                            }, t.prototype.detach = function () {
                                this.children.forEach((function (e) {
                                    e.detach()
                                })), e.prototype.detach.call(this)
                            }, t.prototype.formatAt = function (e, t, n, i) {
                                this.children.forEachAt(e, t, (function (e, t, r) {
                                    e.formatAt(t, r, n, i)
                                }))
                            }, t.prototype.insertAt = function (e, t, n) {
                                var i = this.children.find(e),
                                    r = i[0],
                                    o = i[1];
                                if (r) r.insertAt(o, t, n);
                                else {
                                    var a = null == n ? s.create("text", t) : s.create(t, n);
                                    this.appendChild(a)
                                }
                            }, t.prototype.insertBefore = function (e, t) {
                                if (null != this.statics.allowedChildren && !this.statics.allowedChildren.some((function (t) {
                                        return e instanceof t
                                    }))) throw new s.ParchmentError("Cannot insert " + e.statics.blotName + " into " + this.statics.blotName);
                                e.insertInto(this, t)
                            }, t.prototype.length = function () {
                                return this.children.reduce((function (e, t) {
                                    return e + t.length()
                                }), 0)
                            }, t.prototype.moveChildren = function (e, t) {
                                this.children.forEach((function (n) {
                                    e.insertBefore(n, t)
                                }))
                            }, t.prototype.optimize = function (t) {
                                if (e.prototype.optimize.call(this, t), 0 === this.children.length)
                                    if (null != this.statics.defaultChild) {
                                        var n = s.create(this.statics.defaultChild);
                                        this.appendChild(n), n.optimize(t)
                                    } else this.remove()
                            }, t.prototype.path = function (e, n) {
                                void 0 === n && (n = !1);
                                var i = this.children.find(e, n),
                                    r = i[0],
                                    o = i[1],
                                    a = [
                                        [this, e]
                                    ];
                                return r instanceof t ? a.concat(r.path(o, n)) : (null != r && a.push([r, o]), a)
                            }, t.prototype.removeChild = function (e) {
                                this.children.remove(e)
                            }, t.prototype.replace = function (n) {
                                n instanceof t && n.moveChildren(this), e.prototype.replace.call(this, n)
                            }, t.prototype.split = function (e, t) {
                                if (void 0 === t && (t = !1), !t) {
                                    if (0 === e) return this;
                                    if (e === this.length()) return this.next
                                }
                                var n = this.clone();
                                return this.parent.insertBefore(n, this.next), this.children.forEachAt(e, this.length(), (function (e, i, r) {
                                    e = e.split(i, t), n.appendChild(e)
                                })), n
                            }, t.prototype.unwrap = function () {
                                this.moveChildren(this.parent, this.next), this.remove()
                            }, t.prototype.update = function (e, t) {
                                var n = this,
                                    i = [],
                                    r = [];
                                e.forEach((function (e) {
                                    e.target === n.domNode && "childList" === e.type && (i.push.apply(i, e.addedNodes), r.push.apply(r, e.removedNodes))
                                })), r.forEach((function (e) {
                                    if (!(null != e.parentNode && "IFRAME" !== e.tagName && document.body.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_CONTAINED_BY)) {
                                        var t = s.find(e);
                                        null != t && (null != t.domNode.parentNode && t.domNode.parentNode !== n.domNode || t.detach())
                                    }
                                })), i.filter((function (e) {
                                    return e.parentNode == n.domNode
                                })).sort((function (e, t) {
                                    return e === t ? 0 : e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1
                                })).forEach((function (e) {
                                    var t = null;
                                    null != e.nextSibling && (t = s.find(e.nextSibling));
                                    var i = c(e);
                                    i.next == t && null != i.next || (null != i.parent && i.parent.removeChild(n), n.insertBefore(i, t || void 0))
                                }))
                            }, t
                        }(a.default);

                    function c(e) {
                        var t = s.find(e);
                        if (null == t) try {
                            t = s.create(e)
                        } catch (n) {
                            t = s.create(s.Scope.INLINE), [].slice.call(e.childNodes).forEach((function (e) {
                                t.domNode.appendChild(e)
                            })), e.parentNode && e.parentNode.replaceChild(t.domNode, e), t.attach()
                        }
                        return t
                    }
                    t.default = l
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(12),
                        a = n(31),
                        s = n(17),
                        l = n(1),
                        c = function (e) {
                            function t(t) {
                                var n = e.call(this, t) || this;
                                return n.attributes = new a.default(n.domNode), n
                            }
                            return r(t, e), t.formats = function (e) {
                                return "string" == typeof this.tagName || (Array.isArray(this.tagName) ? e.tagName.toLowerCase() : void 0)
                            }, t.prototype.format = function (e, t) {
                                var n = l.query(e);
                                n instanceof o.default ? this.attributes.attribute(n, t) : t && (null == n || e === this.statics.blotName && this.formats()[e] === t || this.replaceWith(e, t))
                            }, t.prototype.formats = function () {
                                var e = this.attributes.values(),
                                    t = this.statics.formats(this.domNode);
                                return null != t && (e[this.statics.blotName] = t), e
                            }, t.prototype.replaceWith = function (t, n) {
                                var i = e.prototype.replaceWith.call(this, t, n);
                                return this.attributes.copy(i), i
                            }, t.prototype.update = function (t, n) {
                                var i = this;
                                e.prototype.update.call(this, t, n), t.some((function (e) {
                                    return e.target === i.domNode && "attributes" === e.type
                                })) && this.attributes.build()
                            }, t.prototype.wrap = function (n, i) {
                                var r = e.prototype.wrap.call(this, n, i);
                                return r instanceof t && r.statics.scope === this.statics.scope && this.attributes.move(r), r
                            }, t
                        }(s.default);
                    t.default = c
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(30),
                        a = n(1),
                        s = function (e) {
                            function t() {
                                return null !== e && e.apply(this, arguments) || this
                            }
                            return r(t, e), t.value = function (e) {
                                return !0
                            }, t.prototype.index = function (e, t) {
                                return this.domNode === e || this.domNode.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(t, 1) : -1
                            }, t.prototype.position = function (e, t) {
                                var n = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                                return e > 0 && (n += 1), [this.parent.domNode, n]
                            }, t.prototype.value = function () {
                                var e;
                                return (e = {})[this.statics.blotName] = this.statics.value(this.domNode) || !0, e
                            }, t.scope = a.Scope.INLINE_BLOT, t
                        }(o.default);
                    t.default = s
                }, function (e, t, n) {
                    var i = n(11),
                        r = n(3),
                        o = {
                            attributes: {
                                compose: function (e, t, n) {
                                    "object" != typeof e && (e = {}), "object" != typeof t && (t = {});
                                    var i = r(!0, {}, t);
                                    for (var o in n || (i = Object.keys(i).reduce((function (e, t) {
                                            return null != i[t] && (e[t] = i[t]), e
                                        }), {})), e) void 0 !== e[o] && void 0 === t[o] && (i[o] = e[o]);
                                    return Object.keys(i).length > 0 ? i : void 0
                                },
                                diff: function (e, t) {
                                    "object" != typeof e && (e = {}), "object" != typeof t && (t = {});
                                    var n = Object.keys(e).concat(Object.keys(t)).reduce((function (n, r) {
                                        return i(e[r], t[r]) || (n[r] = void 0 === t[r] ? null : t[r]), n
                                    }), {});
                                    return Object.keys(n).length > 0 ? n : void 0
                                },
                                transform: function (e, t, n) {
                                    if ("object" != typeof e) return t;
                                    if ("object" == typeof t) {
                                        if (!n) return t;
                                        var i = Object.keys(t).reduce((function (n, i) {
                                            return void 0 === e[i] && (n[i] = t[i]), n
                                        }), {});
                                        return Object.keys(i).length > 0 ? i : void 0
                                    }
                                }
                            },
                            iterator: function (e) {
                                return new a(e)
                            },
                            length: function (e) {
                                return "number" == typeof e.delete ? e.delete : "number" == typeof e.retain ? e.retain : "string" == typeof e.insert ? e.insert.length : 1
                            }
                        };

                    function a(e) {
                        this.ops = e, this.index = 0, this.offset = 0
                    }
                    a.prototype.hasNext = function () {
                        return this.peekLength() < 1 / 0
                    }, a.prototype.next = function (e) {
                        e || (e = 1 / 0);
                        var t = this.ops[this.index];
                        if (t) {
                            var n = this.offset,
                                i = o.length(t);
                            if (e >= i - n ? (e = i - n, this.index += 1, this.offset = 0) : this.offset += e, "number" == typeof t.delete) return {
                                delete: e
                            };
                            var r = {};
                            return t.attributes && (r.attributes = t.attributes), "number" == typeof t.retain ? r.retain = e : "string" == typeof t.insert ? r.insert = t.insert.substr(n, e) : r.insert = t.insert, r
                        }
                        return {
                            retain: 1 / 0
                        }
                    }, a.prototype.peek = function () {
                        return this.ops[this.index]
                    }, a.prototype.peekLength = function () {
                        return this.ops[this.index] ? o.length(this.ops[this.index]) - this.offset : 1 / 0
                    }, a.prototype.peekType = function () {
                        return this.ops[this.index] ? "number" == typeof this.ops[this.index].delete ? "delete" : "number" == typeof this.ops[this.index].retain ? "retain" : "insert" : "retain"
                    }, a.prototype.rest = function () {
                        if (this.hasNext()) {
                            if (0 === this.offset) return this.ops.slice(this.index);
                            var e = this.offset,
                                t = this.index,
                                n = this.next(),
                                i = this.ops.slice(this.index);
                            return this.offset = e, this.index = t, [n].concat(i)
                        }
                        return []
                    }, e.exports = o
                }, function (e, t) {
                    var n = function () {
                        "use strict";

                        function e(e, t) {
                            return null != t && e instanceof t
                        }
                        var t, n, i;
                        try {
                            t = Map
                        } catch (e) {
                            t = function () {}
                        }
                        try {
                            n = Set
                        } catch (e) {
                            n = function () {}
                        }
                        try {
                            i = Promise
                        } catch (e) {
                            i = function () {}
                        }

                        function r(o, s, l, c, u) {
                            "object" == typeof s && (l = s.depth, c = s.prototype, u = s.includeNonEnumerable, s = s.circular);
                            var d = [],
                                h = [],
                                f = "undefined" != typeof Buffer;
                            return void 0 === s && (s = !0), void 0 === l && (l = 1 / 0),
                                function o(l, p) {
                                    if (null === l) return null;
                                    if (0 === p) return l;
                                    var g, m;
                                    if ("object" != typeof l) return l;
                                    if (e(l, t)) g = new t;
                                    else if (e(l, n)) g = new n;
                                    else if (e(l, i)) g = new i((function (e, t) {
                                        l.then((function (t) {
                                            e(o(t, p - 1))
                                        }), (function (e) {
                                            t(o(e, p - 1))
                                        }))
                                    }));
                                    else if (r.__isArray(l)) g = [];
                                    else if (r.__isRegExp(l)) g = new RegExp(l.source, a(l)), l.lastIndex && (g.lastIndex = l.lastIndex);
                                    else if (r.__isDate(l)) g = new Date(l.getTime());
                                    else {
                                        if (f && Buffer.isBuffer(l)) return g = Buffer.allocUnsafe ? Buffer.allocUnsafe(l.length) : new Buffer(l.length), l.copy(g), g;
                                        e(l, Error) ? g = Object.create(l) : void 0 === c ? (m = Object.getPrototypeOf(l), g = Object.create(m)) : (g = Object.create(c), m = c)
                                    }
                                    if (s) {
                                        var v = d.indexOf(l);
                                        if (-1 != v) return h[v];
                                        d.push(l), h.push(g)
                                    }
                                    for (var b in e(l, t) && l.forEach((function (e, t) {
                                            var n = o(t, p - 1),
                                                i = o(e, p - 1);
                                            g.set(n, i)
                                        })), e(l, n) && l.forEach((function (e) {
                                            var t = o(e, p - 1);
                                            g.add(t)
                                        })), l) {
                                        var y;
                                        m && (y = Object.getOwnPropertyDescriptor(m, b)), y && null == y.set || (g[b] = o(l[b], p - 1))
                                    }
                                    if (Object.getOwnPropertySymbols) {
                                        var _ = Object.getOwnPropertySymbols(l);
                                        for (b = 0; b < _.length; b++) {
                                            var x = _[b];
                                            (!(E = Object.getOwnPropertyDescriptor(l, x)) || E.enumerable || u) && (g[x] = o(l[x], p - 1), E.enumerable || Object.defineProperty(g, x, {
                                                enumerable: !1
                                            }))
                                        }
                                    }
                                    if (u) {
                                        var w = Object.getOwnPropertyNames(l);
                                        for (b = 0; b < w.length; b++) {
                                            var E, k = w[b];
                                            (E = Object.getOwnPropertyDescriptor(l, k)) && E.enumerable || (g[k] = o(l[k], p - 1), Object.defineProperty(g, k, {
                                                enumerable: !1
                                            }))
                                        }
                                    }
                                    return g
                                }(o, l)
                        }

                        function o(e) {
                            return Object.prototype.toString.call(e)
                        }

                        function a(e) {
                            var t = "";
                            return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), t
                        }
                        return r.clonePrototype = function (e) {
                            if (null === e) return null;
                            var t = function () {};
                            return t.prototype = e, new t
                        }, r.__objToStr = o, r.__isDate = function (e) {
                            return "object" == typeof e && "[object Date]" === o(e)
                        }, r.__isArray = function (e) {
                            return "object" == typeof e && "[object Array]" === o(e)
                        }, r.__isRegExp = function (e) {
                            return "object" == typeof e && "[object RegExp]" === o(e)
                        }, r.__getRegExpFlags = a, r
                    }();
                    "object" == typeof e && e.exports && (e.exports = n)
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = f(n(0)),
                        s = f(n(8)),
                        l = n(4),
                        c = f(l),
                        u = f(n(16)),
                        d = f(n(13)),
                        h = f(n(25));

                    function f(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function p(e) {
                        return e instanceof c.default || e instanceof l.BlockEmbed
                    }
                    var g = function (e) {
                        function t(e, n) {
                            ! function (e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, t);
                            var i = function (e, t) {
                                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return !t || "object" != typeof t && "function" != typeof t ? e : t
                            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                            return i.emitter = n.emitter, Array.isArray(n.whitelist) && (i.whitelist = n.whitelist.reduce((function (e, t) {
                                return e[t] = !0, e
                            }), {})), i.domNode.addEventListener("DOMNodeInserted", (function () {})), i.optimize(), i.enable(), i
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, [{
                            key: "batchStart",
                            value: function () {
                                this.batch = !0
                            }
                        }, {
                            key: "batchEnd",
                            value: function () {
                                this.batch = !1, this.optimize()
                            }
                        }, {
                            key: "deleteAt",
                            value: function (e, n) {
                                var r = this.line(e),
                                    a = i(r, 2),
                                    s = a[0],
                                    c = a[1],
                                    h = this.line(e + n),
                                    f = i(h, 1)[0];
                                if (o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "deleteAt", this).call(this, e, n), null != f && s !== f && c > 0) {
                                    if (s instanceof l.BlockEmbed || f instanceof l.BlockEmbed) return void this.optimize();
                                    if (s instanceof d.default) {
                                        var p = s.newlineIndex(s.length(), !0);
                                        if (p > -1 && (s = s.split(p + 1)) === f) return void this.optimize()
                                    } else if (f instanceof d.default) {
                                        var g = f.newlineIndex(0);
                                        g > -1 && f.split(g + 1)
                                    }
                                    var m = f.children.head instanceof u.default ? null : f.children.head;
                                    s.moveChildren(f, m), s.remove()
                                }
                                this.optimize()
                            }
                        }, {
                            key: "enable",
                            value: function () {
                                var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                                this.domNode.setAttribute("contenteditable", e)
                            }
                        }, {
                            key: "formatAt",
                            value: function (e, n, i, r) {
                                (null == this.whitelist || this.whitelist[i]) && (o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "formatAt", this).call(this, e, n, i, r), this.optimize())
                            }
                        }, {
                            key: "insertAt",
                            value: function (e, n, i) {
                                if (null == i || null == this.whitelist || this.whitelist[n]) {
                                    if (e >= this.length())
                                        if (null == i || null == a.default.query(n, a.default.Scope.BLOCK)) {
                                            var r = a.default.create(this.statics.defaultChild);
                                            this.appendChild(r), null == i && n.endsWith("\n") && (n = n.slice(0, -1)), r.insertAt(0, n, i)
                                        } else {
                                            var s = a.default.create(n, i);
                                            this.appendChild(s)
                                        }
                                    else o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertAt", this).call(this, e, n, i);
                                    this.optimize()
                                }
                            }
                        }, {
                            key: "insertBefore",
                            value: function (e, n) {
                                if (e.statics.scope === a.default.Scope.INLINE_BLOT) {
                                    var i = a.default.create(this.statics.defaultChild);
                                    i.appendChild(e), e = i
                                }
                                o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertBefore", this).call(this, e, n)
                            }
                        }, {
                            key: "leaf",
                            value: function (e) {
                                return this.path(e).pop() || [null, -1]
                            }
                        }, {
                            key: "line",
                            value: function (e) {
                                return e === this.length() ? this.line(e - 1) : this.descendant(p, e)
                            }
                        }, {
                            key: "lines",
                            value: function () {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE,
                                    n = function e(t, n, i) {
                                        var r = [],
                                            o = i;
                                        return t.children.forEachAt(n, i, (function (t, n, i) {
                                            p(t) ? r.push(t) : t instanceof a.default.Container && (r = r.concat(e(t, n, o))), o -= i
                                        })), r
                                    };
                                return n(this, e, t)
                            }
                        }, {
                            key: "optimize",
                            value: function () {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                                    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                !0 !== this.batch && (o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e, n), e.length > 0 && this.emitter.emit(s.default.events.SCROLL_OPTIMIZE, e, n))
                            }
                        }, {
                            key: "path",
                            value: function (e) {
                                return o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "path", this).call(this, e).slice(1)
                            }
                        }, {
                            key: "update",
                            value: function (e) {
                                if (!0 !== this.batch) {
                                    var n = s.default.sources.USER;
                                    "string" == typeof e && (n = e), Array.isArray(e) || (e = this.observer.takeRecords()), e.length > 0 && this.emitter.emit(s.default.events.SCROLL_BEFORE_UPDATE, n, e), o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "update", this).call(this, e.concat([])), e.length > 0 && this.emitter.emit(s.default.events.SCROLL_UPDATE, n, e)
                                }
                            }
                        }]), t
                    }(a.default.Scroll);
                    g.blotName = "scroll", g.className = "ql-editor", g.tagName = "DIV", g.defaultChild = "block", g.allowedChildren = [c.default, l.BlockEmbed, h.default], t.default = g
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.SHORTKEY = t.default = void 0;
                    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                            return typeof e
                        } : function (e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        },
                        r = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        a = g(n(21)),
                        s = g(n(11)),
                        l = g(n(3)),
                        c = g(n(2)),
                        u = g(n(20)),
                        d = g(n(0)),
                        h = g(n(5)),
                        f = g(n(10)),
                        p = g(n(9));

                    function g(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function m(e, t, n) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e
                    }
                    var v = (0, f.default)("quill:keyboard"),
                        b = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey",
                        y = function (e) {
                            function t(e, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var i = function (e, t) {
                                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                return i.bindings = {}, Object.keys(i.options.bindings).forEach((function (t) {
                                    ("list autofill" !== t || null == e.scroll.whitelist || e.scroll.whitelist.list) && i.options.bindings[t] && i.addBinding(i.options.bindings[t])
                                })), i.addBinding({
                                    key: t.keys.ENTER,
                                    shiftKey: null
                                }, k), i.addBinding({
                                    key: t.keys.ENTER,
                                    metaKey: null,
                                    ctrlKey: null,
                                    altKey: null
                                }, (function () {})), /Firefox/i.test(navigator.userAgent) ? (i.addBinding({
                                    key: t.keys.BACKSPACE
                                }, {
                                    collapsed: !0
                                }, x), i.addBinding({
                                    key: t.keys.DELETE
                                }, {
                                    collapsed: !0
                                }, w)) : (i.addBinding({
                                    key: t.keys.BACKSPACE
                                }, {
                                    collapsed: !0,
                                    prefix: /^.?$/
                                }, x), i.addBinding({
                                    key: t.keys.DELETE
                                }, {
                                    collapsed: !0,
                                    suffix: /^.?$/
                                }, w)), i.addBinding({
                                    key: t.keys.BACKSPACE
                                }, {
                                    collapsed: !1
                                }, E), i.addBinding({
                                    key: t.keys.DELETE
                                }, {
                                    collapsed: !1
                                }, E), i.addBinding({
                                    key: t.keys.BACKSPACE,
                                    altKey: null,
                                    ctrlKey: null,
                                    metaKey: null,
                                    shiftKey: null
                                }, {
                                    collapsed: !0,
                                    offset: 0
                                }, x), i.listen(), i
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), o(t, null, [{
                                key: "match",
                                value: function (e, t) {
                                    return t = C(t), !["altKey", "ctrlKey", "metaKey", "shiftKey"].some((function (n) {
                                        return !!t[n] !== e[n] && null !== t[n]
                                    })) && t.key === (e.which || e.keyCode)
                                }
                            }]), o(t, [{
                                key: "addBinding",
                                value: function (e) {
                                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                                        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                                        i = C(e);
                                    if (null == i || null == i.key) return v.warn("Attempted to add invalid keyboard binding", i);
                                    "function" == typeof t && (t = {
                                        handler: t
                                    }), "function" == typeof n && (n = {
                                        handler: n
                                    }), i = (0, l.default)(i, t, n), this.bindings[i.key] = this.bindings[i.key] || [], this.bindings[i.key].push(i)
                                }
                            }, {
                                key: "listen",
                                value: function () {
                                    var e = this;
                                    this.quill.root.addEventListener("keydown", (function (n) {
                                        if (!n.defaultPrevented) {
                                            var o = n.which || n.keyCode,
                                                a = (e.bindings[o] || []).filter((function (e) {
                                                    return t.match(n, e)
                                                }));
                                            if (0 !== a.length) {
                                                var l = e.quill.getSelection();
                                                if (null != l && e.quill.hasFocus()) {
                                                    var c = e.quill.getLine(l.index),
                                                        u = r(c, 2),
                                                        h = u[0],
                                                        f = u[1],
                                                        p = e.quill.getLeaf(l.index),
                                                        g = r(p, 2),
                                                        m = g[0],
                                                        v = g[1],
                                                        b = 0 === l.length ? [m, v] : e.quill.getLeaf(l.index + l.length),
                                                        y = r(b, 2),
                                                        _ = y[0],
                                                        x = y[1],
                                                        w = m instanceof d.default.Text ? m.value().slice(0, v) : "",
                                                        E = _ instanceof d.default.Text ? _.value().slice(x) : "",
                                                        k = {
                                                            collapsed: 0 === l.length,
                                                            empty: 0 === l.length && h.length() <= 1,
                                                            format: e.quill.getFormat(l),
                                                            offset: f,
                                                            prefix: w,
                                                            suffix: E
                                                        };
                                                    a.some((function (t) {
                                                        if (null != t.collapsed && t.collapsed !== k.collapsed) return !1;
                                                        if (null != t.empty && t.empty !== k.empty) return !1;
                                                        if (null != t.offset && t.offset !== k.offset) return !1;
                                                        if (Array.isArray(t.format)) {
                                                            if (t.format.every((function (e) {
                                                                    return null == k.format[e]
                                                                }))) return !1
                                                        } else if ("object" === i(t.format) && !Object.keys(t.format).every((function (e) {
                                                                return !0 === t.format[e] ? null != k.format[e] : !1 === t.format[e] ? null == k.format[e] : (0, s.default)(t.format[e], k.format[e])
                                                            }))) return !1;
                                                        return !(null != t.prefix && !t.prefix.test(k.prefix) || null != t.suffix && !t.suffix.test(k.suffix) || !0 === t.handler.call(e, l, k))
                                                    })) && n.preventDefault()
                                                }
                                            }
                                        }
                                    }))
                                }
                            }]), t
                        }(p.default);

                    function _(e, t) {
                        var n, i = e === y.keys.LEFT ? "prefix" : "suffix";
                        return m(n = {
                            key: e,
                            shiftKey: t,
                            altKey: null
                        }, i, /^$/), m(n, "handler", (function (n) {
                            var i = n.index;
                            e === y.keys.RIGHT && (i += n.length + 1);
                            var o = this.quill.getLeaf(i);
                            return !(r(o, 1)[0] instanceof d.default.Embed && (e === y.keys.LEFT ? t ? this.quill.setSelection(n.index - 1, n.length + 1, h.default.sources.USER) : this.quill.setSelection(n.index - 1, h.default.sources.USER) : t ? this.quill.setSelection(n.index, n.length + 1, h.default.sources.USER) : this.quill.setSelection(n.index + n.length + 1, h.default.sources.USER), 1))
                        })), n
                    }

                    function x(e, t) {
                        if (!(0 === e.index || this.quill.getLength() <= 1)) {
                            var n = this.quill.getLine(e.index),
                                i = r(n, 1)[0],
                                o = {};
                            if (0 === t.offset) {
                                var a = this.quill.getLine(e.index - 1),
                                    s = r(a, 1)[0];
                                if (null != s && s.length() > 1) {
                                    var l = i.formats(),
                                        c = this.quill.getFormat(e.index - 1, 1);
                                    o = u.default.attributes.diff(l, c) || {}
                                }
                            }
                            var d = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(t.prefix) ? 2 : 1;
                            this.quill.deleteText(e.index - d, d, h.default.sources.USER), Object.keys(o).length > 0 && this.quill.formatLine(e.index - d, d, o, h.default.sources.USER), this.quill.focus()
                        }
                    }

                    function w(e, t) {
                        var n = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(t.suffix) ? 2 : 1;
                        if (!(e.index >= this.quill.getLength() - n)) {
                            var i = {},
                                o = 0,
                                a = this.quill.getLine(e.index),
                                s = r(a, 1)[0];
                            if (t.offset >= s.length() - 1) {
                                var l = this.quill.getLine(e.index + 1),
                                    c = r(l, 1)[0];
                                if (c) {
                                    var d = s.formats(),
                                        f = this.quill.getFormat(e.index, 1);
                                    i = u.default.attributes.diff(d, f) || {}, o = c.length()
                                }
                            }
                            this.quill.deleteText(e.index, n, h.default.sources.USER), Object.keys(i).length > 0 && this.quill.formatLine(e.index + o - 1, n, i, h.default.sources.USER)
                        }
                    }

                    function E(e) {
                        var t = this.quill.getLines(e),
                            n = {};
                        if (t.length > 1) {
                            var i = t[0].formats(),
                                r = t[t.length - 1].formats();
                            n = u.default.attributes.diff(r, i) || {}
                        }
                        this.quill.deleteText(e, h.default.sources.USER), Object.keys(n).length > 0 && this.quill.formatLine(e.index, 1, n, h.default.sources.USER), this.quill.setSelection(e.index, h.default.sources.SILENT), this.quill.focus()
                    }

                    function k(e, t) {
                        var n = this;
                        e.length > 0 && this.quill.scroll.deleteAt(e.index, e.length);
                        var i = Object.keys(t.format).reduce((function (e, n) {
                            return d.default.query(n, d.default.Scope.BLOCK) && !Array.isArray(t.format[n]) && (e[n] = t.format[n]), e
                        }), {});
                        this.quill.insertText(e.index, "\n", i, h.default.sources.USER), this.quill.setSelection(e.index + 1, h.default.sources.SILENT), this.quill.focus(), Object.keys(t.format).forEach((function (e) {
                            null == i[e] && (Array.isArray(t.format[e]) || "link" !== e && n.quill.format(e, t.format[e], h.default.sources.USER))
                        }))
                    }

                    function O(e) {
                        return {
                            key: y.keys.TAB,
                            shiftKey: !e,
                            format: {
                                "code-block": !0
                            },
                            handler: function (t) {
                                var n = d.default.query("code-block"),
                                    i = t.index,
                                    o = t.length,
                                    a = this.quill.scroll.descendant(n, i),
                                    s = r(a, 2),
                                    l = s[0],
                                    c = s[1];
                                if (null != l) {
                                    var u = this.quill.getIndex(l),
                                        f = l.newlineIndex(c, !0) + 1,
                                        p = l.newlineIndex(u + c + o),
                                        g = l.domNode.textContent.slice(f, p).split("\n");
                                    c = 0, g.forEach((function (t, r) {
                                        e ? (l.insertAt(f + c, n.TAB), c += n.TAB.length, 0 === r ? i += n.TAB.length : o += n.TAB.length) : t.startsWith(n.TAB) && (l.deleteAt(f + c, n.TAB.length), c -= n.TAB.length, 0 === r ? i -= n.TAB.length : o -= n.TAB.length), c += t.length + 1
                                    })), this.quill.update(h.default.sources.USER), this.quill.setSelection(i, o, h.default.sources.SILENT)
                                }
                            }
                        }
                    }

                    function S(e) {
                        return {
                            key: e[0].toUpperCase(),
                            shortKey: !0,
                            handler: function (t, n) {
                                this.quill.format(e, !n.format[e], h.default.sources.USER)
                            }
                        }
                    }

                    function C(e) {
                        if ("string" == typeof e || "number" == typeof e) return C({
                            key: e
                        });
                        if ("object" === (void 0 === e ? "undefined" : i(e)) && (e = (0, a.default)(e, !1)), "string" == typeof e.key)
                            if (null != y.keys[e.key.toUpperCase()]) e.key = y.keys[e.key.toUpperCase()];
                            else {
                                if (1 !== e.key.length) return null;
                                e.key = e.key.toUpperCase().charCodeAt(0)
                            } return e.shortKey && (e[b] = e.shortKey, delete e.shortKey), e
                    }
                    y.keys = {
                        BACKSPACE: 8,
                        TAB: 9,
                        ENTER: 13,
                        ESCAPE: 27,
                        LEFT: 37,
                        UP: 38,
                        RIGHT: 39,
                        DOWN: 40,
                        DELETE: 46
                    }, y.DEFAULTS = {
                        bindings: {
                            bold: S("bold"),
                            italic: S("italic"),
                            underline: S("underline"),
                            indent: {
                                key: y.keys.TAB,
                                format: ["blockquote", "indent", "list"],
                                handler: function (e, t) {
                                    if (t.collapsed && 0 !== t.offset) return !0;
                                    this.quill.format("indent", "+1", h.default.sources.USER)
                                }
                            },
                            outdent: {
                                key: y.keys.TAB,
                                shiftKey: !0,
                                format: ["blockquote", "indent", "list"],
                                handler: function (e, t) {
                                    if (t.collapsed && 0 !== t.offset) return !0;
                                    this.quill.format("indent", "-1", h.default.sources.USER)
                                }
                            },
                            "outdent backspace": {
                                key: y.keys.BACKSPACE,
                                collapsed: !0,
                                shiftKey: null,
                                metaKey: null,
                                ctrlKey: null,
                                altKey: null,
                                format: ["indent", "list"],
                                offset: 0,
                                handler: function (e, t) {
                                    null != t.format.indent ? this.quill.format("indent", "-1", h.default.sources.USER) : null != t.format.list && this.quill.format("list", !1, h.default.sources.USER)
                                }
                            },
                            "indent code-block": O(!0),
                            "outdent code-block": O(!1),
                            "remove tab": {
                                key: y.keys.TAB,
                                shiftKey: !0,
                                collapsed: !0,
                                prefix: /\t$/,
                                handler: function (e) {
                                    this.quill.deleteText(e.index - 1, 1, h.default.sources.USER)
                                }
                            },
                            tab: {
                                key: y.keys.TAB,
                                handler: function (e) {
                                    this.quill.history.cutoff();
                                    var t = (new c.default).retain(e.index).delete(e.length).insert("\t");
                                    this.quill.updateContents(t, h.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(e.index + 1, h.default.sources.SILENT)
                                }
                            },
                            "list empty enter": {
                                key: y.keys.ENTER,
                                collapsed: !0,
                                format: ["list"],
                                empty: !0,
                                handler: function (e, t) {
                                    this.quill.format("list", !1, h.default.sources.USER), t.format.indent && this.quill.format("indent", !1, h.default.sources.USER)
                                }
                            },
                            "checklist enter": {
                                key: y.keys.ENTER,
                                collapsed: !0,
                                format: {
                                    list: "checked"
                                },
                                handler: function (e) {
                                    var t = this.quill.getLine(e.index),
                                        n = r(t, 2),
                                        i = n[0],
                                        o = n[1],
                                        a = (0, l.default)({}, i.formats(), {
                                            list: "checked"
                                        }),
                                        s = (new c.default).retain(e.index).insert("\n", a).retain(i.length() - o - 1).retain(1, {
                                            list: "unchecked"
                                        });
                                    this.quill.updateContents(s, h.default.sources.USER), this.quill.setSelection(e.index + 1, h.default.sources.SILENT), this.quill.scrollIntoView()
                                }
                            },
                            "header enter": {
                                key: y.keys.ENTER,
                                collapsed: !0,
                                format: ["header"],
                                suffix: /^$/,
                                handler: function (e, t) {
                                    var n = this.quill.getLine(e.index),
                                        i = r(n, 2),
                                        o = i[0],
                                        a = i[1],
                                        s = (new c.default).retain(e.index).insert("\n", t.format).retain(o.length() - a - 1).retain(1, {
                                            header: null
                                        });
                                    this.quill.updateContents(s, h.default.sources.USER), this.quill.setSelection(e.index + 1, h.default.sources.SILENT), this.quill.scrollIntoView()
                                }
                            },
                            "list autofill": {
                                key: " ",
                                collapsed: !0,
                                format: {
                                    list: !1
                                },
                                prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                                handler: function (e, t) {
                                    var n = t.prefix.length,
                                        i = this.quill.getLine(e.index),
                                        o = r(i, 2),
                                        a = o[0],
                                        s = o[1];
                                    if (s > n) return !0;
                                    var l = void 0;
                                    switch (t.prefix.trim()) {
                                        case "[]":
                                        case "[ ]":
                                            l = "unchecked";
                                            break;
                                        case "[x]":
                                            l = "checked";
                                            break;
                                        case "-":
                                        case "*":
                                            l = "bullet";
                                            break;
                                        default:
                                            l = "ordered"
                                    }
                                    this.quill.insertText(e.index, " ", h.default.sources.USER), this.quill.history.cutoff();
                                    var u = (new c.default).retain(e.index - s).delete(n + 1).retain(a.length() - 2 - s).retain(1, {
                                        list: l
                                    });
                                    this.quill.updateContents(u, h.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(e.index - n, h.default.sources.SILENT)
                                }
                            },
                            "code exit": {
                                key: y.keys.ENTER,
                                collapsed: !0,
                                format: ["code-block"],
                                prefix: /\n\n$/,
                                suffix: /^\s+$/,
                                handler: function (e) {
                                    var t = this.quill.getLine(e.index),
                                        n = r(t, 2),
                                        i = n[0],
                                        o = n[1],
                                        a = (new c.default).retain(e.index + i.length() - o - 2).retain(1, {
                                            "code-block": null
                                        }).delete(1);
                                    this.quill.updateContents(a, h.default.sources.USER)
                                }
                            },
                            "embed left": _(y.keys.LEFT, !1),
                            "embed left shift": _(y.keys.LEFT, !0),
                            "embed right": _(y.keys.RIGHT, !1),
                            "embed right shift": _(y.keys.RIGHT, !0)
                        }
                    }, t.default = y, t.SHORTKEY = b
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        a = l(n(0)),
                        s = l(n(7));

                    function l(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var c = function (e) {
                        function t(e, n) {
                            ! function (e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, t);
                            var i = function (e, t) {
                                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return !t || "object" != typeof t && "function" != typeof t ? e : t
                            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                            return i.selection = n, i.textNode = document.createTextNode(t.CONTENTS), i.domNode.appendChild(i.textNode), i._length = 0, i
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), o(t, null, [{
                            key: "value",
                            value: function () {}
                        }]), o(t, [{
                            key: "detach",
                            value: function () {
                                null != this.parent && this.parent.removeChild(this)
                            }
                        }, {
                            key: "format",
                            value: function (e, n) {
                                if (0 !== this._length) return r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n);
                                for (var i = this, o = 0; null != i && i.statics.scope !== a.default.Scope.BLOCK_BLOT;) o += i.offset(i.parent), i = i.parent;
                                null != i && (this._length = t.CONTENTS.length, i.optimize(), i.formatAt(o, t.CONTENTS.length, e, n), this._length = 0)
                            }
                        }, {
                            key: "index",
                            value: function (e, n) {
                                return e === this.textNode ? 0 : r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "index", this).call(this, e, n)
                            }
                        }, {
                            key: "length",
                            value: function () {
                                return this._length
                            }
                        }, {
                            key: "position",
                            value: function () {
                                return [this.textNode, this.textNode.data.length]
                            }
                        }, {
                            key: "remove",
                            value: function () {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "remove", this).call(this), this.parent = null
                            }
                        }, {
                            key: "restore",
                            value: function () {
                                if (!this.selection.composing && null != this.parent) {
                                    var e = this.textNode,
                                        n = this.selection.getNativeRange(),
                                        r = void 0,
                                        o = void 0,
                                        l = void 0;
                                    if (null != n && n.start.node === e && n.end.node === e) {
                                        var c = [e, n.start.offset, n.end.offset];
                                        r = c[0], o = c[1], l = c[2]
                                    }
                                    for (; null != this.domNode.lastChild && this.domNode.lastChild !== this.textNode;) this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                                    if (this.textNode.data !== t.CONTENTS) {
                                        var u = this.textNode.data.split(t.CONTENTS).join("");
                                        this.next instanceof s.default ? (r = this.next.domNode, this.next.insertAt(0, u), this.textNode.data = t.CONTENTS) : (this.textNode.data = u, this.parent.insertBefore(a.default.create(this.textNode), this), this.textNode = document.createTextNode(t.CONTENTS), this.domNode.appendChild(this.textNode))
                                    }
                                    if (this.remove(), null != o) {
                                        var d = [o, l].map((function (e) {
                                                return Math.max(0, Math.min(r.data.length, e - 1))
                                            })),
                                            h = i(d, 2);
                                        return o = h[0], l = h[1], {
                                            startNode: r,
                                            startOffset: o,
                                            endNode: r,
                                            endOffset: l
                                        }
                                    }
                                }
                            }
                        }, {
                            key: "update",
                            value: function (e, t) {
                                var n = this;
                                if (e.some((function (e) {
                                        return "characterData" === e.type && e.target === n.textNode
                                    }))) {
                                    var i = this.restore();
                                    i && (t.range = i)
                                }
                            }
                        }, {
                            key: "value",
                            value: function () {
                                return ""
                            }
                        }]), t
                    }(a.default.Embed);
                    c.blotName = "cursor", c.className = "ql-cursor", c.tagName = "span", c.CONTENTS = "\ufeff", t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = a(n(0)),
                        r = n(4),
                        o = a(r);

                    function a(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function s(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function l(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var c = function (e) {
                        function t() {
                            return s(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(i.default.Container);
                    c.allowedChildren = [o.default, r.BlockEmbed, c], t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.ColorStyle = t.ColorClass = t.ColorAttributor = void 0;
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(0),
                        s = (i = a) && i.__esModule ? i : {
                            default: i
                        };

                    function l(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function c(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var u = function (e) {
                            function t() {
                                return l(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "value",
                                value: function (e) {
                                    var n = o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "value", this).call(this, e);
                                    return n.startsWith("rgb(") ? (n = n.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), "#" + n.split(",").map((function (e) {
                                        return ("00" + parseInt(e).toString(16)).slice(-2)
                                    })).join("")) : n
                                }
                            }]), t
                        }(s.default.Attributor.Style),
                        d = new s.default.Attributor.Class("color", "ql-color", {
                            scope: s.default.Scope.INLINE
                        }),
                        h = new u("color", "color", {
                            scope: s.default.Scope.INLINE
                        });
                    t.ColorAttributor = u, t.ColorClass = d, t.ColorStyle = h
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.sanitize = t.default = void 0;
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(6);

                    function s(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function l(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var c = function (e) {
                        function t() {
                            return s(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, [{
                            key: "format",
                            value: function (e, n) {
                                if (e !== this.statics.blotName || !n) return o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n);
                                n = this.constructor.sanitize(n), this.domNode.setAttribute("href", n)
                            }
                        }], [{
                            key: "create",
                            value: function (e) {
                                var n = o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e);
                                return e = this.sanitize(e), n.setAttribute("href", e), n.setAttribute("rel", "noopener noreferrer"), n.setAttribute("target", "_blank"), n
                            }
                        }, {
                            key: "formats",
                            value: function (e) {
                                return e.getAttribute("href")
                            }
                        }, {
                            key: "sanitize",
                            value: function (e) {
                                return u(e, this.PROTOCOL_WHITELIST) ? e : this.SANITIZED_URL
                            }
                        }]), t
                    }(((i = a) && i.__esModule ? i : {
                        default: i
                    }).default);

                    function u(e, t) {
                        var n = document.createElement("a");
                        n.href = e;
                        var i = n.href.slice(0, n.href.indexOf(":"));
                        return t.indexOf(i) > -1
                    }
                    c.blotName = "link", c.tagName = "A", c.SANITIZED_URL = "about:blank", c.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"], t.default = c, t.sanitize = u
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                            return typeof e
                        } : function (e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = s(n(23)),
                        a = s(n(107));

                    function s(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var l = 0;

                    function c(e, t) {
                        e.setAttribute(t, !("true" === e.getAttribute(t)))
                    }
                    var u = function () {
                        function e(t) {
                            var n = this;
                            ! function (e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, e), this.select = t, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", (function () {
                                n.togglePicker()
                            })), this.label.addEventListener("keydown", (function (e) {
                                switch (e.keyCode) {
                                    case o.default.keys.ENTER:
                                        n.togglePicker();
                                        break;
                                    case o.default.keys.ESCAPE:
                                        n.escape(), e.preventDefault()
                                }
                            })), this.select.addEventListener("change", this.update.bind(this))
                        }
                        return r(e, [{
                            key: "togglePicker",
                            value: function () {
                                this.container.classList.toggle("ql-expanded"), c(this.label, "aria-expanded"), c(this.options, "aria-hidden")
                            }
                        }, {
                            key: "buildItem",
                            value: function (e) {
                                var t = this,
                                    n = document.createElement("span");
                                return n.tabIndex = "0", n.setAttribute("role", "button"), n.classList.add("ql-picker-item"), e.hasAttribute("value") && n.setAttribute("data-value", e.getAttribute("value")), e.textContent && n.setAttribute("data-label", e.textContent), n.addEventListener("click", (function () {
                                    t.selectItem(n, !0)
                                })), n.addEventListener("keydown", (function (e) {
                                    switch (e.keyCode) {
                                        case o.default.keys.ENTER:
                                            t.selectItem(n, !0), e.preventDefault();
                                            break;
                                        case o.default.keys.ESCAPE:
                                            t.escape(), e.preventDefault()
                                    }
                                })), n
                            }
                        }, {
                            key: "buildLabel",
                            value: function () {
                                var e = document.createElement("span");
                                return e.classList.add("ql-picker-label"), e.innerHTML = a.default, e.tabIndex = "0", e.setAttribute("role", "button"), e.setAttribute("aria-expanded", "false"), this.container.appendChild(e), e
                            }
                        }, {
                            key: "buildOptions",
                            value: function () {
                                var e = this,
                                    t = document.createElement("span");
                                t.classList.add("ql-picker-options"), t.setAttribute("aria-hidden", "true"), t.tabIndex = "-1", t.id = "ql-picker-options-" + l, l += 1, this.label.setAttribute("aria-controls", t.id), this.options = t, [].slice.call(this.select.options).forEach((function (n) {
                                    var i = e.buildItem(n);
                                    t.appendChild(i), !0 === n.selected && e.selectItem(i)
                                })), this.container.appendChild(t)
                            }
                        }, {
                            key: "buildPicker",
                            value: function () {
                                var e = this;
                                [].slice.call(this.select.attributes).forEach((function (t) {
                                    e.container.setAttribute(t.name, t.value)
                                })), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions()
                            }
                        }, {
                            key: "escape",
                            value: function () {
                                var e = this;
                                this.close(), setTimeout((function () {
                                    return e.label.focus()
                                }), 1)
                            }
                        }, {
                            key: "close",
                            value: function () {
                                this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true")
                            }
                        }, {
                            key: "selectItem",
                            value: function (e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                                    n = this.container.querySelector(".ql-selected");
                                if (e !== n && (null != n && n.classList.remove("ql-selected"), null != e && (e.classList.add("ql-selected"), this.select.selectedIndex = [].indexOf.call(e.parentNode.children, e), e.hasAttribute("data-value") ? this.label.setAttribute("data-value", e.getAttribute("data-value")) : this.label.removeAttribute("data-value"), e.hasAttribute("data-label") ? this.label.setAttribute("data-label", e.getAttribute("data-label")) : this.label.removeAttribute("data-label"), t))) {
                                    if ("function" == typeof Event) this.select.dispatchEvent(new Event("change"));
                                    else if ("object" === ("undefined" == typeof Event ? "undefined" : i(Event))) {
                                        var r = document.createEvent("Event");
                                        r.initEvent("change", !0, !0), this.select.dispatchEvent(r)
                                    }
                                    this.close()
                                }
                            }
                        }, {
                            key: "update",
                            value: function () {
                                var e = void 0;
                                if (this.select.selectedIndex > -1) {
                                    var t = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                                    e = this.select.options[this.select.selectedIndex], this.selectItem(t)
                                } else this.selectItem(null);
                                var n = null != e && e !== this.select.querySelector("option[selected]");
                                this.label.classList.toggle("ql-active", n)
                            }
                        }]), e
                    }();
                    t.default = u
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = v(n(0)),
                        r = v(n(5)),
                        o = n(4),
                        a = v(o),
                        s = v(n(16)),
                        l = v(n(25)),
                        c = v(n(24)),
                        u = v(n(35)),
                        d = v(n(6)),
                        h = v(n(22)),
                        f = v(n(7)),
                        p = v(n(55)),
                        g = v(n(42)),
                        m = v(n(23));

                    function v(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    r.default.register({
                        "blots/block": a.default,
                        "blots/block/embed": o.BlockEmbed,
                        "blots/break": s.default,
                        "blots/container": l.default,
                        "blots/cursor": c.default,
                        "blots/embed": u.default,
                        "blots/inline": d.default,
                        "blots/scroll": h.default,
                        "blots/text": f.default,
                        "modules/clipboard": p.default,
                        "modules/history": g.default,
                        "modules/keyboard": m.default
                    }), i.default.register(a.default, s.default, c.default, d.default, h.default, f.default), t.default = r.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(1),
                        r = function () {
                            function e(e) {
                                this.domNode = e, this.domNode[i.DATA_KEY] = {
                                    blot: this
                                }
                            }
                            return Object.defineProperty(e.prototype, "statics", {
                                get: function () {
                                    return this.constructor
                                },
                                enumerable: !0,
                                configurable: !0
                            }), e.create = function (e) {
                                if (null == this.tagName) throw new i.ParchmentError("Blot definition missing tagName");
                                var t;
                                return Array.isArray(this.tagName) ? ("string" == typeof e && (e = e.toUpperCase(), parseInt(e).toString() === e && (e = parseInt(e))), t = "number" == typeof e ? document.createElement(this.tagName[e - 1]) : this.tagName.indexOf(e) > -1 ? document.createElement(e) : document.createElement(this.tagName[0])) : t = document.createElement(this.tagName), this.className && t.classList.add(this.className), t
                            }, e.prototype.attach = function () {
                                null != this.parent && (this.scroll = this.parent.scroll)
                            }, e.prototype.clone = function () {
                                var e = this.domNode.cloneNode(!1);
                                return i.create(e)
                            }, e.prototype.detach = function () {
                                null != this.parent && this.parent.removeChild(this), delete this.domNode[i.DATA_KEY]
                            }, e.prototype.deleteAt = function (e, t) {
                                this.isolate(e, t).remove()
                            }, e.prototype.formatAt = function (e, t, n, r) {
                                var o = this.isolate(e, t);
                                if (null != i.query(n, i.Scope.BLOT) && r) o.wrap(n, r);
                                else if (null != i.query(n, i.Scope.ATTRIBUTE)) {
                                    var a = i.create(this.statics.scope);
                                    o.wrap(a), a.format(n, r)
                                }
                            }, e.prototype.insertAt = function (e, t, n) {
                                var r = null == n ? i.create("text", t) : i.create(t, n),
                                    o = this.split(e);
                                this.parent.insertBefore(r, o)
                            }, e.prototype.insertInto = function (e, t) {
                                void 0 === t && (t = null), null != this.parent && this.parent.children.remove(this);
                                var n = null;
                                e.children.insertBefore(this, t), null != t && (n = t.domNode), this.domNode.parentNode == e.domNode && this.domNode.nextSibling == n || e.domNode.insertBefore(this.domNode, n), this.parent = e, this.attach()
                            }, e.prototype.isolate = function (e, t) {
                                var n = this.split(e);
                                return n.split(t), n
                            }, e.prototype.length = function () {
                                return 1
                            }, e.prototype.offset = function (e) {
                                return void 0 === e && (e = this.parent), null == this.parent || this == e ? 0 : this.parent.children.offset(this) + this.parent.offset(e)
                            }, e.prototype.optimize = function (e) {
                                null != this.domNode[i.DATA_KEY] && delete this.domNode[i.DATA_KEY].mutations
                            }, e.prototype.remove = function () {
                                null != this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), this.detach()
                            }, e.prototype.replace = function (e) {
                                null != e.parent && (e.parent.insertBefore(this, e.next), e.remove())
                            }, e.prototype.replaceWith = function (e, t) {
                                var n = "string" == typeof e ? i.create(e, t) : e;
                                return n.replace(this), n
                            }, e.prototype.split = function (e, t) {
                                return 0 === e ? this : this.next
                            }, e.prototype.update = function (e, t) {}, e.prototype.wrap = function (e, t) {
                                var n = "string" == typeof e ? i.create(e, t) : e;
                                return null != this.parent && this.parent.insertBefore(n, this.next), n.appendChild(this), n
                            }, e.blotName = "abstract", e
                        }();
                    t.default = r
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = n(12),
                        r = n(32),
                        o = n(33),
                        a = n(1),
                        s = function () {
                            function e(e) {
                                this.attributes = {}, this.domNode = e, this.build()
                            }
                            return e.prototype.attribute = function (e, t) {
                                t ? e.add(this.domNode, t) && (null != e.value(this.domNode) ? this.attributes[e.attrName] = e : delete this.attributes[e.attrName]) : (e.remove(this.domNode), delete this.attributes[e.attrName])
                            }, e.prototype.build = function () {
                                var e = this;
                                this.attributes = {};
                                var t = i.default.keys(this.domNode),
                                    n = r.default.keys(this.domNode),
                                    s = o.default.keys(this.domNode);
                                t.concat(n).concat(s).forEach((function (t) {
                                    var n = a.query(t, a.Scope.ATTRIBUTE);
                                    n instanceof i.default && (e.attributes[n.attrName] = n)
                                }))
                            }, e.prototype.copy = function (e) {
                                var t = this;
                                Object.keys(this.attributes).forEach((function (n) {
                                    var i = t.attributes[n].value(t.domNode);
                                    e.format(n, i)
                                }))
                            }, e.prototype.move = function (e) {
                                var t = this;
                                this.copy(e), Object.keys(this.attributes).forEach((function (e) {
                                    t.attributes[e].remove(t.domNode)
                                })), this.attributes = {}
                            }, e.prototype.values = function () {
                                var e = this;
                                return Object.keys(this.attributes).reduce((function (t, n) {
                                    return t[n] = e.attributes[n].value(e.domNode), t
                                }), {})
                            }, e
                        }();
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });

                    function o(e, t) {
                        return (e.getAttribute("class") || "").split(/\s+/).filter((function (e) {
                            return 0 === e.indexOf(t + "-")
                        }))
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var a = function (e) {
                        function t() {
                            return null !== e && e.apply(this, arguments) || this
                        }
                        return r(t, e), t.keys = function (e) {
                            return (e.getAttribute("class") || "").split(/\s+/).map((function (e) {
                                return e.split("-").slice(0, -1).join("-")
                            }))
                        }, t.prototype.add = function (e, t) {
                            return !!this.canAdd(e, t) && (this.remove(e), e.classList.add(this.keyName + "-" + t), !0)
                        }, t.prototype.remove = function (e) {
                            o(e, this.keyName).forEach((function (t) {
                                e.classList.remove(t)
                            })), 0 === e.classList.length && e.removeAttribute("class")
                        }, t.prototype.value = function (e) {
                            var t = (o(e, this.keyName)[0] || "").slice(this.keyName.length + 1);
                            return this.canAdd(e, t) ? t : ""
                        }, t
                    }(n(12).default);
                    t.default = a
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });

                    function o(e) {
                        var t = e.split("-"),
                            n = t.slice(1).map((function (e) {
                                return e[0].toUpperCase() + e.slice(1)
                            })).join("");
                        return t[0] + n
                    }
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var a = function (e) {
                        function t() {
                            return null !== e && e.apply(this, arguments) || this
                        }
                        return r(t, e), t.keys = function (e) {
                            return (e.getAttribute("style") || "").split(";").map((function (e) {
                                return e.split(":")[0].trim()
                            }))
                        }, t.prototype.add = function (e, t) {
                            return !!this.canAdd(e, t) && (e.style[o(this.keyName)] = t, !0)
                        }, t.prototype.remove = function (e) {
                            e.style[o(this.keyName)] = "", e.getAttribute("style") || e.removeAttribute("style")
                        }, t.prototype.value = function (e) {
                            var t = e.style[o(this.keyName)];
                            return this.canAdd(e, t) ? t : ""
                        }, t
                    }(n(12).default);
                    t.default = a
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function () {
                            function e(t, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, e), this.quill = t, this.options = n, this.modules = {}
                            }
                            return i(e, [{
                                key: "init",
                                value: function () {
                                    var e = this;
                                    Object.keys(this.options.modules).forEach((function (t) {
                                        null == e.modules[t] && e.addModule(t)
                                    }))
                                }
                            }, {
                                key: "addModule",
                                value: function (e) {
                                    var t = this.quill.constructor.import("modules/" + e);
                                    return this.modules[e] = new t(this.quill, this.options.modules[e] || {}), this.modules[e]
                                }
                            }]), e
                        }();
                    r.DEFAULTS = {
                        modules: {}
                    }, r.themes = {
                        default: r
                    }, t.default = r
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = s(n(0)),
                        a = s(n(7));

                    function s(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var l = "\ufeff",
                        c = function (e) {
                            function t(e) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var n = function (e, t) {
                                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                                return n.contentNode = document.createElement("span"), n.contentNode.setAttribute("contenteditable", !1), [].slice.call(n.domNode.childNodes).forEach((function (e) {
                                    n.contentNode.appendChild(e)
                                })), n.leftGuard = document.createTextNode(l), n.rightGuard = document.createTextNode(l), n.domNode.appendChild(n.leftGuard), n.domNode.appendChild(n.contentNode), n.domNode.appendChild(n.rightGuard), n
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), i(t, [{
                                key: "index",
                                value: function (e, n) {
                                    return e === this.leftGuard ? 0 : e === this.rightGuard ? 1 : r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "index", this).call(this, e, n)
                                }
                            }, {
                                key: "restore",
                                value: function (e) {
                                    var t = void 0,
                                        n = void 0,
                                        i = e.data.split(l).join("");
                                    if (e === this.leftGuard)
                                        if (this.prev instanceof a.default) {
                                            var r = this.prev.length();
                                            this.prev.insertAt(r, i), t = {
                                                startNode: this.prev.domNode,
                                                startOffset: r + i.length
                                            }
                                        } else n = document.createTextNode(i), this.parent.insertBefore(o.default.create(n), this), t = {
                                            startNode: n,
                                            startOffset: i.length
                                        };
                                    else e === this.rightGuard && (this.next instanceof a.default ? (this.next.insertAt(0, i), t = {
                                        startNode: this.next.domNode,
                                        startOffset: i.length
                                    }) : (n = document.createTextNode(i), this.parent.insertBefore(o.default.create(n), this.next), t = {
                                        startNode: n,
                                        startOffset: i.length
                                    }));
                                    return e.data = l, t
                                }
                            }, {
                                key: "update",
                                value: function (e, t) {
                                    var n = this;
                                    e.forEach((function (e) {
                                        if ("characterData" === e.type && (e.target === n.leftGuard || e.target === n.rightGuard)) {
                                            var i = n.restore(e.target);
                                            i && (t.range = i)
                                        }
                                    }))
                                }
                            }]), t
                        }(o.default.Embed);
                    t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.AlignStyle = t.AlignClass = t.AlignAttribute = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = {
                            scope: o.default.Scope.BLOCK,
                            whitelist: ["right", "center", "justify"]
                        },
                        s = new o.default.Attributor.Attribute("align", "align", a),
                        l = new o.default.Attributor.Class("align", "ql-align", a),
                        c = new o.default.Attributor.Style("align", "text-align", a);
                    t.AlignAttribute = s, t.AlignClass = l, t.AlignStyle = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.BackgroundStyle = t.BackgroundClass = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = n(26),
                        s = new o.default.Attributor.Class("background", "ql-bg", {
                            scope: o.default.Scope.INLINE
                        }),
                        l = new a.ColorAttributor("background", "background-color", {
                            scope: o.default.Scope.INLINE
                        });
                    t.BackgroundClass = s, t.BackgroundStyle = l
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.DirectionStyle = t.DirectionClass = t.DirectionAttribute = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = {
                            scope: o.default.Scope.BLOCK,
                            whitelist: ["rtl"]
                        },
                        s = new o.default.Attributor.Attribute("direction", "dir", a),
                        l = new o.default.Attributor.Class("direction", "ql-direction", a),
                        c = new o.default.Attributor.Style("direction", "direction", a);
                    t.DirectionAttribute = s, t.DirectionClass = l, t.DirectionStyle = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.FontClass = t.FontStyle = void 0;
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(0),
                        s = (i = a) && i.__esModule ? i : {
                            default: i
                        };

                    function l(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function c(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var u = {
                            scope: s.default.Scope.INLINE,
                            whitelist: ["serif", "monospace"]
                        },
                        d = new s.default.Attributor.Class("font", "ql-font", u),
                        h = function (e) {
                            function t() {
                                return l(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "value",
                                value: function (e) {
                                    return o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "value", this).call(this, e).replace(/["']/g, "")
                                }
                            }]), t
                        }(s.default.Attributor.Style),
                        f = new h("font", "font-family", u);
                    t.FontStyle = f, t.FontClass = d
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.SizeStyle = t.SizeClass = void 0;
                    var i, r = n(0),
                        o = (i = r) && i.__esModule ? i : {
                            default: i
                        },
                        a = new o.default.Attributor.Class("size", "ql-size", {
                            scope: o.default.Scope.INLINE,
                            whitelist: ["small", "large", "huge"]
                        }),
                        s = new o.default.Attributor.Style("size", "font-size", {
                            scope: o.default.Scope.INLINE,
                            whitelist: ["10px", "18px", "32px"]
                        });
                    t.SizeClass = a, t.SizeStyle = s
                }, function (e, t, n) {
                    "use strict";
                    e.exports = {
                        align: {
                            "": n(76),
                            center: n(77),
                            right: n(78),
                            justify: n(79)
                        },
                        background: n(80),
                        blockquote: n(81),
                        bold: n(82),
                        clean: n(83),
                        code: n(58),
                        "code-block": n(58),
                        color: n(84),
                        direction: {
                            "": n(85),
                            rtl: n(86)
                        },
                        float: {
                            center: n(87),
                            full: n(88),
                            left: n(89),
                            right: n(90)
                        },
                        formula: n(91),
                        header: {
                            1: n(92),
                            2: n(93)
                        },
                        italic: n(94),
                        image: n(95),
                        indent: {
                            "+1": n(96),
                            "-1": n(97)
                        },
                        link: n(98),
                        list: {
                            ordered: n(99),
                            bullet: n(100),
                            check: n(101)
                        },
                        script: {
                            sub: n(102),
                            super: n(103)
                        },
                        strike: n(104),
                        underline: n(105),
                        video: n(106)
                    }
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.getLastChangeIndex = t.default = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = a(n(0)),
                        o = a(n(5));

                    function a(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    var s = function (e) {
                        function t(e, n) {
                            ! function (e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                            }(this, t);
                            var i = function (e, t) {
                                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                return !t || "object" != typeof t && "function" != typeof t ? e : t
                            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                            return i.lastRecorded = 0, i.ignoreChange = !1, i.clear(), i.quill.on(o.default.events.EDITOR_CHANGE, (function (e, t, n, r) {
                                e !== o.default.events.TEXT_CHANGE || i.ignoreChange || (i.options.userOnly && r !== o.default.sources.USER ? i.transform(t) : i.record(t, n))
                            })), i.quill.keyboard.addBinding({
                                key: "Z",
                                shortKey: !0
                            }, i.undo.bind(i)), i.quill.keyboard.addBinding({
                                key: "Z",
                                shortKey: !0,
                                shiftKey: !0
                            }, i.redo.bind(i)), /Win/i.test(navigator.platform) && i.quill.keyboard.addBinding({
                                key: "Y",
                                shortKey: !0
                            }, i.redo.bind(i)), i
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), i(t, [{
                            key: "change",
                            value: function (e, t) {
                                if (0 !== this.stack[e].length) {
                                    var n = this.stack[e].pop();
                                    this.stack[t].push(n), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(n[e], o.default.sources.USER), this.ignoreChange = !1;
                                    var i = l(n[e]);
                                    this.quill.setSelection(i)
                                }
                            }
                        }, {
                            key: "clear",
                            value: function () {
                                this.stack = {
                                    undo: [],
                                    redo: []
                                }
                            }
                        }, {
                            key: "cutoff",
                            value: function () {
                                this.lastRecorded = 0
                            }
                        }, {
                            key: "record",
                            value: function (e, t) {
                                if (0 !== e.ops.length) {
                                    this.stack.redo = [];
                                    var n = this.quill.getContents().diff(t),
                                        i = Date.now();
                                    if (this.lastRecorded + this.options.delay > i && this.stack.undo.length > 0) {
                                        var r = this.stack.undo.pop();
                                        n = n.compose(r.undo), e = r.redo.compose(e)
                                    } else this.lastRecorded = i;
                                    this.stack.undo.push({
                                        redo: e,
                                        undo: n
                                    }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift()
                                }
                            }
                        }, {
                            key: "redo",
                            value: function () {
                                this.change("redo", "undo")
                            }
                        }, {
                            key: "transform",
                            value: function (e) {
                                this.stack.undo.forEach((function (t) {
                                    t.undo = e.transform(t.undo, !0), t.redo = e.transform(t.redo, !0)
                                })), this.stack.redo.forEach((function (t) {
                                    t.undo = e.transform(t.undo, !0), t.redo = e.transform(t.redo, !0)
                                }))
                            }
                        }, {
                            key: "undo",
                            value: function () {
                                this.change("undo", "redo")
                            }
                        }]), t
                    }(a(n(9)).default);

                    function l(e) {
                        var t = e.reduce((function (e, t) {
                                return e += t.delete || 0
                            }), 0),
                            n = e.length() - t;
                        return function (e) {
                            var t = e.ops[e.ops.length - 1];
                            return null != t && (null != t.insert ? "string" == typeof t.insert && t.insert.endsWith("\n") : null != t.attributes && Object.keys(t.attributes).some((function (e) {
                                return null != r.default.query(e, r.default.Scope.BLOCK)
                            })))
                        }(e) && (n -= 1), n
                    }
                    s.DEFAULTS = {
                        delay: 1e3,
                        maxStack: 100,
                        userOnly: !1
                    }, t.default = s, t.getLastChangeIndex = l
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.BaseTooltip = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = p(n(3)),
                        a = p(n(2)),
                        s = p(n(8)),
                        l = p(n(23)),
                        c = p(n(34)),
                        u = p(n(59)),
                        d = p(n(60)),
                        h = p(n(28)),
                        f = p(n(61));

                    function p(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function g(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function m(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function v(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var b = [!1, "center", "right", "justify"],
                        y = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"],
                        _ = [!1, "serif", "monospace"],
                        x = ["1", "2", "3", !1],
                        w = ["small", !1, "large", "huge"],
                        E = function (e) {
                            function t(e, n) {
                                g(this, t);
                                var i = m(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                return e.emitter.listenDOM("click", document.body, (function t(n) {
                                    if (!document.body.contains(e.root)) return document.body.removeEventListener("click", t);
                                    null == i.tooltip || i.tooltip.root.contains(n.target) || document.activeElement === i.tooltip.textbox || i.quill.hasFocus() || i.tooltip.hide(), null != i.pickers && i.pickers.forEach((function (e) {
                                        e.container.contains(n.target) || e.close()
                                    }))
                                })), i
                            }
                            return v(t, e), i(t, [{
                                key: "addModule",
                                value: function (e) {
                                    var n = r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "addModule", this).call(this, e);
                                    return "toolbar" === e && this.extendToolbar(n), n
                                }
                            }, {
                                key: "buildButtons",
                                value: function (e, t) {
                                    e.forEach((function (e) {
                                        (e.getAttribute("class") || "").split(/\s+/).forEach((function (n) {
                                            if (n.startsWith("ql-") && (n = n.slice("ql-".length), null != t[n]))
                                                if ("direction" === n) e.innerHTML = t[n][""] + t[n].rtl;
                                                else if ("string" == typeof t[n]) e.innerHTML = t[n];
                                            else {
                                                var i = e.value || "";
                                                null != i && t[n][i] && (e.innerHTML = t[n][i])
                                            }
                                        }))
                                    }))
                                }
                            }, {
                                key: "buildPickers",
                                value: function (e, t) {
                                    var n = this;
                                    this.pickers = e.map((function (e) {
                                        if (e.classList.contains("ql-align")) return null == e.querySelector("option") && O(e, b), new d.default(e, t.align);
                                        if (e.classList.contains("ql-background") || e.classList.contains("ql-color")) {
                                            var n = e.classList.contains("ql-background") ? "background" : "color";
                                            return null == e.querySelector("option") && O(e, y, "background" === n ? "#ffffff" : "#000000"), new u.default(e, t[n])
                                        }
                                        return null == e.querySelector("option") && (e.classList.contains("ql-font") ? O(e, _) : e.classList.contains("ql-header") ? O(e, x) : e.classList.contains("ql-size") && O(e, w)), new h.default(e)
                                    })), this.quill.on(s.default.events.EDITOR_CHANGE, (function () {
                                        n.pickers.forEach((function (e) {
                                            e.update()
                                        }))
                                    }))
                                }
                            }]), t
                        }(c.default);
                    E.DEFAULTS = (0, o.default)(!0, {}, c.default.DEFAULTS, {
                        modules: {
                            toolbar: {
                                handlers: {
                                    formula: function () {
                                        this.quill.theme.tooltip.edit("formula")
                                    },
                                    image: function () {
                                        var e = this,
                                            t = this.container.querySelector("input.ql-image[type=file]");
                                        null == t && ((t = document.createElement("input")).setAttribute("type", "file"), t.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"), t.classList.add("ql-image"), t.addEventListener("change", (function () {
                                            if (null != t.files && null != t.files[0]) {
                                                var n = new FileReader;
                                                n.onload = function (n) {
                                                    var i = e.quill.getSelection(!0);
                                                    e.quill.updateContents((new a.default).retain(i.index).delete(i.length).insert({
                                                        image: n.target.result
                                                    }), s.default.sources.USER), e.quill.setSelection(i.index + 1, s.default.sources.SILENT), t.value = ""
                                                }, n.readAsDataURL(t.files[0])
                                            }
                                        })), this.container.appendChild(t)), t.click()
                                    },
                                    video: function () {
                                        this.quill.theme.tooltip.edit("video")
                                    }
                                }
                            }
                        }
                    });
                    var k = function (e) {
                        function t(e, n) {
                            g(this, t);
                            var i = m(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                            return i.textbox = i.root.querySelector('input[type="text"]'), i.listen(), i
                        }
                        return v(t, e), i(t, [{
                            key: "listen",
                            value: function () {
                                var e = this;
                                this.textbox.addEventListener("keydown", (function (t) {
                                    l.default.match(t, "enter") ? (e.save(), t.preventDefault()) : l.default.match(t, "escape") && (e.cancel(), t.preventDefault())
                                }))
                            }
                        }, {
                            key: "cancel",
                            value: function () {
                                this.hide()
                            }
                        }, {
                            key: "edit",
                            value: function () {
                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "link",
                                    t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                                this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), null != t ? this.textbox.value = t : e !== this.root.getAttribute("data-mode") && (this.textbox.value = ""), this.position(this.quill.getBounds(this.quill.selection.savedRange)), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + e) || ""), this.root.setAttribute("data-mode", e)
                            }
                        }, {
                            key: "restoreFocus",
                            value: function () {
                                var e = this.quill.scrollingContainer.scrollTop;
                                this.quill.focus(), this.quill.scrollingContainer.scrollTop = e
                            }
                        }, {
                            key: "save",
                            value: function () {
                                var e, t, n = this.textbox.value;
                                switch (this.root.getAttribute("data-mode")) {
                                    case "link":
                                        var i = this.quill.root.scrollTop;
                                        this.linkRange ? (this.quill.formatText(this.linkRange, "link", n, s.default.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", n, s.default.sources.USER)), this.quill.root.scrollTop = i;
                                        break;
                                    case "video":
                                        t = (e = n).match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || e.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/), n = t ? (t[1] || "https") + "://www.youtube.com/embed/" + t[2] + "?showinfo=0" : (t = e.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? (t[1] || "https") + "://player.vimeo.com/video/" + t[2] + "/" : e;
                                    case "formula":
                                        if (!n) break;
                                        var r = this.quill.getSelection(!0);
                                        if (null != r) {
                                            var o = r.index + r.length;
                                            this.quill.insertEmbed(o, this.root.getAttribute("data-mode"), n, s.default.sources.USER), "formula" === this.root.getAttribute("data-mode") && this.quill.insertText(o + 1, " ", s.default.sources.USER), this.quill.setSelection(o + 2, s.default.sources.USER)
                                        }
                                }
                                this.textbox.value = "", this.hide()
                            }
                        }]), t
                    }(f.default);

                    function O(e, t) {
                        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        t.forEach((function (t) {
                            var i = document.createElement("option");
                            t === n ? i.setAttribute("selected", "selected") : i.setAttribute("value", t), e.appendChild(i)
                        }))
                    }
                    t.BaseTooltip = k, t.default = E
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                        function e() {
                            this.head = this.tail = null, this.length = 0
                        }
                        return e.prototype.append = function () {
                            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
                            this.insertBefore(e[0], null), e.length > 1 && this.append.apply(this, e.slice(1))
                        }, e.prototype.contains = function (e) {
                            for (var t, n = this.iterator(); t = n();)
                                if (t === e) return !0;
                            return !1
                        }, e.prototype.insertBefore = function (e, t) {
                            e && (e.next = t, null != t ? (e.prev = t.prev, null != t.prev && (t.prev.next = e), t.prev = e, t === this.head && (this.head = e)) : null != this.tail ? (this.tail.next = e, e.prev = this.tail, this.tail = e) : (e.prev = null, this.head = this.tail = e), this.length += 1)
                        }, e.prototype.offset = function (e) {
                            for (var t = 0, n = this.head; null != n;) {
                                if (n === e) return t;
                                t += n.length(), n = n.next
                            }
                            return -1
                        }, e.prototype.remove = function (e) {
                            this.contains(e) && (null != e.prev && (e.prev.next = e.next), null != e.next && (e.next.prev = e.prev), e === this.head && (this.head = e.next), e === this.tail && (this.tail = e.prev), this.length -= 1)
                        }, e.prototype.iterator = function (e) {
                            return void 0 === e && (e = this.head),
                                function () {
                                    var t = e;
                                    return null != e && (e = e.next), t
                                }
                        }, e.prototype.find = function (e, t) {
                            void 0 === t && (t = !1);
                            for (var n, i = this.iterator(); n = i();) {
                                var r = n.length();
                                if (e < r || t && e === r && (null == n.next || 0 !== n.next.length())) return [n, e];
                                e -= r
                            }
                            return [null, 0]
                        }, e.prototype.forEach = function (e) {
                            for (var t, n = this.iterator(); t = n();) e(t)
                        }, e.prototype.forEachAt = function (e, t, n) {
                            if (!(t <= 0))
                                for (var i, r = this.find(e), o = r[0], a = e - r[1], s = this.iterator(o);
                                    (i = s()) && a < e + t;) {
                                    var l = i.length();
                                    e > a ? n(i, e - a, Math.min(t, a + l - e)) : n(i, 0, Math.min(l, e + t - a)), a += l
                                }
                        }, e.prototype.map = function (e) {
                            return this.reduce((function (t, n) {
                                return t.push(e(n)), t
                            }), [])
                        }, e.prototype.reduce = function (e, t) {
                            for (var n, i = this.iterator(); n = i();) t = e(t, n);
                            return t
                        }, e
                    }();
                    t.default = i
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(17),
                        a = n(1),
                        s = {
                            attributes: !0,
                            characterData: !0,
                            characterDataOldValue: !0,
                            childList: !0,
                            subtree: !0
                        },
                        l = function (e) {
                            function t(t) {
                                var n = e.call(this, t) || this;
                                return n.scroll = n, n.observer = new MutationObserver((function (e) {
                                    n.update(e)
                                })), n.observer.observe(n.domNode, s), n.attach(), n
                            }
                            return r(t, e), t.prototype.detach = function () {
                                e.prototype.detach.call(this), this.observer.disconnect()
                            }, t.prototype.deleteAt = function (t, n) {
                                this.update(), 0 === t && n === this.length() ? this.children.forEach((function (e) {
                                    e.remove()
                                })) : e.prototype.deleteAt.call(this, t, n)
                            }, t.prototype.formatAt = function (t, n, i, r) {
                                this.update(), e.prototype.formatAt.call(this, t, n, i, r)
                            }, t.prototype.insertAt = function (t, n, i) {
                                this.update(), e.prototype.insertAt.call(this, t, n, i)
                            }, t.prototype.optimize = function (t, n) {
                                var i = this;
                                void 0 === t && (t = []), void 0 === n && (n = {}), e.prototype.optimize.call(this, n);
                                for (var r = [].slice.call(this.observer.takeRecords()); r.length > 0;) t.push(r.pop());
                                for (var s = function (e, t) {
                                        void 0 === t && (t = !0), null != e && e !== i && null != e.domNode.parentNode && (null == e.domNode[a.DATA_KEY].mutations && (e.domNode[a.DATA_KEY].mutations = []), t && s(e.parent))
                                    }, l = function (e) {
                                        null != e.domNode[a.DATA_KEY] && null != e.domNode[a.DATA_KEY].mutations && (e instanceof o.default && e.children.forEach(l), e.optimize(n))
                                    }, c = t, u = 0; c.length > 0; u += 1) {
                                    if (u >= 100) throw new Error("[Parchment] Maximum optimize iterations reached");
                                    for (c.forEach((function (e) {
                                            var t = a.find(e.target, !0);
                                            null != t && (t.domNode === e.target && ("childList" === e.type ? (s(a.find(e.previousSibling, !1)), [].forEach.call(e.addedNodes, (function (e) {
                                                var t = a.find(e, !1);
                                                s(t, !1), t instanceof o.default && t.children.forEach((function (e) {
                                                    s(e, !1)
                                                }))
                                            }))) : "attributes" === e.type && s(t.prev)), s(t))
                                        })), this.children.forEach(l), r = (c = [].slice.call(this.observer.takeRecords())).slice(); r.length > 0;) t.push(r.pop())
                                }
                            }, t.prototype.update = function (t, n) {
                                var i = this;
                                void 0 === n && (n = {}), (t = t || this.observer.takeRecords()).map((function (e) {
                                    var t = a.find(e.target, !0);
                                    return null == t ? null : null == t.domNode[a.DATA_KEY].mutations ? (t.domNode[a.DATA_KEY].mutations = [e], t) : (t.domNode[a.DATA_KEY].mutations.push(e), null)
                                })).forEach((function (e) {
                                    null != e && e !== i && null != e.domNode[a.DATA_KEY] && e.update(e.domNode[a.DATA_KEY].mutations || [], n)
                                })), null != this.domNode[a.DATA_KEY].mutations && e.prototype.update.call(this, this.domNode[a.DATA_KEY].mutations, n), this.optimize(t, n)
                            }, t.blotName = "scroll", t.defaultChild = "block", t.scope = a.Scope.BLOCK_BLOT, t.tagName = "DIV", t
                        }(o.default);
                    t.default = l
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(18),
                        a = n(1),
                        s = function (e) {
                            function t() {
                                return null !== e && e.apply(this, arguments) || this
                            }
                            return r(t, e), t.formats = function (n) {
                                if (n.tagName !== t.tagName) return e.formats.call(this, n)
                            }, t.prototype.format = function (n, i) {
                                var r = this;
                                n !== this.statics.blotName || i ? e.prototype.format.call(this, n, i) : (this.children.forEach((function (e) {
                                    e instanceof o.default || (e = e.wrap(t.blotName, !0)), r.attributes.copy(e)
                                })), this.unwrap())
                            }, t.prototype.formatAt = function (t, n, i, r) {
                                null != this.formats()[i] || a.query(i, a.Scope.ATTRIBUTE) ? this.isolate(t, n).format(i, r) : e.prototype.formatAt.call(this, t, n, i, r)
                            }, t.prototype.optimize = function (n) {
                                e.prototype.optimize.call(this, n);
                                var i = this.formats();
                                if (0 === Object.keys(i).length) return this.unwrap();
                                var r = this.next;
                                r instanceof t && r.prev === this && function (e, t) {
                                    if (Object.keys(e).length !== Object.keys(t).length) return !1;
                                    for (var n in e)
                                        if (e[n] !== t[n]) return !1;
                                    return !0
                                }(i, r.formats()) && (r.moveChildren(this), r.remove())
                            }, t.blotName = "inline", t.scope = a.Scope.INLINE_BLOT, t.tagName = "SPAN", t
                        }(o.default);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(18),
                        a = n(1),
                        s = function (e) {
                            function t() {
                                return null !== e && e.apply(this, arguments) || this
                            }
                            return r(t, e), t.formats = function (n) {
                                var i = a.query(t.blotName).tagName;
                                if (n.tagName !== i) return e.formats.call(this, n)
                            }, t.prototype.format = function (n, i) {
                                null != a.query(n, a.Scope.BLOCK) && (n !== this.statics.blotName || i ? e.prototype.format.call(this, n, i) : this.replaceWith(t.blotName))
                            }, t.prototype.formatAt = function (t, n, i, r) {
                                null != a.query(i, a.Scope.BLOCK) ? this.format(i, r) : e.prototype.formatAt.call(this, t, n, i, r)
                            }, t.prototype.insertAt = function (t, n, i) {
                                if (null == i || null != a.query(n, a.Scope.INLINE)) e.prototype.insertAt.call(this, t, n, i);
                                else {
                                    var r = this.split(t),
                                        o = a.create(n, i);
                                    r.parent.insertBefore(o, r)
                                }
                            }, t.prototype.update = function (t, n) {
                                navigator.userAgent.match(/Trident/) ? this.build() : e.prototype.update.call(this, t, n)
                            }, t.blotName = "block", t.scope = a.Scope.BLOCK_BLOT, t.tagName = "P", t
                        }(o.default);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = function (e) {
                        function t() {
                            return null !== e && e.apply(this, arguments) || this
                        }
                        return r(t, e), t.formats = function (e) {}, t.prototype.format = function (t, n) {
                            e.prototype.formatAt.call(this, 0, this.length(), t, n)
                        }, t.prototype.formatAt = function (t, n, i, r) {
                            0 === t && n === this.length() ? this.format(i, r) : e.prototype.formatAt.call(this, t, n, i, r)
                        }, t.prototype.formats = function () {
                            return this.statics.formats(this.domNode)
                        }, t
                    }(n(19).default);
                    t.default = o
                }, function (e, t, n) {
                    "use strict";
                    var i, r = this && this.__extends || (i = Object.setPrototypeOf || {
                            __proto__: []
                        }
                        instanceof Array && function (e, t) {
                            e.__proto__ = t
                        } || function (e, t) {
                            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n])
                        },
                        function (e, t) {
                            function n() {
                                this.constructor = e
                            }
                            i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n)
                        });
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var o = n(19),
                        a = n(1),
                        s = function (e) {
                            function t(t) {
                                var n = e.call(this, t) || this;
                                return n.text = n.statics.value(n.domNode), n
                            }
                            return r(t, e), t.create = function (e) {
                                return document.createTextNode(e)
                            }, t.value = function (e) {
                                var t = e.data;
                                return t.normalize && (t = t.normalize()), t
                            }, t.prototype.deleteAt = function (e, t) {
                                this.domNode.data = this.text = this.text.slice(0, e) + this.text.slice(e + t)
                            }, t.prototype.index = function (e, t) {
                                return this.domNode === e ? t : -1
                            }, t.prototype.insertAt = function (t, n, i) {
                                null == i ? (this.text = this.text.slice(0, t) + n + this.text.slice(t), this.domNode.data = this.text) : e.prototype.insertAt.call(this, t, n, i)
                            }, t.prototype.length = function () {
                                return this.text.length
                            }, t.prototype.optimize = function (n) {
                                e.prototype.optimize.call(this, n), this.text = this.statics.value(this.domNode), 0 === this.text.length ? this.remove() : this.next instanceof t && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove())
                            }, t.prototype.position = function (e, t) {
                                return void 0 === t && (t = !1), [this.domNode, e]
                            }, t.prototype.split = function (e, t) {
                                if (void 0 === t && (t = !1), !t) {
                                    if (0 === e) return this;
                                    if (e === this.length()) return this.next
                                }
                                var n = a.create(this.domNode.splitText(e));
                                return this.parent.insertBefore(n, this.next), this.text = this.statics.value(this.domNode), n
                            }, t.prototype.update = function (e, t) {
                                var n = this;
                                e.some((function (e) {
                                    return "characterData" === e.type && e.target === n.domNode
                                })) && (this.text = this.statics.value(this.domNode))
                            }, t.prototype.value = function () {
                                return this.text
                            }, t.blotName = "text", t.scope = a.Scope.INLINE_BLOT, t
                        }(o.default);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    var i = document.createElement("div");
                    if (i.classList.toggle("test-class", !1), i.classList.contains("test-class")) {
                        var r = DOMTokenList.prototype.toggle;
                        DOMTokenList.prototype.toggle = function (e, t) {
                            return arguments.length > 1 && !this.contains(e) == !t ? t : r.call(this, e)
                        }
                    }
                    String.prototype.startsWith || (String.prototype.startsWith = function (e, t) {
                        return t = t || 0, this.substr(t, e.length) === e
                    }), String.prototype.endsWith || (String.prototype.endsWith = function (e, t) {
                        var n = this.toString();
                        ("number" != typeof t || !isFinite(t) || Math.floor(t) !== t || t > n.length) && (t = n.length), t -= e.length;
                        var i = n.indexOf(e, t);
                        return -1 !== i && i === t
                    }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
                        value: function (e) {
                            if (null === this) throw new TypeError("Array.prototype.find called on null or undefined");
                            if ("function" != typeof e) throw new TypeError("predicate must be a function");
                            for (var t, n = Object(this), i = n.length >>> 0, r = arguments[1], o = 0; o < i; o++)
                                if (t = n[o], e.call(r, t, o, n)) return t
                        }
                    }), document.addEventListener("DOMContentLoaded", (function () {
                        document.execCommand("enableObjectResizing", !1, !1), document.execCommand("autoUrlDetect", !1, !1)
                    }))
                }, function (e, t) {
                    var n = -1;

                    function i(e, t, l) {
                        if (e == t) return e ? [
                            [0, e]
                        ] : [];
                        (l < 0 || e.length < l) && (l = null);
                        var u = o(e, t),
                            d = e.substring(0, u);
                        u = a(e = e.substring(u), t = t.substring(u));
                        var h = e.substring(e.length - u),
                            f = function (e, t) {
                                var s;
                                if (!e) return [
                                    [1, t]
                                ];
                                if (!t) return [
                                    [n, e]
                                ];
                                var l = e.length > t.length ? e : t,
                                    c = e.length > t.length ? t : e,
                                    u = l.indexOf(c);
                                if (-1 != u) return s = [
                                    [1, l.substring(0, u)],
                                    [0, c],
                                    [1, l.substring(u + c.length)]
                                ], e.length > t.length && (s[0][0] = s[2][0] = n), s;
                                if (1 == c.length) return [
                                    [n, e],
                                    [1, t]
                                ];
                                var d = function (e, t) {
                                    var n = e.length > t.length ? e : t,
                                        i = e.length > t.length ? t : e;
                                    if (n.length < 4 || 2 * i.length < n.length) return null;

                                    function r(e, t, n) {
                                        for (var i, r, s, l, c = e.substring(n, n + Math.floor(e.length / 4)), u = -1, d = ""; - 1 != (u = t.indexOf(c, u + 1));) {
                                            var h = o(e.substring(n), t.substring(u)),
                                                f = a(e.substring(0, n), t.substring(0, u));
                                            d.length < f + h && (d = t.substring(u - f, u) + t.substring(u, u + h), i = e.substring(0, n - f), r = e.substring(n + h), s = t.substring(0, u - f), l = t.substring(u + h))
                                        }
                                        return 2 * d.length >= e.length ? [i, r, s, l, d] : null
                                    }
                                    var s, l, c, u, d, h = r(n, i, Math.ceil(n.length / 4)),
                                        f = r(n, i, Math.ceil(n.length / 2));
                                    if (!h && !f) return null;
                                    s = f ? h && h[4].length > f[4].length ? h : f : h, e.length > t.length ? (l = s[0], c = s[1], u = s[2], d = s[3]) : (u = s[0], d = s[1], l = s[2], c = s[3]);
                                    var p = s[4];
                                    return [l, c, u, d, p]
                                }(e, t);
                                if (d) {
                                    var h = d[0],
                                        f = d[1],
                                        p = d[2],
                                        g = d[3],
                                        m = d[4],
                                        v = i(h, p),
                                        b = i(f, g);
                                    return v.concat([
                                        [0, m]
                                    ], b)
                                }
                                return function (e, t) {
                                    for (var i = e.length, o = t.length, a = Math.ceil((i + o) / 2), s = a, l = 2 * a, c = new Array(l), u = new Array(l), d = 0; d < l; d++) c[d] = -1, u[d] = -1;
                                    c[s + 1] = 0, u[s + 1] = 0;
                                    for (var h = i - o, f = h % 2 != 0, p = 0, g = 0, m = 0, v = 0, b = 0; b < a; b++) {
                                        for (var y = -b + p; y <= b - g; y += 2) {
                                            for (var _ = s + y, x = (S = y == -b || y != b && c[_ - 1] < c[_ + 1] ? c[_ + 1] : c[_ - 1] + 1) - y; S < i && x < o && e.charAt(S) == t.charAt(x);) S++, x++;
                                            if (c[_] = S, S > i) g += 2;
                                            else if (x > o) p += 2;
                                            else if (f && (k = s + h - y) >= 0 && k < l && -1 != u[k] && S >= (E = i - u[k])) return r(e, t, S, x)
                                        }
                                        for (var w = -b + m; w <= b - v; w += 2) {
                                            for (var E, k = s + w, O = (E = w == -b || w != b && u[k - 1] < u[k + 1] ? u[k + 1] : u[k - 1] + 1) - w; E < i && O < o && e.charAt(i - E - 1) == t.charAt(o - O - 1);) E++, O++;
                                            if (u[k] = E, E > i) v += 2;
                                            else if (O > o) m += 2;
                                            else if (!f) {
                                                var S;
                                                if ((_ = s + h - w) >= 0 && _ < l && -1 != c[_])
                                                    if (x = s + (S = c[_]) - _, S >= (E = i - E)) return r(e, t, S, x)
                                            }
                                        }
                                    }
                                    return [
                                        [n, e],
                                        [1, t]
                                    ]
                                }(e, t)
                            }(e = e.substring(0, e.length - u), t = t.substring(0, t.length - u));
                        return d && f.unshift([0, d]), h && f.push([0, h]), s(f), null != l && (f = function (e, t) {
                            var i = function (e, t) {
                                    if (0 === t) return [0, e];
                                    for (var i = 0, r = 0; r < e.length; r++) {
                                        var o = e[r];
                                        if (o[0] === n || 0 === o[0]) {
                                            var a = i + o[1].length;
                                            if (t === a) return [r + 1, e];
                                            if (t < a) {
                                                e = e.slice();
                                                var s = t - i,
                                                    l = [o[0], o[1].slice(0, s)],
                                                    c = [o[0], o[1].slice(s)];
                                                return e.splice(r, 1, l, c), [r + 1, e]
                                            }
                                            i = a
                                        }
                                    }
                                    throw new Error("cursor_pos is out of bounds!")
                                }(e, t),
                                r = i[1],
                                o = i[0],
                                a = r[o],
                                s = r[o + 1];
                            if (null == a) return e;
                            if (0 !== a[0]) return e;
                            if (null != s && a[1] + s[1] === s[1] + a[1]) return r.splice(o, 2, s, a), c(r, o, 2);
                            if (null != s && 0 === s[1].indexOf(a[1])) {
                                r.splice(o, 2, [s[0], a[1]], [0, a[1]]);
                                var l = s[1].slice(a[1].length);
                                return l.length > 0 && r.splice(o + 2, 0, [s[0], l]), c(r, o, 3)
                            }
                            return e
                        }(f, l)), f = function (e) {
                            for (var t = !1, i = function (e) {
                                    return e.charCodeAt(0) >= 56320 && e.charCodeAt(0) <= 57343
                                }, r = function (e) {
                                    return e.charCodeAt(e.length - 1) >= 55296 && e.charCodeAt(e.length - 1) <= 56319
                                }, o = 2; o < e.length; o += 1) 0 === e[o - 2][0] && r(e[o - 2][1]) && e[o - 1][0] === n && i(e[o - 1][1]) && 1 === e[o][0] && i(e[o][1]) && (t = !0, e[o - 1][1] = e[o - 2][1].slice(-1) + e[o - 1][1], e[o][1] = e[o - 2][1].slice(-1) + e[o][1], e[o - 2][1] = e[o - 2][1].slice(0, -1));
                            if (!t) return e;
                            var a = [];
                            for (o = 0; o < e.length; o += 1) e[o][1].length > 0 && a.push(e[o]);
                            return a
                        }(f)
                    }

                    function r(e, t, n, r) {
                        var o = e.substring(0, n),
                            a = t.substring(0, r),
                            s = e.substring(n),
                            l = t.substring(r),
                            c = i(o, a),
                            u = i(s, l);
                        return c.concat(u)
                    }

                    function o(e, t) {
                        if (!e || !t || e.charAt(0) != t.charAt(0)) return 0;
                        for (var n = 0, i = Math.min(e.length, t.length), r = i, o = 0; n < r;) e.substring(o, r) == t.substring(o, r) ? o = n = r : i = r, r = Math.floor((i - n) / 2 + n);
                        return r
                    }

                    function a(e, t) {
                        if (!e || !t || e.charAt(e.length - 1) != t.charAt(t.length - 1)) return 0;
                        for (var n = 0, i = Math.min(e.length, t.length), r = i, o = 0; n < r;) e.substring(e.length - r, e.length - o) == t.substring(t.length - r, t.length - o) ? o = n = r : i = r, r = Math.floor((i - n) / 2 + n);
                        return r
                    }

                    function s(e) {
                        e.push([0, ""]);
                        for (var t, i = 0, r = 0, l = 0, c = "", u = ""; i < e.length;) switch (e[i][0]) {
                            case 1:
                                l++, u += e[i][1], i++;
                                break;
                            case n:
                                r++, c += e[i][1], i++;
                                break;
                            case 0:
                                r + l > 1 ? (0 !== r && 0 !== l && (0 !== (t = o(u, c)) && (i - r - l > 0 && 0 == e[i - r - l - 1][0] ? e[i - r - l - 1][1] += u.substring(0, t) : (e.splice(0, 0, [0, u.substring(0, t)]), i++), u = u.substring(t), c = c.substring(t)), 0 !== (t = a(u, c)) && (e[i][1] = u.substring(u.length - t) + e[i][1], u = u.substring(0, u.length - t), c = c.substring(0, c.length - t))), 0 === r ? e.splice(i - l, r + l, [1, u]) : 0 === l ? e.splice(i - r, r + l, [n, c]) : e.splice(i - r - l, r + l, [n, c], [1, u]), i = i - r - l + (r ? 1 : 0) + (l ? 1 : 0) + 1) : 0 !== i && 0 == e[i - 1][0] ? (e[i - 1][1] += e[i][1], e.splice(i, 1)) : i++, l = 0, r = 0, c = "", u = ""
                        }
                        "" === e[e.length - 1][1] && e.pop();
                        var d = !1;
                        for (i = 1; i < e.length - 1;) 0 == e[i - 1][0] && 0 == e[i + 1][0] && (e[i][1].substring(e[i][1].length - e[i - 1][1].length) == e[i - 1][1] ? (e[i][1] = e[i - 1][1] + e[i][1].substring(0, e[i][1].length - e[i - 1][1].length), e[i + 1][1] = e[i - 1][1] + e[i + 1][1], e.splice(i - 1, 1), d = !0) : e[i][1].substring(0, e[i + 1][1].length) == e[i + 1][1] && (e[i - 1][1] += e[i + 1][1], e[i][1] = e[i][1].substring(e[i + 1][1].length) + e[i + 1][1], e.splice(i + 1, 1), d = !0)), i++;
                        d && s(e)
                    }
                    var l = i;

                    function c(e, t, n) {
                        for (var i = t + n - 1; i >= 0 && i >= t - 1; i--)
                            if (i + 1 < e.length) {
                                var r = e[i],
                                    o = e[i + 1];
                                r[0] === o[1] && e.splice(i, 2, [r[0], r[1] + o[1]])
                            } return e
                    }
                    l.INSERT = 1, l.DELETE = n, l.EQUAL = 0, e.exports = l
                }, function (e, t) {
                    function n(e) {
                        var t = [];
                        for (var n in e) t.push(n);
                        return t
                    }(e.exports = "function" == typeof Object.keys ? Object.keys : n).shim = n
                }, function (e, t) {
                    var n = "[object Arguments]" == function () {
                        return Object.prototype.toString.call(arguments)
                    }();

                    function i(e) {
                        return "[object Arguments]" == Object.prototype.toString.call(e)
                    }

                    function r(e) {
                        return e && "object" == typeof e && "number" == typeof e.length && Object.prototype.hasOwnProperty.call(e, "callee") && !Object.prototype.propertyIsEnumerable.call(e, "callee") || !1
                    }(t = e.exports = n ? i : r).supported = i, t.unsupported = r
                }, function (e, t) {
                    "use strict";
                    var n = Object.prototype.hasOwnProperty,
                        i = "~";

                    function r() {}

                    function o(e, t, n) {
                        this.fn = e, this.context = t, this.once = n || !1
                    }

                    function a() {
                        this._events = new r, this._eventsCount = 0
                    }
                    Object.create && (r.prototype = Object.create(null), (new r).__proto__ || (i = !1)), a.prototype.eventNames = function () {
                        var e, t, r = [];
                        if (0 === this._eventsCount) return r;
                        for (t in e = this._events) n.call(e, t) && r.push(i ? t.slice(1) : t);
                        return Object.getOwnPropertySymbols ? r.concat(Object.getOwnPropertySymbols(e)) : r
                    }, a.prototype.listeners = function (e, t) {
                        var n = i ? i + e : e,
                            r = this._events[n];
                        if (t) return !!r;
                        if (!r) return [];
                        if (r.fn) return [r.fn];
                        for (var o = 0, a = r.length, s = new Array(a); o < a; o++) s[o] = r[o].fn;
                        return s
                    }, a.prototype.emit = function (e, t, n, r, o, a) {
                        var s = i ? i + e : e;
                        if (!this._events[s]) return !1;
                        var l, c, u = this._events[s],
                            d = arguments.length;
                        if (u.fn) {
                            switch (u.once && this.removeListener(e, u.fn, void 0, !0), d) {
                                case 1:
                                    return u.fn.call(u.context), !0;
                                case 2:
                                    return u.fn.call(u.context, t), !0;
                                case 3:
                                    return u.fn.call(u.context, t, n), !0;
                                case 4:
                                    return u.fn.call(u.context, t, n, r), !0;
                                case 5:
                                    return u.fn.call(u.context, t, n, r, o), !0;
                                case 6:
                                    return u.fn.call(u.context, t, n, r, o, a), !0
                            }
                            for (c = 1, l = new Array(d - 1); c < d; c++) l[c - 1] = arguments[c];
                            u.fn.apply(u.context, l)
                        } else {
                            var h, f = u.length;
                            for (c = 0; c < f; c++) switch (u[c].once && this.removeListener(e, u[c].fn, void 0, !0), d) {
                                case 1:
                                    u[c].fn.call(u[c].context);
                                    break;
                                case 2:
                                    u[c].fn.call(u[c].context, t);
                                    break;
                                case 3:
                                    u[c].fn.call(u[c].context, t, n);
                                    break;
                                case 4:
                                    u[c].fn.call(u[c].context, t, n, r);
                                    break;
                                default:
                                    if (!l)
                                        for (h = 1, l = new Array(d - 1); h < d; h++) l[h - 1] = arguments[h];
                                    u[c].fn.apply(u[c].context, l)
                            }
                        }
                        return !0
                    }, a.prototype.on = function (e, t, n) {
                        var r = new o(t, n || this),
                            a = i ? i + e : e;
                        return this._events[a] ? this._events[a].fn ? this._events[a] = [this._events[a], r] : this._events[a].push(r) : (this._events[a] = r, this._eventsCount++), this
                    }, a.prototype.once = function (e, t, n) {
                        var r = new o(t, n || this, !0),
                            a = i ? i + e : e;
                        return this._events[a] ? this._events[a].fn ? this._events[a] = [this._events[a], r] : this._events[a].push(r) : (this._events[a] = r, this._eventsCount++), this
                    }, a.prototype.removeListener = function (e, t, n, o) {
                        var a = i ? i + e : e;
                        if (!this._events[a]) return this;
                        if (!t) return 0 == --this._eventsCount ? this._events = new r : delete this._events[a], this;
                        var s = this._events[a];
                        if (s.fn) s.fn !== t || o && !s.once || n && s.context !== n || (0 == --this._eventsCount ? this._events = new r : delete this._events[a]);
                        else {
                            for (var l = 0, c = [], u = s.length; l < u; l++)(s[l].fn !== t || o && !s[l].once || n && s[l].context !== n) && c.push(s[l]);
                            c.length ? this._events[a] = 1 === c.length ? c[0] : c : 0 == --this._eventsCount ? this._events = new r : delete this._events[a]
                        }
                        return this
                    }, a.prototype.removeAllListeners = function (e) {
                        var t;
                        return e ? (t = i ? i + e : e, this._events[t] && (0 == --this._eventsCount ? this._events = new r : delete this._events[t])) : (this._events = new r, this._eventsCount = 0), this
                    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prototype.setMaxListeners = function () {
                        return this
                    }, a.prefixed = i, a.EventEmitter = a, void 0 !== e && (e.exports = a)
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.matchText = t.matchSpacing = t.matchNewline = t.matchBlot = t.matchAttributor = t.default = void 0;
                    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                            return typeof e
                        } : function (e) {
                            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                        },
                        r = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        a = y(n(3)),
                        s = y(n(2)),
                        l = y(n(0)),
                        c = y(n(5)),
                        u = y(n(10)),
                        d = y(n(9)),
                        h = n(36),
                        f = n(37),
                        p = y(n(13)),
                        g = n(26),
                        m = n(38),
                        v = n(39),
                        b = n(40);

                    function y(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function _(e, t, n) {
                        return t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e
                    }
                    var x = (0, u.default)("quill:clipboard"),
                        w = "__ql-matcher",
                        E = [
                            [Node.TEXT_NODE, R],
                            [Node.TEXT_NODE, j],
                            ["br", function (e, t) {
                                return M(t, "\n") || t.insert("\n"), t
                            }],
                            [Node.ELEMENT_NODE, j],
                            [Node.ELEMENT_NODE, N],
                            [Node.ELEMENT_NODE, I],
                            [Node.ELEMENT_NODE, L],
                            [Node.ELEMENT_NODE, function (e, t) {
                                var n = {},
                                    i = e.style || {};
                                return i.fontStyle && "italic" === A(e).fontStyle && (n.italic = !0), i.fontWeight && (A(e).fontWeight.startsWith("bold") || parseInt(A(e).fontWeight) >= 700) && (n.bold = !0), Object.keys(n).length > 0 && (t = C(t, n)), parseFloat(i.textIndent || 0) > 0 && (t = (new s.default).insert("\t").concat(t)), t
                            }],
                            ["li", function (e, t) {
                                var n = l.default.query(e);
                                if (null == n || "list-item" !== n.blotName || !M(t, "\n")) return t;
                                for (var i = -1, r = e.parentNode; !r.classList.contains("ql-clipboard");) "list" === (l.default.query(r) || {}).blotName && (i += 1), r = r.parentNode;
                                return i <= 0 ? t : t.compose((new s.default).retain(t.length() - 1).retain(1, {
                                    indent: i
                                }))
                            }],
                            ["b", D.bind(D, "bold")],
                            ["i", D.bind(D, "italic")],
                            ["style", function () {
                                return new s.default
                            }]
                        ],
                        k = [h.AlignAttribute, m.DirectionAttribute].reduce((function (e, t) {
                            return e[t.keyName] = t, e
                        }), {}),
                        O = [h.AlignStyle, f.BackgroundStyle, g.ColorStyle, m.DirectionStyle, v.FontStyle, b.SizeStyle].reduce((function (e, t) {
                            return e[t.keyName] = t, e
                        }), {}),
                        S = function (e) {
                            function t(e, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var i = function (e, t) {
                                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                return i.quill.root.addEventListener("paste", i.onPaste.bind(i)), i.container = i.quill.addContainer("ql-clipboard"), i.container.setAttribute("contenteditable", !0), i.container.setAttribute("tabindex", -1), i.matchers = [], E.concat(i.options.matchers).forEach((function (e) {
                                    var t = r(e, 2),
                                        o = t[0],
                                        a = t[1];
                                    (n.matchVisual || a !== I) && i.addMatcher(o, a)
                                })), i
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), o(t, [{
                                key: "addMatcher",
                                value: function (e, t) {
                                    this.matchers.push([e, t])
                                }
                            }, {
                                key: "convert",
                                value: function (e) {
                                    if ("string" == typeof e) return this.container.innerHTML = e.replace(/\>\r?\n +\</g, "><"), this.convert();
                                    var t = this.quill.getFormat(this.quill.selection.savedRange.index);
                                    if (t[p.default.blotName]) {
                                        var n = this.container.innerText;
                                        return this.container.innerHTML = "", (new s.default).insert(n, _({}, p.default.blotName, t[p.default.blotName]))
                                    }
                                    var i = this.prepareMatching(),
                                        o = r(i, 2),
                                        a = o[0],
                                        l = o[1],
                                        c = P(this.container, a, l);
                                    return M(c, "\n") && null == c.ops[c.ops.length - 1].attributes && (c = c.compose((new s.default).retain(c.length() - 1).delete(1))), x.log("convert", this.container.innerHTML, c), this.container.innerHTML = "", c
                                }
                            }, {
                                key: "dangerouslyPasteHTML",
                                value: function (e, t) {
                                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : c.default.sources.API;
                                    if ("string" == typeof e) this.quill.setContents(this.convert(e), t), this.quill.setSelection(0, c.default.sources.SILENT);
                                    else {
                                        var i = this.convert(t);
                                        this.quill.updateContents((new s.default).retain(e).concat(i), n), this.quill.setSelection(e + i.length(), c.default.sources.SILENT)
                                    }
                                }
                            }, {
                                key: "onPaste",
                                value: function (e) {
                                    var t = this;
                                    if (!e.defaultPrevented && this.quill.isEnabled()) {
                                        var n = this.quill.getSelection(),
                                            i = (new s.default).retain(n.index),
                                            r = this.quill.scrollingContainer.scrollTop;
                                        this.container.focus(), this.quill.selection.update(c.default.sources.SILENT), setTimeout((function () {
                                            i = i.concat(t.convert()).delete(n.length), t.quill.updateContents(i, c.default.sources.USER), t.quill.setSelection(i.length() - n.length, c.default.sources.SILENT), t.quill.scrollingContainer.scrollTop = r, t.quill.focus()
                                        }), 1)
                                    }
                                }
                            }, {
                                key: "prepareMatching",
                                value: function () {
                                    var e = this,
                                        t = [],
                                        n = [];
                                    return this.matchers.forEach((function (i) {
                                        var o = r(i, 2),
                                            a = o[0],
                                            s = o[1];
                                        switch (a) {
                                            case Node.TEXT_NODE:
                                                n.push(s);
                                                break;
                                            case Node.ELEMENT_NODE:
                                                t.push(s);
                                                break;
                                            default:
                                                [].forEach.call(e.container.querySelectorAll(a), (function (e) {
                                                    e[w] = e[w] || [], e[w].push(s)
                                                }))
                                        }
                                    })), [t, n]
                                }
                            }]), t
                        }(d.default);

                    function C(e, t, n) {
                        return "object" === (void 0 === t ? "undefined" : i(t)) ? Object.keys(t).reduce((function (e, n) {
                            return C(e, n, t[n])
                        }), e) : e.reduce((function (e, i) {
                            return i.attributes && i.attributes[t] ? e.push(i) : e.insert(i.insert, (0, a.default)({}, _({}, t, n), i.attributes))
                        }), new s.default)
                    }

                    function A(e) {
                        if (e.nodeType !== Node.ELEMENT_NODE) return {};
                        var t = "__ql-computed-style";
                        return e[t] || (e[t] = window.getComputedStyle(e))
                    }

                    function M(e, t) {
                        for (var n = "", i = e.ops.length - 1; i >= 0 && n.length < t.length; --i) {
                            var r = e.ops[i];
                            if ("string" != typeof r.insert) break;
                            n = r.insert + n
                        }
                        return n.slice(-1 * t.length) === t
                    }

                    function T(e) {
                        if (0 === e.childNodes.length) return !1;
                        var t = A(e);
                        return ["block", "list-item"].indexOf(t.display) > -1
                    }

                    function P(e, t, n) {
                        return e.nodeType === e.TEXT_NODE ? n.reduce((function (t, n) {
                            return n(e, t)
                        }), new s.default) : e.nodeType === e.ELEMENT_NODE ? [].reduce.call(e.childNodes || [], (function (i, r) {
                            var o = P(r, t, n);
                            return r.nodeType === e.ELEMENT_NODE && (o = t.reduce((function (e, t) {
                                return t(r, e)
                            }), o), o = (r[w] || []).reduce((function (e, t) {
                                return t(r, e)
                            }), o)), i.concat(o)
                        }), new s.default) : new s.default
                    }

                    function D(e, t, n) {
                        return C(n, e, !0)
                    }

                    function L(e, t) {
                        var n = l.default.Attributor.Attribute.keys(e),
                            i = l.default.Attributor.Class.keys(e),
                            r = l.default.Attributor.Style.keys(e),
                            o = {};
                        return n.concat(i).concat(r).forEach((function (t) {
                            var n = l.default.query(t, l.default.Scope.ATTRIBUTE);
                            null != n && (o[n.attrName] = n.value(e), o[n.attrName]) || (null == (n = k[t]) || n.attrName !== t && n.keyName !== t || (o[n.attrName] = n.value(e) || void 0), null == (n = O[t]) || n.attrName !== t && n.keyName !== t || (n = O[t], o[n.attrName] = n.value(e) || void 0))
                        })), Object.keys(o).length > 0 && (t = C(t, o)), t
                    }

                    function N(e, t) {
                        var n = l.default.query(e);
                        if (null == n) return t;
                        if (n.prototype instanceof l.default.Embed) {
                            var i = {},
                                r = n.value(e);
                            null != r && (i[n.blotName] = r, t = (new s.default).insert(i, n.formats(e)))
                        } else "function" == typeof n.formats && (t = C(t, n.blotName, n.formats(e)));
                        return t
                    }

                    function j(e, t) {
                        return M(t, "\n") || (T(e) || t.length() > 0 && e.nextSibling && T(e.nextSibling)) && t.insert("\n"), t
                    }

                    function I(e, t) {
                        if (T(e) && null != e.nextElementSibling && !M(t, "\n\n")) {
                            var n = e.offsetHeight + parseFloat(A(e).marginTop) + parseFloat(A(e).marginBottom);
                            e.nextElementSibling.offsetTop > e.offsetTop + 1.5 * n && t.insert("\n")
                        }
                        return t
                    }

                    function R(e, t) {
                        var n = e.data;
                        if ("O:P" === e.parentNode.tagName) return t.insert(n.trim());
                        if (0 === n.trim().length && e.parentNode.classList.contains("ql-clipboard")) return t;
                        if (!A(e.parentNode).whiteSpace.startsWith("pre")) {
                            var i = function (e, t) {
                                return (t = t.replace(/[^\u00a0]/g, "")).length < 1 && e ? " " : t
                            };
                            n = (n = n.replace(/\r\n/g, " ").replace(/\n/g, " ")).replace(/\s\s+/g, i.bind(i, !0)), (null == e.previousSibling && T(e.parentNode) || null != e.previousSibling && T(e.previousSibling)) && (n = n.replace(/^\s+/, i.bind(i, !1))), (null == e.nextSibling && T(e.parentNode) || null != e.nextSibling && T(e.nextSibling)) && (n = n.replace(/\s+$/, i.bind(i, !1)))
                        }
                        return t.insert(n)
                    }
                    S.DEFAULTS = {
                        matchers: [],
                        matchVisual: !0
                    }, t.default = S, t.matchAttributor = L, t.matchBlot = N, t.matchNewline = j, t.matchSpacing = I, t.matchText = R
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(6);

                    function s(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function l(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var c = function (e) {
                        function t() {
                            return s(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, [{
                            key: "optimize",
                            value: function (e) {
                                o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName)
                            }
                        }], [{
                            key: "create",
                            value: function () {
                                return o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this)
                            }
                        }, {
                            key: "formats",
                            value: function () {
                                return !0
                            }
                        }]), t
                    }(((i = a) && i.__esModule ? i : {
                        default: i
                    }).default);
                    c.blotName = "bold", c.tagName = ["STRONG", "B"], t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.addControls = t.default = void 0;
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = u(n(2)),
                        a = u(n(0)),
                        s = u(n(5)),
                        l = u(n(10)),
                        c = u(n(9));

                    function u(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function d(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var h = (0, l.default)("quill:toolbar"),
                        f = function (e) {
                            function t(e, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var r, o = d(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                if (Array.isArray(o.options.container)) {
                                    var a = document.createElement("div");
                                    g(a, o.options.container), e.container.parentNode.insertBefore(a, e.container), o.container = a
                                } else "string" == typeof o.options.container ? o.container = document.querySelector(o.options.container) : o.container = o.options.container;
                                return o.container instanceof HTMLElement ? (o.container.classList.add("ql-toolbar"), o.controls = [], o.handlers = {}, Object.keys(o.options.handlers).forEach((function (e) {
                                    o.addHandler(e, o.options.handlers[e])
                                })), [].forEach.call(o.container.querySelectorAll("button, select"), (function (e) {
                                    o.attach(e)
                                })), o.quill.on(s.default.events.EDITOR_CHANGE, (function (e, t) {
                                    e === s.default.events.SELECTION_CHANGE && o.update(t)
                                })), o.quill.on(s.default.events.SCROLL_OPTIMIZE, (function () {
                                    var e = o.quill.selection.getRange(),
                                        t = i(e, 1)[0];
                                    o.update(t)
                                })), o) : (r = h.error("Container required for toolbar", o.options), d(o, r))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "addHandler",
                                value: function (e, t) {
                                    this.handlers[e] = t
                                }
                            }, {
                                key: "attach",
                                value: function (e) {
                                    var t = this,
                                        n = [].find.call(e.classList, (function (e) {
                                            return 0 === e.indexOf("ql-")
                                        }));
                                    if (n) {
                                        if (n = n.slice("ql-".length), "BUTTON" === e.tagName && e.setAttribute("type", "button"), null == this.handlers[n]) {
                                            if (null != this.quill.scroll.whitelist && null == this.quill.scroll.whitelist[n]) return void h.warn("ignoring attaching to disabled format", n, e);
                                            if (null == a.default.query(n)) return void h.warn("ignoring attaching to nonexistent format", n, e)
                                        }
                                        var r = "SELECT" === e.tagName ? "change" : "click";
                                        e.addEventListener(r, (function (r) {
                                            var l = void 0;
                                            if ("SELECT" === e.tagName) {
                                                if (e.selectedIndex < 0) return;
                                                var c = e.options[e.selectedIndex];
                                                l = !c.hasAttribute("selected") && (c.value || !1)
                                            } else l = !e.classList.contains("ql-active") && (e.value || !e.hasAttribute("value")), r.preventDefault();
                                            t.quill.focus();
                                            var u = t.quill.selection.getRange(),
                                                d = i(u, 1)[0];
                                            if (null != t.handlers[n]) t.handlers[n].call(t, l);
                                            else if (a.default.query(n).prototype instanceof a.default.Embed) {
                                                if (!(l = prompt("Enter " + n))) return;
                                                t.quill.updateContents((new o.default).retain(d.index).delete(d.length).insert(function (e, t, n) {
                                                    return t in e ? Object.defineProperty(e, t, {
                                                        value: n,
                                                        enumerable: !0,
                                                        configurable: !0,
                                                        writable: !0
                                                    }) : e[t] = n, e
                                                }({}, n, l)), s.default.sources.USER)
                                            } else t.quill.format(n, l, s.default.sources.USER);
                                            t.update(d)
                                        })), this.controls.push([n, e])
                                    }
                                }
                            }, {
                                key: "update",
                                value: function (e) {
                                    var t = null == e ? {} : this.quill.getFormat(e);
                                    this.controls.forEach((function (n) {
                                        var r = i(n, 2),
                                            o = r[0],
                                            a = r[1];
                                        if ("SELECT" === a.tagName) {
                                            var s = void 0;
                                            if (null == e) s = null;
                                            else if (null == t[o]) s = a.querySelector("option[selected]");
                                            else if (!Array.isArray(t[o])) {
                                                var l = t[o];
                                                "string" == typeof l && (l = l.replace(/\"/g, '\\"')), s = a.querySelector('option[value="' + l + '"]')
                                            }
                                            null == s ? (a.value = "", a.selectedIndex = -1) : s.selected = !0
                                        } else if (null == e) a.classList.remove("ql-active");
                                        else if (a.hasAttribute("value")) {
                                            var c = t[o] === a.getAttribute("value") || null != t[o] && t[o].toString() === a.getAttribute("value") || null == t[o] && !a.getAttribute("value");
                                            a.classList.toggle("ql-active", c)
                                        } else a.classList.toggle("ql-active", null != t[o])
                                    }))
                                }
                            }]), t
                        }(c.default);

                    function p(e, t, n) {
                        var i = document.createElement("button");
                        i.setAttribute("type", "button"), i.classList.add("ql-" + t), null != n && (i.value = n), e.appendChild(i)
                    }

                    function g(e, t) {
                        Array.isArray(t[0]) || (t = [t]), t.forEach((function (t) {
                            var n = document.createElement("span");
                            n.classList.add("ql-formats"), t.forEach((function (e) {
                                if ("string" == typeof e) p(n, e);
                                else {
                                    var t = Object.keys(e)[0],
                                        i = e[t];
                                    Array.isArray(i) ? function (e, t, n) {
                                        var i = document.createElement("select");
                                        i.classList.add("ql-" + t), n.forEach((function (e) {
                                            var t = document.createElement("option");
                                            !1 !== e ? t.setAttribute("value", e) : t.setAttribute("selected", "selected"), i.appendChild(t)
                                        })), e.appendChild(i)
                                    }(n, t, i) : p(n, t, i)
                                }
                            })), e.appendChild(n)
                        }))
                    }
                    f.DEFAULTS = {}, f.DEFAULTS = {
                        container: null,
                        handlers: {
                            clean: function () {
                                var e = this,
                                    t = this.quill.getSelection();
                                if (null != t)
                                    if (0 == t.length) {
                                        var n = this.quill.getFormat();
                                        Object.keys(n).forEach((function (t) {
                                            null != a.default.query(t, a.default.Scope.INLINE) && e.quill.format(t, !1)
                                        }))
                                    } else this.quill.removeFormat(t, s.default.sources.USER)
                            },
                            direction: function (e) {
                                var t = this.quill.getFormat().align;
                                "rtl" === e && null == t ? this.quill.format("align", "right", s.default.sources.USER) : e || "right" !== t || this.quill.format("align", !1, s.default.sources.USER), this.quill.format("direction", e, s.default.sources.USER)
                            },
                            indent: function (e) {
                                var t = this.quill.getSelection(),
                                    n = this.quill.getFormat(t),
                                    i = parseInt(n.indent || 0);
                                if ("+1" === e || "-1" === e) {
                                    var r = "+1" === e ? 1 : -1;
                                    "rtl" === n.direction && (r *= -1), this.quill.format("indent", i + r, s.default.sources.USER)
                                }
                            },
                            link: function (e) {
                                !0 === e && (e = prompt("Enter link URL:")), this.quill.format("link", e, s.default.sources.USER)
                            },
                            list: function (e) {
                                var t = this.quill.getSelection(),
                                    n = this.quill.getFormat(t);
                                "check" === e ? "checked" === n.list || "unchecked" === n.list ? this.quill.format("list", !1, s.default.sources.USER) : this.quill.format("list", "unchecked", s.default.sources.USER) : this.quill.format("list", e, s.default.sources.USER)
                            }
                        }
                    }, t.default = f, t.addControls = g
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>'
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(28),
                        s = function (e) {
                            function t(e, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var i = function (e, t) {
                                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                                return i.label.innerHTML = n, i.container.classList.add("ql-color-picker"), [].slice.call(i.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach((function (e) {
                                    e.classList.add("ql-primary")
                                })), i
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "buildItem",
                                value: function (e) {
                                    var n = o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "buildItem", this).call(this, e);
                                    return n.style.backgroundColor = e.getAttribute("value") || "", n
                                }
                            }, {
                                key: "selectItem",
                                value: function (e, n) {
                                    o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "selectItem", this).call(this, e, n);
                                    var i = this.label.querySelector(".ql-color-label"),
                                        r = e && e.getAttribute("data-value") || "";
                                    i && ("line" === i.tagName ? i.style.stroke = r : i.style.fill = r)
                                }
                            }]), t
                        }(((i = a) && i.__esModule ? i : {
                            default: i
                        }).default);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(28),
                        s = function (e) {
                            function t(e, n) {
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, t);
                                var i = function (e, t) {
                                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                                }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
                                return i.container.classList.add("ql-icon-picker"), [].forEach.call(i.container.querySelectorAll(".ql-picker-item"), (function (e) {
                                    e.innerHTML = n[e.getAttribute("data-value") || ""]
                                })), i.defaultItem = i.container.querySelector(".ql-selected"), i.selectItem(i.defaultItem), i
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "selectItem",
                                value: function (e, n) {
                                    o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "selectItem", this).call(this, e, n), e = e || this.defaultItem, this.label.innerHTML = e.innerHTML
                                }
                            }]), t
                        }(((i = a) && i.__esModule ? i : {
                            default: i
                        }).default);
                    t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function () {
                            function e(t, n) {
                                var i = this;
                                ! function (e, t) {
                                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                                }(this, e), this.quill = t, this.boundsContainer = n || document.body, this.root = t.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, this.quill.root === this.quill.scrollingContainer && this.quill.root.addEventListener("scroll", (function () {
                                    i.root.style.marginTop = -1 * i.quill.root.scrollTop + "px"
                                })), this.hide()
                            }
                            return i(e, [{
                                key: "hide",
                                value: function () {
                                    this.root.classList.add("ql-hidden")
                                }
                            }, {
                                key: "position",
                                value: function (e) {
                                    var t = e.left + e.width / 2 - this.root.offsetWidth / 2,
                                        n = e.bottom + this.quill.root.scrollTop;
                                    this.root.style.left = t + "px", this.root.style.top = n + "px", this.root.classList.remove("ql-flip");
                                    var i = this.boundsContainer.getBoundingClientRect(),
                                        r = this.root.getBoundingClientRect(),
                                        o = 0;
                                    if (r.right > i.right && (o = i.right - r.right, this.root.style.left = t + o + "px"), r.left < i.left && (o = i.left - r.left, this.root.style.left = t + o + "px"), r.bottom > i.bottom) {
                                        var a = r.bottom - r.top,
                                            s = e.bottom - e.top + a;
                                        this.root.style.top = n - s + "px", this.root.classList.add("ql-flip")
                                    }
                                    return o
                                }
                            }, {
                                key: "show",
                                value: function () {
                                    this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden")
                                }
                            }]), e
                        }();
                    t.default = r
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = function (e, t) {
                            if (Array.isArray(e)) return e;
                            if (Symbol.iterator in Object(e)) return function (e, t) {
                                var n = [],
                                    i = !0,
                                    r = !1,
                                    o = void 0;
                                try {
                                    for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0);
                                } catch (e) {
                                    r = !0, o = e
                                } finally {
                                    try {
                                        !i && s.return && s.return()
                                    } finally {
                                        if (r) throw o
                                    }
                                }
                                return n
                            }(e, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance")
                        },
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        a = f(n(3)),
                        s = f(n(8)),
                        l = n(43),
                        c = f(l),
                        u = f(n(27)),
                        d = n(15),
                        h = f(n(41));

                    function f(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function p(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function g(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function m(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var v = [
                            [{
                                header: ["1", "2", "3", !1]
                            }],
                            ["bold", "italic", "underline", "link"],
                            [{
                                list: "ordered"
                            }, {
                                list: "bullet"
                            }],
                            ["clean"]
                        ],
                        b = function (e) {
                            function t(e, n) {
                                p(this, t), null != n.modules.toolbar && null == n.modules.toolbar.container && (n.modules.toolbar.container = v);
                                var i = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                return i.quill.container.classList.add("ql-snow"), i
                            }
                            return m(t, e), o(t, [{
                                key: "extendToolbar",
                                value: function (e) {
                                    e.container.classList.add("ql-snow"), this.buildButtons([].slice.call(e.container.querySelectorAll("button")), h.default), this.buildPickers([].slice.call(e.container.querySelectorAll("select")), h.default), this.tooltip = new y(this.quill, this.options.bounds), e.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({
                                        key: "K",
                                        shortKey: !0
                                    }, (function (t, n) {
                                        e.handlers.link.call(e, !n.format.link)
                                    }))
                                }
                            }]), t
                        }(c.default);
                    b.DEFAULTS = (0, a.default)(!0, {}, c.default.DEFAULTS, {
                        modules: {
                            toolbar: {
                                handlers: {
                                    link: function (e) {
                                        if (e) {
                                            var t = this.quill.getSelection();
                                            if (null == t || 0 == t.length) return;
                                            var n = this.quill.getText(t);
                                            /^\S+@\S+\.\S+$/.test(n) && 0 !== n.indexOf("mailto:") && (n = "mailto:" + n), this.quill.theme.tooltip.edit("link", n)
                                        } else this.quill.format("link", !1)
                                    }
                                }
                            }
                        }
                    });
                    var y = function (e) {
                        function t(e, n) {
                            p(this, t);
                            var i = g(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                            return i.preview = i.root.querySelector("a.ql-preview"), i
                        }
                        return m(t, e), o(t, [{
                            key: "listen",
                            value: function () {
                                var e = this;
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "listen", this).call(this), this.root.querySelector("a.ql-action").addEventListener("click", (function (t) {
                                    e.root.classList.contains("ql-editing") ? e.save() : e.edit("link", e.preview.textContent), t.preventDefault()
                                })), this.root.querySelector("a.ql-remove").addEventListener("click", (function (t) {
                                    if (null != e.linkRange) {
                                        var n = e.linkRange;
                                        e.restoreFocus(), e.quill.formatText(n, "link", !1, s.default.sources.USER), delete e.linkRange
                                    }
                                    t.preventDefault(), e.hide()
                                })), this.quill.on(s.default.events.SELECTION_CHANGE, (function (t, n, r) {
                                    if (null != t) {
                                        if (0 === t.length && r === s.default.sources.USER) {
                                            var o = e.quill.scroll.descendant(u.default, t.index),
                                                a = i(o, 2),
                                                l = a[0],
                                                c = a[1];
                                            if (null != l) {
                                                e.linkRange = new d.Range(t.index - c, l.length());
                                                var h = u.default.formats(l.domNode);
                                                return e.preview.textContent = h, e.preview.setAttribute("href", h), e.show(), void e.position(e.quill.getBounds(e.linkRange))
                                            }
                                        } else delete e.linkRange;
                                        e.hide()
                                    }
                                }))
                            }
                        }, {
                            key: "show",
                            value: function () {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "show", this).call(this), this.root.removeAttribute("data-mode")
                            }
                        }]), t
                    }(l.BaseTooltip);
                    y.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""), t.default = b
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i = j(n(29)),
                        r = n(36),
                        o = n(38),
                        a = n(64),
                        s = j(n(65)),
                        l = j(n(66)),
                        c = n(67),
                        u = j(c),
                        d = n(37),
                        h = n(26),
                        f = n(39),
                        p = n(40),
                        g = j(n(56)),
                        m = j(n(68)),
                        v = j(n(27)),
                        b = j(n(69)),
                        y = j(n(70)),
                        _ = j(n(71)),
                        x = j(n(72)),
                        w = j(n(73)),
                        E = n(13),
                        k = j(E),
                        O = j(n(74)),
                        S = j(n(75)),
                        C = j(n(57)),
                        A = j(n(41)),
                        M = j(n(28)),
                        T = j(n(59)),
                        P = j(n(60)),
                        D = j(n(61)),
                        L = j(n(108)),
                        N = j(n(62));

                    function j(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }
                    i.default.register({
                        "attributors/attribute/direction": o.DirectionAttribute,
                        "attributors/class/align": r.AlignClass,
                        "attributors/class/background": d.BackgroundClass,
                        "attributors/class/color": h.ColorClass,
                        "attributors/class/direction": o.DirectionClass,
                        "attributors/class/font": f.FontClass,
                        "attributors/class/size": p.SizeClass,
                        "attributors/style/align": r.AlignStyle,
                        "attributors/style/background": d.BackgroundStyle,
                        "attributors/style/color": h.ColorStyle,
                        "attributors/style/direction": o.DirectionStyle,
                        "attributors/style/font": f.FontStyle,
                        "attributors/style/size": p.SizeStyle
                    }, !0), i.default.register({
                        "formats/align": r.AlignClass,
                        "formats/direction": o.DirectionClass,
                        "formats/indent": a.IndentClass,
                        "formats/background": d.BackgroundStyle,
                        "formats/color": h.ColorStyle,
                        "formats/font": f.FontClass,
                        "formats/size": p.SizeClass,
                        "formats/blockquote": s.default,
                        "formats/code-block": k.default,
                        "formats/header": l.default,
                        "formats/list": u.default,
                        "formats/bold": g.default,
                        "formats/code": E.Code,
                        "formats/italic": m.default,
                        "formats/link": v.default,
                        "formats/script": b.default,
                        "formats/strike": y.default,
                        "formats/underline": _.default,
                        "formats/image": x.default,
                        "formats/video": w.default,
                        "formats/list/item": c.ListItem,
                        "modules/formula": O.default,
                        "modules/syntax": S.default,
                        "modules/toolbar": C.default,
                        "themes/bubble": L.default,
                        "themes/snow": N.default,
                        "ui/icons": A.default,
                        "ui/picker": M.default,
                        "ui/icon-picker": P.default,
                        "ui/color-picker": T.default,
                        "ui/tooltip": D.default
                    }, !0), t.default = i.default
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.IndentClass = void 0;
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(0),
                        s = (i = a) && i.__esModule ? i : {
                            default: i
                        };

                    function l(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function c(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var u = function (e) {
                            function t() {
                                return l(this, t), c(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "add",
                                value: function (e, n) {
                                    if ("+1" === n || "-1" === n) {
                                        var i = this.value(e) || 0;
                                        n = "+1" === n ? i + 1 : i - 1
                                    }
                                    return 0 === n ? (this.remove(e), !0) : o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "add", this).call(this, e, n)
                                }
                            }, {
                                key: "canAdd",
                                value: function (e, n) {
                                    return o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "canAdd", this).call(this, e, n) || o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "canAdd", this).call(this, e, parseInt(n))
                                }
                            }, {
                                key: "value",
                                value: function (e) {
                                    return parseInt(o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "value", this).call(this, e)) || void 0
                                }
                            }]), t
                        }(s.default.Attributor.Class),
                        d = new u("indent", "ql-indent", {
                            scope: s.default.Scope.BLOCK,
                            whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
                        });
                    t.IndentClass = d
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(4);

                    function o(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function a(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var s = function (e) {
                        function t() {
                            return o(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(((i = r) && i.__esModule ? i : {
                        default: i
                    }).default);
                    s.blotName = "blockquote", s.tagName = "blockquote", t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = n(4);

                    function a(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function s(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var l = function (e) {
                        function t() {
                            return a(this, t), s(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, null, [{
                            key: "formats",
                            value: function (e) {
                                return this.tagName.indexOf(e.tagName) + 1
                            }
                        }]), t
                    }(((i = o) && i.__esModule ? i : {
                        default: i
                    }).default);
                    l.blotName = "header", l.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"], t.default = l
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.ListItem = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = l(n(0)),
                        a = l(n(4)),
                        s = l(n(25));

                    function l(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function c(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function u(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function d(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var h = function (e) {
                        function t() {
                            return c(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return d(t, e), i(t, [{
                            key: "format",
                            value: function (e, n) {
                                e !== f.blotName || n ? r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n) : this.replaceWith(o.default.create(this.statics.scope))
                            }
                        }, {
                            key: "remove",
                            value: function () {
                                null == this.prev && null == this.next ? this.parent.remove() : r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "remove", this).call(this)
                            }
                        }, {
                            key: "replaceWith",
                            value: function (e, n) {
                                return this.parent.isolate(this.offset(this.parent), this.length()), e === this.parent.statics.blotName ? (this.parent.replaceWith(e, n), this) : (this.parent.unwrap(), r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "replaceWith", this).call(this, e, n))
                            }
                        }], [{
                            key: "formats",
                            value: function (e) {
                                return e.tagName === this.tagName ? void 0 : r(t.__proto__ || Object.getPrototypeOf(t), "formats", this).call(this, e)
                            }
                        }]), t
                    }(a.default);
                    h.blotName = "list-item", h.tagName = "LI";
                    var f = function (e) {
                        function t(e) {
                            c(this, t);
                            var n = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e)),
                                i = function (t) {
                                    if (t.target.parentNode === e) {
                                        var i = n.statics.formats(e),
                                            r = o.default.find(t.target);
                                        "checked" === i ? r.format("list", "unchecked") : "unchecked" === i && r.format("list", "checked")
                                    }
                                };
                            return e.addEventListener("touchstart", i), e.addEventListener("mousedown", i), n
                        }
                        return d(t, e), i(t, null, [{
                            key: "create",
                            value: function (e) {
                                var n = "ordered" === e ? "OL" : "UL",
                                    i = r(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, n);
                                return "checked" !== e && "unchecked" !== e || i.setAttribute("data-checked", "checked" === e), i
                            }
                        }, {
                            key: "formats",
                            value: function (e) {
                                return "OL" === e.tagName ? "ordered" : "UL" === e.tagName ? e.hasAttribute("data-checked") ? "true" === e.getAttribute("data-checked") ? "checked" : "unchecked" : "bullet" : void 0
                            }
                        }]), i(t, [{
                            key: "format",
                            value: function (e, t) {
                                this.children.length > 0 && this.children.tail.format(e, t)
                            }
                        }, {
                            key: "formats",
                            value: function () {
                                return e = {}, t = this.statics.blotName, n = this.statics.formats(this.domNode), t in e ? Object.defineProperty(e, t, {
                                    value: n,
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0
                                }) : e[t] = n, e;
                                var e, t, n
                            }
                        }, {
                            key: "insertBefore",
                            value: function (e, n) {
                                if (e instanceof h) r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "insertBefore", this).call(this, e, n);
                                else {
                                    var i = null == n ? this.length() : n.offset(this),
                                        o = this.split(i);
                                    o.parent.insertBefore(e, o)
                                }
                            }
                        }, {
                            key: "optimize",
                            value: function (e) {
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "optimize", this).call(this, e);
                                var n = this.next;
                                null != n && n.prev === this && n.statics.blotName === this.statics.blotName && n.domNode.tagName === this.domNode.tagName && n.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked") && (n.moveChildren(this), n.remove())
                            }
                        }, {
                            key: "replace",
                            value: function (e) {
                                if (e.statics.blotName !== this.statics.blotName) {
                                    var n = o.default.create(this.statics.defaultChild);
                                    e.moveChildren(n), this.appendChild(n)
                                }
                                r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "replace", this).call(this, e)
                            }
                        }]), t
                    }(s.default);
                    f.blotName = "list", f.scope = o.default.Scope.BLOCK_BLOT, f.tagName = ["OL", "UL"], f.defaultChild = "list-item", f.allowedChildren = [h], t.ListItem = h, t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(56);

                    function o(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function a(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var s = function (e) {
                        function t() {
                            return o(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(((i = r) && i.__esModule ? i : {
                        default: i
                    }).default);
                    s.blotName = "italic", s.tagName = ["EM", "I"], t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(6);

                    function s(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function l(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var c = function (e) {
                        function t() {
                            return s(this, t), l(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), r(t, null, [{
                            key: "create",
                            value: function (e) {
                                return "super" === e ? document.createElement("sup") : "sub" === e ? document.createElement("sub") : o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e)
                            }
                        }, {
                            key: "formats",
                            value: function (e) {
                                return "SUB" === e.tagName ? "sub" : "SUP" === e.tagName ? "super" : void 0
                            }
                        }]), t
                    }(((i = a) && i.__esModule ? i : {
                        default: i
                    }).default);
                    c.blotName = "script", c.tagName = ["SUB", "SUP"], t.default = c
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(6);

                    function o(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function a(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var s = function (e) {
                        function t() {
                            return o(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(((i = r) && i.__esModule ? i : {
                        default: i
                    }).default);
                    s.blotName = "strike", s.tagName = "S", t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = n(6);

                    function o(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function a(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var s = function (e) {
                        function t() {
                            return o(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return function (e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                            e.prototype = Object.create(t && t.prototype, {
                                constructor: {
                                    value: e,
                                    enumerable: !1,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                        }(t, e), t
                    }(((i = r) && i.__esModule ? i : {
                        default: i
                    }).default);
                    s.blotName = "underline", s.tagName = "U", t.default = s
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(0),
                        s = (i = a) && i.__esModule ? i : {
                            default: i
                        },
                        l = n(27);

                    function c(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function u(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var d = ["alt", "height", "width"],
                        h = function (e) {
                            function t() {
                                return c(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "format",
                                value: function (e, n) {
                                    d.indexOf(e) > -1 ? n ? this.domNode.setAttribute(e, n) : this.domNode.removeAttribute(e) : o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n)
                                }
                            }], [{
                                key: "create",
                                value: function (e) {
                                    var n = o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e);
                                    return "string" == typeof e && n.setAttribute("src", this.sanitize(e)), n
                                }
                            }, {
                                key: "formats",
                                value: function (e) {
                                    return d.reduce((function (t, n) {
                                        return e.hasAttribute(n) && (t[n] = e.getAttribute(n)), t
                                    }), {})
                                }
                            }, {
                                key: "match",
                                value: function (e) {
                                    return /\.(jpe?g|gif|png)$/.test(e) || /^data:image\/.+;base64/.test(e)
                                }
                            }, {
                                key: "sanitize",
                                value: function (e) {
                                    return (0, l.sanitize)(e, ["http", "https", "data"]) ? e : "//:0"
                                }
                            }, {
                                key: "value",
                                value: function (e) {
                                    return e.getAttribute("src")
                                }
                            }]), t
                        }(s.default.Embed);
                    h.blotName = "image", h.tagName = "IMG", t.default = h
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    });
                    var i, r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        a = n(4),
                        s = n(27),
                        l = (i = s) && i.__esModule ? i : {
                            default: i
                        };

                    function c(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function u(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }
                    var d = ["height", "width"],
                        h = function (e) {
                            function t() {
                                return c(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                            }
                            return function (e, t) {
                                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                                e.prototype = Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                            }(t, e), r(t, [{
                                key: "format",
                                value: function (e, n) {
                                    d.indexOf(e) > -1 ? n ? this.domNode.setAttribute(e, n) : this.domNode.removeAttribute(e) : o(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "format", this).call(this, e, n)
                                }
                            }], [{
                                key: "create",
                                value: function (e) {
                                    var n = o(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e);
                                    return n.setAttribute("frameborder", "0"), n.setAttribute("allowfullscreen", !0), n.setAttribute("src", this.sanitize(e)), n
                                }
                            }, {
                                key: "formats",
                                value: function (e) {
                                    return d.reduce((function (t, n) {
                                        return e.hasAttribute(n) && (t[n] = e.getAttribute(n)), t
                                    }), {})
                                }
                            }, {
                                key: "sanitize",
                                value: function (e) {
                                    return l.default.sanitize(e)
                                }
                            }, {
                                key: "value",
                                value: function (e) {
                                    return e.getAttribute("src")
                                }
                            }]), t
                        }(a.BlockEmbed);
                    h.blotName = "video", h.className = "ql-video", h.tagName = "IFRAME", t.default = h
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.FormulaBlot = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = l(n(35)),
                        a = l(n(5)),
                        s = l(n(9));

                    function l(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function c(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function u(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function d(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var h = function (e) {
                        function t() {
                            return c(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return d(t, e), i(t, null, [{
                            key: "create",
                            value: function (e) {
                                var n = r(t.__proto__ || Object.getPrototypeOf(t), "create", this).call(this, e);
                                return "string" == typeof e && (window.katex.render(e, n, {
                                    throwOnError: !1,
                                    errorColor: "#f00"
                                }), n.setAttribute("data-value", e)), n
                            }
                        }, {
                            key: "value",
                            value: function (e) {
                                return e.getAttribute("data-value")
                            }
                        }]), t
                    }(o.default);
                    h.blotName = "formula", h.className = "ql-formula", h.tagName = "SPAN";
                    var f = function (e) {
                        function t() {
                            c(this, t);
                            var e = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                            if (null == window.katex) throw new Error("Formula module requires KaTeX.");
                            return e
                        }
                        return d(t, e), i(t, null, [{
                            key: "register",
                            value: function () {
                                a.default.register(h, !0)
                            }
                        }]), t
                    }(s.default);
                    t.FormulaBlot = h, t.default = f
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.CodeToken = t.CodeBlock = void 0;
                    var i = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        r = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        o = l(n(0)),
                        a = l(n(5)),
                        s = l(n(9));

                    function l(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function c(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function u(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function d(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var h = function (e) {
                        function t() {
                            return c(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments))
                        }
                        return d(t, e), i(t, [{
                            key: "replaceWith",
                            value: function (e) {
                                this.domNode.textContent = this.domNode.textContent, this.attach(), r(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "replaceWith", this).call(this, e)
                            }
                        }, {
                            key: "highlight",
                            value: function (e) {
                                var t = this.domNode.textContent;
                                this.cachedText !== t && ((t.trim().length > 0 || null == this.cachedText) && (this.domNode.innerHTML = e(t), this.domNode.normalize(), this.attach()), this.cachedText = t)
                            }
                        }]), t
                    }(l(n(13)).default);
                    h.className = "ql-syntax";
                    var f = new o.default.Attributor.Class("token", "hljs", {
                            scope: o.default.Scope.INLINE
                        }),
                        p = function (e) {
                            function t(e, n) {
                                c(this, t);
                                var i = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                if ("function" != typeof i.options.highlight) throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
                                var r = null;
                                return i.quill.on(a.default.events.SCROLL_OPTIMIZE, (function () {
                                    clearTimeout(r), r = setTimeout((function () {
                                        i.highlight(), r = null
                                    }), i.options.interval)
                                })), i.highlight(), i
                            }
                            return d(t, e), i(t, null, [{
                                key: "register",
                                value: function () {
                                    a.default.register(f, !0), a.default.register(h, !0)
                                }
                            }]), i(t, [{
                                key: "highlight",
                                value: function () {
                                    var e = this;
                                    if (!this.quill.selection.composing) {
                                        this.quill.update(a.default.sources.USER);
                                        var t = this.quill.getSelection();
                                        this.quill.scroll.descendants(h).forEach((function (t) {
                                            t.highlight(e.options.highlight)
                                        })), this.quill.update(a.default.sources.SILENT), null != t && this.quill.setSelection(t, a.default.sources.SILENT)
                                    }
                                }
                            }]), t
                        }(s.default);
                    p.DEFAULTS = {
                        highlight: null == window.hljs ? null : function (e) {
                            return window.hljs.highlightAuto(e).value
                        },
                        interval: 1e3
                    }, t.CodeBlock = h, t.CodeToken = f, t.default = p
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>'
                }, function (e, t) {
                    e.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>'
                }, function (e, t) {
                    e.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>'
                }, function (e, t, n) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", {
                        value: !0
                    }), t.default = t.BubbleTooltip = void 0;
                    var i = function e(t, n, i) {
                            null === t && (t = Function.prototype);
                            var r = Object.getOwnPropertyDescriptor(t, n);
                            if (void 0 === r) {
                                var o = Object.getPrototypeOf(t);
                                return null === o ? void 0 : e(o, n, i)
                            }
                            if ("value" in r) return r.value;
                            var a = r.get;
                            return void 0 !== a ? a.call(i) : void 0
                        },
                        r = function () {
                            function e(e, t) {
                                for (var n = 0; n < t.length; n++) {
                                    var i = t[n];
                                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                                }
                            }
                            return function (t, n, i) {
                                return n && e(t.prototype, n), i && e(t, i), t
                            }
                        }(),
                        o = d(n(3)),
                        a = d(n(8)),
                        s = n(43),
                        l = d(s),
                        c = n(15),
                        u = d(n(41));

                    function d(e) {
                        return e && e.__esModule ? e : {
                            default: e
                        }
                    }

                    function h(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                    }

                    function f(e, t) {
                        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !t || "object" != typeof t && "function" != typeof t ? e : t
                    }

                    function p(e, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                        e.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: e,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                    }
                    var g = [
                            ["bold", "italic", "link"],
                            [{
                                header: 1
                            }, {
                                header: 2
                            }, "blockquote"]
                        ],
                        m = function (e) {
                            function t(e, n) {
                                h(this, t), null != n.modules.toolbar && null == n.modules.toolbar.container && (n.modules.toolbar.container = g);
                                var i = f(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                                return i.quill.container.classList.add("ql-bubble"), i
                            }
                            return p(t, e), r(t, [{
                                key: "extendToolbar",
                                value: function (e) {
                                    this.tooltip = new v(this.quill, this.options.bounds), this.tooltip.root.appendChild(e.container), this.buildButtons([].slice.call(e.container.querySelectorAll("button")), u.default), this.buildPickers([].slice.call(e.container.querySelectorAll("select")), u.default)
                                }
                            }]), t
                        }(l.default);
                    m.DEFAULTS = (0, o.default)(!0, {}, l.default.DEFAULTS, {
                        modules: {
                            toolbar: {
                                handlers: {
                                    link: function (e) {
                                        e ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1)
                                    }
                                }
                            }
                        }
                    });
                    var v = function (e) {
                        function t(e, n) {
                            h(this, t);
                            var i = f(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
                            return i.quill.on(a.default.events.EDITOR_CHANGE, (function (e, t, n, r) {
                                if (e === a.default.events.SELECTION_CHANGE)
                                    if (null != t && t.length > 0 && r === a.default.sources.USER) {
                                        i.show(), i.root.style.left = "0px", i.root.style.width = "", i.root.style.width = i.root.offsetWidth + "px";
                                        var o = i.quill.getLines(t.index, t.length);
                                        if (1 === o.length) i.position(i.quill.getBounds(t));
                                        else {
                                            var s = o[o.length - 1],
                                                l = i.quill.getIndex(s),
                                                u = Math.min(s.length() - 1, t.index + t.length - l),
                                                d = i.quill.getBounds(new c.Range(l, u));
                                            i.position(d)
                                        }
                                    } else document.activeElement !== i.textbox && i.quill.hasFocus() && i.hide()
                            })), i
                        }
                        return p(t, e), r(t, [{
                            key: "listen",
                            value: function () {
                                var e = this;
                                i(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "listen", this).call(this), this.root.querySelector(".ql-close").addEventListener("click", (function () {
                                    e.root.classList.remove("ql-editing")
                                })), this.quill.on(a.default.events.SCROLL_OPTIMIZE, (function () {
                                    setTimeout((function () {
                                        if (!e.root.classList.contains("ql-hidden")) {
                                            var t = e.quill.getSelection();
                                            null != t && e.position(e.quill.getBounds(t))
                                        }
                                    }), 1)
                                }))
                            }
                        }, {
                            key: "cancel",
                            value: function () {
                                this.show()
                            }
                        }, {
                            key: "position",
                            value: function (e) {
                                var n = i(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "position", this).call(this, e),
                                    r = this.root.querySelector(".ql-tooltip-arrow");
                                if (r.style.marginLeft = "", 0 === n) return n;
                                r.style.marginLeft = -1 * n - r.offsetWidth / 2 + "px"
                            }
                        }]), t
                    }(s.BaseTooltip);
                    v.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""), t.BubbleTooltip = v, t.default = m
                }, function (e, t, n) {
                    e.exports = n(63)
                }]).default
            }, e.exports = t()
        },
        915: e => {
            "use strict";
            var t, n, i = 0;

            function r(e) {
                return e >= 48 && e <= 57
            }

            function o(e, t) {
                for (var o = (e += "").length, a = (t += "").length, s = 0, l = 0; s < o && l < a;) {
                    var c = e.charCodeAt(s),
                        u = t.charCodeAt(l);
                    if (r(c)) {
                        if (!r(u)) return c - u;
                        for (var d = s, h = l; 48 === c && ++d < o;) c = e.charCodeAt(d);
                        for (; 48 === u && ++h < a;) u = t.charCodeAt(h);
                        for (var f = d, p = h; f < o && r(e.charCodeAt(f));) ++f;
                        for (; p < a && r(t.charCodeAt(p));) ++p;
                        var g = f - d - p + h;
                        if (g) return g;
                        for (; d < f;)
                            if (g = e.charCodeAt(d++) - t.charCodeAt(h++)) return g;
                        s = f, l = p
                    } else {
                        if (c !== u) return c < i && u < i && -1 !== n[c] && -1 !== n[u] ? n[c] - n[u] : c - u;
                        ++s, ++l
                    }
                }
                return s >= o && l < a && o >= a ? -1 : l >= a && s < o && a >= o ? 1 : o - a
            }
            o.caseInsensitive = o.i = function (e, t) {
                return o(("" + e).toLowerCase(), ("" + t).toLowerCase())
            }, Object.defineProperties(o, {
                alphabet: {
                    get: function () {
                        return t
                    },
                    set: function (e) {
                        n = [];
                        var r = 0;
                        if (t = e)
                            for (; r < t.length; r++) n[t.charCodeAt(r)] = r;
                        for (i = n.length, r = 0; r < i; r++) void 0 === n[r] && (n[r] = -1)
                    }
                }
            }), e.exports = o
        }
    }
]);
//# sourceMappingURL=vendor.bundle.js.map